export const translations = {
  pl: {
    'inventory.type.Bidon': 'Bidon',
    'inventory.type.Buty rowerowe': 'Buty rowerowe',
    'inventory.type.Kask rowerowy': 'Kask rowerowy',
    'inventory.type.Pompka': 'Pompka',
    'inventory.type.Rower górski': 'Rower górski',
    'inventory.type.Rower miejski': 'Rower miejski',
    'inventory.type.Rower szosowy': 'Rower szosowy',
    'inventory.type.Rower trekkingowy': 'Rower trekkingowy',
    'inventory.type.Zapięcie': 'Zapięcie',
    'inventory.type.Zestaw naprawczy': 'Zestaw naprawczy',
    'inventory.type.Kłódki': 'Kłódki',
    'inventory.type.Ochraniacze': 'Ochraniacze',
    'inventory.type.Rękawice': 'Rękawice',
    // Sidebar
    'sidebar.home': 'Strona główna',
    'sidebar.newReservation': 'Nowa rezerwacja',
    'sidebar.generateOffer': 'Oferty',
    'sidebar.calendar': 'Kalendarz',
    'sidebar.inventory': 'Magazyn',
    'sidebar.statistics': 'Statystyki',
    'sidebar.profile': 'Profil',
    'sidebar.logout': 'Wyloguj',
    'sidebar.logoutSaving': 'Zapisuję zmiany i wylogowuję…',
    'sidebar.clients': 'Klienci',
    'sidebar.group.main': 'Główne',
    'sidebar.group.manage': 'Zarządzanie',
    'sidebar.group.account': 'Konto',
    'sidebar.organization': 'Organizacja',
    'sidebar.payments': 'Płatności',
    'sidebar.group.tools': 'Narzędzia',
    'sidebar.contractTemplate': 'Konstruktor umowy',
    'sidebar.offerTemplate': 'Konstruktor oferty',
    'sidebar.paymentSettings': 'Płatności online',
    'sidebar.invoices': 'Faktury',
    'sidebar.notifications': 'Powiadomienia',
    'sidebar.widget': 'Widget',
    'sidebar.superAdmin': 'Panel Super-Admina',
    'sidebar.openMenu': 'Otwórz menu',
    'sidebar.collapseMenu': 'Zwiń menu',
    'sidebar.expandMenu': 'Rozwiń menu',

    // Profile
    'profile.title': 'Twoje konto',
    'profile.subtitle': 'Zarządzaj swoim kontem i ustawieniami',
    'profile.yourData': 'Twoje dane',
    'profile.description.yourData': 'Edytuj swoje dane osobowe i informacje kontaktowe',
    'profile.security': 'Bezpieczeństwo',
    'profile.description.security': 'Zmień hasło i zarządzaj bezpieczeństwem konta',
    'profile.users': 'Użytkownicy',
    'profile.description.users': 'Zarządzaj użytkownikami systemu',
    'profile.preferences': 'Twoje preferencje',
    'profile.description.preferences': 'Dostosuj motyw i język aplikacji',
    'profile.emailSettings': 'Ustawienia email',
    'profile.description.emailSettings': 'Konfiguruj ustawienia poczty e-mail',
    'profile.contractSettings': 'Dane firmy',
    'profile.description.contractSettings': 'Informacje i konfiguracja firmy',
    'profile.priceRules': 'Dynamiczne ceny',
    'profile.description.priceRules': 'Reguły cenowe: sezony, weekendy, promocje',
    'profile.ksef': 'KSeF - e-Faktury',
    'profile.description.ksef': 'Wysyłka faktur ustrukturyzowanych do KSeF',
    'profile.equipmentBundles': 'Pakiety sprzętu',
    'profile.description.equipmentBundles': 'Zestawy sprzętu ze wspólną ceną dzienną',
    'profile.rentalRules': 'Zasady wynajmu',
    'profile.description.rentalRules': 'Reguły wypożyczania: wymiana sprzętu tego samego dnia i dni płatne',
    'pricing.paidDays': '(płatne: {days})',
    'rentalRules.title': 'Zasady wynajmu',
    'rentalRules.subtitle': 'Reguły, które obowiązują przy każdej rezerwacji, w panelu i w widgecie.',
    'rentalRules.back': 'Wróć do profilu',
    'rentalRules.loadError': 'Nie udało się wczytać zasad wynajmu.',
    'rentalRules.saveError': 'Nie udało się zapisać zmiany. Spróbuj ponownie.',
    'rentalRules.adminOnly': 'Zasady wynajmu może zmieniać tylko administrator firmy.',
    'rentalRules.on': 'Włączona',
    'rentalRules.off': 'Wyłączona',
    'rentalRules.exchange.title': 'Wymiana sprzętu tego samego dnia',
    'rentalRules.exchange.description': 'Sztuka oddana w dniu zwrotu może tego samego dnia wyjść do kolejnego klienta. Panel nie zna godzin, więc to Ty pilnujesz, czy zdążysz ją przygotować.',
    'rentalRules.exchange.offNote': 'Po wyłączeniu rezerwacje zapisane wcześniej zostają bez zmian i nadal można je edytować. Nowa rezerwacja i nowy termin będą wtedy musiały zaczynać się dzień po zwrocie.',
    'rentalRules.paidDays.title': 'Dni płatne',
    'rentalRules.paidDays.description': 'Ile dni policzyć przy wynajmie na daną liczbę dni. Tabela działa na cały sprzęt, klasy i pakiety.',
    'rentalRules.paidDays.own': 'Własna tabela',
    'rentalRules.paidDays.defaultRule': 'Teraz działa reguła domyślna: do 7 dni płatny jest każdy dzień, 8 dni liczy się jak 7, a dłuższy wynajem jak o 2 dni krótszy.',
    'rentalRules.paidDays.unsaved': 'Tabela zacznie działać po zapisaniu. Do tego czasu działa reguła domyślna.',
    'rentalRules.paidDays.colRental': 'Wynajem',
    'rentalRules.paidDays.colPaid': 'Dni płatne',
    'rentalRules.paidDays.colExample': 'Przy {rate} zł za dzień',
    'rentalRules.paidDays.rowOne': '1 dzień',
    'rentalRules.paidDays.rowMany': '{n} dni',
    'rentalRules.paidDays.inputLabel': 'Dni płatne przy wynajmie na {n} dni',
    'rentalRules.paidDays.over14': 'Powyżej 14 dni każdy kolejny dzień jest płatny.',
    'rentalRules.paidDays.over7Rate': 'Przy wynajmie dłuższym niż 7 dni nadal działa stawka od 8. dnia, jeśli sprzęt, klasa albo pakiet ją mają.',
    'rentalRules.paidDays.savedReservations': 'Tabela działa przy nowych wycenach. Rezerwacje już zapisane zachowują swoje kwoty.',
    'rentalRules.paidDays.save': 'Zapisz tabelę',
    'rentalRules.paidDays.noDiscount': 'Bez rabatu za dłuższy wynajem',
    'rentalRules.paidDays.reset': 'Przywróć domyślne',
    'rentalRules.paidDays.saved': 'Tabela zapisana.',
    'rentalRules.paidDays.errorNumber': 'Wpisz liczbę dni płatnych.',
    'rentalRules.paidDays.errorRange': 'Wpisz więcej niż 0 i najwyżej {n}.',
    'rentalRules.paidDays.errorDecimals': 'Wpisz najwyżej 2 miejsca po przecinku.',
    'rentalRules.paidDays.errorOrder': 'Nie może być mniej niż w wierszu {row}.',
    'profile.import': 'Import danych',
    'profile.description.import': 'Import sprzętu i klientów z pliku .xlsx',
    'profile.companyExport': 'Eksport danych firmy',
    'profile.description.companyExport': 'Wszystkie dane firmy w jednym pliku ZIP',
    'companyExport.title': 'Eksport danych firmy',
    'companyExport.subtitle': 'Wszystkie dane firmy w jednym pliku ZIP, do zachowania albo przeniesienia do innego programu',
    'companyExport.contentsTitle': 'Co jest w pliku',
    'companyExport.item.data': 'Klienci, rezerwacje z wydanym sprzętem, sprzęt, płatności, faktury z pozycjami, oferty i wysłane powiadomienia, jako CSV (otworzysz w Excelu) i JSON',
    'companyExport.item.invoicesPdf': 'PDF każdej faktury',
    'companyExport.item.photos': 'Zdjęcia stanu sprzętu z wydań i zwrotów, w osobnym katalogu',
    'companyExport.item.settings': 'Ustawienia firmy: szablony umowy i oferty (także wgrany wzór .docx), pola magazynu, typy i klasy sprzętu, cenniki, pakiety i konta pracowników (bez haseł)',
    'companyExport.item.readme': 'Plik CZYTAJ-MNIE.txt z opisem zawartości',
    'companyExport.howTitle': 'Jak to działa',
    'companyExport.how.time': 'Przygotowanie trwa od kilku sekund do kilkunastu minut, zależnie od liczby zdjęć i faktur. Postęp widać na liście pobranych plików przeglądarki, a w panelu możesz w tym czasie dalej pracować.',
    'companyExport.how.limit': 'Eksport pobierzesz najwyżej 5 razy na dobę.',
    'companyExport.how.paused': 'Konto jest w przerwie, a eksport działa normalnie.',
    'companyExport.privacy': 'Plik zawiera dane osobowe Twoich klientów. Przechowuj go bezpiecznie i nie przesyłaj dalej bez potrzeby.',
    'companyExport.adminOnly': 'Eksport danych firmy może pobrać tylko administrator.',
    'companyExport.download': 'Pobierz eksport (ZIP)',
    'companyExport.preparing': 'Przygotowuję plik',
    'companyExport.started': 'Pobieranie się zaczęło. Plik eksport-firmy z dzisiejszą datą znajdziesz w pobranych plikach przeglądarki. Jeśli przeglądarka pokaże nieudane pobieranie albo plik nie będzie archiwum ZIP, kliknij „Pobierz eksport” jeszcze raz.',
    'companyExport.error.inProgress': 'Eksport tej firmy już trwa. Poczekaj, aż plik się pobierze.',
    'companyExport.error.busy': 'Serwer przygotowuje teraz inne eksporty. Spróbuj za kilka minut.',
    'companyExport.error.limit': 'Eksport można pobrać najwyżej 5 razy na dobę. Spróbuj później.',
    'companyExport.error.generic': 'Nie udało się rozpocząć eksportu. Spróbuj ponownie za chwilę.',
    'onboarding.title': 'Pierwsze kroki',
    'onboarding.subtitle': 'Uzupełnij te elementy, aby w pełni wykorzystać system',
    'onboarding.progress': 'Ukończono {done} z {total}',
    'onboarding.dismiss': 'Ukryj na stałe',
    'onboarding.step.companyData': 'Uzupełnij dane firmy',
    'onboarding.step.companyData.cta': 'Uzupełnij dane firmy',
    'onboarding.step.equipment': 'Dodaj pierwszy sprzęt',
    'onboarding.step.equipment.cta': 'Dodaj sprzęt',
    'onboarding.step.equipment.importCta': 'Importuj z pliku',
    'onboarding.step.client': 'Dodaj pierwszego klienta',
    'onboarding.step.client.cta': 'Dodaj klienta',
    'onboarding.step.client.importCta': 'Importuj z pliku',
    'onboarding.step.inventoryFields': 'Skonfiguruj pola magazynu',
    'onboarding.step.inventoryFields.cta': 'Wybierz zestaw pól',
    'onboarding.step.reservation': 'Utwórz pierwszą rezerwację',
    'onboarding.step.reservation.cta': 'Dodaj rezerwację',
    'inventory.emptyState.hint': 'Tutaj pojawi się Twój sprzęt - dodaj go ręcznie albo zaimportuj hurtowo z pliku.',
    'clients.emptyState.hint': 'Tutaj pojawią się Twoi klienci - dodaj pierwszego ręcznie albo zaimportuj listę z pliku.',
    'calendar.emptyState.noReservationsAtAll': 'Nie masz jeszcze żadnych rezerwacji',
    'calendar.emptyState.noReservationsAtAllHint': 'Tutaj pojawi się kalendarz Twoich wypożyczeń - dodaj pierwszą rezerwację, aby zacząć.',
    'calendar.emptyState.addReservation': 'Dodaj rezerwację',
    'inventory.importFromFile': 'Importuj z pliku',
    'clients.importFromFile': 'Importuj z pliku',
    'import.title': 'Import danych',
    'import.subtitle': 'Wybierz, co chcesz zaimportować z pliku .xlsx',
    'import.entity.equipment': 'Sprzęt',
    'import.entity.clients': 'Klienci',
    'import.entity.equipment.description': 'Pozycje magazynu z ceną, rozmiarem i numerem inwentarzowym.',
    'import.entity.clients.description': 'Dane kontaktowe wypożyczających, także firmowe z NIP-em.',
    'import.changeEntity': 'Zmień rodzaj danych',
    'import.stepperLabel': 'Kroki importu',
    'import.step.template': 'Szablon',
    'import.step.file': 'Plik',
    'import.step.review': 'Podgląd',
    'import.step1.title': 'Pobierz szablon',
    'import.step1.description': 'Szablon ma gotowe nagłówki kolumn, więc plik na pewno wczyta się poprawnie.',
    'import.step1.bullet.columns': 'Kolumny w kolejności, jakiej oczekuje system.',
    'import.step1.bullet.values.equipment': 'Lista typów i klas dostępnych w Twojej organizacji, do wyboru z rozwijanej listy.',
    'import.step1.bullet.values.clients': 'Pola kontaktowe i firmowe rozpisane osobno, bez zgadywania formatu.',
    'import.step1.bullet.reuse': 'Otwierasz w Excelu lub Arkuszach Google, wypełniasz i wracasz tutaj.',
    'import.step1.downloaded': 'Szablon pobrany. Uzupełnij go i wróć do kroku 2.',
    'import.step1.configNote': 'Kolumny szablonu wynikają z Ustawień magazynu Twojej organizacji. Skonfiguruj pola sprzętu ZANIM pobierzesz szablon, bo dodane później kolumny wymagają pobrania go ponownie.',
    'import.step1.configLink': 'Przejdź do ustawień pól magazynu',
    'import.downloadTemplate': 'Pobierz szablon',
    'import.downloading': 'Pobieranie…',
    'import.downloadError': 'Nie udało się pobrać szablonu.',
    'import.next': 'Dalej',
    'import.back': 'Wstecz',
    'import.step2.title': 'Wgraj wypełniony plik',
    'import.step2.description': 'Sprawdzimy plik i pokażemy, co zostanie dodane, zanim cokolwiek zapiszemy.',
    'import.dropzone.title': 'Przeciągnij plik tutaj',
    'import.dropzone.hint': 'lub kliknij, aby wybrać z dysku',
    'import.file.remove': 'Usuń plik',
    'import.file.replace': 'Kliknij, aby wybrać inny plik',
    'import.fileTypeError': 'Wgraj plik .xlsx. Inne formaty nie są obsługiwane.',
    'import.constraint.format': 'Format .xlsx',
    'import.constraint.size': 'Maks. 2 MB',
    'import.constraint.rows': 'Do 5000 wierszy',
    'import.analyze': 'Sprawdź plik',
    'import.analyzing': 'Analizowanie pliku…',
    'import.errorGeneric': 'Wystąpił błąd. Spróbuj ponownie.',
    'import.serverBusy': 'Serwer jest chwilowo przeciążony. Spróbuj ponownie za kilka sekund.',
    'import.step3.title': 'Sprawdź i zatwierdź',
    'import.step3.description': 'Nic nie zostało jeszcze zapisane. Zatwierdzenie doda i zaktualizuje poniższe wiersze.',
    'import.summary.total': 'Wierszy w pliku',
    'import.summary.toInsert': 'Do dodania',
    'import.summary.toUpdate': 'Do aktualizacji',
    'import.summary.invalid': 'Błędne',
    'import.errors.title': 'Wiersze błędne',
    'import.errors.hint': 'Te wiersze zostaną pominięte. Popraw je w pliku i wgraj go ponownie, a pozostałe zaimportują się normalnie.',
    'import.warnings.title': 'Ostrzeżenia',
    'import.warnings.hint': 'Te wiersze zaimportują się mimo wszystko. Sprawdź, czy dane są zgodne z Twoimi oczekiwaniami.',
    'import.downloadErrorReport': 'Pobierz raport błędów',
    'import.confirmImport': 'Zatwierdź import',
    'import.importing': 'Importowanie…',
    'import.checksumMismatch': 'Plik zmienił się od podglądu - wgraj plik ponownie.',
    'import.rowNumber': 'Wiersz',
    'import.result.title': 'Import zakończony',
    'import.result.description.equipment': 'Sprzęt jest już w magazynie i można go rezerwować.',
    'import.result.description.clients': 'Klienci są już na liście i można ich wybierać w rezerwacjach.',
    'import.result.inserted': 'Dodano',
    'import.result.updated': 'Zaktualizowano',
    'import.result.skipped': 'Pominięto',
    'import.result.view.equipment': 'Zobacz magazyn',
    'import.result.view.clients': 'Zobacz klientów',
    'import.result.another': 'Importuj kolejny plik',
    'profile.widget': 'Widget',
    'profile.description.widget': 'Zarządzaj widgetem rezerwacji online i jego ustawieniami',
    'profile.widget.premiumOnly': 'Dostępne w planie Premium',
    // U.14: plakietka planu w nagłówku profilu
    'profile.plan.basic': 'Plan Basic',
    'profile.plan.premium': 'Plan Premium',
    'profile.plan.superadmin': 'Super-Admin',
    // Price rules (P7.2)
    'priceRules.title': 'Dynamiczne ceny',
    'priceRules.subtitle': 'Reguły cenowe po kalendarzu: sezony, weekendy, promocje',
    'priceRules.newRule': 'Nowa reguła',
    'priceRules.editRule': 'Edytuj regułę',
    'priceRules.name': 'Nazwa',
    'priceRules.namePlaceholder': 'np. Weekend +15%',
    'priceRules.active': 'Aktywna',
    'priceRules.dateFrom': 'Data od',
    'priceRules.dateTo': 'Data do',
    'priceRules.dateHint': 'Zostaw puste, aby reguła obowiązywała bez ograniczenia dat',
    'priceRules.weekdays': 'Dni tygodnia',
    'priceRules.weekdaysHint': 'Zostaw puste, aby reguła obowiązywała każdego dnia',
    'priceRules.weekday.1': 'Pon',
    'priceRules.weekday.2': 'Wt',
    'priceRules.weekday.3': 'Śr',
    'priceRules.weekday.4': 'Czw',
    'priceRules.weekday.5': 'Pt',
    'priceRules.weekday.6': 'Sob',
    'priceRules.weekday.7': 'Ndz',
    'priceRules.class': 'Klasa sprzętu',
    'priceRules.anyClass': 'Dowolna klasa',
    'priceRules.type': 'Typ sprzętu',
    'priceRules.anyType': 'Dowolny typ',
    'priceRules.adjustmentType': 'Rodzaj modyfikacji',
    'priceRules.percent': 'Procent (%)',
    'priceRules.fixed': 'Stawka stała (zł/dzień)',
    'priceRules.adjustmentValue': 'Wartość',
    'priceRules.adjustmentValueHint': 'Procent może być ujemny (promocja)',
    'priceRules.priority': 'Priorytet',
    'priceRules.priorityHint': 'Wyższy priorytet wygrywa przy nakładających się regułach',
    'priceSuggestions.title': 'Sugestie cenowe',
    'priceSuggestions.hint': 'Wyliczone z obłożenia sprzętu w ostatnich 90 dniach. Zatwierdzenie otwiera formularz reguły do edycji przed zapisem.',
    'priceSuggestions.accept': 'Zatwierdź',
    'priceSuggestions.dismiss': 'Odrzuć',
    'priceSuggestions.reasonHigh': 'Wysokie obłożenie',
    'priceSuggestions.reasonLow': 'Niskie obłożenie',
    'priceSuggestions.utilization': 'obłożenie',
    'equipmentBundles.title': 'Pakiety sprzętu',
    'equipmentBundles.subtitle': 'Zestawy typów sprzętu ze wspólną ceną dzienną - komplet w wycenie dostaje cenę zestawu',
    'equipmentBundles.newBundle': 'Nowy zestaw',
    'equipmentBundles.editBundle': 'Edytuj zestaw',
    'equipmentBundles.name': 'Nazwa',
    'equipmentBundles.namePlaceholder': 'np. Pakiet podstawowy',
    'equipmentBundles.dailyPrice': 'Cena zestawu / dzień',
    'equipmentBundles.dailyPriceHint': 'Zastępuje sumę stawek sprzętu wchodzącego w skład zestawu',
    'equipmentBundles.types': 'Typy sprzętu w zestawie',
    'equipmentBundles.typesHint': 'Wybierz co najmniej 2 typy - komplet tych typów w rezerwacji dostanie cenę zestawu',
    'equipmentBundles.noTypes': 'Nie masz jeszcze żadnych typów sprzętu. Dodaj je w Magazyn → Ustawienia pól, wtedy zbudujesz zestaw.',
    'equipmentBundles.nameRequired': 'Nazwa jest wymagana',
    'equipmentBundles.priceRequired': 'Podaj nieujemną cenę dzienną',
    'equipmentBundles.typesRequired': 'Zestaw musi zawierać co najmniej 2 typy sprzętu',
    'equipmentBundles.save': 'Zapisz',
    'equipmentBundles.cancel': 'Anuluj',
    'equipmentBundles.edit': 'Edytuj',
    'equipmentBundles.delete': 'Usuń',
    'equipmentBundles.deleteConfirm': 'Czy na pewno chcesz usunąć ten zestaw?',
    'equipmentBundles.loadError': 'Nie udało się wczytać zestawów',
    'equipmentBundles.saveError': 'Nie udało się zapisać zestawu',
    'equipmentBundles.deleteError': 'Nie udało się usunąć zestawu',
    'equipmentBundles.empty': 'Brak pakietów sprzętu',
    'equipmentBundles.emptyHint': 'Dodaj pierwszy zestaw, np. sprzęt z akcesoriami ze wspólną ceną dzienną.',
    'equipmentBundles.columnTypes': 'Typy w zestawie',
    'equipmentBundles.columnPrice': 'Cena / dzień',
    'equipmentBundles.columnActions': 'Akcje',
    'equipmentBundles.columnActive': 'Status',
    'equipmentBundles.toggleOn': 'Aktywny',
    'equipmentBundles.toggleOff': 'Nieaktywny',
    'equipmentBundles.toggleAria': 'Przełącz aktywność zestawu {name}',
    'equipmentBundles.toggleError': 'Nie udało się zmienić aktywności zestawu',
    'equipmentBundles.toggleNeedsTypes': 'Zestaw ma mniej niż 2 typy - uzupełnij go w edycji, zanim zmienisz aktywność',
    'equipmentBundles.presets.title': 'Szybkie zestawy',
    'equipmentBundles.presets.hint': 'Sprzęt, który Twoi klienci najczęściej wypożyczają razem (ostatnie 12 miesięcy). Kliknięcie wypełnia formularz - nic nie zapisuje od razu.',
    'equipmentBundles.presets.timesRented': 'Wypożyczane razem: {count}×',
    'equipmentBundles.presets.priceLine': '{price} zł/dzień zamiast ~{sum} zł (−{pct}%)',
    'equipmentBundles.presets.noPrice': 'Brak cen sprzętu do wyliczenia sugestii - cenę podasz w formularzu',
    'equipmentBundles.presets.useAria': 'Wypełnij formularz zestawem {name}',
    'priceRules.save': 'Zapisz',
    'priceRules.cancel': 'Anuluj',
    'priceRules.edit': 'Edytuj',
    'priceRules.delete': 'Usuń',
    'priceRules.deleteConfirm': 'Czy na pewno chcesz usunąć tę regułę?',
    'priceRules.empty': 'Brak reguł cenowych',
    'priceRules.emptyHint': 'Dodaj pierwszą regułę, np. dopłatę weekendową lub promocję na mało używany sprzęt.',
    'priceRules.nameRequired': 'Nazwa jest wymagana',
    'priceRules.valueRequired': 'Podaj wartość modyfikacji',
    'priceRules.percentTooLow': 'Rabat procentowy nie może przekraczać 100%.',
    'priceRules.dateRangeInvalid': 'Data "od" nie może być późniejsza niż data "do"',
    'priceRules.saveError': 'Nie udało się zapisać reguły',
    'priceRules.loadError': 'Nie udało się wczytać reguł',
    'priceRules.deleteError': 'Nie udało się usunąć reguły',
    'priceRules.columnDateRange': 'Zakres dat',
    'priceRules.columnWeekdays': 'Dni tygodnia',
    'priceRules.columnScope': 'Zakres sprzętu',
    'priceRules.columnAdjustment': 'Modyfikacja',
    'priceRules.columnPriority': 'Priorytet',
    'priceRules.columnActions': 'Akcje',
    'priceRules.allDates': 'Zawsze',
    'priceRules.allDays': 'Każdy dzień',
    'priceRules.presets.title': 'Szybkie reguły',
    'priceRules.presets.hint': 'Włącz typową regułę jednym przełącznikiem i wybierz procent chipem albo wpisz własny w polu obok. Wyłączenie nie kasuje reguły - zostaje w tabeli jako nieaktywna.',
    'priceRules.presets.badge': 'Szybka reguła',
    'priceRules.presets.inactive': '(nieaktywna)',
    'priceRules.presets.saveError': 'Nie udało się zapisać szybkiej reguły',
    'priceRules.presets.toggleAria': 'Przełącz preset: {name}',
    'priceRules.presets.chipsAria': 'Wartość procentowa presetu {name}',
    'priceRules.presets.chipAria': '{name}: ustaw {value}',
    'priceRules.presets.customPlaceholder': 'własny',
    'priceRules.presets.customAria': '{name}: własny procent',
    'priceRules.presets.customInvalid': 'Wpisz liczbę, np. 12 albo 12,5.',
    'priceRules.presets.customRange': 'Wpisz procent od 0,01 do {max}.',
    'priceRules.presets.weekend.label': 'Dopłata weekendowa',
    'priceRules.presets.weekend.on': 'Włączona: {value} w soboty i niedziele',
    'priceRules.presets.weekend.off': 'Wyłączona - soboty i niedziele bez dopłaty',
    // Bez dat w etykiecie — sezon wysoki to grudzień-marzec dla narciarni, ale czerwiec-sierpień
    // dla wypożyczalni rowerów czy kajaków. Faktyczny zakres ustawia admin w polach dat obok.
    'priceRules.presets.season_high.label': 'Sezon wysoki',
    'priceRules.presets.season_high.on': 'Włączony: {value}',
    'priceRules.presets.season_high.off': 'Wyłączony - bez dopłaty sezonowej',
    'priceRules.presets.offseason_promo.label': 'Promocja poza sezonem',
    'priceRules.presets.offseason_promo.on': 'Włączona: {value}',
    'priceRules.presets.offseason_promo.off': 'Wyłączona - poza sezonem ceny standardowe',
    'priceRules.presets.onWithRange': 'Włączony: {value} od {range}',
    'priceRules.presets.dateFromAria': 'Data początku sezonu dla presetu {name}',
    'priceRules.presets.dateToAria': 'Data końca sezonu dla presetu {name}',
    'priceRules.presets.dateRangeRequired': 'Ustaw zakres dat przed włączeniem tego presetu',
    // E.4: Presety branżowe magazynu
    'inventoryPresets.cardTitle': 'Zestaw startowy dla Twojej branży',
    'inventoryPresets.cardSub': 'Wybierz branżę, sprawdź, co zestaw ustawi, i zastosuj go jednym kliknięciem. Wszystko możesz potem zmienić.',
    'inventoryPresets.tileMeta': 'Typy: {types} · Pola: {fields}',
    'inventoryPresets.reviewTitle': 'Zestaw „{name}” ustawi:',
    'inventoryPresets.reviewTypes': 'Typy sprzętu',
    'inventoryPresets.reviewTypesHint': 'Zaznaczone typy będą istnieć po zastosowaniu. Odznacz te, których nie wynajmujesz.',
    'inventoryPresets.reviewLeftoverHint': 'Przekreślone zostały po poprzednim zestawie, więc je usuniemy. Zaznacz, żeby zostały.',
    'inventoryPresets.leftoverTag': 'z poprzedniego zestawu',
    'inventoryPresets.reviewFields': 'Pola magazynu',
    'inventoryPresets.reviewNewFields': 'Nowe pola:',
    'inventoryPresets.applyCta': 'Zastosuj zestaw',
    'inventoryPresets.applying': 'Stosuję…',
    'inventoryPresets.applyNote': 'Założymy typy sprzętu ({types}) i ustawimy pola magazynu ({fields}).',
    'inventoryPresets.applyNoteWithRemoval': 'Założymy typy sprzętu ({types}), usuniemy ({removed}) i ustawimy pola magazynu ({fields}).',
    'inventoryPresets.confirmReplace': 'Zastąpić obecną konfigurację pól?',
    'inventoryPresets.confirmReplaceBody': 'Zestaw „{name}” ustawi pola magazynu po swojemu. Typy sprzętu tylko dojdą, nic nie usuwamy.',
    'inventoryPresets.confirmReplaceBodyWithRemoval': 'Zestaw „{name}” ustawi pola magazynu po swojemu i usunie typy zostawione po poprzednim zestawie: {removed}. Typ, na którym stoi sprzęt, cennik albo pakiet, zostanie.',
    'inventorySettings.confirmResetDefaults': 'Czy na pewno chcesz przywrócić domyślne ustawienia?',
    'inventorySettings.confirmResetDefaultsBody': 'Kolumny i pola wymagane wrócą do domyślnych, a zestaw startowy branży pojawi się z powrotem.',
    'inventorySettings.confirmResetDefaultsBodyWithCategories': 'Kolumny i pola wymagane wrócą do domyślnych, a zestaw startowy branży pojawi się z powrotem. USUNIEMY też wszystkie kategorie sprzętu ({count}), także te dodane ręcznie. Zostaną tylko te, na których stoi sprzęt, reguła cennika albo pakiet.',
    'inventorySettings.restoringDefaults': 'Przywracam…',
    'inventorySettings.resetDefaultsKept': 'Przywrócono ustawienia domyślne. Te kategorie zostały, bo są używane: {names}.',
    'inventorySettings.resetDefaultsPartial': 'Ustawienia przywrócone, ale nie wszystkich kategorii udało się usunąć. Odśwież stronę i spróbuj ponownie.',
    'inventorySettings.confirmDeleteCategory': 'Usunąć kategorię „{name}”?',
    'inventorySettings.confirmDeleteCategoryBody': 'Zniknie z formularza dodawania sprzętu i z szablonu importu. Jeśli stoi na niej sprzęt, reguła cennika albo pakiet, nie usuniemy jej.',
    'inventorySettings.catDeleted': 'Usunięto kategorię „{name}”.',
    'inventorySettings.catInUse': 'Nie można usunąć „{name}”, bo jest w użyciu (sprzęt: {equipment}, reguły cennika: {rules}, pakiety: {bundles}).',
    'inventorySettings.catDeleteFailed': 'Nie udało się usunąć kategorii.',
    'inventorySettings.ownFieldTag': 'własne',
    'inventorySettings.resetDefaultsDone': 'Przywrócono ustawienia domyślne.',
    'inventoryPresets.doneTitle': 'Zestaw „{name}” zastosowany',
    'inventoryPresets.doneSummary': 'Nowe typy sprzętu: {types}. Ustawione pola magazynu: {fields}.',
    'inventoryPresets.doneRemoved': 'Usunięte typy z poprzedniego zestawu: {removed}.',
    'inventoryPresets.doneBlocked': 'Zostały, bo są używane: {names}.',
    'inventoryPresets.doneAddEquipment': 'Dodaj pierwszy sprzęt',
    'inventoryPresets.donePickAnother': 'Wybierz inną branżę',
    'inventoryPresets.typeAddError': 'Nie udało się dodać typu sprzętu.',
    // Preferences
    'preferences.title': 'Twoje preferencje',
    'preferences.theme': 'Motyw',
    'preferences.theme.light': 'Jasny',
    'preferences.theme.dark': 'Ciemny',
    'preferences.language': 'Język interfejsu',
    'preferences.language.polish': 'Polski',
    'preferences.language.english': 'Angielski',
    'preferences.cancel': 'Anuluj',
    'preferences.save': 'Zapisz',
    'preferences.saving': 'Zapisywanie…',
    'preferences.loading': 'Ładowanie preferencji...',
    'preferences.saved': 'Ustawienia zostały zapisane',
    'preferences.chooseTheme': 'Wybierz wygląd aplikacji',
    'preferences.chooseLanguage': 'Wybierz język interfejsu',
    'preferences.theme.system': 'Automatyczny',
    'preferences.language.german': 'Niemiecki',

    // Common
    'common.cancel': 'Anuluj',
    'common.save': 'Zapisz',
    'addEquipment.saving': 'Zapisywanie...',
    'addEquipment.quantity': 'Liczba sztuk',
    'addEquipment.quantityLess': 'Mniej sztuk',
    'addEquipment.quantityMore': 'Więcej sztuk',
    'addEquipment.quantityHintOne': 'Masz kilka jednakowych sztuk? Ustaw ich liczbę, a dodasz je jednym zapisem.',
    'addEquipment.quantityHintMany': 'Każda z {n} sztuk będzie osobną pozycją w magazynie, z własnym numerem i etykietą.',
    'addEquipment.quantityNoNumbers': 'Bez numerów inwentarzowych: każda sztuka dostanie własny kod systemowy do etykiety.',
    'addEquipment.quantityInvalid': 'Liczba sztuk musi być liczbą od 1 do {max}.',
    'addEquipment.inventoryNumberFirst': 'Numer pierwszej sztuki',
    'addEquipment.barcodePerUnit': 'Przy kilku sztukach kod producenta wpiszesz potem w każdej sztuce osobno.',
    'addEquipment.saveManyFew': 'Dodaj {n} sztuki',
    'addEquipment.saveManyMany': 'Dodaj {n} sztuk',
    'addEquipment.saveManyOther': 'Dodaj {n} sztuk',
    'addEquipment.savedManyFew': 'Dodano {n} sztuki sprzętu.',
    'addEquipment.savedManyMany': 'Dodano {n} sztuk sprzętu.',
    'addEquipment.savedManyOther': 'Dodano {n} sztuk sprzętu.',
    'addUser.passwordPolicyNotMet': 'Hasło nie spełnia wymagań bezpieczeństwa',
    'addUser.passwordTooWeak': 'Hasło musi mieć siłę przynajmniej „Dobry”',
    'preferences.saveError': 'Nie udało się zapisać preferencji.',
    'userDetails.loadError': 'Nie udało się wczytać danych użytkownika.',
    'common.saving': 'Zapisywanie...',
    'common.edit': 'Edytuj',
    'common.delete': 'Usuń',
    'common.add': 'Dodaj',
    'common.loading': 'Ładowanie...',
    'common.error': 'Błąd',
    'common.success': 'Sukces',
    'common.actions': 'Akcje',
    'common.clear': 'Wyczyść',
    'common.refresh': 'Odśwież',
    'common.close': 'Zamknij',
    'inventory.closeFilters': 'Zamknij filtry',
    'common.previous': 'Poprzednia',
    'common.next': 'Następna',
    'common.pageInfo': 'Strona {page} z {total}',
    'common.yes': 'Tak',
    'common.no': 'Nie',
    'common.undo': 'Cofnij',
    'common.back': 'Powrót',
    /* Wspolne napisy dolozone przy ujednolicaniu interfejsu (2026-08-19). Slownik mial juz
       przestrzen `common.*`, ale wolano ja raptem 36 razy w calej aplikacji, wiec te same
       slowa siedzialy po kilka razy pod kluczami stron — stad m.in. „Powrot do profilu"
       w trzech miejscach obok „Wroc do profilu" w dwoch. Nowe napisy wspolne trafiaja TU. */
    'common.backToProfile': 'Powrót do profilu',
    'common.tour': 'Przewodnik',
    'common.firstPage': 'Pierwsza strona',
    'common.lastPage': 'Ostatnia strona',
    'common.previousPage': 'Poprzednia strona',
    'common.nextPage': 'Następna strona',
    'common.showingRange': 'Pokazano {from}-{to} z {total}',
    'common.retry': 'Spróbuj ponownie',
    'common.search': 'Szukaj',
    'common.filters': 'Filtry',
    'common.clearFilters': 'Wyczyść filtry',
    'common.confirm': 'Potwierdź',
    'common.confirmDeleteTitle': 'Usunąć na pewno?',
    'common.irreversible': 'Tej operacji nie da się cofnąć.',
    'common.savedSuccess': 'Zapisano zmiany',
    'common.saveError': 'Nie udało się zapisać zmian',
    'common.loadError': 'Nie udało się wczytać danych',
    'photos.cropHint': 'Kadruj sam sprzęt: bez twarzy, tablic rejestracyjnych i dokumentów. Aplikacja usuwa z pliku lokalizację i dane aparatu.',
    'common.noResults': 'Brak wyników',
    'common.noData': 'Brak danych',
    'common.all': 'Wszystkie',
    'common.copy': 'Kopiuj',
    'common.copied': 'Skopiowano',
    'common.download': 'Pobierz',
    'common.send': 'Wyślij',
    'common.details': 'Szczegóły',
    'common.status': 'Status',
    'common.date': 'Data',
    'common.amount': 'Kwota',
    'common.required': 'Pole wymagane',
    'common.sessionExpired': 'Sesja wygasła. Zaloguj się ponownie.',

    // Clients page
    'clients.title': 'Kartoteka Klientów',
    'clients.subtitle': 'Zarządzaj danymi klientów i przeglądaj historię rezerwacji',
    'clients.searchPlaceholder': 'Szukaj po imieniu, nazwisku, telefonie lub e-mailu...',
    'clients.addClient': 'Dodaj klienta',
    'clients.totalClients': 'klientów',
    'clients.searchResults': 'Wyniki wyszukiwania',
    'clients.firstName': 'Imię',
    'clients.lastName': 'Nazwisko',
    'clients.phone': 'Telefon',
    'clients.email': 'E-mail',
    'clients.reservations': 'Rezerwacje',
    'clients.details': 'Szczegóły',
    'clients.noResults': 'Brak klientów spełniających kryteria wyszukiwania',
    'clients.noClients': 'Brak klientów w bazie danych',
    'clients.clientDetails': 'Szczegóły klienta',
    'clients.name': 'Imię i nazwisko',
    'clients.showDetails': 'Pokaż szczegóły klienta',
    'clients.newThisMonth': 'Nowi w tym miesiącu',
    'clients.shownOfTotal': 'Wyświetlono {shown} z {total} klientów',
    'clients.regularClient': 'Stały klient',
    'clients.firstNameRequired': 'Imię*',
    'clients.firstNamePlaceholder': 'Wpisz imię',
    'clients.emailPlaceholder': 'przykład@email.com',
    'clients.deleteConfirmTitle': 'Potwierdź usunięcie',
    'clients.deleteConfirmIntro': 'Czy na pewno chcesz usunąć klienta',
    'clients.deleteDataLoss': 'Nadchodzące i anulowane rezerwacje zostaną usunięte. Zakończone zostaną jako historia wypożyczeń, ale bez danych klienta: znikną jego dane kontaktowe, adres, dane firmy, notatki rezerwacji, adresaci powiadomień i zdjęcia stanu sprzętu, a nieopłacone oferty zostaną usunięte (ich linki do zapłaty przestaną działać). Faktury VAT zostają z danymi nabywcy (obowiązek przechowywania 5 lat). Jeśli klient prosi o kopię swoich danych, pobierz je przed usunięciem.',
    'clients.exportData': 'Pobierz dane (RODO)',
    'clientsExport.open': 'Eksportuj',
    'clientsExport.title': 'Eksport klientów',
    'clientsExport.subtitle': 'Wybierz cechy klientów i pobierz je jako plik Excel albo CSV.',
    'clientsExport.scopeTitle': 'Którzy klienci',
    'clientsExport.scopeList': 'Klienci z listy',
    'clientsExport.scopeAll': 'Wszyscy klienci',
    'clientsExport.scopeAllHint': 'Bez wyszukiwania i filtrów',
    'clientsExport.scopeSearch': 'wyszukiwanie: „{q}”',
    'clientsExport.scopeRecent': 'nowi (30 dni)',
    'clientsExport.scopeFrequent': 'stali klienci (3+)',
    'clientsExport.fieldsTitle': 'Co ma być w pliku',
    'clientsExport.clearFields': 'Odznacz wszystko',
    'clientsExport.group.person': 'Dane kontaktowe',
    'clientsExport.group.address': 'Adres',
    'clientsExport.group.company': 'Firma',
    'clientsExport.group.history': 'Historia',
    'clientsExport.field.firstname': 'Imię',
    'clientsExport.field.lastname': 'Nazwisko',
    'clientsExport.field.email': 'E-mail',
    'clientsExport.field.phone_number': 'Telefon',
    'clientsExport.field.address': 'Cały adres w jednej kolumnie',
    'clientsExport.field.street': 'Ulica',
    'clientsExport.field.building_number': 'Nr budynku',
    'clientsExport.field.apartment_number': 'Nr lokalu',
    'clientsExport.field.postal_code': 'Kod pocztowy',
    'clientsExport.field.city': 'Miejscowość',
    'clientsExport.field.client_type': 'Rodzaj klienta',
    'clientsExport.field.company_name': 'Nazwa firmy',
    'clientsExport.field.company_nip': 'NIP',
    'clientsExport.field.company_regon': 'REGON',
    'clientsExport.field.registration_date': 'Data dodania',
    'clientsExport.field.reservations_count': 'Liczba rezerwacji',
    'clientsExport.field.last_reservation': 'Ostatnia rezerwacja',
    'clientsExport.formatTitle': 'Format pliku',
    'clientsExport.format.xlsx': 'Excel (.xlsx)',
    'clientsExport.format.csv': 'CSV (.csv)',
    'clientsExport.formatHint.xlsx': 'Otwiera się od razu w Excelu i Arkuszach Google. Daty i liczby są gotowe do sortowania.',
    'clientsExport.formatHint.csv': 'Tekst rozdzielany średnikiem, do wgrania w inny program, np. do wysyłki newslettera.',
    'clientsExport.previewTitle': 'Podgląd pliku',
    'clientsExport.previewEmpty': 'Zaznacz co najmniej jedną cechę, żeby zobaczyć podgląd.',
    'clientsExport.previewMore': 'Pierwsze {shown} z {total} wierszy z danymi.',
    'clientsExport.previewAll': 'Tak wygląda cały plik.',
    'clientsExport.clientsOne': '{n} klient',
    'clientsExport.clientsFew': '{n} klientów',
    'clientsExport.clientsMany': '{n} klientów',
    'clientsExport.columnsOne': '{n} kolumna',
    'clientsExport.columnsFew': '{n} kolumny',
    'clientsExport.columnsMany': '{n} kolumn',
    'clientsExport.cancel': 'Anuluj',
    'clientsExport.download': 'Pobierz plik {ext}',
    'clientsExport.preparing': 'Przygotowuję plik…',
    'clientsExport.downloaded': 'Pobrano plik {name}.',
    'clientsExport.errorAdmin': 'Eksport klientów wymaga uprawnień administratora.',
    'clientsExport.errorSession': 'Sesja wygasła. Zaloguj się ponownie.',
    'clientsExport.errorGeneric': 'Nie udało się przygotować pliku. Spróbuj ponownie.',
    'clients.exportDataHint': 'Plik JSON ze wszystkimi danymi klienta w systemie: na żądanie klienta (art. 15 i 20 RODO).',
    'clients.exportLoading': 'Przygotowuję plik…',
    'clients.exportFailed': 'Nie udało się pobrać danych klienta.',

    // Equipment
    'addEquipment.title': 'Dodaj sprzęt',
    'addEquipment.name': 'Nazwa modelu',
    'addEquipment.namePlaceholder': 'Nazwa modelu',
    'addEquipment.size': 'Rozmiar sprzętu',
    'addEquipment.sizePlaceholder': 'Rozmiar sprzętu',
    'addEquipment.brand': 'Marka',
    'addEquipment.brandPlaceholder': 'Marka',
    'addEquipment.price': 'Cena za dzień',
    'addEquipment.pricePlaceholder': 'Cena za dzień (PLN)',
    'addEquipment.bail': 'Kaucja',
    'addEquipment.bailPlaceholder': 'Kaucja',
    'addEquipment.class': 'Klasa sprzętu',
    'addEquipment.classPlaceholder': 'Klasa sprzętu',
    'addEquipment.type': 'Kategoria sprzętu',
    'addEquipment.typePlaceholder': 'Kategoria',
    'addEquipment.category': 'Kategoria sprzętu',
    'addEquipment.categoryPlaceholder': 'Wybierz kategorię',
    'addEquipment.selectCategory': 'Wybierz kategorię sprzętu',
    'addEquipment.fillAll': 'Uzupełnij wszystkie pola',
    'addEquipment.success': 'Sprzęt został dodany pomyślnie',
    'addEquipment.error': 'Błąd podczas dodawania sprzętu',
    'addEquipment.class.Junior': 'Junior',
    'addEquipment.class.Premium': 'Premium',
    'addEquipment.class.Normal': 'Normal',
    'addEquipment.inventoryNumber': 'Numer',
    'addEquipment.inventoryNumberPlaceholder': 'Numer',
    'addEquipment.subtitle': 'Uzupełnij dane, aby dodać nowy sprzęt do magazynu',
    'addEquipment.priceOver7': 'Cena za dzień (> 7 dni)',
    'addEquipment.priceOver7Placeholder': 'Cena za dzień po 7+ dniach (PLN)',
    'addEquipment.sku': 'Kod/SKU',
    'addEquipment.skuPlaceholder': 'Kod lub SKU',
    'addEquipment.condition': 'Stan sprzętu',
    'addEquipment.conditionPlaceholder': 'Nowy / Używany / Serwis',
    'addEquipment.location': 'Lokalizacja',
    'addEquipment.locationPlaceholder': 'Regal / strefa / wieszak',
    'addEquipment.tags': 'Tagi',
    'addEquipment.tagsPlaceholder': 'np. dzieciecy, promo',
    'addEquipment.supplier': 'Dostawca',
    'addEquipment.supplierPlaceholder': 'Nazwa dostawcy',
    'addEquipment.purchaseDate': 'Data zakupu',
    'addEquipment.maintenanceDate': 'Data serwisu',
    'addEquipment.images': 'Zdjęcia (URL)',
    'addEquipment.imagesPlaceholder': 'Adresy URL rozdzielone przecinkami',
    'addEquipment.barcode': 'Kod kreskowy / QR',
    'addEquipment.barcodePlaceholder': 'Numer kodu',
    'addEquipment.priceCurrency': 'Waluta ceny',
    'addEquipment.priceCurrencyPlaceholder': 'np. PLN',
    'addEquipment.depositCurrency': 'Waluta kaucji',
    'addEquipment.depositCurrencyPlaceholder': 'np. PLN',
    'addEquipment.currency': 'Waluta',
    'addEquipment.currencyPlaceholder': 'np. PLN',
    'addEquipment.currencyLoading': 'Ładowanie walut…',
    'addEquipment.currencyNoMatches': 'Brak dopasowań',
    'addEquipment.wearLevel': 'Poziom zużycia',
    'addEquipment.wearLevelPlaceholder': 'np. 20%',
    'addEquipment.compatibility': 'Kompatybilność',
    'addEquipment.compatibilityPlaceholder': 'np. NN 75 / system X',
    'addEquipment.sizeRange': 'Zakres rozmiarów',
    'addEquipment.sizeRangePlaceholder': 'np. 36-42',
    'addEquipment.save': 'Zapisz',
    'addEquipment.cancel': 'Anuluj',
    'addEquipment.backToInventory': 'Powrót do magazynu',

    // Inventory
    'inventory.title': 'Magazyn',
    'inventory.calendar': 'Kalendarz sprzętu',
    'inventory.inventoryNumber': 'Numer',
    'inventory.equipment': 'Sprzęt',
    'inventory.size': 'Rozmiar',
    'inventory.brand': 'Marka',
    'inventory.category': 'Kategoria',
    'inventory.class': 'Klasa',
    'inventory.sku': 'Kod/SKU',
    'inventory.condition': 'Stan',
    'inventory.location': 'Lokalizacja',
    'inventory.tags': 'Tagi',
    'inventory.supplier': 'Dostawca',
    'inventory.purchaseDate': 'Data zakupu',
    'inventory.maintenanceDate': 'Data serwisu',
    'inventory.images': 'Zdjęcia',
    'inventory.barcode': 'Kod',
    'inventory.priceCurrency': 'Waluta ceny',
    'inventory.depositCurrency': 'Waluta kaucji',
    'inventory.currency': 'Waluta',
    'inventory.wearLevel': 'Zużycie',
    'inventory.compatibility': 'Kompatybilność',
    'inventory.sizeRange': 'Zakres rozmiarów',
    'inventory.add': 'Dodaj sprzęt',
    'inventory.delete': 'Usuń',
    'inventory.selectedCount': 'Zaznaczono',
    'inventory.confirmDeleteOne': 'Czy na pewno chcesz usunąć ten sprzęt?',
    'inventory.confirmDeleteMany': 'Czy na pewno chcesz usunąć {count} elementów sprzętu?',
    'inventory.selectItem': 'Zaznacz sprzęt',
    'inventory.unselectItem': 'Odznacz sprzęt',
    'inventory.settings': 'Ustawienia magazynu',
    'inventory.settingsSubtitle': 'Zarządzaj widocznością kolumn, wymaganymi polami i kategoriami sprzętu',
    'inventory.settingsColumns': 'Widoczne kolumny w tabeli',
    'inventory.settingsRequired': 'Wymagane pola przy dodawaniu sprzętu',
    'inventory.settingsRequiredHint': 'Pola bazowe są zawsze wymagane.',
    'inventory.addCategory': 'Dodaj kategorię',
    'inventory.categoryName': 'Nazwa kategorii',
    'inventory.addCategoryBtn': 'Dodaj',
    'inventory.categoryNameRequired': 'Podaj nazwę kategorii.',
    'inventory.categoryAddSuccess': 'Kategoria dodana.',
    'inventory.categoryAddError': 'Nie można dodać kategorii.',
    'inventory.categoryFieldsBase': 'Pola wymagane zawsze',
    'inventory.categoryFieldsOptional': 'Dodatkowe pola dla tej kategorii',
    'inventory.categoryFieldsHint': 'Zaznacz pola, które mają być wymagane tylko dla tej kategorii.',
    'inventory.search': 'Szukaj w nazwie...',
    'inventory.options': 'Opcje',
    'inventory.details': 'Szczegóły sprzętu',
    'inventory.page': 'Strona',
    'inventory.next': 'Nast.',
    'inventory.noMatch': 'Brak sprzętu spełniającego kryteria.',
    'inventory.name': 'Nazwa',
    'inventory.sizePlaceholder': 'Wpisz rozmiar...',
    'inventory.type.Narty': 'Narty',
    'inventory.type.Buty narciarskie': 'Buty narciarskie',
    'inventory.type.Buty snowboardowe': 'Buty snowboardowe',
    'inventory.type.Snowboard': 'Snowboard',
    'inventory.type.Kije': 'Kije',
    'inventory.type.Kask': 'Kask',
    'inventory.type.Gogle': 'Gogle',
    'inventory.clearFilters': 'Wyczyść filtry',
    'inventory.searchPlaceholder': 'Szukaj po nazwie, marce lub numerze…',
    'inventory.resultsTotal': '{total} szt.',
    'inventory.resultsOfTotal': '{shown} z {total} szt.',
    'inventory.filterSearchPlaceholder': 'Szukaj…',
    'inventory.filterNoMatches': 'Brak pasujących wartości',
    'inventory.scanned': 'Zeskanowano: {code}',
    'scanner.cameraButton': 'Aparat',
    'scanner.cameraButtonHint': 'Skanuj kod aparatem tego urządzenia',
    'scanner.phoneButton': 'Telefon',
    'scanner.phoneButtonHint': 'Użyj telefonu jako bezprzewodowego skanera dla tego okna',
    'scanner.cameraTitle': 'Skanuj aparatem',
    'scanner.cameraSubtitle': 'Skieruj aparat na kod QR albo kreskowy na naklejce sprzętu.',
    'scanner.videoLabel': 'Podgląd aparatu',
    'scanner.starting': 'Uruchamiam aparat…',
    'scanner.aimHint': 'Trzymaj kod w ramce. Odczyt jest automatyczny: każdy kod liczy się raz, dopóki nie zniknie z kadru.',
    'scanner.read': 'Odczytano: {code}',
    'scanner.sendFailed': 'Nie udało się przetworzyć kodu.',
    'scanner.manualPlaceholder': 'Albo wpisz kod ręcznie',
    'scanner.manualSubmit': 'Wyślij',
    'scanner.problem.insecure': 'Aparat działa tylko na stronie otwartej przez HTTPS. Otwórz panel pod adresem https://…',
    'scanner.problem.unsupported': 'Ta przeglądarka nie udostępnia aparatu. Użyj aktualnego Chrome, Safari lub Edge albo wpisz kod poniżej.',
    'scanner.problem.denied': 'Brak zgody na aparat. Zezwól na dostęp do kamery w ustawieniach przeglądarki (ikona kłódki przy adresie) i otwórz okno ponownie.',
    'scanner.problem.nocamera': 'Nie znaleziono aparatu w tym urządzeniu. Wpisz kod poniżej albo użyj telefonu.',
    'scanner.problem.nocameraPhone': 'Nie znaleziono aparatu w tym urządzeniu. Wpisz kod poniżej.',
    'scanner.problem.busy': 'Aparat jest zajęty przez inną aplikację. Zamknij ją i spróbuj ponownie.',
    'scanner.problem.unknown': 'Nie udało się uruchomić aparatu. Wpisz kod poniżej.',
    'scanner.phone.title': 'Skanuj telefonem',
    'scanner.phone.subtitle': 'Telefon zadziała jak bezprzewodowy czytnik, bez instalowania aplikacji.',
    'scanner.phone.step1': 'Otwórz aparat w telefonie i skieruj go na kod QR poniżej.',
    'scanner.phone.step2': 'Stuknij link, który pokaże telefon. Otworzy się skaner.',
    'scanner.phone.step3': 'Skanuj naklejki na sprzęcie, a kody trafią od razu do tego okna.',
    'scanner.phone.qrAlt': 'Kod QR do otwarcia skanera na telefonie',
    'scanner.phone.status.creating': 'Przygotowuję kod…',
    'scanner.phone.status.waiting': 'Czekam na telefon…',
    'scanner.phone.status.connected': 'Telefon połączony, możesz skanować',
    'scanner.phone.status.expired': 'Kod wygasł albo połączenie zostało zamknięte. Wygeneruj nowy kod.',
    'scanner.phone.status.error': 'Nie udało się przygotować połączenia. Spróbuj ponownie.',
    'scanner.phone.copyLink': 'Kopiuj link',
    'scanner.phone.copied': 'Skopiowano',
    'scanner.phone.localhostWarning': 'Panel jest otwarty pod adresem localhost, więc telefon go nie otworzy. Skanowanie telefonem działa na panelu pod publicznym adresem HTTPS.',
    'scanner.phone.httpWarning': 'Panel nie jest otwarty przez HTTPS, więc przeglądarka telefonu nie udostępni na nim aparatu. Na produkcji (https) wszystko działa.',
    'scanner.phone.connected': 'Telefon połączony',
    'scanner.phone.waitingForCodes': 'Czekam na kody…',
    'scanner.phone.show': 'Pokaż',
    'scanner.phone.disconnect': 'Rozłącz',
    'scanner.phone.minimize': 'Zwiń do paska',
    'scanner.phone.newCode': 'Nowy kod',
    'scanner.phone.finish': 'Zakończ',
    'phoneScanner.title': 'Skaner kodów',
    'phoneScanner.subtitle': 'Kody trafiają do okna na komputerze.',
    'phoneScanner.checking': 'Łączę z komputerem…',
    'phoneScanner.expired': 'Ten link wygasł albo został zamknięty na komputerze. Na komputerze kliknij „Telefon” (albo „Nowy kod”) i zeskanuj nowy kod QR.',
    'phoneScanner.expiredShort': 'Link wygasł. Zeskanuj nowy kod QR z komputera.',
    'phoneScanner.sent': 'Wysłano: {code}',
    'phoneScanner.noListener': 'Wysłano, ale okno na komputerze jest zamknięte. Otwórz je ponownie („Telefon”).',
    'phoneScanner.tooFast': 'Za dużo kodów naraz. Zwolnij na chwilę.',
    'phoneScanner.sendFailed': 'Nie udało się wysłać kodu. Sprawdź połączenie z internetem.',
    'labels.button': 'Etykiety',
    'labels.printOne': 'Drukuj etykietę',
    'labels.summary': 'Etykiety: {labels} · arkusze: {pages}',
    'labels.summaryRoll': 'Etykiety: {labels}',
    'labels.printCount': 'Drukuj ({n})',
    'labels.andMore': 'i {n} innych',
    'labels.noCategory': 'Bez kategorii',
    'labels.preview': 'Podgląd wydruku',
    'labels.sheets': 'Arkusze',
    'labels.goToSheet': 'Arkusz {n}',
    'labels.sheetOf': 'Arkusz {n} z {total}',
    'labels.labelOf': 'Etykieta {n} z {total}',
    'labels.prevSheet': 'Poprzedni arkusz',
    'labels.nextSheet': 'Następny arkusz',
    'labels.prevLabel': 'Poprzednia etykieta',
    'labels.nextLabel': 'Następna etykieta',
    'labels.legend.label': 'etykieta',
    'labels.legend.skipped': 'pominięte pole',
    'labels.legend.free': 'wolne pole',
    'labels.selection.title': 'Co drukujemy',
    'labels.selection.count': '{n} z {total} zaznaczonych',
    'labels.selection.search': 'Szukaj po nazwie, numerze lub kategorii',
    'labels.selection.searchShort': 'Nazwa, numer lub kategoria',
    'labels.selection.selectAll': 'Zaznacz wszystko',
    'labels.selection.clearAll': 'Odznacz wszystko',
    'labels.selection.selectShown': 'Zaznacz znalezione',
    'labels.selection.clearShown': 'Odznacz znalezione',
    'labels.selection.noMatches': 'Nic nie pasuje do „{q}”.',
    'labels.selection.groupToggle': 'Zaznacz całą kategorię: {name}',
    'labels.selection.showOnSheet': 'Pokaż na arkuszu',
    'labels.selection.nothingSelected': 'Zaznacz sprzęt na liście, żeby zobaczyć podgląd.',
    'labels.printSelected': 'Drukuj etykiety ({n})',
    'labels.title': 'Etykiety sprzętu',
    'labels.subtitle': 'Kody QR i kreskowe do naklejenia na sprzęt, rozpoznawane przez skaner w panelu.',
    'labels.print': 'Drukuj',
    'labels.loadError': 'Nie udało się wczytać sprzętu.',
    'labels.layout': 'Arkusz / drukarka',
    'labels.layouts.a4-24': 'A4: 24 etykiety 70 × 37 mm',
    'labels.layouts.a4-21': 'A4: 21 etykiet 70 × 42,3 mm',
    'labels.layouts.a4-65': 'A4: 65 etykiet 38 × 21 mm (małe)',
    'labels.layouts.roll-50x30': 'Drukarka etykiet: 50 × 30 mm',
    'labels.layouts.roll-45x30': 'Drukarka etykiet Brother: 45 × 30 mm',
    'labels.layouts.roll-62x29': 'Drukarka etykiet: 62 × 29 mm (Brother)',
    'labels.format': 'Rodzaj kodu',
    'labels.formats.qr': 'QR',
    'labels.formats.barcode': 'Kreskowy',
    'labels.formats.both': 'Oba',
    'labels.formatHint': 'QR czyta aparat telefonu i czytniki 2D. Tanie czytniki laserowe czytają tylko kod kreskowy, a „Oba” działa z każdym.',
    'labels.copies': 'Kopie każdej etykiety',
    'widgetFilters.showEmpty': 'Pokaż cechy bez danych ({n})',
    'widgetFilters.hideEmpty': 'Ukryj cechy bez danych',
    'widgetFilters.from': 'od',
    'widgetFilters.to': 'do',
    'widgetFilters.title': 'Filtry w widgecie',
    'widgetFilters.sub': 'Wybierz cechy, po których klient zawęzi listę sprzętu. Wartości bierzemy z Twojego magazynu, więc nie trzeba ich wpisywać. Filtr pojawia się w kategorii tylko wtedy, gdy ma w niej co najmniej dwie różne wartości.',
    'widgetFilters.loading': 'Wczytywanie cech sprzętu…',
    'widgetFilters.loadError': 'Nie udało się wczytać filtrów. Odśwież stronę.',
    'widgetFilters.meta': '{n} różnych wartości: {values}',
    'widgetFilters.noData': 'Żaden sprzęt nie ma jeszcze tej cechy',
    'widgetFilters.oneValue': 'jedna wartość',
    'widgetFilters.rangeBadge': 'zakres od–do',
    'widgetFilters.labelAria': 'Nazwa filtra w widgecie: {name}',
    'widgetFilters.up': 'Przesuń wyżej: {name}',
    'widgetFilters.down': 'Przesuń niżej: {name}',
    'widgetFilters.previewAria': 'Podgląd filtrów w widgecie',
    'widgetFilters.counter': 'Wybrane: {n} z {max}',
    'widgetFilters.save': 'Zapisz filtry',
    'widgetFilters.saved': 'Filtry zapisane. Widget pokaże je przy następnym otwarciu.',
    'widgetFilters.saveError': 'Nie udało się zapisać filtrów.',
    'classBooking.title': 'Rezerwacja według klas',
    'classBooking.sub': 'Dla wybranych kategorii klient wybiera w widgecie klasę (np. Narty · Premium ×2) i podaje wymiary, a Ty dobierasz konkretny sprzęt. Klient płaci dopiero po tym, jak potwierdzisz dostępność w szczegółach rezerwacji. Pozostałe kategorie działają jak dotąd.',
    'classBooking.loading': 'Wczytywanie kategorii…',
    'classBooking.loadError': 'Nie udało się wczytać ustawień. Odśwież stronę.',
    'classBooking.empty': 'Najpierw dodaj sprzęt z kategorią i klasą w Magazynie.',
    'classBooking.meta': 'Klasy: {classes} · sprzęt: {units} szt.',
    'classBooking.offHint': 'Klient wybiera konkretny sprzęt i rozmiar, jak dotąd.',
    'classBooking.questionsTitle': 'Pytania do doboru',
    'classBooking.question.height': 'Wzrost',
    'classBooking.question.weight': 'Waga',
    'classBooking.question.shoe_size': 'Rozmiar buta',
    'classBooking.question.skill': 'Poziom',
    'classBooking.question.head': 'Obwód głowy',
    'classBooking.question.age': 'Wiek',
    'classBooking.noQuestions': 'Bez pytań klient poda tylko liczbę sztuk.',
    'classBooking.pricesTitle': 'Ceny klas',
    'classBooking.units': '{n} szt. w magazynie',
    'classBooking.pricePlaceholder': 'nie oferuj',
    'classBooking.perDay': 'za dzień, zł',
    'classBooking.noPrices': 'Podaj cenę co najmniej jednej klasy. Bez ceny kategoria nie trafi do widgetu w tym trybie.',
    'classBooking.save': 'Zapisz rezerwację według klas',
    'classBooking.badPrice': 'Cena musi być kwotą większą od 0, np. 80 albo 79,50.',
    'classBooking.missingPrices': 'Podaj cenę co najmniej jednej klasy albo wyłącz kategorię: {names}.',
    'classBooking.saved': 'Zapisane. Widget pokaże zmiany przy następnym otwarciu.',
    'classBooking.saveError': 'Nie udało się zapisać ustawień.',
    'classBooking.over7': 'od 8. dnia, zł',
    'classBooking.over7Placeholder': 'jak zwykle',
    'classBooking.priceAria': 'Cena za dzień: {name}',
    'classBooking.over7Aria': 'Cena za dzień od 8. dnia: {name}',
    'classBooking.pricingHint': 'Ceny dynamiczne i zestawy dla klas ustawisz w Profilu, w Cennikach i Pakietach sprzętu (pole „Dotyczy”).',
    'priceRules.appliesTo': 'Dotyczy',
    'priceRules.appliesToAll': 'Całej wypożyczalni (sprzęt i klasy w widgecie)',
    'priceRules.appliesToEquipment': 'Tylko konkretnego sprzętu',
    'priceRules.appliesToClasses': 'Tylko rezerwacji według klas w widgecie',
    'priceRules.appliesToHint': 'Reguła „tylko klasy” zmienia ceny klas z ustawień widgetu (Widget → Rezerwacja według klas), a ceny sprzętu zostawia bez zmian.',
    'priceRules.scopeClassesTag': 'klasy w widgecie',
    'priceRules.scopeEquipmentTag': 'tylko sprzęt',
    'priceRules.includesBundles': 'Działa też na pakiety',
    'priceRules.includesBundlesHint': 'Cena pakietu zmienia się o ten sam procent, dzień po dniu. Reguła „tylko konkretny sprzęt” albo „tylko klasy” działa na pakiety o tym samym zakresie i na pakiety całej wypożyczalni.',
    'priceRules.includesBundlesLocked': 'Na pakiety działa tylko reguła procentowa bez wybranej klasy i typu sprzętu.',
    'priceRules.bundlesBadge': 'także pakiety',
    'priceRules.presets.bundlesLabel': 'Też na pakiety',
    'priceRules.presets.toggleLabel': 'Reguła',
    'priceRules.presets.bundlesAria': '{name}: działa też na pakiety',
    'equipmentBundles.classesLabel': 'Klasa składnika',
    'equipmentBundles.anyClass': 'Dowolna klasa',
    'equipmentBundles.classesHint': 'Klasa jest opcjonalna: bez niej zestaw pasuje do każdej klasy tej kategorii.',
    'equipmentBundles.appliesToHint': '„Tylko konkretny sprzęt” działa w panelu i w widgecie, gdy zamówione są konkretne sztuki, „tylko klasy” przy zamówieniu klas w widgecie, a „cała wypożyczalnia” w obu przypadkach, także gdy komplet łączy klasę z konkretną sztuką.',
    'equipmentBundles.dailyPriceOver7': 'Cena od 8. dnia',
    'equipmentBundles.dailyPriceOver7Placeholder': 'jak zwykle',
    'equipmentBundles.dailyPriceOver7Hint': 'Cena za dzień przy wynajmie dłuższym niż 7 dni. Pusta = zwykła cena zestawu.',
    'equipmentBundles.over7Invalid': 'Cena od 8. dnia musi być liczbą nieujemną albo pustym polem.',
    'equipmentBundles.over7Short': 'od 8. dnia: {price} zł/dzień',
    'bundleWarn.title': 'Kiedy ten zestaw nie zadziała',
    'bundleWarn.badgeNever': 'nie działa',
    'bundleWarn.badgePartly': 'nie zawsze działa',
    'bundleWarn.badgeSometimes': 'działa częściowo',
    'bundleWarn.scopeEquipment': 'Konkretny sprzęt',
    'bundleWarn.scopeClasses': 'Klasy w widgecie',
    'bundleWarn.neverShort': '{scope}: przy wynajmie do 7 dni zestaw nigdy nie zadziała. Sztuki kosztują razem {range} za dzień, a zestaw {bundle}.',
    'bundleWarn.neverLong': '{scope}: przy wynajmie dłuższym niż 7 dni zestaw nigdy nie zadziała. Sztuki kosztują wtedy razem {range} za dzień, a zestaw {bundle}. Ustaw niższą cenę od 8. dnia.',
    'bundleWarn.sometimesShort': '{scope}: przy wynajmie do 7 dni zestaw zadziała tylko dla droższych sztuk. Sztuki kosztują razem {range} za dzień, a zestaw {bundle}.',
    'bundleWarn.sometimesLong': '{scope}: przy wynajmie dłuższym niż 7 dni zestaw zadziała tylko dla droższych sztuk. Sztuki kosztują wtedy razem {range} za dzień, a zestaw {bundle}.',
    'bundleWarn.neverBoth': '{scope}: zestaw nigdy nie zadziała. Sztuki kosztują razem {range} za dzień, a przy wynajmie dłuższym niż 7 dni {rangeLong}. Zestaw kosztuje {bundle}.',
    'bundleWarn.sometimesBoth': '{scope}: zestaw zadziała tylko dla droższych sztuk. Sztuki kosztują razem {range} za dzień, a przy wynajmie dłuższym niż 7 dni {rangeLong}. Zestaw kosztuje {bundle}.',
    'bundleWarn.bundleWithOver7': '{price} (od 8. dnia {over7})',
    'bundleWarn.missingEquipment': '{scope}: w magazynie nie ma {items}, więc zestaw nie zadziała dla konkretnego sprzętu.',
    'bundleWarn.missingClasses': '{scope}: {items} nie ma w ofercie rezerwacji według klas, więc zestaw nie zadziała w widgecie.',
    'bundleWarn.footnote': 'Zestaw stosuje się tylko wtedy, gdy wychodzi taniej niż sztuki liczone osobno. Porównanie bez cen dynamicznych.',
    'classRequest.loading': 'Wczytywanie zapytania…',
    'classRequest.loadError': 'Nie udało się wczytać zapytania. Zamknij okno i otwórz je ponownie.',
    'classRequest.title': 'Zapytanie z widgetu',
    'classRequest.stateAwaiting': 'Czeka na potwierdzenie',
    'classRequest.stateConfirmed': 'Potwierdzone',
    'classRequest.stateCancelled': 'Anulowane',
    'classRequest.intro': 'Klient wybrał klasy i podał wymiary. Dobierz sprzęt, a potem potwierdź dostępność: klient dostanie e-mail z linkiem do zapłaty albo danymi do przelewu. Do tego czasu nic nie płaci.',
    'classRequest.introNoPaymentDetails': 'Klient wybrał klasy i podał wymiary. Dobierz sprzęt, a potem potwierdź dostępność. Firma nie ma płatności online ani numeru konta w Danych firmy, więc klient dostanie e-mail z prośbą o kontakt w sprawie płatności. Do tego czasu nic nie płaci.',
    'classRequest.introConfirmed': 'Zapytanie potwierdzone. Sprzęt możesz dobrać albo zmienić do wydania.',
    'classRequest.progress': 'Dobrane: {done} z {total}',
    'classRequest.noAnswers': 'Bez wymiarów',
    'classRequest.otherClass': 'klasa {name}',
    'classRequest.change': 'Zmień',
    'classRequest.pick': 'Dobierz sprzęt',
    'classRequest.target': 'Podpowiedź: {size}',
    'classRequest.pickFor': 'Wybór sprzętu dla pozycji {n}: {name}',
    'classRequest.noCandidates': 'Brak wolnego sprzętu tej kategorii w tym terminie.',
    'classRequest.fitBest': 'pasuje',
    'classRequest.fitNear': 'blisko',
    'classRequest.showAll': 'Pokaż wszystkie ({n})',
    'classRequest.unassign': 'Usuń dobrany sprzęt',
    'classRequest.assignError': 'Nie udało się dobrać sprzętu.',
    'classRequest.confirm': 'Potwierdź i wyślij dane do zapłaty',
    'classRequest.confirmNoPaymentDetails': 'Potwierdź dostępność',
    'classRequest.confirming': 'Potwierdzam…',
    'classRequest.confirmMissingTitle': 'Nie wszystko jest dobrane',
    'classRequest.confirmMissingBody': 'Do dobrania zostało jeszcze {n} szt. Możesz potwierdzić teraz i dobrać sprzęt później, do wydania.',
    'classRequest.confirmAnyway': 'Potwierdź teraz',
    'classRequest.keepAssigning': 'Dobiorę najpierw',
    'classRequest.confirmedOnline': 'Potwierdzone. Klient dostał e-mail z linkiem do zapłaty.',
    'classRequest.confirmedTransfer': 'Potwierdzone. Klient dostał e-mail z danymi do przelewu.',
    'classRequest.confirmedContact': 'Potwierdzone. Klient dostał e-mail z prośbą o kontakt w sprawie płatności.',
    'classRequest.confirmedNoMail': 'Potwierdzone, ale e-mail do klienta nie wyszedł. Zadzwoń do niego i ustal płatność.',
    'classRequest.confirmError': 'Nie udało się potwierdzić zapytania.',
    'classRequest.decline': 'Odrzuć zapytanie',
    'classRequest.declineMessage': 'Wiadomość do klienta (opcjonalnie)',
    'classRequest.declinePlaceholder': 'Np. brak nart w tym rozmiarze, zapraszamy w innym terminie.',
    'classRequest.declineSend': 'Odrzuć i powiadom klienta',
    'classRequest.declining': 'Odrzucam…',
    'classRequest.back': 'Wróć',
    'classRequest.declined': 'Zapytanie odrzucone. Klient dostał e-mail.',
    'classRequest.declinedNoMail': 'Zapytanie odrzucone. E-mail do klienta nie wyszedł, zadzwoń do niego.',
    'classRequest.declineError': 'Nie udało się odrzucić zapytania.',
    'classRequest.tagAwaiting': 'Do potwierdzenia',
    'classRequest.tagToAssign': 'Do dobrania: {n}',
    'classRequest.number': 'nr {n}',
    'notifications.staffCard': 'Powiadomienia dla wypożyczalni',
    'notifications.staffWidgetLabel': 'Mail o nowej rezerwacji z widgetu',
    'notifications.staffWidgetDesc': 'Gdy klient zarezerwuje sprzęt na Twojej stronie, dostaniesz mail z danymi klienta, terminem, sprzętem i linkiem do rezerwacji. Odpowiedź na ten mail trafi do klienta.',
    'notifications.staffEmailLabel': 'Adres powiadomień',
    'notifications.staffEmailPlaceholder': 'np. rezerwacje@twojafirma.pl',
    'notifications.staffEmailHint': 'Puste pole: wyślemy na e-mail z Danych firmy, a gdy go nie ma, do administratorów konta.',
    'equipmentNumber.moveTitle': 'Przenieść numer?',
    'equipmentNumber.moveTitleMany': 'Przenieść numery?',
    'equipmentNumber.moveOne': 'Numer {number} ma nieaktywny sprzęt „{name}”. Po przeniesieniu tamten sprzęt zostanie bez numeru, a numer {number} zapiszemy w jego historii.',
    'equipmentNumber.moveMany': 'Numery {numbers} mają nieaktywne sztuki. Po przeniesieniu tamte sztuki zostaną bez numerów, a stare numery zapiszemy w ich historii.',
    'equipmentNumber.moveConfirm': 'Przenieś numer',
    'equipmentNumber.moveConfirmMany': 'Przenieś numery',
    'equipmentNumber.moveCancel': 'Wpiszę inny numer',
    'equipmentNumber.previous': 'Poprzedni numer: {number} (przeniesiony na inny sprzęt)',
    'companyLookup.button': 'Pobierz dane',
    'companyLookup.buttonTitle': 'Uzupełnij nazwę, REGON i adres z rejestru firm',
    'companyLookup.loading': 'Szukam firmy w rejestrze…',
    'companyLookup.loadingShort': 'Szukam…',
    'companyLookup.foundGus': 'Uzupełniono nazwę, REGON i adres z rejestru REGON (GUS). Sprawdź je przed wystawieniem.',
    'companyLookup.foundVat': 'Uzupełniono nazwę, REGON i adres z wykazu podatników VAT. Sprawdź je przed wystawieniem.',
    'companyLookup.notFound': 'Rejestr nie zna firmy o tym NIP-ie. Wpisz dane ręcznie.',
    'companyLookup.invalidNip': 'Wpisz poprawny NIP (10 cyfr).',
    'companyLookup.tooMany': 'Za dużo zapytań do rejestru. Spróbuj za kilka minut albo wpisz dane ręcznie.',
    'companyLookup.unavailable': 'Rejestr firm nie odpowiada. Wpisz dane ręcznie albo spróbuj za chwilę.',
    'labels.logo.title': 'Logo na etykiecie',
    'labels.logo.loading': 'Wczytywanie logo…',
    'labels.logo.sourceLabel': 'Osobne logo etykiet',
    'labels.logo.sourceCompany': 'Logo z Danych firmy',
    'labels.logo.sourceNone': 'Brak logo: etykiety drukują się bez niego',
    'labels.logo.empty': 'bez logo',
    'labels.logo.previewAlt': 'Logo na etykiecie',
    'labels.logo.upload': 'Wgraj logo etykiet',
    'labels.logo.replace': 'Zmień logo etykiet',
    'labels.logo.saving': 'Zapisywanie…',
    'labels.logo.useCompany': 'Użyj logo z Danych firmy',
    'labels.logo.adminOnly': 'Logo etykiet zmienia administrator.',
    'labels.logo.hint': 'Najlepiej poziome, jednokolorowe, bez tła (PNG lub SVG), do 1 MB.',
    'labels.logo.print': 'Drukuj logo',
    'labels.logo.tooBig': 'Plik jest za duży (maks. 1 MB).',
    'labels.logo.wrongType': 'Wybierz obraz PNG, JPG, WEBP lub SVG.',
    'labels.logo.readError': 'Nie udało się odczytać pliku.',
    'labels.logo.saveError': 'Nie udało się zapisać logo etykiet.',
    'labels.skip': 'Pomiń pierwsze pola arkusza',
    'labels.skipHint': 'Na napoczęty arkusz, z którego odklejono już kilka naklejek.',
    'labels.empty': 'Brak sprzętu do wydruku.',
    'labels.systemCodeNote': '{count} szt. nie ma numeru inwentarzowego ani kodu producenta, więc dostaną kod systemowy (RNT-…), rozpoznawany przez skaner tak samo.',
    'labels.nonAsciiNote': 'Kod kreskowy nie zmieści polskich liter, więc te sztuki dostaną w kodzie kreskowym kod systemowy: {names}',
    'handover.title': 'Wydanie i zwrot sprzętu',
    'handover.tabs.pickup': 'Wydanie',
    'handover.tabs.return': 'Zwrot',
    'handover.cameraTitle.pickup': 'Skanuj wydawany sprzęt',
    'handover.cameraTitle.return': 'Skanuj zwracany sprzęt',
    'handover.progress.pickup': 'Wydano {n} z {total}',
    'handover.progress.return': 'Zwrócono {n} z {total}',
    'handover.scanHint': 'Zeskanuj naklejkę czytnikiem, aparatem albo telefonem. Sztuka zostanie odhaczona i zapisana od razu.',
    'handover.mark.pickup': 'Wydaj',
    'handover.mark.return': 'Przyjmij',
    'handover.undo': 'Cofnij',
    'handover.heldElsewhere': 'Sztuka jest jeszcze u poprzedniego klienta',
    'handover.markAll.pickup': 'Wydaj pozostałe ({n})',
    'handover.markAll.return': 'Przyjmij pozostałe ({n})',
    'handover.allDone.pickup': 'Cały sprzęt wydany.',
    'handover.allDone.return': 'Cały sprzęt zwrócony.',
    'handover.scan.notInReservation': 'Kod {code} nie należy do tej rezerwacji. Sprawdź, czy to właściwa sztuka.',
    'handover.scan.already.pickup': '{name}: już wydane ({time}).',
    'handover.scan.already.return': '{name}: już zwrócone ({time}).',
    'handover.scan.done.pickup': 'Wydano: {name} ({n}/{total})',
    'handover.scan.done.return': 'Zwrócono: {name} ({n}/{total})',
    'handover.saveError': 'Nie udało się zapisać. Spróbuj ponownie.',
    'handover.returnBeforeStart': 'Zwrotu nie da się odnotować przed początkiem rezerwacji. Jeśli klient zrezygnował, anuluj rezerwację.',
    'handover.loadError': 'Nie udało się wczytać stanu wydania i zwrotu.',
    'handover.noItems': 'Rezerwacja nie ma sprzętu.',
    'handover.cancelled': 'Rezerwacja jest anulowana, więc wydanie i zwrot są zablokowane.',
    'handover.notAvailable': 'Wydanie i zwrot są teraz niedostępne.',
    'reservation.scan.pickDatesFirst': 'Najpierw wybierz termin. Skan doda sprzęt wolny w tych dniach.',
    'reservation.scan.added': 'Dodano: {name}',
    'reservation.scan.alreadyAdded': '{name} jest już w rezerwacji.',
    'reservation.scan.unavailable': '{name} jest zajęte w wybranym terminie albo niedostępne.',
    'reservation.scan.unknown': 'Nie znaleziono sprzętu o kodzie {code}.',
    'reservation.offerGone.notFound': 'Oferty, z której uzupełniono formularz, już nie ma: wygasła albo została usunięta. Powiązanie z ofertą zostało usunięte, więc możesz zapisać rezerwację bez niej.',
    'reservation.offerGone.converted': 'Z tej oferty powstała już rezerwacja. Sprawdź kalendarz, zanim dodasz kolejną. Jeśli to ma być osobna rezerwacja, odłącz ofertę i zapisz jeszcze raz.',
    'reservation.offerGone.openCalendar': 'Otwórz kalendarz',
    'reservation.offerGone.unlink': 'Odłącz ofertę',
    'reservation.offerGone.unlinked': 'Oferta odłączona. Zapis utworzy osobną rezerwację, niezwiązaną z ofertą.',
    'reservation.offerPrice': 'Cena i rabat z oferty, do zapłaty {amount}. Zmiana sprzętu albo terminu liczy cenę od nowa.',
    'inventory.scanFound': 'Znaleziono: {name}',
    'inventory.scanNotFound': 'Brak sprzętu o kodzie {code}',
    'addEquipment.scanFilled': 'Wpisano kod: {code}',
    'equipmentDetails.scanHint': 'Kod naklejki możesz zeskanować:',
    'addEquipment.scanHint': 'Możesz zeskanować kod czytnikiem, a wpisze się tutaj. Skanuj, gdy kursor nie stoi w żadnym polu.',
    'addEquipment.scanDone': '✓ Kod wpisany z czytnika.',
    'inventory.filterClearOne': 'Wyczyść filtr: {name}',
    'inventory.clearAll': 'Wyczyść wszystko',
    'inventory.applyFilters': 'Zastosuj filtry',
    'inventory.availability': 'Dostępność',
    'inventory.filters': 'Filtry',
    'inventory.customFields': 'Pola dodatkowe',
    'inventory.resultsCount': 'wyników',
    'inventory.noResults': 'Brak wyników spełniających kryteria filtrowania',
    'inventory.emptyState': 'Brak sprzętu w inwentarzu',
    'inventory.clearFiltersToSeeAll': 'Wyczyść filtry aby zobaczyć wszystko',
    'inventory.deletionScheduled': 'Usuwanie za chwilę...',
    'inventory.tooltip.maintenanceDate': 'Data ostatniego serwisu (format: RRRR-MM-DD)',
    'inventory.tooltip.purchaseDate': 'Data zakupu sprzętu',
    'inventory.tooltip.condition': 'Stan techniczny sprzętu',
    'inventory.tooltip.location': 'Miejsce przechowywania',
    'inventory.tooltip.wearLevel': 'Poziom zużycia sprzętu',
    'inventory.tooltip.compatibility': 'Kompatybilność z innym sprzętem',
    'inventory.status': 'Status',
    'inventory.statusFilter': 'Status',
    'inventory.status.Dostępny': 'Dostępny',
    'inventory.status.Wypożyczony': 'Wypożyczony',
    'inventory.status.W serwisie': 'W serwisie',
    'inventory.status.Nieaktywny': 'Nieaktywny',
    'inventory.rangeFrom': 'Od',
    'inventory.rangeTo': 'Do',
    'inventory.rangeMinPlaceholder': 'min',
    'inventory.rangeMaxPlaceholder': 'maks',
    'inventory.sizePickOne': 'Albo wybierz rozmiar',
    'inventory.availableFrom': 'Dostępny od',
    'inventory.availableTo': 'Dostępny do',
    'inventoryModal.pricePerDay': 'Cena / dzień',
    'inventoryModal.selectedCount': 'Wybrano: {count}',
    'inventoryModal.onlySelected': 'Pokaż tylko wybrane',
    'inventoryModal.confirm': 'Gotowe ({count})',
    'inventoryModal.empty': 'Brak dostępnego sprzętu w wybranym terminie.',
    'inventoryModal.noneSelected': 'Nie wybrano jeszcze żadnego sprzętu.',
    'inventory.currentStatus': 'Aktualny status',
    'inventory.changeStatus': 'Zmiana statusu',
    'inventory.statusWillChange': 'Status zostanie zmieniony',
  
    // Opisy statusów
    'inventory.statusDesc.available': 'Sprzęt gotowy do wypożyczenia',
    'inventory.statusDesc.rented': 'Obecnie w użyciu przez klienta',
    'inventory.statusDesc.service': 'W naprawie lub konserwacji',
    'inventory.statusDesc.inactive': 'Wycofany z obiegu',
    'inventory.deactivate': 'Dezaktywuj',
    'inventory.activate': 'Aktywuj',
    'inventory.confirmDeactivate': 'Czy na pewno chcesz dezaktywować ten sprzęt?',
    'inventory.deactivateWarning': 'Sprzęt nieaktywny nie będzie dostępny do wypożyczenia.',
    'inventory.cannotDeactivateRented': 'Nie można dezaktywować sprzętu, który jest obecnie wypożyczony',
    'inventory.statusChanged': 'Status sprzętu został zmieniony',
    'inventory.statusChangeError': 'Błąd podczas zmiany statusu',
    'inventory.cannotChangeStatus': 'Nie można zmienić statusu',
    'inventory.currentlyRented': 'Sprzęt jest obecnie wypożyczony. Zmiana statusu będzie możliwa dopiero po zwrocie przez klienta.',
    'inventory.hasFutureReservationsBlocked': 'Sprzęt ma zaplanowane przyszłe rezerwacje. Zmiana statusu będzie możliwa po anulowaniu rezerwacji lub ich zakończeniu.',
    'inventory.rentedAndFutureReservations': 'Sprzęt jest obecnie wypożyczony i ma zaplanowane przyszłe rezerwacje. Zmiana statusu będzie możliwa dopiero po zakończeniu wszystkich rezerwacji.',
    'inventory.sortBy': 'Sortuj:',

    // Add User
    'addUser.title': 'Dodaj użytkownika',
    'addUser.firstName': 'Imię',
    'addUser.lastName': 'Nazwisko',
    'addUser.email': 'Email',
    'addUser.phone': 'Telefon',
    'addUser.login': 'Login',
    'addUser.password': 'Hasło',
    'addUser.admin': 'Admin',
    'addUser.addUser': 'Dodaj użytkownika',
    'addUser.addError': 'Błąd podczas dodawania użytkownika.',
    'addUser.userCreated': 'Użytkownik został dodany.',
    'addUser.fillRequired': 'Wypełnij wszystkie wymagane pola',
    'addUser.passwordMismatch': 'Hasła nie są identyczne',
    'addUser.passwordTooShort': 'Hasło musi mieć co najmniej 6 znaków',
    'addUser.success': 'Użytkownik został utworzony pomyślnie',
    'addUser.error': 'Błąd podczas tworzenia użytkownika',
    'addUser.backToList': 'Wróć do listy użytkowników',
    'addUser.firstNamePlaceholder': 'Imię',
    'addUser.lastNamePlaceholder': 'Nazwisko',
    'addUser.emailPlaceholder': 'adres@email.com',
    'addUser.phonePlaceholder': '+48 123 456 789',
    'addUser.passwordPlaceholder': '••••••••',
    'addUser.confirmPasswordPlaceholder': '••••••••',
    'addUser.adminInfo': 'Nadaj uprawnienia administratora',
    'addUser.invalidPhone': 'Nieprawidłowy numer telefonu - podaj 9 cyfr (np. 501234567) lub usuń prefiks +48/spacje.',
    'security.passwordMinStrength': 'Hasło musi być przynajmniej: {strength}',
    'security.policy.minLength': 'Min. {min} znaków',
    'security.policy.upperCase': 'Wielka litera',
    'security.policy.lowerCase': 'Mała litera',
    'security.policy.digit': 'Cyfra',
    'security.policy.minStrength': 'Siła hasła: przynajmniej "{strength}"',
    'security.twoFA.title': 'Weryfikacja dwuetapowa (2FA)',
    'security.twoFA.active': 'Aktywna',
    'security.twoFA.enabledOn': 'Włączona: {date}',
    'security.twoFA.backupCodesRemaining': 'Pozostałe kody zapasowe: {count} / 10',
    'security.twoFA.lowCodesWarning': '(Mało kodów - rozważ wyłączenie i ponowne włączenie 2FA, aby wygenerować nowe)',
    'security.twoFA.confirmDisableIntro': 'Aby wyłączyć 2FA, potwierdź tożsamość kodem TOTP lub kodem zapasowym:',
    'security.twoFA.codePlaceholder': 'Kod TOTP (6 cyfr) lub kod zapasowy (XXXX-XXXX)',
    'security.twoFA.disabling': 'Wyłączanie...',
    'security.twoFA.confirmDisable': 'Potwierdź wyłączenie',
    'security.twoFA.intro': 'Weryfikacja dwuetapowa dodaje dodatkową warstwę ochrony do Twojego konta. Po włączeniu, przy każdym logowaniu będziesz proszony o podanie 6-cyfrowego kodu z aplikacji uwierzytelniającej.',
    'passwordStrength.0': 'Bardzo słabe',
    'passwordStrength.1': 'Słabe',
    'passwordStrength.2': 'Średnie',
    'passwordStrength.3': 'Dobre',
    'passwordStrength.4': 'Silne',

    'yourData.firstNamePlaceholder': 'Imię',
    'yourData.loginAgain': 'Zaloguj się ponownie.',
    'yourData.fileTooLarge': 'Plik jest za duży (maks. 1 MB).',
    'yourData.lastNamePlaceholder': 'Nazwisko',
    'yourData.emailPlaceholder': 'adres@email.com',
    'yourData.phonePlaceholder': '+48 123 456 789',
    'yourData.firstName': 'Imię',
    'yourData.lastName': 'Nazwisko',
    'yourData.email': 'Adres email',
    'yourData.phone': 'Telefon',
    'yourData.success': 'Dane zostały zaktualizowane',
    'yourData.error': 'Błąd podczas aktualizacji danych',
    'yourData.invalidPhone': 'Nieprawidłowy numer telefonu - podaj 9 cyfr (np. 501234567) lub usuń prefiks +48/spacje.',
    'yourData.change': 'Zmień dane',
    'yourData.loading': 'Ładowanie danych...',
    'yourData.noUser': 'Brak zalogowanego użytkownika.',
    'yourData.loadError': 'Nie udało się załadować danych użytkownika.',
    'yourData.saving': 'Zapisywanie zmian...',
    'yourData.backToProfile': 'Wróć do profilu',
    'yourData.title': 'Twoje dane',
    'yourData.noPhoto': 'Brak zdjęcia',
    'yourData.choose': 'Wybierz',
    'yourData.saved': 'Zapisano zmiany',
    'yourData.fillRequired': 'Uzupełnij wymagane pola',
    'yourData.remove': 'Usuń zdjęcie',
    'yourData.saveError': 'Numer telefonu nie może zawierać więcej niż 9 znaków.',


    // Users
    'users.noPermissions': 'Brak uprawnień',
    'users.adminOnly': 'Ta sekcja jest dostępna tylko dla administratorów.',
    'users.title': 'Zarządzanie użytkownikami',
    'users.addUser': 'Dodaj użytkownika',
    'users.firstName': 'Imię',
    'users.lastName': 'Nazwisko',
    'users.email': 'Email',
    'users.admin': 'Admin',
    'users.actions': 'Akcje',
    'users.undoDelete': 'Cofnij usunięcie',
    'users.delete': 'Usuń',
    'users.noUsers': 'Brak użytkowników.',
    'users.revokeSessions': 'Wyloguj ze wszystkich urządzeń',
    'users.revokeSelfHint': 'Własne urządzenia wylogujesz w Bezpieczeństwie konta',
    'users.revokeConfirm': 'Ten pracownik zostanie wylogowany na wszystkich urządzeniach i będzie musiał zalogować się ponownie.',
    'users.revokeAction': 'Wyloguj',
    'users.revokeDone': 'Wylogowano urządzenia: {count}.',
    'users.revokeFailed': 'Nie udało się wylogować pracownika. Spróbuj ponownie.',
    'users.user': 'Pracownik',
    'users.saving': 'Zapisywanie…',
    'users.saveError': 'Błąd podczas zapisu użytkowników.',
    'users.changesSaved': 'Zmiany zapisane.',
    'users.confirmPassword': 'Potwierdź hasłem',
    'users.enterAdminPassword': 'Wprowadź hasło administratora, aby potwierdzić zmiany.',
    'users.password': 'Hasło',
    'users.confirmAndSave': 'Potwierdź i zapisz',
    'users.confirmDelete': 'Czy na pewno chcesz usunąć tego użytkownika?',
    'users.deleteError': 'Błąd podczas usuwania użytkownika',
    'users.deleteModalTitle': 'Potwierdź usunięcie użytkownika',
    'users.passwordConfirmLabel': 'Hasło administratora (potwierdzenie)',
    'users.passwordPlaceholder': 'Wpisz hasło',
    'users.enterPasswordError': 'Wpisz hasło, aby potwierdzić operację.',
    'users.wrongPasswordError': 'Nieprawidłowe hasło.',
    'users.cannotDeleteSelfError': 'Nie możesz usunąć samego siebie.',
    'users.lastAdminError': 'Nie można usunąć użytkownika - to ostatni administrator w systemie.',
    'users.serverError': 'Błąd serwera ({status})',
    'userDetails.adminModalTitle': 'Potwierdź zmianę uprawnień',
    'users.noFirstName': 'Brak imienia',
    'users.noLastName': 'Brak nazwiska',
    'users.noEmail': 'Brak emaila',
    'users.loadError': 'Błąd podczas ładowania użytkowników',
    'users.invalidPhone': 'Numer telefonu nie może zawierać więcej niż 9 znaków.',


    // Generate Offer
    'generateOffer.title': 'Oferty',
    'generateOffer.subtitle': 'Przegląd i zarządzanie ofertami',
    'generateOffer.clientData': 'Dane Klienta',
    'generateOffer.searchClient': 'Wyszukaj klienta w bazie',
    'generateOffer.searchPlaceholder': 'Wpisz imię, nazwisko lub e-mail...',
    'generateOffer.search': 'Szukaj',
    'generateOffer.firstName': 'Imię',
    'generateOffer.lastName': 'Nazwisko',
    'generateOffer.email': 'E-mail',
    'generateOffer.rentalPeriod': 'Termin Wynajmu',
    'generateOffer.startDateTime': 'Data i godzina rozpoczęcia',
    'generateOffer.endDateTime': 'Data i godzina zakończenia',
    'generateOffer.daysCount': 'Liczba dni',
    'generateOffer.equipment': 'Sprzęt do Wynajmu',
    'generateOffer.addEquipment': 'Dodaj sprzęt do oferty',
    'generateOffer.selectEquipment': 'Wybierz sprzęt',
    'generateOffer.category': 'Kategoria',
    'generateOffer.brand': 'Marka',
    'generateOffer.inventoryNumber': 'Nr inwentarzowy',
    'generateOffer.size': 'Rozmiar',
    'generateOffer.pricePerDay': 'Cena/dzień',
    'generateOffer.total': 'Razem',
    'generateOffer.remove': 'Usuń',
    'generateOffer.discount': 'Rabat',
    'generateOffer.percent': 'Procent (%)',
    'generateOffer.amount': 'Kwota (zł)',
    'generateOffer.subtotal': 'Wartość brutto:',
    'generateOffer.discountAmount': 'Rabat:',
    'generateOffer.totalPrice': 'Całkowita wartość oferty:',
    'generateOffer.clearForm': 'Wyczyść formularz',
    'generateOffer.generate': 'Generuj ofertę',
    'generateOffer.save': 'Zapisz ofertę',
    'generateOffer.done': 'Gotowe',
    'generateOffer.confirmSendTitle': 'Potwierdź wysyłkę oferty',
    'generateOffer.confirmSendMessage': 'Czy na pewno chcesz wysłać ofertę emailem na adres:',
    'generateOffer.confirmSend': 'Tak, wyślij ofertę',
    'generateOffer.cancelSend': 'Anuluj',
    'generateOffer.selectDatesFirst': 'Najpierw wybierz termin wynajmu',
    'generateOffer.fillClientData': 'Uzupełnij dane klienta (imię, nazwisko, e-mail)',
    'generateOffer.addEquipmentFirst': 'Dodaj przynajmniej jedną pozycję sprzętu',
    'generateOffer.quotePending': 'Trwa przeliczanie ceny według cennika. Spróbuj za chwilę.',
    'reservation.quotePending': 'Trwa przeliczanie ceny według cennika. Zapisz za chwilę.',
    'generateOffer.history.issued': 'Wystawiona {issued}',
    'generateOffer.history.issuedValidUntil': 'Wystawiona {issued}, ważna do {validUntil}',
    'generateOffer.history.expired': 'Oferta straciła ważność {validUntil}. „Generuj ofertę” pobierze kopię z pierwotną datą i terminem ważności, a „Wyślij mailem” wystawi ją ponownie z dzisiejszą datą.',
    'generateOffer.history.inBundle': 'w zestawie',
    'generateOffer.history.changedAfterSend': 'Oferta zmieniona po wysyłce: klient ma wersję wystawioną {issued}. „Generuj ofertę” pobierze zmienioną ofertę z dzisiejszą datą i ważnością liczoną od dziś, a „Wyślij mailem” wyśle ją klientowi.',
    'generateOffer.history.ratePerDay': '{amount} zł/dzień',
    'generateOffer.errorFetchingClients': 'Nie udało się pobrać klientów z bazy danych',
    'generateOffer.errorFetchingEquipment': 'Nie udało się pobrać dostępnego sprzętu',
    'generateOffer.noEquipmentAvailable': 'Brak dostępnego sprzętu w wybranym terminie',
    'generateOffer.offerGenerated': 'Oferta została wygenerowana i pobrana!',
    'generateOffer.errorGenerating': 'Nie udało się wygenerować oferty',
    'generateOffer.enterSearchQuery': 'Wprowadź fragment imienia, nazwiska lub e-maila',
    'generateOffer.days': 'dni',
    'generateOffer.day': 'dzień',

    // Reservation
    'reservation.title': 'Dodaj rezerwację',
    'reservation.basicData': 'Dane podstawowe',
    'reservation.firstname': 'Imię',
    'reservation.lastname': 'Nazwisko',
    'reservation.contact': 'Kontakt',
    'reservation.contactHint': 'Wystarczy jeden kontakt: e-mail albo telefon.',
    'reservation.contactRequired': 'Podaj e-mail albo telefon klienta.',
    'reservation.email': 'Email',
    'reservation.address': 'Adres',
    'reservation.idNumber': 'Numer dowodu osobistego',
    'reservation.phone': 'Telefon',
    'reservation.discount': 'Rabat',
    'reservation.discountAmount': 'Wysokość rabatu',
    'amountField.currency': 'zł',
    'amountField.unitGroup': 'Jednostka rabatu',
    'amountField.discountPlaceholderPercent': 'Rabat w %',
    'amountField.discountPlaceholderPln': 'Rabat w zł',
    'amountField.advancePlaceholder': 'np. 150,50',
    'amountField.afterDiscount': 'Po rabacie: {amount}',
    'amountField.error.invalid': 'Wpisz kwotę, np. 150,50',
    'amountField.error.percentOver': 'Maksymalnie 100%',
    'amountField.error.amountOver': 'Maksymalnie {max}',
    'amountField.error.checkAmounts': 'Sprawdź kwoty rabatu i zaliczki.',
    'reservation.term': 'Termin',
    'reservation.range': 'Zakres dat', // DODANE
    'reservation.from': 'Od',
    'reservation.to': 'Do',
    'reservation.addressEdit': 'Edytuj adres',
    'reservation.paymentMethod': 'Sposób płatności',
    'reservation.chooseEquipment': 'Wybierz sprzęt',
    'reservation.selectedEquipment': 'Wybrany sprzęt',
    'reservation.noEquipment': 'Nie wybrano sprzętu.',
    'reservation.notes': 'Notatki/wymagania specjalne',
    'reservation.summary': 'Podsumowanie',
    'reservation.days': 'Ilość dni',
    'reservation.equipmentPrice': 'Cena sprzętu',
    'priceBreakdown.perDayAveraged': 'śr.',
    'priceBreakdown.perDay': '{amount}/dzień',
    'priceBreakdown.ruleLabel': 'Cennik: {rule}',
    'priceBreakdown.bundleName': '{name} - {price}/dzień (cena zestawu)',
    'priceBreakdown.bundleNameAverage': '{name} - śr. {price}/dzień (cena zestawu)',
    'priceBreakdown.recalculating': 'przeliczanie…',
    'priceBreakdown.baseSum': 'w tym: suma bazowa',
    'priceBreakdown.ruleAdjustment': 'korekta cennika',
    'priceBreakdown.bundleSaving': 'oszczędność zestawu',
    'reservation.advance': 'Zaliczka',
    'reservation.advancePaid': '(opłacona)',
    'reservation.advanceUnpaid': '(nieopłacona)',
    'reservation.remainingToPay': 'Pozostało do zapłaty',
    'reservation.clearOverride': 'Wyczyść nadpisanie',
    'reservation.bail': 'Kaucja',
    'ksefSettings.title': 'KSeF: e-Faktury',
    'ksefSettings.subtitle': 'Wysyłka faktur ustrukturyzowanych do Krajowego Systemu e-Faktur (faktury VAT i korekty dla firm).',
    'ksefSettings.loading': 'Wczytywanie…',
    'ksefSettings.loadError': 'Nie udało się wczytać ustawień KSeF.',
    'ksefSettings.configCardTitle': 'Konfiguracja KSeF',
    'ksefSettings.authIntro': 'Z KSeF łączymy się tokenem albo certyfikatem KSeF. Obie metody działają tak samo: token to jeden ciąg znaków do wklejenia, a certyfikat to dwa pliki i hasło, odnawiane co 2 lata.',
    'ksefSettings.step1': 'Zaloguj się do Aplikacji Podatnika KSeF (podatki.gov.pl) na NIP firmy.',
    'ksefSettings.step2': 'Wygeneruj token z uprawnieniem do wystawiania faktur albo wystąp o certyfikat KSeF o przeznaczeniu „Uwierzytelnienie w systemie KSeF” (instrukcja niżej).',
    'ksefSettings.step3': 'Wklej token albo wybierz pliki certyfikatu i klucza, zapisz i sprawdź połączenie. Zacznij od środowiska testowego.',
    'ksefSettings.tokenFutureHint': 'Ministerstwo Finansów zapowiedziało, że tokeny KSeF będą działać także po 2026 roku, więc działający token nie wymaga zmian. Gdyby to się zmieniło, uprzedzimy tutaj.',
    'ksefSettings.tokenSunsetHint': 'Tokeny KSeF działają do {date}. Przed tym dniem przełącz metodę na „Certyfikat KSeF” (instrukcja niżej).',
    'ksefSettings.tokenSunsetPassed': 'Tokeny KSeF przestały działać {date}. Przełącz metodę na „Certyfikat KSeF” (instrukcja niżej).',
    'ksefSettings.certGuideTitle': 'Jak zdobyć certyfikat KSeF',
    'ksefSettings.certGuideIntro': 'Certyfikat KSeF wydaje bezpłatnie Ministerstwo Finansów w Aplikacji Podatnika KSeF. Zajmuje to około 15 minut, najwygodniej na komputerze.',
    'ksefSettings.certGuidePrepTitle': 'Co przygotować',
    'ksefSettings.certGuidePrep1': 'NIP firmy.',
    'ksefSettings.certGuidePrep2': 'Sposób logowania do KSeF: przy jednoosobowej działalności Profil Zaufany, mObywatel albo podpis kwalifikowany; w spółce osoba, która ma w KSeF uprawnienie do wystawiania faktur dla NIP spółki, albo kwalifikowana pieczęć spółki.',
    'ksefSettings.certGuidePrep3': 'Bezpieczne miejsce na hasło, na przykład menedżer haseł.',
    'ksefSettings.certGuideStepsTitle': 'Krok po kroku',
    'ksefSettings.certGuideStep1': 'Wejdź na ap.ksef.mf.gov.pl (Aplikacja Podatnika KSeF), zaloguj się i wskaż NIP swojej firmy.',
    'ksefSettings.certGuideStep2': 'Otwórz zakładkę „Certyfikaty” i wybierz „Wnioskuj o certyfikat”.',
    'ksefSettings.certGuideStep3': 'Wpisz nazwę certyfikatu, na przykład „theRENT”, najlepiej bez polskich liter.',
    'ksefSettings.certGuideStep4': 'Ustaw hasło do klucza: od 15 do 32 znaków, z wielką i małą literą (bez polskich liter), cyfrą i znakiem specjalnym. Zapisz je od razu, bo tego hasła nie da się odzyskać ani zmienić.',
    'ksefSettings.certGuideStep5': 'Kliknij „Generuj”. Przeglądarka zapisze plik z końcówką .key, czyli klucz prywatny. Nie wysyłaj go nikomu mailem.',
    'ksefSettings.certGuideStep6': 'Jako przeznaczenie wybierz „Uwierzytelnienie w systemie KSeF”. Nie wybieraj „Podpis linku weryfikacyjnego wystawcy”: to certyfikat do trybu offline, który do połączenia się nie nadaje.',
    'ksefSettings.certGuideStep7': 'Jako początek ważności zostaw dzisiejszą datę, wyślij wniosek i odświeżaj listę, aż certyfikat będzie aktywny. Certyfikat ważny od późniejszego dnia wgrasz tutaj dopiero w tym dniu.',
    'ksefSettings.certGuideStep8': 'Zaznacz nowy certyfikat i pobierz go w formacie PEM. Zapisze się plik z końcówką .crt.',
    'ksefSettings.certGuideStep9': 'Tutaj wybierz metodę „Certyfikat KSeF” i środowisko produkcyjne (certyfikat z ap.ksef.mf.gov.pl), wskaż plik .crt i plik .key, wpisz hasło, zapisz i kliknij „Sprawdź połączenie z KSeF”.',
    'ksefSettings.certGuideNotesTitle': 'Dobrze wiedzieć',
    'ksefSettings.certGuideNote1': 'Hasła nie zapisujemy. Klucz przechowujemy zaszyfrowany i nigdy go nie pokazujemy.',
    'ksefSettings.certGuideNote2': 'Certyfikat jest ważny najwyżej 2 lata. O nowy możesz wystąpić miesiąc przed końcem ważności starego; datę końca widać wyżej, przy zapisanym certyfikacie.',
    'ksefSettings.certGuideNote3': 'Faktury wysłane przez the.rENT będą w KSeF widoczne jako wysłane w imieniu firmy przez osobę, na którą wydano certyfikat.',
    'ksefSettings.certGuideNote4': 'Jeśli korzystasz też z programu księgowego, wygeneruj dla the.rENT osobny certyfikat. W razie problemu unieważnisz jeden, a drugi będzie działał dalej.',
    'ksefSettings.certGuideNote5': 'Zgubiony plik .key albo hasło: unieważnij certyfikat w Aplikacji Podatnika (zakładka „Certyfikaty”) i wygeneruj nowy.',
    'ksefSettings.certGuideMfLink': 'Strona Ministerstwa Finansów o certyfikatach KSeF',
    'ksefSettings.certSavedWithDate': 'Certyfikat zapisany (zaszyfrowany), ważny do {date}',
    'ksefSettings.certSaved': 'Certyfikat zapisany (zaszyfrowany)',
    'ksefSettings.noCert': 'Brak certyfikatu',
    'ksefSettings.tokenSaved': 'Token zapisany (zaszyfrowany)',
    'ksefSettings.noToken': 'Brak tokenu',
    'ksefSettings.sendingEnabled': 'Wysyłka włączona',
    'ksefSettings.sendingDisabled': 'Wysyłka wyłączona',
    'ksefSettings.certSubjectLabel': 'Podmiot certyfikatu: {subject}',
    'ksefSettings.environment': 'Środowisko',
    'ksefSettings.envTest': 'Testowe (TE), faktury bez skutków prawnych',
    'ksefSettings.envDemo': 'Przedprodukcyjne (demo)',
    'ksefSettings.envProd': 'Produkcyjne, faktury realne w obrocie prawnym',
    'ksefSettings.authMethod': 'Metoda uwierzytelniania',
    'ksefSettings.authMethodToken': 'Token KSeF',
    'ksefSettings.authMethodCert': 'Certyfikat KSeF',
    'ksefSettings.tokenLabel': 'Token KSeF',
    'ksefSettings.tokenPlaceholderSaved': '•••••••• (zostaw puste, aby nie zmieniać)',
    'ksefSettings.tokenPlaceholderEmpty': 'Wklej token z Aplikacji Podatnika',
    'ksefSettings.certPemLabel': 'Certyfikat KSeF (PEM)',
    'ksefSettings.certKeyLabel': 'Klucz prywatny certyfikatu (PEM)',
    'ksefSettings.pemPlaceholderSaved': 'Zapisany, zostaw puste, aby nie zmieniać',
    'ksefSettings.certFileLabel': 'Plik certyfikatu (.crt albo .cer)',
    'ksefSettings.keyFileLabel': 'Plik klucza prywatnego (.key)',
    'ksefSettings.keyPasswordLabel': 'Hasło do klucza prywatnego',
    'ksefSettings.keyPasswordHint': 'Hasło ustawione przy generowaniu certyfikatu w Aplikacji Podatnika KSeF. Służy tylko do odczytania klucza przy zapisie: hasła nie zapisujemy, a klucz przechowujemy zaszyfrowany.',
    'ksefSettings.fileChosen': 'Wybrano: {name}',
    'ksefSettings.fileSavedHint': 'Zapisany. Wybierz plik tylko wtedy, gdy chcesz go zmienić.',
    'ksefSettings.fileReadError': 'Nie udało się odczytać pliku {name}.',
    'ksefSettings.fileTooLarge': 'Plik {name} jest za duży jak na certyfikat albo klucz. Sprawdź, czy to właściwy plik.',
    'ksefSettings.pasteToggle': 'Wklej ręcznie jako tekst (PEM)',
    'ksefSettings.testConnection': 'Sprawdź połączenie z KSeF',
    'ksefSettings.testing': 'Sprawdzanie…',
    'ksefSettings.testHint': 'Sprawdza zapisane ustawienia: łączy się z KSeF w imieniu NIP firmy z Danych firmy, bez wysyłania faktury.',
    'ksefSettings.testOk': 'Połączenie działa. KSeF przyjął {method} w środowisku {env}.',
    'ksefSettings.testMethodToken': 'token',
    'ksefSettings.testMethodCert': 'certyfikat',
    'ksefSettings.envTestShort': 'testowym',
    'ksefSettings.envDemoShort': 'przedprodukcyjnym',
    'ksefSettings.envProdShort': 'produkcyjnym',
    'ksefSettings.testError': 'Nie udało się sprawdzić połączenia z KSeF.',
    'ksefSettings.enableSending': 'Włącz wysyłkę do KSeF',
    'ksefSettings.autoSendLabel': 'Wysyłaj automatycznie po wystawieniu faktury VAT/korekty',
    'ksefSettings.autoSendHint': 'Automatyczna wysyłka jest opcjonalna (opt-in) i działa w tle. Awaria KSeF nigdy nie blokuje wystawienia faktury, tylko zostawia ją do ręcznej wysyłki „Wyślij do KSeF”.',
    'ksefSettings.saveSettings': 'Zapisz ustawienia',
    'ksefSettings.saving': 'Zapisywanie…',
    'ksefSettings.saveError': 'Błąd zapisu',
    'ksefSettings.saved': 'Ustawienia KSeF zapisane.',
    'ksefSettings.howItWorksTitle': 'Jak działa wysyłka?',
    'ksefSettings.howItWorksBody': 'Na liście faktur, przy fakturach VAT i korektach, pojawia się przycisk „Wyślij do KSeF”. Po przyjęciu faktura dostaje numer KSeF i wchodzi do obrotu prawnego. Proformy i paragony nie podlegają wysyłce. Środowisko testowe pozwala bezpiecznie sprawdzić cały proces, zanim włączymy produkcję.',
    'paymentThankYou.backToShop': 'Wróć na stronę wypożyczalni',
    'paymentThankYou.cancelledTitle': 'Płatność przerwana',
    'paymentThankYou.cancelledDesc': 'Nic się nie stało. Możesz wrócić do maila i spróbować ponownie.',
    'paymentThankYou.depositAlreadyTitle': 'Kaucja jest już zablokowana',
    'paymentThankYou.depositTitle': 'Kaucja zablokowana',
    'paymentThankYou.depositDesc1': 'Środki nie zostały pobrane. To blokada na karcie, która zostanie zwolniona po zwrocie sprzętu w nienaruszonym stanie.',
    'paymentThankYou.contactHint': 'W razie pytań odpowiedz na otrzymanego maila.',
    'paymentThankYou.alreadyPaidTitle': 'Płatność była już zarejestrowana',
    'paymentThankYou.thankYouTitle': 'Dziękujemy za wpłatę!',
    'paymentThankYou.alreadyPaidDesc': 'Ta rezerwacja ma już zarejestrowaną płatność.',
    'paymentThankYou.paidDesc': 'Twoja płatność została przyjęta. Potwierdzenie wyślemy na Twój adres e-mail.',
    'paymentThankYou.shopSeesPayment': 'Wypożyczalnia widzi Twoją wpłatę. W razie pytań odpowiedz na otrzymanego maila.',
    'paymentReturn.title': 'Płatność',
    'paymentReturn.subtitle': 'Status płatności online.',
    'paymentReturn.status.pending.title': 'Sprawdzamy płatność…',
    'paymentReturn.status.pending.desc': 'Potwierdzenie płatności może chwilę potrwać.',
    'paymentReturn.status.paid.title': 'Zapłacono ✓',
    'paymentReturn.status.paid.desc': 'Płatność została zaksięgowana.',
    'paymentReturn.status.paid.descAdvance': 'Zaliczka została zaksięgowana.',
    'paymentReturn.status.failed.title': 'Płatność nieudana',
    'paymentReturn.status.failed.desc': 'Nie udało się potwierdzić płatności. Spróbuj ponownie.',
    'paymentReturn.status.cancelled.title': 'Płatność anulowana',
    'paymentReturn.status.cancelled.desc': 'Płatność została przerwana.',
    'paymentReturn.status.unknown.title': 'Brak informacji o płatności',
    'paymentReturn.status.unknown.desc': 'Nie znaleziono tej płatności.',
    'paymentReturn.stuckDesc': 'Płatność jeszcze niepotwierdzona. Potwierdzenie może chwilę potrwać, sprawdź ponownie za moment.',
    'paymentReturn.retry': 'Sprawdź ponownie',
    'paymentReturn.backToCalendar': 'Wróć do kalendarza',
    'reservation.perDay': 'dzień',
    'reservation.discountLabel': 'Rabat',
    'reservation.toPay': 'Do zapłaty',

    // PaymentSettings
    'paymentSettings.title': 'Płatności online',
    'paymentSettings.subtitle': 'Przyjmuj płatności BLIK-iem i kartą. Pieniądze klientów trafiają prosto na Twoje konto (Stripe).',
    'paymentSettings.cardTitle': 'Konto płatności (Stripe)',
    'paymentSettings.loading': 'Wczytywanie…',
    'paymentSettings.loadError': 'Nie udało się wczytać ustawień płatności.',
    'paymentSettings.returnedFromStripe': 'Wróciłeś ze Stripe. Aktualny status konta widzisz poniżej.',
    'paymentSettings.serverMissingTitle': 'Płatności online nie są jeszcze włączone na serwerze',
    'paymentSettings.serverMissingBody': 'Ta instalacja the.rENT nie ma skonfigurowanego klucza Stripe, więc nie można podłączyć konta ani przyjmować płatności online. Administrator serwera musi ustawić zmienną {envVar} (klucz test-mode {testKey} na dev, klucz live na produkcji) i zrestartować backend. Do tego czasu przyjmuj zaliczki gotówką lub przelewem - dane do przelewu wysyłają się w potwierdzeniu rezerwacji.',
    'paymentSettings.onboardIntro': 'Podłączenie zajmuje kilka minut i odbywa się na bezpiecznej stronie Stripe:',
    'paymentSettings.step1': 'Kliknij „Połącz ze Stripe”.',
    'paymentSettings.step2': 'Podaj dane firmy i numer konta bankowego (na nie trafiają wypłaty).',
    'paymentSettings.step3': 'Wrócisz tu automatycznie. Gdy status zmieni się na „Aktywne”, możesz przyjmować płatności.',
    'paymentSettings.connectButton': 'Połącz ze Stripe',
    'paymentSettings.redirecting': 'Przekierowanie…',
    'paymentSettings.statusIncomplete': 'Konfiguracja niedokończona',
    'paymentSettings.statusUnknown': 'Nie udało się sprawdzić statusu konta',
    'paymentSettings.statusUnknownHint': 'Nie udało się teraz połączyć ze Stripe, więc nie wiemy, czy konto przyjmuje płatności. To nie musi znaczyć, że konfiguracja jest niedokończona. Odśwież status za chwilę.',
    'paymentSettings.statusStaleHint': 'Nie udało się teraz połączyć ze Stripe. Pokazujemy ostatni znany stan konta.',
    'paymentSettings.statusPaused': 'Wstrzymane: płatności online nie są przyjmowane',
    'paymentSettings.statusActive': 'Aktywne: możesz przyjmować płatności',
    'paymentSettings.needsMoreDataHint': 'Stripe potrzebuje jeszcze danych Twojej firmy (lub trwa ich weryfikacja). Dokończ konfigurację, a status zmieni się na „Aktywne”.',
    'paymentSettings.finishSetup': 'Dokończ konfigurację w Stripe',
    'paymentSettings.refreshStatus': 'Odśwież status',
    'paymentSettings.activeHint': 'Konto jest aktywne: linki do zapłaty, płatność kartą przy ladzie i zaliczki w widgecie trafiają na Twoje konto Stripe. Wypłaty i historię transakcji znajdziesz w panelu Stripe.',
    'paymentSettings.pausedHint': 'Płatności online są wstrzymane. Nowe płatności online (linki, widget, nowe blokady kaucji) są zablokowane, ale zwroty, ściąganie/zwalnianie już zablokowanych kaucji i płatności gotówką/przelewem działają normalnie. Wznów poniżej, gdy chcesz znów przyjmować płatności online.',
    'paymentSettings.advanceSectionTitle': 'Zaliczka w widgecie',
    'paymentSettings.advanceSectionHint': 'Jaki procent kwoty rezerwacji klient płaci online przy rezerwacji przez widget. 100 oznacza całość.',
    'paymentSettings.save': 'Zapisz',
    'paymentSettings.saving': 'Zapisywanie…',
    'paymentSettings.advanceSaved': 'Zapisano: przy rezerwacji w widgecie klient zapłaci online {percent}% kwoty.',
    'paymentSettings.saveError': 'Błąd zapisu',
    'paymentSettings.autoCancelSectionTitle': 'Auto-anulowanie nieopłaconych rezerwacji',
    'paymentSettings.autoCancelHint': 'Rezerwacja z widgetu bez wpłaty zostanie automatycznie anulowana po tylu godzinach (klient dostaje wcześniej przypomnienie mailowe z linkiem do zapłaty). Puste pole wyłącza funkcję. Sugerowane: 24.',
    'paymentSettings.hoursUnit': 'godz.',
    'paymentSettings.autoCancelDisabled': 'Auto-anulowanie wyłączone.',
    'paymentSettings.autoCancelSaved': 'Nieopłacone rezerwacje z widgetu będą anulowane po {hours} godz.',
    'paymentSettings.pauseSectionTitle': 'Wstrzymanie płatności online',
    'paymentSettings.pausedNowHint': 'Płatności online są teraz wstrzymane. Konto Stripe pozostaje podłączone, więc wznowienie wraca na to samo konto. Zwroty, rozliczanie już zablokowanych kaucji i płatności offline działają dalej; wstrzymane są tylko nowe płatności online.',
    'paymentSettings.pauseAvailableHint': 'Tymczasowo wyłącz przyjmowanie NOWYCH płatności online (w tym nowych blokad kaucji), zachowując podłączone konto Stripe. W odróżnieniu od odłączenia, wznowienie wraca na to samo konto. Zwroty, rozliczanie już zablokowanych kaucji i płatności offline działają dalej.',
    'paymentSettings.resumeOnline': 'Wznów płatności online',
    'paymentSettings.pauseOnline': 'Wstrzymaj płatności online',
    'paymentSettings.processing': 'Przetwarzanie…',
    'paymentSettings.pauseConfirmTitle': 'Wstrzymać płatności online?',
    'paymentSettings.pauseConfirmMessage': 'Klienci nie będą mogli płacić linkami ani w widgecie, dopóki nie wznowisz. Konto Stripe zostaje podłączone (w odróżnieniu od odłączenia). Wstrzymane są tylko NOWE płatności online, w tym nowe blokady kaucji. Zwroty, ściąganie i zwalnianie już zablokowanych kaucji oraz płatności gotówką i przelewem działają dalej.',
    'paymentSettings.pauseFailed': 'Nie udało się zmienić stanu płatności online',
    'paymentSettings.pausedSuccess': 'Płatności online wstrzymane.',
    'paymentSettings.resumedSuccess': 'Płatności online wznowione.',
    'paymentSettings.disconnectSectionTitle': 'Odłączenie płatności',
    'paymentSettings.disconnectHint': 'Wyłącza przyjmowanie płatności online w the.rENT. Konto Stripe wypożyczalni i zebrane środki pozostają nietknięte, a płatności możesz podłączyć ponownie w każdej chwili.',
    'paymentSettings.disconnectButton': 'Odłącz konto Stripe',
    'paymentSettings.disconnectConfirmTitle': 'Odłączyć płatności online?',
    'paymentSettings.disconnectConfirmMessage': 'Przyciski i linki do zapłaty przestaną działać, dopóki nie połączysz konta ponownie. Twoje konto Stripe i zebrane środki pozostają nietknięte.',
    'paymentSettings.disconnectFailed': 'Nie udało się odłączyć Stripe',
    'paymentSettings.disconnectedSuccess': 'Płatności online zostały odłączone.',
    'paymentSettings.onboardFailed': 'Nie udało się rozpocząć podłączania Stripe',
    'paymentSettings.adminOnly': 'Ustawienia płatności online są dostępne tylko dla administratora firmy.',
    'paymentSettings.stripeLinkExpired': 'Link do konfiguracji w Stripe wygasł albo został już użyty. Kliknij przycisk poniżej, aby otworzyć nowy.',
    'paymentSettings.advanceRange': 'Wpisz liczbę całkowitą od 1 do 100.',
    'paymentSettings.autoCancelOffNow': 'Teraz: wyłączone',
    'paymentSettings.widgetSettingsPremium': 'Zaliczka płacona w widgecie i auto-anulowanie nieopłaconych rezerwacji z widgetu są dostępne w planie Premium, razem z widgetem rezerwacji.',
    'paymentSettings.premiumTitle': 'Płatności online są w planie Premium.',
    'paymentSettings.premiumBody': 'Na planie Basic zapiszesz przy rezerwacji wpłatę gotówką albo przelewem. Linki do zapłaty wysłane wcześniej działają dalej.',
    'paymentSettings.premiumConnectedBody': 'Na planie Basic nie wyślesz nowych linków do zapłaty. Linki wysłane wcześniej, zwroty i kaucje działają dalej, a podłączone konto Stripe możesz wstrzymać, odłączyć albo dokończyć jego konfigurację.',
    'premium.badge': 'Premium',
    'premium.badgeTitle': 'Funkcja planu Premium',
    'premium.want': 'Chcę Premium',
    'premium.defaultMessage': 'Ta funkcja jest w planie Premium.',
    'premium.request.subject': 'Chcę przejść na Premium',
    'premium.request.body': 'Chcę przejść na plan Premium. Interesuje mnie: {feature}.',
    'premium.feature.widget': 'widget rezerwacji',
    'premium.feature.own_smtp': 'maile z adresu wypożyczalni',
    'premium.feature.reminders': 'automatyczne przypomnienia',
    'premium.feature.sms': 'SMS-y do klientów',
    'premium.feature.payment_links': 'płatności online',
    'premium.feature.booking_link': 'link do rezerwacji i kod QR',
    'premium.feature.unpaid_guard': 'ochrona przed nieopłaconymi rezerwacjami',
    'premium.feature.other': 'funkcje planu Premium',
    'przerwa.tytul': 'Konto w przerwie, tylko podgląd',
    'przerwa.tytulDo': 'Konto w przerwie do {do}, tylko podgląd',
    'przerwa.opis': 'Dane firmy przeglądasz jak zwykle, ale zmian nie zapiszesz. Działają faktury i KSeF (wystawienie, korekta, wpłata na fakturze, wysyłka, ustawienia faktur i KSeF), a także zwroty pieniędzy, kaucje, hasło, odebranie dostępu pracownikowi, usunięcie danych klienta i eksport danych firmy. Widget, przypomnienia i linki do zapłaty są wyłączone.',
    'przerwa.zaplanowana': 'Od {od} konto przejdzie w przerwę: dane zostaną do podglądu, faktury i KSeF będą działać, a pozostały zapis, widget i linki do zapłaty będą wyłączone.',
    'przerwa.zapisZablokowany': 'Konto jest w przerwie i działa tylko do odczytu. Zmiany zapiszesz po wznowieniu konta.',
    'przerwa.wznowienie.przycisk': 'Poproś o wznowienie',
    'przerwa.wznowienie.temat': 'Prośba o wznowienie konta po przerwie',
    'przerwa.wznowienie.tresc': 'Proszę o wznowienie konta po przerwie. Chcemy znowu pracować od: ',
    'przerwa.szablonTylkoOdczyt': 'Konto jest w przerwie, więc szablon jest tylko do podglądu.',
    'przerwa.wznowiona': 'Przerwa się skończyła. Możesz znowu zapisywać zmiany.',
    'rezygnacja.tytul': 'Konto po rezygnacji, tylko podgląd',
    'rezygnacja.opis': 'Dane firmy przeglądasz jak zwykle. Działają faktury i KSeF (wystawienie, korekta, wpłata na fakturze, wysyłka, ustawienia faktur i KSeF), zwroty pieniędzy, kaucje, hasło i eksport danych firmy. Pozostałych zmian nie zapiszesz, a rezerwacje w widgecie, przypomnienia i linki do zapłaty są wyłączone.',
    'rezygnacja.usuniecie': 'Dane firmy mogą zostać usunięte nie wcześniej niż {od}. Przed tym dniem pobierz eksport danych: jeden plik z danymi i fakturami w PDF. Faktury przechowujecie sami przez okres wymagany przepisami.',
    'rezygnacja.usunieciePracownik': 'Dane firmy mogą zostać usunięte nie wcześniej niż {od}. Eksport danych pobiera administrator firmy.',
    'rezygnacja.eksport.przycisk': 'Pobierz eksport danych',
    'rezygnacja.eksport.opis': 'Konto jest po rezygnacji, a eksport działa normalnie. Pobierz go, zanim dane firmy zostaną usunięte.',
    'rezygnacja.odwolanie.przycisk': 'Poproś o odwołanie rezygnacji',
    'rezygnacja.odwolanie.temat': 'Prośba o odwołanie rezygnacji',
    'rezygnacja.odwolanie.tresc': 'Proszę o odwołanie rezygnacji. Chcemy dalej korzystać z the.rENT. ',
    'rezygnacja.zaplanowana': 'Od {od} konto będzie po rezygnacji i przejdzie w tryb tylko do odczytu: zostaną podgląd danych, eksport, faktury i KSeF, a rezerwacje, widget i linki do zapłaty będą wyłączone.',
    'rezygnacja.zapisZablokowany': 'Konto po rezygnacji działa tylko do odczytu. Możesz pobrać eksport danych firmy i obsłużyć faktury.',
    'rezygnacja.odwolana': 'Rezygnacja została odwołana. Możesz znowu zapisywać zmiany.',
    'rezygnacja.szablonTylkoOdczyt': 'Konto jest po rezygnacji, więc szablon jest tylko do podglądu.',
    'rezygnacja.daneFirmy': 'Konto jest po rezygnacji: dane firmy są tylko do podglądu, a ustawienia faktur zapiszesz jak zwykle.',
    'reservation.choose': 'Wybierz',
    'reservation.pickDate': 'Wybierz datę',
    'reservation.success.saved': 'Rezerwacja została zapisana!',
    'reservation.error.fill': 'Uzupełnij wszystkie wymagane pola!',
    'reservation.error.equipment': 'Wybierz sprzęt!',
    'reservation.error.save': 'Błąd podczas zapisu rezerwacji.',
    'reservation.error.selectDates': 'Najpierw wybierz termin rezerwacji!',
    'reservation.clearRangeTitle': 'Wyczyść wybrany zakres',
    'reservation.notePlaceholder': 'Dodatkowe uwagi...',
    'reservation.generateContract': 'Generuj umowę',
    'reservation.generatingContract': 'Generowanie umowy…',
    'reservation.contractGenerated': 'Umowa została wygenerowana i pobrana.',
    'contractError.session': 'Sesja wygasła. Zaloguj się ponownie i spróbuj jeszcze raz.',
    'contractError.tooLarge': 'Dane umowy są za duże, żeby je wysłać. Skróć notatkę albo zmniejsz liczbę pozycji.',
    'contractError.busy': 'Serwer jest teraz zajęty. Spróbuj ponownie za chwilę.',
    'contractError.noTemplate': 'Nie znaleziono szablonu umowy. Opublikuj szablon w konstruktorze umowy.',
    'contractError.server': 'Serwer nie przygotował dokumentu. Sprawdź własny szablon .docx w ustawieniach umowy albo spróbuj ponownie.',
    'contractError.http': 'Serwer odpowiedział błędem (HTTP {status}).',
    'contractError.network': 'Brak połączenia z serwerem. Sprawdź internet i spróbuj ponownie.',
    'reservation.cleared': 'Formularz został wyczyszczony',
    'reservation.contract.generated': 'Umowa została wygenerowana i pobrana',
    'reservation.paymentAndDiscount': 'Rabat i płatność',
    'reservation.paymentMethodPlaceholder': 'Wybierz płatność',
    'reservation.subtitle': 'Utwórz nową rezerwację sprzętu',

    // Validation
    'validation.required': 'To pole jest wymagane',
    'validation.invalidEmail': 'Niepoprawny format adresu e-mail',
    'validation.selectEquipment': 'Wybierz przynajmniej jeden sprzęt',
    'validation.fillAllFields': 'Wypełnij wszystkie wymagane pola, aby kontynuować.',

    // Home page
    'home.header': 'Panel wypożyczalni',
    'home.nav.calendar': 'Kalendarz',
    'home.nav.newReservation': 'Nowa Rezerwacja',
    'home.nav.statistics': 'Statystyki',
    'home.nav.profile': 'Profil',
    'home.pagination.prev': 'Poprzednia',
    'home.pagination.next': 'Następna',
    'home.pagination.page': 'Strona',
    'home.pagination.of': 'z',
    'home.upcomingReservations': 'Nadchodzące rezerwacje',
    'home.loadingReservations': 'Ładowanie rezerwacji...',
    'home.noCategories': 'Brak kategorii',
    'home.noRentals': 'Brak wynajmów',
    'home.ongoingReservations': 'Trwające rezerwacje',
    'home.upcomingShort': 'Nadchodzące',
    'home.ongoingShort': 'Trwające',
    'home.kpisTitle': 'Kluczowe wskaźniki',
    'home.kpisSubtitle': 'Przegląd najważniejszych danych z Twojej wypożyczalni',
    'home.kpis.clients': 'Klienci',
    'home.favorites': 'Ulubione',
    'home.favorites.helper': 'Wybierz do 4 stron',
    'home.favorites.edit': 'Edytuj',
    'home.favorites.choose': 'Zaznacz strony które chcesz mieć w Ulubionych (max 4)',
    'home.favorites.cancel': 'Anuluj',
    'home.favorites.save': 'Zapisz',
    'home.favorites.desc.calendar': 'Widok kalendarza i szczegóły rezerwacji',
    'home.favorites.desc.reservation': 'Szybkie tworzenie nowej rezerwacji',
    'home.favorites.desc.statistics': 'Szybki dostęp do statystyk',
    'home.favorites.desc.profile': 'Ustawienia konta i profil',
    'home.rental.today': 'Wynajmy na dziś',
    'home.rental.week': 'Wynajmy na ten tydzień',
    'home.rental.month': 'Wynajmy na 30 dni',
    'home.rental.all': 'Wszystkie rezerwacje',

    'home.period.today': 'Dzisiaj',
    'home.period.week': 'Ten tydzień',
    'home.period.month': '30 Dni',
    'home.period.all': 'Wszystkie',
    'home.category.all': 'Wszystkie kategorie',
    'home.loading': 'Ładowanie...',
    'home.noData': 'Brak danych',
    'home.kpis.title': 'KPIs',
    'home.kpis.totalRentals': 'Wszystkie wypożyczenia',
    'home.kpis.availableEquipment': 'Dostępny sprzęt',
    'home.kpis.activeCustomers': 'Aktywni klienci',
    'home.kpis.overdueReturns': 'Spóźnione zwroty',

    'home.bestSellers.title': 'Najczęściej wypożyczany sprzęt',
    'home.filter.all': 'Wszystkie',
    'home.table.name': 'Nazwa',
    'home.table.size': 'Rozmiar',
    'home.table.brand': 'Marka',
    'home.table.category': 'Kategoria',
    'home.table.class': 'Klasa',
    'home.table.rentalsYear': 'Wynajmy (rok)',
    'home.refresh': 'Odśwież dane',

    // Calendar
    'calendar.title': 'Kalendarz Rezerwacji',
    'calendar.titleHint': 'Zarządzaj rezerwacjami i planuj obłożenie sprzętu',
    'calendar.addReservation': 'Dodaj rezerwację',
    'calendar.todayButton.label': 'Dziś',
    'calendar.todayButton.tooltip': 'Przejdź do dzisiejszego dnia',
    'calendar.legend.start': 'Start',
    'calendar.legend.end': 'Koniec',
    'calendar.tabs.calendar': 'Kalendarz',
    'calendar.tabs.upcoming': 'Nadchodzące',
    'calendar.tabs.history': 'Historia',
    'calendar.tabs.returns': 'Do zwrotu',
    'calendar.equipmentCountOne': '{count} przedmiot',
    'calendar.equipmentCountFew': '{count} przedmioty',
    'calendar.equipmentCountMany': '{count} przedmiotów',
    'calendar.equipmentCountOther': '{count} przedmiotu',
    'calendar.moreReservations': 'Jeszcze {count} rezerwacji - kliknij dzień, aby zobaczyć wszystkie',
    'calendar.moreWord': 'więcej',

    'calendar.dayReservations.title': 'Rezerwacje na dzień',
    'calendar.dayReservations.empty': 'Brak rezerwacji na ten dzień.',
    'calendar.dayReservations.noneToday': 'brak rezerwacji',

    'calendar.dayPlan.pickups': 'Wydania',
    'calendar.dayPlan.itemPickedUp': 'wydano',
    'calendar.dayPlan.itemReturned': 'zwrócono',
    'calendar.dayPlan.itemReturnsToday': 'wraca dziś',
    'calendar.dayPlan.prepareReturningToday': 'wraca dziś: {count} szt.',
    'calendar.dayPlan.returns': 'Zwroty',
    'calendar.dayPlan.ongoing': 'Trwające',
    'calendar.dayPlan.pickupsEmpty': 'Tego dnia nic nie wydajesz.',
    'calendar.dayPlan.returnsEmpty': 'Tego dnia nic nie wraca.',
    'calendar.dayPlan.ongoingEmpty': 'Brak wypożyczeń trwających z wcześniejszych dni.',
    'calendar.dayPlan.prepare': 'Do przygotowania',
    'calendar.dayPlan.pieces': '{count} szt.',
    'calendar.dayPlan.noSize': 'bez rozmiaru',
    'calendar.dayPlan.noType': 'Bez kategorii',
    'calendar.dayPlan.otherEquipment': 'Pozostały sprzęt',
    'calendar.dayPlan.equipmentLoading': 'Wczytuję magazyn...',
    'calendar.dayPlan.equipmentFailed': 'Nie udało się wczytać magazynu, więc nie ma podziału na typy i rozmiary. Odśwież stronę.',
    'calendar.dayPlan.print': 'Drukuj plan dnia',
    'calendar.dayPlan.printTitle': 'Plan dnia',
    'calendar.dayPlan.until': 'do {date}',
    'calendar.dayPlan.since': 'od {date}',
    'calendar.dayPlan.sameDayReturn': 'zwrot tego samego dnia',
    'calendar.dayPlan.sameDayPickup': 'wydanie tego samego dnia',
    'calendar.dayPlan.inventoryNo': 'nr {number}',
    'calendar.dayPlan.unknownItem': 'Sprzęt #{id}',
    'calendar.dayPlan.noEquipment': 'bez sprzętu',
    'calendar.dayPlan.reservationNo': 'Rezerwacja #{id}',
    'calendar.dayPlan.printedAt': 'Wydrukowano: {date}',

    'calendar.delete.refundFailed': 'Zwrot się nie powiódł: {error}. Rezerwacja NIE została usunięta. Kliknij ponownie, aby dokończyć zwrot, albo zwróć ręcznie z listy Płatności.',
    'calendar.delete.genericError': 'Wystąpił błąd podczas anulowania rezerwacji.',

    // ReservationFormView — panel szczegolow/edycji rezerwacji w kalendarzu
    'reservationForm.date.startBeforeToday': 'Nie można ustawić daty rozpoczęcia wcześniej niż dzisiaj.',
    'reservationForm.date.endBeforeToday': 'Nie można ustawić daty zakończenia wcześniej niż dzisiaj.',
    'reservationForm.classQuote.failed': 'Nie udało się przeliczyć ceny zapytania o klasy, więc zmiany terminu i sprzętu nie da się teraz zapisać. Spróbuj ponownie za chwilę.',
    'reservationForm.deposit.overrideConfirm': 'Kaucja {amount} to {times} razy więcej niż kaucja wybranego sprzętu ({equipmentDeposit}). Ta kwota zostanie zablokowana na karcie klienta. Zapisać?',
    'reservationForm.payment.sendLinkError': 'Nie udało się wysłać linku',
    'reservationForm.payment.linksPremium': 'Linki do zapłaty online i płatność kartą przez Stripe są w planie Premium. Wpłatę gotówką albo przelewem zapiszesz niżej.',
    'reservationForm.payment.sendLinkPriceList': 'Wyślij link do zapłaty reszty',
    'reservationForm.payment.priceListNote': 'Kwotę w linku policzy cennik: ta rezerwacja z rabatem jest zapisana sprzed zmiany sposobu liczenia kwot, więc może różnić się od „Pozostało do zapłaty”. Dokładną kwotę zobaczysz w mailu do klienta i na stronie płatności.',
    'reservationForm.payment.prepareLinkError': 'Nie udało się przygotować linku',
    'reservationForm.payment.initError': 'Nie udało się zainicjować płatności',
    'reservationForm.photos.addRequired': 'Dodaj zdjęcie albo notatkę.',
    'reservation.save.paymentLinkFailed': 'Rezerwacja zapisana, ale nie udało się wysłać linku do zapłaty. Możesz go wysłać z Kalendarza.',
    'reservation.payLinkPremium': 'Link do zapłaty online jest w planie Premium.',
    'reservation.save.paymentLinkFailedReason': 'Rezerwacja zapisana, ale nie wysłano linku do zapłaty: {reason}',
    'reservation.save.docsPartialFailure': 'Rezerwacja zapisana, ale {failed} z {total} wpisów dokumentacji nie zapisało się (powód: {reason}). Dodaj je z Kalendarza.',
    'reservation.save.docsUnconfirmed': 'Rezerwacja zapisana, ale {failed} z {total} wpisów dokumentacji nie ma potwierdzenia zapisu, bo odpowiedź serwera nie dotarła. Sprawdź dokumentację rezerwacji w Kalendarzu i dodaj brakujące wpisy.',
    'reservation.save.docsMixed': 'Rezerwacja zapisana, ale {failed} z {total} wpisów dokumentacji nie zapisało się (powód: {reason}), a {unconfirmed} nie ma potwierdzenia zapisu, bo odpowiedź serwera nie dotarła. Sprawdź dokumentację rezerwacji w Kalendarzu i dodaj brakujące wpisy.',
    'reservationForm.photos.partialFailure': '{failed} z {total} wpisów nie zapisało się. Powód: {reason}.',
    'reservationForm.photos.reasonConnection': 'chwilowy błąd serwera',
    'reservationForm.photos.unconfirmed': '{count} z {total} wpisów nie ma potwierdzenia zapisu: odpowiedź serwera nie dotarła, a zapis mógł się jednak udać.',
    'reservationForm.photos.reasonSession': 'sesja wygasła, zaloguj się ponownie',
    'reservationForm.photos.reasonRejected': 'serwer nie przyjął wpisu',
    'reservationForm.photos.removedFiles': 'Zdjęcia, których serwer nie przyjmie, usunięto z formularza: {files}.',
    'reservationForm.photos.checkListBeforeRetry': 'Zanim wyślesz ponownie, sprawdź listę dokumentacji tej rezerwacji.',
    'reservationForm.photos.deleteConfirmTitle': 'Usunąć ten wpis dokumentacji?',
    'reservationForm.deposit.operationError': 'Błąd operacji na kaucji',
    'reservationForm.offline.invalidAmount': 'Podaj poprawną kwotę.',
    'reservationForm.offline.confirmSaveTitle': 'Zapisać {what} {how}?',
    'reservationForm.offline.confirmSaveMessage': 'Utworzy to wpis płatności. Użyj TYLKO gdy klient faktycznie zapłacił.',
    'reservationForm.offline.saveError': 'Nie udało się zapisać płatności',
    'reservationForm.offline.advanceWord': 'zaliczkę',
    'reservationForm.offline.paymentWord': 'wpłatę {amount}',
    'reservationForm.offline.cashWord': 'gotówką',
    'reservationForm.offline.transferWord': 'przelewem',
    'reservationForm.offline.cardWord': 'kartą (terminal)',
    'reservationForm.offline.amountPrompt': 'Kwota wpłaty {how} w zł:',
    'reservationForm.customLink.sentToClient': 'Link na wskazaną kwotę wysłany do klienta.',
    'reservationForm.customLink.copied': 'Link skopiowany.',
    'reservationForm.contract.generateError': 'Błąd generowania umowy: {message}',
    'reservationForm.deposit.linkSent': 'Link do blokady kaucji wysłany do klienta.',
    'reservationForm.deposit.linkCopied': 'Link do blokady kaucji skopiowany.',
    'reservationForm.deposit.invalidAmountRange': 'Nieprawidłowa kwota. Podaj wartość od 0,01 do {max}.',
    'reservationForm.deposit.captureConfirm': 'Ściągnąć {amount} z kaucji? Reszta blokady zostanie zwolniona.',
    'reservationForm.deposit.releaseConfirm': 'Zwolnić całą blokadę kaucji? Środki wrócą do dyspozycji klienta.',
    'reservationForm.deposit.refundConfirm': 'Zwrócić {amount} z pobranej kaucji klientowi {email}?',
    'reservationForm.deposit.title': 'Kaucja',
    'reservationForm.deposit.takenCash': '{amount} przyjęta gotówką',
    'reservationForm.deposit.takenTransfer': '{amount} przyjęta przelewem',
    'reservationForm.deposit.takenCard': '{amount} przyjęta kartą (terminal)',
    'reservationForm.deposit.cancelledNote': 'Rezerwacja jest anulowana, więc nie przyjmuje nowej kaucji.',
    'reservationForm.deposit.refundAdminOnly': 'Kaucję z karty zwraca administrator.',
    'reservationForm.deposit.offlineHint': 'Albo przyjmij kaucję na miejscu:',
    'reservationForm.deposit.linksPremium': 'Link do kaucji na karcie jest w planie Premium. Kaucję gotówką albo przelewem przyjmiesz niżej.',
    'reservationForm.deposit.offlineCash': 'Kaucja gotówką',
    'reservationForm.deposit.offlineTransfer': 'Kaucja przelewem',
    'reservationForm.deposit.offlineCard': 'Kaucja kartą (terminal)',
    'reservationForm.deposit.offlineConfirm': 'Zapisać kaucję {amount} przyjętą {how}?',
    'reservationForm.deposit.offlineSaved': 'Kaucja przyjęta na miejscu zapisana.',
    'reservationForm.deposit.giveBack': 'Oddaj kaucję',
    'reservationForm.deposit.giveBackConfirm': 'Zapisać oddanie klientowi {amount} z kaucji? Mniejsza kwota to potrącenie za szkodę.',

    'calendar.delete.title': 'Anuluj rezerwację',
    'calendar.delete.confirmMessage': 'Czy na pewno anulować rezerwację #{id}?',
    'calendar.delete.irreversible': 'Rezerwacja zostanie w historii jako anulowana, a sprzęt od razu wróci do puli dostępnych. Anulowania nie da się cofnąć.',
    'calendar.delete.paidOnline': 'Zapłacono online',
    'calendar.delete.cancelFeeLabel': 'Opłata za anulowanie (zatrzymaj)',
    'calendar.delete.cancelFeeAria': 'Opłata za anulowanie',
    'calendar.delete.cancelFeeUnitAria': 'Jednostka opłaty za anulowanie',
    'calendar.delete.toRefund': 'Do zwrotu klientowi',
    'calendar.delete.feeLockedHint': 'Część zwrotu została już wykonana, więc kwoty są zablokowane. Kliknij ponownie, aby dokończyć zwrot i usunąć.',
    'calendar.delete.feeHint': 'Zwrot wraca na kartę, którą płacił klient. Zatrzymana część zostaje jako opłata za anulowanie. Zostaw puste, aby oddać całość.',
    'calendar.delete.refundCheckFailed': 'Nie udało się sprawdzić opłaconych płatności online tej rezerwacji. Jeśli anulujesz mimo to, ewentualny zwrot wykonaj ręcznie z listy Płatności.',
    'calendar.delete.checkingPayments': 'Sprawdzam płatności…',
    'calendar.delete.deleting': 'Anulowanie…',
    'calendar.delete.deleteAnyway': 'Anuluj mimo to',
    'calendar.delete.refundAndDelete': 'Zwróć {amount} i anuluj',
    'calendar.delete.confirmCancel': 'Anuluj rezerwację',
    'calendar.delete.keep': 'Nie anuluj',
    'calendar.delete.done': 'Rezerwacja #{id} anulowana. Znajdziesz ją w zakładce „Historia”.',
    'calendar.delete.feeOverPaid': 'Opłata przekracza wpłatę ({amount}). Popraw kwotę albo wpisz 100%, aby zatrzymać całość.',
    'calendar.delete.fixFee': 'Popraw opłatę',
    'calendar.delete.adminRequired': 'Do tej rezerwacji przyjęto pieniądze. Anulować ją może administrator, który rozliczy zwrot wpłaty i kaucji.',
    'calendar.delete.paidOnSite': 'Przyjęto na miejscu',
    'calendar.delete.paidOnSiteWithMethods': 'Przyjęto na miejscu ({methods})',
    'calendar.delete.paidOnSiteHint': 'Tych pieniędzy panel nie zwróci: oddaj je klientowi ręcznie, gotówką albo przelewem.',
    'calendar.delete.paidOnInvoice': 'Wpisano na fakturze {number}',
    'calendar.delete.paidOnInvoiceHint': 'Tych wpłat panel nie zwróci: oddaj je klientowi ręcznie, gotówką albo przelewem.',
    'calendar.delete.depositAuthorized': 'Kaucja zablokowana na karcie',
    'calendar.delete.releaseDeposit': 'Zwolnij blokadę kaucji przy anulowaniu',
    'calendar.delete.depositKeptHint': 'Kaucja zostanie zablokowana. Zwolnisz ją później w szczegółach anulowanej rezerwacji.',
    'calendar.delete.depositCaptured': 'Kaucja pobrana',
    'calendar.delete.depositCapturedHint': 'Pobrana kaucja zostaje przy rezerwacji. Zwrot wykonasz w karcie kaucji w szczegółach rezerwacji.',
    'calendar.delete.depositReleaseFailed': 'Rezerwacja anulowana, ale nie udało się zwolnić kaucji. Zwolnij ją w szczegółach anulowanej rezerwacji.',

    'calendar.upcoming.title': 'Nadchodzące rezerwacje',
    'calendar.upcoming.empty': 'Brak nadchodzących rezerwacji.',
    'calendar.returns.hint': 'Rezerwacje z terminem zwrotu dziś, z których nie wszystko wróciło, oraz spóźnione: wydany sprzęt, który nie wrócił w terminie.',
    'calendar.returns.overdue': 'Spóźnione',
    'calendar.returns.today': 'Termin zwrotu dziś',
    'calendar.returns.empty': 'Nic nie czeka na zwrot.',
    'calendar.returns.loadFailed': 'Nie udało się wczytać listy zwrotów. Odśwież stronę.',
    'calendar.returns.lateOne': '{count} dzień po terminie',
    'calendar.returns.lateFew': '{count} dni po terminie',
    'calendar.returns.lateMany': '{count} dni po terminie',
    'calendar.returns.lateOther': '{count} dnia po terminie',
    'calendar.handover.out': 'U klienta: {n} z {total}',
    'calendar.handover.allReturned': 'Sprzęt wrócił',

    'calendar.history.title': 'Historia wszystkich rezerwacji',
    'calendar.history.empty': 'Brak rezerwacji w bazie.',
    'calendar.history.noResults': 'Brak wyników dla podanych kryteriów.',
    'calendar.history.loadMore': 'Pokaż więcej',
    'calendar.history.loadFailed': 'Nie udało się wczytać historii rezerwacji. Spróbuj ponownie.',
    'calendar.history.statusFilterHint': 'Filtr stanu obejmuje wczytane rezerwacje. Starsze dociągnij przyciskiem obok.',

    'calendar.filters.from': 'Od:',
    'calendar.filters.to': 'Do:',
    'calendar.filters.name': 'Imię lub nazwisko:',
    'calendar.filters.namePlaceholder': 'Wpisz imię lub nazwisko',
    'calendar.filters.status': 'Status:',
    'calendar.filters.statusAll': 'Wszystkie',
    'calendar.filters.clear': 'Wyczyść filtry',

    'calendar.status.upcoming': 'Nadchodząca',
    'calendar.status.ongoing': 'Trwająca',
    'calendar.status.finished': 'Zakończona',
    'calendar.status.cancelled': 'Anulowana',
    'calendar.status.overdue': 'Spóźniona',
    'calendar.status.unknown': 'Nieznany',
    'calendar.status.nadchodząca': 'Nadchodząca',
    'calendar.status.trwająca': 'Trwająca',
    'calendar.status.zakończona': 'Zakończona',

    'calendar.pagination.previous': 'Poprzednia',
    'calendar.pagination.next': 'Następna',
    'calendar.pagination.pageInfo': 'Strona {page} z {total}',

    'calendar.details': 'Szczegóły',
    'calendar.startLabel': 'rozpoczęcie',
    'calendar.endLabel': 'zakończenie',

    'calendar.modal.title': 'Szczegóły rezerwacji',
    'calendar.modal.clientData': 'Dane klienta',
    'calendar.modal.rentalPeriod': 'Okres wypożyczenia',
    'calendar.modal.equipment': 'Wypożyczony sprzęt',
    'calendar.modal.financial': 'Informacje finansowe',
    'calendar.modal.additional': 'Dodatkowe informacje',
    'calendar.modal.edit': 'Edytuj',
    'calendar.modal.delete': 'Usuń',
    'calendar.modal.deleteConfirmTitle': 'Potwierdź usunięcie rezerwacji',
    'calendar.modal.deleteConfirmText': 'Czy na pewno chcesz usunąć rezerwację',
    'calendar.modal.deleteWarning': 'Operacja jest nieodwracalna!',
    'calendar.modal.cancel': 'Anuluj',
    'calendar.modal.close': 'Zamknij',

    // Calendar - EDYCJA
    'calendar.edit.title': 'Edytuj rezerwację',
    'calendar.edit.firstname': 'Imię:',
    'calendar.edit.lastname': 'Nazwisko:',
    'calendar.edit.cancel': 'Anuluj',
    'calendar.edit.save': 'Zapisz zmiany',
    'calendar.edit.success': 'Rezerwacja została zaktualizowana!',
    'calendar.edit.error': 'Błąd podczas aktualizacji rezerwacji',

    'calendar.paymentStatus.Opłacone': 'Opłacone',
    'calendar.paymentStatus.Nieopłacone': 'Nieopłacone',
    'calendar.paymentStatus.Częściowo opłacone': 'Częściowo opłacone',
    'calendar.paymentStatus.Zwrot': 'Zwrot',
    
    'calendar.paymentMethod.Karta płatnicza': 'Karta płatnicza',
    'calendar.paymentMethod.Gotówka': 'Gotówka',
    'calendar.paymentMethod.Przelew': 'Przelew',
    'calendar.paymentMethod.BLIK': 'BLIK',
    'calendar.paymentMethod.PayPal': 'PayPal',
    'calendar.paymentMethod.Inne': 'Inne',

    'calendar.label.nameSurname': 'Imię i nazwisko:',
    'calendar.label.phone': 'Telefon:',
    'calendar.label.email': 'E-mail:',
    'calendar.label.address': 'Adres:',
    'calendar.label.idNumber': 'Numer dowodu:',
    'calendar.label.registrationDate': 'Data rejestracji klienta:',
    'calendar.label.reservationDate': 'Data rezerwacji:',
    'calendar.label.from': 'Od:',
    'calendar.label.to': 'Do:',
    'calendar.label.duration': 'Długość:',
    'calendar.label.days': 'dni',
    'calendar.label.discount': 'Zniżka:',
    'calendar.label.status': 'Status:',
    'calendar.label.totalPrice': 'Cena całkowita:',
    'calendar.label.deposit': 'Zadatek:',
    'calendar.label.paymentStatus': 'Status płatności:',
    'calendar.label.paymentMethod': 'Metoda płatności:',
    'calendar.label.paymentDate': 'Data płatności:',
    'calendar.label.note': 'Notatka:',
    'calendar.label.reservationId': 'ID rezerwacji:',
    'calendar.label.createdAt': 'Data utworzenia:',
    'calendar.label.updatedAt': 'Ostatnia modyfikacja:',

    'calendar.currency': 'zł',

    'calendar.weekdays': [
      "Niedziela", "Poniedziałek", "Wtorek", "Środa", "Czwartek", "Piątek", "Sobota"
    ],
    'calendar.months': [
      "Styczeń", "Luty", "Marzec", "Kwiecień", "Maj", "Czerwiec",
      "Lipiec", "Sierpień", "Wrzesień", "Październik", "Listopad", "Grudzień"
    ],
    'calendar.monthsShort': [
      "Sty", "Lut", "Mar", "Kwi", "Maj", "Cze",
      "Lip", "Sie", "Wrz", "Paź", "Lis", "Gru"
    ],

    // Statistics
    'statistics.header': 'Statystyki wypożyczeń',
    'statistics.subtitle': 'Przegląd kluczowych wskaźników i wykresów',
    'statistics.clearFilters': 'Wyczyść filtry KPI',
    'statistics.year': 'Rok',
    'statistics.month': 'Miesiąc',
    'statistics.periodFor': 'Okres',
    'statistics.metric.count': 'Liczba rezerwacji',
    'statistics.metric.value': 'Wartość wypożyczeń',
    'statistics.bar.count': 'Liczba rezerwacji',
    'statistics.bar.value': 'Wartość wypożyczeń',
    'statistics.loading': 'Ładowanie danych...',
    'statistics.kpi.title': 'KPI',


    'statistics.section.finances': 'Finanse',
    'statistics.summary.rentalValue': 'Wartość wypożyczeń w okresie',
    'statistics.summary.rentalValueHint': 'Suma rezerwacji po rabatach, niezależnie od wystawionych faktur. Sprzedaż z faktur pokazuje ekran Faktury.',
    'statistics.finances.valuePerActiveCustomer': 'Wartość na aktywnego klienta',



    'statistics.section.customers': 'Klienci',


    'statistics.advanced.title': 'Metryki zaawansowane',
    'statistics.advanced.periodDays': 'Dni w okresie',
    'statistics.advanced.equipmentCount': 'Liczba sprzętu',
    'statistics.advanced.byCategory': 'Wg kategorii',
    'statistics.advanced.revenuePerItem': 'Wartość wypożyczeń / sztuka (top)',
    'statistics.advanced.itemName': 'Sprzęt',
    'statistics.advanced.itemRevenue': 'Wartość',
    'statistics.advanced.itemRentals': 'Wypożyczeń',
    'statistics.advanced.itemAvg': 'Śr. / wypożyczenie',
    'statistics.advanced.inventoryNumber': 'nr {number}',
    'statistics.advanced.revenue': 'Wartość',
    'statistics.advanced.rentals': 'Rezerwacje',
    'statistics.prevYear': 'Poprzedni rok',
    'statistics.nextYear': 'Następny rok',
    'statistics.wholeYear': 'Cały rok',
    'statistics.noSeason': 'Bez sezonu',
    'statistics.seasonLabel': 'Sezon',
    'statistics.season.winter': 'Zima',
    'statistics.season.spring': 'Wiosna',
    'statistics.season.summer': 'Lato',
    'statistics.season.autumn': 'Jesień',
    'statistics.loadError': 'Nie udało się wczytać wskaźników. Odśwież stronę.',
    'statistics.chart.revenuePln': 'Wartość wypożyczeń (zł)',
    'statistics.chart.reservationsCount': 'Liczba rezerwacji',
    'statistics.chart.hint': 'kliknij słupek, sezon lub trend, aby zawęzić KPI',
    'statistics.chart.monthlyActivity': 'Aktywność miesięczna',
    'statistics.chart.equipmentStatus': 'Sprzęt dziś',
    'statistics.chart.equipmentTotal': 'Łącznie: {count} szt.',
    'statistics.chart.itemsUnit': 'szt.',
    'statistics.chart.noData': 'Brak danych',
    'statistics.chart.inUseToday': 'W użyciu',
    'statistics.chart.availableToday': 'Dostępny',
    'statistics.chart.outOfServiceToday': 'W serwisie lub nieaktywny',
    'statistics.chart.seasonality': 'Sezonowość',
    'statistics.chart.bySeason': 'Sezony roku {year}',
    'statistics.chart.reservationsUnit': 'rez.',
    'statistics.chart.noDataFor': 'Brak danych za {year}',
    'statistics.chart.trend': 'Trend miesięczny',
    'statistics.badge.period': 'Okres: {label}',
    'statistics.badge.activeCustomers': 'Aktywni klienci w okresie: {count}',
    'statistics.badge.availableToday': 'Sprzęt dostępny dziś: {count}',
    'statistics.change.noComparison': 'Brak danych do porównania',
    'statistics.change.vsPeriod': '{value} wobec {period}',
    'statistics.change.comparedWith': 'wobec {period}',
    'statistics.change.vsPeriodOngoing': '{value} wobec {period} (okres trwa)',
    'statistics.change.comparedWithOngoing': 'wobec {period} (okres trwa)',
    'statistics.change.notStarted': 'Okres jeszcze się nie zaczął',
    'statistics.change.year': 'roku {year}',
    'statistics.change.season.winter': 'zimy {label}',
    'statistics.change.season.spring': 'wiosny {label}',
    'statistics.change.season.summer': 'lata {label}',
    'statistics.change.season.autumn': 'jesieni {label}',
    'statistics.section.demand': 'Popyt i rezerwacje',
    'statistics.section.operations': 'Operacje i sprzęt',
    'statistics.card.reservationsPeriod': 'Rezerwacje w okresie',
    'statistics.card.reservationsYear': 'Rezerwacje w roku {year}',
    'statistics.card.avgDays': 'Średnia długość wypożyczenia',
    'statistics.card.daysValue': '{value} dni',
    'statistics.card.change': 'Rezerwacje rok do roku',
    'statistics.card.revenueYear': 'Wartość wypożyczeń w roku {year}',
    'statistics.card.avgReservationValuePeriod': 'Średnia wartość rezerwacji w okresie',
    'statistics.card.utilization': 'Wykorzystanie sprzętu',
    'statistics.card.utilizationMeta': '{rented} z {available} dni wynajmu',
    'statistics.card.rentedOnce': 'Sprzęt wypożyczony choć raz w okresie',
    'statistics.card.rentedOnceValue': '{count} szt. ({percent}%)',
    'statistics.card.inUseToday': 'Sprzęt w użyciu dziś',
    'statistics.card.availableToday': 'Sprzęt dostępny dziś',
    'statistics.card.activeCustomers': 'Aktywni klienci w okresie',
    'statistics.card.activeOfAll': 'Aktywni w okresie: {active}, klienci łącznie: {total}',
    'statistics.card.activeShare': 'Udział aktywnych klientów',
    'statistics.card.newCustomers': 'Nowi klienci w okresie',
    'statistics.card.reservationsPerCustomer': 'Śr. liczba rezerwacji na aktywnego klienta',
    'statistics.advanced.category': 'Kategoria',
    'statistics.advanced.seasonalityYear': 'Sezonowość {year}',

    // Security
    'security.title': 'Bezpieczeństwo konta',
    'security.changePassword': 'Zmień hasło',
    'security.oldPassword': 'Stare hasło',
    'security.newPassword': 'Nowe hasło',
    'security.password': 'Hasło',
    'security.currentPassword': 'Aktualne hasło',
    'security.confirmPassword': 'Powtórz hasło',
    'security.repeatPassword': 'Powtórz nowe hasło',
    'security.subtitle': 'Zarządzaj hasłem, sesjami i monitoruj aktywność konta',
    'security.changePasswordButton': 'Zmień hasło',
    'security.changing': 'Zmieniam...',
    'security.change': 'Zmień',
    'security.passwordsDifferent': 'Hasła nie są identyczne.',
    'security.passwordTooShort': 'Hasło jest za krótkie (min. 6 znaków).',
    'security.passwordChanged': 'Hasło zostało zmienione.',
    'security.changePasswordError': 'Błąd podczas zmiany hasła.',
    'security.twoFA': 'Dwuskładnikowe uwierzytelnianie (2FA)',
    'security.enabled': 'Włączone',
    'security.disabled': 'Wyłączone',
    'security.disable2FA': 'Wyłącz 2FA',
    'security.enable2FA': 'Włącz 2FA',
    'twoFactorSetup.intro': 'Włącz weryfikację dwuetapową. Będziesz potrzebować aplikacji uwierzytelniającej: Google Authenticator, Authy lub Microsoft Authenticator.',
    'twoFactorSetup.startError': 'Nie udało się rozpocząć konfiguracji.',
    'twoFactorSetup.connectionError': 'Błąd połączenia z serwerem.',
    'twoFactorSetup.wrongCodeError': 'Błędny kod. Spróbuj ponownie.',
    'twoFactorSetup.loading': 'Ładowanie...',
    'twoFactorSetup.startButton': 'Rozpocznij konfigurację',
    'twoFactorSetup.step1Title': 'Krok 1: Zeskanuj kod QR',
    'twoFactorSetup.step1Intro': 'Otwórz aplikację uwierzytelniającą i zeskanuj poniższy kod QR:',
    'twoFactorSetup.qrAlt': 'Kod QR do konfiguracji 2FA',
    'twoFactorSetup.cantScan': 'Nie możesz zeskanować? Wpisz klucz ręcznie:',
    'twoFactorSetup.next': 'Dalej →',
    'twoFactorSetup.step2Title': 'Krok 2: Potwierdź kod',
    'twoFactorSetup.step2Intro': 'Wprowadź 6-cyfrowy kod z aplikacji, aby potwierdzić poprawną konfigurację:',
    'twoFactorSetup.verifying': 'Weryfikacja...',
    'twoFactorSetup.confirm': 'Potwierdź',
    'twoFactorSetup.passwordLabel': 'Aktualne hasło (wymagane do włączenia weryfikacji)',
    'twoFactorSetup.back': 'Wróć',
    'twoFactorSetup.step3Title': 'Krok 3: Kody zapasowe',
    'twoFactorSetup.importantLabel': 'Ważne:',
    'twoFactorSetup.backupCodesWarning': 'Zapisz te kody w bezpiecznym miejscu. Każdy z nich może być użyty tylko raz i nie będą pokazane ponownie.',
    'twoFactorSetup.copied': '✓ Skopiowano!',
    'twoFactorSetup.copyAll': 'Kopiuj wszystkie',
    'twoFactorSetup.done': 'Gotowe - 2FA aktywne',
    'security.activeSessions': 'Aktywne sesje',
    'security.device': 'Urządzenie',
    'security.ip': 'IP',
    'security.lastActivity': 'Ostatnia aktywność',
    'security.status': 'Status',
    'security.current': 'Aktualna',
    'security.other': 'Inna',
    'security.logout': 'Wyloguj sesję',
    'security.noSessions': 'Brak aktywnych sesji.',
    'security.logoutOthers': 'Wyloguj inne sesje',
    'security.sessionRevoked': 'Sesja została unieważniona.',
    'security.operationError': 'Błąd operacji.',
    'security.loginHistory': 'Historia logowań',
    'security.time': 'Czas',
    'security.noHistory': 'Brak historii logowań.',
    'security.ok': 'OK',
    'security.error': 'Błąd',
    'security.auditLog': 'Audyt bezpieczeństwa',
    'security.devices.title': 'Zalogowane urządzenia',
    'security.devices.subtitle': 'Lista przeglądarek i urządzeń z aktywnym dostępem do konta. Jeśli któregoś nie rozpoznajesz, wyloguj je.',
    'security.devices.lastActive': 'Ostatnia aktywność:',
    'security.devices.revoke': 'Wyloguj',
    'security.devices.revoking': 'Wylogowuję...',
    'security.devices.revokeAll': 'Wyloguj wszystkie pozostałe urządzenia',
    'security.devices.confirmAll': 'Na pewno? Trzeba będzie zalogować się na nich ponownie.',
    'security.devices.confirmYes': 'Tak, wyloguj',
    'security.devices.thisDevice': 'To urządzenie',
    'security.devices.unknown': 'Nieznane',
    'security.devices.empty': 'Brak aktywnych urządzeń',
    'security.devices.revokedOne': 'Urządzenie zostało wylogowane.',
    'security.devices.revokedAll': 'Wylogowano urządzenia: {count}.',
    'security.devices.revokeFailed': 'Nie udało się wylogować urządzenia. Spróbuj ponownie.',
    'security.action': 'Akcja',
    'security.details': 'Szczegóły',
    'security.noAudit': 'Brak zapisanych zdarzeń',
    'security.table.time': 'Czas',
    'security.table.ip': 'IP',
    'security.table.status': 'Status',
    'security.table.device': 'Urządzenie',
    'security.table.last': 'Ostatnia',
    'security.table.actions': 'Akcje',
    'security.empty.loginHistory': 'Brak historii logowań',
    'security.empty.auditLog': 'Brak zdarzeń audytu',
    'security.empty.sessions': 'Brak aktywnych sesji',
    'security.tips.title': 'Wskazówki dotyczące bezpieczeństwa',
    'security.tips.passwordTitle': 'Używaj silnych haseł',
    'security.tips.passwordDesc': 'Co najmniej 12 znaków z mieszanką liter, cyfr i symboli',
    'security.tips.changeTitle': 'Zmieniaj hasła regularnie',
    'security.tips.changeDesc': 'Co 3-6 miesięcy',
    'security.tips.monitorTitle': 'Monitoruj sesje',
    'security.tips.monitorDesc': 'Sprawdzaj nieznane urządzenia',

    // Equipment Details - dodane tłumaczenia
    'equipmentDetails.title': 'Szczegóły sprzętu',
    'equipmentDetails.subtitle': 'Przeglądaj lub edytuj informacje o sprzęcie',
    'equipmentDetails.edit': 'Edytuj',
    'equipmentDetails.save': 'Zapisz',
    'equipmentDetails.cancel': 'Anuluj',
    'equipmentDetails.loadError': 'Nie udało się pobrać danych sprzętu.',
    'equipmentDetails.saveSuccess': 'Zmiany zapisane!',
    'equipmentDetails.saveError': 'Błąd podczas zapisu zmian.',
    'equipmentDetails.calendar': 'Kalendarz',

    'superAdmin.nameEmailRequired': 'Nazwa i email są wymagane',
    'superAdmin.serverError': 'Błąd połączenia z serwerem',
    'superAdmin.ownerRequired': 'Email i imię i nazwisko właściciela są wymagane',
    'superAdmin.pendingStatusLocked': 'Nie można zmienić statusu organizacji oczekującej na aktywację. Klient musi najpierw wypełnić formularz aktywacyjny.',
    'superAdmin.orgUpdated': 'Dane organizacji zostały zaktualizowane',
    'superAdmin.copied': 'Skopiowano do schowka!',
    'superAdmin.title': 'Panel Super-Admina',
    'superAdmin.subtitle': 'Zarządzanie organizacjami w systemie the.rENT',
    'superAdmin.statAll': 'Wszystkie organizacje',
    'superAdmin.statActive': 'Aktywne',
    'superAdmin.statPending': 'Oczekujące',
    'superAdmin.searchPlaceholder': 'Szukaj organizacji...',
    'superAdmin.search': 'Szukaj',
    'superAdmin.loading': 'Ładowanie organizacji...',
    'superAdmin.empty': 'Brak organizacji do wyświetlenia',
    'superAdmin.colId': 'ID',
    'superAdmin.colName': 'Nazwa',
    'superAdmin.colNip': 'NIP',
    'superAdmin.colEmail': 'Email',
    'superAdmin.colPlan': 'Pakiet',
    'superAdmin.colStatus': 'Status',
    'superAdmin.colDemo': 'Demo',
    'superAdmin.colCreated': 'Data utworzenia',
    'superAdmin.colActions': 'Akcje',
    'superAdmin.editTooltip': 'Edytuj dane organizacji',
    'superAdmin.resendTooltip': 'Wyśle ponownie email z linkiem aktywacyjnym',
    'superAdmin.deletePendingTooltip': 'Usuń tę organizację oczekującą na aktywację',
    'superAdmin.addTitle': 'Dodaj nową organizację',
    'superAdmin.noteBefore': 'Organizacja zostanie utworzona, ale ',
    'superAdmin.demoNoteBefore': 'Organizacja demo zostanie utworzona, ale ',
    'superAdmin.noteBold': 'email aktywacyjny nie zostanie wysłany automatycznie',
    'superAdmin.fieldName': 'Nazwa wypożyczalni *',
    'superAdmin.fieldEmail': 'Email kontaktowy *',
    'superAdmin.emailHint': 'Na ten adres zostanie wysłany link aktywacyjny',
    'superAdmin.fieldNip': 'NIP',
    'superAdmin.fieldPhone': 'Telefon',
    'superAdmin.fieldAddress': 'Adres',
    'superAdmin.fieldPlan': 'Pakiet abonamentowy',
    'superAdmin.demoTitle': 'Utwórz organizację demo',
    'superAdmin.fieldOwnerName': 'Imię i nazwisko właściciela *',
    'superAdmin.fieldOwnerEmail': 'Email właściciela *',
    'superAdmin.demoEmailHint': 'Na ten adres zostanie wysłany link aktywacyjny (ważny 24h).',
    'superAdmin.demoPresetLabel': 'Branża wypożyczalni',
    'superAdmin.demoPresetHint': 'Decyduje o przykładowym sprzęcie, klientach i konfiguracji magazynu, które zobaczy lead po aktywacji.',
    'superAdmin.demoDaysLabel': 'Długość demo (dni)',
    'superAdmin.demoDaysHint': 'Liczona od aktywacji konta, od 1 do 365 dni.',
    'superAdmin.demoPurgeOn': 'usunięcie {date}',
    'superAdmin.demoManage': 'Demo',
    'superAdmin.demoManageTooltip': 'Przedłuż demo albo przekształć je w konto klienta',
    'demoManage.title': 'Demo: {name}',
    'demoManage.extendTitle': 'Przedłuż demo',
    'demoManage.extendHint': 'Wygasłe demo przedłużamy od dziś, trwające od obecnego końca. Przedłużenie odsuwa też automatyczne usunięcie.',
    'demoManage.extendPending': 'Konto nie jest jeszcze aktywowane: ustawiasz długość demo liczoną od aktywacji.',
    'demoManage.extendButton': 'Przedłuż o {days} dni',
    'demoManage.setDaysButton': 'Ustaw {days} dni od aktywacji',
    'demoManage.extended': 'Demo przedłużone.',
    'demoManage.convertTitle': 'Przekształć w konto klienta',
    'demoManage.convertHint': 'Konto przestaje być demo: znika limit czasu, blokady wysyłek i płatności oraz automatyczne usunięcie. Użytkownicy, ustawienia, konfiguracja magazynu, szablony oraz cenniki i pakiety dodane przez firmę zostają.',
    'demoManage.planLabel': 'Plan po przekształceniu',
    'demoManage.planPlaceholder': 'Wybierz plan',
    'demoManage.planHint': 'Demo działa na planie Premium. Wybierz plan, który klient kupił: na Basic wyłączają się widget, maile z adresu wypożyczalni i automatyczne przypomnienia (mail i SMS).',
    'demoManage.planRequired': 'Najpierw wybierz plan',
    'demoManage.wipeLabel': 'Usuń dane przykładowe (zalecane)',
    'demoManage.wipeHint': 'Zostaną usunięte fikcyjne dane z demo i wszystko, co zbudowano na fikcyjnych klientach, także przykładowy pakiet i reguła cenowa z demo. Wymiana tego samego dnia włączona w demo wyłączy się, chyba że firma zmieniła to ustawienie.',
    'demoManage.previewItems': 'Klienci: {clients} · sprzęt: {equipment} · rezerwacje: {reservations} · oferty: {offers} · faktury: {invoices}.',
    'demoManage.previewCompany': 'Także fikcyjne dane firmy (NIP, konto, adres), ale tylko pola, których nikt nie zmienił.',
    'demoManage.previewLoading': 'Liczę dane przykładowe…',
    'demoManage.previewFailed': 'Nie udało się policzyć danych przykładowych.',
    'demoManage.keepHint': 'Dane przykładowe zostaną na koncie klienta.',
    'demoManage.convertButton': 'Przekształć w klienta',
    'demoManage.confirmConvertWipe': 'Przekształcić „{name}” w konto klienta i trwale usunąć dane przykładowe?',
    'demoManage.confirmConvert': 'Przekształcić „{name}” w konto klienta bez usuwania danych przykładowych?',
    'demoManage.converted': 'Demo przekształcone w konto klienta.',
    'demoManage.error': 'Nie udało się wykonać operacji.',
    'superAdmin.createdTitle': 'Organizacja utworzona!',
    'superAdmin.createdBefore': 'Organizacja ',
    'superAdmin.createdAfter': ' została pomyślnie utworzona.',
    'superAdmin.activationLink': 'Link aktywacyjny (ważny 24h):',
    'superAdmin.editTitle': 'Edytuj organizację',
    'superAdmin.smtpCheckFailed': 'Nie udało się sprawdzić statusu SMTP',
    'superAdmin.loadError': 'Błąd pobierania organizacji',
    'superAdmin.twoFactorRequiredTitle': 'Włącz weryfikację dwuetapową',
    'superAdmin.twoFactorRequiredBody': 'Panel administracyjny zarządza wszystkimi firmami, więc samo hasło nie wystarcza. Włącz weryfikację dwuetapową (kod z aplikacji w telefonie), a potem zaloguj się ponownie z kodem. Do tego czasu to konto działa jak zwykłe konto administratora Twojej firmy.',
    'superAdmin.twoFactorRequiredCta': 'Przejdź do ustawień bezpieczeństwa',
    'superAdmin.twoFactorSessionTitle': 'Zaloguj się ponownie z kodem',
    'superAdmin.twoFactorSessionBody': 'Weryfikacja dwuetapowa jest już włączona, ale ta sesja zalogowała się bez kodu. Wyloguj się i zaloguj ponownie, podając kod z aplikacji w telefonie.',
    'superAdmin.twoFactorSessionCta': 'Wyloguj się',
    'superAdmin.createError': 'Błąd tworzenia organizacji',
    'superAdmin.createDemoError': 'Błąd tworzenia organizacji demo',
    'superAdmin.updateError': 'Błąd aktualizacji organizacji',
    'superAdmin.resendError': 'Błąd wysyłania emaila',
    'superAdmin.deleteError': 'Błąd usuwania organizacji',
    'superAdmin.confirmActivate': 'Czy na pewno chcesz aktywować tę organizację?',
    'superAdmin.confirmDeactivate': 'Czy na pewno chcesz dezaktywować tę organizację?',
    'superAdmin.confirmResend': 'Wysłać ponownie link aktywacyjny do "{name}" ({email})?',
    'superAdmin.confirmDeletePending': 'Czy na pewno chcesz usunąć oczekującą organizację "{name}"?\n\nTej akcji nie da się cofnąć.',
    'superAdmin.demoAwaiting': 'oczekuje aktywacji',
    'superAdmin.demoExpired': 'wygasło',
    'superAdmin.dayOne': 'dzień',
    'superAdmin.dayMany': 'dni',
    'superAdmin.statusSent': 'Wysłane',
    'superAdmin.statusActive': 'Aktywna',
    'superAdmin.statusInactive': 'Nieaktywna',
    'superAdmin.resending': 'Wysyłam...',
    'superAdmin.resend': 'Wyślij ponownie',
    'superAdmin.delete': 'Usuń',
    'superAdmin.activate': 'Aktywuj',
    'superAdmin.deactivate': 'Dezaktywuj',
    'superAdmin.submitCreate': 'Utwórz organizację',
    'superAdmin.submitCreateDemo': 'Utwórz demo',
    'superAdmin.noteCopyClient': 'Po utworzeniu skopiuj link i wyślij klientowi ręcznie.',
    'superAdmin.noteCopyLead': 'Po utworzeniu skopiuj link i wyślij zainteresowanemu ręcznie.',
    'superAdmin.reason': 'Powód',
    'superAdmin.sentTo': 'Link aktywacyjny został wysłany na',
    'superAdmin.emailNotSent': 'Email nie został wysłany.',
    'superAdmin.copyLinkManually': 'Skopiuj link poniżej i wyślij klientowi ręcznie, na przykład przez Messenger albo SMS.',
    'superAdmin.filterAll': 'Wszystkie',
    'superAdmin.filterActive': 'Aktywne',
    'superAdmin.filterInactive': 'Nieaktywne',
    'superAdmin.filterPaused': 'W przerwie',
    'superAdmin.statusPaused': 'W przerwie',
    'superAdmin.statusPauseScheduled': 'Przerwa od {od}',
    'superAdmin.pause': 'Przerwa',
    'superAdmin.pauseTooltip': 'Przerwa w sezonie: konto tylko do odczytu',
    'pauseManage.title': 'Przerwa: {name}',
    'pauseManage.explain': 'W przerwie firma loguje się i przegląda dane, a zapisuje tylko faktury, KSeF, zwroty i kaucje. Widget, przypomnienia i linki do zapłaty są wyłączone, a faktury dalej trafiają do KSeF. Przerwę kończysz tutaj: nic nie wznawia konta samo.',
    'pauseManage.startInfo': 'Przerwa zacznie się 1. dnia następnego miesiąca. Do tego dnia konto działa normalnie, ale nie przyjmie rezerwacji, która kończy się w dniu początku przerwy albo później.',
    'pauseManage.stateActive': 'Przerwa trwa od {od}.',
    'pauseManage.stateScheduled': 'Przerwa zaplanowana od {od}. Do tego dnia konto działa normalnie, ale nie przyjmie rezerwacji, która kończy się tego dnia albo później.',
    'pauseManage.untilLabel': 'Planowany koniec (opcjonalnie)',
    'pauseManage.untilHint': 'Firma widzi tę datę na banerze. Przerwa nie kończy się sama tego dnia.',
    'pauseManage.enable': 'Włącz przerwę',
    'pauseManage.saveUntil': 'Zapisz koniec',
    'pauseManage.resume': 'Zakończ przerwę',
    'pauseManage.cancelScheduled': 'Odwołaj przerwę',
    'pauseManage.confirmNextMonth': 'Zaplanować przerwę dla „{name}” od 1. dnia przyszłego miesiąca?',
    'pauseManage.confirmResume': 'Zakończyć przerwę „{name}”? Konto od razu wróci do pełnej pracy.',
    'pauseManage.confirmCancel': 'Odwołać zaplanowaną przerwę „{name}”?',
    'pauseManage.enabled': 'Przerwa zapisana.',
    'pauseManage.untilSaved': 'Planowany koniec zapisany.',
    'pauseManage.resumed': 'Przerwa zakończona.',
    'pauseManage.error': 'Nie udało się zmienić przerwy.',
    'pauseManage.unsentKsef': 'Faktury, które nie trafiły do KSeF: {liczba}. Termin przesłania biegnie także w przerwie, a firma wyśle je z listy faktur.',
    'pauseManage.confirmAnyway': 'Włączyć przerwę mimo to?',
    'pauseManage.confirmOpenReservations': 'Firma ma rezerwacje, których w przerwie nie obsłuży: trwające w dniu początku przerwy: {trwajace}, późniejsze: {nadchodzace}. W przerwie nie zapisze do nich wydania, zwrotu ani wpłaty na miejscu. Faktury, korekty i KSeF działają także w przerwie. Włączyć przerwę mimo to?',
    'superAdmin.filterResigned': 'Po rezygnacji',
    'superAdmin.statusResigned': 'Po rezygnacji, usunięcie od {od}',
    'superAdmin.statusResignScheduled': 'Rezygnacja od {od}',
    'superAdmin.resign': 'Rezygnacja',
    'superAdmin.resignTooltip': 'Rezygnacja: konto tylko do odczytu, po 30 dniach usunięcie danych',
    'superAdmin.confirmDeactivateResigned': 'Dezaktywować firmę po rezygnacji? Rezygnacja zostanie odwołana: firma straci logowanie i eksport danych, a jej dane nie zostaną usunięte po 30 dniach.',
    'superAdmin.deleteData': 'Usuń dane firmy',
    'superAdmin.deleteDataTooltip': 'Usuwa na zawsze wszystkie dane firmy po rezygnacji. Dostępne od dnia usunięcia, 30 dni po rezygnacji.',
    'superAdmin.deleteDataFrom': 'dostępne od {od}',
    'deleteResigned.title': 'Usuń dane firmy: {name}',
    'deleteResigned.intro': 'Rezygnacja trwa od {od}, a dane firmy można usunąć od {usuniecie}. Usunięcia nie da się cofnąć.',
    'deleteResigned.whatTitle': 'Zostanie usunięte na zawsze:',
    'deleteResigned.whatData': 'wszystkie dane firmy: klienci, rezerwacje, sprzęt, płatności, faktury i ich stan w KSeF, oferty, cenniki i ustawienia',
    'deleteResigned.whatUsers': 'konta pracowników razem z sesjami i historią logowań',
    'deleteResigned.whatFiles': 'pliki: zdjęcia stanu sprzętu, obrazki widgetu i wgrany wzór umowy',
    'deleteResigned.log': 'Zostaje tylko wpis w dzienniku: numer firmy, dzień rezygnacji, dzień usunięcia i konto, które usunęło dane.',
    'deleteResigned.backups': 'Kopie zapasowe zawierają te dane jeszcze do ok. 6 miesięcy, a kopia poza serwerem do ok. 17 dni dłużej. Z kopii ich nie przywracamy.',
    'deleteResigned.exportReminder': 'Przed usunięciem upewnij się, że firma o nim wie i pobrała eksport danych (administrator firmy: Profil, Eksport danych firmy). Faktury firma przechowuje sama. Ten przycisk nie wysyła firmie żadnego maila.',
    'deleteResigned.confirmLabel': 'Aby potwierdzić, wpisz nazwę firmy:',
    'deleteResigned.confirmHint': 'Wielkość liter ma znaczenie.',
    'deleteResigned.submit': 'Usuń dane na zawsze',
    'deleteResigned.submitting': 'Usuwam…',
    'deleteResigned.done': 'Dane firmy „{name}” zostały usunięte.',
    'deleteResigned.error.notResigned': 'Ta firma nie jest po rezygnacji, więc jej danych nie można usunąć. Rezygnacja mogła zostać odwołana. Lista została odświeżona.',
    'deleteResigned.error.notYet': 'Dane tej firmy można usunąć dopiero od {od}.',
    'deleteResigned.error.notYetNoDate': 'Dane tej firmy nie mogą jeszcze zostać usunięte. Lista została odświeżona.',
    'deleteResigned.error.ksefPending': 'Firma ma faktury do wysłania albo w drodze do KSeF: {liczba}. Dane można usunąć dopiero, gdy firma je wyśle z listy faktur.',
    'deleteResigned.error.nameMismatch': 'Wpisana nazwa nie zgadza się z nazwą firmy. Wpisz ją dokładnie, z wielkimi i małymi literami.',
    'deleteResigned.error.platformAccount': 'W tej firmie jest konto super-admina, więc jej danych nie można usunąć.',
    'deleteResigned.error.demo': 'To konto demo. Konta demo usuwa sprzątanie demo, nie ten przycisk.',
    'deleteResigned.error.conflict': 'Warunki usunięcia zmieniły się w międzyczasie. Lista została odświeżona, sprawdź ją i spróbuj ponownie.',
    'deleteResigned.error.notFound': 'Tej firmy już nie ma. Lista została odświeżona.',
    'deleteResigned.error.session': 'Sesja nie pozwala na tę operację. Wyloguj się i zaloguj ponownie z kodem uwierzytelniającym.',
    'deleteResigned.error.generic': 'Nie udało się usunąć danych firmy. Spróbuj ponownie za chwilę.',
    'deleteResigned.error.unknownOutcome': 'Nie wiadomo, czy dane zostały usunięte, bo nie przyszła odpowiedź serwera. Lista została odświeżona, sprawdź ją przed ponowną próbą.',
    'resignManage.title': 'Rezygnacja: {name}',
    'resignManage.explain': 'Od dnia rezygnacji firma loguje się, przegląda dane, pobiera eksport danych i obsługuje faktury oraz KSeF, a resztę zapisu, widget, przypomnienia i linki do zapłaty wyłączamy. Po 30 dniach dane firmy mogą zostać usunięte: automatycznie, po uprzedzeniu administratorów mailem (maile i usunięcie automatyczne działają dopiero po włączeniu zasady przechowywania danych na serwerze), albo ręcznie przyciskiem „Usuń dane firmy” na liście, bez maila. To nie jest dezaktywacja: firma nieaktywna nie ma logowania ani terminu usunięcia.',
    'resignManage.startLabel': 'Dzień rezygnacji',
    'resignManage.startToday': 'Od dziś',
    'resignManage.startDay': 'Od wybranego dnia',
    'resignManage.dayLabel': 'Dzień rezygnacji',
    'resignManage.todayOnly': 'Firma jest nieaktywna albo w trwającej przerwie, więc rezygnacja może zacząć się tylko od dziś.',
    'resignManage.newDayLabel': 'Nowy dzień rezygnacji',
    'resignManage.stateScheduled': 'Rezygnacja zaplanowana od {od}. Do tego dnia konto działa normalnie, ale nie przyjmie rezerwacji, która kończy się tego dnia albo później.',
    'resignManage.stateActive': 'Rezygnacja trwa od {od}. Dane firmy mogą zostać usunięte nie wcześniej niż {usuniecie}.',
    'resignManage.stateActiveNoDate': 'Rezygnacja trwa od {od}.',
    'resignManage.enable': 'Ustaw rezygnację',
    'resignManage.changeDay': 'Zmień dzień',
    'resignManage.startNow': 'Zacznij od dziś',
    'resignManage.cancel': 'Odwołaj rezygnację',
    'resignManage.confirmToday': 'Ustawić rezygnację „{name}” od dziś? Konto od razu będzie tylko do odczytu, a po 30 dniach dane mogą zostać usunięte.',
    'resignManage.confirmDay': 'Ustawić rezygnację „{name}” od {od}? Do tego dnia konto działa normalnie, ale nie przyjmie rezerwacji, która kończy się tego dnia albo później. Potem jest tylko do odczytu, a po 30 dniach dane mogą zostać usunięte.',
    'resignManage.confirmCancel': 'Odwołać rezygnację „{name}”? Konto od razu wróci do pełnej pracy jako aktywne.',
    'resignManage.saved': 'Rezygnacja zapisana.',
    'resignManage.cancelled': 'Rezygnacja odwołana.',
    'resignManage.error': 'Nie udało się zmienić rezygnacji.',
    'resignManage.unsentKsef': 'Faktury, które nie trafiły do KSeF: {liczba}. Termin przesłania biegnie dalej, a firma wyśle je z listy faktur.',
    'resignManage.confirmAnyway': 'Ustawić rezygnację mimo to?',
    'resignManage.pausePlanned': 'Firma ma przerwę zaplanowaną od {od}. Rezygnacja ją odwoła: do dnia rezygnacji konto działa normalnie, więc rezygnacja może zacząć się najpóźniej {od}.',
    'resignManage.pauseOngoing': 'Firma jest w przerwie od {od}. Rezygnacja zakończy przerwę i ją zastąpi.',
    'resignManage.confirmOpenReservations': 'Firma ma rezerwacje, których po rezygnacji nie obsłuży: trwające w dniu rezygnacji: {trwajace}, późniejsze: {nadchodzace}. Nie zapisze do nich wydania, zwrotu ani wpłaty na miejscu. Faktury, korekty i KSeF działają. Ustawić rezygnację mimo to?',
    'superAdmin.copy': 'Kopiuj',
    'superAdmin.saveChanges': 'Zapisz zmiany',

    // Faktury (lista, edytor, podgląd, KSeF) — U.16
    'invoices.title': 'Faktury',
    'invoices.new': 'Nowa faktura',
    'invoices.loading': 'Ładowanie faktur…',
    'invoices.loadError': 'Nie udało się wczytać faktur.',
    'invoices.nipLabel': 'NIP: {nip}',
    'invoices.filters.search': 'Szukaj',
    'invoices.filters.searchPlaceholder': 'Numer, nabywca, NIP…',
    'invoices.filters.docType': 'Typ dokumentu',
    'invoices.filters.allTypes': 'Wszystkie typy',
    'invoices.filters.paymentStatus': 'Status płatności',
    'invoices.filters.dateFrom': 'Od',
    'invoices.filters.dateTo': 'Do',
    'invoices.table.number': 'Numer',
    'invoices.subtitle': 'Faktury, proformy i korekty: wystawianie, rozliczenia i wysyłka do KSeF',
    'invoices.stats.outstanding': 'Do zapłaty · faktur: {count}',
    'invoices.stats.overdue': 'Po terminie · {amount}',
    'invoices.stats.overdueNone': 'Po terminie',
    'invoices.stats.thisMonth': 'Sprzedaż brutto w tym miesiącu',
    'invoices.paymentFilter.unpaid': 'Nieopłacone',
    'invoices.paymentFilter.partial': 'Częściowo opłacone',
    'invoices.paymentFilter.paid': 'Opłacone',
    'invoices.resultCount': 'Wyników: {count}',
    'invoices.emptyFiltered.title': 'Żadna faktura nie pasuje do filtrów',
    'invoices.emptyFiltered.description': 'Zmień kryteria albo wyczyść filtry, żeby zobaczyć wszystkie dokumenty.',
    'invoices.table.issued': 'Wystawiono',
    'invoices.table.due': 'Termin',
    'invoices.table.overdue': 'po terminie',
    'invoices.table.paidPart': 'zapłacono {amount}',
    'invoices.preview.settlement': 'Rozliczenie',
    'invoices.preview.invoiceTotal': 'Wartość brutto dokumentu',
    'invoices.preview.paymentProgress': 'Postęp płatności',
    'invoices.preview.paidAmount': 'Zapłacono {amount}',
    'invoices.preview.remainingAmount': 'Pozostało {amount}',
    'invoices.preview.paidInFull': 'Opłacona w całości',
    'invoices.preview.overdueSince': 'Termin płatności minął {date}',
    'invoices.preview.details': 'Szczegóły',
    'invoices.preview.correctionSection': 'Zmiany w dokumencie',
    'invoices.editor.fromReservation': 'Na podstawie rezerwacji #{id}',
    'invoices.editor.summaryTitle': 'Podsumowanie',
    'invoices.editor.editCompanyData': 'Edytuj dane firmy',
    'invoices.table.grossAmount': 'Kwota brutto',
    'invoices.table.payment': 'Płatność',
    'invoices.table.ksef': 'KSeF',
    'invoices.fields.issueDate': 'Data wystawienia',
    'invoices.fields.saleDate': 'Data sprzedaży',
    'invoices.fields.dueDate': 'Termin płatności',
    'invoices.fields.buyer': 'Nabywca',
    'invoices.fields.seller': 'Sprzedawca',
    'invoices.fields.paymentMethod': 'Sposób płatności',
    'invoices.fields.notes': 'Uwagi',
    'invoices.fields.paid': 'Zapłacono',
    'invoices.fields.totalDue': 'Do zapłaty',
    'invoices.fields.address': 'Adres',
    'invoices.fields.email': 'E-mail',
    'invoices.fields.phone': 'Telefon',
    'invoices.fields.nip': 'NIP',
    'invoices.fields.regon': 'REGON',
    'invoices.fields.buyerNameCompany': 'Nazwa firmy',
    'invoices.fields.buyerNamePrivate': 'Imię i nazwisko',
    'invoices.status.corrected': 'skorygowana',
    'invoices.status.draft': 'szkic',
    'invoices.docType.vat': 'Faktura VAT',
    'invoices.docType.proforma': 'Proforma',
    'invoices.docType.simplified': 'Faktura uproszczona',
    'invoices.docType.correction': 'Korekta',
    'invoices.docType.vatExempt': 'Faktura',
    'invoices.paymentStatus.unpaid': 'Nieopłacona',
    'invoices.paymentStatus.partial': 'Częściowo opłacona',
    'invoices.paymentStatus.paid': 'Opłacona',
    'invoices.paymentMethod.transfer': 'Przelew',
    'invoices.paymentMethod.cash': 'Gotówka',
    'invoices.paymentMethod.card': 'Karta',
    'invoices.paymentMethod.blik': 'BLIK',
    'invoices.paymentMethod.other': 'Inne',
    'invoices.ksefStatus.pending': 'Oczekuje',
    'invoices.ksefStatus.sent': 'Wysłano',
    'invoices.ksefStatus.accepted': 'Przyjęta',
    'invoices.ksefStatus.rejected': 'Odrzucona',
    'invoices.ksefStatus.error': 'Błąd',
    'invoices.ksefStatus.upoReceived': 'UPO odebrane',
    'invoices.ksef.send': 'Wyślij do KSeF',
    'invoices.ksef.sending': 'Wysyłanie…',
    'invoices.ksef.retry': 'Ponów wysyłkę',
    'invoices.ksef.downloadUpo': 'Pobierz UPO',
    'invoices.ksef.numberTooltip': 'Numer KSeF: {number}',
    'invoices.ksef.sendConfirmTitle': 'Wysłać do KSeF?',
    'invoices.ksef.sendConfirmMessage': 'Czy na pewno chcesz wysłać fakturę {number} do Krajowego Systemu e-Faktur?',
    'invoices.ksef.sendError': 'Nie udało się wysłać faktury do KSeF.',
    'invoices.ksef.upoError': 'Nie udało się pobrać UPO.',
    'invoices.ksef.sendPending': 'Faktura mogła już trafić do KSeF. Status sprawdzimy przy następnym otwarciu listy, nie wysyłaj jej ponownie.',
    'invoices.ksef.duplicateNote': 'Ta faktura jest już w KSeF. Sprawdź ją w Aplikacji Podatnika, nie wysyłaj ponownie.',
    'invoices.ksef.deliveryUnknownNote': 'Nie wiadomo, czy faktura dotarła do KSeF. Sprawdzamy to sami, nie wysyłaj jej ponownie. Jeśli nie dotarła, najpóźniej po 13 godzinach wysyłka zostanie odblokowana.',
    'invoices.ksef.otherEnvironmentNote': 'Stan z innego środowiska KSeF. W obecnym faktury jeszcze nie wysłano.',
    'invoices.ksef.prodEnvironmentNote': 'Faktura jest zgłoszona do produkcyjnego KSeF, więc nie wysyłamy jej do środowiska testowego.',
    'invoices.filters.ksefAttention': 'Nie trafiły do KSeF',
    'ksefUwaga.titleOne': '{count} faktura nie trafiła do KSeF',
    'ksefUwaga.titleFew': '{count} faktury nie trafiły do KSeF',
    'ksefUwaga.titleMany': '{count} faktur nie trafiło do KSeF',
    'ksefUwaga.titleOther': '{count} faktury nie trafiło do KSeF',
    'ksefUwaga.lead': 'Fakturę dla firmy trzeba przesłać do KSeF najpóźniej następnego dnia roboczego po wystawieniu. Wyślij je z listy faktur albo sprawdź przyczynę w szczegółach.',
    'ksefUwaga.overdue': 'Po terminie przesłania: {count}.',
    'ksefUwaga.dueToday': 'Termin przesłania mija dziś: {count}.',
    'ksefUwaga.show': 'Pokaż te faktury',
    'ksefUwaga.details': 'Szczegóły',
    'ksefUwaga.more': 'Pokazujemy {shown} najstarszych z {count}. Wszystkie zobaczysz po kliknięciu „Pokaż te faktury”.',
    'ksefUwaga.state.notSent': 'nie wysłano',
    'ksefUwaga.state.error': 'błąd wysyłki',
    'ksefUwaga.state.rejected': 'odrzucona przez KSeF',
    'ksefUwaga.state.waiting': 'czeka na odpowiedź KSeF',
    'ksefUwaga.state.duplicate': 'KSeF zgłasza duplikat',
    'ksefUwaga.issued': 'wystawiona {date}',
    'ksefUwaga.deadline': 'termin {date}',
    'ksefUwaga.deadlinePassed': 'termin minął {date}',
    'ksefUwaga.deadlineToday': 'termin mija dziś',
    'ksefUwaga.duplicateHint': 'Ta faktura jest już w KSeF. Sprawdź ją w Aplikacji Podatnika KSeF, nie wysyłaj ponownie.',
    'ksefUwaga.simplifiedHint': 'Faktury uproszczonej aplikacja nie wysyła do KSeF. Prześlij ją w Aplikacji Podatnika KSeF.',
    'ksefUwaga.waitingHint': 'Status sprawdzimy sami, nie wysyłaj jej ponownie.',
    'ksefUwaga.certExpired': 'Certyfikat KSeF wygasł {date}. Wysyłka faktur do KSeF nie działa, dopóki nie wgrasz nowego certyfikatu w Ustawieniach KSeF.',
    'ksefUwaga.certToday': 'Certyfikat KSeF wygasa dziś. Wygeneruj nowy w Aplikacji Podatnika KSeF i wgraj go w Ustawieniach KSeF.',
    'ksefUwaga.certTomorrow': 'Certyfikat KSeF wygasa jutro ({date}). Wygeneruj nowy w Aplikacji Podatnika KSeF i wgraj go w Ustawieniach KSeF.',
    'ksefUwaga.certSoon': 'Certyfikat KSeF wygasa {date}, za {count} dni. Nowy możesz wygenerować w Aplikacji Podatnika KSeF już teraz i wgrać go w Ustawieniach KSeF.',
    'ksefUwaga.tokenPassed': 'Tokeny KSeF przestały działać {date}. Przełącz metodę na certyfikat KSeF w Ustawieniach KSeF.',
    'ksefUwaga.tokenSoon': 'Według obecnych przepisów tokeny KSeF działają do {date}. Przed tym dniem przełącz metodę na certyfikat KSeF w Ustawieniach KSeF.',
    'ksefUwaga.openSettings': 'Ustawienia KSeF',
    'ksefSettings.prodSince': 'Pilnujemy faktur wystawionych od {date}, odkąd firma wysyła do produkcyjnego KSeF. Te, które nie trafią do KSeF, pokażemy na liście faktur i na stronie głównej.',
    'ksefSettings.alertEmailLabel': 'Wysyłaj administratorom maile o fakturach, które nie trafiły do KSeF, i o kończącym się certyfikacie',
    'ksefSettings.alertEmailHint': 'Najwyżej jeden mail dziennie, z numerami faktur i linkiem do listy, bez danych nabywców, oraz przypomnienia 30, 7 i 1 dzień przed końcem ważności certyfikatu. Dotyczy tylko produkcyjnego KSeF.',
    'invoices.pdf.download': 'Pobierz PDF',
    'invoices.pdf.downloadError': 'Nie udało się pobrać pliku PDF.',
    'invoices.pdf.busy': 'Za dużo dokumentów PDF naraz. Spróbuj ponownie za chwilę.',
    'invoices.pdf.retry': 'Spróbuj ponownie',
    'invoices.empty.title': 'Brak faktur',
    'invoices.empty.description': 'Nie wystawiono jeszcze żadnej faktury. Utwórz pierwszą, aby zacząć.',
    'invoices.newModal.title': 'Nowa faktura',
    'invoices.newModal.subtitle': 'Wybierz, jak chcesz utworzyć fakturę',
    'invoices.newModal.fromReservationTitle': 'Z rezerwacji',
    'invoices.newModal.fromReservationDescription': 'Wypełnij dane nabywcy i pozycje na podstawie istniejącej rezerwacji',
    'invoices.newModal.blankTitle': 'Od zera',
    'invoices.newModal.blankDescription': 'Wypełnij wszystkie dane ręcznie',
    'invoices.reservationModal.title': 'Wybierz rezerwację',
    'invoices.reservationModal.empty': 'Brak rezerwacji do wyboru.',
    'invoices.reservationModal.searchPlaceholder': 'Szukaj: klient, e-mail, telefon, nr rezerwacji lub sprzęt',
    'invoices.reservationModal.searchAria': 'Szukaj rezerwacji',
    'invoices.reservationModal.scopeAria': 'Które rezerwacje pokazać',
    'invoices.reservationModal.scopeOpen': 'Do zafakturowania',
    'invoices.reservationModal.scopeAll': 'Wszystkie',
    'invoices.reservationModal.periodAria': 'Okres wypożyczenia',
    'invoices.reservationModal.periodAll': 'Cały okres',
    'invoices.reservationModal.periodThisMonth': 'Ten miesiąc',
    'invoices.reservationModal.periodLastMonth': 'Poprzedni miesiąc',
    'invoices.reservationModal.periodLast3Months': 'Ostatnie 3 miesiące',
    'invoices.reservationModal.countOne': '{count} rezerwacja',
    'invoices.reservationModal.countFew': '{count} rezerwacje',
    'invoices.reservationModal.countMany': '{count} rezerwacji',
    'invoices.reservationModal.loading': 'Wczytywanie rezerwacji…',
    'invoices.reservationModal.loadError': 'Nie udało się wczytać rezerwacji.',
    'invoices.reservationModal.loadMore': 'Pokaż starsze ({count})',
    'invoices.reservationModal.noClient': 'Bez przypisanego klienta',
    'invoices.reservationModal.invoicedBadge': 'Faktura {number}',
    'invoices.reservationModal.proformaBadge': 'Proforma {number}',
    'invoices.reservationModal.canceledBadge': 'Anulowana',
    'invoices.reservationModal.allInvoicedTitle': 'Wszystko zafakturowane',
    'invoices.reservationModal.allInvoicedDescription': 'Każda rezerwacja ma już fakturę albo została anulowana. Pokaż wszystkie, żeby wystawić kolejny dokument.',
    'invoices.reservationModal.noMatchTitle': 'Żadna rezerwacja nie pasuje',
    'invoices.reservationModal.noMatchDescription': 'Sprawdź pisownię albo wybierz dłuższy okres.',
    'invoices.reservationModal.showAll': 'Pokaż wszystkie',
    'invoices.reservationModal.clearFilters': 'Wyczyść filtry',
    'invoices.editor.titleNew': 'Nowa faktura',
    'invoices.editor.titleEdit': 'Edycja faktury',
    'invoices.editor.backToList': 'Wróć do listy',
    'invoices.editor.loadError': 'Nie udało się wczytać danych.',
    'invoices.editor.saveError': 'Nie udało się zapisać faktury.',
    'invoices.editor.saveDraft': 'Zapisz jako szkic',
    'invoices.editor.reservationNotFound': 'Nie znaleziono rezerwacji.',
    'invoices.editor.sellerMissing': 'Uzupełnij dane firmy w Ustawieniach, aby wystawiać faktury.',
    'invoices.editor.bankAccountMissing': 'Brak numeru konta bankowego firmy.',
    'invoices.editor.bankAccountLabel': 'Konto: {account}',
    'invoices.editor.completeCompanyData': 'Uzupełnij dane firmy',
    'invoices.editor.orChooseOtherMethod': 'lub wybierz inny sposób płatności.',
    'invoices.editor.clientSearchPlaceholder': 'Szukaj klienta po imieniu, nazwisku lub e-mailu…',
    'invoices.editor.selectedClient': 'Wybrano klienta #{id}',
    'invoices.editor.changeClient': 'Zmień',
    'invoices.editor.issueGeneric': 'Wystaw',
    'invoices.editor.issueProforma': 'Wystaw proformę',
    'invoices.editor.issueByType.VAT': 'Wystaw fakturę VAT',
    'invoices.editor.issueByType.SIMPLIFIED': 'Wystaw fakturę uproszczoną',
    'invoices.editor.issueByType.PROFORMA': 'Wystaw proformę',
    'invoices.editor.addItem': '+ Dodaj pozycję',
    'invoices.editor.grossItemsHint': 'Pozycje z rezerwacji mają kwotę brutto równą kwocie rezerwacji, a netto i VAT są z niej wyliczone. Zmiana ceny netto przelicza pozycję od netto.',
    'invoices.editor.removeItem': 'Usuń pozycję',
    'invoices.editor.itemNamePlaceholder': 'Nazwa towaru/usługi',
    'invoices.editor.notesPlaceholder': 'Dodatkowe uwagi na fakturze…',
    'invoices.editor.buyerType.private': 'Osoba prywatna',
    'invoices.editor.buyerType.company': 'Firma',
    'invoices.editor.sections.header': 'Nagłówek dokumentu',
    'invoices.editor.sections.parties': 'Sprzedawca i nabywca',
    'invoices.editor.sections.items': 'Pozycje',
    'invoices.editor.table.lp': 'Lp.',
    'invoices.editor.table.name': 'Nazwa',
    'invoices.editor.table.unit': 'J.m.',
    'invoices.editor.table.quantity': 'Ilość',
    'invoices.editor.table.unitPriceNet': 'Cena netto',
    'invoices.editor.table.vat': 'VAT',
    'invoices.editor.table.net': 'Netto',
    'invoices.editor.table.gross': 'Brutto',
    'invoices.editor.summary.vatRateNet': 'Netto ({rate})',
    'invoices.editor.summary.totalNet': 'Razem netto',
    'invoices.editor.summary.totalVat': 'Razem VAT',
    'invoices.editor.summary.totalGross': 'Razem brutto',
    'invoices.editor.summary.total': 'Razem',
    'invoices.editor.summary.exemptSale': 'Sprzedaż zwolniona z VAT',
    'invoices.editor.summary.exemptNet': 'Zwolnione (zw)',
    'invoices.editor.table.unitPrice': 'Cena',
    'invoices.editor.table.value': 'Wartość',
    'invoices.editor.vatExemptCode': 'zw',
    'invoices.editor.notApplicable': 'nie dotyczy',
    'invoices.editor.zeroRateHint': '0% to stawka krajowa, a nie zwolnienie z VAT. Sprzedaż zwolnioną oznacz stawką „zw”.',
    'invoices.editor.exemptionBasis': 'Podstawa zwolnienia z VAT',
    'invoices.editor.exemptionBasisPh': 'np. art. 113 ust. 1 ustawy o VAT',
    'invoices.editor.exemptionBasisHint': 'Trafia na fakturę i do KSeF. Domyślnie ta z Danych firmy.',
    'invoices.editor.issueExempt': 'Wystaw fakturę',
    'invoices.editor.validation.exemptTaxedItem': 'Firma zwolniona z VAT wystawia tylko pozycje „zw”. Zmień stawki pozycji albo status VAT w Danych firmy.',
    'invoices.editor.validation.exemptionBasisRequired': 'Pozycja zwolniona z VAT („zw”) wymaga podstawy zwolnienia.',
    'invoices.editor.validation.exemptionBasisIncomplete': 'Uzupełnij podstawę zwolnienia: w miejscu „…” wpisz numer punktu.',
    'invoices.editor.validation.buyerNameRequired': 'Podaj nazwę/imię i nazwisko nabywcy.',
    'invoices.editor.validation.nipRequired': 'Podaj NIP nabywcy.',
    'invoices.editor.validation.sellerRequired': 'Uzupełnij NIP i adres firmy w Ustawieniach → Dane firmy, aby wystawić fakturę.',
    'invoices.editor.validation.itemsRequired': 'Dodaj co najmniej jedną pozycję.',
    'invoices.editor.validation.itemNameRequired': 'Podaj nazwę każdej pozycji.',
    'invoices.preview.notFound': 'Nie znaleziono faktury.',
    'invoices.preview.backToList': 'Wróć do listy',
    'invoices.preview.downloadPdf': 'Pobierz PDF',
    'invoices.preview.sendEmail': 'Wyślij e-mailem',
    'invoices.preview.registerPayment': 'Zarejestruj płatność',
    'invoices.preview.issueCorrection': 'Wystaw korektę',
    'invoices.preview.correctedBadge': 'skorygowana',
    'invoices.preview.draftBadge': 'szkic',
    'invoices.preview.noBuyerEmail': 'Nabywca nie ma podanego adresu e-mail.',
    'invoices.preview.sendEmailConfirmTitle': 'Wysłać fakturę e-mailem?',
    'invoices.preview.sendEmailConfirmMessage': 'Faktura zostanie wysłana na adres {email}.',
    'invoices.preview.actionError': 'Coś poszło nie tak: {message}',
    'invoices.preview.deleteConfirmTitle': 'Usunąć fakturę?',
    'invoices.preview.deleteConfirmMessage': 'Tej operacji nie można cofnąć.',
    'invoices.preview.vatLockedBanner': 'Wystawionej faktury VAT nie można edytować ani usunąć. Zmiany wprowadza się korektą.',
    'invoices.preview.pdfPreviewTitle': 'Podgląd faktury PDF',
    'invoices.preview.generatingPdf': 'Generowanie podglądu PDF…',
    'invoices.preview.paymentModalTitle': 'Zarejestruj płatność',
    'invoices.preview.paymentModalInvoiceAmount': 'Kwota faktury: {amount} · zapłacono dotąd: {paid} · pozostało: {remaining}',
    'invoices.preview.paymentModalAmountLabel': 'Kwota wpłaty',
    'invoices.preview.savePayment': 'Zapisz płatność',
    'invoices.preview.paymentAmountInvalid': 'Podaj kwotę wpłaty większą od zera.',
    'invoices.preview.correctionNoPayment': 'Korekty nie rozlicza się wpłatą, bo zmienia ona kwotę faktury, którą koryguje.',
    'invoices.preview.correctModalTitle': 'Wystaw korektę',
    'invoices.preview.correctModalDescription': 'Korekta zeruje wszystkie pozycje faktury pierwotnej (storno) i jest wystawiana od razu, więc potem nie da się jej edytować. Aby zmienić tylko część pozycji, po korekcie wystaw nową fakturę z poprawnymi danymi. Przy włączonej automatycznej wysyłce korekta trafi też do nabywcy e-mailem i do KSeF.',
    'invoices.preview.correctReasonLabel': 'Przyczyna korekty',
    'invoices.preview.correctReasonPlaceholder': 'Np. zwrot sprzętu, pomyłka w cenie…',
    'invoices.preview.correctReasonRequired': 'Podaj przyczynę korekty.',
    'invoices.preview.creating': 'Tworzenie…',
    'invoices.preview.issueCorrectionSubmit': 'Wystaw korektę',

    // Płatności — U.16
    'payments.title': 'Płatności',
    'payments.subtitle': 'Wpłaty klientów: kto, ile, kiedy i jakim sposobem',
    'payments.statPaidLabel': 'Zebrano ({period})',
    'payments.statPendingLabel': 'Oczekujące',
    'payments.statRowsLabel': 'Wyświetlone wiersze',
    'payments.periodSelected': 'wybrany okres',
    'payments.periodTotal': 'łącznie',
    'payments.paidCountOne': '1 wpłata',
    'payments.paidCountMany': '{count} wpłat',
    'payments.paidCountFew': '{count} wpłaty',
    'payments.adminOnly': 'Rejestr wpłat jest dostępny dla administratora firmy. Wpłaty konkretnej rezerwacji widzisz w jej szczegółach w Kalendarzu.',
    'payments.status.reversed': 'Cofnięty wpis',
    'payments.reversedAt': 'Cofnięto {date}: pieniędzy nie przyjęto',
    'payments.reversedNote': 'Wpis cofnięty: pieniędzy nie przyjęto',
    'payments.reservationCancelled': 'Rezerwacja anulowana',
    'payments.paidAfterCancel': 'Wpłata po anulowaniu rezerwacji: do zwrotu',
    'payments.depositAfterCancel': 'Kaucja zablokowana po anulowaniu rezerwacji: zwolnij blokadę',
    'payments.secondDeposit': 'Druga kaucja przy tej rezerwacji: zwolnij blokadę',
    'payments.pendingHint': 'czekają na klienta',
    'payments.afterFilters': 'po filtrach',
    'payments.recentPayments': 'ostatnie',
    'payments.filterDateFrom': 'Od',
    'payments.filterDateTo': 'Do',
    'payments.filterClientLabel': 'Klient',
    'payments.filterClientPlaceholder': 'Szukaj po nazwisku lub e-mailu…',
    'payments.statusFilter.paid': 'Opłacone',
    'payments.statusFilter.pending': 'Oczekujące',
    'payments.statusFilter.failed': 'Nieudane',
    'payments.statusFilter.refunded': 'Zwrócone',
    'payments.status.paid': 'Opłacona',
    'payments.status.pending': 'Oczekująca',
    'payments.status.failed': 'Nieudana',
    'payments.status.refunded': 'Zwrócona',
    'payments.status.cancelled': 'Anulowana',
    'payments.status.partiallyRefunded': 'Częściowo zwrócona',
    'payments.status.authorized': 'Autoryzowana',
    'payments.status.captured': 'Zabezpieczona',
    'payments.status.released': 'Zwolniona',
    'payments.type.deposit': 'Kaucja',
    'payments.type.advance': 'Zaliczka',
    'payments.type.balance': 'Dopłata',
    'payments.methodCash': 'Gotówka',
    'payments.methodTransfer': 'Przelew',
    'payments.methodCard': 'Karta (terminal)',
    'payments.methodOnline': 'Online',
    'payments.filterMethod': 'Sposób zapłaty',
    'paymentDeadline.toggle': 'Anuluj, jeśli klient nie wpłaci do',
    'paymentDeadline.hint': 'Klient zobaczy termin w wiadomości z linkiem i dostanie jedno przypomnienie przed terminem.',
    'paymentDeadline.hintNoEmail': 'Klient nie ma adresu e-mail, więc nie dostanie przypomnienia. Termin jest w tekście do skopiowania razem z linkiem.',
    'paymentDeadline.invalid': 'Wybierz termin co najmniej godzinę od teraz, najpóźniej o 22:00 dnia przed rozpoczęciem rezerwacji (najwyżej 30 dni).',
    'paymentDeadline.noRoom': 'Rezerwacja zaczyna się zbyt szybko, żeby ustawić termin wpłaty.',
    'paymentDeadline.premium': 'Automatyczne anulowanie nieopłaconych rezerwacji jest w planie Premium.',
    'paymentDeadline.infoTitle': 'Termin wpłaty zaliczki: {date}',
    'paymentDeadline.info': 'Bez wpłaty do tego terminu rezerwacja zostanie anulowana automatycznie, a sprzęt zwolniony. Klient dostanie przypomnienie przed terminem.',
    'paymentDeadline.infoNoEmail': 'Bez wpłaty do tego terminu rezerwacja zostanie anulowana automatycznie, a sprzęt zwolniony. Klient nie ma adresu e-mail, więc nie dostanie przypomnienia.',
    'paymentDeadline.removedByLink': 'Termin wpłaty minął albo zaraz mija, więc nowy link go usunął. Rezerwacja nie zostanie anulowana automatycznie.',
    'paymentDeadline.removedByLinkWidget': 'Termin wpłaty minął albo zaraz mija, więc nowy link go usunął. Rezerwacja z widgetu wraca do jego zasad: bez wpłaty klient dostanie przypomnienie, a około {hours} godz. po nim rezerwacja zostanie anulowana automatycznie.',
    'paymentDeadline.droppedNoTimeWidget': 'Termin wpłaty rezerwacji nr {id} usunięty: przypomnienie nie zdążyło przed dniem rozpoczęcia, więc klient nie miałby czasu na wpłatę. Rezerwacja z widgetu wraca do jego zasad: bez wpłaty klient dostanie przypomnienie, a około {hours} godz. po nim rezerwacja zostanie anulowana automatycznie.',
    'paymentDeadline.droppedNoTime': 'Termin wpłaty rezerwacji nr {id} usunięty: przypomnienie nie zdążyło przed dniem rozpoczęcia, więc klient nie miałby czasu na wpłatę. Rezerwacja zostaje.',
    'paymentDeadline.editNote': 'Zapis zmienionych dat albo kwoty zaliczki usunie termin wpłaty.',
    'paymentDeadline.remove': 'Usuń termin',
    'paymentDeadline.removing': 'Usuwanie…',
    'paymentDeadline.removeConfirmTitle': 'Usunąć termin wpłaty?',
    'paymentDeadline.removeConfirmMessage': 'Rezerwacja nie zostanie anulowana automatycznie, a klient nie dostanie przypomnienia o terminie.',
    'paymentDeadline.removeConfirmMessageWidget': 'Rezerwacja z widgetu wraca do jego zasad: bez wpłaty klient dostanie przypomnienie, a około {hours} godz. po nim rezerwacja zostanie anulowana automatycznie.',
    'paymentDeadline.removed': 'Termin wpłaty usunięty.',
    'paymentDeadline.removeError': 'Nie udało się usunąć terminu wpłaty.',
    'paymentSettings.deadlineSectionTitle': 'Termin wpłaty zaliczki',
    'paymentSettings.deadlineSectionHint': 'Domyślny czas na wpłatę, gdy przy linku do zaliczki zaznaczysz „Anuluj, jeśli klient nie wpłaci do”. Termin można zmienić przy każdej rezerwacji.',
    'paymentSettings.deadlinePremium': 'Termin wpłaty z automatycznym anulowaniem nieopłaconych rezerwacji jest w planie Premium.',
    'paymentSettings.deadlineRange': 'Podaj liczbę godzin od {min} do {max}.',
    'paymentSettings.deadlineSaved': 'Zapisano: domyślnie {hours} godz. na wpłatę.',
    'payments.tableClient': 'Klient',
    'payments.tableSource': 'Źródło',
    'payments.tablePaidAt': 'Data wpłaty',
    'payments.noClientData': 'Brak danych klienta',
    'payments.noSource': '—',
    'payments.reservationRef': 'Rezerwacja #{id}',
    'payments.offerRef': 'Oferta #{seq}',
    'payments.refundedAmount': 'Zwrócono: {amount}',
    'payments.overpayment': 'Nadpłata: {amount}',
    'payments.refundAction': 'Zwróć',
    'payments.reverseAction': 'Cofnij wpis',
    'payments.cancelRequestAction': 'Anuluj prośbę',
    'payments.blockLinkAction': 'Zablokuj link',
    'payments.payLinkLabel': 'Link do płatności:',
    'payments.payLinkHint': 'Kliknij, aby zaznaczyć cały adres',
    'payments.refundPrompt': 'Kwota zwrotu (maks. {max} zł)',
    'payments.refundInvalidAmount': 'Nieprawidłowa kwota zwrotu (maks. {max} zł).',
    'payments.refundError': 'Nie udało się wykonać zwrotu.',
    'payments.reverseError': 'Nie udało się cofnąć wpisu.',
    'payments.cancelRequestError': 'Nie udało się anulować prośby.',
    'payments.confirmRefundTitle': 'Zwrócić płatność?',
    'payments.confirmRefundMessage': 'Zwrócisz {amount} klientowi {client}.',
    'payments.confirmReverseTitle': 'Cofnąć wpis?',
    'payments.confirmReverseMessage': 'Cofniesz wpis {amount} ({method}).',
    'payments.confirmCancelTitle': 'Anulować prośbę?',
    'payments.confirmCancelMessage': 'Prośba o płatność na kwotę {amount} zostanie anulowana.',
    'payments.emptyNoneTitle': 'Brak płatności',
    'payments.emptyNone': 'Nie zarejestrowano jeszcze żadnej płatności.',
    'payments.emptyFilteredTitle': 'Brak wyników',
    'payments.emptyFiltered': 'Żadna płatność nie pasuje do wybranych filtrów.',

    // Profil — nagłówki grup kart (U.16)
    'profile.group.account': 'Konto',
    'profile.group.company': 'Firma',
    'profile.group.sales': 'Sprzedaż',
    'profile.group.integrations': 'Integracje',

    // Logowanie (U.16)
    'login.tagline': 'Zarządzanie wypożyczalnią sprzętu',
    'login.heading': 'Zaloguj się',
    'login.subtitle': 'Wprowadź dane, aby uzyskać dostęp do panelu',
    'login.usernamePlaceholder': 'Login',
    'login.passwordPlaceholder': 'Hasło',
    'login.submitting': 'Logowanie…',
    'login.submit': 'Zaloguj się',
    'login.forgotPassword': 'Nie pamiętasz hasła?',
    'login.allFieldsRequired': 'Wypełnij wszystkie pola.',
    'login.tooManyAttempts': 'Zbyt wiele prób logowania. Spróbuj ponownie później.',
    'login.genericError': 'Nieprawidłowy login lub hasło.',
    'login.connectionError': 'Błąd połączenia z serwerem.',
    'login.success': 'Zalogowano pomyślnie.',
    'login.resetTitle': 'Reset hasła',
    'login.resetDescription': 'Podaj adres e-mail przypisany do konta, a wyślemy na niego link do ustawienia nowego hasła.',
    'login.resetEmailPlaceholder': 'Adres e-mail',
    'login.resetSentDefault': 'Jeśli podany adres e-mail istnieje w systemie, wysłaliśmy na niego link do resetu hasła.',
    'login.resetError': 'Nie udało się wysłać linku do resetu hasła.',
    'login.resetSubmitting': 'Wysyłanie…',
    'login.resetSubmit': 'Wyślij link resetujący',

    // Dodawanie użytkownika — polityka hasła i stany formularza (U.16)
    'addUser.demoDisabled': 'Niedostępne w trybie demo',
    'addUser.formIncompleteHint': 'Uzupełnij wymagane pola formularza',
    'addUser.passwordMinLength': 'Co najmniej {min} znaków',
    'addUser.passwordUppercase': 'Wielka litera',
    'addUser.passwordLowercase': 'Mała litera',
    'addUser.passwordDigit': 'Cyfra',
    'addUser.passwordStrengthGood': 'Wystarczająca siła hasła',

    // Edytor konstruktora umowy — pasek narzędzi RTE (U.16)
    'contracts.editor.fontDefault': 'Domyślny',
    'contracts.editor.fontFamily': 'Krój czcionki',
    'contracts.editor.fontSize': 'Rozmiar czcionki',
    'contracts.editor.equipmentPlaceholder': 'Tabela sprzętu',
    'contracts.editor.logoPlaceholder': 'Logo firmy',
    'contracts.editor.linkPrompt': 'Podaj adres URL',
    'contracts.editor.bold': 'Pogrubienie',
    'contracts.editor.italic': 'Kursywa',
    'contracts.editor.underline': 'Podkreślenie',
    'contracts.editor.strike': 'Przekreślenie',
    'contracts.editor.heading': 'Nagłówek',
    'contracts.editor.bulletList': 'Lista punktowana',
    'contracts.editor.orderedList': 'Lista numerowana',
    'contracts.editor.alignLeft': 'Wyrównaj do lewej',
    'contracts.editor.alignCenter': 'Wyśrodkuj',
    'contracts.editor.alignRight': 'Wyrównaj do prawej',
    'contracts.editor.link': 'Wstaw link',

    // Kalendarz — konflikt terminów bez daty (U.16)
    'calendar.noDate': 'brak daty',

    // ── P8.1e (6/6): i18n konstruktora umowy (tresc umowy CELOWO zostaje po polsku) ──
    'contractBuilder.addSection': 'Dodaj sekcję',
    'contractBuilder.advancedToggle': 'Pokaż/ukryj opcje zaawansowane (przesuwanie, wyrównanie, usuwanie sekcji)',
    'contractBuilder.allFields': 'Wszystkie dostępne pola',
    'contractBuilder.autoSaveError': 'Nie udało się zapisać automatycznie. Zapisz szkic ręcznie.',
    'contractBuilder.bannerFillCompany': 'Uzupełnij Dane firmy',
    'contractBuilder.bannerIncomplete': 'Niekompletne dane firmy',
    'contractBuilder.bannerLoadFailed': 'Nie udało się pobrać danych firmy',
    'contractBuilder.bannerLoadFailedBody': 'Podgląd pokazuje puste pola w miejscach danych firmy. Odśwież stronę albo sprawdź Dane firmy.',
    'contractBuilder.bannerSettingsAction': 'Dane firmy',
    'contractBuilder.blockContent': 'Treść bloku',
    'contractBuilder.blockHeading': 'Nagłówek bloku',
    'contractBuilder.catClient': 'Dane Klienta',
    'contractBuilder.catContract': 'Umowa',
    'contractBuilder.catEquipment': 'Sprzęt',
    'contractBuilder.catFinance': 'Finanse',
    'contractBuilder.catOrganization': 'Organizacja',
    'contractBuilder.contentPanel': 'Treść umowy',
    'contractBuilder.contractSettings': 'Dane firmy',
    'contractBuilder.deleteError': 'Błąd usuwania: {msg}',
    'contractBuilder.deleteSection': 'Usuń sekcję',
    'contractBuilder.deleteSectionTitle': 'Czy na pewno chcesz usunąć sekcję „{name}”?',
    'contractBuilder.deleteVersionTitle': 'Usuń tę wersję z historii',
    'contractBuilder.deleting': 'Usuwanie...',
    'contractBuilder.documentLook': 'Wygląd dokumentu',
    'contractBuilder.downloadPdf': 'Pobierz PDF',
    'contractBuilder.downloading': 'Pobieranie...',
    'contractBuilder.errorPrefix': 'Błąd: {msg}',
    'contractBuilder.fontSize': 'Wielkość pisma',
    'contractBuilder.generating': 'Generowanie...',
    'contractBuilder.headingAlignGroup': 'Wyrównanie nagłówka sekcji',
    'contractBuilder.headingCenter': 'Nagłówek do środka',
    'contractBuilder.checkBeforePublish': 'Sprawdź przed publikacją',
    'contractBuilder.dragToReorder': 'Przeciągnij, aby zmienić kolejność',
    'contractBuilder.pdfFrameTitle': 'Podgląd PDF umowy',
    'contractBuilder.headingLeft': 'Nagłówek do lewej',
    'contractBuilder.headingRight': 'Nagłówek do prawej',
    'contractBuilder.history': 'Historia ({count})',
    'contractBuilder.historyHead': 'Poprzednie wersje: {count}',
    'contractBuilder.importDisclosure': 'Masz już własną umowę? Zaimportuj jej treść',
    'contractBuilder.importEmpty': 'Wklej treść umowy do importu.',
    'contractBuilder.importError': 'Błąd importu treści umowy.',
    'contractBuilder.importLabel': 'Wklej treść umowy (TXT)',
    'contractBuilder.importNoSections': 'Nie udało się utworzyć sekcji z podanego tekstu.',
    'contractBuilder.importPartial': 'Zaimportowano treść, ale część pól nie została rozpoznana',
    'contractBuilder.importPlaceholder': 'Wklej pełną treść umowy. System automatycznie podzieli ją na sekcje i spróbuje rozpoznać pola.',
    'contractBuilder.importSubmit': 'Importuj treść do kreatora',
    'contractBuilder.imported': 'Zaimportowano treść umowy. Sprawdź sekcje i zapisz szkic.',
    'contractBuilder.importing': 'Importowanie...',
    'contractBuilder.intro': 'Układasz treść umowy, a podgląd od razu pokazuje, jak wyjdzie na papierze. Pola takie jak „Imię klienta” system podstawia sam przy generowaniu umowy dla rezerwacji.',
    'contractBuilder.irreversible': 'Tej operacji nie można cofnąć.',
    'contractBuilder.logoMissing': 'Brak. Dodaj logo w „Dane firmy”.',
    'contractBuilder.logoSet': 'Ustawione w „Dane firmy”.',
    'contractBuilder.modeAdvanced': 'Zaawansowane',
    'contractBuilder.modeSimple': 'Widok prosty',
    'contractBuilder.moveDown': 'Przesuń sekcję w dół',
    'contractBuilder.moveUp': 'Przesuń sekcję w górę',
    'contractBuilder.noWarnings': 'Brak ostrzeżeń. Szablon gotowy do publikacji.',
    'contractBuilder.pdfDownloadError': 'Błąd podczas pobierania PDF: {msg}',
    'contractBuilder.pdfModalHint': 'Podgląd PDF: tu widzisz podział na strony (1:1 jak wyjdzie)',
    'contractBuilder.pdfPreview': 'Podgląd PDF',
    'contractBuilder.pdfPreviewError': 'Błąd podczas generowania podglądu PDF: {msg}',
    'contractBuilder.pickFieldBelow': '(wybierz pole z listy poniżej)',
    'contractBuilder.presetNoDeposit': 'Bez kaucji',
    'contractBuilder.presetStandardNotes': 'Standard + notatki',
    'contractBuilder.previewPanel': 'Podgląd umowy',
    'contractBuilder.redo': 'Powtórz',
    'contractBuilder.redoTitle': 'Powtórz (Ctrl+Y)',
    'contractBuilder.restore': 'Przywróć',
    'contractBuilder.restoreTitle': 'Wczytaj tę wersję do edytora',
    'contractBuilder.saveDraft': 'Zapisz szkic',
    'contractBuilder.saved': 'Szablon umowy został zapisany pomyślnie!',
    'contractBuilder.sectionAdded': 'Dodano nową sekcję w bieżącym kroku.',
    'contractBuilder.startHint': 'Wybór wzoru podmienia wszystkie sekcje. Potem dopasujesz treść po swojemu.',
    'contractBuilder.startTitle': 'Zacznij od gotowego wzoru',
    'contractBuilder.statusDescDraft': 'Szablon nie jest jeszcze aktywny. Opublikuj, aby używać w produkcji.',
    'contractBuilder.statusDescEmpty': 'Zacznij od gotowego wzoru albo zaimportuj treść swojej umowy.',
    'contractBuilder.statusDescPublished': 'Nowe umowy będą używać tego szablonu.',
    'contractBuilder.statusDraft': 'Szkic',
    'contractBuilder.statusEmpty': 'Brak szablonu',
    'contractBuilder.readOnlyNotice': 'Szablon umowy zmienia administrator firmy. Możesz go przeglądać i pobrać podgląd PDF.',
    'contractBuilder.statusDraftOverPublished': 'Szkic (obowiązuje v{n})',
    'contractBuilder.statusDescDraftOverPublished': 'Klienci nadal dostają opublikowaną wersję v{n}. Opublikuj, żeby zmiany trafiły do nowych umów.',
    'contractBuilder.templateLoadFailed': 'Nie udało się wczytać szablonu umowy. Odśwież stronę przed edycją: zmiany nie będą zapisywane, żeby nie nadpisać zapisanego szkicu.',
    'contractBuilder.step1': 'Krok 1: Start i klient',
    'contractBuilder.step1Helper': 'Uzupełnij nagłówek umowy i dane klienta. To najczęściej edytowana część.',
    'contractBuilder.step2': 'Krok 2: Sprzęt i kwoty',
    'contractBuilder.step2Helper': 'Doprecyzuj opis sprzętu, terminy oraz informacje finansowe.',
    'contractBuilder.step3Helper': 'Dodaj podpisy i dodatkowe zapisy. Tu trafiają też niestandardowe sekcje.',
    'contractBuilder.tableFontSize': 'Pismo w tabeli sprzętu',
    'contractBuilder.undoTitle': 'Cofnij (Ctrl+Z)',
    'contractBuilder.untitled': '(bez tytułu)',
    'contractBuilder.varAddress': 'Adres klienta',
    'contractBuilder.varAdvance': 'Zaliczka',
    'contractBuilder.varAmountDue': 'Do zapłaty',
    'contractBuilder.varBankAccount': 'Konto bankowe',
    'contractBuilder.varBankName': 'Nazwa banku',
    'contractBuilder.varDays': 'Liczba dni wypożyczenia',
    'contractBuilder.varDeposit': 'Kaucja',
    'contractBuilder.varEmail': 'Email klienta',
    'contractBuilder.varEndDate': 'Data zakończenia',
    'contractBuilder.varEquipmentTable': 'Tabela ze sprzętem (auto-generowana)',
    'contractBuilder.varFirstName': 'Imię klienta',
    'contractBuilder.varIdNumber': 'Numer dowodu klienta',
    'contractBuilder.varClientCompanyName': 'Nazwa firmy klienta',
    'contractBuilder.varClientNip': 'NIP klienta',
    'contractBuilder.varClientCompanyLine': 'Dane firmy klienta (cała linia, znika u klienta prywatnego)',
    'contractBuilder.varLastName': 'Nazwisko klienta',
    'contractBuilder.varOrgAddress': 'Adres organizacji',
    'contractBuilder.varOrgName': 'Nazwa organizacji',
    'contractBuilder.varOrgPhone': 'Telefon organizacji',
    'contractBuilder.varPhone': 'Telefon klienta',
    'contractBuilder.varStartDate': 'Data rozpoczęcia',
    'contractBuilder.varTotalPrice': 'Cena całkowita',
    'contractBuilder.varsLabel': 'Pola do wstawienia w treść',
    'contractBuilder.versionDeleteTitle': 'Usunąć wersję v{n} z historii?',
    'contractBuilder.versionDeleted': 'Usunięto wersję v{n} z historii.',
    'contractBuilder.versionLoadBody': 'Zastąpi obecnie edytowaną treść. Nic nie publikujemy. Gdy będzie dobrze, kliknij „Publikuj szablon”, żeby ją uaktywnić.',
    'contractBuilder.versionLoadFailed': 'Nie udało się wczytać wersji v{n}.',
    'contractBuilder.versionLoadTitle': 'Wczytać wersję v{n}?',
    'contractBuilder.versionLoaded': 'Wczytano wersję v{n} do edytora. Sprawdź i kliknij „Publikuj szablon”, aby ją uaktywnić.',
    'contractBuilder.warnEmptySection': 'Sekcja „{name}” ma pustą treść.',
    'contractBuilder.warnNoSignatures': 'Brak sekcji podpisów: dodaj sekcję o tytule zaczynającym się od „Podpis” albo z linią ________ do podpisu.',
    'contractBuilder.yesPublish': 'Tak, publikuj',
    'contractBuilder.pageTitle': 'Konstruktor umowy',
    'contractBuilder.autoSavedAt': 'Zapisano automatycznie {time}',
    'contractBuilder.missingLabel': 'Brakuje:',
    'contractBuilder.missingCompanyEffect': 'Podgląd i generowane umowy będą miały w tych miejscach puste pola.',
    'contractBuilder.untitledInContract': '(bez tytułu w umowie)',
    'contractBuilder.unknownVarsTitle': 'Nieznane pola: {list}',
    'contractBuilder.unknownVarsBadge': 'Nieznane pola: {n}',
    'contractBuilder.showLess': 'Pokaż mniej',
    'contractBuilder.showAllFields': 'Pokaż wszystkie pola',
    'contractBuilder.sheetSplitNote': 'podział orientacyjny, dokładny pokaże „Podgląd PDF”',
    'contractBuilder.statusLoadFailed': 'Nie wczytano szablonu',
    'contractBuilder.statusDescLoadFailed': 'Nie wiadomo, która wersja szablonu obowiązuje. Odśwież stronę.',
    'contractBuilder.statusPublished': 'Opublikowany',
    'contractBuilder.statusPublishedVersion': 'Opublikowany (v{n})',
    'contractBuilder.importSection': 'Sekcja „{name}”:',
    'contractBuilder.importDidYouMean': 'czy chodziło o',
    'contractBuilder.templateConflict': 'Szablon zmieniono w innej karcie lub na innym komputerze. Odśwież stronę.',
    'contractBuilder.accountChanged': 'W innej karcie zalogowano się na inne konto, więc zmian nie zapisano. Odśwież stronę.',
    'contractBuilder.exitSaveFailed': 'Szkic umowy nie został zapisany: {msg}',
    'contractBuilder.blockNameHeading': 'Nazwa bloku w edytorze (nie drukuje się)',
    'contractBuilder.blockNameHeadingHint': 'Tytuł umowy wpisz w „Treść bloku” poniżej.',
    'contractBuilder.testOn': 'Testuj na',
    'contractBuilder.scenarioStandard': 'Scenariusz: standard',
    'contractBuilder.scenarioNoDeposit': 'Scenariusz: bez kaucji',
    'contractBuilder.scenarioLongTerm': 'Scenariusz: dłuższy najem',
    'contractBuilder.presetApplied': 'Zastosowano wzór umowy.',
    'contractBuilder.publishTemplate': 'Publikuj szablon',
    'contractBuilder.publishing': 'Publikowanie...',
    'contractBuilder.publishTitle': 'Publikuj szablon?',
    'contractBuilder.publishBodyReplace': 'Publikacja zastąpi aktywny szablon Twojej firmy, a obecna wersja (v{n}) przejdzie do historii. Nowe umowy będą generowane z nowego szablonu.',
    'contractBuilder.publishBodyFirst': 'Po publikacji nowe umowy będą generowane z tego szablonu.',
    'contractBuilder.publishBlocked': 'Popraw przed publikacją',
    'contractBuilder.warnNoHeading': 'Brak bloku nagłówka z tytułem umowy (np. „UMOWA NAJMU”).',
    'contractBuilder.warnNoContent': 'Szablon nie ma żadnej treści.',
    'contractBuilder.warnUnknownVars': 'Nieznane pola: {list}. Usuń je albo wybierz pole z listy.',
    'contractBuilder.warnCompanyIncomplete': 'Niekompletne dane firmy: {list}',
    'contractBuilder.sessionExpired': 'Sesja wygasła. Zaloguj się ponownie.',

    // ── P8.1e (5/6): i18n konstruktora oferty (dokument CELOWO zostaje po polsku) ──
    'offerTemplate.alignCenter': 'Wyśrodkuj',
    'offerTemplate.alignLeft': 'Do lewej',
    'offerTemplate.alignRight': 'Do prawej',
    'offerTemplate.checkBeforePublish': 'Sprawdź przed publikacją',
    'offerTemplate.clickFieldFirst': 'Najpierw kliknij w pole tekstu (wstęp lub stopka), potem w zmienną.',
    'offerTemplate.companyIncomplete': 'Niekompletne dane firmy',
    'offerTemplate.companyIncompleteBody': 'Brakuje: {fields}. Oferta pokaże w tych miejscach „-”, także w danych do przelewu.',
    'offerTemplate.contentPanel': 'Treść oferty',
    'offerTemplate.contractSettings': 'Dane firmy',
    'offerTemplate.deleteVersionFailed': 'Nie udało się usunąć wersji',
    'offerTemplate.deleteVersionTitle': 'Usuń tę wersję z historii',
    'offerTemplate.downloadPdf': 'Pobierz PDF',
    'offerTemplate.downloading': 'Pobieranie...',
    'offerTemplate.draftSaved': 'Zapisano szkic. Klienci nadal dostają wersję opublikowaną.',
    'offerTemplate.exitBack': 'Wróć do konstruktora',
    'offerTemplate.exitNotLoaded': 'Nie zapisano zmian w konstruktorze oferty, bo jego ustawienia się nie wczytały. Odśwież stronę konstruktora i wprowadź zmiany ponownie.',
    'offerTemplate.exitSaveFailed': 'Nie zapisano zmian w konstruktorze oferty ({msg}). Zmiany czekają w tej karcie i wrócą po powrocie do konstruktora.',
    'offerTemplate.exitTooLong': 'Nie zapisano zmian w konstruktorze oferty: wstęp albo stopka ma ponad 2000 znaków. Zmiany czekają w tej karcie i wrócą po powrocie do konstruktora.',
    'offerTemplate.fillCompany': 'Uzupełnij Dane firmy',
    'offerTemplate.fontSize': 'Wielkość tekstu',
    'offerTemplate.footerLabel': 'Stopka / instrukcja płatności',
    'offerTemplate.generateError': 'Błąd generowania',
    'offerTemplate.generating': 'Generowanie...',
    'offerTemplate.groupHeader': 'Nagłówek',
    'offerTemplate.groupTexts': 'Teksty',
    'offerTemplate.groupValidity': 'Ważność',
    'offerTemplate.history': 'Historia ({count})',
    'offerTemplate.historyHead': 'Poprzednie wersje: {count}',
    'offerTemplate.intro': 'Ustawiasz to, co w ofercie stałe: logo, tytuł, teksty i ważność. Tabele z danymi klienta, sprzętem i podsumowaniem wypełniają się same z rezerwacji, a podgląd pokazuje je na przykładowych danych.',
    'offerTemplate.introLabel': 'Tekst wstępu (nad tabelami, opcjonalny)',
    'offerTemplate.loadFailed': 'Nie udało się wczytać szablonu oferty',
    'offerTemplate.loadFailedBody': 'Edytor pokazuje wartości domyślne, a nie Twój szablon, więc zapis jest wyłączony. Odśwież stronę.',
    'offerTemplate.loading': 'Wczytywanie ustawień…',
    'offerTemplate.logoAlign': 'Wyrównanie logo',
    'offerTemplate.missingAccount': 'numer konta',
    'offerTemplate.missingBankName': 'nazwa banku',
    'offerTemplate.missingName': 'nazwa firmy',
    'offerTemplate.noLogoHint': 'Brak logo. Dodaj je w „Dane firmy”.',
    'offerTemplate.noWarnings': 'Brak ostrzeżeń. Szablon gotowy do publikacji.',
    'offerTemplate.offerTitle': 'Tytuł oferty',
    'offerTemplate.pagesApprox': 'podział orientacyjny, dokładny pokaże wygenerowany PDF',
    'offerTemplate.pdfFailed': 'Nie udało się wygenerować PDF oferty',
    'offerTemplate.pdfFrameTitle': 'Podgląd PDF oferty',
    'offerTemplate.pdfModalHint': 'Podgląd PDF: tu widzisz podział na strony (1:1 jak wyjdzie)',
    'offerTemplate.pdfPreview': 'Podgląd PDF',
    'offerTemplate.previewError': 'Błąd generowania podglądu',
    'offerTemplate.previewPanel': 'Podgląd oferty',
    'offerTemplate.publish': 'Publikuj szablon',
    'offerTemplate.publishBlocked': 'Tego szablonu nie da się teraz opublikować',
    'offerTemplate.publishConfirmBody': 'Publikacja zastąpi szablon, z którego generują się oferty dla Twoich klientów.',
    'offerTemplate.publishConfirmTitle': 'Publikuj szablon?',
    'offerTemplate.publishError': 'Błąd publikacji',
    'offerTemplate.publishMovesToHistory': 'Obecna wersja zostanie przeniesiona do historii.',
    'offerTemplate.published': 'Szablon opublikowany. Nowe oferty korzystają z tej wersji.',
    'offerTemplate.publishing': 'Publikowanie...',
    'offerTemplate.reload': 'Odśwież stronę',
    'offerTemplate.restore': 'Przywróć',
    'offerTemplate.restoreTitle': 'Wczytaj tę wersję do edytora',
    'offerTemplate.restoredBody': 'Przy ostatnim wyjściu z konstruktora nie udało się ich zapisać. Zapisz szkic, żeby je zachować, albo odrzuć je.',
    'offerTemplate.restoredDiscard': 'Odrzuć zmiany',
    'offerTemplate.restoredTitle': 'Przywrócono niezapisane zmiany',
    'offerTemplate.sampleData': 'przykładowe dane',
    'offerTemplate.saveDraft': 'Zapisz szkic',
    'offerTemplate.saveError': 'Błąd zapisu',
    'offerTemplate.settingsNotLoaded': 'Ustawienia się nie wczytały. Odśwież stronę, inaczej zmian nie da się zapisać.',
    'offerTemplate.showLogo': 'Pokaż logo firmy na ofercie',
    'offerTemplate.statusDefault': 'Brak szablonu',
    'offerTemplate.statusDescDefault': 'Oferty wysyłają się na ustawieniach domyślnych. Opublikuj, aby używać własnego szablonu.',
    'offerTemplate.statusDescDraft': 'Masz zmiany, których klienci jeszcze nie widzą. Opublikuj, aby zaczęły obowiązywać.',
    'offerTemplate.statusDescLoadFailed': 'Nie wiadomo, jaki szablon obowiązuje, dopóki strona się nie wczyta.',
    'offerTemplate.statusDescPublished': 'Nowe oferty będą używać tego szablonu.',
    'offerTemplate.statusDraft': 'Szkic',
    'offerTemplate.statusLoadFailed': 'Nie wczytano',
    'offerTemplate.statusPublished': 'Opublikowany',
    'offerTemplate.textTooLong': 'Wstęp albo stopka ma ponad 2000 znaków. Skróć tekst, inaczej szablonu nie da się zapisać ani opublikować.',
    'offerTemplate.title': 'Konstruktor oferty',
    'offerTemplate.unsaved': 'Niezapisane zmiany',
    'offerTemplate.validityHint': 'Od 1 do 365 dni. Data ważności liczy się od dnia wystawienia oferty i trafia na jej ostatnią linię.',
    'offerTemplate.validityInvalid': 'Podaj liczbę dni od 1 do 365. Bez poprawki po wyjściu z pola wróci poprzednia wartość: {n}.',
    'offerTemplate.validityLabel': 'Oferta ważna przez (dni)',
    'offerTemplate.validityTooLong': 'Najwyżej 365 dni. Oferta będzie ważna 365 dni.',
    'offerTemplate.varBank': 'Bank',
    'offerTemplate.varDataOferty': 'Data oferty',
    'offerTemplate.varDepozyt': 'Depozyt',
    'offerTemplate.varEmail': 'Email',
    'offerTemplate.varFirma': 'Nazwa firmy',
    'offerTemplate.varKlient': 'Klient',
    'offerTemplate.varNrKonta': 'Nr konta',
    'offerTemplate.varNrOferty': 'Nr oferty',
    'offerTemplate.varRazem': 'Razem do zapłaty',
    'offerTemplate.varTerminDo': 'Termin do',
    'offerTemplate.varTerminOd': 'Termin od',
    'offerTemplate.varWaznosc': 'Ważność (dni)',
    'offerTemplate.varZaliczka': 'Zaliczka',
    'offerTemplate.varsHint': 'Kliknij najpierw w pole tekstu poniżej, potem w pole z listy, a wstawi się w miejscu kursora.',
    'offerTemplate.varsLabel': 'Pola do wstawienia w treść',
    'offerTemplate.versionRestored': 'Wczytano wersję v{n} do edytora. Opublikuj, aby zaczęła obowiązywać.',
    'offerTemplate.warnCompanyData': 'Brakuje danych firmy ({fields}), więc oferta pokaże w tych miejscach „-”.',
    'offerTemplate.warnNoLogo': 'Logo jest włączone, ale w „Dane firmy" go nie ma, więc oferta wyjdzie bez logo.',
    'offerTemplate.warnNoTitle': 'Oferta nie ma tytułu.',
    'offerTemplate.yesPublish': 'Tak, publikuj',

    // ── P8.1e (4/6): i18n panelu widgetu (podglad widgetu CELOWO zostaje po polsku) ──
    'widgetMedia.adminOnlySub': 'Ten panel jest dostępny tylko dla administratora.',
    'widgetMedia.adminOnlyTitle': 'Ustawienia widgetu',
    'widgetMedia.allowedDomains': 'Dozwolone domeny dla widgetu',
    'widgetMedia.allowedDomainsHint': 'Adresy stron Twojej wypożyczalni, na które klient może wrócić po płatności online, np. https://twojadomena.pl. Zapisujemy sam adres strony, bez ścieżki; jeśli strona działa też pod www, dodaj oba adresy. Widget wklejony kodem z tego ekranu i link z kodem QR działają zawsze, a pole nie blokuje wklejenia widgetu na innej stronie. Zostaw puste, aby nie ograniczać. Jeden adres w linii lub rozdziel przecinkami.',
    'widgetMedia.privacyPolicyUrl': 'Polityka prywatności (adres strony)',
    'widgetMedia.privacyPolicyUrlPlaceholder': 'https://twojafirma.pl/polityka-prywatnosci',
    'widgetMedia.privacyPolicyUrlHint': 'Pod formularzem rezerwacji widget pokazuje, że administratorem danych klientów jest Twoja firma (nazwa z Danych firmy), i linkuje do tej strony. Wymaga tego RODO (art. 13). Bez adresu zostaje samo zdanie o administratorze.',
    'widgetMedia.termsUrl': 'Regulamin wypożyczalni (adres strony)',
    'widgetMedia.termsUrlPlaceholder': 'https://twojafirma.pl/regulamin',
    'widgetMedia.termsUrlHint': 'Gdy podasz adres, pod przyciskiem rezerwacji w widgecie pojawi się zdanie, że składając rezerwację klient akceptuje regulamin, a słowo „regulamin” poprowadzi do tej strony. Puste pole = bez oświadczenia.',
    'widgetMedia.blockBasic': 'Podstawowe',
    'widgetMedia.blockPresentation': 'Prezentacja danych',
    'widgetMedia.blockTheme': 'Motyw kolorystyczny',
    'widgetMedia.checkingServer': 'Sprawdzam serwer widgetu…',
    'widgetMedia.deviceDesktop': 'Komputer',
    'widgetMedia.deviceMobile': 'Telefon',
    'widgetMedia.devicePicker': 'Wybierz urządzenie podglądu',
    'widgetMedia.embedCopied': 'Kod embedowania skopiowany do schowka!',
    'widgetMedia.embedCopyFailed': 'Nie udało się skopiować kodu automatycznie. Zaznacz go ręcznie i skopiuj (Ctrl+C).',
    'widgetMedia.embedDemoNote': 'Na koncie demo widget pokazuje sprzęt, terminy i ceny, ale nie przyjmuje rezerwacji, bo w demo nie zbiera się danych prawdziwych klientów (regulamin, § 6 ust. 3).',
    'widgetMedia.superAdminNotPremium': 'Twoja firma nie jest na planie Premium. Jako super-admin zmienisz tu ustawienia widgetu, ale widget na stronie, link do rezerwacji i kod QR nie zadziałają u klientów, dopóki firma nie przejdzie na Premium.',
    'widgetMedia.bookingLink.title': 'Link do rezerwacji i kod QR',
    'widgetMedia.bookingLink.subtitle': 'Klienci rezerwują sprzęt na stronie widgetu, także gdy nie masz własnej strony WWW. Wyślij im link albo wydrukuj kod QR, na przykład przy ladzie lub na ulotce.',
    'widgetMedia.bookingLink.fieldLabel': 'Link do rezerwacji',
    'widgetMedia.bookingLink.copy': 'Skopiuj link do rezerwacji',
    'widgetMedia.bookingLink.copied': 'Skopiowano',
    'widgetMedia.bookingLink.copyFailed': 'Nie udało się skopiować. Zaznacz link w polu i skopiuj go ręcznie.',
    'widgetMedia.bookingLink.downloadPng': 'Pobierz PNG',
    'widgetMedia.bookingLink.downloadSvg': 'Pobierz SVG',
    'widgetMedia.bookingLink.print': 'Drukuj kod QR',
    'widgetMedia.bookingLink.open': 'Otwórz stronę rezerwacji w nowej karcie',
    'widgetMedia.bookingLink.qrAlt': 'Kod QR z linkiem do rezerwacji',
    'widgetMedia.bookingLink.printTitle': 'Kod QR do rezerwacji',
    'widgetMedia.bookingLink.fileName': 'link-do-rezerwacji-qr',
    'widgetMedia.bookingLink.printHeading': 'Zarezerwuj sprzęt online. Zeskanuj kod aparatem telefonu.',
    'widgetMedia.bookingLink.missing': 'Link pojawi się, gdy panel ustali adres widgetu i kod Twojej firmy.',
    'widgetMedia.bookingLink.demoNote': 'Na koncie demo strona rezerwacji pokazuje sprzęt, terminy i ceny, ale nie przyjmuje rezerwacji (regulamin, § 6 ust. 3). Klient zobaczy o tym komunikat.',
    'widgetMedia.embedSubtitle': 'Gdy widget wygląda już tak, jak chcesz - skopiuj poniższy kod i wklej go na swojej stronie. Widżet zostanie przypisany do Twojej organizacji po unikalnym kodzie.',
    'widgetMedia.embedTitle': 'Kod do instalacji na stronie',
    'widgetMedia.fileTooBig': 'Plik zbyt duży (max 5MB)',
    'widgetMedia.invalidFormat': 'Nieprawidłowy format (dozwolone: JPG, PNG, WEBP)',
    'widgetMedia.hideCode': 'Ukryj kod',
    'widgetMedia.imagesCategoriesHint': 'Obrazy dla kafelków kategorii. Zalecana rozdzielczość:',
    'widgetMedia.imagesClassesHint': 'Obrazy dla kafelków klas. Zalecana rozdzielczość:',
    'widgetMedia.imagesFormatHint': ', max 5MB (JPG, PNG, WEBP).',
    'widgetMedia.invalidScope': 'Nieprawidłowy scope.',
    'widgetMedia.livePreview': 'Podgląd na żywo',
    'widgetMedia.loadFailed': 'Nie udało się pobrać danych.',
    'widgetMedia.loading': 'Ładowanie danych...',
    'widgetMedia.premiumOnly': 'Widget jest dostępny wyłącznie w planie premium.',
    'widgetMedia.previewNote': 'Podgląd poglądowy - Twoje zmiany zostaną zapisane i pojawią się w prawdziwym widgecie.',
    'widgetMedia.priceDaily': 'Cena dzienna',
    'widgetMedia.priceMode': 'Tryb wyświetlania ceny',
    'widgetMedia.priceTotal': 'Cena całkowita',
    'widgetMedia.refresh': 'Odśwież',
    'widgetMedia.refreshPreview': 'Odśwież podgląd',
    'widgetMedia.rotateError': 'Błąd rotacji kodu.',
    'widgetMedia.rotateFailed': 'Nie udało się wygenerować nowego kodu.',
    'widgetMedia.rotateOk': 'Wygenerowano nowy kod widgetu.',
    'widgetMedia.saveError': 'Błąd zapisu.',
    'widgetMedia.saveFailed': 'Nie udało się zapisać.',
    'widgetMedia.saveSettings': 'Zapisz ustawienia',
    'widgetMedia.saveSettingsError': 'Błąd zapisu ustawień.',
    'widgetMedia.saveSettingsFailed': 'Nie udało się zapisać ustawień.',
    'widgetMedia.savedChanges': 'Zapisano zmiany.',
    'widgetMedia.sectionCategories': 'Kategorie',
    'widgetMedia.sectionClasses': 'Klasy sprzętu',
    'widgetMedia.classesDefaultGroup': 'Zdjęcie domyślne klasy',
    'widgetMedia.classesDefaultHint': 'Widget pokazuje je w każdej kategorii, w której klasa nie ma własnego zdjęcia (poniżej).',
    'widgetMedia.classDefaultBadge': 'Zdjęcie domyślne',
    'widgetMedia.groupImages': 'Zdjęcia: {own} z {all}',
    'widgetMedia.categoriesGroup': 'Wszystkie kategorie',
    'widgetMedia.settingsSaved': 'Ustawienia widgetu zapisane pomyślnie!',
    'widgetMedia.settingsSub': 'Dostosuj wygląd i zachowanie widgetu do potrzeb Twojej wypożyczalni.',
    'widgetMedia.showCode': 'Pokaż kod',
    'widgetMedia.copied': 'Skopiowano!',
    'widgetMedia.copyCode': 'Kopiuj kod',
    'widgetMedia.showImages': 'Pokazuj obrazy w kafelkach',
    'widgetMedia.showProgress': 'Pokazuj pasek postępu',
    'widgetMedia.showSizeChart': 'Pokazuj tabelę rozmiarów',
    'widgetMedia.subtitle': 'Ustawienia wyglądu, treści i obrazów widocznych w widgetcie klienta.',
    'widgetMedia.themeBlue': 'Niebieski',
    'widgetMedia.themeDarkBlue': 'Ciemny niebieski (brand)',
    'widgetMedia.themeGreen': 'Zielony',
    'widgetMedia.themeNature': 'Gradient Natura',
    'widgetMedia.customThemeTitle': 'Własny motyw',
    'widgetMedia.customThemeModeAria': 'Typ własnego motywu',
    'widgetMedia.modeSolid': 'Jednolity',
    'widgetMedia.modeGradient': 'Gradient',
    'widgetMedia.customThemeHintSolid': 'Jeden kolor dla całego motywu.',
    'widgetMedia.customThemeHintGradient': 'Dwa kolory tworzą płynne przejście w tle widgetu.',
    'widgetMedia.customColorSolid': 'Kolor motywu',
    'widgetMedia.customColor1': 'Kolor 1',
    'widgetMedia.customColor2': 'Kolor 2',
    'widgetMedia.customAccent': 'Kolor akcentu',
    'widgetMedia.shuffleColors': 'Wylosuj parę kolorów',
    'widgetMedia.previewFallbackTitle': 'Twoja wypożyczalnia',
    'widgetMedia.previewCta': 'Zarezerwuj teraz',
    'widgetMedia.themeNight': 'Gradient Nocny',
    'widgetMedia.themeOcean': 'Gradient Ocean',
    'widgetMedia.themeOrange': 'Pomarańczowy',
    'widgetMedia.themePurple': 'Fioletowy',
    'widgetMedia.themeRed': 'Czerwony',
    'widgetMedia.themeSunset': 'Gradient Zachód',
    'widgetMedia.themeTurquoise': 'Turkusowy',
    'widgetMedia.title': 'Widget',
    'widgetMedia.uploadFailed': 'Nie udało się przesłać pliku.',
    'widgetMedia.uploadOk': 'Obraz przesłany pomyślnie.',
    'widgetMedia.uploadTitle': 'Prześlij obraz (JPG, PNG, WEBP, max 5MB)',
    'widgetMedia.uploading': 'Przesyłanie...',
    'widgetMedia.widgetName': 'Nazwa widgetu',

    // ── P8.1e (3/6): przewodniki stron i kalendarz sprzetu ──
    'equipmentCalendar.aggregateHint': 'Liczby w dniach to rezerwacje i oferty wszystkich sztuk razem.',
    'equipmentCalendar.aggregateView': 'Widok zbiorczy kalendarza',
    'equipmentCalendar.allEquipment': 'Wszystkie sprzęty',
    'equipmentCalendar.apartmentNo': 'Nr lokalu',
    'equipmentCalendar.backToInventory': 'Powrót do magazynu',
    'equipmentCalendar.basicData': 'Dane podstawowe',
    'equipmentCalendar.bookEquipment': 'Zarezerwuj sprzęt',
    'equipmentCalendar.buildingNo': 'Nr budynku',
    'equipmentCalendar.checkAvailabilityFailed': 'Nie udało się sprawdzić dostępności sprzętu.',
    'equipmentCalendar.city': 'Miasto',
    'equipmentCalendar.clearRange': 'Wyczyść zakres dat',
    'equipmentCalendar.clientLabel': 'Klient:',
    'equipmentCalendar.dateRange': 'Zakres dat*',
    'equipmentCalendar.dayCount': 'Liczba dni',
    'equipmentCalendar.dayEmpty': 'Tego dnia sztuka jest wolna.',
    'equipmentCalendar.dayEmptyAll': 'Tego dnia nie ma rezerwacji ani ofert.',
    'equipmentCalendar.daysFew': '{count} dni',
    'equipmentCalendar.daysMany': '{count} dni',
    'equipmentCalendar.daysOne': '{count} dzień',
    'equipmentCalendar.daysOther': '{count} dnia',
    'equipmentCalendar.editAddress': 'Edytuj adres',
    'equipmentCalendar.emptyPickEquipment': 'Kliknij "Wybierz sprzęt", aby dodać sprzęt do rezerwacji',
    'equipmentCalendar.emptyPickRange': 'Najpierw wybierz zakres dat, aby zobaczyć dostępny sprzęt',
    'equipmentCalendar.equipmentRequired': 'Wybierz sprzęt',
    'equipmentCalendar.errorPanel': 'Błąd',
    'equipmentCalendar.fillRequired': 'Wypełnij wszystkie obowiązkowe pola',
    'equipmentCalendar.firstname': 'Imię*',
    'equipmentCalendar.firstnameRequired': 'Imię wymagane',
    'equipmentCalendar.goToday': 'Wróć do dziś',
    'equipmentCalendar.kindReservation': 'Rezerwacja',
    'equipmentCalendar.lastname': 'Nazwisko*',
    'equipmentCalendar.lastnameRequired': 'Nazwisko wymagane',
    'equipmentCalendar.legend': 'Legenda',
    'equipmentCalendar.legendAvailable': 'Dostępne',
    'equipmentCalendar.legendBooked': 'Zarezerwowane',
    'equipmentCalendar.legendOffer': 'Oferta',
    'equipmentCalendar.legendOfferHold': 'Oferta (wstępna blokada)',
    'equipmentCalendar.legendToday': 'Dzisiaj',
    'equipmentCalendar.loadAvailableFailed': 'Nie udało się pobrać dostępnego sprzętu.',
    'equipmentCalendar.loadFailed': 'Nie udało się załadować kalendarza sprzętu. Sprawdź połączenie i spróbuj ponownie.',
    'equipmentCalendar.loading': 'Ładowanie...',
    'equipmentCalendar.moreOnDay': 'Jeszcze {count} tego dnia',
    'equipmentCalendar.newReservation': 'Nowa rezerwacja',
    'equipmentCalendar.newReservationHint': 'Wprowadź dane rezerwacji i wybierz sprzęt',
    'equipmentCalendar.next30': 'Najbliższe 30 dni',
    'equipmentCalendar.next30Empty': 'Nic zaplanowanego na najbliższe 30 dni.',
    'equipmentCalendar.noReservations': 'Brak rezerwacji',
    'equipmentCalendar.noUpcomingOffers': 'Brak nadchodzących ofert',
    'equipmentCalendar.notFound': 'Nie znaleziono sprzętu o podanym identyfikatorze.',
    'equipmentCalendar.notePlaceholder': 'Wprowadź notatkę',
    'equipmentCalendar.notes': 'Notatki',
    'equipmentCalendar.occupancy': '{month}: zajęty {busy} z {total} dni',
    'equipmentCalendar.offerFor': 'Oferta: {name}',
    'equipmentCalendar.open': 'Otwórz',
    'equipmentCalendar.openTitle': 'Otwórz szczegóły rezerwacji',
    'equipmentCalendar.phApartmentOptional': 'Nr lokalu (opcjonalnie)',
    'equipmentCalendar.phFirstname': 'Imię',
    'equipmentCalendar.phLastname': 'Nazwisko',
    'equipmentCalendar.phPhone': 'Telefon',
    'equipmentCalendar.phone': 'Telefon*',
    'equipmentCalendar.phoneRequired': 'Telefon wymagany',
    'equipmentCalendar.pickRangeFirst': 'Najpierw wybierz zakres dat.',
    'equipmentCalendar.pickRangeFirstShort': 'Najpierw wybierz zakres dat',
    'equipmentCalendar.postalCode': 'Kod pocztowy',
    'equipmentCalendar.rangeFrom': 'Od',
    'equipmentCalendar.rangeRequired': 'Wybierz zakres dat',
    'equipmentCalendar.rangeTo': 'Do',
    'equipmentCalendar.removeFromReservation': 'Usuń sprzęt z rezerwacji',
    'equipmentCalendar.reservationRange': 'Termin rezerwacji',
    'equipmentCalendar.reservations': 'Rezerwacje',
    'equipmentCalendar.saveAddress': 'Zapisz adres',
    'equipmentCalendar.saveError': 'Błąd zapisu',
    'equipmentCalendar.saveReservation': 'Zapisz rezerwację',
    'equipmentCalendar.saveReservationFailed': 'Nie udało się zapisać rezerwacji',
    'equipmentCalendar.searchEquipment': 'Szukaj sprzętu...',
    'equipmentCalendar.selectedDay': 'Wybrany dzień',
    'equipmentCalendar.selectedEquipment': 'Wybrany sprzęt',
    'equipmentCalendar.selectedEquipmentRequired': 'Wybrany sprzęt*',
    'equipmentCalendar.showInCalendar': 'Pokaż w kalendarzu',
    'equipmentCalendar.statusFree': 'Wolny dziś',
    'equipmentCalendar.statusHeld': 'Zablokowany ofertą do {date}',
    'equipmentCalendar.statusLabel': 'Status:',
    'equipmentCalendar.statusNext': 'Najbliższa rezerwacja: {range}, {name}',
    'equipmentCalendar.statusNoNext': 'Brak zaplanowanych rezerwacji',
    'equipmentCalendar.statusRented': 'Wypożyczony do {date}',
    'equipmentCalendar.street': 'Ulica',
    'equipmentCalendar.summary': 'Podsumowanie',
    'equipmentCalendar.title': 'Kalendarz wypożyczeń',
    'equipmentCalendar.upcomingOffers': 'Nadchodzące oferty ({count})',
    'reservationDetails.cancelledNote': 'Rezerwacja jest anulowana: sprzęt jest wolny, a nowych płatności nie przyjmujesz. Kaucję z blokady na karcie rozliczysz niżej.',
    'reservationDetails.depositAfterReturn': 'Cały sprzęt wrócił, a kaucja jest nadal zablokowana na karcie klienta. Zwolnij ją albo ściągnij kwotę za szkodę w sekcji „Kaucja online” obok.',
    'reservationDetails.daysFew': '{count} dni',
    'reservationDetails.daysMany': '{count} dni',
    'reservationDetails.daysOne': '{count} dzień',
    'reservationDetails.daysOther': '{count} dnia',
    'reservationDetails.equipment': 'Sprzęt',
    'reservationDetails.eyebrow': 'Szczegóły rezerwacji #{id}',
    'reservationDetails.itemsCount': 'sztuk: {count}',
    'reservationDetails.note': 'Notatka',
    'reservationDetails.paidExtra': 'W tym dopłacono {amount}',
    'reservationDetails.paidInFull': 'Opłacona w całości',
    'reservationDetails.payments': 'Płatności i kaucja',
    'reservationDetails.remaining': 'Pozostało do zapłaty',
    'pageTours.calendar.day.lead': 'Kolorowe paski w siatce to rezerwacje, a ten panel pokazuje wybrany dzień.',
    'pageTours.calendar.day.p1': 'Klik w dzień w kalendarzu pokazuje tutaj plan dnia: wydania, zwroty i sprzęt do przygotowania.',
    'pageTours.calendar.day.p2': 'Klik w rezerwację otwiera szczegóły: edycję oraz wydanie i zwrot sprzętu.',
    'pageTours.calendar.day.p3': 'Strzałki nad siatką przełączają miesiące, a „Dziś" wraca do bieżącego dnia.',
    'pageTours.calendar.day.title': 'Kalendarz rezerwacji',
    'pageTours.calendar.tabs.lead': 'Zakładki pokazują te same rezerwacje jako listę.',
    'pageTours.calendar.tabs.p1': '„Nadchodzące" to wszystko od dziś - liczba w odznace mówi, ile tego jest.',
    'pageTours.calendar.tabs.p2': '„Historia" zaczyna od najnowszych i pozwala szukać po nazwisku.',
    'pageTours.calendar.tabs.p3': '„Dodaj rezerwację" w prawym górnym rogu otwiera formularz nowej rezerwacji.',
    'pageTours.calendar.tabs.title': 'Lista zamiast siatki',
    'pageTours.calendar.title': 'Kalendarz',
    'pageTours.clients.card.lead': 'Klik w kartę otwiera szczegóły klienta.',
    'pageTours.clients.card.p1': '„Edytuj dane" poprawia kontakt i adres - trafią potem na umowę i fakturę.',
    'pageTours.clients.card.p2': '„Rezerwacje" pokazuje historię wypożyczeń tej osoby, a „Nowa rezerwacja" zaczyna kolejną z jej danymi.',
    'pageTours.clients.card.p3': '„Dodaj klienta" u góry przyda się, gdy ktoś przychodzi z ulicy.',
    'pageTours.clients.card.title': 'Karta klienta',
    'pageTours.clients.search.lead': 'Jedna lista wszystkich osób, które u Ciebie wypożyczały.',
    'pageTours.clients.search.p1': 'Szukasz po nazwisku, imieniu, telefonie albo mailu - wpisujesz fragment, lista filtruje się od razu.',
    'pageTours.clients.search.p2': 'Obok masz sortowanie (A-Z, po liczbie rezerwacji, najnowsi) i filtr: wszyscy, nowi z 30 dni, stali klienci.',
    'pageTours.clients.search.p3': 'Klienci dopisują się sami przy rezerwacji z widgetu - nie trzeba ich wprowadzać ręcznie.',
    'pageTours.clients.search.title': 'Baza klientów',
    'pageTours.clients.title': 'Klienci',
    'pageTours.contract-template.preview.lead': 'Podgląd pokazuje umowę tak, jak wyjdzie na papierze.',
    'pageTours.contract-template.preview.p1': '„Testuj na” podstawia przykładowe rezerwacje: standardową, bez kaucji i dłuższy najem.',
    'pageTours.contract-template.preview.p2': '„Podgląd PDF” pokazuje dokładny podział na strony.',
    'pageTours.contract-template.preview.p3': 'Zmiany zapisują się jako szkic - klienci dostają nową wersję dopiero po „Publikuj szablon”.',
    'pageTours.contract-template.preview.title': 'Podgląd i publikacja',
    'pageTours.contract-template.start.lead': 'Umowę składasz z bloków - najprościej zacząć od gotowego wzoru.',
    'pageTours.contract-template.start.p1': 'Wzór podmienia wszystkie sekcje, a potem poprawiasz treść po swojemu.',
    'pageTours.contract-template.start.p2': 'Masz już własną umowę? Rozwiń import i wklej jej treść.',
    'pageTours.contract-template.start.p3': 'Pola, np. imię klienta albo listę sprzętu, wstawiasz z listy - w umowie dla rezerwacji pojawią się prawdziwe dane.',
    'pageTours.contract-template.start.title': 'Konstruktor umowy',
    'pageTours.contract-template.title': 'Konstruktor umowy',
    'pageTours.counter': 'Krok {current} z {total}',
    'pageTours.equipment-bundles.effect.lead': 'Nie musisz o pakiecie pamiętać - system sam go rozpozna.',
    'pageTours.equipment-bundles.effect.p1': 'Gdy klient bierze komplet pasujący do zestawu, cena schodzi do stawki pakietu.',
    'pageTours.equipment-bundles.effect.p2': 'Rozbicie ceny w podsumowaniu pokazuje, ile klient zyskał na zestawie.',
    'pageTours.equipment-bundles.effect.p3': 'Przełącznik w wierszu listy włącza i wyłącza zestaw bez kasowania go.',
    'pageTours.equipment-bundles.effect.title': 'Jak to działa przy rezerwacji',
    'pageTours.equipment-bundles.presets.lead': 'Pakiet to kilka typów sprzętu wypożyczanych razem taniej - „Nowy zestaw" tworzy go od zera.',
    'pageTours.equipment-bundles.presets.p1': '„Szybkie zestawy" poniżej podpowiadają sprzęt, który klienci wypożyczają razem, z sugerowaną ceną.',
    'pageTours.equipment-bundles.presets.p2': 'Klik w propozycję tylko wypełnia formularz - cenę i nazwę możesz zmienić przed zapisem.',
    'pageTours.equipment-bundles.presets.p3': 'Zestaw musi mieć co najmniej dwa typy sprzętu.',
    'pageTours.equipment-bundles.presets.title': 'Zestawy w jednej cenie',
    'pageTours.equipment-bundles.title': 'Pakiety sprzętu',
    'help.button.aria': 'Pomoc i zgłoszenia',
    'help.menu.label': 'Pomoc',
    'help.menu.bug': 'Zgłoś błąd',
    'help.menu.question': 'Zadaj pytanie',
    'help.menu.idea': 'Zaproponuj zmianę lub nową funkcję',
    'help.menu.tour': 'Przewodnik po tej stronie',
    'help.form.title': 'Napisz do nas',
    'help.form.subtitle': 'Zgłoszenie trafi do zespołu the.rENT, a odpowiemy mailem.',
    'help.form.category': 'Czego dotyczy',
    'help.category.bug': 'Błąd',
    'help.category.question': 'Pytanie',
    'help.category.idea': 'Propozycja',
    'help.category.other': 'Inne',
    'help.form.subject': 'Temat',
    'help.form.message': 'Opis',
    'help.form.hint.bug': 'Co zrobiłeś, co się stało i czego się spodziewałeś?',
    'help.form.hint.question': 'Czego szukasz albo co chcesz zrobić?',
    'help.form.hint.idea': 'Co chcesz zmienić albo dodać i do czego Ci to posłuży?',
    'help.form.hint.other': 'Napisz, w czym możemy pomóc.',
    'help.form.counter': '{n} z {max} znaków',
    'help.form.noCustomerData': 'Nie wpisuj danych klientów, jeśli nie są potrzebne.',
    'help.form.replyTo': 'Odpowiemy na adres',
    'help.form.replyToMissing': 'Twoje konto nie ma adresu e-mail, więc nie mamy jak odpowiedzieć mailem. Podaj w opisie telefon albo inny sposób kontaktu.',
    'help.form.send': 'Wyślij zgłoszenie',
    'help.form.sending': 'Wysyłanie…',
    'help.form.cancel': 'Anuluj',
    'help.form.close': 'Zamknij',
    'help.shots.toggle': 'Dołącz zrzut ekranu (opcjonalnie)',
    'help.shots.drop': 'Wklej zrzut (Ctrl+V), przeciągnij go tutaj albo',
    'help.shots.choose': 'wybierz plik',
    'help.shots.count': 'Dołączone: {n} z {max}',
    'help.shots.warning': 'Zrzut może zawierać dane Twoich klientów. Przytnij go albo zakryj je przed wysłaniem.',
    'help.shots.howTo': 'Jak zrobić zrzut: w Windows Win+Shift+S, na Macu Cmd+Shift+4, na telefonie jednocześnie przycisk zasilania i ściszania.',
    'help.shots.remove': 'Usuń zrzut {n}',
    'help.shots.alt': 'Zrzut ekranu {n}',
    'help.shots.limit': 'Można dołączyć najwyżej {max} zrzuty.',
    'help.shots.notImage': 'Pominięto plik, który nie jest obrazem.',
    'help.context.summary': 'Co jeszcze wyślemy',
    'help.context.intro': 'Dołączamy to automatycznie, żeby szybciej znaleźć przyczynę:',
    'help.context.page': 'Strona',
    'help.context.browser': 'Przeglądarka',
    'help.context.language': 'Język panelu',
    'help.context.window': 'Rozmiar okna',
    'help.context.org': 'Firma',
    'help.context.account': 'Konto',
    'help.context.role': 'Rola i plan',
    'help.context.roleValue': 'z Twojego konta',
    'help.context.attachments': 'Zrzuty ekranu',
    'help.context.none': 'brak',
    'help.done.title': 'Dziękujemy, zgłoszenie wysłane',
    'help.done.ticket': 'Numer zgłoszenia',
    'help.done.reply': 'Odpowiemy na adres {email}.',
    'help.done.replyNoEmail': 'Twoje konto nie ma adresu e-mail. Gdy będziesz do nas pisać, podaj numer zgłoszenia.',
    'help.error.invalid_category': 'Wybierz, czego dotyczy zgłoszenie.',
    'help.error.subject_required': 'Wpisz temat.',
    'help.error.subject_too_long': 'Temat może mieć najwyżej {max} znaków.',
    'help.error.message_too_short': 'Opisz sprawę w co najmniej {min} znakach.',
    'help.error.message_too_long': 'Opis może mieć najwyżej {max} znaków.',
    'help.error.too_many_attachments': 'Można dołączyć najwyżej {max} zrzuty.',
    'help.error.attachment_too_large': 'Jeden ze zrzutów jest za duży. Przytnij go albo zmniejsz.',
    'help.error.attachment_not_image': 'Jeden z plików nie jest obrazem PNG, JPEG ani WebP.',
    'help.error.attachment_unreadable': 'Jednego ze zrzutów nie da się odczytać. Zapisz go ponownie i dołącz jeszcze raz.',
    'help.error.request_too_large': 'Zrzuty są łącznie za duże. Usuń jeden albo przytnij je.',
    'help.error.too_many_requests': 'Wysłano już dużo zgłoszeń. Spróbuj ponownie za {minutes} min albo napisz do nas mailem.',
    'help.error.server_busy': 'Serwer jest chwilowo przeciążony. Spróbuj ponownie za {seconds} s albo napisz do nas mailem.',
    'help.error.session': 'Sesja wygasła. Zaloguj się ponownie, wpisany tekst zostanie zachowany. Możesz też napisać do nas mailem.',
    'help.error.generic': 'Nie udało się wysłać zgłoszenia.',
    'help.fallback.retry': 'Spróbuj ponownie',
    'help.fallback.title': 'Nie udało się wysłać zgłoszenia przez panel',
    'help.fallback.body': 'Wyślij je zwykłym mailem, treść jest już przygotowana.',
    'help.fallback.link': 'Otwórz wiadomość w programie pocztowym',
    'help.fallback.address': 'Albo napisz na adres {email}.',
    'help.fallback.attachNote': 'Zrzutów ekranu nie da się dodać automatycznie, dołącz je do maila ręcznie.',
    'help.mailto.attachNote': 'Do tego zgłoszenia miały być dołączone zrzuty ekranu ({n}), dołączam je do tej wiadomości.',
    'pageTours.finish': 'Rozumiem',
    'pageTours.home.favorites.lead': 'Skróty do stron, z których korzystasz najczęściej.',
    'pageTours.home.favorites.p1': 'Klik w kafelek przenosi od razu na wybraną stronę.',
    'pageTours.home.favorites.p2': '„Edytuj" pozwala wybrać do czterech skrótów.',
    'pageTours.home.favorites.p3': 'Kafelki przeciągasz za uchwyt w rogu, żeby ułożyć je po swojemu.',
    'pageTours.home.favorites.title': 'Twój pulpit',
    'pageTours.home.title': 'Strona główna',
    'pageTours.home.upcoming.lead': 'Lista tego, co wydajesz w najbliższych dniach.',
    'pageTours.home.upcoming.p1': 'Przełącznik „Nadchodzące / Trwające" pokazuje też rezerwacje, które już się zaczęły.',
    'pageTours.home.upcoming.p2': 'Zakres zmienisz obok: dziś, ten tydzień albo 30 dni.',
    'pageTours.home.upcoming.p3': 'Klik w rezerwację otwiera ją w kalendarzu ze wszystkimi szczegółami.',
    'pageTours.home.upcoming.title': 'Najbliższe rezerwacje',
    'pageTours.inventory.actions.lead': 'Cały sprzęt w jednej tabeli, a nad nią najczęstsze akcje.',
    'pageTours.inventory.actions.p1': '„Dodaj sprzęt" dodaje jedną sztukę; dłuższą listę wgrasz z arkusza (Profil → Import danych).',
    'pageTours.inventory.actions.p2': '„Ustawienia magazynu" decydują, jakie pola i kolumny ma Twój sprzęt.',
    'pageTours.inventory.actions.p3': '„Etykiety" drukują kody QR i kreskowe, a „Kalendarz sprzętu" pokazuje obłożenie sztuk.',
    'pageTours.inventory.actions.title': 'Magazyn',
    'pageTours.inventory.filters.lead': 'Jedno pole szuka po nazwie, marce, numerze i kodzie kreskowym.',
    'pageTours.inventory.filters.p1': 'Pigułki pod spodem zawężają listę - ustawiona pokazuje swoją wartość i krzyżyk do wyczyszczenia.',
    'pageTours.inventory.filters.p2': '„Aparat" i „Telefon" skanują kod z naklejki i od razu znajdują sztukę.',
    'pageTours.inventory.filters.p3': 'Klik w sztukę otwiera jej szczegóły z edycją i wydrukiem etykiety.',
    'pageTours.inventory.filters.title': 'Szukanie i filtry',
    'pageTours.inventory.title': 'Magazyn',
    'pageTours.invoices.filters.lead': 'Wyszukiwarka i filtry zawężają listę.',
    'pageTours.invoices.filters.p1': 'Szukasz po numerze, nabywcy albo NIP-ie; obok wybierzesz typ dokumentu i zakres dat.',
    'pageTours.invoices.filters.p2': 'Pigułki pod polami filtrują po płatności: nieopłacone, częściowo opłacone, opłacone.',
    'pageTours.invoices.filters.p3': 'W wierszu pobierzesz PDF i wyślesz fakturę VAT do KSeF (w trybie demo wysyłka do KSeF jest zablokowana).',
    'pageTours.invoices.filters.title': 'Lista dokumentów',
    'pageTours.invoices.new.lead': 'Tu wystawiasz proformy, faktury VAT i korekty.',
    'pageTours.invoices.new.p1': '„Nowa faktura" tworzy dokument z rezerwacji (pozycje i nabywca wypełnią się same) albo od zera.',
    'pageTours.invoices.new.p2': 'Kafelki pod spodem pokazują, ile czeka na zapłatę i co jest po terminie.',
    'pageTours.invoices.new.p3': 'Wystawionej faktury VAT nie edytujesz - poprawiasz ją korektą.',
    'pageTours.invoices.new.title': 'Faktury',
    'pageTours.invoices.title': 'Faktury',
    'pageTours.next': 'Dalej',
    'pageTours.notifications.email.lead': 'Maile do klientów wychodzą same - włączasz tylko te, których potrzebujesz.',
    'pageTours.notifications.email.p1': 'Cztery rodzaje: potwierdzenie rezerwacji, przypomnienie o odbiorze, o zwrocie i gotowa umowa.',
    'pageTours.notifications.email.p2': 'Po włączeniu rozwija się treść: dane klienta i rezerwacji wstawiasz pigułkami, a przycisk testu wysyła próbkę na Twój adres.',
    'pageTours.notifications.email.p3': 'Przypomnienia wychodzą tyle dni przed terminem, ile ustawisz, i tylko w godzinach 9-20.',
    'pageTours.notifications.email.title': 'Powiadomienia e-mail',
    'pageTours.notifications.sms.lead': 'SMS-y idą przez Twoje konto w SMSAPI.pl.',
    'pageTours.notifications.sms.p1': 'Włączasz je głównym przełącznikiem, a potem każdy rodzaj osobno - jak maile.',
    'pageTours.notifications.sms.p2': 'Token API wklejasz raz; po zapisie nie jest już nigdzie pokazywany.',
    'pageTours.notifications.sms.p3': 'W trybie demo wiadomości do klientów nie są wysyłane - test trafia tylko na Twój adres e-mail.',
    'pageTours.notifications.sms.title': 'Powiadomienia SMS',
    'pageTours.notifications.title': 'Powiadomienia',
    'pageTours.offer-template.fields.lead': 'Stałe elementy oferty ustawiasz raz, a dane klienta wypełniają się same.',
    'pageTours.offer-template.fields.p1': 'Pigułki wstawiają pola (klient, termin, kwota, numer konta) w miejscu kursora w polu tekstu.',
    'pageTours.offer-template.fields.p2': 'Tabele z danymi klienta, sprzętem i podsumowaniem tworzą się automatycznie.',
    'pageTours.offer-template.fields.p3': 'W nagłówku wyżej ustawisz tytuł, logo firmy i wielkość tekstu.',
    'pageTours.offer-template.fields.title': 'Konstruktor oferty',
    'pageTours.offer-template.preview.lead': 'Podgląd pokazuje ofertę na przykładowych danych.',
    'pageTours.offer-template.preview.p1': '„Podgląd PDF” i „Pobierz PDF” dają dokładnie ten plik, który dostanie klient.',
    'pageTours.offer-template.preview.p2': '„Zapisz szkic” niczego nie zmienia u klientów - nowa wersja działa dopiero po „Publikuj szablon”.',
    'pageTours.offer-template.preview.p3': 'Poprzednie opublikowane wersje zostają w historii.',
    'pageTours.offer-template.preview.title': 'Podgląd i publikacja',
    'pageTours.offer-template.title': 'Konstruktor oferty',
    'pageTours.offers.form.lead': 'Tu wyceniasz zapytanie, zanim powstanie rezerwacja.',
    'pageTours.offers.form.p1': 'Wpisujesz dane klienta (mail podpowiada istniejących), termin i sprzęt - cena liczy się z Twojego cennika.',
    'pageTours.offers.form.p2': 'Rabat podasz w złotówkach albo procentach; kwotę końcową możesz nadpisać ręcznie.',
    'pageTours.offers.form.p3': '„Generuj ofertę" robi PDF, „Wyślij ofertę emailem" wysyła go klientowi.',
    'pageTours.offers.form.title': 'Oferta dla klienta',
    'pageTours.offers.history.lead': 'Wysłane oferty nie giną - leżą w zakładce „Historia ofert".',
    'pageTours.offers.history.p1': 'Widzisz, co i komu poszło, i możesz wygenerować dokument jeszcze raz.',
    'pageTours.offers.history.p2': 'Z zaakceptowanej oferty zrobisz rezerwację bez przepisywania danych.',
    'pageTours.offers.history.p3': 'Sprzęt z oferty może być czasowo blokowany, żeby ktoś nie zarezerwował go w międzyczasie.',
    'pageTours.offers.history.title': 'Historia ofert',
    'pageTours.offers.title': 'Oferty',
    'pageTours.payment-settings.account.lead': 'Po podłączeniu konta w tej karcie pojawiają się ustawienia płatności.',
    'pageTours.payment-settings.account.p1': '„Zaliczka w widgecie": jaki procent kwoty klient płaci online przy rezerwacji.',
    'pageTours.payment-settings.account.p2': 'Auto-anulowanie: rezerwacja z widgetu bez wpłaty znika po wybranej liczbie godzin, a klient dostaje wcześniej przypomnienie.',
    'pageTours.payment-settings.account.p3': 'Wstrzymanie płatności online wyłącza nowe płatności bez odłączania konta.',
    'pageTours.payment-settings.account.title': 'Konto i zasady płatności',
    'pageTours.payment-settings.intro.lead': 'Klienci płacą BLIK-iem albo kartą, a pieniądze trafiają prosto na Twoje konto.',
    'pageTours.payment-settings.intro.p1': 'Płatności obsługuje Stripe - konto podłączasz raz, na jego bezpiecznej stronie.',
    'pageTours.payment-settings.intro.p2': 'Bez podłączenia rezerwacje działają dalej: zaliczkę przyjmujesz gotówką albo przelewem.',
    'pageTours.payment-settings.intro.p3': 'W trybie demo płatności online są wyłączone - żadna karta nie zostanie obciążona.',
    'pageTours.payment-settings.intro.title': 'Płatności online',
    'pageTours.payment-settings.title': 'Płatności online',
    'pageTours.payments.deposits.lead': 'Kafelki u góry mówią, ile już zebrano i ile wpłat czeka na klienta.',
    'pageTours.payments.deposits.p1': 'Zaliczka potwierdza rezerwację; jej procent ustawiasz w ustawieniach płatności.',
    'pageTours.payments.deposits.p2': 'Kaucja przechodzi przez blokadę na karcie, a potem ściągnięcie albo zwolnienie.',
    'pageTours.payments.deposits.p3': 'W trybie demo płatności online są wyłączone - żadna karta nie zostanie obciążona.',
    'pageTours.payments.deposits.title': 'Zaliczki i kaucje',
    'pageTours.payments.list.lead': 'Razem: płatności online i te przyjęte na miejscu.',
    'pageTours.payments.list.p1': 'Pigułki statusu filtrują listę - te same kolory co odznaki w tabeli.',
    'pageTours.payments.list.p2': 'Zakres dat i wyszukiwarka zawężają listę do konkretnej sprawy.',
    'pageTours.payments.list.p3': 'Płatności online rozliczasz z wypłatami ze Stripe; gotówka i przelew są zapisywane ręcznie przy rezerwacji.',
    'pageTours.payments.list.title': 'Wpłaty klientów',
    'pageTours.payments.title': 'Płatności',
    'pageTours.prev': 'Wstecz',
    'pageTours.price-rules.form.lead': 'Gdy potrzebujesz czegoś spoza gotowców.',
    'pageTours.price-rules.form.p1': '„Nowa reguła" otwiera formularz: zakres dat, dni tygodnia, klasa lub typ sprzętu i zmiana - procent albo kwota.',
    'pageTours.price-rules.form.p2': 'Priorytet rozstrzyga, która reguła wygrywa, gdy pasuje kilka naraz.',
    'pageTours.price-rules.form.p3': 'Reguły działają wszędzie tam, gdzie liczy się cena: rezerwacje, oferty i widget.',
    'pageTours.price-rules.form.title': 'Własna reguła',
    'pageTours.price-rules.presets.lead': 'Najprostszy start: włącz gotową regułę przełącznikiem.',
    'pageTours.price-rules.presets.p1': 'Dopłata weekendowa, sezon wysoki i promocja poza sezonem - z gotowymi zakresami dat.',
    'pageTours.price-rules.presets.p2': 'Chipy obok wybierają wielkość zmiany (np. +10%, +15%, +20%).',
    'pageTours.price-rules.presets.p3': 'Wyłączenie przełącznika tylko usypia regułę, nie kasuje jej.',
    'pageTours.price-rules.presets.title': 'Szybkie reguły',
    'pageTours.price-rules.title': 'Cenniki sezonowe',
    'pageTours.profile.account.lead': 'Ustawienia są podzielone na grupy - pierwsza dotyczy Ciebie.',
    'pageTours.profile.account.p1': '„Twoje dane" i „Bezpieczeństwo": kontakt, hasło i logowanie dwuetapowe.',
    'pageTours.profile.account.p2': '„Twoje preferencje": motyw jasny albo ciemny i język panelu.',
    'pageTours.profile.account.p3': '„Użytkownicy": konta dla pracowników - każdy loguje się własnym loginem.',
    'pageTours.profile.account.title': 'Twoje konto',
    'pageTours.profile.company.lead': 'Niżej są ustawienia całej wypożyczalni.',
    'pageTours.profile.company.p1': '„Dane firmy" trafiają na umowy, oferty i faktury - uzupełnij je przed pierwszym dokumentem.',
    'pageTours.profile.company.p2': 'W „Sprzedaży" są dynamiczne ceny (sezony, weekendy) i pakiety sprzętu.',
    'pageTours.profile.company.p3': 'W „Integracjach": wysyłka maili, import danych z arkusza i widget na stronę.',
    'pageTours.profile.company.title': 'Firma i sprzedaż',
    'pageTours.profile.title': 'Profil',
    'pageTours.reservation.client.lead': 'Formularz idzie od góry: klient, termin, sprzęt, płatność.',
    'pageTours.reservation.client.p1': 'Zacznij od nazwiska - podpowiemy klientów, którzy już u Ciebie byli, i uzupełnimy ich dane.',
    'pageTours.reservation.client.p2': 'Nowa osoba sama trafi do bazy klientów przy zapisie rezerwacji.',
    'pageTours.reservation.client.p3': 'Pola z gwiazdką są wymagane; adres rozpiszesz na ulicę, kod i miasto po kliknięciu w pole.',
    'pageTours.reservation.client.title': 'Nowa rezerwacja',
    'pageTours.reservation.equipment.lead': 'Sprzęt dobierasz po wybraniu terminu - wtedy wiadomo, co jest wolne.',
    'pageTours.reservation.equipment.p1': '„Wybierz sprzęt" pokazuje tylko sztuki dostępne w tym terminie.',
    'pageTours.reservation.equipment.p2': 'Sztukę dodasz też skanem kodu: czytnikiem, aparatem albo telefonem.',
    'pageTours.reservation.equipment.p3': 'Cena liczy się sama z cennika i pakietów, a podsumowanie na dole pokazuje rabat i zaliczkę.',
    'pageTours.reservation.equipment.title': 'Sprzęt do rezerwacji',
    'pageTours.reservation.title': 'Nowa rezerwacja',
    'pageTours.skip': 'Pomiń przewodnik',
    'pageTours.statistics.charts.lead': 'Wykresy liczą się z Twoich rezerwacji - nic nie trzeba uzupełniać.',
    'pageTours.statistics.charts.p1': 'Przełącznik tutaj zmienia miarę wykresów: liczba rezerwacji albo wartość w złotówkach.',
    'pageTours.statistics.charts.p2': '„Sezonowość" pokazuje rozkład w roku - od razu widać szczyt i martwe miesiące.',
    'pageTours.statistics.charts.p3': 'Na dole strony, w „Metrykach zaawansowanych”, tabela „Wartość wypożyczeń / sztuka”: sprzęt, który w wybranym okresie przyniósł najwięcej, z liczbą wypożyczeń. Podstawa do decyzji, co dokupić.',
    'pageTours.statistics.charts.title': 'Jak idzie biznes',
    'pageTours.statistics.kpi.lead': 'Sekcja KPI ma własne filtry roku, miesiąca i sezonu.',
    'pageTours.statistics.kpi.p1': 'Wybierasz rok, miesiąc albo sezon - wskaźniki przeliczają się dla tego okresu. Procent pod kafelkami porównuje go z tym samym okresem rok wcześniej, a okres w toku liczy do dziś.',
    'pageTours.statistics.kpi.p2': '„Wyczyść" wraca do bieżącego miesiąca, a wykresy do bieżącego roku. Strzałki roku nad wykresem ustawiają wskaźniki na cały rok.',
    'pageTours.statistics.kpi.p3': 'Wykorzystanie sprzętu i średnia wartość wypożyczenia mówią, czy podnieść ceny.',
    'pageTours.statistics.kpi.title': 'Wskaźniki za okres',
    'pageTours.statistics.title': 'Statystyki',
    'pageTours.widget.embed.lead': 'Nad tym miejscem zmieniasz nazwę, kolory i zdjęcia kategorii - podgląd zmienia się od razu.',
    'pageTours.widget.embed.p1': '„Pokaż kod" daje fragment do wklejenia na Twojej stronie.',
    'pageTours.widget.embed.p2': '„Dozwolone domeny" to strony, na które klient wraca po płatności online; widget z kodu i link z kodem QR działają zawsze.',
    'pageTours.widget.embed.p3': 'Zdjęcia kategorii wgrywasz z dysku - widget nie pobiera obrazków z innych stron.',
    'pageTours.widget.embed.title': 'Ustawienia i instalacja',
    'pageTours.widget.preview.lead': 'Widget to formularz rezerwacji, który wstawiasz na swoją stronę.',
    'pageTours.widget.preview.p1': 'Podgląd na żywo pokazuje go tak, jak zobaczy go klient - na komputerze i na telefonie.',
    'pageTours.widget.preview.p2': 'Klient wybiera termin i sprzęt, a rezerwacja trafia prosto do Twojego kalendarza. Na koncie demo widget rezerwacji nie przyjmuje.',
    'pageTours.widget.preview.p3': 'Dostępność liczy się z magazynu i rezerwacji, więc klient nie zarezerwuje zajętego sprzętu.',
    'pageTours.widget.preview.title': 'Widget rezerwacji',
    'pageTours.widget.title': 'Widget',

    // ── P8.1e (2/5): ustawienia firmy i powiadomien ──
    'contractSettings.alignCenter': 'Wyśrodkowane',
    'contractSettings.alignLeft': 'Do lewej',
    'contractSettings.alignRight': 'Do prawej',
    'contractSettings.autoEmail': 'Automatycznie wysyłaj fakturę emailem do nabywcy',
    'contractSettings.autoEmailHint': 'Po wystawieniu faktury VAT, paragonu lub korekty system automatycznie wyśle PDF na adres email klienta.',
    'contractSettings.bankCard': 'Dane bankowe',
    'contractSettings.bankName': 'Nazwa banku',
    'contractSettings.bankNamePh': 'PKO Bank Polski S.A.',
    'contractSettings.changeLogo': 'Zmień logo',
    'contractSettings.city': 'Miasto',
    'contractSettings.cityPh': 'Warszawa',
    'contractSettings.companyCard': 'Dane firmy (wypożyczalni)',
    'contractSettings.companyName': 'Pełna nazwa firmy',
    'contractSettings.companyNamePh': 'np. Twoja Firma Sp. z o.o.',
    'contractSettings.email': 'E-mail firmy',
    'contractSettings.emailBody': 'Treść emaila',
    'contractSettings.emailPh': 'kontakt@twojafirma.pl',
    'contractSettings.emailSubject': 'Temat emaila',
    'contractSettings.goToBuilder': 'Przejdź do Konstruktora Umowy →',
    'contractSettings.iban': 'Numer konta (IBAN)',
    'contractSettings.ibanPh': 'PL 12 3456 7890 1234 5678 9012 3456',
    'contractSettings.insertVarHint': 'Kliknij, aby wstawić zmienną w polu Temat lub Treść (w miejscu kursora):',
    'contractSettings.insertVarTitle': 'Kliknij, aby wstawić',
    'contractSettings.invoiceCard': 'Ustawienia faktur',
    'contractSettings.krs': 'KRS (opcjonalnie)',
    'contractSettings.loadError': 'Nie udało się załadować ustawień umowy.',
    'contractSettings.loading': 'Ładowanie…',
    'contractSettings.logoAlign': 'Wyrównanie logo',
    'contractSettings.logoCard': 'Logo firmy',
    'contractSettings.logoHeight': 'Wysokość logo (px)',
    'contractSettings.logoHeightError': 'Wpisz liczbę całkowitą od {min} do {max}.',
    'contractSettings.logoHeightHint': 'Od {min} do {max} px, puste pole to {def} px. Szerokie logo ogranicza też szerokość 260 px, więc może wyjść niższe niż wpisana wysokość.',
    'contractSettings.saveBlockedAfterLoadError': 'Odśwież stronę, zanim zapiszesz: zapis jest wyłączony, żeby puste pola nie nadpisały zapisanych danych firmy.',
    'contractSettings.logoHint': 'Pojawia się na górze generowanych umów. PNG, JPG, WEBP lub SVG, maksymalnie 1 MB.',
    'contractSettings.logoTooBig': 'Logo jest za duże. Maksymalny rozmiar to 1 MB.',
    'contractSettings.logoType': 'Logo musi być plikiem PNG, JPG, WEBP lub SVG.',
    'contractSettings.missingDataBody': 'Brakuje danych firmy: {list}. Te dane są automatycznie wstawiane do umów. Bez nich umowy będą miały puste pola. Przejść do Konstruktora mimo to?',
    'contractSettings.missingDataTitle': 'Brakuje danych firmy',
    'contractSettings.noLogo': 'Brak logo',
    'contractSettings.numberFormat': 'Numer faktury będzie miał format:',
    'contractSettings.payBlik': 'BLIK',
    'contractSettings.payCard': 'Karta płatnicza',
    'contractSettings.payCash': 'Gotówka',
    'contractSettings.payMethod': 'Domyślny sposób zapłaty',
    'contractSettings.payOther': 'Inny',
    'contractSettings.payTerm': 'Domyślny termin płatności (dni)',
    'contractSettings.payTransfer': 'Przelew bankowy',
    'contractSettings.phone': 'Telefon firmy',
    'contractSettings.pickLogo': 'Wybierz plik logo',
    'contractSettings.postalCode': 'Kod pocztowy',
    'contractSettings.prefixCorrection': 'Korekta',
    'contractSettings.prefixProforma': 'Proforma',
    'contractSettings.prefixSimplified': 'Paragon / uproszczona',
    'contractSettings.prefixVat': 'Faktura VAT',
    'contractSettings.prefixes': 'Prefiksy numeracji faktur',
    'contractSettings.regon': 'REGON (opcjonalnie)',
    'contractSettings.removeLogo': 'Usuń logo',
    'contractSettings.save': 'Zapisz ustawienia',
    'contractSettings.saveError': 'Błąd zapisu',
    'contractSettings.saveGenericError': 'Błąd zapisu ustawień.',
    'contractSettings.saveInvoiceError': 'Błąd zapisu ustawień faktur',
    'contractSettings.saved': 'Dane firmy i ustawienia faktur zostały zapisane.',
    'contractSettings.saving': 'Zapisywanie…',
    'contractSettings.signerCard': 'Osoba podpisująca umowę',
    'contractSettings.signerName': 'Imię i nazwisko',
    'contractSettings.signerNamePh': 'Jan Kowalski',
    'contractSettings.signerTitle': 'Stanowisko / funkcja',
    'contractSettings.signerTitlePh': 'Właściciel / Prezes Zarządu',
    'contractSettings.street': 'Ulica i numer',
    'contractSettings.streetPh': 'ul. Przykładowa 1',
    'contractSettings.subtitle': 'Dane Twojej wypożyczalni są automatycznie uzupełniane w generowanych umowach.',
    'contractSettings.title': 'Dane firmy',
    'contractSettings.unsavedBanner': 'Masz niezapisane zmiany. Zapisz je przed przejściem do innej strony.',
    'contractSettings.pauseNote': 'Konto jest w przerwie: dane firmy są tylko do podglądu, a ustawienia faktur zapiszesz jak zwykle.',
    'contractSettings.unsavedBody': 'Masz niezapisane zmiany. Czy na pewno chcesz przejść do Konstruktora Umowy?',
    'contractSettings.unsavedTitle': 'Niezapisane zmiany',
    'contractSettings.varBuyerName': 'Nazwa nabywcy',
    'contractSettings.varDocLabel': 'Typ dokumentu',
    'contractSettings.varInvoiceNumber': 'Numer faktury',
    'contractSettings.varOrganizationName': 'Nazwa firmy',
    'contractSettings.varTotalGross': 'Kwota brutto',
    'contractSettings.varAmountPaid': 'Zapłacono',
    'contractSettings.varAmountDue': 'Pozostało do zapłaty',
    'contractSettings.vatRate': 'Domyślna stawka VAT',
    'contractSettings.vatStatus': 'Status VAT',
    'contractSettings.vatStatusActive': 'Czynny podatnik VAT',
    'contractSettings.vatStatusExempt': 'Zwolniony z VAT',
    'contractSettings.vatRateZero': '0% (krajowa, to nie zwolnienie)',
    'contractSettings.vatRateLegacy': '{rate}% (spoza listy, wybierz inną stawkę)',
    'contractSettings.vatZeroHint': 'Stawka 0% to nie zwolnienie z VAT. Jeśli firma jest zwolniona z VAT, wybierz status „Zwolniony z VAT” i podaj podstawę zwolnienia. Faktury już wystawione się nie zmienią.',
    'contractSettings.vatBasis': 'Podstawa zwolnienia z VAT',
    'contractSettings.vatBasisPh': 'np. art. 113 ust. 1 ustawy o VAT',
    'contractSettings.vatBasis113': 'art. 113 ust. 1: sprzedaż do 240 000 zł w poprzednim roku',
    'contractSettings.vatBasis1139': 'art. 113 ust. 9: działalność rozpoczęta w tym roku',
    'contractSettings.vatBasis43': 'art. 43 ust. 1: usługa zwolniona z mocy ustawy (wpisz punkt)',
    'contractSettings.vatExemptHint': 'Faktury firmy zwolnionej mają tytuł „Faktura”, pozycje ze stawką „zw” i zdanie o zwolnieniu z tą podstawą. Od 2026 roku zwolnienie podmiotowe przysługuje przy sprzedaży do 240 000 zł rocznie. Podstawę najlepiej potwierdzić z księgową.',
    'contractSettings.vatBasisRequired': 'Firma zwolniona z VAT musi podać podstawę zwolnienia.',
    'contractSettings.vatBasisIncomplete': 'Uzupełnij podstawę zwolnienia: w miejscu „…” wpisz numer punktu.',
    'notifications.active': 'Aktywne',
    'notifications.body': 'Treść wiadomości',
    'notifications.chars': 'znaków',
    'notifications.confirmDesc': 'Wysyłane automatycznie do klienta zaraz po utworzeniu rezerwacji.',
    'notifications.confirmLabel': 'Potwierdzenie rezerwacji',
    'notifications.contractDesc': 'Wysyłane do klienta gdy pracownik generuje umowę wypożyczenia w systemie.',
    'notifications.contractLabel': 'Umowa gotowa',
    'notifications.daysBefore': 'dni przed',
    'notifications.demoNotice': 'Tryb demo - wiadomości do klientów nie są wysyłane. Wiadomość testowa trafia wyłącznie na Twój adres e-mail.',
    'notifications.premiumTitle': 'Automatyczne przypomnienia i SMS-y są w planie Premium.',
    'notifications.premiumBody': 'Na planie Basic klient dostaje mailem potwierdzenie rezerwacji i umowę.',
    'notifications.remindersPremium': 'Przypomnienia o odbiorze i zwrocie są w planie Premium. Zapisane ustawienia zaczną działać po przejściu na Premium.',
    'notifications.smsPremium': 'SMS-y do klientów (potwierdzenie rezerwacji i przypomnienie o zwrocie) są w planie Premium. Zapisane ustawienia zaczną działać po przejściu na Premium, a zapisany token SMSAPI możesz usunąć.',
    'notifications.superAdminNotPremium': 'Twoja firma nie jest na planie Premium. Jako super-admin zapiszesz przypomnienia i SMS-y, ale nie zostaną wysłane, dopóki firma nie przejdzie na Premium.',
    'notifications.emailCard': 'Powiadomienia e-mail',
    'notifications.inactive': 'Wyłączone',
    'notifications.insertData': 'Wstaw dane:',
    'notifications.insertHint': 'Kliknij przycisk, aby wstawić dane klienta lub firmy w odpowiednie miejsce w tekście.',
    'notifications.loadError': 'Nie udało się załadować ustawień powiadomień.',
    'notifications.loading': 'Ładowanie…',
    'notifications.pickupDesc': 'Wysyłane automatycznie N dni przed planowanym odbiorem sprzętu.',
    'notifications.pickupLabel': 'Przypomnienie o odbiorze',
    'notifications.returnDesc': 'Wysyłane automatycznie N dni przed upływem terminu zwrotu sprzętu.',
    'notifications.returnLabel': 'Przypomnienie o zwrocie',
    'notifications.save': 'Zapisz ustawienia',
    'notifications.saveError': 'Błąd zapisu',
    'notifications.saveGenericError': 'Błąd zapisu.',
    'notifications.saved': 'Ustawienia powiadomień zostały zapisane.',
    'notifications.saving': 'Zapisywanie…',
    'notifications.sendError': 'Błąd wysyłki',
    'notifications.sendTest': 'Wyślij testowy email na mój adres',
    'notifications.sending': 'Wysyłanie…',
    'notifications.smsBody': 'Treść SMS (maks. 160 znaków)',
    'notifications.smsCard': 'Powiadomienia SMS',
    'notifications.smsConfirmDesc': 'Krótka wiadomość SMS zaraz po złożeniu rezerwacji.',
    'notifications.smsConfirmLabel': 'Potwierdzenie rezerwacji (SMS)',
    'notifications.smsEnableDesc': 'Po włączeniu możesz aktywować poszczególne powiadomienia SMS poniżej.',
    'notifications.smsEnableLabel': 'Włącz SMS (SMSAPI.pl)',
    'notifications.smsInfoAfter': ' (koszt ~0,09 zł/SMS). Wymagane jest własne konto i token API.',
    'notifications.smsInfoBefore': 'SMS-y są wysyłane przez serwis',
    'notifications.smsReturnDesc': 'Krótki SMS N dni przed upływem terminu zwrotu sprzętu.',
    'notifications.smsReturnLabel': 'Przypomnienie o zwrocie (SMS)',
    'notifications.smsSender': 'Nadawca SMS (maks. 11 znaków, bez spacji)',
    'notifications.smsSenderPh': 'np. therENT',
    'notifications.smsStep1a': 'Załóż konto na',
    'notifications.smsStep1b': 'i doładuj konto',
    'notifications.smsStep2a': 'Wejdź w',
    'notifications.smsStep2b': 'API → Tokeny dostępu',
    'notifications.smsStep2c': 'i skopiuj token OAuth',
    'notifications.smsStep3': 'Wklej token poniżej i zapisz ustawienia',
    'notifications.smsToken': 'Token API (SMSAPI OAuth)',
    'notifications.smsTokenPh': 'Wklej token z panelu SMSAPI',
    'notifications.smsTokenSavedPh': 'Token zapisany. Wpisz nowy, aby go zmienić',
    'notifications.smsTokenRemove': 'Usuń zapisany token',
    'notifications.smsTokenWillRemove': 'Token zostanie usunięty po zapisaniu ustawień.',
    'notifications.tomorrowMismatch': 'Treść mówi „jutro”, a przypomnienie wychodzi wcześniej niż dzień przed terminem, więc klient dostanie nieprawdziwą informację. Wstaw datę zamiast „jutro” albo ustaw 1 dzień.',
    'notifications.smtpInfoAfter': '.',
    'notifications.smtpInfoBefore': 'Bez własnego serwera poczty maile do klientów wychodzą z adresu the.rENT, podpisane nazwą Twojej wypożyczalni, a odpowiedzi trafiają na e-mail z Danych firmy. Własny serwer poczty (plan Premium) ustawisz na ekranie',
    'notifications.subject': 'Temat wiadomości',
    'notifications.subtitle': 'Automatyczne wiadomości wysyłane do klientów przy rezerwacjach. Włącz tylko to, czego potrzebujesz.',
    'notifications.title': 'Powiadomienia dla klientów',
    'notifications.usedInBody': 'Użyte w treści:',
    'notifications.varEndDate': 'Data zwrotu',
    'notifications.varFirstName': 'Imię',
    'notifications.varLastName': 'Nazwisko',
    'notifications.varOrgName': 'Nazwa firmy',
    'notifications.varOrgPhone': 'Telefon firmy',
    'notifications.varPickupDate': 'Data odbioru',
    'notifications.varReturnDate': 'Data zwrotu',
    'notifications.varReservationId': 'Numer rezerwacji',
    'notifications.varOrgEmail': 'E-mail wypożyczalni',
    'notifications.varOrgContact': 'Kontakt (e-mail i telefon)',
    'notifications.widgetEmailsCard': 'Maile do klientów z widgetu',
    'notifications.widgetEmailsInfo': 'Te maile wychodzą zawsze, gdy klient rezerwuje przez widget. Możesz zmienić temat, wstęp i zakończenie. Numer, termin, kwoty, link do zapłaty i dane do przelewu dodajemy sami, więc nie da się ich przypadkiem usunąć.',
    'notifications.widgetEmailCustom': 'Własny tekst',
    'notifications.widgetEmailDefault': 'Tekst domyślny',
    'notifications.widgetEmailEdit': 'Edytuj tekst',
    'notifications.widgetEmailCollapse': 'Zwiń',
    'notifications.widgetEmailIntro': 'Wstęp',
    'notifications.widgetEmailOutro': 'Zakończenie',
    'notifications.widgetEmailSystemPart': 'Między wstępem a zakończeniem dodamy:',
    'notifications.widgetEmailReset': 'Przywróć tekst domyślny',
    'notifications.widgetEmail.confirm.label': 'Potwierdzenie rezerwacji',
    'notifications.widgetEmail.confirm.desc': 'Po rezerwacji w widgecie. W rezerwacji według klas po potwierdzeniu dostępności.',
    'notifications.widgetEmail.confirm.system': 'numer rezerwacji, termin, kwotę do zapłaty oraz link do zapłaty online albo dane do przelewu z terminem płatności.',
    'notifications.widgetEmail.request.label': 'Przyjęcie zapytania o klasy',
    'notifications.widgetEmail.request.desc': 'Gdy klient wybiera klasę sprzętu, zanim potwierdzisz dostępność.',
    'notifications.widgetEmail.request.system': 'numer i termin, zamówiony sprzęt z wymiarami, szacowaną wartość i informację, że klient płaci dopiero po potwierdzeniu.',
    'notifications.widgetEmail.decline.label': 'Odmowa zapytania',
    'notifications.widgetEmail.decline.desc': 'Gdy odrzucasz zapytanie o klasy.',
    'notifications.widgetEmail.decline.system': 'numer i termin zapytania, informację o anulowaniu i wiadomość wpisaną przy odmowie.',
    'notifications.widgetEmail.unpaid_reminder.label': 'Przypomnienie o płatności',
    'notifications.widgetEmail.unpaid_reminder.desc': 'Gdy rezerwacja nie jest opłacona, przed automatycznym anulowaniem. Także rezerwacje z panelu z terminem wpłaty.',
    'notifications.widgetEmail.unpaid_reminder.system': 'numer i termin, kwotę, przycisk „Zapłać online” i informację, kiedy rezerwacja zostanie anulowana.',
    'notifications.widgetEmail.unpaid_cancel.label': 'Anulowanie z braku wpłaty',
    'notifications.widgetEmail.unpaid_cancel.desc': 'Gdy rezerwacja zostaje anulowana, bo wpłata nie dotarła.',
    'notifications.widgetEmail.unpaid_cancel.system': 'numer i termin oraz informację, że rezerwacja została anulowana z braku wpłaty.',
    'notifications.varStartDate': 'Data odbioru',
    'notifications.willInsert': 'Wstawi: {var}',

    // ── P8.1e (1/4): wejscie do aplikacji + poczta ──
    'activation.activationError': 'Błąd podczas aktywacji konta.',
    'activation.adminSection': 'Dane Administratora',
    'activation.adminSectionHint': 'Utwórz konto administratora dla swojej wypożyczalni. Po aktywacji będziesz mógł zarządzać pracownikami i sprzętem.',
    'activation.checkingToken': 'Sprawdzanie tokena aktywacyjnego...',
    'activation.connectionErrorLater': 'Błąd połączenia z serwerem. Spróbuj ponownie później.',
    'activation.connectionErrorRetry': 'Błąd połączenia z serwerem. Spróbuj ponownie.',
    'activation.email': 'Email (login) *',
    'activation.emailHint': 'Ten email będzie Twoim loginem do systemu',
    'activation.emailInvalid': 'Nieprawidłowy format email',
    'activation.emailRequired': 'Email jest wymagany',
    'activation.firstname': 'Imię *',
    'activation.firstnameRequired': 'Imię jest wymagane',
    'activation.footer': 'Po aktywacji będziesz mógł zalogować się do systemu i zarządzać swoją wypożyczalnią.',
    'activation.termsBefore': 'Akceptuję',
    'activation.termsLink': 'Regulamin świadczenia usług',
    'activation.termsAfter': '.',
    'activation.termsRequired': 'Zaakceptuj regulamin, aby aktywować konto.',
    'activation.demoDataNote': 'Konto demo służy do sprawdzenia systemu na danych przykładowych. Nie wpisuj danych prawdziwych klientów.',
    'activation.goToLogin': 'Przejdź do logowania',
    'activation.invalidLinkBody': 'Link aktywacyjny mógł wygasnąć lub został już użyty.',
    'activation.invalidLinkTitle': 'Nieprawidłowy Link',
    'activation.invalidToken': 'Token aktywacyjny jest nieprawidłowy lub wygasł.',
    'activation.lastname': 'Nazwisko *',
    'activation.lastnameRequired': 'Nazwisko jest wymagane',
    'activation.password': 'Hasło *',
    'activation.passwordConfirm': 'Potwierdź hasło *',
    'activation.passwordMin8': 'Hasło musi mieć minimum 8 znaków',
    'activation.passwordMax128': 'Hasło może mieć maksymalnie 128 znaków',
    'activation.passwordTooWeak': 'Hasło jest za słabe. Wydłuż je albo dopisz kilka słów.',
    'activation.passwordStrength': 'Siła hasła',
    'activation.passwordRequirements': 'Wymagania',
    'activation.reqLength': 'Co najmniej {min} znaków',
    'activation.reqStrength': 'Siła hasła co najmniej „{strength}”',
    'activation.reqMatch': 'Oba hasła są takie same',
    'activation.passwordTip': 'Najprościej o silne hasło: kilka niepowiązanych słów albo krótkie zdanie. Zamiana liter na cyfry (np. „a” na „4”) niewiele daje.',
    'activation.passwordMismatch': 'Hasła nie są identyczne',
    'activation.passwordRequired': 'Hasło jest wymagane',
    'activation.phEmail': 'jan@wypozyczalnia.pl',
    'activation.phFirstname': 'Jan',
    'activation.phLastname': 'Kowalski',
    'activation.phone': 'Telefon *',
    'activation.phoneDigits': 'Telefon musi mieć 9 cyfr',
    'activation.phoneRequired': 'Telefon jest wymagany',
    'activation.redirecting': 'Za chwilę zostaniesz przekierowany do strony logowania...',
    'activation.rentalLabel': 'Wypożyczalnia:',
    'activation.submit': 'Aktywuj Konto',
    'activation.submitting': 'Aktywacja...',
    'activation.successAfter': ' została pomyślnie aktywowana.',
    'activation.successBefore': 'Twoja wypożyczalnia',
    'activation.successTitle': 'Konto aktywowane!',
    'activation.title': 'Aktywacja Konta',
    'emailSettings.bccHelp': 'Każda wysłana oferta będzie kopiowana na ten adres.',
    'emailSettings.bccLabel': 'BCC - kopia ukryta (opcjonalnie)',
    'emailSettings.bccPlaceholder': 'np. archiwum@twojafirma.pl',
    'emailSettings.connectionError': 'Błąd połączenia z serwerem',
    'emailSettings.deleteConfig': 'Usuń konfigurację',
    'emailSettings.deleteConfirmBody': 'Oferty będą wysyłane z domyślnego adresu systemowego.',
    'emailSettings.deleteConfirmTitle': 'Na pewno chcesz usunąć konfigurację email?',
    'emailSettings.deleting': 'Usuwanie...',
    'emailSettings.demoNotice': 'Tryb demo - konfiguracja własnego SMTP jest niedostępna.',
    'emailSettings.premiumTitle': 'Własny serwer poczty jest w planie Premium.',
    'emailSettings.premiumBody': 'Na planie Basic maile do Twoich klientów wychodzą z adresu the.rENT, podpisane nazwą Twojej wypożyczalni, a odpowiedzi trafiają na e-mail z Danych firmy.',
    'emailSettings.premiumSavedNote': 'Zapisana konfiguracja zostaje i zacznie działać po przejściu na Premium. Możesz ją też usunąć.',
    'emailSettings.superAdminNotPremium': 'Twoja firma nie jest na planie Premium. Jako super-admin zapiszesz i sprawdzisz konfigurację, ale maile do klientów wyjdą z adresu the.rENT, dopóki firma nie przejdzie na Premium.',
    'emailSettings.emailExamplePlaceholder': 'np. oferty@twojafirma.pl',
    'emailSettings.enableHelp': 'Gdy wyłączone, oferty są wysyłane z domyślnego adresu systemowego.',
    'emailSettings.enableLabel': 'Włącz własny email',
    'emailSettings.fromEmailLabel': 'Email nadawcy *',
    'emailSettings.fromNameLabel': 'Nazwa nadawcy *',
    'emailSettings.fromNamePlaceholder': 'np. Wypożyczalnia Narciarska XYZ',
    'emailSettings.gmailStep1': 'Zaloguj się na konto Google, z którego chcesz wysyłać maile',
    'emailSettings.gmailStep2': 'Wejdź na',
    'emailSettings.gmailStep3a': 'Włącz',
    'emailSettings.gmailStep3b': 'Weryfikację dwuetapową',
    'emailSettings.gmailStep3c': '(jeśli jeszcze nie masz)',
    'emailSettings.gmailStep4': 'Po włączeniu 2FA wejdź na',
    'emailSettings.gmailStep5a': 'W polu „Nazwa aplikacji" wpisz np.',
    'emailSettings.gmailStep5b': 'i kliknij',
    'emailSettings.gmailStep5c': 'Utwórz',
    'emailSettings.gmailStep6a': 'Google wygeneruje',
    'emailSettings.gmailStep6b': '16-literowe hasło',
    'emailSettings.gmailStep6c': '- skopiuj je',
    'emailSettings.gmailStep7': 'Wróć tutaj i uzupełnij formularz:',
    'emailSettings.gmailTitle': 'Konfiguracja Gmail - krok po kroku',
    'emailSettings.gmailWarning': 'Gmail wymusza, aby pole „Email nadawcy" było takie samo jak Login SMTP. Jeśli chcesz wysyłać z innego adresu, dodaj go jako alias w Gmail → Ustawienia → Zobacz wszystkie ustawienia → Konta i importowanie → Wyślij jako → „Dodaj inny adres e-mail".',
    'emailSettings.helpBody': 'Gdy skonfigurujesz własny serwer SMTP, wszystkie oferty i powiadomienia wysyłane z systemu the.rENT będą wychodziły z Twojego adresu email. Klient otrzyma wiadomość z Twoją nazwą i adresem - wygląda to profesjonalnie i buduje zaufanie.',
    'emailSettings.helpTitle': 'Jak to działa?',
    'emailSettings.hostLabel': 'Host SMTP *',
    'emailSettings.hostPlaceholder': 'np. smtp.gmail.com',
    'emailSettings.importantLabel': 'Ważne:',
    'emailSettings.loginLabel': 'Login SMTP *',
    'emailSettings.otherServersBody': 'Jeśli korzystasz z hostingu (np. nazwa.pl, OVH) lub usług takich jak Mailgun, SendGrid czy Amazon SES - wpisz dane SMTP dostarczone przez dostawcę. Na tych serwerach pole „Email nadawcy" działa bez ograniczeń.',
    'emailSettings.otherServersTitle': 'Inne serwery SMTP',
    'emailSettings.passwordEnter': 'Wprowadź hasło',
    'emailSettings.passwordHelp': 'Zostaw puste, jeżeli nie chcesz zmieniać hasła.',
    'emailSettings.passwordKeep': '(bez zmian - zostaw puste)',
    'emailSettings.passwordLabel': 'Hasło SMTP *',
    'emailSettings.port25': '25 (bez szyfrowania)',
    'emailSettings.port2525': '2525 (alternatywny)',
    'emailSettings.port587': '587 (STARTTLS - zalecany)',
    'emailSettings.replyToHelp': 'Jeśli klient odpowie na ofertę, wiadomość trafi na ten adres.',
    'emailSettings.replyToLabel': 'Reply-To (opcjonalnie)',
    'emailSettings.replyToPlaceholder': 'Adres do odpowiedzi',
    'emailSettings.save': 'Zapisz ustawienia',
    'emailSettings.saveError': 'Błąd zapisu',
    'emailSettings.saved': 'Ustawienia zapisane pomyślnie!',
    'emailSettings.sendErrorCause.auth': 'błędny login albo hasło',
    'emailSettings.sendErrorCause.connect': 'nie udało się połączyć z serwerem',
    'emailSettings.sendErrorCause.connectionLost': 'serwer przerwał połączenie',
    'emailSettings.sendErrorCause.dns': 'nie znaleziono serwera o tej nazwie',
    'emailSettings.sendErrorCause.other': 'błąd serwera poczty',
    'emailSettings.sendErrorCause.rejected': 'serwer odrzucił wiadomość',
    'emailSettings.sendErrorCause.sender': 'serwer nie przyjął adresu nadawcy',
    'emailSettings.sendErrorCause.timeout': 'serwer przestał odpowiadać',
    'emailSettings.sendErrorCause.tls': 'nie udało się nawiązać szyfrowanego połączenia (sprawdź ustawienie SSL, port i certyfikat serwera)',
    'emailSettings.sendErrorFallback': 'Mail wysłaliśmy z adresu the.rENT z nazwą Twojej wypożyczalni, a odpowiedzi trafią na Twój adres.',
    'emailSettings.sendErrorFix': 'Sprawdź ustawienia serwera poczty, zapisz je i wyślij test. Komunikat zniknie po zapisaniu ustawień albo po pierwszej udanej wysyłce.',
    'emailSettings.sendErrorOpen': 'Otwórz Ustawienia email',
    'emailSettings.sendErrorNoFallback': 'Mail mógł nie dotrzeć do klienta. Nie wysłaliśmy go drugi raz, bo serwer mógł go już przyjąć.',
    'emailSettings.sendErrorTitle': 'Ostatni mail nie wyszedł przez Twój serwer poczty.',
    'emailSettings.sendErrorWhen': '{czas}: {przyczyna}.',
    'emailSettings.senderLabel': 'Nadawca:',
    'emailSettings.senderSubtitle': 'Te dane będą widoczne jako nadawca w wysyłanych ofertach.',
    'emailSettings.senderTitle': 'Dane nadawcy',
    'emailSettings.smtpSubtitle': 'Wprowadź dane serwera poczty wychodzącej. Wybierz preset lub wpisz ręcznie.',
    'emailSettings.smtpTitle': 'Serwer SMTP',
    'emailSettings.sslHelp': 'Włącz dla portu 465. Dla portu 587 zazwyczaj STARTTLS (wyłączone).',
    'emailSettings.sslLabel': 'Połączenie SSL',
    'emailSettings.statusTitle': 'Status konfiguracji',
    'emailSettings.subtitle': 'Skonfiguruj własny adres email do wysyłki ofert i powiadomień',
    'emailSettings.tblFrom': 'Email nadawcy',
    'emailSettings.tblFromValue': 'Ten sam adres co Login SMTP',
    'emailSettings.tblHost': 'Host SMTP',
    'emailSettings.tblLogin': 'Login SMTP',
    'emailSettings.tblLoginValue': 'Twój adres Gmail (np. jan@gmail.com)',
    'emailSettings.tblPassword': 'Hasło SMTP',
    'emailSettings.tblPasswordValue': '16-literowe hasło z kroku 6 (bez spacji)',
    'emailSettings.tblPort': 'Port',
    'emailSettings.tblPortValue': '587 (STARTTLS)',
    'emailSettings.tblSsl': 'Połączenie SSL',
    'emailSettings.tblSslValue': 'Wyłączone',
    'emailSettings.testFailed': 'Test nieudany',
    'emailSettings.testRecipientLabel': 'Adres email odbiorcy',
    'emailSettings.testRecipientPlaceholder': 'np. jan@example.com',
    'emailSettings.testSend': 'Wyślij test',
    'emailSettings.testSubtitle': 'Sprawdź czy konfiguracja SMTP działa poprawnie wysyłając wiadomość na wybrany adres.',
    'emailSettings.testTitle': 'Wyślij testowy email',
    'emailSettings.testing': 'Wysyłanie...',
    'emailSettings.title': 'Ustawienia email',
    'emailSettings.unverified': 'Niezweryfikowany',
    'emailSettings.verified': 'Zweryfikowany',
    'resetPassword.backToLogin': 'Wróć do logowania',
    'resetPassword.checkingLink': 'Sprawdzanie linku...',
    'resetPassword.confirmPlaceholder': 'Potwierdź hasło',
    'resetPassword.connectionErrorLater': 'Błąd połączenia z serwerem. Spróbuj ponownie później.',
    'resetPassword.connectionErrorRetry': 'Błąd połączenia z serwerem. Spróbuj ponownie.',
    'resetPassword.defaultUserName': 'Użytkowniku',
    'resetPassword.greetingAfter': ', ustaw nowe hasło do swojego konta.',
    'resetPassword.greetingBefore': 'Witaj',
    'resetPassword.invalidLink': 'Link resetowania hasła jest nieprawidłowy lub wygasł.',
    'resetPassword.invalidLinkTitle': 'Nieprawidłowy link',
    'resetPassword.mismatch': 'Hasła nie pasują do siebie.',
    'resetPassword.mismatchInline': 'Hasła nie pasują do siebie',
    'resetPassword.newPasswordPlaceholder': 'Nowe hasło (min. 8 znaków)',
    'resetPassword.pleaseWait': 'Proszę czekać...',
    'resetPassword.redirecting': 'Za chwilę zostaniesz przekierowany do logowania...',
    'resetPassword.resetError': 'Błąd podczas resetowania hasła.',
    'resetPassword.strengthAdd': 'Dodaj: {list}',
    'resetPassword.strengthCase': 'Małe i wielkie litery',
    'resetPassword.strengthDigits': 'Cyfry',
    'resetPassword.strengthGood': 'Dobre',
    'resetPassword.strengthMedium': 'Średnie',
    'resetPassword.strengthMin8': 'Co najmniej 8 znaków',
    'resetPassword.strengthSpecial': 'Znaki specjalne',
    'resetPassword.strengthStrong': 'Silne hasło!',
    'resetPassword.strengthVeryGood': 'Bardzo dobre',
    'resetPassword.strengthWeak': 'Słabe',
    'resetPassword.submit': 'Zmień hasło',
    'resetPassword.submitting': 'Resetowanie...',
    'resetPassword.successBody': 'Możesz teraz zalogować się używając nowego hasła.',
    'resetPassword.successTitle': 'Hasło zostało zmienione!',
    'resetPassword.title': 'Reset hasła',
    'resetPassword.tooShort': 'Hasło musi mieć co najmniej 8 znaków.',
    'twoFactor.attemptsLeft': 'Pozostało prób: {count}.',
    'twoFactor.backToTotp': 'Wróć do kodu TOTP',
    'twoFactor.backupHint': 'Wprowadź jeden z kodów zapasowych (format: XXXX-XXXX).',
    'twoFactor.cancelLogin': 'Anuluj logowanie',
    'twoFactor.loggingIn': 'Logowanie...',
    'twoFactor.loginWithBackup': 'Zaloguj z kodem zapasowym',
    'twoFactor.title': 'Weryfikacja dwuetapowa',
    'twoFactor.totpHint': 'Wprowadź 6-cyfrowy kod z aplikacji uwierzytelniającej (Google Authenticator, Authy itp.)',
    'twoFactor.useBackupCode': 'Użyj kodu zapasowego',
    'twoFactor.verify': 'Zweryfikuj',
    'twoFactor.verifying': 'Weryfikacja...',
    'twoFactor.wrongBackupCode': 'Nieprawidłowy kod zapasowy.',
    'twoFactor.wrongCode': 'Błędny kod weryfikacyjny.',

    // ── P8.1d: i18n Magazynu (konfigurator, tabela, presety, opisy pol) ──
    'inventory.deleteError': 'Wystąpił błąd przy usuwaniu {name}: {msg}',
    'inventory.deleteFailed': 'Nie można usunąć sprzętu {name}.',
    'inventory.deleteGenericError': 'Błąd podczas usuwania sprzętu.',
    'inventory.deleteHasRefs': 'Nie można usunąć sprzętu {name}, ponieważ jest przypisany do istniejących rezerwacji lub innych powiązań w bazie danych. Aby usunąć, najpierw usuń lub odłącz ten sprzęt z rezerwacji.',
    'inventory.deleteNotFound': 'Sprzęt {name} nie został znaleziony (być może został już usunięty).',
    'inventoryFields.bail.desc': 'Kaucja pobierana za sprzęt',
    'inventoryFields.bail.descAlt': 'Kaucja',
    'inventoryFields.barcode.desc': 'Kod kreskowy lub QR',
    'inventoryFields.brand.desc': 'Marka producenta',
    'inventoryFields.brand.descAlt': 'Producent',
    'inventoryFields.category.desc': 'Typ sprzętu (np. Narty, Buty)',
    'inventoryFields.class.desc': 'Klasa jakości (np. Standard, Premium)',
    'inventoryFields.compatibility.desc': 'Kompatybilność',
    'inventoryFields.condition.desc': 'Stan techniczny sprzętu',
    'inventoryFields.condition.descAlt': 'Stan techniczny',
    'inventoryFields.currency.desc': 'Waluta',
    'inventoryFields.images.desc': 'Linki do zdjęć',
    'inventoryFields.images.descAlt': 'Adresy zdjęć (URL)',
    'inventoryFields.inventory_number.desc': 'Unikalny numer inwentarzowy',
    'inventoryFields.inventory_number.descAlt': 'Numer w systemie',
    'inventoryFields.location.desc': 'Lokalizacja w magazynie',
    'inventoryFields.maintenanceDate.desc': 'Data ostatniego serwisu',
    'inventoryFields.name.desc': 'Nazwa modelu',
    'inventoryFields.name.descAlt': 'Nazwa modelu sprzętu',
    'inventoryFields.price.desc': 'Cena wypożyczenia za dzień',
    'inventoryFields.price.descAlt': 'Cena wypożyczenia',
    'inventoryFields.price_over_7.desc': 'Cena za dzień przy pobycie > 7 dni',
    'inventoryFields.price_over_7.descAlt': 'Cena przy wypożyczeniu >7 dni',
    'inventoryFields.purchaseDate.desc': 'Data zakupu',
    'inventoryFields.size.desc': 'Rozmiar sprzętu',
    'inventoryFields.size.descAlt': 'Rozmiar (np. długość nart, rozmiar butów)',
    'inventoryFields.sizeRange.desc': 'Zakres rozmiarów',
    'inventoryFields.sku.desc': 'Kod wewnętrzny lub SKU',
    'inventoryFields.sku.descAlt': 'Kod magazynowy lub SKU',
    'inventoryFields.status.desc': 'Status dostępności',
    'inventoryFields.supplier.desc': 'Dostawca sprzętu',
    'inventoryFields.tags.desc': 'Tagi ułatwiające filtrowanie',
    'inventoryFields.tags.descAlt': 'Tagi rozdzielone przecinkami',
    'inventoryFields.typeId.desc': 'Rodzaj sprzętu',
    'inventoryFields.wearLevel.desc': 'Poziom zużycia',
    'inventoryPresets.bikes.desc': 'Wypożyczalnia rowerów i sprzętu rowerowego',
    'inventoryPresets.bikes.name': 'Rowery',
    'inventoryPresets.events.desc': 'Wypożyczalnia wyposażenia na imprezy i eventy',
    'inventoryPresets.events.name': 'Sprzęt eventowy',
    'inventoryPresets.ski.desc': 'Wypożyczalnia sprzętu narciarskiego i snowboardowego',
    'inventoryPresets.ski.name': 'Narty i snowboard',
    'inventoryPresets.tools.desc': 'Wypożyczalnia narzędzi i sprzętu budowlanego',
    'inventoryPresets.tools.name': 'Narzędzia budowlane',
    'inventoryPresets.vehicles.desc': 'Wypożyczalnia przyczep i pojazdów',
    'inventoryPresets.vehicles.name': 'Przyczepy i samochody',
    'inventoryPresets.water.desc': 'Wypożyczalnia sprzętu wodnego',
    'inventoryPresets.water.name': 'Kajaki i SUP',
    'inventorySettings.activeCount': '{visible} / {total} aktywnych',
    'inventorySettings.addCategory': 'Dodaj kategorię',
    'inventorySettings.addColumn': 'Dodaj kolumnę',
    'inventorySettings.addCustomColumn': 'Dodaj własną kolumnę',
    'inventorySettings.alwaysRequired': 'zawsze wymagane',
    'inventorySettings.alwaysRequiredHint': 'Nazwa, Cena i Kategoria są wymagane zawsze, bo bez nich sprzęt nie zapisze się w bazie. Pozostałe pola możesz wyłączyć, jeśli Twoja branża ich nie używa (np. wypożyczalnia bez kaucji).',
    'inventorySettings.atLeastOneColumn': 'Musi być zaznaczona przynajmniej jedna kolumna.',
    'inventorySettings.autoSaveHint': 'Zmiany są zapisywane automatycznie. Możesz dodać własną kolumnę, której nie ma na liście poniżej.',
    'inventorySettings.autodetect': 'Autodetekcja',
    'inventorySettings.baseFields': 'Pola bazowe',
    'inventorySettings.catAdded': 'Kategoria "{name}" dodana.',
    'inventorySettings.catNameRequired': 'Wprowadź nazwę kategorii.',
    'inventorySettings.catSaveFailed': 'Nie można zapisać kategorii.',
    'inventorySettings.catUpdated': 'Zaktualizowano "{name}".',
    'inventorySettings.categoriesSub': 'Zarządzaj kategoriami i definiuj wymagane pola dla każdej z nich',
    'inventorySettings.categoriesTitle': 'Kategorie sprzętu',
    'inventorySettings.categoryNameLabel': 'Nazwa kategorii',
    'inventorySettings.categoryNamePlaceholder': 'np. Narty alpejskie, Buty snowboardowe…',
    'inventorySettings.categoryNamePlaceholderShort': 'np. Narty alpejskie…',
    'inventorySettings.colAdded': 'Dodano kolumnę "{name}".',
    'inventorySettings.colDeleted': 'Kolumna usunięta.',
    'inventorySettings.colDescLabel': 'Opis (opcjonalny)',
    'inventorySettings.colDescPlaceholder': 'Krótki opis tej kolumny…',
    'inventorySettings.colExampleLabel': 'Przykładowa wartość (opcjonalna)',
    'inventorySettings.colExamplePlaceholder': 'np. 12345, 2026-01-15…',
    'inventorySettings.colExists': 'Kolumna "{name}" już istnieje.',
    'inventorySettings.colNameLabel': 'Nazwa kolumny *',
    'inventorySettings.colNamePlaceholder': 'np. Certyfikat, Waga, Producent…',
    'inventorySettings.colNameRequired': 'Podaj nazwę kolumny.',
    'inventorySettings.columnsHint': 'Wybierz, które informacje mają być widoczne w tabeli magazynu',
    'inventorySettings.createCategory': 'Utwórz kategorię',
    'inventorySettings.createFirstCategory': 'Utwórz pierwszą kategorię',
    'inventorySettings.deleteThisColumn': 'Usuń tę kolumnę',
    'inventorySettings.deselectAll': 'Odznacz wszystkie',
    'inventorySettings.editCategory': 'Edycja: {name}',
    'inventorySettings.errorPrefix': 'Błąd: {msg}',
    'inventorySettings.extraFields': 'Dodatkowe pola',
    'inventorySettings.extraFieldsScope': 'Wymagane tylko dla sprzętu w tej kategorii, oprócz pól wymaganych w całym magazynie (wyżej). Import ich nie sprawdza.',
    'inventorySettings.extraRequiredFields': 'Dodatkowe wymagane pola',
    'inventorySettings.fetchFailed': 'Nie udało się pobrać danych z serwera.',
    'inventorySettings.fieldType': 'Typ pola',
    'inventorySettings.groupBasic': 'Podstawowe informacje',
    'inventorySettings.groupCustom': 'Własne kolumny',
    'inventorySettings.groupMeta': 'Dodatkowe metadane',
    'inventorySettings.groupPricing': 'Ceny i kaucja',
    'inventorySettings.listValuesLabel': 'Wartości listy (oddzielone przecinkiem)',
    'inventorySettings.listValuesPlaceholder': 'np. Nowy, Używany, Do naprawy',
    'inventorySettings.loadingFromDb': 'Wczytywanie z bazy danych...',
    'inventorySettings.nameMin2': 'Nazwa musi mieć co najmniej 2 znaki.',
    'inventorySettings.nameOnlyInvalidChars': 'Nazwa zawiera tylko niedozwolone znaki.',
    'inventorySettings.newCategory': 'Nowa kategoria',
    'inventorySettings.newCategoryTitle': 'Nowa kategoria sprzętu',
    'inventorySettings.newColumn': 'Nowa kolumna',
    'inventorySettings.noAuthLogin': 'Brak uprawnień - zaloguj się.',
    'inventorySettings.noCategories': 'Brak kategorii',
    'inventorySettings.noCategoriesDesc': 'Utwórz pierwszą kategorię sprzętu lub użyj autodetekcji, aby wykryć je z istniejących danych w bazie.',
    'inventorySettings.noCategory': 'Bez kategorii',
    'inventorySettings.fieldTypeText': 'Tekst',
    'inventorySettings.fieldTypeNumber': 'Liczba',
    'inventorySettings.fieldTypeList': 'Lista',
    'inventorySettings.additional': 'Dodatkowe',
    'inventorySettings.noDataReset': 'Brak danych - zresetowano ustawienia.',
    'inventorySettings.noEquipmentKeptCats': 'Brak sprzętu; zachowano kategorie.',
    'inventorySettings.none': 'Żadne',
    'inventorySettings.processing': 'Przetwarzanie...',
    'inventorySettings.requiredCount': '{count} wymaganych',
    'inventorySettings.requiredHint': 'Dotyczy formularza dodawania sprzętu i szablonu importu: pole wymagane dostaje gwiazdkę w pliku .xlsx',
    'inventorySettings.requiredTitle': 'Pola wymagane',
    'inventorySettings.restoreDefaults': 'Przywróć domyślne',
    'inventorySettings.saveChanges': 'Zapisz zmiany',
    'inventorySettings.saveServerFailed': 'Nie udało się zapisać na serwerze (zmiany zostały tylko lokalnie).',
    'inventorySettings.saving': 'Zapisywanie…',
    'inventorySettings.selectAll': 'Zaznacz wszystkie',
    'inventorySettings.subtitle': 'Widoczne kolumny, wymagane pola i kategorie sprzętu',
    'inventorySettings.syncedWithDb': 'Zsynchronizowano z bazą danych.',
    'inventorySettings.visibleColumns': 'Widoczne kolumny',
    'paperSheet.fitPage': 'Cała strona',
    'paperSheet.zoomGroup': 'Powiększenie podglądu',
    'builderChrome.closeWithEsc': 'Zamknij (Esc)',
  },

  en: {
    // Sidebar
    'sidebar.home': 'Home',
    'sidebar.newReservation': 'New Reservation',
    'sidebar.generateOffer': 'Generate Offer',
    'sidebar.calendar': 'Calendar',
    'sidebar.inventory': 'Inventory',
    'sidebar.statistics': 'Statistics',
    'sidebar.profile': 'Profile',
    'sidebar.logout': 'Log Out',
    'sidebar.logoutSaving': 'Saving your changes and logging out…',
    'sidebar.clients': 'Clients',
    'sidebar.group.main': 'Main',
    'sidebar.group.manage': 'Management',
    'sidebar.group.account': 'Account',
    'sidebar.organization': 'Organisation',
    'sidebar.payments': 'Payments',
    'sidebar.group.tools': 'Tools',
    'sidebar.contractTemplate': 'Contract builder',
    'sidebar.offerTemplate': 'Offer builder',
    'sidebar.paymentSettings': 'Online payments',
    'sidebar.invoices': 'Invoices',
    'sidebar.notifications': 'Notifications',
    'sidebar.widget': 'Widget',
    'sidebar.superAdmin': 'Super-admin panel',
    'sidebar.openMenu': 'Open menu',
    'sidebar.collapseMenu': 'Collapse menu',
    'sidebar.expandMenu': 'Expand menu',

        // Security (EN)
    'security.empty.sessions': 'No active sessions',
    'security.table.time': 'Time',
    'security.table.ip': 'IP',
    'security.table.status': 'Status',
    'security.table.device': 'Device',
    'security.table.last': 'Last',
    'security.table.actions': 'Actions',

    // Security tips (EN)
    'security.tips.title': 'Security tips',
    'security.tips.passwordTitle': 'Use strong passwords',
    'security.tips.passwordDesc': 'At least 12 characters with a mix of letters, numbers and symbols',
    'security.tips.changeTitle': 'Change passwords regularly',
    'security.tips.changeDesc': 'Every 3-6 months',
    'security.tips.monitorTitle': 'Monitor sessions',
    'security.tips.monitorDesc': 'Check for unknown devices',

    // Profile
    'profile.title': 'Your Account',
    'profile.subtitle': 'Manage your account and settings',
    'profile.yourData': 'Your Data',
    'profile.description.yourData': 'Edit your personal and contact information',
    'profile.security': 'Security',
    'profile.description.security': 'Change your password and manage account security',
    'profile.users': 'Users',
    'profile.description.users': 'Manage system users',
    'profile.preferences': 'Your Preferences',
    'profile.description.preferences': 'Customize the app theme and language',
    'profile.emailSettings': 'Email Settings',
    'profile.description.emailSettings': 'Configure your email settings',
    'profile.contractSettings': 'Contract Settings',
    'profile.description.contractSettings': 'Configure the contract template and settings',
    'profile.priceRules': 'Dynamic Pricing',
    'profile.ksef': 'KSeF e-Invoicing',
    'profile.description.ksef': 'Send structured invoices to the Polish KSeF system',
    'profile.equipmentBundles': 'Equipment Bundles',
    'profile.description.equipmentBundles': 'Equipment sets with one shared daily price',
    'profile.rentalRules': 'Rental rules',
    'profile.description.rentalRules': 'How you rent out: same-day equipment changeover and paid days',
    'pricing.paidDays': '(paid: {days})',
    'rentalRules.title': 'Rental rules',
    'rentalRules.subtitle': 'Rules that apply to every reservation, in the panel and in the widget.',
    'rentalRules.back': 'Back to profile',
    'rentalRules.loadError': 'Could not load the rental rules.',
    'rentalRules.saveError': 'Could not save the change. Try again.',
    'rentalRules.adminOnly': 'Only a company administrator can change the rental rules.',
    'rentalRules.on': 'On',
    'rentalRules.off': 'Off',
    'rentalRules.exchange.title': 'Same-day equipment changeover',
    'rentalRules.exchange.description': 'An item returned on its return day can go out to the next customer on the same day. The panel does not track hours, so it is up to you to make sure you have time to prepare it.',
    'rentalRules.exchange.offNote': 'After you switch this off, existing reservations stay as they are and can still be edited. New reservations and new dates will then have to start the day after the return.',
    'rentalRules.paidDays.title': 'Paid days',
    'rentalRules.paidDays.description': 'How many days to charge for a rental of a given length. The table applies to all equipment, classes and bundles.',
    'rentalRules.paidDays.own': 'Own table',
    'rentalRules.paidDays.defaultRule': 'The default rule applies now: every day is charged up to 7 days, 8 days count as 7, and a longer rental counts as 2 days shorter.',
    'rentalRules.paidDays.unsaved': 'The table takes effect once you save it. Until then the default rule applies.',
    'rentalRules.paidDays.colRental': 'Rental',
    'rentalRules.paidDays.colPaid': 'Paid days',
    'rentalRules.paidDays.colExample': 'At {rate} zł per day',
    'rentalRules.paidDays.rowOne': '1 day',
    'rentalRules.paidDays.rowMany': '{n} days',
    'rentalRules.paidDays.inputLabel': 'Paid days for a rental of {n} days',
    'rentalRules.paidDays.over14': 'Above 14 days every further day is charged.',
    'rentalRules.paidDays.over7Rate': 'For rentals longer than 7 days the rate from day 8 still applies if the equipment, class or bundle has one.',
    'rentalRules.paidDays.savedReservations': 'The table applies to new quotes. Saved reservations keep their amounts.',
    'rentalRules.paidDays.save': 'Save table',
    'rentalRules.paidDays.noDiscount': 'No discount for longer rentals',
    'rentalRules.paidDays.reset': 'Restore defaults',
    'rentalRules.paidDays.saved': 'Table saved.',
    'rentalRules.paidDays.errorNumber': 'Enter the number of paid days.',
    'rentalRules.paidDays.errorRange': 'Enter more than 0 and at most {n}.',
    'rentalRules.paidDays.errorDecimals': 'Enter at most 2 decimal places.',
    'rentalRules.paidDays.errorOrder': 'Cannot be less than in row {row}.',
    'profile.import': 'Data import',
    'profile.description.import': 'Import equipment and clients from an .xlsx file',
    'profile.companyExport': 'Company data export',
    'profile.description.companyExport': 'All company data in one ZIP file',
    'companyExport.title': 'Company data export',
    'companyExport.subtitle': 'All company data in one ZIP file, to keep or to move to another program',
    'companyExport.contentsTitle': 'What the file contains',
    'companyExport.item.data': 'Clients, reservations with handed over equipment, equipment, payments, invoices with items, offers and sent notifications, as CSV (opens in Excel) and JSON',
    'companyExport.item.invoicesPdf': 'A PDF of every invoice',
    'companyExport.item.photos': 'Equipment condition photos from handovers and returns, in a separate folder',
    'companyExport.item.settings': 'Company settings: contract and offer templates (including an uploaded .docx template), inventory fields, equipment types and classes, price rules, bundles and staff accounts (without passwords)',
    'companyExport.item.readme': 'A CZYTAJ-MNIE.txt file describing the contents',
    'companyExport.howTitle': 'How it works',
    'companyExport.how.time': 'Preparing takes from a few seconds to over ten minutes, depending on the number of photos and invoices. Progress shows in the browser downloads list, and you can keep working in the panel meanwhile.',
    'companyExport.how.limit': 'You can download the export at most 5 times a day.',
    'companyExport.how.paused': 'The account is paused, and the export works as usual.',
    'companyExport.privacy': 'The file contains personal data of your clients. Keep it safe and do not pass it on unless needed.',
    'companyExport.adminOnly': 'Only an administrator can download the company data export.',
    'companyExport.download': 'Download export (ZIP)',
    'companyExport.preparing': 'Preparing the file',
    'companyExport.started': 'The download has started. The eksport-firmy file with today\'s date will be in your browser downloads. If the browser shows a failed download or the file is not a ZIP archive, click "Download export" again.',
    'companyExport.error.inProgress': 'An export of this company is already running. Wait until the file downloads.',
    'companyExport.error.busy': 'The server is preparing other exports right now. Try again in a few minutes.',
    'companyExport.error.limit': 'The export can be downloaded at most 5 times a day. Try again later.',
    'companyExport.error.generic': 'The export could not be started. Try again in a moment.',
    'onboarding.title': 'First steps',
    'onboarding.subtitle': 'Complete these to get the most out of the system',
    'onboarding.progress': 'Completed {done} of {total}',
    'onboarding.dismiss': 'Hide permanently',
    'onboarding.step.companyData': 'Fill in company data',
    'onboarding.step.companyData.cta': 'Fill in company data',
    'onboarding.step.equipment': 'Add your first equipment',
    'onboarding.step.equipment.cta': 'Add equipment',
    'onboarding.step.equipment.importCta': 'Import from file',
    'onboarding.step.client': 'Add your first client',
    'onboarding.step.client.cta': 'Add client',
    'onboarding.step.client.importCta': 'Import from file',
    'onboarding.step.inventoryFields': 'Set up inventory fields',
    'onboarding.step.inventoryFields.cta': 'Choose a field set',
    'onboarding.step.reservation': 'Create your first reservation',
    'onboarding.step.reservation.cta': 'Add reservation',
    'inventory.emptyState.hint': 'Your equipment will show up here - add it manually or import it in bulk from a file.',
    'clients.emptyState.hint': 'Your clients will show up here - add your first one manually or import a list from a file.',
    'calendar.emptyState.noReservationsAtAll': "You don't have any reservations yet",
    'calendar.emptyState.noReservationsAtAllHint': 'Your rental calendar will show up here - add your first reservation to get started.',
    'calendar.emptyState.addReservation': 'Add reservation',
    'inventory.importFromFile': 'Import from file',
    'clients.importFromFile': 'Import from file',
    'import.title': 'Data import',
    'import.subtitle': 'Choose what you want to import from an .xlsx file',
    'import.entity.equipment': 'Equipment',
    'import.entity.clients': 'Clients',
    'import.entity.equipment.description': 'Inventory items with price, size and inventory number.',
    'import.entity.clients.description': 'Contact details of the people who rent from you, companies with a VAT ID included.',
    'import.changeEntity': 'Change data type',
    'import.stepperLabel': 'Import steps',
    'import.step.template': 'Template',
    'import.step.file': 'File',
    'import.step.review': 'Review',
    'import.step1.title': 'Download the template',
    'import.step1.description': 'The template comes with the column headers already in place, so your file will load correctly.',
    'import.step1.bullet.columns': 'Columns in the order the system expects.',
    'import.step1.bullet.values.equipment': 'The types and classes available in your organization, as a dropdown list.',
    'import.step1.bullet.values.clients': 'Contact and company fields laid out separately, no guessing the format.',
    'import.step1.bullet.reuse': 'Open it in Excel or Google Sheets, fill it in and come back here.',
    'import.step1.downloaded': 'Template downloaded. Fill it in and come back to step 2.',
    'import.step1.configNote': 'The template columns come from your organization’s inventory settings. Configure the equipment fields BEFORE downloading the template, because columns added later require downloading it again.',
    'import.step1.configLink': 'Go to inventory field settings',
    'import.downloadTemplate': 'Download template',
    'import.downloading': 'Downloading…',
    'import.downloadError': 'Failed to download the template.',
    'import.next': 'Next',
    'import.back': 'Back',
    'import.step2.title': 'Upload the filled-in file',
    'import.step2.description': 'We check the file and show you what will be added before anything is saved.',
    'import.dropzone.title': 'Drag the file here',
    'import.dropzone.hint': 'or click to pick it from your computer',
    'import.file.remove': 'Remove file',
    'import.file.replace': 'Click to pick a different file',
    'import.fileTypeError': 'Upload an .xlsx file. Other formats are not supported.',
    'import.constraint.format': '.xlsx format',
    'import.constraint.size': 'Max 2 MB',
    'import.constraint.rows': 'Up to 5000 rows',
    'import.analyze': 'Check file',
    'import.analyzing': 'Analyzing file…',
    'import.errorGeneric': 'An error occurred. Please try again.',
    'import.serverBusy': 'The server is busy right now. Please try again in a few seconds.',
    'import.step3.title': 'Review and confirm',
    'import.step3.description': 'Nothing has been saved yet. Confirming adds and updates the rows below.',
    'import.summary.total': 'Rows in file',
    'import.summary.toInsert': 'To add',
    'import.summary.toUpdate': 'To update',
    'import.summary.invalid': 'Invalid',
    'import.errors.title': 'Invalid rows',
    'import.errors.hint': 'These rows will be skipped. Fix them in the file and upload it again, and the rest imports as normal.',
    'import.warnings.title': 'Warnings',
    'import.warnings.hint': 'These rows will be imported anyway. Check that the data matches what you expect.',
    'import.downloadErrorReport': 'Download error report',
    'import.confirmImport': 'Confirm import',
    'import.importing': 'Importing…',
    'import.checksumMismatch': 'The file changed since the preview - upload it again.',
    'import.rowNumber': 'Row',
    'import.result.title': 'Import complete',
    'import.result.description.equipment': 'The equipment is in your inventory and ready to be booked.',
    'import.result.description.clients': 'The clients are on your list and ready to pick in reservations.',
    'import.result.inserted': 'Inserted',
    'import.result.updated': 'Updated',
    'import.result.skipped': 'Skipped',
    'import.result.view.equipment': 'View inventory',
    'import.result.view.clients': 'View clients',
    'import.result.another': 'Import another file',
    'profile.description.priceRules': 'Price rules: seasons, weekends, promotions',
    'profile.widget': 'Widget',
    'profile.description.widget': 'Manage the online booking widget and its settings',
    'profile.widget.premiumOnly': 'Available on the Premium plan',
    'profile.plan.basic': 'Basic plan',
    'profile.plan.premium': 'Premium plan',
    'profile.plan.superadmin': 'Super-Admin',
    // Price rules (P7.2)
    'priceRules.title': 'Dynamic Pricing',
    'priceRules.subtitle': 'Calendar-based price rules: seasons, weekends, promotions',
    'priceRules.newRule': 'New rule',
    'priceRules.editRule': 'Edit rule',
    'priceRules.name': 'Name',
    'priceRules.namePlaceholder': 'e.g. Weekend +15%',
    'priceRules.active': 'Active',
    'priceRules.dateFrom': 'Date from',
    'priceRules.dateTo': 'Date to',
    'priceRules.dateHint': 'Leave empty for a rule with no date restriction',
    'priceRules.weekdays': 'Weekdays',
    'priceRules.weekdaysHint': 'Leave empty for a rule that applies every day',
    'priceRules.weekday.1': 'Mon',
    'priceRules.weekday.2': 'Tue',
    'priceRules.weekday.3': 'Wed',
    'priceRules.weekday.4': 'Thu',
    'priceRules.weekday.5': 'Fri',
    'priceRules.weekday.6': 'Sat',
    'priceRules.weekday.7': 'Sun',
    'priceRules.class': 'Equipment class',
    'priceRules.anyClass': 'Any class',
    'priceRules.type': 'Equipment type',
    'priceRules.anyType': 'Any type',
    'priceRules.adjustmentType': 'Adjustment type',
    'priceRules.percent': 'Percent (%)',
    'priceRules.fixed': 'Fixed rate (per day)',
    'priceRules.adjustmentValue': 'Value',
    'priceRules.adjustmentValueHint': 'Percent can be negative (a promotion)',
    'priceRules.priority': 'Priority',
    'priceRules.priorityHint': 'Higher priority wins when rules overlap',
    'priceRules.presets.title': 'Quick rules',
    'priceRules.presets.hint': 'Enable a typical rule with one switch and pick the percent with a chip or type your own in the field next to it. Turning it off never deletes the rule - it stays in the table as inactive.',
    'priceRules.presets.badge': 'Quick rule',
    'priceRules.presets.inactive': '(inactive)',
    'priceRules.presets.saveError': 'Failed to save the quick rule',
    'priceRules.presets.toggleAria': 'Toggle preset: {name}',
    'priceRules.presets.chipsAria': 'Percent value for preset {name}',
    'priceRules.presets.chipAria': '{name}: set {value}',
    'priceRules.presets.customPlaceholder': 'custom',
    'priceRules.presets.customAria': '{name}: custom percent',
    'priceRules.presets.customInvalid': 'Enter a number, e.g. 12 or 12.5.',
    'priceRules.presets.customRange': 'Enter a percent from 0.01 to {max}.',
    'priceRules.presets.weekend.label': 'Weekend surcharge',
    'priceRules.presets.weekend.on': 'Enabled: {value} on Saturdays and Sundays',
    'priceRules.presets.weekend.off': 'Disabled - no weekend surcharge',
    'priceRules.presets.season_high.label': 'High season',
    'priceRules.presets.season_high.on': 'Enabled: {value}',
    'priceRules.presets.season_high.off': 'Disabled - no high-season surcharge',
    'priceRules.presets.offseason_promo.label': 'Off-season promo',
    'priceRules.presets.offseason_promo.on': 'Enabled: {value}',
    'priceRules.presets.offseason_promo.off': 'Disabled - standard prices off-season',
    'priceRules.presets.onWithRange': 'Enabled: {value} from {range}',
    'priceRules.presets.dateFromAria': 'Season start date for preset {name}',
    'priceRules.presets.dateToAria': 'Season end date for preset {name}',
    'priceRules.presets.dateRangeRequired': 'Set a date range before enabling this preset',
    // E.4: Inventory presets by industry
    'inventoryPresets.cardTitle': 'Starter set for your industry',
    'inventoryPresets.cardSub': 'Pick your industry, check what the set configures, then apply it in one click. You can change everything afterwards.',
    'inventoryPresets.tileMeta': 'Types: {types} · Fields: {fields}',
    'inventoryPresets.reviewTitle': 'The “{name}” set configures:',
    'inventoryPresets.reviewTypes': 'Equipment types',
    'inventoryPresets.reviewTypesHint': 'Ticked types will exist after applying. Clear the ones you do not rent out.',
    'inventoryPresets.reviewLeftoverHint': 'Struck-through ones are left from the previous set, so we will remove them. Tick one to keep it.',
    'inventoryPresets.leftoverTag': 'from the previous set',
    'inventoryPresets.reviewFields': 'Inventory fields',
    'inventoryPresets.reviewNewFields': 'New fields:',
    'inventoryPresets.applyCta': 'Apply set',
    'inventoryPresets.applying': 'Applying…',
    'inventoryPresets.applyNote': 'Creates equipment types ({types}) and configures inventory fields ({fields}).',
    'inventoryPresets.applyNoteWithRemoval': 'Creates equipment types ({types}), removes ({removed}) and configures inventory fields ({fields}).',
    'inventoryPresets.confirmReplace': 'Replace the current field configuration?',
    'inventoryPresets.confirmReplaceBody': 'The “{name}” set overwrites your inventory fields. Equipment types are only added, nothing is removed.',
    'inventoryPresets.confirmReplaceBodyWithRemoval': 'The “{name}” set overwrites your inventory fields and removes the types left from the previous set: {removed}. A type used by equipment, a price rule or a bundle stays.',
    'inventorySettings.confirmResetDefaults': 'Are you sure you want to restore the default settings?',
    'inventorySettings.confirmResetDefaultsBody': 'Columns and required fields go back to the defaults, and the industry starter set comes back.',
    'inventorySettings.confirmResetDefaultsBodyWithCategories': 'Columns and required fields go back to the defaults, and the industry starter set comes back. We will ALSO delete every equipment category ({count}), including the ones you added by hand. Only those used by equipment, a price rule or a bundle will stay.',
    'inventorySettings.restoringDefaults': 'Restoring…',
    'inventorySettings.resetDefaultsKept': 'Default settings restored. These categories stayed because they are in use: {names}.',
    'inventorySettings.resetDefaultsPartial': 'Settings restored, but some categories could not be deleted. Refresh the page and try again.',
    'inventorySettings.confirmDeleteCategory': 'Delete the “{name}” category?',
    'inventorySettings.confirmDeleteCategoryBody': 'It disappears from the add-equipment form and from the import template. If equipment, a price rule or a bundle uses it, we will not remove it.',
    'inventorySettings.catDeleted': 'Deleted the “{name}” category.',
    'inventorySettings.catInUse': 'Cannot delete “{name}” because it is in use (equipment: {equipment}, price rules: {rules}, bundles: {bundles}).',
    'inventorySettings.catDeleteFailed': 'Could not delete the category.',
    'inventorySettings.ownFieldTag': 'custom',
    'inventorySettings.resetDefaultsDone': 'Default settings restored.',
    'inventoryPresets.doneTitle': '“{name}” set applied',
    'inventoryPresets.doneSummary': 'New equipment types: {types}. Inventory fields configured: {fields}.',
    'inventoryPresets.doneRemoved': 'Types removed from the previous set: {removed}.',
    'inventoryPresets.doneBlocked': 'Kept because they are in use: {names}.',
    'inventoryPresets.doneAddEquipment': 'Add your first item',
    'inventoryPresets.donePickAnother': 'Pick another industry',
    'inventoryPresets.typeAddError': 'Could not add the equipment type.',
    'priceSuggestions.title': 'Price suggestions',
    'priceSuggestions.hint': 'Computed from equipment utilization over the last 90 days. Approving opens the rule form so you can edit before saving.',
    'priceSuggestions.accept': 'Approve',
    'priceSuggestions.dismiss': 'Dismiss',
    'priceSuggestions.reasonHigh': 'High utilization',
    'priceSuggestions.reasonLow': 'Low utilization',
    'priceSuggestions.utilization': 'utilization',
    'equipmentBundles.title': 'Equipment Bundles',
    'equipmentBundles.subtitle': 'Sets of equipment types with one shared daily price - a complete set in a quote gets the bundle price',
    'equipmentBundles.newBundle': 'New bundle',
    'equipmentBundles.editBundle': 'Edit bundle',
    'equipmentBundles.name': 'Name',
    'equipmentBundles.namePlaceholder': 'e.g. Basic bundle',
    'equipmentBundles.dailyPrice': 'Bundle price / day',
    'equipmentBundles.dailyPriceHint': 'Replaces the sum of the bundled equipment rates',
    'equipmentBundles.types': 'Equipment types in the bundle',
    'equipmentBundles.typesHint': 'Pick at least 2 types - a reservation covering all of them gets the bundle price',
    'equipmentBundles.noTypes': 'You have no equipment types yet. Add them in Inventory → Field settings to build a bundle.',
    'equipmentBundles.nameRequired': 'Name is required',
    'equipmentBundles.priceRequired': 'Enter a non-negative daily price',
    'equipmentBundles.typesRequired': 'A bundle needs at least 2 equipment types',
    'equipmentBundles.save': 'Save',
    'equipmentBundles.cancel': 'Cancel',
    'equipmentBundles.edit': 'Edit',
    'equipmentBundles.delete': 'Delete',
    'equipmentBundles.deleteConfirm': 'Are you sure you want to delete this bundle?',
    'equipmentBundles.loadError': 'Failed to load bundles',
    'equipmentBundles.saveError': 'Failed to save the bundle',
    'equipmentBundles.deleteError': 'Failed to delete the bundle',
    'equipmentBundles.empty': 'No equipment bundles yet',
    'equipmentBundles.emptyHint': 'Add your first set, e.g. equipment with accessories at one shared daily price.',
    'equipmentBundles.columnTypes': 'Types in the bundle',
    'equipmentBundles.columnPrice': 'Price / day',
    'equipmentBundles.columnActions': 'Actions',
    'equipmentBundles.columnActive': 'Status',
    'equipmentBundles.toggleOn': 'Active',
    'equipmentBundles.toggleOff': 'Inactive',
    'equipmentBundles.toggleAria': 'Toggle bundle {name}',
    'equipmentBundles.toggleError': 'Failed to change the bundle status',
    'equipmentBundles.toggleNeedsTypes': 'This bundle has fewer than 2 types - fix it in edit before toggling',
    'equipmentBundles.presets.title': 'Quick bundles',
    'equipmentBundles.presets.hint': 'Equipment your customers most often rent together (last 12 months). Clicking prefills the form - nothing is saved right away.',
    'equipmentBundles.presets.timesRented': 'Rented together: {count}×',
    'equipmentBundles.presets.priceLine': '{price} per day instead of ~{sum} (−{pct}%)',
    'equipmentBundles.presets.noPrice': 'No equipment prices to suggest from - set the price in the form',
    'equipmentBundles.presets.useAria': 'Prefill the form with bundle {name}',
    'priceRules.save': 'Save',
    'priceRules.cancel': 'Cancel',
    'priceRules.edit': 'Edit',
    'priceRules.delete': 'Delete',
    'priceRules.deleteConfirm': 'Are you sure you want to delete this rule?',
    'priceRules.empty': 'No price rules yet',
    'priceRules.emptyHint': 'Add your first rule, e.g. a weekend surcharge or a promo on rarely-used equipment.',
    'priceRules.nameRequired': 'Name is required',
    'priceRules.valueRequired': 'Enter the adjustment value',
    'priceRules.percentTooLow': 'A percent discount cannot exceed 100%.',
    'priceRules.dateRangeInvalid': '"From" date cannot be later than "to" date',
    'priceRules.saveError': 'Failed to save the rule',
    'priceRules.loadError': 'Failed to load price rules',
    'priceRules.deleteError': 'Failed to delete the rule',
    'priceRules.columnDateRange': 'Date range',
    'priceRules.columnWeekdays': 'Weekdays',
    'priceRules.columnScope': 'Equipment scope',
    'priceRules.columnAdjustment': 'Adjustment',
    'priceRules.columnPriority': 'Priority',
    'priceRules.columnActions': 'Actions',
    'priceRules.allDates': 'Always',
    'priceRules.allDays': 'Every day',

    // Preferences
    'preferences.title': 'Your Preferences',
    'preferences.theme': 'Theme',
    'preferences.theme.light': 'Light',
    'preferences.theme.dark': 'Dark',
    'preferences.language': 'Interface Language',
    'preferences.language.polish': 'Polish',
    'preferences.language.english': 'English',
    'preferences.cancel': 'Cancel',
    'preferences.save': 'Save',
    'preferences.saving': 'Saving…',
    'preferences.loading': 'Loading preferences...',
    'preferences.saved': 'Settings saved',
    'preferences.chooseTheme': 'Choose app appearance',
    'preferences.chooseLanguage': 'Choose interface language',
    'preferences.theme.system': 'System',
    'preferences.language.german': 'German',

    // Common
    'common.cancel': 'Cancel',
    'common.save': 'Save',
    'addEquipment.saving': 'Saving...',
    'addEquipment.quantity': 'Number of units',
    'addEquipment.quantityLess': 'Fewer units',
    'addEquipment.quantityMore': 'More units',
    'addEquipment.quantityHintOne': 'Have several identical units? Set how many and add them in one go.',
    'addEquipment.quantityHintMany': 'Each of the {n} units becomes a separate inventory item with its own number and label.',
    'addEquipment.quantityNoNumbers': 'No inventory numbers: each unit gets its own system code for the label.',
    'addEquipment.quantityInvalid': 'The number of units must be a number from 1 to {max}.',
    'addEquipment.inventoryNumberFirst': 'Number of the first unit',
    'addEquipment.barcodePerUnit': 'With several units, enter the manufacturer code later for each unit separately.',
    'addEquipment.saveManyFew': 'Add {n} units',
    'addEquipment.saveManyMany': 'Add {n} units',
    'addEquipment.saveManyOther': 'Add {n} units',
    'addEquipment.savedManyFew': 'Added {n} units.',
    'addEquipment.savedManyMany': 'Added {n} units.',
    'addEquipment.savedManyOther': 'Added {n} units.',
    'addUser.passwordPolicyNotMet': 'Password does not meet the security requirements',
    'addUser.passwordTooWeak': 'Password strength must be at least Good',
    'preferences.saveError': 'Could not save preferences.',
    'userDetails.loadError': 'Could not load user data.',
    'common.saving': 'Saving...',
    'common.edit': 'Edit',
    'common.delete': 'Delete',
    'common.add': 'Add',
    'common.loading': 'Loading...',
    'common.error': 'Error',
    'common.success': 'Success',
    'common.actions': 'Actions',
    'common.clear': 'Clear',
    'common.refresh': 'Refresh',
    'common.close': 'Close',
    'inventory.closeFilters': 'Close filters',
    'common.previous': 'Previous',
    'common.next': 'Next',
    'common.pageInfo': 'Page {page} of {total}',
    'common.yes': 'Yes',
    'common.no': 'No',
    'common.undo': 'Undo',
    'common.back': 'Back',
    'common.backToProfile': 'Back to profile',
    'common.tour': 'Guide',
    'common.firstPage': 'First page',
    'common.lastPage': 'Last page',
    'common.previousPage': 'Previous page',
    'common.nextPage': 'Next page',
    'common.showingRange': 'Showing {from}-{to} of {total}',
    'common.retry': 'Try again',
    'common.search': 'Search',
    'common.filters': 'Filters',
    'common.clearFilters': 'Clear filters',
    'common.confirm': 'Confirm',
    'common.confirmDeleteTitle': 'Delete for good?',
    'common.irreversible': 'This action cannot be undone.',
    'common.savedSuccess': 'Changes saved',
    'common.saveError': 'Could not save changes',
    'common.loadError': 'Could not load data',
    'photos.cropHint': 'Frame only the equipment: no faces, number plates or documents. The app removes location and camera data from the file.',
    'common.noResults': 'No results',
    'common.noData': 'No data',
    'common.all': 'All',
    'common.copy': 'Copy',
    'common.copied': 'Copied',
    'common.download': 'Download',
    'common.send': 'Send',
    'common.details': 'Details',
    'common.status': 'Status',
    'common.date': 'Date',
    'common.amount': 'Amount',
    'common.required': 'Required field',
    'common.sessionExpired': 'Your session has expired. Please sign in again.',

    // Clients page
    'clients.title': 'Client Directory',
    'clients.subtitle': 'Manage client data and view reservation history',
    'clients.searchPlaceholder': 'Search by name, surname, phone or email...',
    'clients.addClient': 'Add client',
    'clients.totalClients': 'clients',
    'clients.searchResults': 'Search results',
    'clients.firstName': 'First name',
    'clients.lastName': 'Last name',
    'clients.phone': 'Phone',
    'clients.email': 'E-mail',
    'clients.reservations': 'Reservations',
    'clients.details': 'Details',
    'clients.noResults': 'No clients matching search criteria',
    'clients.noClients': 'No clients in database',
    'clients.clientDetails': 'Client details',
    'clients.name': 'Name and surname',
    'clients.showDetails': 'Show client details',
    'clients.newThisMonth': 'New this month',
    'clients.shownOfTotal': 'Showing {shown} of {total} clients',
    'clients.regularClient': 'Regular client',
    'clients.firstNameRequired': 'First name*',
    'clients.firstNamePlaceholder': 'Enter first name',
    'clients.emailPlaceholder': 'example@email.com',
    'clients.deleteConfirmTitle': 'Confirm deletion',
    'clients.deleteConfirmIntro': 'Are you sure you want to delete client',
    'clients.deleteDataLoss': 'Upcoming and cancelled reservations will be deleted. Completed ones stay as rental history, but without the customer: their contact details, address, company details, reservation notes, notification recipients and equipment condition photos are removed, and unpaid offers are deleted (their payment links stop working). VAT invoices keep the buyer details (5-year retention duty). If the customer asked for a copy of their data, download it before deleting.',
    'clients.exportData': 'Download data (GDPR)',
    'clientsExport.open': 'Export',
    'clientsExport.title': 'Export clients',
    'clientsExport.subtitle': 'Choose the client details and download them as an Excel or CSV file.',
    'clientsExport.scopeTitle': 'Which clients',
    'clientsExport.scopeList': 'Clients on the list',
    'clientsExport.scopeAll': 'All clients',
    'clientsExport.scopeAllHint': 'Without search and filters',
    'clientsExport.scopeSearch': 'search: “{q}”',
    'clientsExport.scopeRecent': 'new (30 days)',
    'clientsExport.scopeFrequent': 'regular clients (3+)',
    'clientsExport.fieldsTitle': 'What goes in the file',
    'clientsExport.clearFields': 'Clear all',
    'clientsExport.group.person': 'Contact details',
    'clientsExport.group.address': 'Address',
    'clientsExport.group.company': 'Company',
    'clientsExport.group.history': 'History',
    'clientsExport.field.firstname': 'First name',
    'clientsExport.field.lastname': 'Last name',
    'clientsExport.field.email': 'Email',
    'clientsExport.field.phone_number': 'Phone',
    'clientsExport.field.address': 'Full address in one column',
    'clientsExport.field.street': 'Street',
    'clientsExport.field.building_number': 'Building no.',
    'clientsExport.field.apartment_number': 'Apartment no.',
    'clientsExport.field.postal_code': 'Postal code',
    'clientsExport.field.city': 'City',
    'clientsExport.field.client_type': 'Client type',
    'clientsExport.field.company_name': 'Company name',
    'clientsExport.field.company_nip': 'Tax ID (NIP)',
    'clientsExport.field.company_regon': 'REGON',
    'clientsExport.field.registration_date': 'Date added',
    'clientsExport.field.reservations_count': 'Number of reservations',
    'clientsExport.field.last_reservation': 'Last reservation',
    'clientsExport.formatTitle': 'File format',
    'clientsExport.format.xlsx': 'Excel (.xlsx)',
    'clientsExport.format.csv': 'CSV (.csv)',
    'clientsExport.formatHint.xlsx': 'Opens straight in Excel and Google Sheets. Dates and numbers are ready to sort.',
    'clientsExport.formatHint.csv': 'Semicolon-separated text for importing into another program, such as a newsletter tool.',
    'clientsExport.previewTitle': 'File preview',
    'clientsExport.previewEmpty': 'Select at least one detail to see the preview.',
    'clientsExport.previewMore': 'First {shown} of {total} data rows.',
    'clientsExport.previewAll': 'This is the whole file.',
    'clientsExport.clientsOne': '{n} client',
    'clientsExport.clientsFew': '{n} clients',
    'clientsExport.clientsMany': '{n} clients',
    'clientsExport.columnsOne': '{n} column',
    'clientsExport.columnsFew': '{n} columns',
    'clientsExport.columnsMany': '{n} columns',
    'clientsExport.cancel': 'Cancel',
    'clientsExport.download': 'Download {ext} file',
    'clientsExport.preparing': 'Preparing file…',
    'clientsExport.downloaded': 'Downloaded {name}.',
    'clientsExport.errorAdmin': 'Exporting clients requires administrator rights.',
    'clientsExport.errorSession': 'Your session has expired. Log in again.',
    'clientsExport.errorGeneric': 'Could not prepare the file. Try again.',
    'clients.exportDataHint': 'A JSON file with all data about this customer in the system, for customer requests (GDPR Art. 15 and 20).',
    'clients.exportLoading': 'Preparing file…',
    'clients.exportFailed': 'Could not download the customer data.',

    // Equipment
    'addEquipment.title': 'Add Equipment',
    'addEquipment.subtitle': 'Fill the form to add new equipment to inventory',
    'addEquipment.name': 'Name of the model',
    'addEquipment.namePlaceholder': 'Name of the model',
    'addEquipment.size': 'Size of the equipment',
    'addEquipment.sizePlaceholder': 'Size of the equipment',
    'addEquipment.brand': 'Brand',
    'addEquipment.brandPlaceholder': 'Brand',
    'addEquipment.price': 'Price per day',
    'addEquipment.pricePlaceholder': 'Price per day (PLN)',
    'addEquipment.bail': 'Deposit per day',
    'addEquipment.bailPlaceholder': 'Deposit per day (PLN)',
    'addEquipment.class': 'Equipment Class',
    'addEquipment.classPlaceholder': 'Equipment Class',
    'addEquipment.type': 'Equipment Category',
    'addEquipment.typePlaceholder': 'Choose equipment type',
    'addEquipment.category': 'Equipment category',
    'addEquipment.categoryPlaceholder': 'Choose category',
    'addEquipment.inventoryNumber': 'Number',
    'addEquipment.inventoryNumberPlaceholder': 'Number',
    'addEquipment.priceOver7': 'Price per day (> 7 days)',
    'addEquipment.priceOver7Placeholder': 'Price per day for rentals >7 days (PLN)',
    'addEquipment.sku': 'SKU / Code',
    'addEquipment.skuPlaceholder': 'Internal code or SKU',
    'addEquipment.condition': 'Condition',
    'addEquipment.conditionPlaceholder': 'New / Used / Service',
    'addEquipment.location': 'Location',
    'addEquipment.locationPlaceholder': 'Shelf / zone / rack',
    'addEquipment.tags': 'Tags',
    'addEquipment.tagsPlaceholder': 'e.g. kids, promo',
    'addEquipment.supplier': 'Supplier',
    'addEquipment.supplierPlaceholder': 'Supplier name',
    'addEquipment.purchaseDate': 'Purchase date',
    'addEquipment.maintenanceDate': 'Maintenance date',
    'addEquipment.images': 'Images (URL)',
    'addEquipment.imagesPlaceholder': 'Comma-separated URLs',
    'addEquipment.barcode': 'Barcode / QR',
    'addEquipment.barcodePlaceholder': 'Barcode number',
    'addEquipment.priceCurrency': 'Price currency',
    'addEquipment.priceCurrencyPlaceholder': 'e.g. PLN',
    'addEquipment.depositCurrency': 'Deposit currency',
    'addEquipment.depositCurrencyPlaceholder': 'e.g. PLN',
    'addEquipment.wearLevel': 'Wear level',
    'addEquipment.wearLevelPlaceholder': 'e.g. 20%',
    'addEquipment.compatibility': 'Compatibility',
    'addEquipment.compatibilityPlaceholder': 'e.g. NN 75 / system X',
    'addEquipment.sizeRange': 'Size range',
    'addEquipment.sizeRangePlaceholder': 'e.g. 36-42',
    'addEquipment.selectCategory': 'Select equipment category',
    'addEquipment.fillAll': 'Fill in all fields',
    'addEquipment.success': 'Equipment added successfully',
    'addEquipment.error': 'Error while adding equipment',
    'addEquipment.class.Junior': 'Junior',
    'addEquipment.class.Premium': 'Premium',
    'addEquipment.class.Normal': 'Normal',
    'addEquipment.currency': 'Currency',
    'addEquipment.currencyPlaceholder': 'e.g. PLN',
    'addEquipment.currencyLoading': 'Loading currencies…',
    'addEquipment.currencyNoMatches': 'No matches',
    'addEquipment.save': 'Save',
    'addEquipment.cancel': 'Cancel',
    'addEquipment.backToInventory': 'Back to inventory',

    // Inventory
    'inventory.title': 'Inventory',
    'inventory.calendar': 'Equipment calendar',
    'inventory.inventoryNumber': 'Inventory no.',
    'inventory.equipment': 'Equipment',
    'inventory.size': 'Size',
    'inventory.brand': 'Brand',
    'inventory.category': 'Category',
    'inventory.class': 'Class',
    'inventory.sku': 'SKU / Code',
    'inventory.condition': 'Condition',
    'inventory.location': 'Location',
    'inventory.tags': 'Tags',
    'inventory.supplier': 'Supplier',
    'inventory.purchaseDate': 'Purchase date',
    'inventory.maintenanceDate': 'Maintenance date',
    'inventory.images': 'Images',
    'inventory.barcode': 'Barcode',
    'inventory.priceCurrency': 'Price currency',
    'inventory.depositCurrency': 'Deposit currency',
    'inventory.wearLevel': 'Wear level',
    'inventory.compatibility': 'Compatibility',
    'inventory.sizeRange': 'Size range',
    'inventory.add': 'Add equipment',
    'inventory.delete': 'Delete',
    'inventory.selectedCount': 'Selected',
    'inventory.confirmDeleteOne': 'Are you sure you want to delete this equipment?',
    'inventory.confirmDeleteMany': 'Are you sure you want to delete {count} equipment items?',
    'inventory.selectItem': 'Select equipment',
    'inventory.unselectItem': 'Unselect equipment',
    'inventory.settings': 'Inventory settings',
    'inventory.settingsSubtitle': 'Manage visible columns, required fields, and equipment categories',
    'inventory.settingsColumns': 'Visible table columns',
    'inventory.settingsRequired': 'Required fields when adding equipment',
    'inventory.settingsRequiredHint': 'Base fields are always required.',
    'inventory.addCategory': 'Add category',
    'inventory.categoryName': 'Category name',
    'inventory.addCategoryBtn': 'Add',
    'inventory.categoryNameRequired': 'Enter a category name.',
    'inventory.categoryAddSuccess': 'Category added.',
    'inventory.categoryAddError': 'Unable to add category.',
    'inventory.categoryFieldsBase': 'Always required fields',
    'inventory.categoryFieldsOptional': 'Extra fields for this category',
    'inventory.categoryFieldsHint': 'Select fields that should be required only for this category.',
    'inventory.search': 'Search...',
    'inventory.options': 'Options',
    'inventory.details': 'Equipment details',
    'inventory.page': 'Page',
    'inventory.next': 'Next',
    'inventory.noMatch': 'No equipment matches the filters.',
    'inventory.name': 'Name',
    'inventory.sizePlaceholder': 'Enter size...',
    'inventory.type.Narty': 'Skis',
    'inventory.type.Buty narciarskie': 'Ski boots',
    'inventory.type.Buty snowboardowe': 'Snowboard boots',
    'inventory.type.Snowboard': 'Snowboard',
    'inventory.type.Kije': 'Poles',
    'inventory.type.Kask': 'Helmet',
    'inventory.type.Gogle': 'Goggles',
    'inventory.filters': 'Filters',
    'inventory.customFields': 'Custom fields',
    'inventory.resultsCount': 'results',
    'inventory.noResults': 'No results matching filter criteria',
    'inventory.emptyState': 'No equipment in inventory',
    'inventory.clearFiltersToSeeAll': 'Clear filters to see all',
    'inventory.deletionScheduled': 'Deletion in a moment...',
    'inventory.tooltip.maintenanceDate': 'Last service date (format: YYYY-MM-DD)',
    'inventory.tooltip.purchaseDate': 'Equipment purchase date',
    'inventory.tooltip.condition': 'Technical condition of equipment',
    'inventory.tooltip.location': 'Storage location',
    'inventory.tooltip.wearLevel': 'Equipment wear level',
    'inventory.tooltip.compatibility': 'Compatibility with other equipment',
    'inventory.status': 'Status',
    'inventory.statusFilter': 'Status',
    'inventory.status.Dostępny': 'Available',
    'inventory.status.Wypożyczony': 'Rented',
    'inventory.status.W serwisie': 'In service',
    'inventory.status.Nieaktywny': 'Inactive',
    'inventory.rangeFrom': 'From',
    'inventory.rangeTo': 'To',
    'inventory.rangeMinPlaceholder': 'min',
    'inventory.rangeMaxPlaceholder': 'max',
    'inventory.sizePickOne': 'Or pick a size',
    'inventory.availableFrom': 'Available from',
    'inventory.availableTo': 'Available to',
    'inventoryModal.pricePerDay': 'Price / day',
    'inventoryModal.selectedCount': 'Selected: {count}',
    'inventoryModal.onlySelected': 'Show selected only',
    'inventoryModal.confirm': 'Done ({count})',
    'inventoryModal.empty': 'No equipment is available for the selected dates.',
    'inventoryModal.noneSelected': 'No equipment selected yet.',
    'inventory.currentStatus': 'Current status',
    'inventory.changeStatus': 'Change status',
    'inventory.statusWillChange': 'Status will change',
    'inventory.deactivateWarning': 'Inactive equipment will not be available for rental and will not appear in search.',
    'inventory.cannotDeactivateRented': 'Cannot deactivate equipment that is currently rented. Please wait for return.',
    'inventory.statusDesc.available': 'Equipment ready to rent',
    'inventory.statusDesc.rented': 'Currently in use by a customer',
    'inventory.statusDesc.service': 'In repair or maintenance',
    'inventory.statusDesc.inactive': 'Removed from circulation',
    'inventory.deactivate': 'Deactivate',
    'inventory.activate': 'Activate',
    'inventory.confirmDeactivate': 'Are you sure you want to deactivate this equipment?',
    'inventory.statusChanged': 'Equipment status has been changed',
    'inventory.statusChangeError': 'Error changing status',
    'inventory.cannotChangeStatus': 'Cannot change status',
    'inventory.currentlyRented': 'Equipment is currently rented. Status change will be possible after customer return.',
    'inventory.hasFutureReservationsBlocked': 'Equipment has scheduled future reservations. Status change will be possible after canceling or completing reservations.',
    'inventory.rentedAndFutureReservations': 'Equipment is currently rented and has scheduled future reservations. Status change will be possible after completing all reservations.',
    'inventory.clearFilters': 'Clear filters',
    'inventory.searchPlaceholder': 'Search by name, brand or number…',
    'inventory.resultsTotal': '{total} items',
    'inventory.resultsOfTotal': '{shown} of {total} items',
    'inventory.filterSearchPlaceholder': 'Search…',
    'inventory.filterNoMatches': 'No matching values',
    'inventory.scanned': 'Scanned: {code}',
    'scanner.cameraButton': 'Camera',
    'scanner.cameraButtonHint': 'Scan a code with this device\'s camera',
    'scanner.phoneButton': 'Phone',
    'scanner.phoneButtonHint': 'Use your phone as a wireless scanner for this window',
    'scanner.cameraTitle': 'Scan with camera',
    'scanner.cameraSubtitle': 'Point the camera at the QR code or barcode on the equipment label.',
    'scanner.videoLabel': 'Camera preview',
    'scanner.starting': 'Starting camera…',
    'scanner.aimHint': 'Keep the code inside the frame. Reading is automatic: each code counts once until it leaves the view.',
    'scanner.read': 'Read: {code}',
    'scanner.sendFailed': 'The code could not be processed.',
    'scanner.manualPlaceholder': 'Or type the code',
    'scanner.manualSubmit': 'Send',
    'scanner.problem.insecure': 'The camera only works on a page opened over HTTPS. Open the panel at an https://… address.',
    'scanner.problem.unsupported': 'This browser does not provide camera access. Use a current Chrome, Safari or Edge, or type the code below.',
    'scanner.problem.denied': 'Camera access was denied. Allow camera access in the browser settings (padlock icon next to the address) and open this window again.',
    'scanner.problem.nocamera': 'No camera was found on this device. Type the code below or use your phone.',
    'scanner.problem.nocameraPhone': 'No camera was found on this device. Type the code below.',
    'scanner.problem.busy': 'The camera is being used by another app. Close it and try again.',
    'scanner.problem.unknown': 'The camera could not be started. Type the code below.',
    'scanner.phone.title': 'Scan with your phone',
    'scanner.phone.subtitle': 'Your phone works as a wireless scanner, no app to install.',
    'scanner.phone.step1': 'Open the camera on your phone and point it at the QR code below.',
    'scanner.phone.step2': 'Tap the link your phone shows. The scanner opens.',
    'scanner.phone.step3': 'Scan the equipment labels and the codes arrive in this window right away.',
    'scanner.phone.qrAlt': 'QR code that opens the scanner on your phone',
    'scanner.phone.status.creating': 'Preparing the code…',
    'scanner.phone.status.waiting': 'Waiting for the phone…',
    'scanner.phone.status.connected': 'Phone connected, you can scan',
    'scanner.phone.status.expired': 'The code expired or the connection was closed. Generate a new code.',
    'scanner.phone.status.error': 'The connection could not be prepared. Try again.',
    'scanner.phone.copyLink': 'Copy link',
    'scanner.phone.copied': 'Copied',
    'scanner.phone.localhostWarning': 'The panel is open at a localhost address, so your phone cannot open it. Phone scanning works on the panel at its public HTTPS address.',
    'scanner.phone.httpWarning': 'The panel is not open over HTTPS, so the phone browser will not allow the camera there. On production (https) everything works.',
    'scanner.phone.connected': 'Phone connected',
    'scanner.phone.waitingForCodes': 'Waiting for codes…',
    'scanner.phone.show': 'Show',
    'scanner.phone.disconnect': 'Disconnect',
    'scanner.phone.minimize': 'Minimise',
    'scanner.phone.newCode': 'New code',
    'scanner.phone.finish': 'Finish',
    'phoneScanner.title': 'Code scanner',
    'phoneScanner.subtitle': 'Codes are sent to the window on the computer.',
    'phoneScanner.checking': 'Connecting to the computer…',
    'phoneScanner.expired': 'This link has expired or was closed on the computer. On the computer click “Phone” (or “New code”) and scan the new QR code.',
    'phoneScanner.expiredShort': 'Link expired. Scan a new QR code from the computer.',
    'phoneScanner.sent': 'Sent: {code}',
    'phoneScanner.noListener': 'Sent, but the window on the computer is closed. Open it again (“Phone”).',
    'phoneScanner.tooFast': 'Too many codes at once. Slow down for a moment.',
    'phoneScanner.sendFailed': 'The code could not be sent. Check the internet connection.',
    'labels.button': 'Labels',
    'labels.printOne': 'Print label',
    'labels.summary': 'Labels: {labels} · sheets: {pages}',
    'labels.summaryRoll': 'Labels: {labels}',
    'labels.printCount': 'Print ({n})',
    'labels.andMore': 'and {n} more',
    'labels.noCategory': 'No category',
    'labels.preview': 'Print preview',
    'labels.sheets': 'Sheets',
    'labels.goToSheet': 'Sheet {n}',
    'labels.sheetOf': 'Sheet {n} of {total}',
    'labels.labelOf': 'Label {n} of {total}',
    'labels.prevSheet': 'Previous sheet',
    'labels.nextSheet': 'Next sheet',
    'labels.prevLabel': 'Previous label',
    'labels.nextLabel': 'Next label',
    'labels.legend.label': 'label',
    'labels.legend.skipped': 'skipped field',
    'labels.legend.free': 'empty field',
    'labels.selection.title': 'What to print',
    'labels.selection.count': '{n} of {total} selected',
    'labels.selection.search': 'Search by name, number or category',
    'labels.selection.searchShort': 'Name, number or category',
    'labels.selection.selectAll': 'Select all',
    'labels.selection.clearAll': 'Clear all',
    'labels.selection.selectShown': 'Select results',
    'labels.selection.clearShown': 'Clear results',
    'labels.selection.noMatches': 'Nothing matches “{q}”.',
    'labels.selection.groupToggle': 'Select the whole category: {name}',
    'labels.selection.showOnSheet': 'Show on the sheet',
    'labels.selection.nothingSelected': 'Select equipment in the list to see the preview.',
    'labels.printSelected': 'Print labels ({n})',
    'labels.title': 'Equipment labels',
    'labels.subtitle': 'QR codes and barcodes to stick on equipment, recognised by the scanner in the panel.',
    'labels.print': 'Print',
    'labels.loadError': 'Could not load equipment.',
    'labels.layout': 'Sheet / printer',
    'labels.layouts.a4-24': 'A4: 24 labels 70 × 37 mm',
    'labels.layouts.a4-21': 'A4: 21 labels 70 × 42.3 mm',
    'labels.layouts.a4-65': 'A4: 65 labels 38 × 21 mm (small)',
    'labels.layouts.roll-50x30': 'Label printer: 50 × 30 mm',
    'labels.layouts.roll-45x30': 'Brother label printer: 45 × 30 mm',
    'labels.layouts.roll-62x29': 'Label printer: 62 × 29 mm (Brother)',
    'labels.format': 'Code type',
    'labels.formats.qr': 'QR',
    'labels.formats.barcode': 'Barcode',
    'labels.formats.both': 'Both',
    'labels.formatHint': 'QR is read by phone cameras and 2D scanners. Cheap laser scanners read barcodes only, while “Both” works with any.',
    'labels.copies': 'Copies of each label',
    'widgetFilters.showEmpty': 'Show features without data ({n})',
    'widgetFilters.hideEmpty': 'Hide features without data',
    'widgetFilters.from': 'from',
    'widgetFilters.to': 'to',
    'widgetFilters.title': 'Widget filters',
    'widgetFilters.sub': 'Choose the features customers can use to narrow the equipment list. Values come from your inventory, so there is nothing to type. A filter appears in a category only when it has at least two different values there.',
    'widgetFilters.loading': 'Loading equipment features…',
    'widgetFilters.loadError': 'Could not load filters. Refresh the page.',
    'widgetFilters.meta': '{n} different values: {values}',
    'widgetFilters.noData': 'No equipment has this feature yet',
    'widgetFilters.oneValue': 'one value',
    'widgetFilters.rangeBadge': 'from–to range',
    'widgetFilters.labelAria': 'Filter name in the widget: {name}',
    'widgetFilters.up': 'Move up: {name}',
    'widgetFilters.down': 'Move down: {name}',
    'widgetFilters.previewAria': 'Widget filters preview',
    'widgetFilters.counter': 'Selected: {n} of {max}',
    'widgetFilters.save': 'Save filters',
    'widgetFilters.saved': 'Filters saved. The widget shows them next time it opens.',
    'widgetFilters.saveError': 'Could not save the filters.',
    'classBooking.title': 'Booking by class',
    'classBooking.sub': 'For selected categories the customer picks a class in the widget (e.g. Skis · Premium ×2) and gives their measurements, and you pick the exact equipment. The customer pays only after you confirm availability in the reservation details. Other categories work as before.',
    'classBooking.loading': 'Loading categories…',
    'classBooking.loadError': 'Could not load the settings. Refresh the page.',
    'classBooking.empty': 'First add equipment with a category and a class in Inventory.',
    'classBooking.meta': 'Classes: {classes} · equipment: {units} pcs',
    'classBooking.offHint': 'The customer picks specific equipment and size, as before.',
    'classBooking.questionsTitle': 'Fitting questions',
    'classBooking.question.height': 'Height',
    'classBooking.question.weight': 'Weight',
    'classBooking.question.shoe_size': 'Shoe size',
    'classBooking.question.skill': 'Skill level',
    'classBooking.question.head': 'Head size',
    'classBooking.question.age': 'Age',
    'classBooking.noQuestions': 'Without questions the customer only gives the quantity.',
    'classBooking.pricesTitle': 'Class prices',
    'classBooking.units': '{n} pcs in inventory',
    'classBooking.pricePlaceholder': 'don\'t offer',
    'classBooking.perDay': 'per day, PLN',
    'classBooking.noPrices': 'Set a price for at least one class. Without a price the category won\'t appear in the widget in this mode.',
    'classBooking.save': 'Save booking by class',
    'classBooking.badPrice': 'The price must be an amount above 0, e.g. 80 or 79.50.',
    'classBooking.missingPrices': 'Set a price for at least one class or turn the category off: {names}.',
    'classBooking.saved': 'Saved. The widget shows the changes next time it opens.',
    'classBooking.saveError': 'Could not save the settings.',
    'classBooking.over7': 'from day 8, PLN',
    'classBooking.over7Placeholder': 'same',
    'classBooking.priceAria': 'Price per day: {name}',
    'classBooking.over7Aria': 'Price per day from day 8: {name}',
    'classBooking.pricingHint': 'Set dynamic prices and bundles for classes in Profile, under Price rules and Equipment bundles (the "Applies to" field).',
    'priceRules.appliesTo': 'Applies to',
    'priceRules.appliesToAll': 'Whole rental (equipment and widget classes)',
    'priceRules.appliesToEquipment': 'Specific equipment only',
    'priceRules.appliesToClasses': 'Widget booking by class only',
    'priceRules.appliesToHint': 'A "classes only" rule changes the class prices from the widget settings (Widget → Booking by class) and leaves equipment prices unchanged.',
    'priceRules.scopeClassesTag': 'widget classes',
    'priceRules.scopeEquipmentTag': 'equipment only',
    'priceRules.includesBundles': 'Also applies to bundles',
    'priceRules.includesBundlesHint': 'The bundle price changes by the same percent, day by day. A "specific equipment only" or "classes only" rule applies to bundles with the same scope and to bundles for the whole rental.',
    'priceRules.includesBundlesLocked': 'Only a percent rule with no class or equipment type selected applies to bundles.',
    'priceRules.bundlesBadge': 'bundles too',
    'priceRules.presets.bundlesLabel': 'Also on bundles',
    'priceRules.presets.toggleLabel': 'Rule',
    'priceRules.presets.bundlesAria': '{name}: also applies to bundles',
    'equipmentBundles.classesLabel': 'Item class',
    'equipmentBundles.anyClass': 'Any class',
    'equipmentBundles.classesHint': 'The class is optional: without it the bundle matches every class of that category.',
    'equipmentBundles.appliesToHint': '"Specific equipment only" works in the panel and in the widget when specific items are ordered, "classes only" when classes are ordered in the widget, and "whole rental" in both cases, also when a set combines a class with a specific item.',
    'equipmentBundles.dailyPriceOver7': 'Price from day 8',
    'equipmentBundles.dailyPriceOver7Placeholder': 'same',
    'equipmentBundles.dailyPriceOver7Hint': 'Price per day for rentals longer than 7 days. Empty = the normal bundle price.',
    'equipmentBundles.over7Invalid': 'The price from day 8 must be a non-negative number or empty.',
    'equipmentBundles.over7Short': 'from day 8: {price} PLN/day',
    'bundleWarn.title': 'When this bundle won\'t apply',
    'bundleWarn.badgeNever': 'doesn\'t apply',
    'bundleWarn.badgePartly': 'doesn\'t always apply',
    'bundleWarn.badgeSometimes': 'applies partly',
    'bundleWarn.scopeEquipment': 'Specific equipment',
    'bundleWarn.scopeClasses': 'Widget classes',
    'bundleWarn.neverShort': '{scope}: for rentals up to 7 days the bundle will never apply. The items cost {range} per day together, the bundle {bundle}.',
    'bundleWarn.neverLong': '{scope}: for rentals longer than 7 days the bundle will never apply. The items then cost {range} per day together, the bundle {bundle}. Set a lower price from day 8.',
    'bundleWarn.sometimesShort': '{scope}: for rentals up to 7 days the bundle applies only to more expensive items. The items cost {range} per day together, the bundle {bundle}.',
    'bundleWarn.sometimesLong': '{scope}: for rentals longer than 7 days the bundle applies only to more expensive items. The items then cost {range} per day together, the bundle {bundle}.',
    'bundleWarn.neverBoth': '{scope}: the bundle will never apply. The items cost {range} per day together, and {rangeLong} for rentals longer than 7 days. The bundle costs {bundle}.',
    'bundleWarn.sometimesBoth': '{scope}: the bundle applies only to more expensive items. The items cost {range} per day together, and {rangeLong} for rentals longer than 7 days. The bundle costs {bundle}.',
    'bundleWarn.bundleWithOver7': '{price} (from day 8: {over7})',
    'bundleWarn.missingEquipment': '{scope}: there is no {items} in the inventory, so the bundle won\'t apply to specific equipment.',
    'bundleWarn.missingClasses': '{scope}: {items} is not offered in booking by class, so the bundle won\'t apply in the widget.',
    'bundleWarn.footnote': 'A bundle is used only when it is cheaper than the items priced separately. The comparison leaves out dynamic prices.',
    'classRequest.loading': 'Loading the request…',
    'classRequest.loadError': 'Could not load the request. Close the window and open it again.',
    'classRequest.title': 'Request from the widget',
    'classRequest.stateAwaiting': 'Awaiting confirmation',
    'classRequest.stateConfirmed': 'Confirmed',
    'classRequest.stateCancelled': 'Cancelled',
    'classRequest.intro': 'The customer chose classes and gave their measurements. Pick the equipment, then confirm availability: the customer gets an email with a payment link or transfer details. Until then they pay nothing.',
    'classRequest.introNoPaymentDetails': 'The customer chose classes and gave their measurements. Pick the equipment, then confirm availability. The company has no online payments and no account number in Company details, so the customer gets an email asking them to get in touch about payment. Until then they pay nothing.',
    'classRequest.introConfirmed': 'Request confirmed. You can pick or change the equipment until pickup.',
    'classRequest.progress': 'Picked: {done} of {total}',
    'classRequest.noAnswers': 'No measurements',
    'classRequest.otherClass': 'class {name}',
    'classRequest.change': 'Change',
    'classRequest.pick': 'Pick equipment',
    'classRequest.target': 'Suggestion: {size}',
    'classRequest.pickFor': 'Equipment for item {n}: {name}',
    'classRequest.noCandidates': 'No free equipment of this category for these dates.',
    'classRequest.fitBest': 'fits',
    'classRequest.fitNear': 'close',
    'classRequest.showAll': 'Show all ({n})',
    'classRequest.unassign': 'Remove picked equipment',
    'classRequest.assignError': 'Could not pick the equipment.',
    'classRequest.confirm': 'Confirm and send payment details',
    'classRequest.confirmNoPaymentDetails': 'Confirm availability',
    'classRequest.confirming': 'Confirming…',
    'classRequest.confirmMissingTitle': 'Not everything is picked',
    'classRequest.confirmMissingBody': '{n} more item(s) still need equipment. You can confirm now and pick the equipment later, before pickup.',
    'classRequest.confirmAnyway': 'Confirm now',
    'classRequest.keepAssigning': 'Pick first',
    'classRequest.confirmedOnline': 'Confirmed. The customer got an email with the payment link.',
    'classRequest.confirmedTransfer': 'Confirmed. The customer got an email with transfer details.',
    'classRequest.confirmedContact': 'Confirmed. The customer got an email asking them to get in touch about payment.',
    'classRequest.confirmedNoMail': 'Confirmed, but the email to the customer did not go out. Call them and arrange the payment.',
    'classRequest.confirmError': 'Could not confirm the request.',
    'classRequest.decline': 'Decline request',
    'classRequest.declineMessage': 'Message to the customer (optional)',
    'classRequest.declinePlaceholder': 'E.g. no skis in this size, please try other dates.',
    'classRequest.declineSend': 'Decline and notify the customer',
    'classRequest.declining': 'Declining…',
    'classRequest.back': 'Back',
    'classRequest.declined': 'Request declined. The customer got an email.',
    'classRequest.declinedNoMail': 'Request declined. The email to the customer did not go out, call them.',
    'classRequest.declineError': 'Could not decline the request.',
    'classRequest.tagAwaiting': 'To confirm',
    'classRequest.tagToAssign': 'To pick: {n}',
    'classRequest.number': 'no. {n}',
    'notifications.staffCard': 'Notifications for your rental',
    'notifications.staffWidgetLabel': 'Email about a new widget booking',
    'notifications.staffWidgetDesc': 'When a customer books on your website, you get an email with the customer\'s details, dates, equipment and a link to the booking. Replying to it reaches the customer.',
    'notifications.staffEmailLabel': 'Notification address',
    'notifications.staffEmailPlaceholder': 'e.g. bookings@yourcompany.com',
    'notifications.staffEmailHint': 'Empty: we send it to the email from Company details, or to the account administrators if there is none.',
    'equipmentNumber.moveTitle': 'Move the number?',
    'equipmentNumber.moveTitleMany': 'Move the numbers?',
    'equipmentNumber.moveOne': 'Number {number} belongs to the inactive item “{name}”. After moving, that item will have no number and {number} will be kept in its history.',
    'equipmentNumber.moveMany': 'Numbers {numbers} belong to inactive items. After moving, those items will have no numbers and the old numbers will be kept in their history.',
    'equipmentNumber.moveConfirm': 'Move number',
    'equipmentNumber.moveConfirmMany': 'Move numbers',
    'equipmentNumber.moveCancel': 'I\'ll enter another number',
    'equipmentNumber.previous': 'Previous number: {number} (moved to another item)',
    'companyLookup.button': 'Fetch details',
    'companyLookup.buttonTitle': 'Fill in the name, REGON and address from the business register',
    'companyLookup.loading': 'Looking up the company…',
    'companyLookup.loadingShort': 'Searching…',
    'companyLookup.foundGus': 'Name, REGON and address filled in from the REGON register (GUS). Check them before issuing.',
    'companyLookup.foundVat': 'Name, REGON and address filled in from the VAT taxpayer list. Check them before issuing.',
    'companyLookup.notFound': 'The register has no company with this NIP. Enter the details manually.',
    'companyLookup.invalidNip': 'Enter a valid NIP (10 digits).',
    'companyLookup.tooMany': 'Too many register lookups. Try again in a few minutes or enter the details manually.',
    'companyLookup.unavailable': 'The business register is not responding. Enter the details manually or try again shortly.',
    'labels.logo.title': 'Logo on the label',
    'labels.logo.loading': 'Loading logo…',
    'labels.logo.sourceLabel': 'Separate label logo',
    'labels.logo.sourceCompany': 'Logo from Company details',
    'labels.logo.sourceNone': 'No logo: labels print without one',
    'labels.logo.empty': 'no logo',
    'labels.logo.previewAlt': 'Logo on the label',
    'labels.logo.upload': 'Upload label logo',
    'labels.logo.replace': 'Change label logo',
    'labels.logo.saving': 'Saving…',
    'labels.logo.useCompany': 'Use the logo from Company details',
    'labels.logo.adminOnly': 'Only an administrator can change the label logo.',
    'labels.logo.hint': 'Best horizontal, single-colour, without background (PNG or SVG), up to 1 MB.',
    'labels.logo.print': 'Print logo',
    'labels.logo.tooBig': 'The file is too large (max. 1 MB).',
    'labels.logo.wrongType': 'Choose a PNG, JPG, WEBP or SVG image.',
    'labels.logo.readError': 'Could not read the file.',
    'labels.logo.saveError': 'Could not save the label logo.',
    'labels.skip': 'Skip the first fields of the sheet',
    'labels.skipHint': 'For a partly used sheet with some labels already peeled off.',
    'labels.empty': 'No equipment to print.',
    'labels.systemCodeNote': '{count} item(s) have no inventory number or manufacturer code, so they get a system code (RNT-…), recognised by the scanner the same way.',
    'labels.nonAsciiNote': 'Barcodes cannot hold non-ASCII letters, so these items get the system code in the barcode: {names}',
    'handover.title': 'Equipment pickup and return',
    'handover.tabs.pickup': 'Pickup',
    'handover.tabs.return': 'Return',
    'handover.cameraTitle.pickup': 'Scan equipment being picked up',
    'handover.cameraTitle.return': 'Scan returned equipment',
    'handover.progress.pickup': 'Picked up {n} of {total}',
    'handover.progress.return': 'Returned {n} of {total}',
    'handover.scanHint': 'Scan the label with a reader, camera or phone. The item is ticked off and saved right away.',
    'handover.mark.pickup': 'Pick up',
    'handover.mark.return': 'Receive',
    'handover.undo': 'Undo',
    'handover.heldElsewhere': 'This item is still with the previous customer',
    'handover.markAll.pickup': 'Pick up remaining ({n})',
    'handover.markAll.return': 'Receive remaining ({n})',
    'handover.allDone.pickup': 'All equipment picked up.',
    'handover.allDone.return': 'All equipment returned.',
    'handover.scan.notInReservation': 'Code {code} is not part of this reservation. Check that this is the right item.',
    'handover.scan.already.pickup': '{name}: already picked up ({time}).',
    'handover.scan.already.return': '{name}: already returned ({time}).',
    'handover.scan.done.pickup': 'Picked up: {name} ({n}/{total})',
    'handover.scan.done.return': 'Returned: {name} ({n}/{total})',
    'handover.saveError': 'Could not save. Try again.',
    'handover.returnBeforeStart': 'A return cannot be recorded before the reservation starts. If the customer cancelled, cancel the reservation.',
    'handover.loadError': 'Could not load the pickup and return status.',
    'handover.noItems': 'The reservation has no equipment.',
    'handover.cancelled': 'The reservation is cancelled, so pickup and return are blocked.',
    'handover.notAvailable': 'Pickup and return are unavailable right now.',
    'reservation.scan.pickDatesFirst': 'Pick the dates first. Scanning adds equipment available on those days.',
    'reservation.scan.added': 'Added: {name}',
    'reservation.scan.alreadyAdded': '{name} is already in the reservation.',
    'reservation.scan.unavailable': '{name} is booked on the selected dates or unavailable.',
    'reservation.scan.unknown': 'No equipment found with code {code}.',
    'reservation.offerGone.notFound': 'The offer used to fill in this form no longer exists: it expired or was deleted. The link to the offer has been removed, so you can save the reservation without it.',
    'reservation.offerGone.converted': 'A reservation has already been created from this offer. Check the calendar before adding another one. If this is meant to be a separate reservation, unlink the offer and save again.',
    'reservation.offerGone.openCalendar': 'Open calendar',
    'reservation.offerGone.unlink': 'Unlink offer',
    'reservation.offerGone.unlinked': 'Offer unlinked. Saving will create a separate reservation that is not linked to the offer.',
    'reservation.offerPrice': 'Price and discount from the offer, {amount} to pay. Changing the equipment or dates recalculates the price.',
    'inventory.scanFound': 'Found: {name}',
    'inventory.scanNotFound': 'No equipment with code {code}',
    'addEquipment.scanFilled': 'Code entered: {code}',
    'equipmentDetails.scanHint': 'You can scan the label code:',
    'addEquipment.scanHint': 'You can scan the code with a reader and it lands here. Scan while the cursor is not in any field.',
    'addEquipment.scanDone': '✓ Code entered from the reader.',
    'inventory.filterClearOne': 'Clear filter: {name}',
    'inventory.clearAll': 'Clear all',
    'inventory.applyFilters': 'Apply filters',
    'inventory.availability': 'Availability',
    'inventory.type.Bidon': 'Water bottle',
    'inventory.type.Buty rowerowe': 'Cycling shoes',
    'inventory.type.Kask rowerowy': 'Bike helmet',
    'inventory.type.Pompka': 'Pump',
    'inventory.type.Rower górski': 'Mountain bike',
    'inventory.type.Rower miejski': 'City bike',
    'inventory.type.Rower szosowy': 'Road bike',
    'inventory.type.Rower trekkingowy': 'Trekking bike',
    'inventory.type.Zapięcie': 'Bike lock',
    'inventory.type.Zestaw naprawczy': 'Repair kit',
    'inventory.type.Kłódki': 'Padlocks',
    'inventory.type.Ochraniacze': 'Protectors',
    'inventory.type.Rękawice': 'Gloves',
    'inventory.currency': 'Currency',
    'inventory.sortBy': 'Sort by',

    // Add User
    'addUser.title': 'Add user',
    'addUser.firstName': 'First name',
    'addUser.lastName': 'Last name',
    'addUser.email': 'Email',
    'addUser.phone': 'Phone',
    'addUser.login': 'Login',
    'addUser.password': 'Password',
    'addUser.admin': 'Admin',
    'addUser.addUser': 'Add user',
    'addUser.addError': 'Error adding user.',
    'addUser.userCreated': 'User created.',
    'addUser.fillRequired': 'Fill all required fields',
    'addUser.passwordMismatch': 'Passwords do not match',
    'addUser.passwordTooShort': 'Password must be at least 6 characters',
    'addUser.success': 'User created successfully',
    'addUser.error': 'Error creating user',
    'addUser.backToList': 'Back to users list',
    'addUser.firstNamePlaceholder': 'First name',
    'addUser.lastNamePlaceholder': 'Last name',
    'addUser.emailPlaceholder': 'email@example.com',
    'addUser.phonePlaceholder': '+48 123 456 789',
    'addUser.passwordPlaceholder': '••••••••',
    'addUser.confirmPasswordPlaceholder': '••••••••',
    'addUser.adminInfo': 'Grant admin rights',

    // Generate Offer
    'generateOffer.title': 'Generate Offer',
    'generateOffer.subtitle': 'Create a professional rental offer in Word format',
    'generateOffer.clientData': 'Client Data',
    'generateOffer.searchClient': 'Search client in database',
    'generateOffer.searchPlaceholder': 'Enter first name, last name or email...',
    'generateOffer.search': 'Search',
    'generateOffer.firstName': 'First name',
    'generateOffer.lastName': 'Last name',
    'generateOffer.email': 'E-mail',
    'generateOffer.rentalPeriod': 'Rental Period',
    'generateOffer.startDateTime': 'Start date and time',
    'generateOffer.endDateTime': 'End date and time',
    'generateOffer.daysCount': 'Number of days',
    'generateOffer.equipment': 'Rental Equipment',
    'generateOffer.addEquipment': 'Add equipment to offer',
    'generateOffer.selectEquipment': 'Select equipment',
    'generateOffer.category': 'Category',
    'generateOffer.brand': 'Brand',
    'generateOffer.inventoryNumber': 'Inventory no.',
    'generateOffer.size': 'Size',
    'generateOffer.pricePerDay': 'Price/day',
    'generateOffer.total': 'Total',
    'generateOffer.remove': 'Remove',
    'generateOffer.discount': 'Discount',
    'generateOffer.percent': 'Percent (%)',
    'generateOffer.amount': 'Amount (zł)',
    'generateOffer.subtotal': 'Subtotal:',
    'generateOffer.discountAmount': 'Discount:',
    'generateOffer.totalPrice': 'Total offer value:',
    'generateOffer.clearForm': 'Clear form',
    'generateOffer.generate': 'Generate offer',
    'generateOffer.save': 'Save offer',
    'generateOffer.done': 'Done',
    'generateOffer.confirmSendTitle': 'Confirm sending offer',
    'generateOffer.confirmSendMessage': 'Are you sure you want to send the offer by email to:',
    'generateOffer.confirmSend': 'Yes, send offer',
    'generateOffer.cancelSend': 'Cancel',
    'generateOffer.selectDatesFirst': 'Please select rental dates first',
    'generateOffer.fillClientData': 'Fill in client data (first name, last name, email)',
    'generateOffer.addEquipmentFirst': 'Add at least one equipment item',
    'generateOffer.quotePending': 'Recalculating the price from the price list. Try again in a moment.',
    'reservation.quotePending': 'Recalculating the price from the price list. Save in a moment.',
    'generateOffer.history.issued': 'Issued on {issued}',
    'generateOffer.history.issuedValidUntil': 'Issued on {issued}, valid until {validUntil}',
    'generateOffer.history.expired': 'This offer expired on {validUntil}. Generating it downloads a copy with the original date and validity, sending it by e-mail issues it again with today\'s date.',
    'generateOffer.history.inBundle': 'in the bundle',
    'generateOffer.history.changedAfterSend': 'This offer was changed after it was sent: the client has the version issued on {issued}. Generating it downloads the changed offer with today\'s date and validity counted from today, sending it by e-mail sends it to the client.',
    'generateOffer.history.ratePerDay': '{amount} PLN/day',
    'generateOffer.errorFetchingClients': 'Failed to fetch clients from database',
    'generateOffer.errorFetchingEquipment': 'Failed to fetch available equipment',
    'generateOffer.noEquipmentAvailable': 'No equipment available for selected dates',
    'generateOffer.offerGenerated': 'Offer has been generated and downloaded!',
    'generateOffer.errorGenerating': 'Failed to generate offer',
    'generateOffer.enterSearchQuery': 'Enter first name, last name or email fragment',
    'generateOffer.days': 'days',
    'generateOffer.day': 'day',

    // Reservation
    'reservation.title': 'Add reservation',
    'reservation.basicData': 'Basic information',
    'reservation.firstname': 'First name',
    'reservation.lastname': 'Last name',
    'reservation.contact': 'Contact',
    'reservation.contactHint': 'One contact is enough: email or phone.',
    'reservation.contactRequired': "Enter the customer's email or phone.",
    'reservation.email': 'Email',
    'reservation.address': 'Address',
    'reservation.idNumber': 'ID number',
    'reservation.phone': 'Phone',
    'reservation.discount': 'Discount',
    'reservation.discountAmount': 'Discount amount',
    'amountField.currency': 'PLN',
    'amountField.unitGroup': 'Discount unit',
    'amountField.discountPlaceholderPercent': 'Discount in %',
    'amountField.discountPlaceholderPln': 'Discount in PLN',
    'amountField.advancePlaceholder': 'e.g. 150.50',
    'amountField.afterDiscount': 'After discount: {amount}',
    'amountField.error.invalid': 'Enter an amount, e.g. 150.50',
    'amountField.error.percentOver': 'Maximum 100%',
    'amountField.error.amountOver': 'Maximum {max}',
    'amountField.error.checkAmounts': 'Check the discount and advance amounts.',
    'reservation.term': 'Term',
    'reservation.range': 'Date range', // DODANE
    'reservation.from': 'From',
    'reservation.to': 'To',
    'reservation.paymentMethod': 'Payment method',
    'reservation.chooseEquipment': 'Choose equipment',
    'reservation.selectedEquipment': 'Selected equipment',
    'reservation.noEquipment': 'No equipment selected.',
    'reservation.notes': 'Notes / special requirements',
    'reservation.summary': 'Summary',
    'reservation.days': 'Number of days',
    'reservation.equipmentPrice': 'Equipment price',
    'priceBreakdown.perDayAveraged': 'avg.',
    'priceBreakdown.perDay': '{amount}/day',
    'priceBreakdown.ruleLabel': 'Pricing: {rule}',
    'priceBreakdown.bundleName': '{name} - {price}/day (bundle price)',
    'priceBreakdown.bundleNameAverage': '{name} - avg. {price}/day (bundle price)',
    'priceBreakdown.recalculating': 'recalculating…',
    'priceBreakdown.baseSum': 'incl.: base total',
    'priceBreakdown.ruleAdjustment': 'pricing adjustment',
    'priceBreakdown.bundleSaving': 'bundle saving',
    'reservation.advance': 'Advance',
    'reservation.advancePaid': '(paid)',
    'reservation.advanceUnpaid': '(unpaid)',
    'reservation.remainingToPay': 'Remaining to pay',
    'reservation.clearOverride': 'Clear override',
    'reservation.bail': 'Deposit',
    'ksefSettings.title': 'KSeF: e-Invoices',
    'ksefSettings.subtitle': 'Sending structured invoices to the National e-Invoice System (VAT invoices and corrections for companies).',
    'ksefSettings.loading': 'Loading…',
    'ksefSettings.loadError': 'Failed to load KSeF settings.',
    'ksefSettings.configCardTitle': 'KSeF configuration',
    'ksefSettings.authIntro': 'We connect to KSeF with a token or a KSeF certificate. Both methods work the same way: a token is a single string to paste, a certificate is two files and a password, renewed every 2 years.',
    'ksefSettings.step1': "Log in to the KSeF Taxpayer App (podatki.gov.pl) using the company's Tax ID.",
    'ksefSettings.step2': 'Generate a token with permission to issue invoices, or apply for a KSeF certificate with the purpose "Authentication in the KSeF system" (instructions below).',
    'ksefSettings.step3': 'Paste the token or choose the certificate and key files, save and test the connection. Start with the test environment.',
    'ksefSettings.tokenFutureHint': 'The Ministry of Finance has announced that KSeF tokens will keep working after 2026, so a working token needs no changes. If that changes, we will let you know here.',
    'ksefSettings.tokenSunsetHint': 'KSeF tokens work until {date}. Before that day, switch the method to "KSeF certificate" (instructions below).',
    'ksefSettings.tokenSunsetPassed': 'KSeF tokens stopped working on {date}. Switch the method to "KSeF certificate" (instructions below).',
    'ksefSettings.certGuideTitle': 'How to get a KSeF certificate',
    'ksefSettings.certGuideIntro': 'The Ministry of Finance issues KSeF certificates free of charge in the KSeF Taxpayer App. It takes about 15 minutes and is easiest on a computer.',
    'ksefSettings.certGuidePrepTitle': 'What to prepare',
    'ksefSettings.certGuidePrep1': "The company's Tax ID (NIP).",
    'ksefSettings.certGuidePrep2': "A way to log in to KSeF: for a sole proprietorship, Profil Zaufany, mObywatel or a qualified signature; for a company, a person with KSeF permission to issue invoices for the company's Tax ID, or the company's qualified seal.",
    'ksefSettings.certGuidePrep3': 'A safe place for the password, for example a password manager.',
    'ksefSettings.certGuideStepsTitle': 'Step by step',
    'ksefSettings.certGuideStep1': "Go to ap.ksef.mf.gov.pl (KSeF Taxpayer App), log in and select your company's Tax ID.",
    'ksefSettings.certGuideStep2': 'Open the "Certificates" tab and choose "Apply for a certificate".',
    'ksefSettings.certGuideStep3': 'Enter a certificate name, for example "theRENT", preferably without Polish characters.',
    'ksefSettings.certGuideStep4': 'Set a key password: 15 to 32 characters, with an uppercase and a lowercase letter (no Polish characters), a digit and a special character. Write it down right away, because this password cannot be recovered or changed.',
    'ksefSettings.certGuideStep5': 'Click "Generate". The browser saves a file ending in .key, which is the private key. Do not email it to anyone.',
    'ksefSettings.certGuideStep6': 'As the purpose, choose "Authentication in the KSeF system". Do not choose "Signing the issuer verification link": that is a certificate for offline mode and cannot be used to connect.',
    'ksefSettings.certGuideStep7': "Leave today's date as the start of validity, send the application and refresh the list until the certificate is active. A certificate valid from a later day can only be uploaded here on that day.",
    'ksefSettings.certGuideStep8': 'Select the new certificate and download it in PEM format. A file ending in .crt will be saved.',
    'ksefSettings.certGuideStep9': 'Here, choose the "KSeF certificate" method and the production environment (certificate from ap.ksef.mf.gov.pl), select the .crt file and the .key file, enter the password, save and click "Test connection to KSeF".',
    'ksefSettings.certGuideNotesTitle': 'Good to know',
    'ksefSettings.certGuideNote1': 'We do not store the password. The key is stored encrypted and never shown.',
    'ksefSettings.certGuideNote2': 'A certificate is valid for at most 2 years. You can apply for a new one a month before the old one expires; the expiry date is shown above, next to the saved certificate.',
    'ksefSettings.certGuideNote3': 'Invoices sent by the.rENT will appear in KSeF as sent on behalf of the company by the person the certificate was issued to.',
    'ksefSettings.certGuideNote4': 'If you also use accounting software, generate a separate certificate for the.rENT. If there is a problem, you can revoke one and the other keeps working.',
    'ksefSettings.certGuideNote5': 'Lost the .key file or the password: revoke the certificate in the Taxpayer App ("Certificates" tab) and generate a new one.',
    'ksefSettings.certGuideMfLink': 'Ministry of Finance page about KSeF certificates',
    'ksefSettings.certSavedWithDate': 'Certificate saved (encrypted), valid until {date}',
    'ksefSettings.certSaved': 'Certificate saved (encrypted)',
    'ksefSettings.noCert': 'No certificate',
    'ksefSettings.tokenSaved': 'Token saved (encrypted)',
    'ksefSettings.noToken': 'No token',
    'ksefSettings.sendingEnabled': 'Sending enabled',
    'ksefSettings.sendingDisabled': 'Sending disabled',
    'ksefSettings.certSubjectLabel': 'Certificate subject: {subject}',
    'ksefSettings.environment': 'Environment',
    'ksefSettings.envTest': 'Test (TE), invoices with no legal effect',
    'ksefSettings.envDemo': 'Pre-production (demo)',
    'ksefSettings.envProd': 'Production, real legally binding invoices',
    'ksefSettings.authMethod': 'Authentication method',
    'ksefSettings.authMethodToken': 'KSeF token',
    'ksefSettings.authMethodCert': 'KSeF certificate',
    'ksefSettings.tokenLabel': 'KSeF token',
    'ksefSettings.tokenPlaceholderSaved': '•••••••• (leave empty to keep unchanged)',
    'ksefSettings.tokenPlaceholderEmpty': 'Paste the token from the Taxpayer App',
    'ksefSettings.certPemLabel': 'KSeF certificate (PEM)',
    'ksefSettings.certKeyLabel': 'Certificate private key (PEM)',
    'ksefSettings.pemPlaceholderSaved': 'Saved, leave empty to keep unchanged',
    'ksefSettings.certFileLabel': 'Certificate file (.crt or .cer)',
    'ksefSettings.keyFileLabel': 'Private key file (.key)',
    'ksefSettings.keyPasswordLabel': 'Private key password',
    'ksefSettings.keyPasswordHint': 'The password set when generating the certificate in the KSeF Taxpayer App. It is only used to read the key when saving: we do not store the password, and the key is stored encrypted.',
    'ksefSettings.fileChosen': 'Selected: {name}',
    'ksefSettings.fileSavedHint': 'Saved. Choose a file only if you want to replace it.',
    'ksefSettings.fileReadError': 'Could not read the file {name}.',
    'ksefSettings.fileTooLarge': 'The file {name} is too large for a certificate or key. Check that it is the right file.',
    'ksefSettings.pasteToggle': 'Paste manually as text (PEM)',
    'ksefSettings.testConnection': 'Test connection to KSeF',
    'ksefSettings.testing': 'Testing…',
    'ksefSettings.testHint': 'Tests the saved settings: connects to KSeF on behalf of the company Tax ID from Company details, without sending an invoice.',
    'ksefSettings.testOk': 'The connection works. KSeF accepted the {method} in the {env} environment.',
    'ksefSettings.testMethodToken': 'token',
    'ksefSettings.testMethodCert': 'certificate',
    'ksefSettings.envTestShort': 'test',
    'ksefSettings.envDemoShort': 'pre-production',
    'ksefSettings.envProdShort': 'production',
    'ksefSettings.testError': 'Could not test the connection to KSeF.',
    'ksefSettings.enableSending': 'Enable sending to KSeF',
    'ksefSettings.autoSendLabel': 'Send automatically after issuing a VAT invoice/correction',
    'ksefSettings.autoSendHint': 'Automatic sending is opt-in and runs in the background. A KSeF outage never blocks issuing an invoice - it just leaves it for manual "Send to KSeF".',
    'ksefSettings.saveSettings': 'Save settings',
    'ksefSettings.saving': 'Saving…',
    'ksefSettings.saveError': 'Save failed',
    'ksefSettings.saved': 'KSeF settings saved.',
    'ksefSettings.howItWorksTitle': 'How does sending work?',
    'ksefSettings.howItWorksBody': 'On the invoice list, a "Send to KSeF" button appears next to VAT invoices and corrections. Once accepted, the invoice gets a KSeF number and becomes legally binding. Proformas and receipts are not sent. The test environment lets you safely check the whole process before enabling production.',
    'paymentThankYou.backToShop': 'Back to the rental shop',
    'paymentThankYou.cancelledTitle': 'Payment cancelled',
    'paymentThankYou.cancelledDesc': "Nothing happened. You can go back to the email and try again.",
    'paymentThankYou.depositAlreadyTitle': 'Deposit is already held',
    'paymentThankYou.depositTitle': 'Deposit held',
    'paymentThankYou.depositDesc1': "Funds were not charged. This is a hold on your card, released once the equipment is returned undamaged.",
    'paymentThankYou.contactHint': 'If you have any questions, reply to the email you received.',
    'paymentThankYou.alreadyPaidTitle': 'Payment was already registered',
    'paymentThankYou.thankYouTitle': 'Thank you for your payment!',
    'paymentThankYou.alreadyPaidDesc': 'This reservation already has a registered payment.',
    'paymentThankYou.paidDesc': 'Your payment was accepted. We will send the confirmation to your email address.',
    'paymentThankYou.shopSeesPayment': 'The rental shop can see your payment. If you have any questions, reply to the email you received.',
    'paymentReturn.title': 'Payment',
    'paymentReturn.subtitle': 'Online payment status.',
    'paymentReturn.status.pending.title': 'Checking payment…',
    'paymentReturn.status.pending.desc': 'The payment confirmation may take a moment.',
    'paymentReturn.status.paid.title': 'Paid ✓',
    'paymentReturn.status.paid.desc': 'The payment has been recorded.',
    'paymentReturn.status.paid.descAdvance': 'The advance has been recorded.',
    'paymentReturn.status.failed.title': 'Payment failed',
    'paymentReturn.status.failed.desc': 'The payment could not be confirmed. Please try again.',
    'paymentReturn.status.cancelled.title': 'Payment cancelled',
    'paymentReturn.status.cancelled.desc': 'The payment was interrupted.',
    'paymentReturn.status.unknown.title': 'No payment information',
    'paymentReturn.status.unknown.desc': 'This payment could not be found.',
    'paymentReturn.stuckDesc': 'Payment not yet confirmed. The confirmation may take a moment, check again shortly.',
    'paymentReturn.retry': 'Check again',
    'paymentReturn.backToCalendar': 'Back to calendar',
    'reservation.perDay': 'day',
    'reservation.discountLabel': 'Discount',
    'reservation.toPay': 'To pay',

    // PaymentSettings
    'paymentSettings.title': 'Online payments',
    'paymentSettings.subtitle': 'Accept BLIK and card payments. Customer money goes straight to your account (Stripe).',
    'paymentSettings.cardTitle': 'Payment account (Stripe)',
    'paymentSettings.loading': 'Loading…',
    'paymentSettings.loadError': 'Failed to load payment settings.',
    'paymentSettings.returnedFromStripe': "You're back from Stripe. The current account status is shown below.",
    'paymentSettings.serverMissingTitle': 'Online payments are not yet enabled on the server',
    'paymentSettings.serverMissingBody': 'This the.rENT installation has no Stripe key configured, so an account cannot be connected and online payments cannot be accepted. The server administrator must set the {envVar} variable (test-mode key {testKey} in dev, a live key in production) and restart the backend. Until then, accept advances in cash or by transfer - transfer details are sent in the reservation confirmation.',
    'paymentSettings.onboardIntro': 'Connecting takes a few minutes and happens on Stripe\'s secure page:',
    'paymentSettings.step1': 'Click "Connect to Stripe".',
    'paymentSettings.step2': 'Provide your company details and bank account number (payouts go there).',
    'paymentSettings.step3': 'You\'ll return here automatically. Once the status changes to "Active", you can accept payments.',
    'paymentSettings.connectButton': 'Connect to Stripe',
    'paymentSettings.redirecting': 'Redirecting…',
    'paymentSettings.statusIncomplete': 'Setup incomplete',
    'paymentSettings.statusUnknown': 'Could not check the account status',
    'paymentSettings.statusUnknownHint': 'We could not reach Stripe just now, so we do not know whether the account accepts payments. This does not have to mean the setup is incomplete. Refresh the status in a moment.',
    'paymentSettings.statusStaleHint': 'We could not reach Stripe just now. Showing the last known account status.',
    'paymentSettings.statusPaused': 'Paused: online payments are not being accepted',
    'paymentSettings.statusActive': 'Active: you can accept payments',
    'paymentSettings.needsMoreDataHint': 'Stripe still needs your company\'s details (or they\'re being verified). Finish the setup and the status will change to "Active".',
    'paymentSettings.finishSetup': 'Finish setup in Stripe',
    'paymentSettings.refreshStatus': 'Refresh status',
    'paymentSettings.activeHint': 'The account is active: payment links, card payments at the desk and widget advances go to your Stripe account. Find payouts and transaction history in your Stripe dashboard.',
    'paymentSettings.pausedHint': 'Online payments are paused. New online payments (links, widget, new deposit holds) are blocked, but refunds, capturing/releasing already-held deposits, and cash/transfer payments work normally. Resume below when you want to accept online payments again.',
    'paymentSettings.advanceSectionTitle': 'Widget advance payment',
    'paymentSettings.advanceSectionHint': 'What percentage of the reservation amount the customer pays online when booking through the widget. 100 means the full amount.',
    'paymentSettings.save': 'Save',
    'paymentSettings.saving': 'Saving…',
    'paymentSettings.advanceSaved': 'Saved: when booking in the widget, the customer pays {percent}% of the amount online.',
    'paymentSettings.saveError': 'Save failed',
    'paymentSettings.autoCancelSectionTitle': 'Auto-cancel unpaid reservations',
    'paymentSettings.autoCancelHint': 'A widget reservation with no payment will be cancelled automatically after this many hours (the customer gets a payment reminder email beforehand). Leave empty to disable. Suggested: 24.',
    'paymentSettings.hoursUnit': 'hrs',
    'paymentSettings.autoCancelDisabled': 'Auto-cancel disabled.',
    'paymentSettings.autoCancelSaved': 'Unpaid widget reservations will be cancelled after {hours} hours.',
    'paymentSettings.pauseSectionTitle': 'Pausing online payments',
    'paymentSettings.pausedNowHint': 'Online payments are now paused. The Stripe account stays connected, so resuming returns to the same account. Refunds, settling already-held deposits, and offline payments keep working; only new online payments are paused.',
    'paymentSettings.pauseAvailableHint': 'Temporarily disable accepting NEW online payments (including new deposit holds), while keeping the connected Stripe account. Unlike disconnecting, resuming returns to the same account. Refunds, settling already-held deposits, and offline payments keep working.',
    'paymentSettings.resumeOnline': 'Resume online payments',
    'paymentSettings.pauseOnline': 'Pause online payments',
    'paymentSettings.processing': 'Processing…',
    'paymentSettings.pauseConfirmTitle': 'Pause online payments?',
    'paymentSettings.pauseConfirmMessage': "Customers won't be able to pay via links or the widget until you resume. The Stripe account stays connected (unlike disconnecting). Only NEW online payments are paused, including new deposit holds. Refunds, capturing and releasing already-held deposits, and cash/transfer payments keep working.",
    'paymentSettings.pauseFailed': 'Failed to change the online payment state',
    'paymentSettings.pausedSuccess': 'Online payments paused.',
    'paymentSettings.resumedSuccess': 'Online payments resumed.',
    'paymentSettings.disconnectSectionTitle': 'Disconnecting payments',
    'paymentSettings.disconnectHint': 'Disables accepting online payments in the.rENT. Your rental\'s Stripe account and collected funds remain untouched, and you can reconnect payments at any time.',
    'paymentSettings.disconnectButton': 'Disconnect Stripe account',
    'paymentSettings.disconnectConfirmTitle': 'Disconnect online payments?',
    'paymentSettings.disconnectConfirmMessage': 'Payment buttons and links will stop working until you reconnect the account. Your Stripe account and collected funds remain untouched.',
    'paymentSettings.disconnectFailed': 'Failed to disconnect Stripe',
    'paymentSettings.disconnectedSuccess': 'Online payments have been disconnected.',
    'paymentSettings.onboardFailed': 'Failed to start connecting Stripe',
    'paymentSettings.adminOnly': 'Online payment settings are available only to the company administrator.',
    'paymentSettings.stripeLinkExpired': 'The Stripe setup link has expired or was already used. Click the button below to open a new one.',
    'paymentSettings.advanceRange': 'Enter a whole number from 1 to 100.',
    'paymentSettings.autoCancelOffNow': 'Currently: off',
    'paymentSettings.widgetSettingsPremium': 'The advance paid in the widget and auto-cancelling unpaid widget reservations are available in the Premium plan, together with the booking widget.',
    'paymentSettings.premiumTitle': 'Online payments are part of the Premium plan.',
    'paymentSettings.premiumBody': 'On the Basic plan you record cash or bank transfer payments on the reservation. Payment links sent earlier keep working.',
    'paymentSettings.premiumConnectedBody': 'On the Basic plan you cannot send new payment links. Links sent earlier, refunds and deposits keep working, and you can pause or disconnect the connected Stripe account or finish its setup.',
    'premium.badge': 'Premium',
    'premium.badgeTitle': 'Premium plan feature',
    'premium.want': 'I want Premium',
    'premium.defaultMessage': 'This feature is part of the Premium plan.',
    'premium.request.subject': 'I want to switch to Premium',
    'premium.request.body': 'I want to switch to the Premium plan. I am interested in: {feature}.',
    'premium.feature.widget': 'booking widget',
    'premium.feature.own_smtp': 'emails from your rental address',
    'premium.feature.reminders': 'automatic reminders',
    'premium.feature.sms': 'text messages to customers',
    'premium.feature.payment_links': 'online payments',
    'premium.feature.booking_link': 'booking link and QR code',
    'premium.feature.unpaid_guard': 'protection against unpaid reservations',
    'premium.feature.other': 'Premium plan features',
    'przerwa.tytul': 'Account paused, view only',
    'przerwa.tytulDo': 'Account paused until {do}, view only',
    'przerwa.opis': 'You can browse your company data as usual, but changes are not saved. Invoices and KSeF work (issuing, corrections, payments on invoices, sending, invoice and KSeF settings), as do refunds, deposits, your password, removing staff access, deleting client data and the company data export. The widget, reminders and payment links are off.',
    'przerwa.zaplanowana': 'From {od} the account will be paused: data stays viewable and invoices and KSeF keep working, while other saving, the widget and payment links will be off.',
    'przerwa.zapisZablokowany': 'The account is paused and read only. You can save changes once it is resumed.',
    'przerwa.wznowienie.przycisk': 'Ask to resume',
    'przerwa.wznowienie.temat': 'Request to resume the account after the pause',
    'przerwa.wznowienie.tresc': 'Please resume our account after the pause. We want to work again from: ',
    'przerwa.szablonTylkoOdczyt': 'The account is paused, so the template is view only.',
    'przerwa.wznowiona': 'The pause has ended. You can save changes again.',
    'rezygnacja.tytul': 'Account after cancellation, view only',
    'rezygnacja.opis': 'You can browse your company data as usual. Invoices and KSeF work (issuing, corrections, payments on invoices, sending, invoice and KSeF settings), as do refunds, deposits, your password and the company data export. Other changes are not saved, and widget bookings, reminders and payment links are off.',
    'rezygnacja.usuniecie': 'Company data may be deleted no earlier than {od}. Before that day download the data export: one file with your data and invoices as PDF. You keep the invoices yourselves for the period required by law.',
    'rezygnacja.usunieciePracownik': 'Company data may be deleted no earlier than {od}. The data export is downloaded by the company administrator.',
    'rezygnacja.eksport.przycisk': 'Download data export',
    'rezygnacja.eksport.opis': 'The account has been cancelled, and the export works as usual. Download it before the company data is deleted.',
    'rezygnacja.odwolanie.przycisk': 'Ask to withdraw the cancellation',
    'rezygnacja.odwolanie.temat': 'Request to withdraw the cancellation',
    'rezygnacja.odwolanie.tresc': 'Please withdraw our cancellation. We want to keep using the.rENT. ',
    'rezygnacja.zaplanowana': 'From {od} the account will be cancelled and become read only: data stays viewable and the export, invoices and KSeF keep working, while bookings, the widget and payment links will be off.',
    'rezygnacja.zapisZablokowany': 'The account has been cancelled and is read only. You can download the company data export and handle invoices.',
    'rezygnacja.odwolana': 'The cancellation has been withdrawn. You can save changes again.',
    'rezygnacja.szablonTylkoOdczyt': 'The account has been cancelled, so the template is view only.',
    'rezygnacja.daneFirmy': 'The account has been cancelled: company data is view only, while invoice settings can be saved as usual.',
    'reservation.choose': 'Choose',
    'reservation.pickDate': 'Pick a date',
    'reservation.success.saved': 'Reservation saved!',
    'reservation.error.fill': 'Fill all required fields!',
    'reservation.error.equipment': 'Choose equipment!',
    'reservation.error.save': 'Error saving reservation.',
    'reservation.error.selectDates': 'Please select reservation dates first!',
    'reservation.paymentAndDiscount': 'Discount & Payment',
    'reservation.paymentMethodPlaceholder': 'Choose payment',
    'reservation.clearRangeTitle': 'Clear selected range',
    'reservation.notePlaceholder': 'Additional notes...',
    'reservation.generateContract': 'Generate contract',
    'reservation.generatingContract': 'Generating contract…',
    'reservation.contractGenerated': 'The contract has been generated and downloaded.',
    'contractError.session': 'Your session has expired. Log in again and try once more.',
    'contractError.tooLarge': 'The contract data is too large to send. Shorten the note or reduce the number of items.',
    'contractError.busy': 'The server is busy right now. Please try again in a moment.',
    'contractError.noTemplate': 'No contract template found. Publish a template in the contract builder.',
    'contractError.server': 'The server did not prepare the document. Check your own .docx template in the contract settings or try again.',
    'contractError.http': 'The server returned an error (HTTP {status}).',
    'contractError.network': 'No connection to the server. Check your internet connection and try again.',
    'reservation.cleared': 'Form has been cleared',
    'reservation.contract.generated': 'Contract generated and downloaded',
    'reservation.subtitle': 'Create a new equipment reservation',
    'reservation.addressEdit': 'Edit address',

    // Validation
    'validation.required': 'This field is required',
    'validation.invalidEmail': 'Invalid email format',
    'validation.selectEquipment': 'Select at least one piece of equipment',
    'validation.fillAllFields': 'Please fill in all required fields to continue.',

    // Home page
    'home.header': 'Rental dashboard',
    'home.nav.calendar': 'Calendar',
    'home.nav.newReservation': 'New Reservation',
    'home.nav.statistics': 'Statistics',
    'home.nav.profile': 'Profile',
    'home.ongoingReservations': 'Ongoing reservations',
    'home.upcomingShort': 'Upcoming',
    'home.ongoingShort': 'Ongoing',
    'home.kpisTitle': 'Key metrics',
    'home.kpisSubtitle': 'Overview of key data from your rental',
    'home.kpis.clients': 'Clients',
    'home.favorites': 'Favorites',
    'home.favorites.helper': 'Choose up to 4 pages',
    'home.favorites.edit': 'Edit',
    'home.favorites.choose': 'Select pages to appear in Favorites (max 4)',
    'home.favorites.cancel': 'Cancel',
    'home.favorites.save': 'Save',
    'home.pagination.prev': 'Previous',
    'home.pagination.next': 'Next',
    'home.pagination.page': 'Page',
    'home.pagination.of': 'of',
    'home.upcomingReservations': 'Upcoming reservations',
    'home.loadingReservations': 'Loading reservations...',
    'home.noRentals': 'No rentals',

    'home.rental.today': 'Rentals for today',
    'home.rental.week': 'Rentals for this week',
    'home.rental.month': 'Rentals for 30 days',
    'home.rental.all': 'All reservations',

    'home.period.today': 'Today',
    'home.period.week': 'This week',
    'home.period.month': '30 Days',
    'home.period.all': 'All',

    'home.kpis.title': 'KPIs',
    'home.kpis.totalRentals': 'Total rentals',
    'home.kpis.availableEquipment': 'Available equipment',
    'home.kpis.activeCustomers': 'Active customers',
    'home.kpis.overdueReturns': 'Overdue returns',
    'home.category.all': 'All categories',
    'home.loading': 'Loading...',
    'home.noData': 'No data',
    'home.bestSellers.title': 'Most rented equipment',
    'home.filter.all': 'All',
    'home.table.name': 'Name',
    'home.table.size': 'Size',
    'home.table.brand': 'Brand',
    'home.table.category': 'Category',
    'home.table.class': 'Class',
    'home.table.rentalsYear': 'Rentals (year)',
    'home.refresh': 'Refresh data',
    'home.noCategories': 'No categories',
    'home.favorites.desc.calendar': 'Calendar view and reservation details',
    'home.favorites.desc.reservation': 'Quickly create a new reservation',
    'home.favorites.desc.statistics': 'Quick access to statistics',
    'home.favorites.desc.profile': 'Account settings and profile',

    // Calendar
    'calendar.title': 'Reservation Calendar',
    'calendar.titleHint': 'Manage reservations and plan equipment utilization',
    'calendar.addReservation': 'Add Reservation',
    'calendar.todayButton.label': 'Today',
    'calendar.todayButton.tooltip': 'Go to today',
    'calendar.legend.start': 'Start',
    'calendar.legend.end': 'End',
    'calendar.tabs.calendar': 'Calendar',
    'calendar.tabs.upcoming': 'Upcoming',
    'calendar.tabs.history': 'History',
    'calendar.tabs.returns': 'Returns due',
    'calendar.equipmentCountOne': '{count} item',
    'calendar.equipmentCountFew': '{count} items',
    'calendar.equipmentCountMany': '{count} items',
    'calendar.equipmentCountOther': '{count} items',
    'calendar.moreReservations': '{count} more reservation(s) - click the day to see all',
    'calendar.moreWord': 'more',

    'calendar.dayReservations.title': 'Reservations for',
    'calendar.dayReservations.empty': 'No reservations for this day.',
    'calendar.dayReservations.noneToday': 'no reservations',

    'calendar.dayPlan.pickups': 'Pick-ups',
    'calendar.dayPlan.itemPickedUp': 'handed out',
    'calendar.dayPlan.itemReturned': 'returned',
    'calendar.dayPlan.itemReturnsToday': 'back today',
    'calendar.dayPlan.prepareReturningToday': 'back today: {count} pcs',
    'calendar.dayPlan.returns': 'Returns',
    'calendar.dayPlan.ongoing': 'Ongoing',
    'calendar.dayPlan.pickupsEmpty': 'Nothing to hand out on this day.',
    'calendar.dayPlan.returnsEmpty': 'Nothing comes back on this day.',
    'calendar.dayPlan.ongoingEmpty': 'No rentals carried over from earlier days.',
    'calendar.dayPlan.prepare': 'To prepare',
    'calendar.dayPlan.pieces': '{count} pcs',
    'calendar.dayPlan.noSize': 'no size',
    'calendar.dayPlan.noType': 'No category',
    'calendar.dayPlan.otherEquipment': 'Other equipment',
    'calendar.dayPlan.equipmentLoading': 'Loading inventory...',
    'calendar.dayPlan.equipmentFailed': 'Could not load the inventory, so there is no breakdown by type and size. Refresh the page.',
    'calendar.dayPlan.print': 'Print day plan',
    'calendar.dayPlan.printTitle': 'Day plan',
    'calendar.dayPlan.until': 'until {date}',
    'calendar.dayPlan.since': 'since {date}',
    'calendar.dayPlan.sameDayReturn': 'returned the same day',
    'calendar.dayPlan.sameDayPickup': 'handed out the same day',
    'calendar.dayPlan.inventoryNo': 'no. {number}',
    'calendar.dayPlan.unknownItem': 'Item #{id}',
    'calendar.dayPlan.noEquipment': 'no equipment',
    'calendar.dayPlan.reservationNo': 'Reservation #{id}',
    'calendar.dayPlan.printedAt': 'Printed: {date}',

    'calendar.delete.refundFailed': 'Refund failed: {error}. The reservation was NOT deleted. Click again to finish the refund, or refund manually from the Payments list.',
    'calendar.delete.genericError': 'An error occurred while cancelling the reservation.',

    // ReservationFormView
    'reservationForm.date.startBeforeToday': 'The start date cannot be earlier than today.',
    'reservationForm.date.endBeforeToday': 'The end date cannot be earlier than today.',
    'reservationForm.classQuote.failed': 'The price of this class request could not be recalculated, so the new dates and equipment cannot be saved now. Try again in a moment.',
    'reservationForm.deposit.overrideConfirm': 'The deposit {amount} is {times}x higher than the selected equipment\'s deposit ({equipmentDeposit}). This amount will be blocked on the customer\'s card. Save anyway?',
    'reservationForm.payment.sendLinkError': 'Failed to send the link',
    'reservationForm.payment.linksPremium': 'Online payment links and card payments through Stripe are part of the Premium plan. Record cash or transfer payments below.',
    'reservationForm.payment.sendLinkPriceList': 'Send a link for the rest',
    'reservationForm.payment.priceListNote': 'The price list will calculate the amount in the link: this discounted reservation was saved before amounts were calculated the new way, so it may differ from “Remaining to pay”. You will see the exact amount in the email to the customer and on the payment page.',
    'reservationForm.payment.prepareLinkError': 'Failed to prepare the link',
    'reservationForm.payment.initError': 'Failed to initiate the payment',
    'reservationForm.photos.addRequired': 'Add a photo or a note.',
    'reservation.save.paymentLinkFailed': 'Reservation saved, but the payment link could not be sent. You can send it from the Calendar.',
    'reservation.payLinkPremium': 'The online payment link is part of the Premium plan.',
    'reservation.save.paymentLinkFailedReason': 'Reservation saved, but the payment link was not sent: {reason}',
    'reservation.save.docsPartialFailure': 'Reservation saved, but {failed} of {total} documentation entries failed to save (reason: {reason}). Add them from the Calendar.',
    'reservation.save.docsUnconfirmed': 'Reservation saved, but {failed} of {total} documentation entries have no save confirmation because the server response did not arrive. Check the reservation documentation in the Calendar and add any missing entries.',
    'reservation.save.docsMixed': 'Reservation saved, but {failed} of {total} documentation entries failed to save (reason: {reason}), and for {unconfirmed} there is no save confirmation because the server response did not arrive. Check the reservation documentation in the Calendar and add any missing entries.',
    'reservationForm.photos.partialFailure': '{failed} of {total} entries failed to save. Reason: {reason}.',
    'reservationForm.photos.reasonConnection': 'a temporary server error',
    'reservationForm.photos.unconfirmed': '{count} of {total} entries have no save confirmation: the server response did not arrive, but saving may have succeeded anyway.',
    'reservationForm.photos.reasonSession': 'your session has expired, please log in again',
    'reservationForm.photos.reasonRejected': 'the server did not accept the entry',
    'reservationForm.photos.removedFiles': 'Photos the server will not accept were removed from the form: {files}.',
    'reservationForm.photos.checkListBeforeRetry': 'Before sending again, check the documentation list of this reservation.',
    'reservationForm.photos.deleteConfirmTitle': 'Delete this documentation entry?',
    'reservationForm.deposit.operationError': 'Deposit operation failed',
    'reservationForm.offline.invalidAmount': 'Enter a valid amount.',
    'reservationForm.offline.confirmSaveTitle': 'Save {what} {how}?',
    'reservationForm.offline.confirmSaveMessage': 'This will create a payment entry. Use it ONLY when the customer has actually paid.',
    'reservationForm.offline.saveError': 'Failed to save the payment',
    'reservationForm.offline.advanceWord': 'the advance',
    'reservationForm.offline.paymentWord': 'a payment of {amount}',
    'reservationForm.offline.cashWord': 'in cash',
    'reservationForm.offline.transferWord': 'by transfer',
    'reservationForm.offline.cardWord': 'by card (terminal)',
    'reservationForm.offline.amountPrompt': 'Amount paid {how} in PLN:',
    'reservationForm.customLink.sentToClient': 'The link for the specified amount was sent to the customer.',
    'reservationForm.customLink.copied': 'Link copied.',
    'reservationForm.contract.generateError': 'Failed to generate the contract: {message}',
    'reservationForm.deposit.linkSent': 'The deposit hold link was sent to the customer.',
    'reservationForm.deposit.linkCopied': 'Deposit hold link copied.',
    'reservationForm.deposit.invalidAmountRange': 'Invalid amount. Enter a value between 0.01 and {max}.',
    'reservationForm.deposit.captureConfirm': 'Capture {amount} from the deposit? The remaining hold will be released.',
    'reservationForm.deposit.releaseConfirm': 'Release the entire deposit hold? The funds will return to the customer.',
    'reservationForm.deposit.refundConfirm': 'Refund {amount} of the captured deposit to {email}?',
    'reservationForm.deposit.title': 'Deposit',
    'reservationForm.deposit.takenCash': '{amount} taken in cash',
    'reservationForm.deposit.takenTransfer': '{amount} taken by bank transfer',
    'reservationForm.deposit.takenCard': '{amount} taken by card (terminal)',
    'reservationForm.deposit.cancelledNote': 'The reservation is cancelled, so it does not take a new deposit.',
    'reservationForm.deposit.refundAdminOnly': 'An administrator refunds a card deposit.',
    'reservationForm.deposit.offlineHint': 'Or take the deposit on site:',
    'reservationForm.deposit.linksPremium': 'The card deposit link is part of the Premium plan. Take the deposit in cash or by transfer below.',
    'reservationForm.deposit.offlineCash': 'Deposit in cash',
    'reservationForm.deposit.offlineTransfer': 'Deposit by transfer',
    'reservationForm.deposit.offlineCard': 'Deposit by card (terminal)',
    'reservationForm.deposit.offlineConfirm': 'Record a deposit of {amount} taken {how}?',
    'reservationForm.deposit.offlineSaved': 'Deposit taken on site recorded.',
    'reservationForm.deposit.giveBack': 'Return deposit',
    'reservationForm.deposit.giveBackConfirm': 'Record returning {amount} of the deposit to the customer? A smaller amount is a deduction for damage.',

    'calendar.delete.title': 'Cancel reservation',
    'calendar.delete.confirmMessage': 'Cancel reservation #{id}?',
    'calendar.delete.irreversible': 'The reservation stays in the history as cancelled and the equipment becomes available again right away. Cancelling cannot be undone.',
    'calendar.delete.paidOnline': 'Paid online',
    'calendar.delete.cancelFeeLabel': 'Cancellation fee (kept)',
    'calendar.delete.cancelFeeAria': 'Cancellation fee',
    'calendar.delete.cancelFeeUnitAria': 'Cancellation fee unit',
    'calendar.delete.toRefund': 'Refund to customer',
    'calendar.delete.feeLockedHint': 'Part of the refund has already been processed, so the amounts are locked. Click again to finish the refund and delete.',
    'calendar.delete.feeHint': 'The refund goes back to the card the customer paid with. The kept part remains as a cancellation fee. Leave it empty to refund in full.',
    'calendar.delete.refundCheckFailed': 'Couldn\'t check this reservation\'s paid online payments. If you cancel it anyway, process any refund manually from the Payments list.',
    'calendar.delete.checkingPayments': 'Checking payments…',
    'calendar.delete.deleting': 'Cancelling…',
    'calendar.delete.deleteAnyway': 'Cancel anyway',
    'calendar.delete.refundAndDelete': 'Refund {amount} and cancel',
    'calendar.delete.confirmCancel': 'Cancel reservation',
    'calendar.delete.keep': 'Keep it',
    'calendar.delete.done': 'Reservation #{id} cancelled. You will find it in the History tab.',
    'calendar.delete.feeOverPaid': 'The fee is higher than the payment ({amount}). Correct the amount or enter 100% to keep all of it.',
    'calendar.delete.fixFee': 'Correct the fee',
    'calendar.delete.adminRequired': 'Money was received for this reservation. Only an administrator can cancel it and settle the refund of the payment and deposit.',
    'calendar.delete.paidOnSite': 'Received on site',
    'calendar.delete.paidOnSiteWithMethods': 'Received on site ({methods})',
    'calendar.delete.paidOnSiteHint': 'The panel won\'t refund this money: give it back to the customer yourself, in cash or by transfer.',
    'calendar.delete.paidOnInvoice': 'Entered on invoice {number}',
    'calendar.delete.paidOnInvoiceHint': 'The panel won\'t refund these payments: give them back to the customer yourself, in cash or by transfer.',
    'calendar.delete.depositAuthorized': 'Deposit held on the card',
    'calendar.delete.releaseDeposit': 'Release the deposit hold when cancelling',
    'calendar.delete.depositKeptHint': 'The deposit stays on hold. You can release it later in the cancelled reservation\'s details.',
    'calendar.delete.depositCaptured': 'Deposit captured',
    'calendar.delete.depositCapturedHint': 'The captured deposit stays with the reservation. Refund it from the deposit card in the reservation details.',
    'calendar.delete.depositReleaseFailed': 'Reservation cancelled, but the deposit couldn\'t be released. Release it in the cancelled reservation\'s details.',

    'calendar.upcoming.title': 'Upcoming Reservations',
    'calendar.upcoming.empty': 'No upcoming reservations.',
    'calendar.returns.hint': 'Reservations due back today that are not fully returned, and overdue ones: equipment handed out that did not come back on time.',
    'calendar.returns.overdue': 'Overdue',
    'calendar.returns.today': 'Due back today',
    'calendar.returns.empty': 'Nothing is waiting to be returned.',
    'calendar.returns.loadFailed': 'Could not load the returns list. Refresh the page.',
    'calendar.returns.lateOne': '{count} day overdue',
    'calendar.returns.lateFew': '{count} days overdue',
    'calendar.returns.lateMany': '{count} days overdue',
    'calendar.returns.lateOther': '{count} days overdue',
    'calendar.handover.out': 'With customer: {n} of {total}',
    'calendar.handover.allReturned': 'Equipment returned',

    'calendar.history.title': 'All Reservations History',
    'calendar.history.empty': 'No reservations in database.',
    'calendar.history.noResults': 'No results for the selected criteria.',
    'calendar.history.loadMore': 'Show more',
    'calendar.history.loadFailed': 'Could not load the reservation history. Please try again.',
    'calendar.history.statusFilterHint': 'The status filter covers loaded reservations. Load older ones with the button next to it.',

    'calendar.filters.from': 'From:',
    'calendar.filters.to': 'To:',
    'calendar.filters.name': 'First or last name:',
    'calendar.filters.namePlaceholder': 'Enter first or last name',
    'calendar.filters.status': 'Status:',
    'calendar.filters.statusAll': 'All',
    'calendar.filters.clear': 'Clear filters',

    'calendar.status.upcoming': 'Upcoming',
    'calendar.status.ongoing': 'Ongoing',
    'calendar.status.finished': 'Finished',
    'calendar.status.cancelled': 'Cancelled',
    'calendar.status.overdue': 'Overdue',
    'calendar.status.unknown': 'Unknown',
    'calendar.status.nadchodząca': 'Upcoming',
    'calendar.status.trwająca': 'Ongoing',
    'calendar.status.zakończona': 'Finished',

    'calendar.pagination.previous': 'Previous',
    'calendar.pagination.next': 'Next',
    'calendar.pagination.pageInfo': 'Page {page} of {total}',

    'calendar.details': 'Details',
    'calendar.startLabel': 'start',
    'calendar.endLabel': 'end',

    'calendar.modal.title': 'Reservation Details',
    'calendar.modal.clientData': 'Client Data',
    'calendar.modal.rentalPeriod': 'Rental Period',
    'calendar.modal.equipment': 'Rented Equipment',
    'calendar.modal.financial': 'Financial Information',
    'calendar.modal.additional': 'Additional Information',
    'calendar.modal.edit': 'Edit',
    'calendar.modal.delete': 'Delete',
    'calendar.modal.deleteConfirmTitle': 'Confirm reservation deletion',
    'calendar.modal.deleteConfirmText': 'Are you sure you want to delete the reservation',
    'calendar.modal.deleteWarning': 'This action is irreversible!',
    'calendar.modal.cancel': 'Cancel',
    'calendar.modal.close': 'Close',

    // Calendar - EDYCJA
    'calendar.edit.title': 'Edit Reservation',
    'calendar.edit.firstname': 'First name:',
    'calendar.edit.lastname': 'Last name:',
    'calendar.edit.cancel': 'Cancel',
    'calendar.edit.save': 'Save Changes',
    'calendar.edit.success': 'Reservation has been updated!',
    'calendar.edit.error': 'Error updating reservation',

    'calendar.paymentStatus.Opłacone': 'Paid',
    'calendar.paymentStatus.Nieopłacone': 'Unpaid',
    'calendar.paymentStatus.Częściowo opłacone': 'Partially paid', 
    'calendar.paymentStatus.Zwrot': 'Refund',
    
    'calendar.paymentMethod.Karta płatnicza': 'Credit card',
    'calendar.paymentMethod.Gotówka': 'Cash',
    'calendar.paymentMethod.Przelew': 'Bank transfer',
    'calendar.paymentMethod.BLIK': 'BLIK',
    'calendar.paymentMethod.PayPal': 'PayPal',
    'calendar.paymentMethod.Inne': 'Other',

    'calendar.label.nameSurname': 'Name and surname:',
    'calendar.label.phone': 'Phone:',
    'calendar.label.email': 'E-mail:',
    'calendar.label.address': 'Address:',
    'calendar.label.idNumber': 'ID number:',
    'calendar.label.registrationDate': 'Client registration date:',
    'calendar.label.reservationDate': 'Reservation date:',
    'calendar.label.from': 'From:',
    'calendar.label.to': 'To:',
    'calendar.label.duration': 'Duration:',
    'calendar.label.days': 'days',
    'calendar.label.discount': 'Discount:',
    'calendar.label.status': 'Status:',
    'calendar.label.totalPrice': 'Total price:',
    'calendar.label.deposit': 'Deposit:',
    'calendar.label.paymentStatus': 'Payment status:',
    'calendar.label.paymentMethod': 'Payment method:',
    'calendar.label.paymentDate': 'Payment date:',
    'calendar.label.note': 'Note:',
    'calendar.label.reservationId': 'Reservation ID:',
    'calendar.label.createdAt': 'Created at:',
    'calendar.label.updatedAt': 'Last modified:',

    'calendar.currency': 'zł',
    
    'calendar.weekdays': [
      "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
    ],
    'calendar.months': [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ],
    'calendar.monthsShort': [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ],

    // Statistics
    'statistics.header': 'Rental statistics',
    'statistics.subtitle': 'Overview of key metrics and charts',
    'statistics.clearFilters': 'Clear KPI filters',
    'statistics.year': 'Year',
    'statistics.month': 'Month',
    'statistics.periodFor': 'Period',
    'statistics.metric.count': 'Number of reservations',
    'statistics.metric.value': 'Rental value',
    'statistics.bar.count': 'Number of reservations',
    'statistics.bar.value': 'Rental value',
    'statistics.loading': 'Loading data...',
    'statistics.kpi.title': 'KPI',


    'statistics.section.finances': 'Finances',
    'statistics.summary.rentalValue': 'Rental value in period',
    'statistics.summary.rentalValueHint': 'Total of reservations after discounts, regardless of invoices issued. Invoiced sales are shown on the Invoices screen.',
    'statistics.finances.valuePerActiveCustomer': 'Value per active customer',



    'statistics.section.customers': 'Customers',


    'statistics.advanced.title': 'Advanced metrics',
    'statistics.advanced.periodDays': 'Period days',
    'statistics.advanced.equipmentCount': 'Equipment count',
    'statistics.advanced.byCategory': 'By category',
    'statistics.advanced.revenuePerItem': 'Revenue / item (top)',
    'statistics.advanced.itemName': 'Equipment',
    'statistics.advanced.itemRevenue': 'Revenue',
    'statistics.advanced.itemRentals': 'Rentals',
    'statistics.advanced.itemAvg': 'Avg / rental',
    'statistics.advanced.inventoryNumber': 'no. {number}',
    'statistics.advanced.revenue': 'Revenue',
    'statistics.advanced.rentals': 'Reservations',
    'statistics.prevYear': 'Previous year',
    'statistics.nextYear': 'Next year',
    'statistics.wholeYear': 'Whole year',
    'statistics.noSeason': 'No season',
    'statistics.seasonLabel': 'Season',
    'statistics.season.winter': 'Winter',
    'statistics.season.spring': 'Spring',
    'statistics.season.summer': 'Summer',
    'statistics.season.autumn': 'Autumn',
    'statistics.loadError': 'Could not load the indicators. Refresh the page.',
    'statistics.chart.revenuePln': 'Rental value (PLN)',
    'statistics.chart.reservationsCount': 'Number of reservations',
    'statistics.chart.hint': 'click a bar, season or trend to narrow the KPIs',
    'statistics.chart.monthlyActivity': 'Monthly activity',
    'statistics.chart.equipmentStatus': 'Equipment today',
    'statistics.chart.equipmentTotal': 'Total: {count} pcs.',
    'statistics.chart.itemsUnit': 'pcs.',
    'statistics.chart.noData': 'No data',
    'statistics.chart.inUseToday': 'In use',
    'statistics.chart.availableToday': 'Available',
    'statistics.chart.outOfServiceToday': 'In service or inactive',
    'statistics.chart.seasonality': 'Seasonality',
    'statistics.chart.bySeason': 'Seasons of {year}',
    'statistics.chart.reservationsUnit': 'res.',
    'statistics.chart.noDataFor': 'No data for {year}',
    'statistics.chart.trend': 'Monthly trend',
    'statistics.badge.period': 'Period: {label}',
    'statistics.badge.activeCustomers': 'Active customers in period: {count}',
    'statistics.badge.availableToday': 'Equipment available today: {count}',
    'statistics.change.noComparison': 'No data to compare with',
    'statistics.change.vsPeriod': '{value} vs {period}',
    'statistics.change.comparedWith': 'vs {period}',
    'statistics.change.vsPeriodOngoing': '{value} vs {period} (period in progress)',
    'statistics.change.comparedWithOngoing': 'vs {period} (period in progress)',
    'statistics.change.notStarted': 'The period has not started yet',
    'statistics.change.year': '{year}',
    'statistics.change.season.winter': 'winter {label}',
    'statistics.change.season.spring': 'spring {label}',
    'statistics.change.season.summer': 'summer {label}',
    'statistics.change.season.autumn': 'autumn {label}',
    'statistics.section.demand': 'Demand and reservations',
    'statistics.section.operations': 'Operations and equipment',
    'statistics.card.reservationsPeriod': 'Reservations in period',
    'statistics.card.reservationsYear': 'Reservations in {year}',
    'statistics.card.avgDays': 'Average rental length',
    'statistics.card.daysValue': '{value} days',
    'statistics.card.change': 'Reservations year on year',
    'statistics.card.revenueYear': 'Rental value in {year}',
    'statistics.card.avgReservationValuePeriod': 'Average reservation value in period',
    'statistics.card.utilization': 'Equipment utilization',
    'statistics.card.utilizationMeta': '{rented} of {available} rental days',
    'statistics.card.rentedOnce': 'Equipment rented at least once in period',
    'statistics.card.rentedOnceValue': '{count} pcs. ({percent}%)',
    'statistics.card.inUseToday': 'Equipment in use today',
    'statistics.card.availableToday': 'Equipment available today',
    'statistics.card.activeCustomers': 'Active customers in period',
    'statistics.card.activeOfAll': 'Active in period: {active}, customers in total: {total}',
    'statistics.card.activeShare': 'Share of active customers',
    'statistics.card.newCustomers': 'New customers in period',
    'statistics.card.reservationsPerCustomer': 'Avg. reservations per active customer',
    'statistics.advanced.category': 'Category',
    'statistics.advanced.seasonalityYear': 'Seasonality {year}',

    // Security
    'security.title': 'Security',
    'security.changePassword': 'Change password',
    'security.oldPassword': 'Old password',
    'security.newPassword': 'New password',
    'security.password': 'Password',
    'security.confirmPassword': 'Confirm password',
    'security.repeatPassword': 'Repeat new password',
    'security.subtitle': 'Manage password, sessions and monitor account activity',
    'security.changePasswordButton': 'Change password',
    'security.changing': 'Changing...',
    'security.change': 'Change',
    'security.passwordsDifferent': 'Passwords do not match.',
    'security.passwordTooShort': 'Password too short (min. 6 chars).',
    'security.passwordChanged': 'Password changed.',
    'security.changePasswordError': 'Error changing password.',
    'security.twoFA': 'Two-factor authentication (2FA)',
    'security.enabled': 'Enabled',
    'security.disabled': 'Disabled',
    'security.disable2FA': 'Disable 2FA',
    'security.enable2FA': 'Enable 2FA',
    'twoFactorSetup.intro': "Enable two-step verification. You'll need an authenticator app: Google Authenticator, Authy, or Microsoft Authenticator.",
    'twoFactorSetup.startError': 'Failed to start the setup.',
    'twoFactorSetup.connectionError': 'Connection to the server failed.',
    'twoFactorSetup.wrongCodeError': 'Wrong code. Please try again.',
    'twoFactorSetup.loading': 'Loading...',
    'twoFactorSetup.startButton': 'Start setup',
    'twoFactorSetup.step1Title': 'Step 1: Scan the QR code',
    'twoFactorSetup.step1Intro': 'Open your authenticator app and scan the QR code below:',
    'twoFactorSetup.qrAlt': '2FA setup QR code',
    'twoFactorSetup.cantScan': "Can't scan it? Enter the key manually:",
    'twoFactorSetup.next': 'Next →',
    'twoFactorSetup.step2Title': 'Step 2: Confirm the code',
    'twoFactorSetup.step2Intro': 'Enter the 6-digit code from the app to confirm the setup is correct:',
    'twoFactorSetup.verifying': 'Verifying...',
    'twoFactorSetup.confirm': 'Confirm',
    'twoFactorSetup.passwordLabel': 'Current password (required to turn on verification)',
    'twoFactorSetup.back': 'Back',
    'twoFactorSetup.step3Title': 'Step 3: Backup codes',
    'twoFactorSetup.importantLabel': 'Important:',
    'twoFactorSetup.backupCodesWarning': "Save these codes somewhere safe. Each one can be used only once, and they won't be shown again.",
    'twoFactorSetup.copied': '✓ Copied!',
    'twoFactorSetup.copyAll': 'Copy all',
    'twoFactorSetup.done': 'Done - 2FA active',
    'security.activeSessions': 'Active sessions',
    'security.device': 'Device',
    'security.ip': 'IP',
    'security.lastActivity': 'Last activity',
    'security.status': 'Status',
    'security.current': 'Current',
    'security.other': 'Other',
    'security.logout': 'Log out session',
    'security.noSessions': 'No active sessions.',
    'security.logoutOthers': 'Log out other sessions',
    'security.sessionRevoked': 'Session revoked.',
    'security.operationError': 'Operation error.',
    'security.loginHistory': 'Login history',
    'security.time': 'Time',
    'security.noHistory': 'No history.',
    'security.ok': 'OK',
    'security.error': 'Error',
    'security.auditLog': 'Security audit',
    'security.devices.title': 'Signed-in devices',
    'security.devices.subtitle': 'Browsers and devices with active access to your account. If you do not recognise one, sign it out.',
    'security.devices.lastActive': 'Last active:',
    'security.devices.revoke': 'Sign out',
    'security.devices.revoking': 'Signing out...',
    'security.devices.revokeAll': 'Sign out all other devices',
    'security.devices.confirmAll': 'Are you sure? They will need to sign in again.',
    'security.devices.confirmYes': 'Yes, sign out',
    'security.devices.thisDevice': 'This device',
    'security.devices.unknown': 'Unknown',
    'security.devices.empty': 'No active devices',
    'security.devices.revokedOne': 'The device has been signed out.',
    'security.devices.revokedAll': 'Devices signed out: {count}.',
    'security.devices.revokeFailed': 'Could not sign the device out. Please try again.',
    'security.action': 'Action',
    'security.details': 'Details',
    'security.noAudit': 'No audit events',
    'security.currentPassword': 'Current password',
    'security.empty.loginHistory': 'No login history',
    'security.empty.auditLog': 'No audit events',

    // Users
    'users.noPermissions': 'No permissions',
    'users.adminOnly': 'This section is available to administrators only.',
    'users.title': 'User management',
    'users.addUser': 'Add user',
    'users.firstName': 'First name',
    'users.lastName': 'Last name',
    'users.email': 'Email',
    'users.admin': 'Admin',
    'users.actions': 'Actions',
    'users.undoDelete': 'Undo delete',
    'users.delete': 'Delete',
    'users.noUsers': 'No users.',
    'users.revokeSessions': 'Sign out of all devices',
    'users.revokeSelfHint': 'Sign your own devices out from Account security',
    'users.revokeConfirm': 'This employee will be signed out on every device and will have to sign in again.',
    'users.revokeAction': 'Sign out',
    'users.revokeDone': 'Devices signed out: {count}.',
    'users.revokeFailed': 'Could not sign the employee out. Please try again.',
    'users.user': 'Employee',
    'users.saving': 'Saving…',
    'users.saveError': 'Error saving users.',
    'users.changesSaved': 'Changes saved.',
    'users.confirmPassword': 'Confirm with password',
    'users.enterAdminPassword': 'Enter admin password to confirm changes.',
    'users.password': 'Password',
    'users.confirmAndSave': 'Confirm and save',
    'users.confirmDelete': 'Are you sure you want to delete this user?',
    'users.deleteError': 'Error deleting user',
    'users.deleteModalTitle': 'Confirm user deletion',
    'users.passwordConfirmLabel': 'Administrator password (confirmation)',
    'users.passwordPlaceholder': 'Enter password',
    'users.enterPasswordError': 'Enter your password to confirm this operation.',
    'users.wrongPasswordError': 'Incorrect password.',
    'users.cannotDeleteSelfError': 'You cannot delete yourself.',
    'users.lastAdminError': 'Cannot delete this user - they are the last administrator in the system.',
    'users.serverError': 'Server error ({status})',
    'userDetails.adminModalTitle': 'Confirm permission change',
    'users.noFirstName': 'No first name',
    'users.noLastName': 'No last name',
    'users.noEmail': 'No email',
    'users.loadError': 'Error loading users',
    'users.invalidPhone': 'Phone number cannot contain more than 9 digits.',

    // YourData
    'yourData.saved': 'Data saved.',
    'yourData.saveError': 'Error saving data.',
    'yourData.loginAgain': 'Please log in again.',
    'yourData.title': 'Your data',
    'yourData.noPhoto': 'No photo',
    'yourData.choose': 'Choose photo',
    'yourData.remove': 'Remove',
    'yourData.firstName': 'First name',
    'yourData.lastName': 'Last name',
    'yourData.email': 'Email',
    'yourData.phone': 'Phone',
    'yourData.saving': 'Saving…',
    'yourData.fileTooLarge': 'File too large (max 1MB).',
    'yourData.firstNamePlaceholder': 'First name',
    'yourData.lastNamePlaceholder': 'Last name',
    'yourData.emailPlaceholder': 'email@example.com',
    'yourData.phonePlaceholder': '+48 123 456 789',
    'yourData.success': 'Data has been updated',
    'yourData.error': 'Error updating data',
    'yourData.invalidPhone': 'Invalid phone number - provide 9 digits (e.g. 501234567) or remove +48/spaces.',
    'yourData.change': 'Change data',
    'yourData.loading': 'Loading data...',
    'yourData.noUser': 'No logged-in user.',
    'yourData.loadError': 'Failed to load user data.',
    'yourData.backToProfile': 'Back to profile',
    'yourData.fillRequired': 'Fill in the required fields',
    'security.passwordMinStrength': 'The password must be at least: {strength}',
    'security.policy.minLength': 'Min. {min} characters',
    'security.policy.upperCase': 'Uppercase letter',
    'security.policy.lowerCase': 'Lowercase letter',
    'security.policy.digit': 'Digit',
    'security.policy.minStrength': 'Password strength: at least "{strength}"',
    'security.twoFA.title': 'Two-step verification (2FA)',
    'security.twoFA.active': 'Active',
    'security.twoFA.enabledOn': 'Enabled: {date}',
    'security.twoFA.backupCodesRemaining': 'Backup codes remaining: {count} / 10',
    'security.twoFA.lowCodesWarning': '(Low on codes - consider disabling and re-enabling 2FA to generate new ones)',
    'security.twoFA.confirmDisableIntro': 'To disable 2FA, confirm your identity with a TOTP code or a backup code:',
    'security.twoFA.codePlaceholder': 'TOTP code (6 digits) or backup code (XXXX-XXXX)',
    'security.twoFA.disabling': 'Disabling...',
    'security.twoFA.confirmDisable': 'Confirm disable',
    'security.twoFA.intro': "Two-step verification adds an extra layer of protection to your account. Once enabled, you'll be asked for a 6-digit code from your authenticator app every time you sign in.",
    'passwordStrength.0': 'Very weak',
    'passwordStrength.1': 'Weak',
    'passwordStrength.2': 'Fair',
    'passwordStrength.3': 'Good',
    'passwordStrength.4': 'Strong',

    'addUser.invalidPhone': 'Invalid phone number - provide 9 digits (e.g. 501234567) or remove +48/spaces.',
    'equipmentDetails.title': 'Equipment details',
    'equipmentDetails.subtitle': 'Browse or edit equipment information',
    'equipmentDetails.edit': 'Edit',
    'equipmentDetails.save': 'Save',
    'equipmentDetails.cancel': 'Cancel',
    'equipmentDetails.loadError': 'Failed to load equipment data.',
    'equipmentDetails.saveSuccess': 'Changes saved!',
    'equipmentDetails.saveError': 'Error saving changes.',
    'equipmentDetails.calendar': 'Calendar',

    'superAdmin.nameEmailRequired': 'Name and email are required',
    'superAdmin.serverError': 'Could not reach the server',
    'superAdmin.ownerRequired': 'The owner\'s email and full name are required',
    'superAdmin.pendingStatusLocked': 'The status of an organisation awaiting activation cannot be changed. The client has to fill in the activation form first.',
    'superAdmin.orgUpdated': 'Organisation details updated',
    'superAdmin.copied': 'Copied to clipboard',
    'superAdmin.title': 'Super-admin panel',
    'superAdmin.subtitle': 'Managing organisations in the.rENT',
    'superAdmin.statAll': 'All organisations',
    'superAdmin.statActive': 'Active',
    'superAdmin.statPending': 'Awaiting activation',
    'superAdmin.searchPlaceholder': 'Search organisations...',
    'superAdmin.search': 'Search',
    'superAdmin.loading': 'Loading organisations...',
    'superAdmin.empty': 'No organisations to show',
    'superAdmin.colId': 'ID',
    'superAdmin.colName': 'Name',
    'superAdmin.colNip': 'Tax ID (NIP)',
    'superAdmin.colEmail': 'Email',
    'superAdmin.colPlan': 'Plan',
    'superAdmin.colStatus': 'Status',
    'superAdmin.colDemo': 'Demo',
    'superAdmin.colCreated': 'Created',
    'superAdmin.colActions': 'Actions',
    'superAdmin.editTooltip': 'Edit organisation details',
    'superAdmin.resendTooltip': 'Send the activation link again',
    'superAdmin.deletePendingTooltip': 'Delete this organisation awaiting activation',
    'superAdmin.addTitle': 'Add a new organisation',
    'superAdmin.noteBefore': 'The organisation will be created, but ',
    'superAdmin.demoNoteBefore': 'The demo organisation will be created, but ',
    'superAdmin.noteBold': 'the activation email will not be sent automatically',
    'superAdmin.fieldName': 'Rental company name *',
    'superAdmin.fieldEmail': 'Contact email *',
    'superAdmin.emailHint': 'The activation link goes to this address',
    'superAdmin.fieldNip': 'Tax ID (NIP)',
    'superAdmin.fieldPhone': 'Phone',
    'superAdmin.fieldAddress': 'Address',
    'superAdmin.fieldPlan': 'Subscription plan',
    'superAdmin.demoTitle': 'Create a demo organisation',
    'superAdmin.fieldOwnerName': 'Owner\'s full name *',
    'superAdmin.fieldOwnerEmail': 'Owner\'s email *',
    'superAdmin.demoEmailHint': 'The activation link goes to this address and is valid for 24h.',
    'superAdmin.demoPresetLabel': 'Rental business type',
    'superAdmin.demoPresetHint': 'Sets the sample equipment, customers and inventory configuration the lead sees after activation.',
    'superAdmin.demoDaysLabel': 'Demo length (days)',
    'superAdmin.demoDaysHint': 'Counted from account activation, 1 to 365 days.',
    'superAdmin.demoPurgeOn': 'deleted on {date}',
    'superAdmin.demoManage': 'Demo',
    'superAdmin.demoManageTooltip': 'Extend the demo or convert it into a customer account',
    'demoManage.title': 'Demo: {name}',
    'demoManage.extendTitle': 'Extend the demo',
    'demoManage.extendHint': 'An expired demo is extended from today, an active one from its current end. Extending also postpones automatic deletion.',
    'demoManage.extendPending': 'The account is not activated yet: you set the demo length counted from activation.',
    'demoManage.extendButton': 'Extend by {days} days',
    'demoManage.setDaysButton': 'Set {days} days from activation',
    'demoManage.extended': 'Demo extended.',
    'demoManage.convertTitle': 'Convert into a customer account',
    'demoManage.convertHint': 'The account stops being a demo: no time limit, no blocked messages or payments, no automatic deletion. Users, settings, inventory configuration, templates and the price lists and bundles the company added stay.',
    'demoManage.planLabel': 'Plan after conversion',
    'demoManage.planPlaceholder': 'Choose a plan',
    'demoManage.planHint': 'The demo runs on the Premium plan. Choose the plan the customer bought: Basic turns off the widget, e-mails from the rental company address and automatic reminders (e-mail and text message).',
    'demoManage.planRequired': 'Choose a plan first',
    'demoManage.wipeLabel': 'Delete sample data (recommended)',
    'demoManage.wipeHint': 'The fictional demo data and everything built on fictional customers will be deleted, including the sample bundle and price rule from the demo. Same-day exchange switched on in the demo will be turned off unless the company changed that setting.',
    'demoManage.previewItems': 'Customers: {clients} · equipment: {equipment} · reservations: {reservations} · offers: {offers} · invoices: {invoices}.',
    'demoManage.previewCompany': 'Also the fictional company data (tax ID, bank account, address), but only fields nobody changed.',
    'demoManage.previewLoading': 'Counting sample data…',
    'demoManage.previewFailed': 'Could not count the sample data.',
    'demoManage.keepHint': 'The sample data will stay in the customer account.',
    'demoManage.convertButton': 'Convert to customer',
    'demoManage.confirmConvertWipe': 'Convert "{name}" into a customer account and permanently delete the sample data?',
    'demoManage.confirmConvert': 'Convert "{name}" into a customer account without deleting the sample data?',
    'demoManage.converted': 'Demo converted into a customer account.',
    'demoManage.error': 'The operation failed.',
    'superAdmin.createdTitle': 'Organisation created',
    'superAdmin.createdBefore': 'Organisation ',
    'superAdmin.createdAfter': ' has been created successfully.',
    'superAdmin.activationLink': 'Activation link (valid 24h):',
    'superAdmin.editTitle': 'Edit organisation',
    'superAdmin.smtpCheckFailed': 'Could not check the SMTP status',
    'superAdmin.loadError': 'Could not load the organisations',
    'superAdmin.twoFactorRequiredTitle': 'Turn on two-step verification',
    'superAdmin.twoFactorRequiredBody': 'The admin panel manages every company, so a password alone is not enough. Turn on two-step verification (a code from an app on your phone), then log out and log back in with the code. Until then this account works like a regular admin account of your company.',
    'superAdmin.twoFactorRequiredCta': 'Go to security settings',
    'superAdmin.twoFactorSessionTitle': 'Log in again with your code',
    'superAdmin.twoFactorSessionBody': 'Two-step verification is already on, but this session logged in without a code. Log out and log back in with the code from the app on your phone.',
    'superAdmin.twoFactorSessionCta': 'Log out',
    'superAdmin.createError': 'Could not create the organisation',
    'superAdmin.createDemoError': 'Could not create the demo organisation',
    'superAdmin.updateError': 'Could not update the organisation',
    'superAdmin.resendError': 'Could not send the email',
    'superAdmin.deleteError': 'Could not delete the organisation',
    'superAdmin.confirmActivate': 'Activate this organisation?',
    'superAdmin.confirmDeactivate': 'Deactivate this organisation?',
    'superAdmin.confirmResend': 'Send the activation link to "{name}" ({email}) again?',
    'superAdmin.confirmDeletePending': 'Delete the pending organisation "{name}"?\n\nThis cannot be undone.',
    'superAdmin.demoAwaiting': 'awaiting activation',
    'superAdmin.demoExpired': 'expired',
    'superAdmin.dayOne': 'day',
    'superAdmin.dayMany': 'days',
    'superAdmin.statusSent': 'Sent',
    'superAdmin.statusActive': 'Active',
    'superAdmin.statusInactive': 'Inactive',
    'superAdmin.resending': 'Sending...',
    'superAdmin.resend': 'Send again',
    'superAdmin.delete': 'Delete',
    'superAdmin.activate': 'Activate',
    'superAdmin.deactivate': 'Deactivate',
    'superAdmin.submitCreate': 'Create organisation',
    'superAdmin.submitCreateDemo': 'Create demo',
    'superAdmin.noteCopyClient': 'Once created, copy the link and send it to the client yourself.',
    'superAdmin.noteCopyLead': 'Once created, copy the link and send it to the lead yourself.',
    'superAdmin.reason': 'Reason',
    'superAdmin.sentTo': 'The activation link was sent to',
    'superAdmin.emailNotSent': 'The email was not sent.',
    'superAdmin.copyLinkManually': 'Copy the link below and send it to the client yourself, for example over Messenger or SMS.',
    'superAdmin.filterAll': 'All',
    'superAdmin.filterActive': 'Active',
    'superAdmin.filterInactive': 'Inactive',
    'superAdmin.filterPaused': 'Paused',
    'superAdmin.statusPaused': 'Paused',
    'superAdmin.statusPauseScheduled': 'Pause from {od}',
    'superAdmin.pause': 'Pause',
    'superAdmin.pauseTooltip': 'Seasonal pause: read-only account',
    'pauseManage.title': 'Pause: {name}',
    'pauseManage.explain': 'During a pause the company can log in and browse data, and can save only invoices, KSeF, refunds and deposits. The widget, reminders and payment links are off, while invoices still go to KSeF. You end the pause here: nothing resumes the account on its own.',
    'pauseManage.startInfo': 'The pause starts on the 1st of next month. Until then the account works normally, but it will not accept a reservation that ends on the first day of the pause or later.',
    'pauseManage.stateActive': 'Paused since {od}.',
    'pauseManage.stateScheduled': 'Pause scheduled from {od}. Until then the account works as usual, but it will not accept a reservation that ends on that day or later.',
    'pauseManage.untilLabel': 'Planned end (optional)',
    'pauseManage.untilHint': 'The company sees this date on its banner. The pause does not end by itself on that day.',
    'pauseManage.enable': 'Start pause',
    'pauseManage.saveUntil': 'Save end date',
    'pauseManage.resume': 'End pause',
    'pauseManage.cancelScheduled': 'Cancel pause',
    'pauseManage.confirmNextMonth': 'Schedule a pause for "{name}" from the 1st of next month?',
    'pauseManage.confirmResume': 'End the pause of "{name}"? The account returns to full work right away.',
    'pauseManage.confirmCancel': 'Cancel the scheduled pause of "{name}"?',
    'pauseManage.enabled': 'Pause saved.',
    'pauseManage.untilSaved': 'Planned end saved.',
    'pauseManage.resumed': 'Pause ended.',
    'pauseManage.error': 'Could not change the pause.',
    'pauseManage.unsentKsef': 'Invoices that did not reach KSeF: {liczba}. The submission deadline keeps running during the pause, and the company can send them from the invoice list.',
    'pauseManage.confirmAnyway': 'Start the pause anyway?',
    'pauseManage.confirmOpenReservations': 'The company has reservations it cannot handle during the pause: ongoing on the first day of the pause: {trwajace}, later: {nadchodzace}. During the pause it cannot record their pickup, return or on site payment. Invoices, corrections and KSeF keep working during the pause. Start the pause anyway?',
    'superAdmin.filterResigned': 'Cancelled',
    'superAdmin.statusResigned': 'Cancelled, deletion from {od}',
    'superAdmin.statusResignScheduled': 'Cancellation from {od}',
    'superAdmin.resign': 'Cancellation',
    'superAdmin.resignTooltip': 'Cancellation: read-only account, data deletion after 30 days',
    'superAdmin.confirmDeactivateResigned': 'Deactivate the cancelled company? The cancellation will be withdrawn: the company loses login and the data export, and its data will not be deleted after 30 days.',
    'superAdmin.deleteData': 'Delete company data',
    'superAdmin.deleteDataTooltip': 'Permanently deletes all data of the cancelled company. Available from the deletion day, 30 days after the cancellation.',
    'superAdmin.deleteDataFrom': 'available from {od}',
    'deleteResigned.title': 'Delete company data: {name}',
    'deleteResigned.intro': 'The cancellation has been in effect since {od}, and the company data can be deleted from {usuniecie}. The deletion cannot be undone.',
    'deleteResigned.whatTitle': 'This will be deleted permanently:',
    'deleteResigned.whatData': 'all company data: clients, reservations, equipment, payments, invoices and their KSeF status, offers, price lists and settings',
    'deleteResigned.whatUsers': 'staff accounts with their sessions and login history',
    'deleteResigned.whatFiles': 'files: equipment condition photos, widget images and the uploaded contract template',
    'deleteResigned.log': 'Only a log entry remains: the company number, the cancellation day, the deletion day and the account that deleted the data.',
    'deleteResigned.backups': 'Backups still contain this data for up to about 6 months, and the off site copy for up to about 17 days longer. We do not restore it from backups.',
    'deleteResigned.exportReminder': 'Before deleting, make sure the company knows about it and has downloaded its data export (company administrator: Profile, Company data export). The company keeps its invoices itself. This button sends the company no email.',
    'deleteResigned.confirmLabel': 'To confirm, type the company name:',
    'deleteResigned.confirmHint': 'Letter case matters.',
    'deleteResigned.submit': 'Delete data permanently',
    'deleteResigned.submitting': 'Deleting…',
    'deleteResigned.done': 'The data of “{name}” has been deleted.',
    'deleteResigned.error.notResigned': 'This company is not cancelled, so its data cannot be deleted. The cancellation may have been withdrawn. The list has been refreshed.',
    'deleteResigned.error.notYet': 'The data of this company can only be deleted from {od}.',
    'deleteResigned.error.notYetNoDate': 'The data of this company cannot be deleted yet. The list has been refreshed.',
    'deleteResigned.error.ksefPending': 'The company has invoices waiting to be sent or on their way to KSeF: {liczba}. The data can be deleted only after the company sends them from the invoice list.',
    'deleteResigned.error.nameMismatch': 'The name you typed does not match the company name. Type it exactly, with upper and lower case letters.',
    'deleteResigned.error.platformAccount': 'This company has a super admin account, so its data cannot be deleted.',
    'deleteResigned.error.demo': 'This is a demo account. Demo accounts are removed by the demo cleanup, not by this button.',
    'deleteResigned.error.conflict': 'The deletion conditions changed in the meantime. The list has been refreshed, check it and try again.',
    'deleteResigned.error.notFound': 'This company no longer exists. The list has been refreshed.',
    'deleteResigned.error.session': 'Your session does not allow this operation. Log out and log in again with your authentication code.',
    'deleteResigned.error.generic': 'Could not delete the company data. Try again in a moment.',
    'deleteResigned.error.unknownOutcome': 'It is not known whether the data was deleted, because the server did not respond. The list has been refreshed, check it before trying again.',
    'resignManage.title': 'Cancellation: {name}',
    'resignManage.explain': 'From the cancellation day the company can log in, browse data, download the data export and handle invoices and KSeF, while other saving, the widget, reminders and payment links are off. After 30 days the company data may be deleted: automatically, after the administrators are notified by email (emails and automatic deletion work only once the data retention rule is enabled on the server), or manually with the “Delete company data” button in the list, without an email. This is not deactivation: an inactive company has no login and no deletion date.',
    'resignManage.startLabel': 'Cancellation day',
    'resignManage.startToday': 'From today',
    'resignManage.startDay': 'From a chosen day',
    'resignManage.dayLabel': 'Cancellation day',
    'resignManage.todayOnly': 'The company is inactive or in an ongoing pause, so the cancellation can only start today.',
    'resignManage.newDayLabel': 'New cancellation day',
    'resignManage.stateScheduled': 'Cancellation scheduled from {od}. Until then the account works as usual, but it will not accept a reservation that ends on that day or later.',
    'resignManage.stateActive': 'Cancelled since {od}. Company data may be deleted no earlier than {usuniecie}.',
    'resignManage.stateActiveNoDate': 'Cancelled since {od}.',
    'resignManage.enable': 'Set cancellation',
    'resignManage.changeDay': 'Change day',
    'resignManage.startNow': 'Start today',
    'resignManage.cancel': 'Withdraw cancellation',
    'resignManage.confirmToday': 'Set the cancellation of "{name}" from today? The account becomes read only right away, and the data may be deleted after 30 days.',
    'resignManage.confirmDay': 'Set the cancellation of "{name}" from {od}? Until then the account works as usual, but it will not accept a reservation that ends on that day or later. After that it is read only, and the data may be deleted after 30 days.',
    'resignManage.confirmCancel': 'Withdraw the cancellation of "{name}"? The account returns to full work as active right away.',
    'resignManage.saved': 'Cancellation saved.',
    'resignManage.cancelled': 'Cancellation withdrawn.',
    'resignManage.error': 'Could not change the cancellation.',
    'resignManage.unsentKsef': 'Invoices that did not reach KSeF: {liczba}. The submission deadline keeps running, and the company can send them from the invoice list.',
    'resignManage.confirmAnyway': 'Set the cancellation anyway?',
    'resignManage.pausePlanned': 'The company has a pause scheduled from {od}. The cancellation withdraws it: until the cancellation day the account works as usual, so the cancellation can start no later than {od}.',
    'resignManage.pauseOngoing': 'The company has been paused since {od}. The cancellation ends the pause and replaces it.',
    'resignManage.confirmOpenReservations': 'The company has reservations it cannot handle after the cancellation: ongoing on the cancellation day: {trwajace}, later: {nadchodzace}. It cannot record their pickup, return or on site payment. Invoices, corrections and KSeF keep working. Set the cancellation anyway?',
    'superAdmin.copy': 'Copy',
    'superAdmin.saveChanges': 'Save changes',

    // Invoices (list, editor, preview, KSeF) — U.16
    'invoices.title': 'Invoices',
    'invoices.new': 'New invoice',
    'invoices.loading': 'Loading invoices…',
    'invoices.loadError': 'Failed to load invoices.',
    'invoices.nipLabel': 'Tax ID: {nip}',
    'invoices.filters.search': 'Search',
    'invoices.filters.searchPlaceholder': 'Number, buyer, tax ID…',
    'invoices.filters.docType': 'Document type',
    'invoices.filters.allTypes': 'All types',
    'invoices.filters.paymentStatus': 'Payment status',
    'invoices.filters.dateFrom': 'From',
    'invoices.filters.dateTo': 'To',
    'invoices.table.number': 'Number',
    'invoices.subtitle': 'Invoices, pro formas and corrections: issuing, settlement and KSeF submission',
    'invoices.stats.outstanding': 'Outstanding · invoices: {count}',
    'invoices.stats.overdue': 'Overdue · {amount}',
    'invoices.stats.overdueNone': 'Overdue',
    'invoices.stats.thisMonth': 'Gross sales this month',
    'invoices.paymentFilter.unpaid': 'Unpaid',
    'invoices.paymentFilter.partial': 'Partially paid',
    'invoices.paymentFilter.paid': 'Paid',
    'invoices.resultCount': 'Results: {count}',
    'invoices.emptyFiltered.title': 'No invoices match the filters',
    'invoices.emptyFiltered.description': 'Change the criteria or clear the filters to see all documents.',
    'invoices.table.issued': 'Issued',
    'invoices.table.due': 'Due',
    'invoices.table.overdue': 'overdue',
    'invoices.table.paidPart': 'paid {amount}',
    'invoices.preview.settlement': 'Settlement',
    'invoices.preview.invoiceTotal': 'Document gross total',
    'invoices.preview.paymentProgress': 'Payment progress',
    'invoices.preview.paidAmount': 'Paid {amount}',
    'invoices.preview.remainingAmount': 'Remaining {amount}',
    'invoices.preview.paidInFull': 'Paid in full',
    'invoices.preview.overdueSince': 'Payment was due {date}',
    'invoices.preview.details': 'Details',
    'invoices.preview.correctionSection': 'Changes to this document',
    'invoices.editor.fromReservation': 'Based on reservation #{id}',
    'invoices.editor.summaryTitle': 'Summary',
    'invoices.editor.editCompanyData': 'Edit company details',
    'invoices.table.grossAmount': 'Gross amount',
    'invoices.table.payment': 'Payment',
    'invoices.table.ksef': 'KSeF',
    'invoices.fields.issueDate': 'Issue date',
    'invoices.fields.saleDate': 'Sale date',
    'invoices.fields.dueDate': 'Due date',
    'invoices.fields.buyer': 'Buyer',
    'invoices.fields.seller': 'Seller',
    'invoices.fields.paymentMethod': 'Payment method',
    'invoices.fields.notes': 'Notes',
    'invoices.fields.paid': 'Paid',
    'invoices.fields.totalDue': 'Total due',
    'invoices.fields.address': 'Address',
    'invoices.fields.email': 'Email',
    'invoices.fields.phone': 'Phone',
    'invoices.fields.nip': 'Tax ID',
    'invoices.fields.regon': 'REGON',
    'invoices.fields.buyerNameCompany': 'Company name',
    'invoices.fields.buyerNamePrivate': 'Full name',
    'invoices.status.corrected': 'corrected',
    'invoices.status.draft': 'draft',
    'invoices.docType.vat': 'VAT invoice',
    'invoices.docType.proforma': 'Proforma',
    'invoices.docType.simplified': 'Simplified invoice',
    'invoices.docType.correction': 'Correction',
    'invoices.docType.vatExempt': 'Invoice',
    'invoices.paymentStatus.unpaid': 'Unpaid',
    'invoices.paymentStatus.partial': 'Partially paid',
    'invoices.paymentStatus.paid': 'Paid',
    'invoices.paymentMethod.transfer': 'Bank transfer',
    'invoices.paymentMethod.cash': 'Cash',
    'invoices.paymentMethod.card': 'Card',
    'invoices.paymentMethod.blik': 'BLIK',
    'invoices.paymentMethod.other': 'Other',
    'invoices.ksefStatus.pending': 'Pending',
    'invoices.ksefStatus.sent': 'Sent',
    'invoices.ksefStatus.accepted': 'Accepted',
    'invoices.ksefStatus.rejected': 'Rejected',
    'invoices.ksefStatus.error': 'Error',
    'invoices.ksefStatus.upoReceived': 'UPO received',
    'invoices.ksef.send': 'Send to KSeF',
    'invoices.ksef.sending': 'Sending…',
    'invoices.ksef.retry': 'Retry send',
    'invoices.ksef.downloadUpo': 'Download UPO',
    'invoices.ksef.numberTooltip': 'KSeF number: {number}',
    'invoices.ksef.sendConfirmTitle': 'Send to KSeF?',
    'invoices.ksef.sendConfirmMessage': 'Are you sure you want to send invoice {number} to the National e-Invoice System?',
    'invoices.ksef.sendError': 'Failed to send the invoice to KSeF.',
    'invoices.ksef.upoError': 'Failed to download the UPO.',
    'invoices.ksef.sendPending': 'The invoice may already be in KSeF. We will check its status the next time the list opens, do not send it again.',
    'invoices.ksef.duplicateNote': 'This invoice is already in KSeF. Check it in the Taxpayer Application, do not send it again.',
    'invoices.ksef.deliveryUnknownNote': 'It is not known whether the invoice reached KSeF. We are checking it ourselves, do not send it again. If it did not arrive, sending will be unlocked within 13 hours.',
    'invoices.ksef.otherEnvironmentNote': 'Status from another KSeF environment. The invoice has not been sent in the current one yet.',
    'invoices.ksef.prodEnvironmentNote': 'The invoice has been submitted to the production KSeF, so we do not send it to the test environment.',
    'invoices.filters.ksefAttention': 'Not in KSeF',
    'ksefUwaga.titleOne': '{count} invoice did not reach KSeF',
    'ksefUwaga.titleFew': '{count} invoices did not reach KSeF',
    'ksefUwaga.titleMany': '{count} invoices did not reach KSeF',
    'ksefUwaga.titleOther': '{count} invoices did not reach KSeF',
    'ksefUwaga.lead': 'An invoice for a business must be sent to KSeF no later than the next working day after it is issued. Send them from the invoice list or check the reason in the details.',
    'ksefUwaga.overdue': 'Past the sending deadline: {count}.',
    'ksefUwaga.dueToday': 'Sending deadline is today: {count}.',
    'ksefUwaga.show': 'Show these invoices',
    'ksefUwaga.details': 'Details',
    'ksefUwaga.more': 'Showing the {shown} oldest of {count}. Click "Show these invoices" to see all of them.',
    'ksefUwaga.state.notSent': 'not sent',
    'ksefUwaga.state.error': 'sending error',
    'ksefUwaga.state.rejected': 'rejected by KSeF',
    'ksefUwaga.state.waiting': 'waiting for KSeF',
    'ksefUwaga.state.duplicate': 'KSeF reports a duplicate',
    'ksefUwaga.issued': 'issued {date}',
    'ksefUwaga.deadline': 'deadline {date}',
    'ksefUwaga.deadlinePassed': 'deadline passed {date}',
    'ksefUwaga.deadlineToday': 'deadline today',
    'ksefUwaga.duplicateHint': 'This invoice is already in KSeF. Check it in the Taxpayer Application, do not send it again.',
    'ksefUwaga.simplifiedHint': 'The app does not send simplified invoices to KSeF. Submit it in the KSeF Taxpayer Application.',
    'ksefUwaga.waitingHint': 'We will check the status ourselves, do not send it again.',
    'ksefUwaga.certExpired': 'The KSeF certificate expired on {date}. Sending invoices to KSeF will not work until you upload a new certificate in KSeF settings.',
    'ksefUwaga.certToday': 'The KSeF certificate expires today. Generate a new one in the Taxpayer Application and upload it in KSeF settings.',
    'ksefUwaga.certTomorrow': 'The KSeF certificate expires tomorrow ({date}). Generate a new one in the Taxpayer Application and upload it in KSeF settings.',
    'ksefUwaga.certSoon': 'The KSeF certificate expires on {date}, in {count} days. You can already generate a new one in the Taxpayer Application and upload it in KSeF settings.',
    'ksefUwaga.tokenPassed': 'KSeF tokens stopped working on {date}. Switch the method to a KSeF certificate in KSeF settings.',
    'ksefUwaga.tokenSoon': 'Under current rules, KSeF tokens work until {date}. Before that day, switch the method to a KSeF certificate in KSeF settings.',
    'ksefUwaga.openSettings': 'KSeF settings',
    'ksefSettings.prodSince': 'We watch invoices issued since {date}, when the company started sending to production KSeF. Those that do not reach KSeF are shown on the invoice list and the home page.',
    'ksefSettings.alertEmailLabel': 'Email admins about invoices that did not reach KSeF and about an expiring certificate',
    'ksefSettings.alertEmailHint': 'At most one email a day, with invoice numbers and a link to the list, without buyer data, plus reminders 30, 7 and 1 day before the certificate expires. Applies to production KSeF only.',
    'invoices.pdf.download': 'Download PDF',
    'invoices.pdf.downloadError': 'Failed to download the PDF file.',
    'invoices.pdf.busy': 'Too many PDF documents at once. Please try again in a moment.',
    'invoices.pdf.retry': 'Try again',
    'invoices.empty.title': 'No invoices',
    'invoices.empty.description': 'No invoice has been issued yet. Create your first one to get started.',
    'invoices.newModal.title': 'New invoice',
    'invoices.newModal.subtitle': 'Choose how you want to create the invoice',
    'invoices.newModal.fromReservationTitle': 'From a reservation',
    'invoices.newModal.fromReservationDescription': 'Fill in the buyer details and items from an existing reservation',
    'invoices.newModal.blankTitle': 'From scratch',
    'invoices.newModal.blankDescription': 'Fill in all the details manually',
    'invoices.reservationModal.title': 'Choose a reservation',
    'invoices.reservationModal.empty': 'No reservations to choose from.',
    'invoices.reservationModal.searchPlaceholder': 'Search: client, email, phone, reservation no. or equipment',
    'invoices.reservationModal.searchAria': 'Search reservations',
    'invoices.reservationModal.scopeAria': 'Which reservations to show',
    'invoices.reservationModal.scopeOpen': 'To invoice',
    'invoices.reservationModal.scopeAll': 'All',
    'invoices.reservationModal.periodAria': 'Rental period',
    'invoices.reservationModal.periodAll': 'Any time',
    'invoices.reservationModal.periodThisMonth': 'This month',
    'invoices.reservationModal.periodLastMonth': 'Last month',
    'invoices.reservationModal.periodLast3Months': 'Last 3 months',
    'invoices.reservationModal.countOne': '{count} reservation',
    'invoices.reservationModal.countFew': '{count} reservations',
    'invoices.reservationModal.countMany': '{count} reservations',
    'invoices.reservationModal.loading': 'Loading reservations…',
    'invoices.reservationModal.loadError': 'Failed to load reservations.',
    'invoices.reservationModal.loadMore': 'Show older ({count})',
    'invoices.reservationModal.noClient': 'No client assigned',
    'invoices.reservationModal.invoicedBadge': 'Invoice {number}',
    'invoices.reservationModal.proformaBadge': 'Pro forma {number}',
    'invoices.reservationModal.canceledBadge': 'Cancelled',
    'invoices.reservationModal.allInvoicedTitle': 'Everything is invoiced',
    'invoices.reservationModal.allInvoicedDescription': 'Every reservation already has an invoice or was cancelled. Show all to issue another document.',
    'invoices.reservationModal.noMatchTitle': 'No reservation matches',
    'invoices.reservationModal.noMatchDescription': 'Check the spelling or choose a longer period.',
    'invoices.reservationModal.showAll': 'Show all',
    'invoices.reservationModal.clearFilters': 'Clear filters',
    'invoices.editor.titleNew': 'New invoice',
    'invoices.editor.titleEdit': 'Edit invoice',
    'invoices.editor.backToList': 'Back to list',
    'invoices.editor.loadError': 'Failed to load the data.',
    'invoices.editor.saveError': 'Failed to save the invoice.',
    'invoices.editor.saveDraft': 'Save as draft',
    'invoices.editor.reservationNotFound': 'Reservation not found.',
    'invoices.editor.sellerMissing': 'Complete your company details in Settings to issue invoices.',
    'invoices.editor.bankAccountMissing': 'The company bank account number is missing.',
    'invoices.editor.bankAccountLabel': 'Account: {account}',
    'invoices.editor.completeCompanyData': 'Complete company data',
    'invoices.editor.orChooseOtherMethod': 'or choose a different payment method.',
    'invoices.editor.clientSearchPlaceholder': 'Search a client by name or email…',
    'invoices.editor.selectedClient': 'Selected client #{id}',
    'invoices.editor.changeClient': 'Change',
    'invoices.editor.issueGeneric': 'Issue',
    'invoices.editor.issueProforma': 'Issue proforma',
    'invoices.editor.issueByType.VAT': 'Issue VAT invoice',
    'invoices.editor.issueByType.SIMPLIFIED': 'Issue simplified invoice',
    'invoices.editor.issueByType.PROFORMA': 'Issue proforma',
    'invoices.editor.addItem': '+ Add item',
    'invoices.editor.grossItemsHint': 'Items from the reservation keep a gross amount equal to the reservation amount; net and VAT are calculated from it. Changing the net price recalculates the item from net.',
    'invoices.editor.removeItem': 'Remove item',
    'invoices.editor.itemNamePlaceholder': 'Product/service name',
    'invoices.editor.notesPlaceholder': 'Additional notes on the invoice…',
    'invoices.editor.buyerType.private': 'Private person',
    'invoices.editor.buyerType.company': 'Company',
    'invoices.editor.sections.header': 'Document header',
    'invoices.editor.sections.parties': 'Seller and buyer',
    'invoices.editor.sections.items': 'Items',
    'invoices.editor.table.lp': 'No.',
    'invoices.editor.table.name': 'Name',
    'invoices.editor.table.unit': 'Unit',
    'invoices.editor.table.quantity': 'Quantity',
    'invoices.editor.table.unitPriceNet': 'Net unit price',
    'invoices.editor.table.vat': 'VAT',
    'invoices.editor.table.net': 'Net',
    'invoices.editor.table.gross': 'Gross',
    'invoices.editor.summary.vatRateNet': 'Net ({rate})',
    'invoices.editor.summary.totalNet': 'Total net',
    'invoices.editor.summary.totalVat': 'Total VAT',
    'invoices.editor.summary.totalGross': 'Total gross',
    'invoices.editor.summary.total': 'Total',
    'invoices.editor.summary.exemptSale': 'VAT exempt sale',
    'invoices.editor.summary.exemptNet': 'Exempt (zw)',
    'invoices.editor.table.unitPrice': 'Price',
    'invoices.editor.table.value': 'Value',
    'invoices.editor.vatExemptCode': 'zw',
    'invoices.editor.notApplicable': 'n/a',
    'invoices.editor.zeroRateHint': '0% is a domestic rate, not a VAT exemption. Mark exempt sales with the rate “zw”.',
    'invoices.editor.exemptionBasis': 'Legal basis of the VAT exemption',
    'invoices.editor.exemptionBasisPh': 'e.g. art. 113 ust. 1 ustawy o VAT',
    'invoices.editor.exemptionBasisHint': 'Printed on the invoice and sent to KSeF. Defaults to the one in company data.',
    'invoices.editor.issueExempt': 'Issue invoice',
    'invoices.editor.validation.exemptTaxedItem': 'A VAT exempt company issues only “zw” items. Change the item rates or the VAT status in company data.',
    'invoices.editor.validation.exemptionBasisRequired': 'A VAT exempt item (“zw”) needs the legal basis of the exemption.',
    'invoices.editor.validation.exemptionBasisIncomplete': 'Complete the legal basis: replace “…” with the point number.',
    'invoices.editor.validation.buyerNameRequired': "Enter the buyer's name.",
    'invoices.editor.validation.nipRequired': "Enter the buyer's tax ID.",
    'invoices.editor.validation.sellerRequired': 'Add your company tax ID and address in Settings → Company details to issue an invoice.',
    'invoices.editor.validation.itemsRequired': 'Add at least one item.',
    'invoices.editor.validation.itemNameRequired': 'Enter a name for every item.',
    'invoices.preview.notFound': 'Invoice not found.',
    'invoices.preview.backToList': 'Back to list',
    'invoices.preview.downloadPdf': 'Download PDF',
    'invoices.preview.sendEmail': 'Send by email',
    'invoices.preview.registerPayment': 'Register payment',
    'invoices.preview.issueCorrection': 'Issue correction',
    'invoices.preview.correctedBadge': 'corrected',
    'invoices.preview.draftBadge': 'draft',
    'invoices.preview.noBuyerEmail': 'The buyer has no email address on file.',
    'invoices.preview.sendEmailConfirmTitle': 'Send invoice by email?',
    'invoices.preview.sendEmailConfirmMessage': 'The invoice will be sent to {email}.',
    'invoices.preview.actionError': 'Something went wrong: {message}',
    'invoices.preview.deleteConfirmTitle': 'Delete invoice?',
    'invoices.preview.deleteConfirmMessage': 'This action cannot be undone.',
    'invoices.preview.vatLockedBanner': 'An issued VAT invoice cannot be edited or deleted. Make changes with a correction.',
    'invoices.preview.pdfPreviewTitle': 'Invoice PDF preview',
    'invoices.preview.generatingPdf': 'Generating PDF preview…',
    'invoices.preview.paymentModalTitle': 'Register payment',
    'invoices.preview.paymentModalInvoiceAmount': 'Invoice amount: {amount} · paid so far: {paid} · remaining: {remaining}',
    'invoices.preview.paymentModalAmountLabel': 'Payment amount',
    'invoices.preview.savePayment': 'Save payment',
    'invoices.preview.paymentAmountInvalid': 'Enter a payment amount greater than zero.',
    'invoices.preview.correctionNoPayment': 'A correction is not settled with a payment because it changes the amount of the invoice it corrects.',
    'invoices.preview.correctModalTitle': 'Issue correction',
    'invoices.preview.correctModalDescription': 'The correction zeroes out all items of the original invoice (full reversal) and is issued immediately, so it cannot be edited afterwards. To change only some items, issue a new invoice with the correct data after the correction. With automatic sending enabled, the correction also goes to the buyer by email and to KSeF.',
    'invoices.preview.correctReasonLabel': 'Correction reason',
    'invoices.preview.correctReasonPlaceholder': 'E.g. equipment return, price mistake…',
    'invoices.preview.correctReasonRequired': 'Enter the correction reason.',
    'invoices.preview.creating': 'Creating…',
    'invoices.preview.issueCorrectionSubmit': 'Issue correction',

    // Payments — U.16
    'payments.title': 'Payments',
    'payments.subtitle': "Client payments: who, how much, when and how",
    'payments.statPaidLabel': 'Collected ({period})',
    'payments.statPendingLabel': 'Pending',
    'payments.statRowsLabel': 'Rows shown',
    'payments.periodSelected': 'selected period',
    'payments.periodTotal': 'total',
    'payments.paidCountOne': '1 payment',
    'payments.paidCountMany': '{count} payments',
    'payments.paidCountFew': '{count} payments',
    'payments.adminOnly': 'The payment register is available to the company administrator. You can see the payments of a reservation in its details in the Calendar.',
    'payments.status.reversed': 'Reversed entry',
    'payments.reversedAt': 'Reversed {date}: no money was received',
    'payments.reversedNote': 'Entry reversed: no money was received',
    'payments.reservationCancelled': 'Reservation cancelled',
    'payments.paidAfterCancel': 'Paid after the reservation was cancelled: to refund',
    'payments.depositAfterCancel': 'Deposit held after the reservation was cancelled: release the hold',
    'payments.secondDeposit': 'Second deposit for this reservation: release the hold',
    'payments.pendingHint': 'awaiting the client',
    'payments.afterFilters': 'after filters',
    'payments.recentPayments': 'recent',
    'payments.filterDateFrom': 'From',
    'payments.filterDateTo': 'To',
    'payments.filterClientLabel': 'Client',
    'payments.filterClientPlaceholder': 'Search by name or email…',
    'payments.statusFilter.paid': 'Paid',
    'payments.statusFilter.pending': 'Pending',
    'payments.statusFilter.failed': 'Failed',
    'payments.statusFilter.refunded': 'Refunded',
    'payments.status.paid': 'Paid',
    'payments.status.pending': 'Pending',
    'payments.status.failed': 'Failed',
    'payments.status.refunded': 'Refunded',
    'payments.status.cancelled': 'Cancelled',
    'payments.status.partiallyRefunded': 'Partially refunded',
    'payments.status.authorized': 'Authorized',
    'payments.status.captured': 'Captured',
    'payments.status.released': 'Released',
    'payments.type.deposit': 'Deposit',
    'payments.type.advance': 'Advance',
    'payments.type.balance': 'Balance',
    'payments.methodCash': 'Cash',
    'payments.methodTransfer': 'Bank transfer',
    'payments.methodCard': 'Card (terminal)',
    'payments.methodOnline': 'Online',
    'payments.filterMethod': 'Payment method',
    'paymentDeadline.toggle': 'Cancel if the customer has not paid by',
    'paymentDeadline.hint': 'The customer will see the deadline in the message with the link and get one reminder before it.',
    'paymentDeadline.hintNoEmail': 'The customer has no email address, so they will not get a reminder. The deadline is in the text to copy together with the link.',
    'paymentDeadline.invalid': 'Choose a deadline at least one hour from now and no later than 10 PM on the day before the reservation starts (at most 30 days).',
    'paymentDeadline.noRoom': 'The reservation starts too soon to set a payment deadline.',
    'paymentDeadline.premium': 'Automatic cancellation of unpaid reservations is part of the Premium plan.',
    'paymentDeadline.infoTitle': 'Advance payment deadline: {date}',
    'paymentDeadline.info': 'Without payment by this deadline the reservation will be cancelled automatically and the equipment released. The customer gets a reminder before the deadline.',
    'paymentDeadline.infoNoEmail': 'Without payment by this deadline the reservation will be cancelled automatically and the equipment released. The customer has no email address, so they will not get a reminder.',
    'paymentDeadline.removedByLink': 'The payment deadline has passed or is about to, so the new link removed it. The reservation will not be cancelled automatically.',
    'paymentDeadline.removedByLinkWidget': 'The payment deadline has passed or is about to, so the new link removed it. A widget reservation goes back to the widget rules: without payment the customer gets a reminder, and about {hours} h later the reservation is cancelled automatically.',
    'paymentDeadline.droppedNoTimeWidget': 'Payment deadline of reservation no. {id} removed: the reminder did not go out in time before the start day, so the customer would have no time to pay. A widget reservation goes back to the widget rules: without payment the customer gets a reminder, and about {hours} h later the reservation is cancelled automatically.',
    'paymentDeadline.droppedNoTime': 'Payment deadline of reservation no. {id} removed: the reminder did not go out in time before the start day, so the customer would have no time to pay. The reservation stays.',
    'paymentDeadline.editNote': 'Saving changed dates or advance amount removes the payment deadline.',
    'paymentDeadline.remove': 'Remove deadline',
    'paymentDeadline.removing': 'Removing…',
    'paymentDeadline.removeConfirmTitle': 'Remove the payment deadline?',
    'paymentDeadline.removeConfirmMessage': 'The reservation will not be cancelled automatically and the customer will not get a deadline reminder.',
    'paymentDeadline.removeConfirmMessageWidget': 'A widget reservation goes back to the widget rules: without payment the customer gets a reminder, and about {hours} h later the reservation is cancelled automatically.',
    'paymentDeadline.removed': 'Payment deadline removed.',
    'paymentDeadline.removeError': 'Failed to remove the payment deadline.',
    'paymentSettings.deadlineSectionTitle': 'Advance payment deadline',
    'paymentSettings.deadlineSectionHint': 'Default time to pay when you tick “Cancel if the customer has not paid by” on an advance payment link. The deadline can be changed for each reservation.',
    'paymentSettings.deadlinePremium': 'A payment deadline with automatic cancellation of unpaid reservations is part of the Premium plan.',
    'paymentSettings.deadlineRange': 'Enter a number of hours from {min} to {max}.',
    'paymentSettings.deadlineSaved': 'Saved: {hours} h to pay by default.',
    'payments.tableClient': 'Client',
    'payments.tableSource': 'Source',
    'payments.tablePaidAt': 'Paid at',
    'payments.noClientData': 'No client data',
    'payments.noSource': '—',
    'payments.reservationRef': 'Reservation #{id}',
    'payments.offerRef': 'Offer #{seq}',
    'payments.refundedAmount': 'Refunded: {amount}',
    'payments.overpayment': 'Overpayment: {amount}',
    'payments.refundAction': 'Refund',
    'payments.reverseAction': 'Reverse entry',
    'payments.cancelRequestAction': 'Cancel request',
    'payments.blockLinkAction': 'Block link',
    'payments.payLinkLabel': 'Payment link:',
    'payments.payLinkHint': 'Click to select the whole address',
    'payments.refundPrompt': 'Refund amount (max {max})',
    'payments.refundInvalidAmount': 'Invalid refund amount (max {max}).',
    'payments.refundError': 'Failed to process the refund.',
    'payments.reverseError': 'Failed to reverse the entry.',
    'payments.cancelRequestError': 'Failed to cancel the request.',
    'payments.confirmRefundTitle': 'Refund payment?',
    'payments.confirmRefundMessage': 'You will refund {amount} to {client}.',
    'payments.confirmReverseTitle': 'Reverse entry?',
    'payments.confirmReverseMessage': 'You will reverse the {amount} entry ({method}).',
    'payments.confirmCancelTitle': 'Cancel request?',
    'payments.confirmCancelMessage': 'The payment request for {amount} will be cancelled.',
    'payments.emptyNoneTitle': 'No payments',
    'payments.emptyNone': 'No payment has been recorded yet.',
    'payments.emptyFilteredTitle': 'No results',
    'payments.emptyFiltered': 'No payment matches the selected filters.',

    // Profile — card group headings (U.16)
    'profile.group.account': 'Account',
    'profile.group.company': 'Company',
    'profile.group.sales': 'Sales',
    'profile.group.integrations': 'Integrations',

    // Login (U.16)
    'login.tagline': 'Equipment rental management',
    'login.heading': 'Sign in',
    'login.subtitle': 'Enter your details to access the panel',
    'login.usernamePlaceholder': 'Username',
    'login.passwordPlaceholder': 'Password',
    'login.submitting': 'Signing in…',
    'login.submit': 'Sign in',
    'login.forgotPassword': 'Forgot your password?',
    'login.allFieldsRequired': 'Fill in all fields.',
    'login.tooManyAttempts': 'Too many login attempts. Please try again later.',
    'login.genericError': 'Invalid username or password.',
    'login.connectionError': 'Server connection error.',
    'login.success': 'Signed in successfully.',
    'login.resetTitle': 'Password reset',
    'login.resetDescription': 'Enter the email address associated with your account and we will send you a link to set a new password.',
    'login.resetEmailPlaceholder': 'Email address',
    'login.resetSentDefault': 'If the given email address exists in the system, we have sent a password reset link to it.',
    'login.resetError': 'Failed to send the password reset link.',
    'login.resetSubmitting': 'Sending…',
    'login.resetSubmit': 'Send reset link',

    // Add user — password policy and form states (U.16)
    'addUser.demoDisabled': 'Not available in demo mode',
    'addUser.formIncompleteHint': 'Fill in the required form fields',
    'addUser.passwordMinLength': 'At least {min} characters',
    'addUser.passwordUppercase': 'An uppercase letter',
    'addUser.passwordLowercase': 'A lowercase letter',
    'addUser.passwordDigit': 'A digit',
    'addUser.passwordStrengthGood': 'Sufficient password strength',

    // Contract builder editor — RTE toolbar (U.16)
    'contracts.editor.fontDefault': 'Default',
    'contracts.editor.fontFamily': 'Font family',
    'contracts.editor.fontSize': 'Font size',
    'contracts.editor.equipmentPlaceholder': 'Equipment table',
    'contracts.editor.logoPlaceholder': 'Company logo',
    'contracts.editor.linkPrompt': 'Enter the URL',
    'contracts.editor.bold': 'Bold',
    'contracts.editor.italic': 'Italic',
    'contracts.editor.underline': 'Underline',
    'contracts.editor.strike': 'Strikethrough',
    'contracts.editor.heading': 'Heading',
    'contracts.editor.bulletList': 'Bullet list',
    'contracts.editor.orderedList': 'Numbered list',
    'contracts.editor.alignLeft': 'Align left',
    'contracts.editor.alignCenter': 'Align center',
    'contracts.editor.alignRight': 'Align right',
    'contracts.editor.link': 'Insert link',

    // Calendar — date-free scheduling conflicts (U.16)
    'calendar.noDate': 'no date',

    // ── P8.1e (6/6): i18n konstruktora umowy (tresc umowy CELOWO zostaje po polsku) ──
    'contractBuilder.addSection': 'Add section',
    'contractBuilder.advancedToggle': 'Show/hide advanced options (reordering, alignment, deleting sections)',
    'contractBuilder.allFields': 'All available fields',
    'contractBuilder.autoSaveError': 'Autosave failed. Save the draft by hand.',
    'contractBuilder.bannerFillCompany': 'Complete the company details',
    'contractBuilder.bannerIncomplete': 'Incomplete company details',
    'contractBuilder.bannerLoadFailed': 'Could not load the company details',
    'contractBuilder.bannerLoadFailedBody': 'The preview shows empty fields where the company details go. Refresh the page or check the company details.',
    'contractBuilder.bannerSettingsAction': 'Company details',
    'contractBuilder.blockContent': 'Block content',
    'contractBuilder.blockHeading': 'Block heading',
    'contractBuilder.catClient': 'Client details',
    'contractBuilder.catContract': 'Contract',
    'contractBuilder.catEquipment': 'Equipment',
    'contractBuilder.catFinance': 'Finances',
    'contractBuilder.catOrganization': 'Organisation',
    'contractBuilder.contentPanel': 'Contract content',
    'contractBuilder.contractSettings': 'Company details',
    'contractBuilder.deleteError': 'Deletion error: {msg}',
    'contractBuilder.deleteSection': 'Delete section',
    'contractBuilder.deleteSectionTitle': 'Delete the section "{name}"?',
    'contractBuilder.deleteVersionTitle': 'Remove this version from the history',
    'contractBuilder.deleting': 'Deleting...',
    'contractBuilder.documentLook': 'Document appearance',
    'contractBuilder.downloadPdf': 'Download PDF',
    'contractBuilder.downloading': 'Downloading...',
    'contractBuilder.errorPrefix': 'Error: {msg}',
    'contractBuilder.fontSize': 'Text size',
    'contractBuilder.generating': 'Generating...',
    'contractBuilder.headingAlignGroup': 'Section heading alignment',
    'contractBuilder.headingCenter': 'Heading centred',
    'contractBuilder.checkBeforePublish': 'Check before publishing',
    'contractBuilder.dragToReorder': 'Drag to reorder',
    'contractBuilder.pdfFrameTitle': 'Contract PDF preview',
    'contractBuilder.headingLeft': 'Heading to the left',
    'contractBuilder.headingRight': 'Heading to the right',
    'contractBuilder.history': 'History ({count})',
    'contractBuilder.historyHead': 'Previous versions: {count}',
    'contractBuilder.importDisclosure': 'Already have your own contract? Import its text',
    'contractBuilder.importEmpty': 'Paste the contract text to import.',
    'contractBuilder.importError': 'Error importing the contract text.',
    'contractBuilder.importLabel': 'Paste the contract text (TXT)',
    'contractBuilder.importNoSections': 'Could not create sections from the given text.',
    'contractBuilder.importPartial': 'The text was imported, but some fields were not recognised',
    'contractBuilder.importPlaceholder': 'Paste the full contract text. The system will split it into sections automatically and try to recognise the fields.',
    'contractBuilder.importSubmit': 'Import the text into the builder',
    'contractBuilder.imported': 'Contract text imported. Check the sections and save a draft.',
    'contractBuilder.importing': 'Importing...',
    'contractBuilder.intro': 'You arrange the contract text, and the preview shows straight away how it comes out on paper. Fields such as "Client first name" are filled in by the system when the contract is generated for a reservation.',
    'contractBuilder.irreversible': 'This cannot be undone.',
    'contractBuilder.logoMissing': 'None. Add a logo in "Company details".',
    'contractBuilder.logoSet': 'Set in "Company details".',
    'contractBuilder.modeAdvanced': 'Advanced',
    'contractBuilder.modeSimple': 'Simple view',
    'contractBuilder.moveDown': 'Move the section down',
    'contractBuilder.moveUp': 'Move the section up',
    'contractBuilder.noWarnings': 'No warnings. The template is ready to publish.',
    'contractBuilder.pdfDownloadError': 'Error while downloading the PDF: {msg}',
    'contractBuilder.pdfModalHint': 'PDF preview: here you see the real page breaks (1:1 with the output)',
    'contractBuilder.pdfPreview': 'PDF preview',
    'contractBuilder.pdfPreviewError': 'Error while generating the PDF preview: {msg}',
    'contractBuilder.pickFieldBelow': '(pick a field from the list below)',
    'contractBuilder.presetNoDeposit': 'Without deposit',
    'contractBuilder.presetStandardNotes': 'Standard + notes',
    'contractBuilder.previewPanel': 'Contract preview',
    'contractBuilder.redo': 'Redo',
    'contractBuilder.redoTitle': 'Redo (Ctrl+Y)',
    'contractBuilder.restore': 'Restore',
    'contractBuilder.restoreTitle': 'Load this version into the editor',
    'contractBuilder.saveDraft': 'Save draft',
    'contractBuilder.saved': 'The contract template has been saved successfully!',
    'contractBuilder.sectionAdded': 'A new section was added in the current step.',
    'contractBuilder.startHint': 'Choosing a pattern replaces all sections. You can then adjust the text as you like.',
    'contractBuilder.startTitle': 'Start from a ready-made pattern',
    'contractBuilder.statusDescDraft': 'The template is not active yet. Publish it to use it in production.',
    'contractBuilder.statusDescEmpty': 'Start from a ready-made pattern or import your own contract text.',
    'contractBuilder.statusDescPublished': 'New contracts will use this template.',
    'contractBuilder.statusDraft': 'Draft',
    'contractBuilder.statusEmpty': 'No template',
    'contractBuilder.readOnlyNotice': 'The contract template is changed by the company administrator. You can view it and download a PDF preview.',
    'contractBuilder.statusDraftOverPublished': 'Draft (v{n} in use)',
    'contractBuilder.statusDescDraftOverPublished': 'Clients still receive the published version v{n}. Publish to use your changes in new contracts.',
    'contractBuilder.templateLoadFailed': 'Could not load the contract template. Refresh the page before editing: changes will not be saved, so the saved draft is not overwritten.',
    'contractBuilder.step1': 'Step 1: Start and client',
    'contractBuilder.step1Helper': 'Fill in the contract header and the client details. This is the most frequently edited part.',
    'contractBuilder.step2': 'Step 2: Equipment and amounts',
    'contractBuilder.step2Helper': 'Refine the equipment description, the dates and the financial information.',
    'contractBuilder.step3Helper': 'Add signatures and any extra clauses. Custom sections land here too.',
    'contractBuilder.tableFontSize': 'Text in the equipment table',
    'contractBuilder.undoTitle': 'Undo (Ctrl+Z)',
    'contractBuilder.untitled': '(untitled)',
    'contractBuilder.varAddress': 'Client address',
    'contractBuilder.varAdvance': 'Advance',
    'contractBuilder.varAmountDue': 'Amount due',
    'contractBuilder.varBankAccount': 'Bank account',
    'contractBuilder.varBankName': 'Bank name',
    'contractBuilder.varDays': 'Number of rental days',
    'contractBuilder.varDeposit': 'Deposit',
    'contractBuilder.varEmail': 'Client email',
    'contractBuilder.varEndDate': 'End date',
    'contractBuilder.varEquipmentTable': 'Equipment table (auto-generated)',
    'contractBuilder.varFirstName': 'Client first name',
    'contractBuilder.varIdNumber': 'Client ID number',
    'contractBuilder.varClientCompanyName': 'Client company name',
    'contractBuilder.varClientNip': 'Client tax ID (NIP)',
    'contractBuilder.varClientCompanyLine': 'Client company details (whole line, hidden for private clients)',
    'contractBuilder.varLastName': 'Client last name',
    'contractBuilder.varOrgAddress': 'Organisation address',
    'contractBuilder.varOrgName': 'Organisation name',
    'contractBuilder.varOrgPhone': 'Organisation phone',
    'contractBuilder.varPhone': 'Client phone',
    'contractBuilder.varStartDate': 'Start date',
    'contractBuilder.varTotalPrice': 'Total price',
    'contractBuilder.varsLabel': 'Fields to insert into the text',
    'contractBuilder.versionDeleteTitle': 'Remove version v{n} from the history?',
    'contractBuilder.versionDeleted': 'Version v{n} removed from the history.',
    'contractBuilder.versionLoadBody': 'It will replace the content you are editing. Nothing is published. When it looks right, click "Publish template" to activate it.',
    'contractBuilder.versionLoadFailed': 'Could not load version v{n}.',
    'contractBuilder.versionLoadTitle': 'Load version v{n}?',
    'contractBuilder.versionLoaded': 'Version v{n} loaded into the editor. Check it and click "Publish template" to activate it.',
    'contractBuilder.warnEmptySection': 'Section "{name}" has no content.',
    'contractBuilder.warnNoSignatures': 'There is no signatures section: add a section whose title starts with „Podpis” or that has a ________ signature line.',
    'contractBuilder.yesPublish': 'Yes, publish',
    'contractBuilder.pageTitle': 'Contract builder',
    'contractBuilder.autoSavedAt': 'Saved automatically {time}',
    'contractBuilder.missingLabel': 'Missing:',
    'contractBuilder.missingCompanyEffect': 'The preview and generated contracts will have empty fields in these places.',
    'contractBuilder.untitledInContract': '(no title in the contract)',
    'contractBuilder.unknownVarsTitle': 'Unknown fields: {list}',
    'contractBuilder.unknownVarsBadge': 'Unknown fields: {n}',
    'contractBuilder.showLess': 'Show less',
    'contractBuilder.showAllFields': 'Show all fields',
    'contractBuilder.sheetSplitNote': 'approximate page breaks, "PDF preview" shows the exact ones',
    'contractBuilder.statusLoadFailed': 'Template not loaded',
    'contractBuilder.statusDescLoadFailed': 'It is not known which template version applies. Refresh the page.',
    'contractBuilder.statusPublished': 'Published',
    'contractBuilder.statusPublishedVersion': 'Published (v{n})',
    'contractBuilder.importSection': 'Section „{name}”:',
    'contractBuilder.importDidYouMean': 'did you mean',
    'contractBuilder.templateConflict': 'The template was changed in another tab or on another computer. Refresh the page.',
    'contractBuilder.accountChanged': 'A different account signed in in another tab, so the changes were not saved. Refresh the page.',
    'contractBuilder.exitSaveFailed': 'The contract draft was not saved: {msg}',
    'contractBuilder.blockNameHeading': 'Block name in the editor (not printed)',
    'contractBuilder.blockNameHeadingHint': 'Type the contract title in „Block content” below.',
    'contractBuilder.testOn': 'Test on',
    'contractBuilder.scenarioStandard': 'Scenario: standard',
    'contractBuilder.scenarioNoDeposit': 'Scenario: no deposit',
    'contractBuilder.scenarioLongTerm': 'Scenario: longer rental',
    'contractBuilder.presetApplied': 'Contract pattern applied.',
    'contractBuilder.publishTemplate': 'Publish template',
    'contractBuilder.publishing': 'Publishing...',
    'contractBuilder.publishTitle': 'Publish the template?',
    'contractBuilder.publishBodyReplace': 'Publishing replaces your company\'s active template, and the current version (v{n}) moves to the history. New contracts will be generated from the new template.',
    'contractBuilder.publishBodyFirst': 'After publishing, new contracts will be generated from this template.',
    'contractBuilder.publishBlocked': 'Fix before publishing',
    'contractBuilder.warnNoHeading': 'There is no heading block with the contract title (e.g. „UMOWA NAJMU”).',
    'contractBuilder.warnNoContent': 'The template has no content.',
    'contractBuilder.warnUnknownVars': 'Unknown fields: {list}. Remove them or pick a field from the list.',
    'contractBuilder.warnCompanyIncomplete': 'Incomplete company details: {list}',
    'contractBuilder.sessionExpired': 'Your session has expired. Please log in again.',

    // ── P8.1e (5/6): i18n konstruktora oferty (dokument CELOWO zostaje po polsku) ──
    'offerTemplate.alignCenter': 'Centre',
    'offerTemplate.alignLeft': 'Left',
    'offerTemplate.alignRight': 'Right',
    'offerTemplate.checkBeforePublish': 'Check before publishing',
    'offerTemplate.clickFieldFirst': 'Click into a text field (intro or footer) first, then on a variable.',
    'offerTemplate.companyIncomplete': 'Incomplete company details',
    'offerTemplate.companyIncompleteBody': 'Missing: {fields}. The offer will show "-" in these places, including the payment details.',
    'offerTemplate.contentPanel': 'Offer content',
    'offerTemplate.contractSettings': 'Company details',
    'offerTemplate.deleteVersionFailed': 'Could not delete the version',
    'offerTemplate.deleteVersionTitle': 'Remove this version from the history',
    'offerTemplate.downloadPdf': 'Download PDF',
    'offerTemplate.downloading': 'Downloading...',
    'offerTemplate.draftSaved': 'Draft saved. Clients still receive the published version.',
    'offerTemplate.exitBack': 'Back to the builder',
    'offerTemplate.exitNotLoaded': 'Changes in the offer builder were not saved because its settings did not load. Reload the builder page and make the changes again.',
    'offerTemplate.exitSaveFailed': 'Changes in the offer builder were not saved ({msg}). They are kept in this tab and come back when you return to the builder.',
    'offerTemplate.exitTooLong': 'Changes in the offer builder were not saved: the intro or footer has more than 2000 characters. They are kept in this tab and come back when you return to the builder.',
    'offerTemplate.fillCompany': 'Complete the company details',
    'offerTemplate.fontSize': 'Text size',
    'offerTemplate.footerLabel': 'Footer / payment instructions',
    'offerTemplate.generateError': 'Generation error',
    'offerTemplate.generating': 'Generating...',
    'offerTemplate.groupHeader': 'Header',
    'offerTemplate.groupTexts': 'Texts',
    'offerTemplate.groupValidity': 'Validity',
    'offerTemplate.history': 'History ({count})',
    'offerTemplate.historyHead': 'Previous versions: {count}',
    'offerTemplate.intro': 'You set what stays fixed in the offer: logo, title, texts and validity. The tables with client details, equipment and the summary fill themselves from the reservation, and the preview shows them on sample data.',
    'offerTemplate.introLabel': 'Intro text (above the tables, optional)',
    'offerTemplate.loadFailed': 'Could not load the offer template',
    'offerTemplate.loadFailedBody': 'The editor shows default values, not your template, so saving is disabled. Reload the page.',
    'offerTemplate.loading': 'Loading the settings…',
    'offerTemplate.logoAlign': 'Logo alignment',
    'offerTemplate.missingAccount': 'account number',
    'offerTemplate.missingBankName': 'bank name',
    'offerTemplate.missingName': 'company name',
    'offerTemplate.noLogoHint': 'No logo. Add one in "Company details".',
    'offerTemplate.noWarnings': 'No warnings. The template is ready to publish.',
    'offerTemplate.offerTitle': 'Offer title',
    'offerTemplate.pagesApprox': 'approximate page breaks, the generated PDF shows the exact ones',
    'offerTemplate.pdfFailed': 'Could not generate the offer PDF',
    'offerTemplate.pdfFrameTitle': 'Offer PDF preview',
    'offerTemplate.pdfModalHint': 'PDF preview: here you see the real page breaks (1:1 with the output)',
    'offerTemplate.pdfPreview': 'PDF preview',
    'offerTemplate.previewError': 'Error generating the preview',
    'offerTemplate.previewPanel': 'Offer preview',
    'offerTemplate.publish': 'Publish template',
    'offerTemplate.publishBlocked': 'This template cannot be published right now',
    'offerTemplate.publishConfirmBody': 'Publishing replaces the template your client offers are generated from.',
    'offerTemplate.publishConfirmTitle': 'Publish the template?',
    'offerTemplate.publishError': 'Publishing error',
    'offerTemplate.publishMovesToHistory': 'The current version will be moved to the history.',
    'offerTemplate.published': 'Template published. New offers use this version.',
    'offerTemplate.publishing': 'Publishing...',
    'offerTemplate.reload': 'Reload the page',
    'offerTemplate.restore': 'Restore',
    'offerTemplate.restoreTitle': 'Load this version into the editor',
    'offerTemplate.restoredBody': 'They could not be saved when you last left the builder. Save the draft to keep them, or discard them.',
    'offerTemplate.restoredDiscard': 'Discard changes',
    'offerTemplate.restoredTitle': 'Unsaved changes restored',
    'offerTemplate.sampleData': 'sample data',
    'offerTemplate.saveDraft': 'Save draft',
    'offerTemplate.saveError': 'Save error',
    'offerTemplate.settingsNotLoaded': 'The settings did not load. Reload the page, otherwise changes cannot be saved.',
    'offerTemplate.showLogo': 'Show the company logo on the offer',
    'offerTemplate.statusDefault': 'No template',
    'offerTemplate.statusDescDefault': 'Offers are sent using the default settings. Publish to use your own template.',
    'offerTemplate.statusDescDraft': 'You have changes that clients cannot see yet. Publish them to make them take effect.',
    'offerTemplate.statusDescLoadFailed': 'It is unknown which template applies until the page loads.',
    'offerTemplate.statusDescPublished': 'New offers will use this template.',
    'offerTemplate.statusDraft': 'Draft',
    'offerTemplate.statusLoadFailed': 'Not loaded',
    'offerTemplate.statusPublished': 'Published',
    'offerTemplate.textTooLong': 'The intro or footer has more than 2000 characters. Shorten the text, otherwise the template cannot be saved or published.',
    'offerTemplate.title': 'Offer builder',
    'offerTemplate.unsaved': 'Unsaved changes',
    'offerTemplate.validityHint': 'From 1 to 365 days. The validity date counts from the day the offer is issued and appears on its last line.',
    'offerTemplate.validityInvalid': 'Enter a number of days from 1 to 365. If you leave the field like this, the previous value comes back: {n}.',
    'offerTemplate.validityLabel': 'Offer valid for (days)',
    'offerTemplate.validityTooLong': 'At most 365 days. The offer will be valid for 365 days.',
    'offerTemplate.varBank': 'Bank',
    'offerTemplate.varDataOferty': 'Offer date',
    'offerTemplate.varDepozyt': 'Deposit',
    'offerTemplate.varEmail': 'Email',
    'offerTemplate.varFirma': 'Company name',
    'offerTemplate.varKlient': 'Client',
    'offerTemplate.varNrKonta': 'Account no.',
    'offerTemplate.varNrOferty': 'Offer no.',
    'offerTemplate.varRazem': 'Total due',
    'offerTemplate.varTerminDo': 'To',
    'offerTemplate.varTerminOd': 'From',
    'offerTemplate.varWaznosc': 'Validity (days)',
    'offerTemplate.varZaliczka': 'Advance',
    'offerTemplate.varsHint': 'Click into a text field below first, then on a field from the list, and it will be inserted at the cursor.',
    'offerTemplate.varsLabel': 'Fields to insert into the text',
    'offerTemplate.versionRestored': 'Version v{n} loaded into the editor. Publish it to make it take effect.',
    'offerTemplate.warnCompanyData': 'Company details are missing ({fields}), so the offer will show "-" in these places.',
    'offerTemplate.warnNoLogo': 'The logo is enabled, but there is none in "Company details", so the offer will go out without it.',
    'offerTemplate.warnNoTitle': 'The offer has no title.',
    'offerTemplate.yesPublish': 'Yes, publish',

    // ── P8.1e (4/6): i18n panelu widgetu (podglad widgetu CELOWO zostaje po polsku) ──
    'widgetMedia.adminOnlySub': 'This panel is available to administrators only.',
    'widgetMedia.adminOnlyTitle': 'Widget settings',
    'widgetMedia.allowedDomains': 'Allowed domains for the widget',
    'widgetMedia.allowedDomainsHint': 'Addresses of your rental\'s pages that customers can return to after an online payment, e.g. https://yourdomain.com. We save only the site address, without the path; if your site also works with www, add both addresses. The widget pasted with the code from this screen and the QR code link always work, and this field does not stop anyone from pasting the widget on another site. Leave empty for no limit. One address per line or separate them with commas.',
    'widgetMedia.privacyPolicyUrl': 'Privacy policy (page address)',
    'widgetMedia.privacyPolicyUrlPlaceholder': 'https://yourcompany.com/privacy-policy',
    'widgetMedia.privacyPolicyUrlHint': 'Below the booking form the widget states that your company (name from Company details) is the controller of customer data and links to this page. This is required by the GDPR (Art. 13). Without an address only the controller sentence is shown.',
    'widgetMedia.termsUrl': 'Rental terms and conditions (page address)',
    'widgetMedia.termsUrlPlaceholder': 'https://yourcompany.com/terms',
    'widgetMedia.termsUrlHint': 'When you enter an address, the widget shows below the booking button that by booking the customer accepts the terms, with the word “terms” linking to this page. Empty field = no statement.',
    'widgetMedia.blockBasic': 'Basics',
    'widgetMedia.blockPresentation': 'Data presentation',
    'widgetMedia.blockTheme': 'Colour theme',
    'widgetMedia.checkingServer': 'Checking the widget server…',
    'widgetMedia.deviceDesktop': 'Desktop',
    'widgetMedia.deviceMobile': 'Phone',
    'widgetMedia.devicePicker': 'Choose the preview device',
    'widgetMedia.embedCopied': 'Embed code copied to the clipboard!',
    'widgetMedia.embedCopyFailed': 'Could not copy the code automatically. Select it by hand and copy it (Ctrl+C).',
    'widgetMedia.embedDemoNote': 'On a demo account the widget shows equipment, dates and prices but does not accept bookings, because a demo account must not collect real customer data (terms of service, § 6(3)).',
    'widgetMedia.superAdminNotPremium': 'Your company is not on the Premium plan. As a super admin you can change the widget settings here, but the widget on your website, the booking link and the QR code do not work for customers until the company switches to Premium.',
    'widgetMedia.bookingLink.title': 'Booking link and QR code',
    'widgetMedia.bookingLink.subtitle': 'Customers book equipment on the widget page, even if you have no website of your own. Send them the link or print the QR code, for example at the counter or on a flyer.',
    'widgetMedia.bookingLink.fieldLabel': 'Booking link',
    'widgetMedia.bookingLink.copy': 'Copy booking link',
    'widgetMedia.bookingLink.copied': 'Copied',
    'widgetMedia.bookingLink.copyFailed': 'Copying failed. Select the link in the field and copy it manually.',
    'widgetMedia.bookingLink.downloadPng': 'Download PNG',
    'widgetMedia.bookingLink.downloadSvg': 'Download SVG',
    'widgetMedia.bookingLink.print': 'Print QR code',
    'widgetMedia.bookingLink.open': 'Open the booking page in a new tab',
    'widgetMedia.bookingLink.qrAlt': 'QR code with the booking link',
    'widgetMedia.bookingLink.printTitle': 'Booking QR code',
    'widgetMedia.bookingLink.fileName': 'booking-link-qr',
    'widgetMedia.bookingLink.printHeading': 'Book equipment online. Scan the code with your phone camera.',
    'widgetMedia.bookingLink.missing': 'The link appears once the panel knows the widget address and your company code.',
    'widgetMedia.bookingLink.demoNote': 'On a demo account the booking page shows equipment, dates and prices but does not accept bookings (terms of service, § 6(3)). The customer sees a message about it.',
    'widgetMedia.embedSubtitle': 'Once the widget looks the way you want - copy the code below and paste it on your site. The widget is tied to your organisation by its unique code.',
    'widgetMedia.embedTitle': 'Code to install on your site',
    'widgetMedia.fileTooBig': 'File too large (max 5MB)',
    'widgetMedia.invalidFormat': 'Invalid format (allowed: JPG, PNG, WEBP)',
    'widgetMedia.hideCode': 'Hide code',
    'widgetMedia.imagesCategoriesHint': 'Images for the category tiles. Recommended resolution:',
    'widgetMedia.imagesClassesHint': 'Images for the class tiles. Recommended resolution:',
    'widgetMedia.imagesFormatHint': ', max 5MB (JPG, PNG, WEBP).',
    'widgetMedia.invalidScope': 'Invalid scope.',
    'widgetMedia.livePreview': 'Live preview',
    'widgetMedia.loadFailed': 'Could not load the data.',
    'widgetMedia.loading': 'Loading data...',
    'widgetMedia.premiumOnly': 'The widget is available on the premium plan only.',
    'widgetMedia.previewNote': 'Indicative preview - your changes will be saved and will appear in the real widget.',
    'widgetMedia.priceDaily': 'Daily price',
    'widgetMedia.priceMode': 'Price display mode',
    'widgetMedia.priceTotal': 'Total price',
    'widgetMedia.refresh': 'Refresh',
    'widgetMedia.refreshPreview': 'Refresh the preview',
    'widgetMedia.rotateError': 'Code rotation error.',
    'widgetMedia.rotateFailed': 'Could not generate a new code.',
    'widgetMedia.rotateOk': 'A new widget code has been generated.',
    'widgetMedia.saveError': 'Save error.',
    'widgetMedia.saveFailed': 'Could not save.',
    'widgetMedia.saveSettings': 'Save settings',
    'widgetMedia.saveSettingsError': 'Error saving the settings.',
    'widgetMedia.saveSettingsFailed': 'Could not save the settings.',
    'widgetMedia.savedChanges': 'Changes saved.',
    'widgetMedia.sectionCategories': 'Categories',
    'widgetMedia.sectionClasses': 'Equipment classes',
    'widgetMedia.classesDefaultGroup': 'Default class image',
    'widgetMedia.classesDefaultHint': 'The widget shows it in every category where the class has no image of its own (below).',
    'widgetMedia.classDefaultBadge': 'Default image',
    'widgetMedia.groupImages': 'Images: {own} of {all}',
    'widgetMedia.categoriesGroup': 'All categories',
    'widgetMedia.settingsSaved': 'Widget settings saved successfully!',
    'widgetMedia.settingsSub': 'Adjust the look and behaviour of the widget to suit your rental business.',
    'widgetMedia.showCode': 'Show code',
    'widgetMedia.copied': 'Copied!',
    'widgetMedia.copyCode': 'Copy code',
    'widgetMedia.showImages': 'Show images on the tiles',
    'widgetMedia.showProgress': 'Show the progress bar',
    'widgetMedia.showSizeChart': 'Show the size chart',
    'widgetMedia.subtitle': 'Appearance, content and images shown in the client widget.',
    'widgetMedia.themeBlue': 'Blue',
    'widgetMedia.themeDarkBlue': 'Dark blue (brand)',
    'widgetMedia.themeGreen': 'Green',
    'widgetMedia.themeNature': 'Nature gradient',
    'widgetMedia.customThemeTitle': 'Custom theme',
    'widgetMedia.customThemeModeAria': 'Custom theme type',
    'widgetMedia.modeSolid': 'Solid',
    'widgetMedia.modeGradient': 'Gradient',
    'widgetMedia.customThemeHintSolid': 'One color for the whole theme.',
    'widgetMedia.customThemeHintGradient': 'Two colors blend into a smooth background transition.',
    'widgetMedia.customColorSolid': 'Theme color',
    'widgetMedia.customColor1': 'Color 1',
    'widgetMedia.customColor2': 'Color 2',
    'widgetMedia.customAccent': 'Accent color',
    'widgetMedia.shuffleColors': 'Shuffle color pair',
    'widgetMedia.previewFallbackTitle': 'Your rental shop',
    'widgetMedia.previewCta': 'Book now',
    'widgetMedia.themeNight': 'Night gradient',
    'widgetMedia.themeOcean': 'Ocean gradient',
    'widgetMedia.themeOrange': 'Orange',
    'widgetMedia.themePurple': 'Purple',
    'widgetMedia.themeRed': 'Red',
    'widgetMedia.themeSunset': 'Sunset gradient',
    'widgetMedia.themeTurquoise': 'Turquoise',
    'widgetMedia.title': 'Widget',
    'widgetMedia.uploadFailed': 'Could not upload the file.',
    'widgetMedia.uploadOk': 'Image uploaded successfully.',
    'widgetMedia.uploadTitle': 'Upload an image (JPG, PNG, WEBP, max 5MB)',
    'widgetMedia.uploading': 'Uploading...',
    'widgetMedia.widgetName': 'Widget name',

    // ── P8.1e (3/6): przewodniki stron i kalendarz sprzetu ──
    'equipmentCalendar.aggregateHint': 'The numbers on each day are reservations and offers across all items.',
    'equipmentCalendar.aggregateView': 'Combined calendar view',
    'equipmentCalendar.allEquipment': 'All equipment',
    'equipmentCalendar.apartmentNo': 'Flat no.',
    'equipmentCalendar.backToInventory': 'Back to inventory',
    'equipmentCalendar.basicData': 'Basic details',
    'equipmentCalendar.bookEquipment': 'Book equipment',
    'equipmentCalendar.buildingNo': 'Building no.',
    'equipmentCalendar.checkAvailabilityFailed': 'Could not check equipment availability.',
    'equipmentCalendar.city': 'City',
    'equipmentCalendar.clearRange': 'Clear the date range',
    'equipmentCalendar.clientLabel': 'Client:',
    'equipmentCalendar.dateRange': 'Date range*',
    'equipmentCalendar.dayCount': 'Number of days',
    'equipmentCalendar.dayEmpty': 'The item is free on this day.',
    'equipmentCalendar.dayEmptyAll': 'No reservations or offers on this day.',
    'equipmentCalendar.daysFew': '{count} days',
    'equipmentCalendar.daysMany': '{count} days',
    'equipmentCalendar.daysOne': '{count} day',
    'equipmentCalendar.daysOther': '{count} days',
    'equipmentCalendar.editAddress': 'Edit address',
    'equipmentCalendar.emptyPickEquipment': 'Click "Choose equipment" to add equipment to the reservation',
    'equipmentCalendar.emptyPickRange': 'Pick a date range first to see the available equipment',
    'equipmentCalendar.equipmentRequired': 'Choose equipment',
    'equipmentCalendar.errorPanel': 'Error',
    'equipmentCalendar.fillRequired': 'Fill in all the required fields',
    'equipmentCalendar.firstname': 'First name*',
    'equipmentCalendar.firstnameRequired': 'First name is required',
    'equipmentCalendar.goToday': 'Back to today',
    'equipmentCalendar.kindReservation': 'Reservation',
    'equipmentCalendar.lastname': 'Last name*',
    'equipmentCalendar.lastnameRequired': 'Last name is required',
    'equipmentCalendar.legend': 'Legend',
    'equipmentCalendar.legendAvailable': 'Available',
    'equipmentCalendar.legendBooked': 'Booked',
    'equipmentCalendar.legendOffer': 'Offer',
    'equipmentCalendar.legendOfferHold': 'Offer (provisional hold)',
    'equipmentCalendar.legendToday': 'Today',
    'equipmentCalendar.loadAvailableFailed': 'Could not load the available equipment.',
    'equipmentCalendar.loadFailed': 'Could not load the equipment calendar. Check your connection and try again.',
    'equipmentCalendar.loading': 'Loading...',
    'equipmentCalendar.moreOnDay': '{count} more on this day',
    'equipmentCalendar.newReservation': 'New reservation',
    'equipmentCalendar.newReservationHint': 'Enter the reservation details and choose the equipment',
    'equipmentCalendar.next30': 'Next 30 days',
    'equipmentCalendar.next30Empty': 'Nothing planned for the next 30 days.',
    'equipmentCalendar.noReservations': 'No reservations',
    'equipmentCalendar.noUpcomingOffers': 'No upcoming offers',
    'equipmentCalendar.notFound': 'No equipment found with that identifier.',
    'equipmentCalendar.notePlaceholder': 'Enter a note',
    'equipmentCalendar.notes': 'Notes',
    'equipmentCalendar.occupancy': '{month}: booked {busy} of {total} days',
    'equipmentCalendar.offerFor': 'Offer: {name}',
    'equipmentCalendar.open': 'Open',
    'equipmentCalendar.openTitle': 'Open the reservation details',
    'equipmentCalendar.phApartmentOptional': 'Flat no. (optional)',
    'equipmentCalendar.phFirstname': 'First name',
    'equipmentCalendar.phLastname': 'Last name',
    'equipmentCalendar.phPhone': 'Phone',
    'equipmentCalendar.phone': 'Phone*',
    'equipmentCalendar.phoneRequired': 'Phone is required',
    'equipmentCalendar.pickRangeFirst': 'Pick a date range first.',
    'equipmentCalendar.pickRangeFirstShort': 'Pick a date range first',
    'equipmentCalendar.postalCode': 'Postal code',
    'equipmentCalendar.rangeFrom': 'From',
    'equipmentCalendar.rangeRequired': 'Pick a date range',
    'equipmentCalendar.rangeTo': 'To',
    'equipmentCalendar.removeFromReservation': 'Remove equipment from the reservation',
    'equipmentCalendar.reservationRange': 'Reservation dates',
    'equipmentCalendar.reservations': 'Reservations',
    'equipmentCalendar.saveAddress': 'Save address',
    'equipmentCalendar.saveError': 'Save error',
    'equipmentCalendar.saveReservation': 'Save reservation',
    'equipmentCalendar.saveReservationFailed': 'Could not save the reservation',
    'equipmentCalendar.searchEquipment': 'Search equipment...',
    'equipmentCalendar.selectedDay': 'Selected day',
    'equipmentCalendar.selectedEquipment': 'Selected equipment',
    'equipmentCalendar.selectedEquipmentRequired': 'Selected equipment*',
    'equipmentCalendar.showInCalendar': 'Show in the calendar',
    'equipmentCalendar.statusFree': 'Free today',
    'equipmentCalendar.statusHeld': 'Held by an offer until {date}',
    'equipmentCalendar.statusLabel': 'Status:',
    'equipmentCalendar.statusNext': 'Next reservation: {range}, {name}',
    'equipmentCalendar.statusNoNext': 'No reservations planned',
    'equipmentCalendar.statusRented': 'Rented out until {date}',
    'equipmentCalendar.street': 'Street',
    'equipmentCalendar.summary': 'Summary',
    'equipmentCalendar.title': 'Rental calendar',
    'equipmentCalendar.upcomingOffers': 'Upcoming offers ({count})',
    'reservationDetails.cancelledNote': 'This reservation is cancelled: the equipment is free and no new payments are taken. You can settle a card deposit hold below.',
    'reservationDetails.depositAfterReturn': 'All equipment is back and the deposit is still held on the customer\'s card. Release it, or capture an amount for damage, in the "Online deposit" section.',
    'reservationDetails.daysFew': '{count} days',
    'reservationDetails.daysMany': '{count} days',
    'reservationDetails.daysOne': '{count} day',
    'reservationDetails.daysOther': '{count} days',
    'reservationDetails.equipment': 'Equipment',
    'reservationDetails.eyebrow': 'Reservation details #{id}',
    'reservationDetails.itemsCount': 'items: {count}',
    'reservationDetails.note': 'Note',
    'reservationDetails.paidExtra': 'Including additional payments of {amount}',
    'reservationDetails.paidInFull': 'Paid in full',
    'reservationDetails.payments': 'Payments and deposit',
    'reservationDetails.remaining': 'Left to pay',
    'pageTours.calendar.day.lead': 'The coloured bars in the grid are reservations; this panel shows the selected day.',
    'pageTours.calendar.day.p1': 'Clicking a day in the calendar shows its plan here: pick-ups, returns and the equipment to prepare.',
    'pageTours.calendar.day.p2': 'Clicking a reservation opens its details: editing, plus handing out and taking back equipment.',
    'pageTours.calendar.day.p3': 'The arrows above the grid switch months, and "Today" jumps back to the current day.',
    'pageTours.calendar.day.title': 'Reservation calendar',
    'pageTours.calendar.tabs.lead': 'The tabs show the same reservations as a list.',
    'pageTours.calendar.tabs.p1': '"Upcoming" is everything from today on - the badge tells you how many.',
    'pageTours.calendar.tabs.p2': '"History" starts with the newest and lets you search by name.',
    'pageTours.calendar.tabs.p3': '"Add Reservation" in the top right corner opens the new reservation form.',
    'pageTours.calendar.tabs.title': 'A list instead of the grid',
    'pageTours.calendar.title': 'Calendar',
    'pageTours.clients.card.lead': 'Clicking a card opens the client details.',
    'pageTours.clients.card.p1': '"Edit details" updates contact details and address - they later go onto the contract and the invoice.',
    'pageTours.clients.card.p2': '"Reservations" shows that person\'s rental history, and "New reservation" starts another one with their details.',
    'pageTours.clients.card.p3': '"Add client" at the top is handy when somebody walks in off the street.',
    'pageTours.clients.card.title': 'Client card',
    'pageTours.clients.search.lead': 'One list of everyone who has ever rented from you.',
    'pageTours.clients.search.p1': 'Search by surname, first name, phone or email - type a fragment and the list filters instantly.',
    'pageTours.clients.search.p2': 'Next to it: sorting (A-Z, by number of reservations, newest) and a filter for all, new in the last 30 days, or regulars.',
    'pageTours.clients.search.p3': 'Clients add themselves when they book through the widget - you do not have to enter them by hand.',
    'pageTours.clients.search.title': 'Client base',
    'pageTours.clients.title': 'Clients',
    'pageTours.contract-template.preview.lead': 'The preview shows the contract exactly as it will come out on paper.',
    'pageTours.contract-template.preview.p1': '"Test on" fills in sample reservations: a standard one, one without a deposit and a longer rental.',
    'pageTours.contract-template.preview.p2': '"PDF preview" shows the exact page breaks.',
    'pageTours.contract-template.preview.p3': 'Changes are saved as a draft - clients only get the new version after "Publish template".',
    'pageTours.contract-template.preview.title': 'Preview and publishing',
    'pageTours.contract-template.start.lead': 'You build the contract from blocks - the easiest start is a ready-made pattern.',
    'pageTours.contract-template.start.p1': 'A pattern replaces all sections, and then you adjust the text your way.',
    'pageTours.contract-template.start.p2': 'Already have your own contract? Expand the import and paste its text.',
    'pageTours.contract-template.start.p3': 'Fields such as the client name or the equipment list are inserted from a list - the contract for a reservation gets the real data.',
    'pageTours.contract-template.start.title': 'Contract builder',
    'pageTours.contract-template.title': 'Contract builder',
    'pageTours.counter': 'Step {current} of {total}',
    'pageTours.equipment-bundles.effect.lead': 'You do not have to remember the bundle - the system recognises it.',
    'pageTours.equipment-bundles.effect.p1': 'When a client takes a set matching a bundle, the price drops to the bundle rate.',
    'pageTours.equipment-bundles.effect.p2': 'The price breakdown in the summary shows how much the client saved on the bundle.',
    'pageTours.equipment-bundles.effect.p3': 'The toggle in the list row switches a bundle on and off without deleting it.',
    'pageTours.equipment-bundles.effect.title': 'How it works during booking',
    'pageTours.equipment-bundles.presets.lead': 'A bundle is several equipment types rented together for less - "New bundle" creates one from scratch.',
    'pageTours.equipment-bundles.presets.p1': '"Quick bundles" below suggest equipment your clients rent together, with a suggested price.',
    'pageTours.equipment-bundles.presets.p2': 'Clicking a suggestion only fills in the form - you can change the price and the name before saving.',
    'pageTours.equipment-bundles.presets.p3': 'A bundle must contain at least two equipment types.',
    'pageTours.equipment-bundles.presets.title': 'Sets at one price',
    'pageTours.equipment-bundles.title': 'Equipment bundles',
    'help.button.aria': 'Help and feedback',
    'help.menu.label': 'Help',
    'help.menu.bug': 'Report a bug',
    'help.menu.question': 'Ask a question',
    'help.menu.idea': 'Suggest a change or a new feature',
    'help.menu.tour': 'Guide to this page',
    'help.form.title': 'Write to us',
    'help.form.subtitle': 'Your message goes to the the.rENT team and we will reply by email.',
    'help.form.category': 'Topic',
    'help.category.bug': 'Bug',
    'help.category.question': 'Question',
    'help.category.idea': 'Suggestion',
    'help.category.other': 'Other',
    'help.form.subject': 'Subject',
    'help.form.message': 'Description',
    'help.form.hint.bug': 'What did you do, what happened and what did you expect?',
    'help.form.hint.question': 'What are you looking for or trying to do?',
    'help.form.hint.idea': 'What would you like to change or add, and what would it help you with?',
    'help.form.hint.other': 'Tell us how we can help.',
    'help.form.counter': '{n} of {max} characters',
    'help.form.noCustomerData': 'Do not include your customers\' data unless it is needed.',
    'help.form.replyTo': 'We will reply to',
    'help.form.replyToMissing': 'Your account has no email address, so we cannot reply by email. Add a phone number or another way to reach you in the description.',
    'help.form.send': 'Send',
    'help.form.sending': 'Sending…',
    'help.form.cancel': 'Cancel',
    'help.form.close': 'Close',
    'help.shots.toggle': 'Attach a screenshot (optional)',
    'help.shots.drop': 'Paste a screenshot (Ctrl+V), drag it here or',
    'help.shots.choose': 'choose a file',
    'help.shots.count': 'Attached: {n} of {max}',
    'help.shots.warning': 'A screenshot may contain your customers\' data. Crop it or cover the data before sending.',
    'help.shots.howTo': 'How to take a screenshot: Win+Shift+S on Windows, Cmd+Shift+4 on a Mac, power and volume-down buttons together on a phone.',
    'help.shots.remove': 'Remove screenshot {n}',
    'help.shots.alt': 'Screenshot {n}',
    'help.shots.limit': 'You can attach up to {max} screenshots.',
    'help.shots.notImage': 'A file that is not an image was skipped.',
    'help.context.summary': 'What else we send',
    'help.context.intro': 'We add this automatically so we can find the cause faster:',
    'help.context.page': 'Page',
    'help.context.browser': 'Browser',
    'help.context.language': 'Panel language',
    'help.context.window': 'Window size',
    'help.context.org': 'Company',
    'help.context.account': 'Account',
    'help.context.role': 'Role and plan',
    'help.context.roleValue': 'from your account',
    'help.context.attachments': 'Screenshots',
    'help.context.none': 'none',
    'help.done.title': 'Thank you, your message has been sent',
    'help.done.ticket': 'Ticket number',
    'help.done.reply': 'We will reply to {email}.',
    'help.done.replyNoEmail': 'Your account has no email address. Please quote the ticket number when you contact us.',
    'help.error.invalid_category': 'Choose what your message is about.',
    'help.error.subject_required': 'Enter a subject.',
    'help.error.subject_too_long': 'The subject can have at most {max} characters.',
    'help.error.message_too_short': 'Describe the issue in at least {min} characters.',
    'help.error.message_too_long': 'The description can have at most {max} characters.',
    'help.error.too_many_attachments': 'You can attach up to {max} screenshots.',
    'help.error.attachment_too_large': 'One of the screenshots is too large. Crop or shrink it.',
    'help.error.attachment_not_image': 'One of the files is not a PNG, JPEG or WebP image.',
    'help.error.attachment_unreadable': 'One of the screenshots cannot be read. Save it again and attach it once more.',
    'help.error.request_too_large': 'The screenshots are too large in total. Remove one or crop them.',
    'help.error.too_many_requests': 'Many messages have already been sent. Try again in {minutes} min or email us.',
    'help.error.server_busy': 'The server is busy right now. Try again in {seconds} s or email us.',
    'help.error.session': 'Your session has expired. Log in again, your text will be kept. You can also email us.',
    'help.error.generic': 'The message could not be sent.',
    'help.fallback.retry': 'Try again',
    'help.fallback.title': 'The message could not be sent from the panel',
    'help.fallback.body': 'Send it by regular email instead, the text is ready.',
    'help.fallback.link': 'Open the message in your email app',
    'help.fallback.address': 'Or write to {email}.',
    'help.fallback.attachNote': 'Screenshots cannot be added automatically, attach them to the email yourself.',
    'help.mailto.attachNote': 'This message was meant to include screenshots ({n}); I am attaching them to this email.',
    'pageTours.finish': 'Got it',
    'pageTours.home.favorites.lead': 'Shortcuts to the pages you use most often.',
    'pageTours.home.favorites.p1': 'Clicking a tile takes you straight to that page.',
    'pageTours.home.favorites.p2': 'The edit button lets you pick up to four shortcuts.',
    'pageTours.home.favorites.p3': 'Drag the tiles by the handle in the corner to arrange them your way.',
    'pageTours.home.favorites.title': 'Your dashboard',
    'pageTours.home.title': 'Home',
    'pageTours.home.upcoming.lead': 'A list of what you hand out over the next few days.',
    'pageTours.home.upcoming.p1': 'The "Upcoming / Ongoing" switch also shows reservations that have already started.',
    'pageTours.home.upcoming.p2': 'Change the range next to it: today, this week or 30 days.',
    'pageTours.home.upcoming.p3': 'Clicking a reservation opens it in the calendar with all its details.',
    'pageTours.home.upcoming.title': 'Upcoming reservations',
    'pageTours.inventory.actions.lead': 'All your equipment in one table, with the most common actions above it.',
    'pageTours.inventory.actions.p1': '"Add equipment" adds a single item; a longer list can be uploaded from a spreadsheet (Profile → Data import).',
    'pageTours.inventory.actions.p2': '"Inventory settings" decide which fields and columns your equipment has.',
    'pageTours.inventory.actions.p3': '"Labels" prints QR codes and barcodes, and "Equipment calendar" shows how busy each item is.',
    'pageTours.inventory.actions.title': 'Inventory',
    'pageTours.inventory.filters.lead': 'One field searches by name, brand, number and barcode.',
    'pageTours.inventory.filters.p1': 'The chips below narrow the list - a chip that is set shows its value and a cross to clear it.',
    'pageTours.inventory.filters.p2': '"Camera" and "Phone" scan the code on the sticker and find the item straight away.',
    'pageTours.inventory.filters.p3': 'Clicking an item opens its details, with editing and label printing.',
    'pageTours.inventory.filters.title': 'Search and filters',
    'pageTours.inventory.title': 'Inventory',
    'pageTours.invoices.filters.lead': 'The search and filters narrow the list.',
    'pageTours.invoices.filters.p1': 'Search by number, buyer or tax ID; next to it pick the document type and a date range.',
    'pageTours.invoices.filters.p2': 'The chips below the fields filter by payment: unpaid, partially paid, paid.',
    'pageTours.invoices.filters.p3': 'In each row you download the PDF and send a VAT invoice to KSeF (sending to KSeF is blocked in demo mode).',
    'pageTours.invoices.filters.title': 'Document list',
    'pageTours.invoices.new.lead': 'This is where you issue pro formas, VAT invoices and corrections.',
    'pageTours.invoices.new.p1': '"New invoice" creates a document from a reservation (items and buyer fill in by themselves) or from scratch.',
    'pageTours.invoices.new.p2': 'The tiles below show how much is waiting to be paid and what is overdue.',
    'pageTours.invoices.new.p3': 'An issued VAT invoice cannot be edited - you fix it with a correction.',
    'pageTours.invoices.new.title': 'Invoices',
    'pageTours.invoices.title': 'Invoices',
    'pageTours.next': 'Next',
    'pageTours.notifications.email.lead': 'Emails to clients go out automatically - switch on only the ones you need.',
    'pageTours.notifications.email.p1': 'Four kinds: reservation confirmation, pick-up reminder, return reminder and contract ready.',
    'pageTours.notifications.email.p2': 'Once switched on, the text expands: insert client and reservation data with chips, and the test button sends a sample to your address.',
    'pageTours.notifications.email.p3': 'Reminders go out as many days in advance as you set, and only between 9:00 and 20:00.',
    'pageTours.notifications.email.title': 'Email notifications',
    'pageTours.notifications.sms.lead': 'Text messages are sent through your own SMSAPI.pl account.',
    'pageTours.notifications.sms.p1': 'Switch them on with the main toggle, then each kind separately - just like emails.',
    'pageTours.notifications.sms.p2': 'You paste the API token once; after saving it is never shown again.',
    'pageTours.notifications.sms.p3': 'In demo mode no messages are sent to clients - a test only goes to your own email address.',
    'pageTours.notifications.sms.title': 'SMS notifications',
    'pageTours.notifications.title': 'Notifications',
    'pageTours.offer-template.fields.lead': 'You set the fixed parts of the offer once; client data fills in by itself.',
    'pageTours.offer-template.fields.p1': 'The chips insert fields (client, dates, amount, account number) where the cursor is in a text field.',
    'pageTours.offer-template.fields.p2': 'The tables with client data, equipment and the summary are created automatically.',
    'pageTours.offer-template.fields.p3': 'In the header above you set the title, company logo and text size.',
    'pageTours.offer-template.fields.title': 'Offer builder',
    'pageTours.offer-template.preview.lead': 'The preview shows the offer with sample data.',
    'pageTours.offer-template.preview.p1': '"PDF preview" and "Download PDF" give you exactly the file the client will receive.',
    'pageTours.offer-template.preview.p2': '"Save draft" changes nothing for clients - the new version only takes effect after "Publish template".',
    'pageTours.offer-template.preview.p3': 'Previously published versions stay in the history.',
    'pageTours.offer-template.preview.title': 'Preview and publishing',
    'pageTours.offer-template.title': 'Offer builder',
    'pageTours.offers.form.lead': 'This is where you price an enquiry before it becomes a reservation.',
    'pageTours.offers.form.p1': 'Enter the client details (the email field suggests existing ones), the dates and the equipment - the price comes from your price list.',
    'pageTours.offers.form.p2': 'Give the discount in currency or per cent; you can also override the final amount by hand.',
    'pageTours.offers.form.p3': '"Generate offer" produces a PDF, "Send offer by email" delivers it to the client.',
    'pageTours.offers.form.title': 'Offer for a client',
    'pageTours.offers.history.lead': 'Sent offers do not get lost - they are in the offer history tab.',
    'pageTours.offers.history.p1': 'You can see what went out and to whom, and generate the document again.',
    'pageTours.offers.history.p2': 'An accepted offer turns into a reservation without retyping anything.',
    'pageTours.offers.history.p3': 'Equipment in an offer can be held temporarily so nobody books it in the meantime.',
    'pageTours.offers.history.title': 'Offer history',
    'pageTours.offers.title': 'Offers',
    'pageTours.payment-settings.account.lead': 'Once the account is connected, the payment settings appear in this card.',
    'pageTours.payment-settings.account.p1': '"Widget advance payment": what percentage of the amount the client pays online when booking.',
    'pageTours.payment-settings.account.p2': 'Auto-cancel: a widget reservation without payment is cancelled after the hours you set, with a reminder to the client first.',
    'pageTours.payment-settings.account.p3': 'Pausing online payments switches off new payments without disconnecting the account.',
    'pageTours.payment-settings.account.title': 'Account and payment rules',
    'pageTours.payment-settings.intro.lead': 'Clients pay by BLIK or card, and the money goes straight to your account.',
    'pageTours.payment-settings.intro.p1': 'Payments are handled by Stripe - you connect your account once, on its secure page.',
    'pageTours.payment-settings.intro.p2': 'Without it, reservations still work: you take the advance in cash or by bank transfer.',
    'pageTours.payment-settings.intro.p3': 'In demo mode online payments are switched off - no card will be charged.',
    'pageTours.payment-settings.intro.title': 'Online payments',
    'pageTours.payment-settings.title': 'Online payments',
    'pageTours.payments.deposits.lead': 'The tiles at the top tell you how much has been collected and how many payments are waiting for the client.',
    'pageTours.payments.deposits.p1': 'An advance confirms the reservation; you set its percentage in the payment settings.',
    'pageTours.payments.deposits.p2': 'A deposit goes through a hold on the card and is then captured or released.',
    'pageTours.payments.deposits.p3': 'In demo mode online payments are switched off - no card will ever be charged.',
    'pageTours.payments.deposits.title': 'Advances and deposits',
    'pageTours.payments.list.lead': 'Together: online payments and those taken on site.',
    'pageTours.payments.list.p1': 'The status chips filter the list - the same colours as the badges in the table.',
    'pageTours.payments.list.p2': 'The date range and the search box narrow the list down to a specific case.',
    'pageTours.payments.list.p3': 'Online payments are reconciled with Stripe payouts; cash and transfers are recorded by hand with the reservation.',
    'pageTours.payments.list.title': 'Client payments',
    'pageTours.payments.title': 'Payments',
    'pageTours.prev': 'Back',
    'pageTours.price-rules.form.lead': 'For when you need something beyond the ready-made ones.',
    'pageTours.price-rules.form.p1': '"New rule" opens the form: date range, weekdays, equipment class or type, and the change - percentage or amount.',
    'pageTours.price-rules.form.p2': 'Priority decides which rule wins when several match at once.',
    'pageTours.price-rules.form.p3': 'Rules apply everywhere a price is calculated: reservations, offers and the widget.',
    'pageTours.price-rules.form.title': 'Your own rule',
    'pageTours.price-rules.presets.lead': 'The simplest start: switch on a ready-made rule.',
    'pageTours.price-rules.presets.p1': 'Weekend surcharge, high season and off-season promotion - with date ranges already filled in.',
    'pageTours.price-rules.presets.p2': 'The chips next to it pick the size of the change (e.g. +10%, +15%, +20%).',
    'pageTours.price-rules.presets.p3': 'Switching the toggle off only puts the rule to sleep, it does not delete it.',
    'pageTours.price-rules.presets.title': 'Quick rules',
    'pageTours.price-rules.title': 'Seasonal pricing',
    'pageTours.profile.account.lead': 'Settings are split into groups - the first one is about you.',
    'pageTours.profile.account.p1': '"Your Data" and "Security": contact details, password and two-step login.',
    'pageTours.profile.account.p2': '"Your Preferences": light or dark theme and the panel language.',
    'pageTours.profile.account.p3': '"Users": accounts for your staff - everyone signs in with their own login.',
    'pageTours.profile.account.title': 'Your account',
    'pageTours.profile.company.lead': 'Further down are the settings for the whole rental business.',
    'pageTours.profile.company.p1': 'The company details go onto contracts, offers and invoices - fill them in before your first document.',
    'pageTours.profile.company.p2': '"Sales" holds dynamic prices (seasons, weekends) and equipment bundles.',
    'pageTours.profile.company.p3': '"Integrations": email sending, importing data from a spreadsheet and the website widget.',
    'pageTours.profile.company.title': 'Company and sales',
    'pageTours.profile.title': 'Profile',
    'pageTours.reservation.client.lead': 'The form runs top to bottom: client, dates, equipment, payment.',
    'pageTours.reservation.client.p1': 'Start with the surname - we suggest clients who have rented from you before and fill in their details.',
    'pageTours.reservation.client.p2': 'A new person is added to your client base automatically when you save the reservation.',
    'pageTours.reservation.client.p3': 'Fields with an asterisk are required; click the address field to enter street, postcode and city.',
    'pageTours.reservation.client.title': 'New reservation',
    'pageTours.reservation.equipment.lead': 'You pick equipment after choosing the dates - that is when it is clear what is free.',
    'pageTours.reservation.equipment.p1': '"Choose equipment" shows only the items available for those dates.',
    'pageTours.reservation.equipment.p2': 'You can also add an item by scanning its code: with a scanner, the camera or your phone.',
    'pageTours.reservation.equipment.p3': 'The price is calculated from your price list and bundles; the summary at the bottom shows the discount and advance.',
    'pageTours.reservation.equipment.title': 'Equipment for the reservation',
    'pageTours.reservation.title': 'New reservation',
    'pageTours.skip': 'Skip the guide',
    'pageTours.statistics.charts.lead': 'The charts are computed from your reservations - nothing to fill in.',
    'pageTours.statistics.charts.p1': 'This switch changes what the charts measure: number of reservations or value in currency.',
    'pageTours.statistics.charts.p2': '"Seasonality" shows the spread across the year - the peak and the dead months are visible at once.',
    'pageTours.statistics.charts.p3': 'At the bottom of the page, under "Advanced metrics", the "Revenue / item" table: the equipment that earned the most in the selected period, with its number of rentals. The basis for deciding what to buy next.',
    'pageTours.statistics.charts.title': 'How the business is doing',
    'pageTours.statistics.kpi.lead': 'The KPI section has its own year, month and season filters.',
    'pageTours.statistics.kpi.p1': 'Pick a year, a month or a season - the indicators are recalculated for that period. The percentage under the tiles compares it with the same period a year earlier, and a period in progress counts up to today.',
    'pageTours.statistics.kpi.p2': '"Clear" returns to the current month, and the charts to the current year. The year arrows above the chart set the indicators to the whole year.',
    'pageTours.statistics.kpi.p3': 'Equipment utilization and average rental value tell you whether to raise prices.',
    'pageTours.statistics.kpi.title': 'Indicators for a period',
    'pageTours.statistics.title': 'Statistics',
    'pageTours.widget.embed.lead': 'Above this point you change the name, colours and category images - the preview updates straight away.',
    'pageTours.widget.embed.p1': '"Show code" gives you a snippet to paste into your website.',
    'pageTours.widget.embed.p2': 'The allowed domains are the pages customers return to after an online payment; the widget from the code and the QR code link always work.',
    'pageTours.widget.embed.p3': 'Category images are uploaded from your disk - the widget never loads images from other websites.',
    'pageTours.widget.embed.title': 'Settings and installation',
    'pageTours.widget.preview.lead': 'The widget is a booking form you put on your own website.',
    'pageTours.widget.preview.p1': 'The live preview shows it the way the client will see it - on a computer and on a phone.',
    'pageTours.widget.preview.p2': 'The client picks the dates and equipment, and the reservation lands straight in your calendar. On a demo account the widget does not accept bookings.',
    'pageTours.widget.preview.p3': 'Availability comes from your inventory and reservations, so a client cannot book equipment that is taken.',
    'pageTours.widget.preview.title': 'Booking widget',
    'pageTours.widget.title': 'Widget',

    // ── P8.1e (2/5): ustawienia firmy i powiadomien ──
    'contractSettings.alignCenter': 'Centred',
    'contractSettings.alignLeft': 'Left',
    'contractSettings.alignRight': 'Right',
    'contractSettings.autoEmail': 'Automatically email the invoice to the buyer',
    'contractSettings.autoEmailHint': 'After a VAT invoice, receipt or correction is issued, the system automatically sends the PDF to the client email address.',
    'contractSettings.bankCard': 'Bank details',
    'contractSettings.bankName': 'Bank name',
    'contractSettings.bankNamePh': 'PKO Bank Polski S.A.',
    'contractSettings.changeLogo': 'Change logo',
    'contractSettings.city': 'City',
    'contractSettings.cityPh': 'Warszawa',
    'contractSettings.companyCard': 'Company details (rental business)',
    'contractSettings.companyName': 'Full company name',
    'contractSettings.companyNamePh': 'e.g. Twoja Firma Sp. z o.o.',
    'contractSettings.email': 'Company e-mail',
    'contractSettings.emailBody': 'Email body',
    'contractSettings.emailPh': 'contact@yourcompany.com',
    'contractSettings.emailSubject': 'Email subject',
    'contractSettings.goToBuilder': 'Go to the Contract Builder →',
    'contractSettings.iban': 'Account number (IBAN)',
    'contractSettings.ibanPh': 'PL 12 3456 7890 1234 5678 9012 3456',
    'contractSettings.insertVarHint': 'Click to insert a variable into the Subject or Body field (at the cursor):',
    'contractSettings.insertVarTitle': 'Click to insert',
    'contractSettings.invoiceCard': 'Invoice settings',
    'contractSettings.krs': 'KRS (optional)',
    'contractSettings.loadError': 'Could not load the contract settings.',
    'contractSettings.loading': 'Loading…',
    'contractSettings.logoAlign': 'Logo alignment',
    'contractSettings.logoCard': 'Company logo',
    'contractSettings.logoHeight': 'Logo height (px)',
    'contractSettings.logoHeightError': 'Enter a whole number from {min} to {max}.',
    'contractSettings.logoHeightHint': 'From {min} to {max} px, an empty field means {def} px. A wide logo is also limited to 260 px in width, so it may come out lower than the height entered.',
    'contractSettings.saveBlockedAfterLoadError': 'Refresh the page before saving: saving is disabled so that empty fields do not overwrite the saved company details.',
    'contractSettings.logoHint': 'Appears at the top of generated contracts. PNG, JPG, WEBP or SVG, up to 1 MB.',
    'contractSettings.logoTooBig': 'The logo is too large. The maximum size is 1 MB.',
    'contractSettings.logoType': 'The logo must be a PNG, JPG, WEBP or SVG file.',
    'contractSettings.missingDataBody': 'Missing company details: {list}. These are inserted into contracts automatically. Without them the contracts will have empty fields. Go to the Builder anyway?',
    'contractSettings.missingDataTitle': 'Company details are missing',
    'contractSettings.noLogo': 'No logo',
    'contractSettings.numberFormat': 'The invoice number will look like:',
    'contractSettings.payBlik': 'BLIK',
    'contractSettings.payCard': 'Card',
    'contractSettings.payCash': 'Cash',
    'contractSettings.payMethod': 'Default payment method',
    'contractSettings.payOther': 'Other',
    'contractSettings.payTerm': 'Default payment term (days)',
    'contractSettings.payTransfer': 'Bank transfer',
    'contractSettings.phone': 'Company phone',
    'contractSettings.pickLogo': 'Choose a logo file',
    'contractSettings.postalCode': 'Postal code',
    'contractSettings.prefixCorrection': 'Correction',
    'contractSettings.prefixProforma': 'Proforma',
    'contractSettings.prefixSimplified': 'Receipt / simplified',
    'contractSettings.prefixVat': 'VAT invoice',
    'contractSettings.prefixes': 'Invoice numbering prefixes',
    'contractSettings.regon': 'REGON (optional)',
    'contractSettings.removeLogo': 'Remove logo',
    'contractSettings.save': 'Save settings',
    'contractSettings.saveError': 'Save error',
    'contractSettings.saveGenericError': 'Error saving the settings.',
    'contractSettings.saveInvoiceError': 'Error saving the invoice settings',
    'contractSettings.saved': 'Company details and invoice settings have been saved.',
    'contractSettings.saving': 'Saving…',
    'contractSettings.signerCard': 'Person signing the contract',
    'contractSettings.signerName': 'Full name',
    'contractSettings.signerNamePh': 'Jan Kowalski',
    'contractSettings.signerTitle': 'Position / role',
    'contractSettings.signerTitlePh': 'Owner / Managing Director',
    'contractSettings.street': 'Street and number',
    'contractSettings.streetPh': 'ul. Przykładowa 1',
    'contractSettings.subtitle': 'Your rental business details are filled into generated contracts automatically.',
    'contractSettings.title': 'Company details',
    'contractSettings.unsavedBanner': 'You have unsaved changes. Save them before going to another page.',
    'contractSettings.pauseNote': 'The account is paused: company data is view only, while invoice settings can be saved as usual.',
    'contractSettings.unsavedBody': 'You have unsaved changes. Are you sure you want to go to the Contract Builder?',
    'contractSettings.unsavedTitle': 'Unsaved changes',
    'contractSettings.varBuyerName': 'Buyer name',
    'contractSettings.varDocLabel': 'Document type',
    'contractSettings.varInvoiceNumber': 'Invoice number',
    'contractSettings.varOrganizationName': 'Company name',
    'contractSettings.varTotalGross': 'Gross amount',
    'contractSettings.varAmountPaid': 'Amount paid',
    'contractSettings.varAmountDue': 'Amount due',
    'contractSettings.vatRate': 'Default VAT rate',
    'contractSettings.vatStatus': 'VAT status',
    'contractSettings.vatStatusActive': 'Active VAT payer',
    'contractSettings.vatStatusExempt': 'VAT exempt',
    'contractSettings.vatRateZero': '0% (domestic, not an exemption)',
    'contractSettings.vatRateLegacy': '{rate}% (not on the list, choose another rate)',
    'contractSettings.vatZeroHint': 'A 0% rate is not a VAT exemption. If the company is VAT exempt, choose the status “VAT exempt” and enter the legal basis. Invoices already issued will not change.',
    'contractSettings.vatBasis': 'Legal basis of the VAT exemption',
    'contractSettings.vatBasisPh': 'e.g. art. 113 ust. 1 ustawy o VAT',
    'contractSettings.vatBasis113': 'Art. 113(1): sales up to PLN 240,000 in the previous year',
    'contractSettings.vatBasis1139': 'Art. 113(9): business started this year',
    'contractSettings.vatBasis43': 'Art. 43(1): service exempt by law (enter the point)',
    'contractSettings.vatExemptHint': 'Invoices of an exempt company are titled “Faktura”, have items with the rate “zw” and a sentence about the exemption with this legal basis. From 2026 the small business exemption applies to sales up to PLN 240,000 a year. Confirm the basis with your accountant.',
    'contractSettings.vatBasisRequired': 'A VAT exempt company must enter the legal basis of the exemption.',
    'contractSettings.vatBasisIncomplete': 'Complete the legal basis: replace “…” with the point number.',
    'notifications.active': 'Active',
    'notifications.body': 'Message body',
    'notifications.chars': 'characters',
    'notifications.confirmDesc': 'Sent to the client automatically right after a reservation is created.',
    'notifications.confirmLabel': 'Reservation confirmation',
    'notifications.contractDesc': 'Sent to the client when a staff member generates a rental contract in the system.',
    'notifications.contractLabel': 'Contract ready',
    'notifications.daysBefore': 'days before',
    'notifications.demoNotice': 'Demo mode - no messages are sent to customers. A test message goes only to your own e-mail address.',
    'notifications.premiumTitle': 'Automatic reminders and text messages are part of the Premium plan.',
    'notifications.premiumBody': 'On the Basic plan, customers get the booking confirmation and the contract by e-mail.',
    'notifications.remindersPremium': 'Pickup and return reminders are part of the Premium plan. Saved settings start working after switching to Premium.',
    'notifications.smsPremium': 'Text messages to customers (booking confirmation and return reminder) are part of the Premium plan. Saved settings start working after switching to Premium, and you can remove a saved SMSAPI token.',
    'notifications.superAdminNotPremium': 'Your company is not on the Premium plan. As a super admin you can save reminders and text messages, but they are not sent until the company switches to Premium.',
    'notifications.emailCard': 'Email notifications',
    'notifications.inactive': 'Disabled',
    'notifications.insertData': 'Insert data:',
    'notifications.insertHint': 'Click a button to insert client or company data at the right place in the text.',
    'notifications.loadError': 'Could not load the notification settings.',
    'notifications.loading': 'Loading…',
    'notifications.pickupDesc': 'Sent automatically N days before the planned equipment pickup.',
    'notifications.pickupLabel': 'Pickup reminder',
    'notifications.returnDesc': 'Sent automatically N days before the equipment return deadline.',
    'notifications.returnLabel': 'Return reminder',
    'notifications.save': 'Save settings',
    'notifications.saveError': 'Save error',
    'notifications.saveGenericError': 'Save error.',
    'notifications.saved': 'Notification settings have been saved.',
    'notifications.saving': 'Saving…',
    'notifications.sendError': 'Sending error',
    'notifications.sendTest': 'Send a test email to my address',
    'notifications.sending': 'Sending…',
    'notifications.smsBody': 'SMS body (max. 160 characters)',
    'notifications.smsCard': 'SMS notifications',
    'notifications.smsConfirmDesc': 'A short text message right after a reservation is placed.',
    'notifications.smsConfirmLabel': 'Reservation confirmation (SMS)',
    'notifications.smsEnableDesc': 'Once enabled you can switch on the individual SMS notifications below.',
    'notifications.smsEnableLabel': 'Enable SMS (SMSAPI.pl)',
    'notifications.smsInfoAfter': ' (around 0.09 PLN per SMS). Your own account and API token are required.',
    'notifications.smsInfoBefore': 'Text messages are sent through',
    'notifications.smsReturnDesc': 'A short SMS N days before the equipment return deadline.',
    'notifications.smsReturnLabel': 'Return reminder (SMS)',
    'notifications.smsSender': 'SMS sender (max. 11 characters, no spaces)',
    'notifications.smsSenderPh': 'e.g. therENT',
    'notifications.smsStep1a': 'Create an account at',
    'notifications.smsStep1b': 'and top it up',
    'notifications.smsStep2a': 'Go to',
    'notifications.smsStep2b': 'API → Access tokens',
    'notifications.smsStep2c': 'and copy the OAuth token',
    'notifications.smsStep3': 'Paste the token below and save the settings',
    'notifications.smsToken': 'API token (SMSAPI OAuth)',
    'notifications.smsTokenPh': 'Paste the token from the SMSAPI panel',
    'notifications.smsTokenSavedPh': 'Token saved. Enter a new one to replace it',
    'notifications.smsTokenRemove': 'Remove saved token',
    'notifications.smsTokenWillRemove': 'The token will be removed when you save the settings.',
    'notifications.tomorrowMismatch': 'The text says “tomorrow”, but the reminder goes out more than a day before the deadline, so the client will get wrong information. Insert the date instead of “tomorrow”, or set 1 day.',
    'notifications.smtpInfoAfter': ' screen.',
    'notifications.smtpInfoBefore': 'Without your own mail server, emails to customers are sent from the the.rENT address, signed with the name of your rental, and replies go to the email in Company details. You can set up your own mail server (Premium plan) on the',
    'notifications.subject': 'Message subject',
    'notifications.subtitle': 'Automatic messages sent to clients around their reservations. Enable only what you need.',
    'notifications.title': 'Client notifications',
    'notifications.usedInBody': 'Used in the body:',
    'notifications.varEndDate': 'Return date',
    'notifications.varFirstName': 'First name',
    'notifications.varLastName': 'Last name',
    'notifications.varOrgName': 'Company name',
    'notifications.varOrgPhone': 'Company phone',
    'notifications.varPickupDate': 'Pickup date',
    'notifications.varReturnDate': 'Return date',
    'notifications.varReservationId': 'Reservation number',
    'notifications.varOrgEmail': 'Rental e-mail',
    'notifications.varOrgContact': 'Contact (e-mail and phone)',
    'notifications.widgetEmailsCard': 'Widget e-mails to customers',
    'notifications.widgetEmailsInfo': 'These e-mails always go out when a customer books through the widget. You can change the subject, opening and closing. We add the number, dates, amounts, payment link and bank details ourselves, so they cannot be removed by accident.',
    'notifications.widgetEmailCustom': 'Custom text',
    'notifications.widgetEmailDefault': 'Default text',
    'notifications.widgetEmailEdit': 'Edit text',
    'notifications.widgetEmailCollapse': 'Collapse',
    'notifications.widgetEmailIntro': 'Opening',
    'notifications.widgetEmailOutro': 'Closing',
    'notifications.widgetEmailSystemPart': 'Between the opening and the closing we add:',
    'notifications.widgetEmailReset': 'Restore default text',
    'notifications.widgetEmail.confirm.label': 'Booking confirmation',
    'notifications.widgetEmail.confirm.desc': 'After a booking in the widget. For class booking, after you confirm availability.',
    'notifications.widgetEmail.confirm.system': 'the booking number, dates, amount due and the online payment link or bank details with the payment deadline.',
    'notifications.widgetEmail.request.label': 'Class request received',
    'notifications.widgetEmail.request.desc': 'When the customer picks an equipment class, before you confirm availability.',
    'notifications.widgetEmail.request.system': 'the number and dates, ordered equipment with measurements, estimated value and a note that the customer pays only after confirmation.',
    'notifications.widgetEmail.decline.label': 'Request declined',
    'notifications.widgetEmail.decline.desc': 'When you decline a class request.',
    'notifications.widgetEmail.decline.system': 'the request number and dates, a cancellation note and the message entered when declining.',
    'notifications.widgetEmail.unpaid_reminder.label': 'Payment reminder',
    'notifications.widgetEmail.unpaid_reminder.desc': 'When a booking is unpaid, before automatic cancellation. Also panel bookings with a payment deadline.',
    'notifications.widgetEmail.unpaid_reminder.system': 'the number and dates, amount, a “Pay online” button and when the booking will be cancelled.',
    'notifications.widgetEmail.unpaid_cancel.label': 'Cancelled for non-payment',
    'notifications.widgetEmail.unpaid_cancel.desc': 'When a booking is cancelled because the payment did not arrive.',
    'notifications.widgetEmail.unpaid_cancel.system': 'the number and dates and a note that the booking was cancelled for non-payment.',
    'notifications.varStartDate': 'Pickup date',
    'notifications.willInsert': 'Inserts: {var}',

    // ── P8.1e (1/4): wejscie do aplikacji + poczta ──
    'activation.activationError': 'Error while activating the account.',
    'activation.adminSection': 'Administrator details',
    'activation.adminSectionHint': 'Create an administrator account for your rental business. After activation you will be able to manage staff and equipment.',
    'activation.checkingToken': 'Checking the activation token...',
    'activation.connectionErrorLater': 'Connection error. Please try again later.',
    'activation.connectionErrorRetry': 'Connection error. Please try again.',
    'activation.email': 'Email (login) *',
    'activation.emailHint': 'This email will be your login to the system',
    'activation.emailInvalid': 'Invalid email format',
    'activation.emailRequired': 'Email is required',
    'activation.firstname': 'First name *',
    'activation.firstnameRequired': 'First name is required',
    'activation.footer': 'After activation you will be able to sign in and manage your rental business.',
    'activation.termsBefore': 'I accept the',
    'activation.termsLink': 'Terms of Service',
    'activation.termsAfter': ' (document in Polish).',
    'activation.termsRequired': 'Accept the Terms of Service to activate the account.',
    'activation.demoDataNote': 'The demo account is for trying the system on sample data. Do not enter data of real customers.',
    'activation.goToLogin': 'Go to sign-in',
    'activation.invalidLinkBody': 'The activation link may have expired or has already been used.',
    'activation.invalidLinkTitle': 'Invalid link',
    'activation.invalidToken': 'The activation token is invalid or has expired.',
    'activation.lastname': 'Last name *',
    'activation.lastnameRequired': 'Last name is required',
    'activation.password': 'Password *',
    'activation.passwordConfirm': 'Confirm password *',
    'activation.passwordMin8': 'The password must be at least 8 characters long',
    'activation.passwordMax128': 'The password can be at most 128 characters long',
    'activation.passwordTooWeak': 'The password is too weak. Make it longer or add a few words.',
    'activation.passwordStrength': 'Password strength',
    'activation.passwordRequirements': 'Requirements',
    'activation.reqLength': 'At least {min} characters',
    'activation.reqStrength': 'Strength at least “{strength}”',
    'activation.reqMatch': 'Both passwords match',
    'activation.passwordTip': 'The easiest strong password: a few unrelated words or a short sentence. Swapping letters for digits (e.g. "a" for "4") adds little.',
    'activation.passwordMismatch': 'The passwords do not match',
    'activation.passwordRequired': 'Password is required',
    'activation.phEmail': 'john@rental.com',
    'activation.phFirstname': 'John',
    'activation.phLastname': 'Smith',
    'activation.phone': 'Phone *',
    'activation.phoneDigits': 'The phone number must have 9 digits',
    'activation.phoneRequired': 'Phone number is required',
    'activation.redirecting': 'You will be redirected to the sign-in page shortly...',
    'activation.rentalLabel': 'Rental business:',
    'activation.submit': 'Activate account',
    'activation.submitting': 'Activating...',
    'activation.successAfter': ' has been activated successfully.',
    'activation.successBefore': 'Your rental business',
    'activation.successTitle': 'Account activated!',
    'activation.title': 'Account activation',
    'emailSettings.bccHelp': 'Every offer sent will be copied to this address.',
    'emailSettings.bccLabel': 'BCC - blind copy (optional)',
    'emailSettings.bccPlaceholder': 'e.g. archive@yourcompany.com',
    'emailSettings.connectionError': 'Connection error',
    'emailSettings.deleteConfig': 'Delete configuration',
    'emailSettings.deleteConfirmBody': 'Offers will be sent from the default system address.',
    'emailSettings.deleteConfirmTitle': 'Delete the email configuration?',
    'emailSettings.deleting': 'Deleting...',
    'emailSettings.demoNotice': 'Demo mode - configuring your own SMTP is not available.',
    'emailSettings.premiumTitle': 'Your own mail server is part of the Premium plan.',
    'emailSettings.premiumBody': 'On the Basic plan, e-mails to your customers are sent from the.rENT address, signed with the name of your rental company, and replies go to the e-mail in Company details.',
    'emailSettings.premiumSavedNote': 'The saved configuration stays and starts working again after switching to Premium. You can also delete it.',
    'emailSettings.superAdminNotPremium': 'Your company is not on the Premium plan. As a super admin you can save and test the configuration, but e-mails to customers are sent from the.rENT address until the company switches to Premium.',
    'emailSettings.emailExamplePlaceholder': 'e.g. offers@yourcompany.com',
    'emailSettings.enableHelp': 'When disabled, offers are sent from the default system address.',
    'emailSettings.enableLabel': 'Enable your own email',
    'emailSettings.fromEmailLabel': 'Sender email *',
    'emailSettings.fromNameLabel': 'Sender name *',
    'emailSettings.fromNamePlaceholder': 'e.g. XYZ Ski Rental',
    'emailSettings.gmailStep1': 'Sign in to the Google account you want to send mail from',
    'emailSettings.gmailStep2': 'Go to',
    'emailSettings.gmailStep3a': 'Enable',
    'emailSettings.gmailStep3b': 'two-step verification',
    'emailSettings.gmailStep3c': '(if you do not have it yet)',
    'emailSettings.gmailStep4': 'After enabling 2FA, go to',
    'emailSettings.gmailStep5a': 'In the "App name" field type e.g.',
    'emailSettings.gmailStep5b': 'and click',
    'emailSettings.gmailStep5c': 'Create',
    'emailSettings.gmailStep6a': 'Google will generate a',
    'emailSettings.gmailStep6b': '16-letter password',
    'emailSettings.gmailStep6c': '- copy it',
    'emailSettings.gmailStep7': 'Come back here and fill in the form:',
    'emailSettings.gmailTitle': 'Gmail setup - step by step',
    'emailSettings.gmailWarning': 'Gmail requires the "Sender email" field to be the same as the SMTP login. If you want to send from a different address, add it as an alias in Gmail → Settings → See all settings → Accounts and Import → Send mail as → "Add another email address".',
    'emailSettings.helpBody': 'Once you configure your own SMTP server, every offer and notification sent from the.rENT will go out from your email address. The client receives a message with your name and address - it looks professional and builds trust.',
    'emailSettings.helpTitle': 'How does it work?',
    'emailSettings.hostLabel': 'SMTP host *',
    'emailSettings.hostPlaceholder': 'e.g. smtp.gmail.com',
    'emailSettings.importantLabel': 'Important:',
    'emailSettings.loginLabel': 'SMTP login *',
    'emailSettings.otherServersBody': 'If you use a hosting provider (e.g. nazwa.pl, OVH) or a service such as Mailgun, SendGrid or Amazon SES - enter the SMTP details supplied by that provider. On those servers the "Sender email" field works without restrictions.',
    'emailSettings.otherServersTitle': 'Other SMTP servers',
    'emailSettings.passwordEnter': 'Enter password',
    'emailSettings.passwordHelp': 'Leave empty if you do not want to change the password.',
    'emailSettings.passwordKeep': '(unchanged - leave empty)',
    'emailSettings.passwordLabel': 'SMTP password *',
    'emailSettings.port25': '25 (no encryption)',
    'emailSettings.port2525': '2525 (alternative)',
    'emailSettings.port587': '587 (STARTTLS - recommended)',
    'emailSettings.replyToHelp': 'If a client replies to an offer, the message will go to this address.',
    'emailSettings.replyToLabel': 'Reply-To (optional)',
    'emailSettings.replyToPlaceholder': 'Reply address',
    'emailSettings.save': 'Save settings',
    'emailSettings.saveError': 'Save error',
    'emailSettings.saved': 'Settings saved successfully!',
    'emailSettings.sendErrorCause.auth': 'wrong login or password',
    'emailSettings.sendErrorCause.connect': 'could not connect to the server',
    'emailSettings.sendErrorCause.connectionLost': 'the server dropped the connection',
    'emailSettings.sendErrorCause.dns': 'no server found under this name',
    'emailSettings.sendErrorCause.other': 'mail server error',
    'emailSettings.sendErrorCause.rejected': 'the server rejected the message',
    'emailSettings.sendErrorCause.sender': 'the server did not accept the sender address',
    'emailSettings.sendErrorCause.timeout': 'the server stopped responding',
    'emailSettings.sendErrorCause.tls': 'could not set up an encrypted connection (check the SSL setting, the port and the server certificate)',
    'emailSettings.sendErrorFallback': 'We sent the email from the the.rENT address with the name of your rental, and replies will go to your address.',
    'emailSettings.sendErrorFix': 'Check the mail server settings, save them and send a test. This message disappears after you save the settings or after the first successful send.',
    'emailSettings.sendErrorOpen': 'Open Email settings',
    'emailSettings.sendErrorNoFallback': 'The email may not have reached the customer. We did not send it a second time, because the server may have already accepted it.',
    'emailSettings.sendErrorTitle': 'The last email did not go out through your mail server.',
    'emailSettings.sendErrorWhen': '{czas}: {przyczyna}.',
    'emailSettings.senderLabel': 'Sender:',
    'emailSettings.senderSubtitle': 'These details will be visible as the sender in the offers you send.',
    'emailSettings.senderTitle': 'Sender details',
    'emailSettings.smtpSubtitle': 'Enter your outgoing mail server details. Pick a preset or type them in manually.',
    'emailSettings.smtpTitle': 'SMTP server',
    'emailSettings.sslHelp': 'Enable for port 465. Port 587 usually uses STARTTLS (disabled).',
    'emailSettings.sslLabel': 'SSL connection',
    'emailSettings.statusTitle': 'Configuration status',
    'emailSettings.subtitle': 'Set up your own email address for sending offers and notifications',
    'emailSettings.tblFrom': 'Sender email',
    'emailSettings.tblFromValue': 'The same address as the SMTP login',
    'emailSettings.tblHost': 'SMTP host',
    'emailSettings.tblLogin': 'SMTP login',
    'emailSettings.tblLoginValue': 'Your Gmail address (e.g. john@gmail.com)',
    'emailSettings.tblPassword': 'SMTP password',
    'emailSettings.tblPasswordValue': 'The 16-letter password from step 6 (without spaces)',
    'emailSettings.tblPort': 'Port',
    'emailSettings.tblPortValue': '587 (STARTTLS)',
    'emailSettings.tblSsl': 'SSL connection',
    'emailSettings.tblSslValue': 'Disabled',
    'emailSettings.testFailed': 'Test failed',
    'emailSettings.testRecipientLabel': 'Recipient email address',
    'emailSettings.testRecipientPlaceholder': 'e.g. john@example.com',
    'emailSettings.testSend': 'Send test',
    'emailSettings.testSubtitle': 'Check that the SMTP configuration works by sending a message to an address of your choice.',
    'emailSettings.testTitle': 'Send a test email',
    'emailSettings.testing': 'Sending...',
    'emailSettings.title': 'Email settings',
    'emailSettings.unverified': 'Not verified',
    'emailSettings.verified': 'Verified',
    'resetPassword.backToLogin': 'Back to sign-in',
    'resetPassword.checkingLink': 'Checking the link...',
    'resetPassword.confirmPlaceholder': 'Confirm password',
    'resetPassword.connectionErrorLater': 'Connection error. Please try again later.',
    'resetPassword.connectionErrorRetry': 'Connection error. Please try again.',
    'resetPassword.defaultUserName': 'there',
    'resetPassword.greetingAfter': ', set a new password for your account.',
    'resetPassword.greetingBefore': 'Hello',
    'resetPassword.invalidLink': 'The password reset link is invalid or has expired.',
    'resetPassword.invalidLinkTitle': 'Invalid link',
    'resetPassword.mismatch': 'The passwords do not match.',
    'resetPassword.mismatchInline': 'The passwords do not match',
    'resetPassword.newPasswordPlaceholder': 'New password (min. 8 characters)',
    'resetPassword.pleaseWait': 'Please wait...',
    'resetPassword.redirecting': 'You will be redirected to sign-in shortly...',
    'resetPassword.resetError': 'Error while resetting the password.',
    'resetPassword.strengthAdd': 'Add: {list}',
    'resetPassword.strengthCase': 'Upper and lower case letters',
    'resetPassword.strengthDigits': 'Digits',
    'resetPassword.strengthGood': 'Good',
    'resetPassword.strengthMedium': 'Medium',
    'resetPassword.strengthMin8': 'At least 8 characters',
    'resetPassword.strengthSpecial': 'Special characters',
    'resetPassword.strengthStrong': 'Strong password!',
    'resetPassword.strengthVeryGood': 'Very good',
    'resetPassword.strengthWeak': 'Weak',
    'resetPassword.submit': 'Change password',
    'resetPassword.submitting': 'Resetting...',
    'resetPassword.successBody': 'You can now sign in using your new password.',
    'resetPassword.successTitle': 'Your password has been changed!',
    'resetPassword.title': 'Password reset',
    'resetPassword.tooShort': 'The password must be at least 8 characters long.',
    'twoFactor.attemptsLeft': 'Attempts left: {count}.',
    'twoFactor.backToTotp': 'Back to the TOTP code',
    'twoFactor.backupHint': 'Enter one of your backup codes (format: XXXX-XXXX).',
    'twoFactor.cancelLogin': 'Cancel sign-in',
    'twoFactor.loggingIn': 'Signing in...',
    'twoFactor.loginWithBackup': 'Sign in with a backup code',
    'twoFactor.title': 'Two-factor verification',
    'twoFactor.totpHint': 'Enter the 6-digit code from your authenticator app (Google Authenticator, Authy, etc.)',
    'twoFactor.useBackupCode': 'Use a backup code',
    'twoFactor.verify': 'Verify',
    'twoFactor.verifying': 'Verifying...',
    'twoFactor.wrongBackupCode': 'Invalid backup code.',
    'twoFactor.wrongCode': 'Incorrect verification code.',

    // ── P8.1d: i18n Magazynu (konfigurator, tabela, presety, opisy pol) ──
    'inventory.deleteError': 'An error occurred while deleting {name}: {msg}',
    'inventory.deleteFailed': 'Cannot delete equipment {name}.',
    'inventory.deleteGenericError': 'Error while deleting equipment.',
    'inventory.deleteHasRefs': 'Cannot delete equipment {name} because it is assigned to existing reservations or other references in the database. To delete it, first remove or detach this equipment from the reservations.',
    'inventory.deleteNotFound': 'Equipment {name} was not found (it may have been deleted already).',
    'inventoryFields.bail.desc': 'Deposit charged for the equipment',
    'inventoryFields.bail.descAlt': 'Deposit',
    'inventoryFields.barcode.desc': 'Barcode or QR code',
    'inventoryFields.brand.desc': 'Manufacturer brand',
    'inventoryFields.brand.descAlt': 'Manufacturer',
    'inventoryFields.category.desc': 'Equipment type (e.g. Skis, Boots)',
    'inventoryFields.class.desc': 'Quality class (e.g. Standard, Premium)',
    'inventoryFields.compatibility.desc': 'Compatibility',
    'inventoryFields.condition.desc': 'Technical condition of the equipment',
    'inventoryFields.condition.descAlt': 'Technical condition',
    'inventoryFields.currency.desc': 'Currency',
    'inventoryFields.images.desc': 'Links to photos',
    'inventoryFields.images.descAlt': 'Photo addresses (URL)',
    'inventoryFields.inventory_number.desc': 'Unique inventory number',
    'inventoryFields.inventory_number.descAlt': 'Number in the system',
    'inventoryFields.location.desc': 'Location in the warehouse',
    'inventoryFields.maintenanceDate.desc': 'Last service date',
    'inventoryFields.name.desc': 'Model name',
    'inventoryFields.name.descAlt': 'Equipment model name',
    'inventoryFields.price.desc': 'Rental price per day',
    'inventoryFields.price.descAlt': 'Rental price',
    'inventoryFields.price_over_7.desc': 'Price per day for stays over 7 days',
    'inventoryFields.price_over_7.descAlt': 'Price for rentals over 7 days',
    'inventoryFields.purchaseDate.desc': 'Purchase date',
    'inventoryFields.size.desc': 'Equipment size',
    'inventoryFields.size.descAlt': 'Size (e.g. ski length, boot size)',
    'inventoryFields.sizeRange.desc': 'Size range',
    'inventoryFields.sku.desc': 'Internal code or SKU',
    'inventoryFields.sku.descAlt': 'Stock code or SKU',
    'inventoryFields.status.desc': 'Availability status',
    'inventoryFields.supplier.desc': 'Equipment supplier',
    'inventoryFields.tags.desc': 'Tags that make filtering easier',
    'inventoryFields.tags.descAlt': 'Comma separated tags',
    'inventoryFields.typeId.desc': 'Equipment kind',
    'inventoryFields.wearLevel.desc': 'Wear level',
    'inventoryPresets.bikes.desc': 'Bicycle and cycling equipment rental',
    'inventoryPresets.bikes.name': 'Bicycles',
    'inventoryPresets.events.desc': 'Party and event equipment rental',
    'inventoryPresets.events.name': 'Event equipment',
    'inventoryPresets.ski.desc': 'Ski and snowboard equipment rental',
    'inventoryPresets.ski.name': 'Skis and snowboards',
    'inventoryPresets.tools.desc': 'Tool and construction equipment rental',
    'inventoryPresets.tools.name': 'Construction tools',
    'inventoryPresets.vehicles.desc': 'Trailer and vehicle rental',
    'inventoryPresets.vehicles.name': 'Trailers and cars',
    'inventoryPresets.water.desc': 'Water sports equipment rental',
    'inventoryPresets.water.name': 'Kayaks and SUP',
    'inventorySettings.activeCount': '{visible} / {total} active',
    'inventorySettings.addCategory': 'Add category',
    'inventorySettings.addColumn': 'Add column',
    'inventorySettings.addCustomColumn': 'Add a custom column',
    'inventorySettings.alwaysRequired': 'always required',
    'inventorySettings.alwaysRequiredHint': 'Name, Price and Category are always required because without them equipment cannot be saved in the database. You can switch off the remaining fields if your industry does not use them (e.g. a rental without deposits).',
    'inventorySettings.atLeastOneColumn': 'At least one column must be selected.',
    'inventorySettings.autoSaveHint': 'Changes are saved automatically. You can add your own column if it is not in the list below.',
    'inventorySettings.autodetect': 'Auto-detect',
    'inventorySettings.baseFields': 'Base fields',
    'inventorySettings.catAdded': 'Category "{name}" added.',
    'inventorySettings.catNameRequired': 'Enter a category name.',
    'inventorySettings.catSaveFailed': 'Could not save the category.',
    'inventorySettings.catUpdated': '"{name}" updated.',
    'inventorySettings.categoriesSub': 'Manage categories and define the required fields for each of them',
    'inventorySettings.categoriesTitle': 'Equipment categories',
    'inventorySettings.categoryNameLabel': 'Category name',
    'inventorySettings.categoryNamePlaceholder': 'e.g. Alpine skis, Snowboard boots…',
    'inventorySettings.categoryNamePlaceholderShort': 'e.g. Alpine skis…',
    'inventorySettings.colAdded': 'Column "{name}" added.',
    'inventorySettings.colDeleted': 'Column deleted.',
    'inventorySettings.colDescLabel': 'Description (optional)',
    'inventorySettings.colDescPlaceholder': 'A short description of this column…',
    'inventorySettings.colExampleLabel': 'Example value (optional)',
    'inventorySettings.colExamplePlaceholder': 'e.g. 12345, 2026-01-15…',
    'inventorySettings.colExists': 'Column "{name}" already exists.',
    'inventorySettings.colNameLabel': 'Column name *',
    'inventorySettings.colNamePlaceholder': 'e.g. Certificate, Weight, Manufacturer…',
    'inventorySettings.colNameRequired': 'Enter a column name.',
    'inventorySettings.columnsHint': 'Choose which information should be visible in the inventory table',
    'inventorySettings.createCategory': 'Create category',
    'inventorySettings.createFirstCategory': 'Create the first category',
    'inventorySettings.deleteThisColumn': 'Delete this column',
    'inventorySettings.deselectAll': 'Deselect all',
    'inventorySettings.editCategory': 'Editing: {name}',
    'inventorySettings.errorPrefix': 'Error: {msg}',
    'inventorySettings.extraFields': 'Additional fields',
    'inventorySettings.extraFieldsScope': 'Required only for equipment in this category, on top of the fields required across the whole inventory (above). The import does not check them.',
    'inventorySettings.extraRequiredFields': 'Additional required fields',
    'inventorySettings.fetchFailed': 'Could not fetch data from the server.',
    'inventorySettings.fieldType': 'Field type',
    'inventorySettings.groupBasic': 'Basic information',
    'inventorySettings.groupCustom': 'Custom columns',
    'inventorySettings.groupMeta': 'Additional metadata',
    'inventorySettings.groupPricing': 'Prices and deposit',
    'inventorySettings.listValuesLabel': 'List values (comma separated)',
    'inventorySettings.listValuesPlaceholder': 'e.g. New, Used, Needs repair',
    'inventorySettings.loadingFromDb': 'Loading from the database...',
    'inventorySettings.nameMin2': 'The name must be at least 2 characters long.',
    'inventorySettings.nameOnlyInvalidChars': 'The name contains only disallowed characters.',
    'inventorySettings.newCategory': 'New category',
    'inventorySettings.newCategoryTitle': 'New equipment category',
    'inventorySettings.newColumn': 'New column',
    'inventorySettings.noAuthLogin': 'Not authorised - please sign in.',
    'inventorySettings.noCategories': 'No categories',
    'inventorySettings.noCategoriesDesc': 'Create your first equipment category or use auto-detect to find them in existing data in the database.',
    'inventorySettings.noCategory': 'No category',
    'inventorySettings.fieldTypeText': 'Text',
    'inventorySettings.fieldTypeNumber': 'Number',
    'inventorySettings.fieldTypeList': 'List',
    'inventorySettings.additional': 'Additional',
    'inventorySettings.noDataReset': 'No data - settings were reset.',
    'inventorySettings.noEquipmentKeptCats': 'No equipment; categories kept.',
    'inventorySettings.none': 'None',
    'inventorySettings.processing': 'Processing...',
    'inventorySettings.requiredCount': '{count} required',
    'inventorySettings.requiredHint': 'Applies to the add-equipment form and the import template: a required field gets an asterisk in the .xlsx file',
    'inventorySettings.requiredTitle': 'Required fields',
    'inventorySettings.restoreDefaults': 'Restore defaults',
    'inventorySettings.saveChanges': 'Save changes',
    'inventorySettings.saveServerFailed': 'Could not save on the server (changes are local only).',
    'inventorySettings.saving': 'Saving…',
    'inventorySettings.selectAll': 'Select all',
    'inventorySettings.subtitle': 'Visible columns, required fields and equipment categories',
    'inventorySettings.syncedWithDb': 'Synced with the database.',
    'inventorySettings.visibleColumns': 'Visible columns',
    'paperSheet.fitPage': 'Whole page',
    'paperSheet.zoomGroup': 'Preview zoom',
    'builderChrome.closeWithEsc': 'Close (Esc)',
  },
  de: {
    // Preferences (niemieckie tłumaczenia)
    'preferences.theme.system': 'System',

    'addEquipment.saving': 'Speichern...',
    'addEquipment.quantity': 'Anzahl der Stücke',
    'addEquipment.quantityLess': 'Weniger Stücke',
    'addEquipment.quantityMore': 'Mehr Stücke',
    'addEquipment.quantityHintOne': 'Mehrere gleiche Stücke? Anzahl einstellen und in einem Schritt hinzufügen.',
    'addEquipment.quantityHintMany': 'Jedes der {n} Stücke wird ein eigener Lagerartikel mit eigener Nummer und eigenem Etikett.',
    'addEquipment.quantityNoNumbers': 'Ohne Inventarnummern: Jedes Stück erhält einen eigenen Systemcode für das Etikett.',
    'addEquipment.quantityInvalid': 'Die Anzahl muss eine Zahl von 1 bis {max} sein.',
    'addEquipment.inventoryNumberFirst': 'Nummer des ersten Stücks',
    'addEquipment.barcodePerUnit': 'Bei mehreren Stücken tragen Sie den Herstellercode später für jedes Stück einzeln ein.',
    'addEquipment.saveManyFew': '{n} Stücke hinzufügen',
    'addEquipment.saveManyMany': '{n} Stücke hinzufügen',
    'addEquipment.saveManyOther': '{n} Stücke hinzufügen',
    'addEquipment.savedManyFew': '{n} Stücke hinzugefügt.',
    'addEquipment.savedManyMany': '{n} Stücke hinzugefügt.',
    'addEquipment.savedManyOther': '{n} Stücke hinzugefügt.',
    'addUser.passwordPolicyNotMet': 'Das Passwort erfüllt die Sicherheitsanforderungen nicht',
    'addUser.passwordTooWeak': 'Die Passwortstärke muss mindestens Gut sein',
    'preferences.saveError': 'Einstellungen konnten nicht gespeichert werden.',
    'userDetails.loadError': 'Benutzerdaten konnten nicht geladen werden.',
    'common.saving': 'Speichern...',

    // Profile 
    'profile.title': 'Ihr Konto',
    'profile.subtitle': 'Verwalten Sie Ihr Konto und Ihre Einstellungen',
    'profile.yourData': 'Ihre Daten',
    'profile.description.yourData': 'Bearbeiten Sie Ihre persönlichen Daten und Kontaktinformationen',
    'profile.security': 'Sicherheit',
    'profile.description.security': 'Ändern Sie Ihr Passwort und verwalten Sie die Kontosicherheit',
    'profile.users': 'Benutzer',
    'profile.description.users': 'Verwalten Sie Systembenutzer',
    'profile.preferences': 'Ihre Einstellungen',
    'profile.description.preferences': 'Passen Sie Design und Sprache der Anwendung an',
    'profile.emailSettings': 'E-Mail-Einstellungen',
    'profile.description.emailSettings': 'Konfigurieren Sie Ihre E-Mail-Einstellungen',
    'profile.priceRules': 'Dynamische Preise',
    'profile.ksef': 'KSeF E-Rechnungen',
    'profile.description.ksef': 'Strukturierte Rechnungen an das polnische KSeF-System senden',
    'profile.equipmentBundles': 'Ausrüstungspakete',
    'profile.description.equipmentBundles': 'Ausrüstungssets mit einem gemeinsamen Tagespreis',
    'profile.rentalRules': 'Mietregeln',
    'profile.description.rentalRules': 'Regeln für die Vermietung: Ausrüstungswechsel am selben Tag und bezahlte Tage',
    'pricing.paidDays': '(bezahlt: {days})',
    'rentalRules.title': 'Mietregeln',
    'rentalRules.subtitle': 'Regeln, die für jede Reservierung gelten, im Panel und im Widget.',
    'rentalRules.back': 'Zurück zum Profil',
    'rentalRules.loadError': 'Die Mietregeln konnten nicht geladen werden.',
    'rentalRules.saveError': 'Die Änderung konnte nicht gespeichert werden. Bitte erneut versuchen.',
    'rentalRules.adminOnly': 'Nur ein Administrator der Firma kann die Mietregeln ändern.',
    'rentalRules.on': 'Ein',
    'rentalRules.off': 'Aus',
    'rentalRules.exchange.title': 'Ausrüstungswechsel am selben Tag',
    'rentalRules.exchange.description': 'Ein am Rückgabetag zurückgegebener Artikel kann noch am selben Tag an den nächsten Kunden gehen. Das Panel kennt keine Uhrzeiten, daher musst du selbst darauf achten, ob genug Zeit für die Vorbereitung bleibt.',
    'rentalRules.exchange.offNote': 'Nach dem Ausschalten bleiben bestehende Reservierungen unverändert und lassen sich weiter bearbeiten. Neue Reservierungen und neue Termine müssen dann am Tag nach der Rückgabe beginnen.',
    'rentalRules.paidDays.title': 'Bezahlte Tage',
    'rentalRules.paidDays.description': 'Wie viele Tage bei einer Miete bestimmter Länge berechnet werden. Die Tabelle gilt für die gesamte Ausrüstung, Klassen und Pakete.',
    'rentalRules.paidDays.own': 'Eigene Tabelle',
    'rentalRules.paidDays.defaultRule': 'Jetzt gilt die Standardregel: Bis 7 Tage wird jeder Tag berechnet, 8 Tage zählen wie 7, und eine längere Miete zählt 2 Tage weniger.',
    'rentalRules.paidDays.unsaved': 'Die Tabelle gilt erst nach dem Speichern. Bis dahin gilt die Standardregel.',
    'rentalRules.paidDays.colRental': 'Miete',
    'rentalRules.paidDays.colPaid': 'Bezahlte Tage',
    'rentalRules.paidDays.colExample': 'Bei {rate} zł pro Tag',
    'rentalRules.paidDays.rowOne': '1 Tag',
    'rentalRules.paidDays.rowMany': '{n} Tage',
    'rentalRules.paidDays.inputLabel': 'Bezahlte Tage bei einer Miete von {n} Tagen',
    'rentalRules.paidDays.over14': 'Ab 14 Tagen wird jeder weitere Tag berechnet.',
    'rentalRules.paidDays.over7Rate': 'Bei Mieten über 7 Tage gilt weiterhin der Tagespreis ab dem 8. Tag, wenn Ausrüstung, Klasse oder Paket einen haben.',
    'rentalRules.paidDays.savedReservations': 'Die Tabelle gilt für neue Preisberechnungen. Gespeicherte Reservierungen behalten ihre Beträge.',
    'rentalRules.paidDays.save': 'Tabelle speichern',
    'rentalRules.paidDays.noDiscount': 'Kein Rabatt für längere Mieten',
    'rentalRules.paidDays.reset': 'Standard wiederherstellen',
    'rentalRules.paidDays.saved': 'Tabelle gespeichert.',
    'rentalRules.paidDays.errorNumber': 'Geben Sie die Anzahl der bezahlten Tage ein.',
    'rentalRules.paidDays.errorRange': 'Geben Sie mehr als 0 und höchstens {n} ein.',
    'rentalRules.paidDays.errorDecimals': 'Geben Sie höchstens 2 Nachkommastellen ein.',
    'rentalRules.paidDays.errorOrder': 'Darf nicht kleiner sein als in Zeile {row}.',
    'profile.import': 'Datenimport',
    'profile.description.import': 'Ausrüstung und Kunden aus einer .xlsx-Datei importieren',
    'profile.companyExport': 'Export der Firmendaten',
    'profile.description.companyExport': 'Alle Firmendaten in einer ZIP-Datei',
    'companyExport.title': 'Export der Firmendaten',
    'companyExport.subtitle': 'Alle Firmendaten in einer ZIP-Datei, zum Aufbewahren oder für ein anderes Programm',
    'companyExport.contentsTitle': 'Was die Datei enthält',
    'companyExport.item.data': 'Kunden, Reservierungen mit ausgegebener Ausrüstung, Ausrüstung, Zahlungen, Rechnungen mit Positionen, Angebote und gesendete Benachrichtigungen, als CSV (öffnet in Excel) und JSON',
    'companyExport.item.invoicesPdf': 'Ein PDF jeder Rechnung',
    'companyExport.item.photos': 'Zustandsfotos der Ausrüstung von Ausgabe und Rückgabe, in einem eigenen Ordner',
    'companyExport.item.settings': 'Firmeneinstellungen: Vertrags- und Angebotsvorlagen (auch eine hochgeladene .docx-Vorlage), Lagerfelder, Gerätetypen und Geräteklassen, Preisregeln, Pakete und Mitarbeiterkonten (ohne Passwörter)',
    'companyExport.item.readme': 'Eine Datei CZYTAJ-MNIE.txt mit der Beschreibung des Inhalts',
    'companyExport.howTitle': 'So funktioniert es',
    'companyExport.how.time': 'Die Vorbereitung dauert von einigen Sekunden bis über zehn Minuten, je nach Anzahl der Fotos und Rechnungen. Den Fortschritt sehen Sie in der Download-Liste des Browsers, und im Panel können Sie währenddessen weiterarbeiten.',
    'companyExport.how.limit': 'Den Export können Sie höchstens 5 Mal pro Tag herunterladen.',
    'companyExport.how.paused': 'Das Konto ist pausiert, und der Export funktioniert wie gewohnt.',
    'companyExport.privacy': 'Die Datei enthält personenbezogene Daten Ihrer Kunden. Bewahren Sie sie sicher auf und geben Sie sie nicht ohne Grund weiter.',
    'companyExport.adminOnly': 'Nur ein Administrator kann den Export der Firmendaten herunterladen.',
    'companyExport.download': 'Export herunterladen (ZIP)',
    'companyExport.preparing': 'Datei wird vorbereitet',
    'companyExport.started': 'Der Download hat begonnen. Die Datei eksport-firmy mit dem heutigen Datum finden Sie in den Downloads des Browsers. Wenn der Browser einen fehlgeschlagenen Download meldet oder die Datei kein ZIP-Archiv ist, klicken Sie erneut auf „Export herunterladen“.',
    'companyExport.error.inProgress': 'Ein Export dieser Firma läuft bereits. Warten Sie, bis die Datei heruntergeladen ist.',
    'companyExport.error.busy': 'Der Server bereitet gerade andere Exporte vor. Versuchen Sie es in einigen Minuten erneut.',
    'companyExport.error.limit': 'Der Export kann höchstens 5 Mal pro Tag heruntergeladen werden. Versuchen Sie es später erneut.',
    'companyExport.error.generic': 'Der Export konnte nicht gestartet werden. Versuchen Sie es gleich noch einmal.',
    'onboarding.title': 'Erste Schritte',
    'onboarding.subtitle': 'Vervollständige diese Punkte, um das System optimal zu nutzen',
    'onboarding.progress': '{done} von {total} erledigt',
    'onboarding.dismiss': 'Dauerhaft ausblenden',
    'onboarding.step.companyData': 'Firmendaten ausfüllen',
    'onboarding.step.companyData.cta': 'Firmendaten ausfüllen',
    'onboarding.step.equipment': 'Erste Ausrüstung hinzufügen',
    'onboarding.step.equipment.cta': 'Ausrüstung hinzufügen',
    'onboarding.step.equipment.importCta': 'Aus Datei importieren',
    'onboarding.step.client': 'Ersten Kunden hinzufügen',
    'onboarding.step.client.cta': 'Kunde hinzufügen',
    'onboarding.step.client.importCta': 'Aus Datei importieren',
    'onboarding.step.inventoryFields': 'Lagerfelder konfigurieren',
    'onboarding.step.inventoryFields.cta': 'Feldset wählen',
    'onboarding.step.reservation': 'Erste Reservierung erstellen',
    'onboarding.step.reservation.cta': 'Reservierung hinzufügen',
    'inventory.emptyState.hint': 'Hier erscheint deine Ausrüstung - füge sie manuell hinzu oder importiere sie aus einer Datei.',
    'clients.emptyState.hint': 'Hier erscheinen deine Kunden - füge den ersten manuell hinzu oder importiere eine Liste aus einer Datei.',
    'calendar.emptyState.noReservationsAtAll': 'Du hast noch keine Reservierungen',
    'calendar.emptyState.noReservationsAtAllHint': 'Hier erscheint dein Vermietungskalender - füge deine erste Reservierung hinzu, um zu starten.',
    'calendar.emptyState.addReservation': 'Reservierung hinzufügen',
    'inventory.importFromFile': 'Aus Datei importieren',
    'clients.importFromFile': 'Aus Datei importieren',
    'import.title': 'Datenimport',
    'import.subtitle': 'Wählen Sie, was Sie aus einer .xlsx-Datei importieren möchten',
    'import.entity.equipment': 'Ausrüstung',
    'import.entity.clients': 'Kunden',
    'import.entity.equipment.description': 'Lagerartikel mit Preis, Größe und Inventarnummer.',
    'import.entity.clients.description': 'Kontaktdaten Ihrer Mieter, auch Firmen mit USt-IdNr.',
    'import.changeEntity': 'Datentyp ändern',
    'import.stepperLabel': 'Import-Schritte',
    'import.step.template': 'Vorlage',
    'import.step.file': 'Datei',
    'import.step.review': 'Vorschau',
    'import.step1.title': 'Vorlage herunterladen',
    'import.step1.description': 'Die Vorlage enthält die fertigen Spaltenüberschriften, damit Ihre Datei korrekt eingelesen wird.',
    'import.step1.bullet.columns': 'Spalten in der Reihenfolge, die das System erwartet.',
    'import.step1.bullet.values.equipment': 'Die Typen und Klassen Ihrer Organisation, als Auswahlliste hinterlegt.',
    'import.step1.bullet.values.clients': 'Kontakt- und Firmenfelder getrennt aufgeführt, ohne Rätselraten beim Format.',
    'import.step1.bullet.reuse': 'In Excel oder Google Tabellen öffnen, ausfüllen und hierher zurückkehren.',
    'import.step1.downloaded': 'Vorlage heruntergeladen. Füllen Sie sie aus und kehren Sie zu Schritt 2 zurück.',
    'import.step1.configNote': 'Die Spalten der Vorlage ergeben sich aus den Lagereinstellungen Ihrer Organisation. Konfigurieren Sie die Ausrüstungsfelder, BEVOR Sie die Vorlage herunterladen, denn später ergänzte Spalten erfordern einen erneuten Download.',
    'import.step1.configLink': 'Zu den Lagerfeld-Einstellungen',
    'import.downloadTemplate': 'Vorlage herunterladen',
    'import.downloading': 'Wird heruntergeladen…',
    'import.downloadError': 'Vorlage konnte nicht heruntergeladen werden.',
    'import.next': 'Weiter',
    'import.back': 'Zurück',
    'import.step2.title': 'Ausgefüllte Datei hochladen',
    'import.step2.description': 'Wir prüfen die Datei und zeigen Ihnen, was hinzukommt, bevor etwas gespeichert wird.',
    'import.dropzone.title': 'Datei hierher ziehen',
    'import.dropzone.hint': 'oder klicken, um sie auszuwählen',
    'import.file.remove': 'Datei entfernen',
    'import.file.replace': 'Klicken, um eine andere Datei zu wählen',
    'import.fileTypeError': 'Laden Sie eine .xlsx-Datei hoch. Andere Formate werden nicht unterstützt.',
    'import.constraint.format': 'Format .xlsx',
    'import.constraint.size': 'Max. 2 MB',
    'import.constraint.rows': 'Bis zu 5000 Zeilen',
    'import.analyze': 'Datei prüfen',
    'import.analyzing': 'Datei wird analysiert…',
    'import.errorGeneric': 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
    'import.serverBusy': 'Der Server ist gerade ausgelastet. Bitte versuchen Sie es in einigen Sekunden erneut.',
    'import.step3.title': 'Prüfen und bestätigen',
    'import.step3.description': 'Es wurde noch nichts gespeichert. Mit dem Bestätigen werden die Zeilen unten hinzugefügt und aktualisiert.',
    'import.summary.total': 'Zeilen in der Datei',
    'import.summary.toInsert': 'Hinzuzufügen',
    'import.summary.toUpdate': 'Zu aktualisieren',
    'import.summary.invalid': 'Fehlerhaft',
    'import.errors.title': 'Fehlerhafte Zeilen',
    'import.errors.hint': 'Diese Zeilen werden übersprungen. Korrigieren Sie sie in der Datei und laden Sie sie erneut hoch, der Rest wird normal importiert.',
    'import.warnings.title': 'Warnungen',
    'import.warnings.hint': 'Diese Zeilen werden trotzdem importiert. Prüfen Sie, ob die Daten Ihren Erwartungen entsprechen.',
    'import.downloadErrorReport': 'Fehlerbericht herunterladen',
    'import.confirmImport': 'Import bestätigen',
    'import.importing': 'Importiert…',
    'import.checksumMismatch': 'Die Datei hat sich seit der Vorschau geändert - bitte erneut hochladen.',
    'import.rowNumber': 'Zeile',
    'import.result.title': 'Import abgeschlossen',
    'import.result.description.equipment': 'Die Ausrüstung ist im Lager und kann gebucht werden.',
    'import.result.description.clients': 'Die Kunden stehen auf der Liste und können in Reservierungen gewählt werden.',
    'import.result.inserted': 'Hinzugefügt',
    'import.result.updated': 'Aktualisiert',
    'import.result.skipped': 'Übersprungen',
    'import.result.view.equipment': 'Lager ansehen',
    'import.result.view.clients': 'Kunden ansehen',
    'import.result.another': 'Weitere Datei importieren',
    'profile.description.priceRules': 'Preisregeln: Saisons, Wochenenden, Aktionen',
    'profile.widget': 'Widget',
    'profile.description.widget': 'Verwalten Sie das Online-Buchungswidget und seine Einstellungen',
    'profile.widget.premiumOnly': 'Im Premium-Tarif verfügbar',
    'profile.plan.basic': 'Basic-Tarif',
    'profile.plan.premium': 'Premium-Tarif',
    'profile.plan.superadmin': 'Super-Admin',
    'profile.contractSettings': 'Firmendaten',
    'profile.description.contractSettings': 'Informationen und Konfiguration des Unternehmens',
    // Price rules (P7.2)
    'priceRules.title': 'Dynamische Preise',
    'priceRules.subtitle': 'Kalenderbasierte Preisregeln: Saisons, Wochenenden, Aktionen',
    'priceRules.newRule': 'Neue Regel',
    'priceRules.editRule': 'Regel bearbeiten',
    'priceRules.name': 'Name',
    'priceRules.namePlaceholder': 'z.B. Wochenende +15%',
    'priceRules.active': 'Aktiv',
    'priceRules.dateFrom': 'Datum von',
    'priceRules.dateTo': 'Datum bis',
    'priceRules.dateHint': 'Leer lassen für eine Regel ohne Datumsbeschränkung',
    'priceRules.weekdays': 'Wochentage',
    'priceRules.weekdaysHint': 'Leer lassen für eine Regel, die jeden Tag gilt',
    'priceRules.weekday.1': 'Mo',
    'priceRules.weekday.2': 'Di',
    'priceRules.weekday.3': 'Mi',
    'priceRules.weekday.4': 'Do',
    'priceRules.weekday.5': 'Fr',
    'priceRules.weekday.6': 'Sa',
    'priceRules.weekday.7': 'So',
    'priceRules.class': 'Geräteklasse',
    'priceRules.anyClass': 'Beliebige Klasse',
    'priceRules.type': 'Gerätetyp',
    'priceRules.anyType': 'Beliebiger Typ',
    'priceRules.adjustmentType': 'Art der Anpassung',
    'priceRules.percent': 'Prozent (%)',
    'priceRules.fixed': 'Festpreis (pro Tag)',
    'priceRules.adjustmentValue': 'Wert',
    'priceRules.adjustmentValueHint': 'Prozent kann negativ sein (eine Aktion)',
    'priceRules.priority': 'Priorität',
    'priceRules.priorityHint': 'Höhere Priorität gewinnt bei sich überschneidenden Regeln',
    'priceSuggestions.title': 'Preisvorschläge',
    'priceSuggestions.hint': 'Berechnet aus der Geräteauslastung der letzten 90 Tage. Übernehmen öffnet das Regelformular zur Bearbeitung vor dem Speichern.',
    'priceSuggestions.accept': 'Übernehmen',
    'priceSuggestions.dismiss': 'Verwerfen',
    'priceSuggestions.reasonHigh': 'Hohe Auslastung',
    'priceSuggestions.reasonLow': 'Geringe Auslastung',
    'priceSuggestions.utilization': 'Auslastung',
    'equipmentBundles.title': 'Ausrüstungspakete',
    'equipmentBundles.subtitle': 'Sets von Gerätetypen mit einem gemeinsamen Tagespreis - ein komplettes Set erhält den Paketpreis',
    'equipmentBundles.newBundle': 'Neues Set',
    'equipmentBundles.editBundle': 'Set bearbeiten',
    'equipmentBundles.name': 'Name',
    'equipmentBundles.namePlaceholder': 'z.B. Basispaket',
    'equipmentBundles.dailyPrice': 'Paketpreis / Tag',
    'equipmentBundles.dailyPriceHint': 'Ersetzt die Summe der Tarife der enthaltenen Geräte',
    'equipmentBundles.types': 'Gerätetypen im Set',
    'equipmentBundles.typesHint': 'Mindestens 2 Typen wählen - eine Reservierung mit dem kompletten Set erhält den Paketpreis',
    'equipmentBundles.noTypes': 'Sie haben noch keine Gerätetypen. Legen Sie sie unter Lager → Feldeinstellungen an, um ein Set zu erstellen.',
    'equipmentBundles.nameRequired': 'Name ist erforderlich',
    'equipmentBundles.priceRequired': 'Geben Sie einen nicht negativen Tagespreis an',
    'equipmentBundles.typesRequired': 'Ein Set benötigt mindestens 2 Gerätetypen',
    'equipmentBundles.save': 'Speichern',
    'equipmentBundles.cancel': 'Abbrechen',
    'equipmentBundles.edit': 'Bearbeiten',
    'equipmentBundles.delete': 'Löschen',
    'equipmentBundles.deleteConfirm': 'Möchten Sie dieses Set wirklich löschen?',
    'equipmentBundles.loadError': 'Sets konnten nicht geladen werden',
    'equipmentBundles.saveError': 'Set konnte nicht gespeichert werden',
    'equipmentBundles.deleteError': 'Set konnte nicht gelöscht werden',
    'equipmentBundles.empty': 'Noch keine Ausrüstungspakete',
    'equipmentBundles.emptyHint': 'Fügen Sie Ihr erstes Set hinzu, z.B. Geräte mit Zubehör zu einem gemeinsamen Tagespreis.',
    'equipmentBundles.columnTypes': 'Typen im Set',
    'equipmentBundles.columnPrice': 'Preis / Tag',
    'equipmentBundles.columnActions': 'Aktionen',
    'equipmentBundles.columnActive': 'Status',
    'equipmentBundles.toggleOn': 'Aktiv',
    'equipmentBundles.toggleOff': 'Inaktiv',
    'equipmentBundles.toggleAria': 'Set {name} aktivieren oder deaktivieren',
    'equipmentBundles.toggleError': 'Der Status des Sets konnte nicht geändert werden',
    'equipmentBundles.toggleNeedsTypes': 'Das Set hat weniger als 2 Typen. Ergänzen Sie es in der Bearbeitung, bevor Sie den Status ändern',
    'equipmentBundles.presets.title': 'Schnelle Sets',
    'equipmentBundles.presets.hint': 'Geräte, die Ihre Kunden am häufigsten zusammen mieten (letzte 12 Monate). Ein Klick füllt das Formular aus und speichert noch nichts.',
    'equipmentBundles.presets.timesRented': 'Zusammen gemietet: {count}×',
    'equipmentBundles.presets.priceLine': '{price} zł/Tag statt ~{sum} zł (−{pct}%)',
    'equipmentBundles.presets.noPrice': 'Keine Gerätepreise für einen Vorschlag vorhanden. Den Preis geben Sie im Formular an',
    'equipmentBundles.presets.useAria': 'Formular mit dem Set {name} ausfüllen',
    'priceRules.save': 'Speichern',
    'priceRules.cancel': 'Abbrechen',
    'priceRules.edit': 'Bearbeiten',
    'priceRules.delete': 'Löschen',
    'priceRules.deleteConfirm': 'Möchten Sie diese Regel wirklich löschen?',
    'priceRules.empty': 'Noch keine Preisregeln',
    'priceRules.emptyHint': 'Fügen Sie Ihre erste Regel hinzu, z.B. einen Wochenendzuschlag oder eine Aktion für selten genutzte Geräte.',
    'priceRules.nameRequired': 'Name ist erforderlich',
    'priceRules.valueRequired': 'Geben Sie den Anpassungswert ein',
    'priceRules.percentTooLow': 'Ein prozentualer Rabatt darf 100 % nicht überschreiten.',
    'priceRules.dateRangeInvalid': 'Das "Von"-Datum darf nicht nach dem "Bis"-Datum liegen',
    'priceRules.saveError': 'Regel konnte nicht gespeichert werden',
    'priceRules.loadError': 'Preisregeln konnten nicht geladen werden',
    'priceRules.deleteError': 'Regel konnte nicht gelöscht werden',
    'priceRules.columnDateRange': 'Datumsbereich',
    'priceRules.columnWeekdays': 'Wochentage',
    'priceRules.columnScope': 'Gerätebereich',
    'priceRules.columnAdjustment': 'Anpassung',
    'priceRules.columnPriority': 'Priorität',
    'priceRules.columnActions': 'Aktionen',
    'priceRules.allDates': 'Immer',
    'priceRules.allDays': 'Jeden Tag',
    'priceRules.presets.title': 'Schnelle Regeln',
    'priceRules.presets.hint': 'Aktivieren Sie eine typische Regel mit einem Schalter und wählen Sie den Prozentsatz per Chip oder geben Sie im Feld daneben einen eigenen ein. Das Ausschalten löscht die Regel nicht, sie bleibt als inaktiv in der Tabelle.',
    'priceRules.presets.badge': 'Schnelle Regel',
    'priceRules.presets.inactive': '(inaktiv)',
    'priceRules.presets.saveError': 'Die schnelle Regel konnte nicht gespeichert werden',
    'priceRules.presets.toggleAria': 'Voreinstellung umschalten: {name}',
    'priceRules.presets.chipsAria': 'Prozentwert der Voreinstellung {name}',
    'priceRules.presets.chipAria': '{name}: {value} einstellen',
    'priceRules.presets.customPlaceholder': 'eigener',
    'priceRules.presets.customAria': '{name}: eigener Prozentwert',
    'priceRules.presets.customInvalid': 'Geben Sie eine Zahl ein, z. B. 12 oder 12,5.',
    'priceRules.presets.customRange': 'Geben Sie einen Prozentwert von 0,01 bis {max} ein.',
    'priceRules.presets.weekend.label': 'Wochenendzuschlag',
    'priceRules.presets.weekend.on': 'Aktiv: {value} samstags und sonntags',
    'priceRules.presets.weekend.off': 'Inaktiv, samstags und sonntags ohne Zuschlag',
    'priceRules.presets.season_high.label': 'Hochsaison',
    'priceRules.presets.season_high.on': 'Aktiv: {value}',
    'priceRules.presets.season_high.off': 'Inaktiv, kein Hochsaison-Zuschlag',
    'priceRules.presets.offseason_promo.label': 'Nebensaison-Aktion',
    'priceRules.presets.offseason_promo.on': 'Aktiv: {value}',
    'priceRules.presets.offseason_promo.off': 'Inaktiv, außerhalb der Saison gelten Standardpreise',
    'priceRules.presets.onWithRange': 'Aktiv: {value} vom {range}',
    'priceRules.presets.dateFromAria': 'Beginn der Saison für Voreinstellung {name}',
    'priceRules.presets.dateToAria': 'Ende der Saison für Voreinstellung {name}',
    'priceRules.presets.dateRangeRequired': 'Legen Sie einen Datumsbereich fest, bevor Sie diese Voreinstellung aktivieren',
    // E.4: Branchen-Presets für das Lager
    'inventoryPresets.cardTitle': 'Startset für deine Branche',
    'inventoryPresets.cardSub': 'Wähle deine Branche, prüfe, was das Set einrichtet, und wende es mit einem Klick an. Danach kannst du alles ändern.',
    'inventoryPresets.tileMeta': 'Typen: {types} · Felder: {fields}',
    'inventoryPresets.reviewTitle': 'Das Set „{name}“ richtet ein:',
    'inventoryPresets.reviewTypes': 'Gerätetypen',
    'inventoryPresets.reviewTypesHint': 'Angehakte Typen existieren nach dem Anwenden. Entferne die Haken bei allem, was du nicht vermietest.',
    'inventoryPresets.reviewLeftoverHint': 'Durchgestrichene stammen aus dem vorherigen Set, daher entfernen wir sie. Hake an, damit sie bleiben.',
    'inventoryPresets.leftoverTag': 'aus dem vorherigen Set',
    'inventoryPresets.reviewFields': 'Lagerfelder',
    'inventoryPresets.reviewNewFields': 'Neue Felder:',
    'inventoryPresets.applyCta': 'Set anwenden',
    'inventoryPresets.applying': 'Wird angewendet…',
    'inventoryPresets.applyNote': 'Legt Gerätetypen an ({types}) und richtet Lagerfelder ein ({fields}).',
    'inventoryPresets.applyNoteWithRemoval': 'Legt Gerätetypen an ({types}), entfernt ({removed}) und richtet Lagerfelder ein ({fields}).',
    'inventoryPresets.confirmReplace': 'Aktuelle Feldkonfiguration ersetzen?',
    'inventoryPresets.confirmReplaceBody': 'Das Set „{name}“ überschreibt deine Lagerfelder. Gerätetypen kommen nur hinzu, nichts wird entfernt.',
    'inventoryPresets.confirmReplaceBodyWithRemoval': 'Das Set „{name}“ überschreibt deine Lagerfelder und entfernt die Typen aus dem vorherigen Set: {removed}. Ein Typ, den Geräte, eine Preisregel oder ein Paket nutzen, bleibt.',
    'inventorySettings.confirmResetDefaults': 'Möchten Sie die Standardeinstellungen wirklich wiederherstellen?',
    'inventorySettings.confirmResetDefaultsBody': 'Spalten und Pflichtfelder kehren zu den Standardwerten zurück und das Branchen-Startset erscheint wieder.',
    'inventorySettings.confirmResetDefaultsBodyWithCategories': 'Spalten und Pflichtfelder kehren zu den Standardwerten zurück und das Branchen-Startset erscheint wieder. Wir löschen AUCH alle Gerätekategorien ({count}), einschließlich der selbst angelegten. Es bleiben nur die, die von Geräten, einer Preisregel oder einem Paket genutzt werden.',
    'inventorySettings.restoringDefaults': 'Wird wiederhergestellt…',
    'inventorySettings.resetDefaultsKept': 'Standardeinstellungen wiederhergestellt. Diese Kategorien blieben, weil sie genutzt werden: {names}.',
    'inventorySettings.resetDefaultsPartial': 'Einstellungen wiederhergestellt, aber nicht alle Kategorien konnten gelöscht werden. Lade die Seite neu und versuche es erneut.',
    'inventorySettings.confirmDeleteCategory': 'Kategorie „{name}“ löschen?',
    'inventorySettings.confirmDeleteCategoryBody': 'Sie verschwindet aus dem Formular zum Hinzufügen von Geräten und aus der Importvorlage. Wird sie von Geräten, einer Preisregel oder einem Paket genutzt, entfernen wir sie nicht.',
    'inventorySettings.catDeleted': 'Kategorie „{name}“ gelöscht.',
    'inventorySettings.catInUse': '„{name}“ kann nicht gelöscht werden, weil es verwendet wird (Geräte: {equipment}, Preisregeln: {rules}, Pakete: {bundles}).',
    'inventorySettings.catDeleteFailed': 'Kategorie konnte nicht gelöscht werden.',
    'inventorySettings.ownFieldTag': 'eigenes',
    'inventorySettings.resetDefaultsDone': 'Standardeinstellungen wiederhergestellt.',
    'inventoryPresets.doneTitle': 'Set „{name}“ angewendet',
    'inventoryPresets.doneSummary': 'Neue Gerätetypen: {types}. Eingerichtete Lagerfelder: {fields}.',
    'inventoryPresets.doneRemoved': 'Entfernte Typen aus dem vorherigen Set: {removed}.',
    'inventoryPresets.doneBlocked': 'Geblieben, weil sie genutzt werden: {names}.',
    'inventoryPresets.doneAddEquipment': 'Erstes Gerät hinzufügen',
    'inventoryPresets.donePickAnother': 'Andere Branche wählen',
    'inventoryPresets.typeAddError': 'Gerätetyp konnte nicht hinzugefügt werden.',

    // Preferences
    'preferences.title': 'Ihre Einstellungen',
    'preferences.theme': 'Design',
    'preferences.theme.light': 'Hell',
    'preferences.theme.dark': 'Dunkel',
    'preferences.language': 'Sprache der Benutzeroberfläche',
    'preferences.language.polish': 'Polnisch',
    'preferences.language.english': 'Englisch',
    'preferences.language.german': 'Deutsch',
    'preferences.chooseTheme': 'Wählen Sie das Design der Anwendung',
    'preferences.chooseLanguage': 'Wählen Sie die Anzeigesprache',
    'preferences.loading': 'Einstellungen werden geladen...',
    'preferences.saved': 'Einstellungen wurden gespeichert',
    'preferences.save': 'Speichern',
    'preferences.cancel': 'Abbrechen',
    'preferences.saving': 'Speichern…',

    // Common
    'common.cancel': 'Abbrechen',
    'common.save': 'Speichern',
    'common.edit': 'Bearbeiten',
    'common.delete': 'Löschen',
    'common.add': 'Hinzufügen',
    'common.loading': 'Laden...',
    'common.error': 'Fehler',
    'common.success': 'Erfolg',
    'common.actions': 'Aktionen',
    'common.clear': 'Löschen',
    'common.refresh': 'Aktualisieren',
    'common.close': 'Schließen',
    'inventory.closeFilters': 'Filter schließen',
    'common.previous': 'Vorherige',
    'common.next': 'Nächste',
    'common.pageInfo': 'Seite {page} von {total}',
    'common.yes': 'Ja',
    'common.no': 'Nein',
    'common.back': 'Zurück',
    'common.backToProfile': 'Zurück zum Profil',
    'common.tour': 'Rundgang',
    'common.firstPage': 'Erste Seite',
    'common.lastPage': 'Letzte Seite',
    'common.previousPage': 'Vorherige Seite',
    'common.nextPage': 'Nächste Seite',
    'common.showingRange': 'Angezeigt {from}-{to} von {total}',
    'common.retry': 'Erneut versuchen',
    'common.search': 'Suchen',
    'common.filters': 'Filter',
    'common.clearFilters': 'Filter zurücksetzen',
    'common.confirm': 'Bestätigen',
    'common.confirmDeleteTitle': 'Wirklich löschen?',
    'common.irreversible': 'Diese Aktion kann nicht rückgängig gemacht werden.',
    'common.savedSuccess': 'Änderungen gespeichert',
    'common.saveError': 'Änderungen konnten nicht gespeichert werden',
    'common.loadError': 'Daten konnten nicht geladen werden',
    'photos.cropHint': 'Fotografieren Sie nur die Ausrüstung: keine Gesichter, Kennzeichen oder Dokumente. Die App entfernt Standort- und Kameradaten aus der Datei.',
    'common.noResults': 'Keine Ergebnisse',
    'common.noData': 'Keine Daten',
    'common.all': 'Alle',
    'common.copy': 'Kopieren',
    'common.copied': 'Kopiert',
    'common.download': 'Herunterladen',
    'common.send': 'Senden',
    'common.details': 'Details',
    'common.status': 'Status',
    'common.date': 'Datum',
    'common.amount': 'Betrag',
    'common.required': 'Pflichtfeld',
    'common.sessionExpired': 'Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.',
    'common.undo': 'Rückgängig',

    // Clients page
    'clients.title': 'Kundenkartei',
    'clients.subtitle': 'Verwalten Sie Kundendaten und sehen Sie die Reservierungshistorie',
    'clients.searchPlaceholder': 'Suchen nach Name, Nachname, Telefon oder E-Mail...',
    'clients.addClient': 'Kunde hinzufügen',
    'clients.totalClients': 'Kunden',
    'clients.searchResults': 'Suchergebnisse',
    'clients.firstName': 'Vorname',
    'clients.lastName': 'Nachname',
    'clients.phone': 'Telefon',
    'clients.email': 'E-Mail',
    'clients.reservations': 'Reservierungen',
    'clients.details': 'Details',
    'clients.noResults': 'Keine Kunden entsprechen den Suchkriterien',
    'clients.noClients': 'Keine Kunden in der Datenbank',
    'clients.clientDetails': 'Kundendetails',
    'clients.name': 'Vor- und Nachname',
    'clients.showDetails': 'Kundendetails anzeigen',
    'clients.newThisMonth': 'Neu diesen Monat',
    'clients.shownOfTotal': '{shown} von {total} Kunden angezeigt',
    'clients.regularClient': 'Stammkunde',
    'clients.firstNameRequired': 'Vorname*',
    'clients.firstNamePlaceholder': 'Vorname eingeben',
    'clients.emailPlaceholder': 'beispiel@email.com',
    'clients.deleteConfirmTitle': 'Löschen bestätigen',
    'clients.deleteConfirmIntro': 'Möchten Sie den Kunden wirklich löschen',
    'clients.deleteDataLoss': 'Bevorstehende und stornierte Reservierungen werden gelöscht. Abgeschlossene bleiben als Mietverlauf, aber ohne Kundendaten: Kontaktdaten, Adresse, Firmendaten, Reservierungsnotizen, Benachrichtigungsempfänger und Zustandsfotos werden entfernt, unbezahlte Angebote werden gelöscht (ihre Zahlungslinks funktionieren nicht mehr). Umsatzsteuerrechnungen behalten die Käuferdaten (5 Jahre Aufbewahrungspflicht). Wenn der Kunde eine Kopie seiner Daten verlangt, laden Sie sie vor dem Löschen herunter.',
    'clients.exportData': 'Daten herunterladen (DSGVO)',
    'clientsExport.open': 'Exportieren',
    'clientsExport.title': 'Kunden exportieren',
    'clientsExport.subtitle': 'Wählen Sie die Kundendaten und laden Sie sie als Excel- oder CSV-Datei herunter.',
    'clientsExport.scopeTitle': 'Welche Kunden',
    'clientsExport.scopeList': 'Kunden aus der Liste',
    'clientsExport.scopeAll': 'Alle Kunden',
    'clientsExport.scopeAllHint': 'Ohne Suche und Filter',
    'clientsExport.scopeSearch': 'Suche: „{q}“',
    'clientsExport.scopeRecent': 'neu (30 Tage)',
    'clientsExport.scopeFrequent': 'Stammkunden (3+)',
    'clientsExport.fieldsTitle': 'Was in die Datei kommt',
    'clientsExport.clearFields': 'Alle abwählen',
    'clientsExport.group.person': 'Kontaktdaten',
    'clientsExport.group.address': 'Adresse',
    'clientsExport.group.company': 'Firma',
    'clientsExport.group.history': 'Verlauf',
    'clientsExport.field.firstname': 'Vorname',
    'clientsExport.field.lastname': 'Nachname',
    'clientsExport.field.email': 'E-Mail',
    'clientsExport.field.phone_number': 'Telefon',
    'clientsExport.field.address': 'Ganze Adresse in einer Spalte',
    'clientsExport.field.street': 'Straße',
    'clientsExport.field.building_number': 'Hausnummer',
    'clientsExport.field.apartment_number': 'Wohnungsnummer',
    'clientsExport.field.postal_code': 'Postleitzahl',
    'clientsExport.field.city': 'Ort',
    'clientsExport.field.client_type': 'Kundenart',
    'clientsExport.field.company_name': 'Firmenname',
    'clientsExport.field.company_nip': 'Steuernummer (NIP)',
    'clientsExport.field.company_regon': 'REGON',
    'clientsExport.field.registration_date': 'Hinzugefügt am',
    'clientsExport.field.reservations_count': 'Anzahl Reservierungen',
    'clientsExport.field.last_reservation': 'Letzte Reservierung',
    'clientsExport.formatTitle': 'Dateiformat',
    'clientsExport.format.xlsx': 'Excel (.xlsx)',
    'clientsExport.format.csv': 'CSV (.csv)',
    'clientsExport.formatHint.xlsx': 'Öffnet sich direkt in Excel und Google Tabellen. Daten und Zahlen lassen sich sofort sortieren.',
    'clientsExport.formatHint.csv': 'Durch Semikolon getrennter Text zum Import in ein anderes Programm, z. B. für einen Newsletter.',
    'clientsExport.previewTitle': 'Dateivorschau',
    'clientsExport.previewEmpty': 'Wählen Sie mindestens ein Merkmal, um die Vorschau zu sehen.',
    'clientsExport.previewMore': 'Die ersten {shown} von {total} Datenzeilen.',
    'clientsExport.previewAll': 'So sieht die ganze Datei aus.',
    'clientsExport.clientsOne': '{n} Kunde',
    'clientsExport.clientsFew': '{n} Kunden',
    'clientsExport.clientsMany': '{n} Kunden',
    'clientsExport.columnsOne': '{n} Spalte',
    'clientsExport.columnsFew': '{n} Spalten',
    'clientsExport.columnsMany': '{n} Spalten',
    'clientsExport.cancel': 'Abbrechen',
    'clientsExport.download': '{ext}-Datei herunterladen',
    'clientsExport.preparing': 'Datei wird vorbereitet…',
    'clientsExport.downloaded': '{name} heruntergeladen.',
    'clientsExport.errorAdmin': 'Der Kundenexport erfordert Administratorrechte.',
    'clientsExport.errorSession': 'Ihre Sitzung ist abgelaufen. Melden Sie sich erneut an.',
    'clientsExport.errorGeneric': 'Die Datei konnte nicht vorbereitet werden. Versuchen Sie es erneut.',
    'clients.exportDataHint': 'JSON-Datei mit allen Daten dieses Kunden im System, für Kundenanfragen (Art. 15 und 20 DSGVO).',
    'clients.exportLoading': 'Datei wird vorbereitet…',
    'clients.exportFailed': 'Kundendaten konnten nicht heruntergeladen werden.',
    
    // Equipment
    'addEquipment.title': 'Ausrüstung hinzufügen',
    'addEquipment.subtitle': 'Füllen Sie das Formular aus, um neue Ausrüstung zum Lager hinzuzufügen',
    'addEquipment.name': 'Name',
    'addEquipment.namePlaceholder': 'Name',
    'addEquipment.size': 'Größe',
    'addEquipment.sizePlaceholder': 'Größe',
    'addEquipment.brand': 'Marke',
    'addEquipment.brandPlaceholder': 'Marke',
    'addEquipment.price': 'Preis',
    'addEquipment.pricePlaceholder': 'Preis (PLN)',
    'addEquipment.bail': 'Kaution',
    'addEquipment.bailPlaceholder': 'Kaution (PLN)',
    'addEquipment.class': 'Klasse',
    'addEquipment.classPlaceholder': 'Klasse auswählen',
    'addEquipment.type': 'Gerätekategorie',
    'addEquipment.typePlaceholder': 'Kategorie wählen',
    'addEquipment.category': 'Kategorie',
    'addEquipment.categoryPlaceholder': 'Kategorie wählen',
    'addEquipment.inventoryNumber': 'Nummer',
    'addEquipment.inventoryNumberPlaceholder': 'Nummer',

    'equipmentDetails.calendar': 'Kalender',
    'equipmentDetails.subtitle': 'Ausrüstungsinformationen durchsuchen oder bearbeiten',
    'addEquipment.selectCategory': 'Kategorie auswählen',
    'addEquipment.fillAll': 'Alle Felder ausfüllen',
    'addEquipment.success': 'Ausrüstung erfolgreich hinzugefügt',
    'addEquipment.error': 'Fehler beim Hinzufügen der Ausrüstung',
    'addEquipment.class.Junior': 'Junior',
    'addEquipment.class.Premium': 'Premium',
    'addEquipment.class.Normal': 'Normal',

    // Inventory
    'inventory.title': 'Inventar',
    'inventory.calendar': 'Gerätekalender',
    'inventory.inventoryNumber': 'Nummer',
    'inventory.equipment': 'Ausrüstung',
    'inventory.size': 'Größe',
    'inventory.brand': 'Marke',
    'inventory.category': 'Kategorie',
    'inventory.class': 'Klasse',
    'inventory.add': 'Ausrüstung hinzufügen',
    'inventory.delete': 'Löschen',
    'inventory.selectedCount': 'Ausgewählt',
    'inventory.confirmDeleteOne': 'Möchten Sie diese Ausrüstung wirklich löschen?',
    'inventory.confirmDeleteMany': 'Möchten Sie wirklich {count} Ausrüstungsgegenstände löschen?',
    'inventory.selectItem': 'Ausrüstung auswählen',
    'inventory.unselectItem': 'Ausrüstung abwählen',
    'inventory.settings': 'Inventar-Einstellungen',
    'inventory.settingsSubtitle': 'Spalten, Pflichtfelder und Kategorien verwalten',
    'inventory.settingsColumns': 'Sichtbare Tabellenspalten',
    'inventory.settingsRequired': 'Erforderliche Felder beim Hinzufügen',
    'inventory.settingsRequiredHint': 'Basisfelder sind immer erforderlich.',
    'inventory.addCategory': 'Kategorie hinzufügen',
    'inventory.categoryName': 'Kategoriename',
    'inventory.addCategoryBtn': 'Hinzufügen',
    'inventory.categoryNameRequired': 'Bitte Kategorienamen eingeben.',
    'inventory.categoryAddSuccess': 'Kategorie hinzugefügt.',
    'inventory.categoryAddError': 'Kategorie kann nicht hinzugefügt werden.',
    'inventory.categoryFieldsBase': 'Immer erforderliche Felder',
    'inventory.categoryFieldsOptional': 'Zusatzfelder für diese Kategorie',
    'inventory.categoryFieldsHint': 'Wähle Felder, die nur für diese Kategorie erforderlich sein sollen.',
    'inventory.search': 'Suche...',
    'inventory.options': 'Optionen',
    'inventory.details': 'Gerätedetails',
    'inventory.page': 'Seite',
    'inventory.next': 'Nächste',
    'inventory.noMatch': 'Keine Ausrüstung entspricht den Filtern.',
    'inventory.name': 'Name', // Dodane
    'inventory.sizePlaceholder': 'Größe eingeben...',
    'inventory.type.Narty': 'Skier',
    'inventory.type.Buty narciarskie': 'Skischuhe',
    'inventory.type.Buty snowboardowe': 'Snowboardschuhe',
    'inventory.type.Snowboard': 'Snowboard',
    'inventory.type.Kije': 'Skistöcke',
    'inventory.type.Kask': 'Helm',
    'inventory.type.Gogle': 'Skibrille',
    'inventory.status': 'Status',
    'inventory.statusFilter': 'Status',
    'inventory.status.Dostępny': 'Verfügbar',
    'inventory.status.Wypożyczony': 'Vermietet',
    'inventory.status.W serwisie': 'In Wartung',
    'inventory.status.Nieaktywny': 'Inaktiv',
    'inventory.rangeFrom': 'Von',
    'inventory.rangeTo': 'Bis',
    'inventory.rangeMinPlaceholder': 'min',
    'inventory.rangeMaxPlaceholder': 'max',
    'inventory.sizePickOne': 'Oder Größe wählen',
    'inventory.availableFrom': 'Verfügbar ab',
    'inventory.availableTo': 'Verfügbar bis',
    'inventoryModal.pricePerDay': 'Preis / Tag',
    'inventoryModal.selectedCount': 'Ausgewählt: {count}',
    'inventoryModal.onlySelected': 'Nur ausgewählte anzeigen',
    'inventoryModal.confirm': 'Fertig ({count})',
    'inventoryModal.empty': 'Für den gewählten Zeitraum ist keine Ausrüstung verfügbar.',
    'inventoryModal.noneSelected': 'Noch keine Ausrüstung ausgewählt.',
    'inventory.currentStatus': 'Aktueller Status',
    'inventory.changeStatus': 'Status ändern',
    'inventory.statusWillChange': 'Status wird geändert',
    'inventory.deactivateWarning': 'Inaktive Ausrüstung steht nicht zur Vermietung zur Verfügung und erscheint nicht in der Suche.',
    'inventory.cannotDeactivateRented': 'Ausrüstung kann nicht deaktiviert werden, solange sie vermietet ist. Bitte auf Rückgabe warten.',
    'inventory.statusDesc.available': 'Ausrüstung ist einsatzbereit',
    'inventory.statusDesc.rented': 'Derzeit von einem Kunden genutzt',
    'inventory.statusDesc.service': 'In Reparatur oder Wartung',
    'inventory.statusDesc.inactive': 'Aus dem Umlauf genommen',
    'inventory.deactivate': 'Deaktivieren',
    'inventory.activate': 'Aktivieren',
    'inventory.confirmDeactivate': 'Möchten Sie diese Ausrüstung wirklich deaktivieren?',
    'inventory.statusChanged': 'Ausrüstungsstatus wurde geändert',
    'inventory.statusChangeError': 'Fehler beim Ändern des Status',
    'inventory.cannotChangeStatus': 'Status kann nicht geändert werden',
    'inventory.currentlyRented': 'Ausrüstung ist derzeit vermietet. Statusänderung wird nach Rückgabe durch den Kunden möglich sein.',
    'inventory.hasFutureReservationsBlocked': 'Ausrüstung hat geplante zukünftige Reservierungen. Statusänderung wird nach Stornierung oder Abschluss der Reservierungen möglich sein.',
    'inventory.rentedAndFutureReservations': 'Ausrüstung ist derzeit vermietet und hat geplante zukünftige Reservierungen. Statusänderung wird erst nach Abschluss aller Reservierungen möglich sein.',
    'inventory.type.Bidon': 'Trinkflasche',
    'inventory.type.Buty rowerowe': 'Fahrradschuhe',
    'inventory.type.Kask rowerowy': 'Fahrradhelm',
    'inventory.type.Pompka': 'Luftpumpe',
    'inventory.type.Rower górski': 'Mountainbike',
    'inventory.type.Rower miejski': 'Cityrad',
    'inventory.type.Rower szosowy': 'Rennrad',
    'inventory.type.Rower trekkingowy': 'Trekkingrad',
    'inventory.type.Zapięcie': 'Fahrradschloss',
    'inventory.type.Zestaw naprawczy': 'Reparaturset',
    'inventory.type.Kłódki': 'Vorhängeschlösser',
    'inventory.type.Ochraniacze': 'Protektoren',
    'inventory.type.Rękawice': 'Handschuhe',
    'inventory.sku': 'Code/SKU',
    'inventory.condition': 'Zustand',
    'inventory.location': 'Lagerort',
    'inventory.tags': 'Schlagwörter',
    'inventory.supplier': 'Lieferant',
    'inventory.purchaseDate': 'Kaufdatum',
    'inventory.maintenanceDate': 'Servicedatum',
    'inventory.images': 'Fotos',
    'inventory.barcode': 'Code',
    'inventory.priceCurrency': 'Preiswährung',
    'inventory.depositCurrency': 'Kautionswährung',
    'inventory.currency': 'Währung',
    'inventory.wearLevel': 'Verschleiß',
    'inventory.compatibility': 'Kompatibilität',
    'inventory.sizeRange': 'Größenbereich',
    'inventory.clearFilters': 'Filter zurücksetzen',
    'inventory.searchPlaceholder': 'Nach Name, Marke oder Nummer suchen…',
    'inventory.resultsTotal': '{total} Stück',
    'inventory.resultsOfTotal': '{shown} von {total} Stück',
    'inventory.filterSearchPlaceholder': 'Suchen…',
    'inventory.filterNoMatches': 'Keine passenden Werte',
    'inventory.scanned': 'Gescannt: {code}',
    'scanner.cameraButton': 'Kamera',
    'scanner.cameraButtonHint': 'Code mit der Kamera dieses Geräts scannen',
    'scanner.phoneButton': 'Handy',
    'scanner.phoneButtonHint': 'Handy als kabellosen Scanner für dieses Fenster verwenden',
    'scanner.cameraTitle': 'Mit Kamera scannen',
    'scanner.cameraSubtitle': 'Richte die Kamera auf den QR- oder Barcode auf dem Geräteetikett.',
    'scanner.videoLabel': 'Kameravorschau',
    'scanner.starting': 'Kamera wird gestartet…',
    'scanner.aimHint': 'Halte den Code im Rahmen. Das Lesen erfolgt automatisch: Jeder Code zählt einmal, bis er aus dem Bild verschwindet.',
    'scanner.read': 'Gelesen: {code}',
    'scanner.sendFailed': 'Der Code konnte nicht verarbeitet werden.',
    'scanner.manualPlaceholder': 'Oder Code eingeben',
    'scanner.manualSubmit': 'Senden',
    'scanner.problem.insecure': 'Die Kamera funktioniert nur auf einer über HTTPS geöffneten Seite. Öffne das Panel unter einer https://…-Adresse.',
    'scanner.problem.unsupported': 'Dieser Browser bietet keinen Kamerazugriff. Verwende aktuelles Chrome, Safari oder Edge oder gib den Code unten ein.',
    'scanner.problem.denied': 'Kamerazugriff verweigert. Erlaube den Kamerazugriff in den Browsereinstellungen (Schloss-Symbol neben der Adresse) und öffne das Fenster erneut.',
    'scanner.problem.nocamera': 'Auf diesem Gerät wurde keine Kamera gefunden. Gib den Code unten ein oder verwende dein Handy.',
    'scanner.problem.nocameraPhone': 'Auf diesem Gerät wurde keine Kamera gefunden. Gib den Code unten ein.',
    'scanner.problem.busy': 'Die Kamera wird von einer anderen App verwendet. Schließe sie und versuche es erneut.',
    'scanner.problem.unknown': 'Die Kamera konnte nicht gestartet werden. Gib den Code unten ein.',
    'scanner.phone.title': 'Mit dem Handy scannen',
    'scanner.phone.subtitle': 'Dein Handy funktioniert als kabelloser Scanner, ohne App-Installation.',
    'scanner.phone.step1': 'Öffne die Kamera deines Handys und richte sie auf den QR-Code unten.',
    'scanner.phone.step2': 'Tippe auf den Link, den dein Handy anzeigt. Der Scanner öffnet sich.',
    'scanner.phone.step3': 'Scanne die Etiketten, und die Codes erscheinen sofort in diesem Fenster.',
    'scanner.phone.qrAlt': 'QR-Code zum Öffnen des Scanners auf dem Handy',
    'scanner.phone.status.creating': 'Code wird vorbereitet…',
    'scanner.phone.status.waiting': 'Warte auf das Handy…',
    'scanner.phone.status.connected': 'Handy verbunden, du kannst scannen',
    'scanner.phone.status.expired': 'Der Code ist abgelaufen oder die Verbindung wurde geschlossen. Erzeuge einen neuen Code.',
    'scanner.phone.status.error': 'Die Verbindung konnte nicht vorbereitet werden. Versuche es erneut.',
    'scanner.phone.copyLink': 'Link kopieren',
    'scanner.phone.copied': 'Kopiert',
    'scanner.phone.localhostWarning': 'Das Panel ist unter localhost geöffnet, daher kann dein Handy es nicht öffnen. Handy-Scannen funktioniert mit der öffentlichen HTTPS-Adresse des Panels.',
    'scanner.phone.httpWarning': 'Das Panel ist nicht über HTTPS geöffnet, daher erlaubt der Handy-Browser dort keine Kamera. In der Produktion (https) funktioniert alles.',
    'scanner.phone.connected': 'Handy verbunden',
    'scanner.phone.waitingForCodes': 'Warte auf Codes…',
    'scanner.phone.show': 'Anzeigen',
    'scanner.phone.disconnect': 'Trennen',
    'scanner.phone.minimize': 'Minimieren',
    'scanner.phone.newCode': 'Neuer Code',
    'scanner.phone.finish': 'Beenden',
    'phoneScanner.title': 'Code-Scanner',
    'phoneScanner.subtitle': 'Codes werden an das Fenster am Computer gesendet.',
    'phoneScanner.checking': 'Verbinde mit dem Computer…',
    'phoneScanner.expired': 'Dieser Link ist abgelaufen oder wurde am Computer geschlossen. Klicke am Computer auf „Handy“ (oder „Neuer Code“) und scanne den neuen QR-Code.',
    'phoneScanner.expiredShort': 'Link abgelaufen. Scanne einen neuen QR-Code vom Computer.',
    'phoneScanner.sent': 'Gesendet: {code}',
    'phoneScanner.noListener': 'Gesendet, aber das Fenster am Computer ist geschlossen. Öffne es erneut („Handy“).',
    'phoneScanner.tooFast': 'Zu viele Codes auf einmal. Bitte kurz langsamer.',
    'phoneScanner.sendFailed': 'Der Code konnte nicht gesendet werden. Prüfe die Internetverbindung.',
    'labels.button': 'Etiketten',
    'labels.printOne': 'Etikett drucken',
    'labels.summary': 'Etiketten: {labels} · Bögen: {pages}',
    'labels.summaryRoll': 'Etiketten: {labels}',
    'labels.printCount': 'Drucken ({n})',
    'labels.andMore': 'und {n} weitere',
    'labels.noCategory': 'Ohne Kategorie',
    'labels.preview': 'Druckvorschau',
    'labels.sheets': 'Bögen',
    'labels.goToSheet': 'Bogen {n}',
    'labels.sheetOf': 'Bogen {n} von {total}',
    'labels.labelOf': 'Etikett {n} von {total}',
    'labels.prevSheet': 'Vorheriger Bogen',
    'labels.nextSheet': 'Nächster Bogen',
    'labels.prevLabel': 'Vorheriges Etikett',
    'labels.nextLabel': 'Nächstes Etikett',
    'labels.legend.label': 'Etikett',
    'labels.legend.skipped': 'übersprungenes Feld',
    'labels.legend.free': 'freies Feld',
    'labels.selection.title': 'Was drucken',
    'labels.selection.count': '{n} von {total} ausgewählt',
    'labels.selection.search': 'Nach Name, Nummer oder Kategorie suchen',
    'labels.selection.searchShort': 'Name, Nummer oder Kategorie',
    'labels.selection.selectAll': 'Alle auswählen',
    'labels.selection.clearAll': 'Alle abwählen',
    'labels.selection.selectShown': 'Treffer auswählen',
    'labels.selection.clearShown': 'Treffer abwählen',
    'labels.selection.noMatches': 'Nichts passt zu „{q}“.',
    'labels.selection.groupToggle': 'Ganze Kategorie auswählen: {name}',
    'labels.selection.showOnSheet': 'Auf dem Bogen zeigen',
    'labels.selection.nothingSelected': 'Wähle Geräte in der Liste aus, um die Vorschau zu sehen.',
    'labels.printSelected': 'Etiketten drucken ({n})',
    'labels.title': 'Geräteetiketten',
    'labels.subtitle': 'QR- und Barcodes zum Aufkleben auf Geräte, vom Scanner im Panel erkannt.',
    'labels.print': 'Drucken',
    'labels.loadError': 'Geräte konnten nicht geladen werden.',
    'labels.layout': 'Bogen / Drucker',
    'labels.layouts.a4-24': 'A4: 24 Etiketten 70 × 37 mm',
    'labels.layouts.a4-21': 'A4: 21 Etiketten 70 × 42,3 mm',
    'labels.layouts.a4-65': 'A4: 65 Etiketten 38 × 21 mm (klein)',
    'labels.layouts.roll-50x30': 'Etikettendrucker: 50 × 30 mm',
    'labels.layouts.roll-45x30': 'Brother-Etikettendrucker: 45 × 30 mm',
    'labels.layouts.roll-62x29': 'Etikettendrucker: 62 × 29 mm (Brother)',
    'labels.format': 'Code-Art',
    'labels.formats.qr': 'QR',
    'labels.formats.barcode': 'Barcode',
    'labels.formats.both': 'Beide',
    'labels.formatHint': 'QR wird von Handykameras und 2D-Scannern gelesen. Günstige Laserscanner lesen nur Barcodes, „Beide“ funktioniert mit allen.',
    'labels.copies': 'Kopien je Etikett',
    'widgetFilters.showEmpty': 'Merkmale ohne Daten anzeigen ({n})',
    'widgetFilters.hideEmpty': 'Merkmale ohne Daten ausblenden',
    'widgetFilters.from': 'von',
    'widgetFilters.to': 'bis',
    'widgetFilters.title': 'Filter im Widget',
    'widgetFilters.sub': 'Wählen Sie die Merkmale, nach denen Kunden die Geräteliste eingrenzen. Die Werte stammen aus Ihrem Lager, Sie müssen nichts eintippen. Ein Filter erscheint in einer Kategorie nur, wenn er dort mindestens zwei verschiedene Werte hat.',
    'widgetFilters.loading': 'Gerätemerkmale werden geladen…',
    'widgetFilters.loadError': 'Filter konnten nicht geladen werden. Seite neu laden.',
    'widgetFilters.meta': '{n} verschiedene Werte: {values}',
    'widgetFilters.noData': 'Noch kein Gerät hat dieses Merkmal',
    'widgetFilters.oneValue': 'ein Wert',
    'widgetFilters.rangeBadge': 'Bereich von–bis',
    'widgetFilters.labelAria': 'Filtername im Widget: {name}',
    'widgetFilters.up': 'Nach oben: {name}',
    'widgetFilters.down': 'Nach unten: {name}',
    'widgetFilters.previewAria': 'Vorschau der Widget-Filter',
    'widgetFilters.counter': 'Ausgewählt: {n} von {max}',
    'widgetFilters.save': 'Filter speichern',
    'widgetFilters.saved': 'Filter gespeichert. Das Widget zeigt sie beim nächsten Öffnen.',
    'widgetFilters.saveError': 'Die Filter konnten nicht gespeichert werden.',
    'classBooking.title': 'Buchung nach Klasse',
    'classBooking.sub': 'Für ausgewählte Kategorien wählt der Kunde im Widget eine Klasse (z. B. Ski · Premium ×2) und gibt seine Maße an, Sie wählen das konkrete Gerät. Der Kunde zahlt erst, nachdem Sie die Verfügbarkeit in den Reservierungsdetails bestätigt haben. Andere Kategorien funktionieren wie bisher.',
    'classBooking.loading': 'Kategorien werden geladen…',
    'classBooking.loadError': 'Die Einstellungen konnten nicht geladen werden. Seite neu laden.',
    'classBooking.empty': 'Fügen Sie zuerst im Lager Geräte mit Kategorie und Klasse hinzu.',
    'classBooking.meta': 'Klassen: {classes} · Geräte: {units} Stk.',
    'classBooking.offHint': 'Der Kunde wählt wie bisher ein konkretes Gerät und die Größe.',
    'classBooking.questionsTitle': 'Fragen zur Auswahl',
    'classBooking.question.height': 'Körpergröße',
    'classBooking.question.weight': 'Gewicht',
    'classBooking.question.shoe_size': 'Schuhgröße',
    'classBooking.question.skill': 'Können',
    'classBooking.question.head': 'Kopfumfang',
    'classBooking.question.age': 'Alter',
    'classBooking.noQuestions': 'Ohne Fragen gibt der Kunde nur die Anzahl an.',
    'classBooking.pricesTitle': 'Klassenpreise',
    'classBooking.units': '{n} Stk. im Lager',
    'classBooking.pricePlaceholder': 'nicht anbieten',
    'classBooking.perDay': 'pro Tag, zł',
    'classBooking.noPrices': 'Geben Sie für mindestens eine Klasse einen Preis an. Ohne Preis erscheint die Kategorie in diesem Modus nicht im Widget.',
    'classBooking.save': 'Buchung nach Klasse speichern',
    'classBooking.badPrice': 'Der Preis muss ein Betrag über 0 sein, z. B. 80 oder 79,50.',
    'classBooking.missingPrices': 'Geben Sie für mindestens eine Klasse einen Preis an oder schalten Sie die Kategorie aus: {names}.',
    'classBooking.saved': 'Gespeichert. Das Widget zeigt die Änderungen beim nächsten Öffnen.',
    'classBooking.saveError': 'Die Einstellungen konnten nicht gespeichert werden.',
    'classBooking.over7': 'ab Tag 8, zł',
    'classBooking.over7Placeholder': 'wie sonst',
    'classBooking.priceAria': 'Preis pro Tag: {name}',
    'classBooking.over7Aria': 'Preis pro Tag ab Tag 8: {name}',
    'classBooking.pricingHint': 'Dynamische Preise und Sets für Klassen legen Sie im Profil unter Preisregeln und Gerätesets fest (Feld „Gilt für“).',
    'priceRules.appliesTo': 'Gilt für',
    'priceRules.appliesToAll': 'Gesamten Verleih (Geräte und Widget-Klassen)',
    'priceRules.appliesToEquipment': 'Nur konkrete Geräte',
    'priceRules.appliesToClasses': 'Nur Buchung nach Klasse im Widget',
    'priceRules.appliesToHint': 'Eine Regel „nur Klassen“ ändert die Klassenpreise aus den Widget-Einstellungen (Widget → Buchung nach Klasse) und lässt Gerätepreise unverändert.',
    'priceRules.scopeClassesTag': 'Widget-Klassen',
    'priceRules.scopeEquipmentTag': 'nur Geräte',
    'priceRules.includesBundles': 'Gilt auch für Pakete',
    'priceRules.includesBundlesHint': 'Der Paketpreis ändert sich Tag für Tag um denselben Prozentsatz. Eine Regel „nur konkrete Geräte“ oder „nur Klassen“ gilt für Pakete mit demselben Geltungsbereich und für Pakete des gesamten Verleihs.',
    'priceRules.includesBundlesLocked': 'Für Pakete gilt nur eine Prozentregel ohne ausgewählte Klasse und Geräteart.',
    'priceRules.bundlesBadge': 'auch Pakete',
    'priceRules.presets.bundlesLabel': 'Auch für Pakete',
    'priceRules.presets.toggleLabel': 'Regel',
    'priceRules.presets.bundlesAria': '{name}: gilt auch für Pakete',
    'equipmentBundles.classesLabel': 'Klasse des Bestandteils',
    'equipmentBundles.anyClass': 'Beliebige Klasse',
    'equipmentBundles.classesHint': 'Die Klasse ist optional: ohne sie passt das Set zu jeder Klasse dieser Kategorie.',
    'equipmentBundles.appliesToHint': '„Nur bestimmte Geräte“ gilt im Panel und im Widget, wenn bestimmte Stücke bestellt werden, „nur Klassen“ bei Klassen im Widget und „gesamter Verleih“ in beiden Fällen, auch wenn ein Set eine Klasse mit einem bestimmten Stück verbindet.',
    'equipmentBundles.dailyPriceOver7': 'Preis ab Tag 8',
    'equipmentBundles.dailyPriceOver7Placeholder': 'wie sonst',
    'equipmentBundles.dailyPriceOver7Hint': 'Preis pro Tag bei Mieten über 7 Tage. Leer = normaler Setpreis.',
    'equipmentBundles.over7Invalid': 'Der Preis ab Tag 8 muss eine nicht negative Zahl oder leer sein.',
    'equipmentBundles.over7Short': 'ab Tag 8: {price} zł/Tag',
    'bundleWarn.title': 'Wann dieses Set nicht greift',
    'bundleWarn.badgeNever': 'greift nicht',
    'bundleWarn.badgePartly': 'greift nicht immer',
    'bundleWarn.badgeSometimes': 'greift teilweise',
    'bundleWarn.scopeEquipment': 'Konkrete Geräte',
    'bundleWarn.scopeClasses': 'Widget-Klassen',
    'bundleWarn.neverShort': '{scope}: Bei Mieten bis 7 Tage greift das Set nie. Die Teile kosten zusammen {range} pro Tag, das Set {bundle}.',
    'bundleWarn.neverLong': '{scope}: Bei Mieten über 7 Tage greift das Set nie. Die Teile kosten dann zusammen {range} pro Tag, das Set {bundle}. Legen Sie einen niedrigeren Preis ab Tag 8 fest.',
    'bundleWarn.sometimesShort': '{scope}: Bei Mieten bis 7 Tage greift das Set nur für teurere Teile. Die Teile kosten zusammen {range} pro Tag, das Set {bundle}.',
    'bundleWarn.sometimesLong': '{scope}: Bei Mieten über 7 Tage greift das Set nur für teurere Teile. Die Teile kosten dann zusammen {range} pro Tag, das Set {bundle}.',
    'bundleWarn.neverBoth': '{scope}: Das Set greift nie. Die Teile kosten zusammen {range} pro Tag, bei Mieten über 7 Tage {rangeLong}. Das Set kostet {bundle}.',
    'bundleWarn.sometimesBoth': '{scope}: Das Set greift nur für teurere Teile. Die Teile kosten zusammen {range} pro Tag, bei Mieten über 7 Tage {rangeLong}. Das Set kostet {bundle}.',
    'bundleWarn.bundleWithOver7': '{price} (ab Tag 8: {over7})',
    'bundleWarn.missingEquipment': '{scope}: Im Lager gibt es kein {items}, daher greift das Set nicht für konkrete Geräte.',
    'bundleWarn.missingClasses': '{scope}: {items} wird bei der Buchung nach Klasse nicht angeboten, daher greift das Set im Widget nicht.',
    'bundleWarn.footnote': 'Ein Set wird nur verwendet, wenn es günstiger ist als die einzeln berechneten Teile. Der Vergleich lässt dynamische Preise außer Acht.',
    'classRequest.loading': 'Anfrage wird geladen…',
    'classRequest.loadError': 'Die Anfrage konnte nicht geladen werden. Fenster schließen und erneut öffnen.',
    'classRequest.title': 'Anfrage aus dem Widget',
    'classRequest.stateAwaiting': 'Wartet auf Bestätigung',
    'classRequest.stateConfirmed': 'Bestätigt',
    'classRequest.stateCancelled': 'Storniert',
    'classRequest.intro': 'Der Kunde hat Klassen gewählt und seine Maße angegeben. Wählen Sie die Geräte und bestätigen Sie dann die Verfügbarkeit: Der Kunde erhält eine E-Mail mit Zahlungslink oder Überweisungsdaten. Bis dahin zahlt er nichts.',
    'classRequest.introNoPaymentDetails': 'Der Kunde hat Klassen gewählt und seine Maße angegeben. Wählen Sie die Geräte und bestätigen Sie dann die Verfügbarkeit. Die Firma hat weder Online-Zahlung noch eine Kontonummer in den Firmendaten, daher erhält der Kunde eine E-Mail mit der Bitte um Kontakt wegen der Zahlung. Bis dahin zahlt er nichts.',
    'classRequest.introConfirmed': 'Anfrage bestätigt. Geräte können bis zur Ausgabe gewählt oder geändert werden.',
    'classRequest.progress': 'Gewählt: {done} von {total}',
    'classRequest.noAnswers': 'Ohne Maße',
    'classRequest.otherClass': 'Klasse {name}',
    'classRequest.change': 'Ändern',
    'classRequest.pick': 'Gerät wählen',
    'classRequest.target': 'Vorschlag: {size}',
    'classRequest.pickFor': 'Gerät für Position {n}: {name}',
    'classRequest.noCandidates': 'Keine freien Geräte dieser Kategorie in diesem Zeitraum.',
    'classRequest.fitBest': 'passt',
    'classRequest.fitNear': 'nah dran',
    'classRequest.showAll': 'Alle anzeigen ({n})',
    'classRequest.unassign': 'Gewähltes Gerät entfernen',
    'classRequest.assignError': 'Das Gerät konnte nicht gewählt werden.',
    'classRequest.confirm': 'Bestätigen und Zahlungsdaten senden',
    'classRequest.confirmNoPaymentDetails': 'Verfügbarkeit bestätigen',
    'classRequest.confirming': 'Wird bestätigt…',
    'classRequest.confirmMissingTitle': 'Noch nicht alles gewählt',
    'classRequest.confirmMissingBody': 'Für {n} Position(en) fehlt noch ein Gerät. Sie können jetzt bestätigen und die Geräte später, vor der Ausgabe, wählen.',
    'classRequest.confirmAnyway': 'Jetzt bestätigen',
    'classRequest.keepAssigning': 'Erst wählen',
    'classRequest.confirmedOnline': 'Bestätigt. Der Kunde hat eine E-Mail mit dem Zahlungslink erhalten.',
    'classRequest.confirmedTransfer': 'Bestätigt. Der Kunde hat eine E-Mail mit den Überweisungsdaten erhalten.',
    'classRequest.confirmedContact': 'Bestätigt. Der Kunde hat eine E-Mail mit der Bitte um Kontakt wegen der Zahlung erhalten.',
    'classRequest.confirmedNoMail': 'Bestätigt, aber die E-Mail an den Kunden ging nicht raus. Rufen Sie ihn an und klären Sie die Zahlung.',
    'classRequest.confirmError': 'Die Anfrage konnte nicht bestätigt werden.',
    'classRequest.decline': 'Anfrage ablehnen',
    'classRequest.declineMessage': 'Nachricht an den Kunden (optional)',
    'classRequest.declinePlaceholder': 'Z. B. keine Ski in dieser Größe, gerne zu einem anderen Termin.',
    'classRequest.declineSend': 'Ablehnen und Kunden benachrichtigen',
    'classRequest.declining': 'Wird abgelehnt…',
    'classRequest.back': 'Zurück',
    'classRequest.declined': 'Anfrage abgelehnt. Der Kunde hat eine E-Mail erhalten.',
    'classRequest.declinedNoMail': 'Anfrage abgelehnt. Die E-Mail an den Kunden ging nicht raus, rufen Sie ihn an.',
    'classRequest.declineError': 'Die Anfrage konnte nicht abgelehnt werden.',
    'classRequest.tagAwaiting': 'Zu bestätigen',
    'classRequest.tagToAssign': 'Zu wählen: {n}',
    'classRequest.number': 'Nr. {n}',
    'notifications.staffCard': 'Benachrichtigungen für den Verleih',
    'notifications.staffWidgetLabel': 'E-Mail bei neuer Widget-Reservierung',
    'notifications.staffWidgetDesc': 'Wenn ein Kunde auf Ihrer Website reserviert, erhalten Sie eine E-Mail mit Kundendaten, Zeitraum, Ausrüstung und einem Link zur Reservierung. Eine Antwort darauf geht an den Kunden.',
    'notifications.staffEmailLabel': 'Benachrichtigungsadresse',
    'notifications.staffEmailPlaceholder': 'z. B. reservierung@ihrefirma.de',
    'notifications.staffEmailHint': 'Leer: Versand an die E-Mail aus den Firmendaten, ohne diese an die Administratoren des Kontos.',
    'equipmentNumber.moveTitle': 'Nummer übertragen?',
    'equipmentNumber.moveTitleMany': 'Nummern übertragen?',
    'equipmentNumber.moveOne': 'Die Nummer {number} gehört dem inaktiven Gerät „{name}“. Nach der Übertragung hat dieses Gerät keine Nummer mehr, {number} bleibt in seinem Verlauf.',
    'equipmentNumber.moveMany': 'Die Nummern {numbers} gehören inaktiven Geräten. Nach der Übertragung haben diese keine Nummern mehr, die alten Nummern bleiben im Verlauf.',
    'equipmentNumber.moveConfirm': 'Nummer übertragen',
    'equipmentNumber.moveConfirmMany': 'Nummern übertragen',
    'equipmentNumber.moveCancel': 'Andere Nummer eingeben',
    'equipmentNumber.previous': 'Vorherige Nummer: {number} (auf ein anderes Gerät übertragen)',
    'companyLookup.button': 'Daten abrufen',
    'companyLookup.buttonTitle': 'Name, REGON und Adresse aus dem Firmenregister übernehmen',
    'companyLookup.loading': 'Firma wird im Register gesucht…',
    'companyLookup.loadingShort': 'Suche…',
    'companyLookup.foundGus': 'Name, REGON und Adresse aus dem REGON-Register (GUS) übernommen. Bitte vor dem Ausstellen prüfen.',
    'companyLookup.foundVat': 'Name, REGON und Adresse aus der Liste der USt-Pflichtigen übernommen. Bitte vor dem Ausstellen prüfen.',
    'companyLookup.notFound': 'Das Register kennt keine Firma mit dieser NIP. Bitte Daten manuell eingeben.',
    'companyLookup.invalidNip': 'Geben Sie eine gültige NIP ein (10 Ziffern).',
    'companyLookup.tooMany': 'Zu viele Registerabfragen. Versuchen Sie es in einigen Minuten erneut oder geben Sie die Daten manuell ein.',
    'companyLookup.unavailable': 'Das Firmenregister antwortet nicht. Daten manuell eingeben oder gleich erneut versuchen.',
    'labels.logo.title': 'Logo auf dem Etikett',
    'labels.logo.loading': 'Logo wird geladen…',
    'labels.logo.sourceLabel': 'Eigenes Etikettenlogo',
    'labels.logo.sourceCompany': 'Logo aus den Firmendaten',
    'labels.logo.sourceNone': 'Kein Logo: Etiketten werden ohne Logo gedruckt',
    'labels.logo.empty': 'kein Logo',
    'labels.logo.previewAlt': 'Logo auf dem Etikett',
    'labels.logo.upload': 'Etikettenlogo hochladen',
    'labels.logo.replace': 'Etikettenlogo ändern',
    'labels.logo.saving': 'Wird gespeichert…',
    'labels.logo.useCompany': 'Logo aus den Firmendaten verwenden',
    'labels.logo.adminOnly': 'Das Etikettenlogo ändert ein Administrator.',
    'labels.logo.hint': 'Am besten quer, einfarbig, ohne Hintergrund (PNG oder SVG), bis 1 MB.',
    'labels.logo.print': 'Logo drucken',
    'labels.logo.tooBig': 'Die Datei ist zu groß (max. 1 MB).',
    'labels.logo.wrongType': 'Wählen Sie ein PNG-, JPG-, WEBP- oder SVG-Bild.',
    'labels.logo.readError': 'Die Datei konnte nicht gelesen werden.',
    'labels.logo.saveError': 'Das Etikettenlogo konnte nicht gespeichert werden.',
    'labels.skip': 'Erste Felder des Bogens überspringen',
    'labels.skipHint': 'Für einen angebrochenen Bogen, von dem schon Etiketten abgezogen wurden.',
    'labels.empty': 'Keine Geräte zum Drucken.',
    'labels.systemCodeNote': '{count} Stück haben weder Inventarnummer noch Herstellercode, daher erhalten sie einen Systemcode (RNT-…), der vom Scanner genauso erkannt wird.',
    'labels.nonAsciiNote': 'Barcodes können keine Sonderzeichen enthalten, daher erhalten diese Geräte im Barcode den Systemcode: {names}',
    'handover.title': 'Ausgabe und Rückgabe',
    'handover.tabs.pickup': 'Ausgabe',
    'handover.tabs.return': 'Rückgabe',
    'handover.cameraTitle.pickup': 'Ausgegebene Geräte scannen',
    'handover.cameraTitle.return': 'Zurückgegebene Geräte scannen',
    'handover.progress.pickup': '{n} von {total} ausgegeben',
    'handover.progress.return': '{n} von {total} zurückgegeben',
    'handover.scanHint': 'Scanne das Etikett mit Lesegerät, Kamera oder Handy. Das Gerät wird sofort abgehakt und gespeichert.',
    'handover.mark.pickup': 'Ausgeben',
    'handover.mark.return': 'Annehmen',
    'handover.undo': 'Rückgängig',
    'handover.heldElsewhere': 'Dieser Artikel ist noch beim vorherigen Kunden',
    'handover.markAll.pickup': 'Restliche ausgeben ({n})',
    'handover.markAll.return': 'Restliche annehmen ({n})',
    'handover.allDone.pickup': 'Alle Geräte ausgegeben.',
    'handover.allDone.return': 'Alle Geräte zurückgegeben.',
    'handover.scan.notInReservation': 'Code {code} gehört nicht zu dieser Reservierung. Prüfe, ob es das richtige Gerät ist.',
    'handover.scan.already.pickup': '{name}: bereits ausgegeben ({time}).',
    'handover.scan.already.return': '{name}: bereits zurückgegeben ({time}).',
    'handover.scan.done.pickup': 'Ausgegeben: {name} ({n}/{total})',
    'handover.scan.done.return': 'Zurückgegeben: {name} ({n}/{total})',
    'handover.saveError': 'Speichern fehlgeschlagen. Versuche es erneut.',
    'handover.returnBeforeStart': 'Eine Rückgabe kann nicht vor Beginn der Reservierung erfasst werden. Hat der Kunde abgesagt, stornieren Sie die Reservierung.',
    'handover.loadError': 'Ausgabe- und Rückgabestatus konnte nicht geladen werden.',
    'handover.noItems': 'Die Reservierung hat keine Geräte.',
    'handover.cancelled': 'Die Reservierung ist storniert, daher sind Ausgabe und Rückgabe gesperrt.',
    'handover.notAvailable': 'Ausgabe und Rückgabe sind derzeit nicht verfügbar.',
    'reservation.scan.pickDatesFirst': 'Wähle zuerst den Zeitraum. Der Scan fügt an diesen Tagen verfügbare Geräte hinzu.',
    'reservation.scan.added': 'Hinzugefügt: {name}',
    'reservation.scan.alreadyAdded': '{name} ist bereits in der Reservierung.',
    'reservation.scan.unavailable': '{name} ist im gewählten Zeitraum belegt oder nicht verfügbar.',
    'reservation.scan.unknown': 'Kein Gerät mit dem Code {code} gefunden.',
    'reservation.offerGone.notFound': 'Das Angebot, aus dem dieses Formular ausgefüllt wurde, existiert nicht mehr: Es ist abgelaufen oder wurde gelöscht. Die Verknüpfung mit dem Angebot wurde entfernt, Sie können die Reservierung also ohne Angebot speichern.',
    'reservation.offerGone.converted': 'Aus diesem Angebot wurde bereits eine Reservierung erstellt. Prüfen Sie den Kalender, bevor Sie eine weitere hinzufügen. Soll es eine separate Reservierung sein, lösen Sie das Angebot und speichern Sie erneut.',
    'reservation.offerGone.openCalendar': 'Kalender öffnen',
    'reservation.offerGone.unlink': 'Angebot lösen',
    'reservation.offerGone.unlinked': 'Angebot gelöst. Beim Speichern entsteht eine separate Reservierung ohne Verknüpfung zum Angebot.',
    'reservation.offerPrice': 'Preis und Rabatt aus dem Angebot, zu zahlen {amount}. Eine Änderung der Ausrüstung oder des Zeitraums berechnet den Preis neu.',
    'inventory.scanFound': 'Gefunden: {name}',
    'inventory.scanNotFound': 'Kein Gerät mit dem Code {code}',
    'addEquipment.scanFilled': 'Code eingetragen: {code}',
    'equipmentDetails.scanHint': 'Etikettencode scannen:',
    'addEquipment.scanHint': 'Du kannst den Code mit einem Lesegerät scannen, er landet dann hier. Scanne, wenn der Cursor in keinem Feld steht.',
    'addEquipment.scanDone': '✓ Code vom Lesegerät eingetragen.',
    'inventory.filterClearOne': 'Filter zurücksetzen: {name}',
    'inventory.clearAll': 'Alles zurücksetzen',
    'inventory.applyFilters': 'Filter anwenden',
    'inventory.availability': 'Verfügbarkeit',
    'inventory.filters': 'Filter',
    'inventory.customFields': 'Zusatzfelder',
    'inventory.resultsCount': 'Ergebnisse',
    'inventory.noResults': 'Keine Ergebnisse für die gewählten Filter',
    'inventory.emptyState': 'Keine Geräte im Lager',
    'inventory.clearFiltersToSeeAll': 'Filter zurücksetzen, um alles zu sehen',
    'inventory.deletionScheduled': 'Wird gleich gelöscht...',
    'inventory.tooltip.maintenanceDate': 'Datum des letzten Service (Format: JJJJ-MM-TT)',
    'inventory.tooltip.purchaseDate': 'Kaufdatum des Geräts',
    'inventory.tooltip.condition': 'Technischer Zustand des Geräts',
    'inventory.tooltip.location': 'Lagerort',
    'inventory.tooltip.wearLevel': 'Verschleißgrad des Geräts',
    'inventory.tooltip.compatibility': 'Kompatibilität mit anderen Geräten',
    'inventory.sortBy': 'Sortieren nach',
    'addEquipment.priceOver7': 'Preis pro Tag (> 7 Tage)',
    'addEquipment.priceOver7Placeholder': 'Preis pro Tag für Vermietungen >7 Tage (PLN)',
    'addEquipment.sku': 'Code/SKU',
    'addEquipment.skuPlaceholder': 'Interner Code oder SKU',
    'addEquipment.condition': 'Zustand',
    'addEquipment.conditionPlaceholder': 'Neu / Gebraucht / Service',
    'addEquipment.location': 'Lagerort',
    'addEquipment.locationPlaceholder': 'Regal / Bereich / Halter',
    'addEquipment.tags': 'Schlagwörter',
    'addEquipment.tagsPlaceholder': 'z. B. Kinder, Aktion',
    'addEquipment.supplier': 'Lieferant',
    'addEquipment.supplierPlaceholder': 'Name des Lieferanten',
    'addEquipment.purchaseDate': 'Kaufdatum',
    'addEquipment.maintenanceDate': 'Servicedatum',
    'addEquipment.images': 'Fotos (URL)',
    'addEquipment.imagesPlaceholder': 'URLs durch Kommas getrennt',
    'addEquipment.barcode': 'Barcode / QR',
    'addEquipment.barcodePlaceholder': 'Codenummer',
    'addEquipment.priceCurrency': 'Preiswährung',
    'addEquipment.priceCurrencyPlaceholder': 'z. B. PLN',
    'addEquipment.depositCurrency': 'Kautionswährung',
    'addEquipment.depositCurrencyPlaceholder': 'z. B. PLN',
    'addEquipment.currency': 'Währung',
    'addEquipment.currencyPlaceholder': 'z. B. PLN',
    'addEquipment.currencyLoading': 'Währungen werden geladen…',
    'addEquipment.currencyNoMatches': 'Keine Treffer',
    'addEquipment.wearLevel': 'Verschleißgrad',
    'addEquipment.wearLevelPlaceholder': 'z. B. 20%',
    'addEquipment.compatibility': 'Kompatibilität',
    'addEquipment.compatibilityPlaceholder': 'z. B. NN 75 / System X',
    'addEquipment.sizeRange': 'Größenbereich',
    'addEquipment.sizeRangePlaceholder': 'z. B. 36-42',
    'addEquipment.save': 'Speichern',
    'addEquipment.cancel': 'Abbrechen',
    'addEquipment.backToInventory': 'Zurück zum Lager',

    // Add User
    'addUser.title': 'Benutzer hinzufügen',
    'addUser.firstName': 'Vorname',
    'addUser.lastName': 'Nachname',
    'addUser.email': 'Email',
    'addUser.phone': 'Telefon',
    'addUser.login': 'Login',
    'addUser.password': 'Passwort',
    'addUser.admin': 'Admin',
    'addUser.addUser': 'Benutzer hinzufügen',
    'addUser.addError': 'Fehler beim Hinzufügen des Benutzers.',
    'addUser.userCreated': 'Benutzer erstellt.',
    'addUser.fillRequired': 'Füllen Sie alle erforderlichen Felder aus',
    'addUser.passwordMismatch': 'Passwörter stimmen nicht überein',
    'addUser.passwordTooShort': 'Das Passwort muss mindestens 6 Zeichen lang sein',
    'addUser.success': 'Benutzer erfolgreich erstellt',
    'addUser.error': 'Fehler beim Erstellen des Benutzers',
    'addUser.backToList': 'Zurück zur Benutzerliste',
    'addUser.firstNamePlaceholder': 'Vorname',
    'addUser.lastNamePlaceholder': 'Nachname',
    'addUser.emailPlaceholder': 'email@beispiel.de',
    'addUser.phonePlaceholder': '+48 123 456 789',
    'addUser.passwordPlaceholder': '••••••••',
    'addUser.confirmPasswordPlaceholder': '••••••••',
    'addUser.adminInfo': 'Administratorrechte vergeben',

    // Generate Offer
    'generateOffer.save': 'Angebot speichern',
    'generateOffer.confirmSendTitle': 'Versand des Angebots bestätigen',
    'generateOffer.confirmSendMessage': 'Möchten Sie das Angebot wirklich per E-Mail senden an:',
    'generateOffer.confirmSend': 'Ja, Angebot senden',
    'generateOffer.cancelSend': 'Abbrechen',
    'generateOffer.title': 'Angebote',
    'generateOffer.subtitle': 'Angebote ansehen und verwalten',
    'generateOffer.clientData': 'Kundendaten',
    'generateOffer.searchClient': 'Kunden in der Datenbank suchen',
    'generateOffer.searchPlaceholder': 'Vorname, Nachname oder E-Mail eingeben...',
    'generateOffer.search': 'Suchen',
    'generateOffer.firstName': 'Vorname',
    'generateOffer.lastName': 'Nachname',
    'generateOffer.email': 'E-Mail',
    'generateOffer.rentalPeriod': 'Mietzeitraum',
    'generateOffer.startDateTime': 'Datum und Uhrzeit des Beginns',
    'generateOffer.endDateTime': 'Datum und Uhrzeit des Endes',
    'generateOffer.daysCount': 'Anzahl der Tage',
    'generateOffer.equipment': 'Geräte zur Miete',
    'generateOffer.addEquipment': 'Gerät zum Angebot hinzufügen',
    'generateOffer.selectEquipment': 'Gerät auswählen',
    'generateOffer.category': 'Kategorie',
    'generateOffer.brand': 'Marke',
    'generateOffer.inventoryNumber': 'Inventarnr.',
    'generateOffer.size': 'Größe',
    'generateOffer.pricePerDay': 'Preis/Tag',
    'generateOffer.total': 'Gesamt',
    'generateOffer.remove': 'Entfernen',
    'generateOffer.discount': 'Rabatt',
    'generateOffer.percent': 'Prozent (%)',
    'generateOffer.amount': 'Betrag (zł)',
    'generateOffer.subtotal': 'Bruttowert:',
    'generateOffer.discountAmount': 'Rabatt:',
    'generateOffer.totalPrice': 'Gesamtwert des Angebots:',
    'generateOffer.clearForm': 'Formular leeren',
    'generateOffer.generate': 'Angebot erstellen',
    'generateOffer.done': 'Fertig',
    'generateOffer.selectDatesFirst': 'Wählen Sie zuerst den Mietzeitraum',
    'generateOffer.fillClientData': 'Ergänzen Sie die Kundendaten (Vorname, Nachname, E-Mail)',
    'generateOffer.addEquipmentFirst': 'Fügen Sie mindestens ein Gerät hinzu',
    'generateOffer.quotePending': 'Der Preis wird nach der Preisliste neu berechnet. Bitte gleich erneut versuchen.',
    'reservation.quotePending': 'Der Preis wird nach der Preisliste neu berechnet. Bitte gleich speichern.',
    'generateOffer.history.issued': 'Ausgestellt am {issued}',
    'generateOffer.history.issuedValidUntil': 'Ausgestellt am {issued}, gültig bis {validUntil}',
    'generateOffer.history.expired': 'Das Angebot ist am {validUntil} abgelaufen. Beim Erstellen wird eine Kopie mit dem ursprünglichen Datum und der ursprünglichen Gültigkeit heruntergeladen, beim Senden per E-Mail wird es mit dem heutigen Datum neu ausgestellt.',
    'generateOffer.history.inBundle': 'im Paket',
    'generateOffer.history.changedAfterSend': 'Das Angebot wurde nach dem Versand geändert: Der Kunde hat die am {issued} ausgestellte Fassung. Beim Erstellen wird das geänderte Angebot mit dem heutigen Datum und ab heute gezählter Gültigkeit heruntergeladen, beim Senden per E-Mail geht es an den Kunden.',
    'generateOffer.history.ratePerDay': '{amount} PLN/Tag',
    'generateOffer.errorFetchingClients': 'Die Kunden konnten nicht aus der Datenbank geladen werden',
    'generateOffer.errorFetchingEquipment': 'Die verfügbaren Geräte konnten nicht geladen werden',
    'generateOffer.noEquipmentAvailable': 'Im gewählten Zeitraum sind keine Geräte verfügbar',
    'generateOffer.offerGenerated': 'Das Angebot wurde erstellt und heruntergeladen!',
    'generateOffer.errorGenerating': 'Das Angebot konnte nicht erstellt werden',
    'generateOffer.enterSearchQuery': 'Geben Sie einen Teil des Vornamens, Nachnamens oder der E-Mail ein',
    'generateOffer.days': 'Tage',
    'generateOffer.day': 'Tag',

    // Reservation (uzupełnione)
    'reservation.title': 'Reservierung hinzufügen',
    'reservation.basicData': 'Grundlegende Informationen',
    'reservation.firstname': 'Vorname',
    'reservation.lastname': 'Nachname',
    'reservation.contact': 'Kontakt',
    'reservation.contactHint': 'Ein Kontakt genügt: E-Mail oder Telefon.',
    'reservation.contactRequired': 'Geben Sie die E-Mail oder Telefonnummer des Kunden an.',
    'reservation.email': 'Email',
    'reservation.address': 'Adresse',
    'reservation.idNumber': 'Personalausweisnummer',
    'reservation.phone': 'Telefon',
    'reservation.discount': 'Rabatt',
    'reservation.discountAmount': 'Höhe des Rabatts',
    'amountField.currency': 'PLN',
    'amountField.unitGroup': 'Einheit des Rabatts',
    'amountField.discountPlaceholderPercent': 'Rabatt in %',
    'amountField.discountPlaceholderPln': 'Rabatt in PLN',
    'amountField.advancePlaceholder': 'z. B. 150,50',
    'amountField.afterDiscount': 'Nach Rabatt: {amount}',
    'amountField.error.invalid': 'Betrag eingeben, z. B. 150,50',
    'amountField.error.percentOver': 'Maximal 100 %',
    'amountField.error.amountOver': 'Maximal {max}',
    'amountField.error.checkAmounts': 'Bitte Rabatt und Anzahlung prüfen.',
    'reservation.term': 'Termin',
    'reservation.range': 'Datumsbereich',
    'reservation.from': 'Von',
    'reservation.to': 'Bis',
    'reservation.paymentMethod': 'Zahlungsmethode',
    'reservation.chooseEquipment': 'Ausrüstung wählen',
    'reservation.selectedEquipment': 'Ausgewählte Ausrüstung',
    'reservation.noEquipment': 'Keine Ausrüstung ausgewählt.',
    'reservation.notes': 'Notizen / besondere Anforderungen',
    'reservation.summary': 'Zusammenfassung',
    'reservation.days': 'Anzahl der Tage',
    'reservation.equipmentPrice': 'Ausrüstungspreis',
    'priceBreakdown.perDayAveraged': 'Ø',
    'priceBreakdown.perDay': '{amount}/Tag',
    'priceBreakdown.ruleLabel': 'Preisliste: {rule}',
    'priceBreakdown.bundleName': '{name} - {price}/Tag (Paketpreis)',
    'priceBreakdown.bundleNameAverage': '{name} - Ø {price}/Tag (Paketpreis)',
    'priceBreakdown.recalculating': 'wird neu berechnet…',
    'priceBreakdown.baseSum': 'davon: Basissumme',
    'priceBreakdown.ruleAdjustment': 'Preislistenkorrektur',
    'priceBreakdown.bundleSaving': 'Paketersparnis',
    'reservation.advance': 'Anzahlung',
    'reservation.advancePaid': '(bezahlt)',
    'reservation.advanceUnpaid': '(unbezahlt)',
    'reservation.remainingToPay': 'Verbleibend zu zahlen',
    'reservation.clearOverride': 'Überschreibung löschen',
    'reservation.bail': 'Kaution',
    'ksefSettings.title': 'KSeF: E-Rechnungen',
    'ksefSettings.subtitle': 'Versand strukturierter Rechnungen an das nationale E-Rechnungssystem (USt-Rechnungen und Korrekturen für Unternehmen).',
    'ksefSettings.loading': 'Wird geladen…',
    'ksefSettings.loadError': 'KSeF-Einstellungen konnten nicht geladen werden.',
    'ksefSettings.configCardTitle': 'KSeF-Konfiguration',
    'ksefSettings.authIntro': 'Die Verbindung zu KSeF erfolgt per Token oder KSeF-Zertifikat. Beide Methoden funktionieren gleich: Ein Token ist eine Zeichenfolge zum Einfügen, ein Zertifikat besteht aus zwei Dateien und einem Passwort und wird alle 2 Jahre erneuert.',
    'ksefSettings.step1': 'Melden Sie sich mit der Steuernummer des Unternehmens in der KSeF-Steuerpflichtigen-App (podatki.gov.pl) an.',
    'ksefSettings.step2': 'Generieren Sie einen Token mit Berechtigung zur Rechnungsausstellung oder beantragen Sie ein KSeF-Zertifikat mit dem Zweck „Authentifizierung im KSeF-System“ (Anleitung unten).',
    'ksefSettings.step3': 'Fügen Sie den Token ein oder wählen Sie die Zertifikats- und Schlüsseldatei, speichern Sie und prüfen Sie die Verbindung. Beginnen Sie mit der Testumgebung.',
    'ksefSettings.tokenFutureHint': 'Das Finanzministerium hat angekündigt, dass KSeF-Token auch nach 2026 funktionieren, ein funktionierender Token muss also nicht geändert werden. Sollte sich das ändern, informieren wir Sie hier.',
    'ksefSettings.tokenSunsetHint': 'KSeF-Token funktionieren bis {date}. Wechseln Sie vor diesem Tag zur Methode „KSeF-Zertifikat“ (Anleitung unten).',
    'ksefSettings.tokenSunsetPassed': 'KSeF-Token funktionieren seit {date} nicht mehr. Wechseln Sie zur Methode „KSeF-Zertifikat“ (Anleitung unten).',
    'ksefSettings.certGuideTitle': 'So erhalten Sie ein KSeF-Zertifikat',
    'ksefSettings.certGuideIntro': 'Das Finanzministerium stellt KSeF-Zertifikate kostenlos in der KSeF-Steuerpflichtigen-App aus. Das dauert etwa 15 Minuten und geht am bequemsten am Computer.',
    'ksefSettings.certGuidePrepTitle': 'Was Sie vorbereiten sollten',
    'ksefSettings.certGuidePrep1': 'Die Steuernummer (NIP) des Unternehmens.',
    'ksefSettings.certGuidePrep2': 'Eine Anmeldemöglichkeit für KSeF: bei Einzelunternehmen Profil Zaufany, mObywatel oder eine qualifizierte Signatur; bei Gesellschaften eine Person mit KSeF-Berechtigung zur Rechnungsausstellung für die Steuernummer der Gesellschaft oder das qualifizierte Siegel der Gesellschaft.',
    'ksefSettings.certGuidePrep3': 'Einen sicheren Ort für das Passwort, zum Beispiel einen Passwortmanager.',
    'ksefSettings.certGuideStepsTitle': 'Schritt für Schritt',
    'ksefSettings.certGuideStep1': 'Öffnen Sie ap.ksef.mf.gov.pl (KSeF-Steuerpflichtigen-App), melden Sie sich an und wählen Sie die Steuernummer Ihres Unternehmens.',
    'ksefSettings.certGuideStep2': 'Öffnen Sie die Registerkarte „Zertifikate“ und wählen Sie „Zertifikat beantragen“.',
    'ksefSettings.certGuideStep3': 'Geben Sie einen Namen für das Zertifikat ein, zum Beispiel „theRENT“, am besten ohne polnische Buchstaben.',
    'ksefSettings.certGuideStep4': 'Legen Sie ein Schlüsselpasswort fest: 15 bis 32 Zeichen, mit Groß- und Kleinbuchstaben (ohne polnische Buchstaben), einer Ziffer und einem Sonderzeichen. Notieren Sie es sofort, denn dieses Passwort lässt sich weder wiederherstellen noch ändern.',
    'ksefSettings.certGuideStep5': 'Klicken Sie auf „Generieren“. Der Browser speichert eine Datei mit der Endung .key, den privaten Schlüssel. Senden Sie ihn niemandem per E-Mail.',
    'ksefSettings.certGuideStep6': 'Wählen Sie als Zweck „Authentifizierung im KSeF-System“. Wählen Sie nicht „Signatur des Prüflinks des Ausstellers“: Das ist ein Zertifikat für den Offline-Modus, das sich nicht zum Verbinden eignet.',
    'ksefSettings.certGuideStep7': 'Lassen Sie als Gültigkeitsbeginn das heutige Datum, senden Sie den Antrag und aktualisieren Sie die Liste, bis das Zertifikat aktiv ist. Ein Zertifikat, das erst ab einem späteren Tag gilt, können Sie hier erst an diesem Tag hochladen.',
    'ksefSettings.certGuideStep8': 'Markieren Sie das neue Zertifikat und laden Sie es im PEM-Format herunter. Es wird eine Datei mit der Endung .crt gespeichert.',
    'ksefSettings.certGuideStep9': 'Wählen Sie hier die Methode „KSeF-Zertifikat“ und die Produktionsumgebung (Zertifikat aus ap.ksef.mf.gov.pl), wählen Sie die .crt- und die .key-Datei, geben Sie das Passwort ein, speichern Sie und klicken Sie auf „Verbindung zu KSeF prüfen“.',
    'ksefSettings.certGuideNotesTitle': 'Gut zu wissen',
    'ksefSettings.certGuideNote1': 'Wir speichern das Passwort nicht. Der Schlüssel wird verschlüsselt gespeichert und nie angezeigt.',
    'ksefSettings.certGuideNote2': 'Ein Zertifikat gilt höchstens 2 Jahre. Ein neues können Sie einen Monat vor Ablauf des alten beantragen; das Ablaufdatum steht oben beim gespeicherten Zertifikat.',
    'ksefSettings.certGuideNote3': 'Von the.rENT gesendete Rechnungen erscheinen in KSeF als im Namen des Unternehmens von der Person gesendet, auf die das Zertifikat ausgestellt wurde.',
    'ksefSettings.certGuideNote4': 'Wenn Sie auch eine Buchhaltungssoftware nutzen, erzeugen Sie für the.rENT ein eigenes Zertifikat. Bei Problemen widerrufen Sie eines, und das andere funktioniert weiter.',
    'ksefSettings.certGuideNote5': 'Datei .key oder Passwort verloren: Widerrufen Sie das Zertifikat in der Steuerpflichtigen-App (Registerkarte „Zertifikate“) und erzeugen Sie ein neues.',
    'ksefSettings.certGuideMfLink': 'Seite des Finanzministeriums zu KSeF-Zertifikaten',
    'ksefSettings.certSavedWithDate': 'Zertifikat gespeichert (verschlüsselt), gültig bis {date}',
    'ksefSettings.certSaved': 'Zertifikat gespeichert (verschlüsselt)',
    'ksefSettings.noCert': 'Kein Zertifikat',
    'ksefSettings.tokenSaved': 'Token gespeichert (verschlüsselt)',
    'ksefSettings.noToken': 'Kein Token',
    'ksefSettings.sendingEnabled': 'Versand aktiviert',
    'ksefSettings.sendingDisabled': 'Versand deaktiviert',
    'ksefSettings.certSubjectLabel': 'Zertifikatsinhaber: {subject}',
    'ksefSettings.environment': 'Umgebung',
    'ksefSettings.envTest': 'Test (TE), Rechnungen ohne Rechtswirkung',
    'ksefSettings.envDemo': 'Vorproduktion (Demo)',
    'ksefSettings.envProd': 'Produktion, rechtsverbindliche Rechnungen',
    'ksefSettings.authMethod': 'Authentifizierungsmethode',
    'ksefSettings.authMethodToken': 'KSeF-Token',
    'ksefSettings.authMethodCert': 'KSeF-Zertifikat',
    'ksefSettings.tokenLabel': 'KSeF-Token',
    'ksefSettings.tokenPlaceholderSaved': '•••••••• (leer lassen, um nichts zu ändern)',
    'ksefSettings.tokenPlaceholderEmpty': 'Token aus der Steuerpflichtigen-App einfügen',
    'ksefSettings.certPemLabel': 'KSeF-Zertifikat (PEM)',
    'ksefSettings.certKeyLabel': 'Privater Schlüssel des Zertifikats (PEM)',
    'ksefSettings.pemPlaceholderSaved': 'Gespeichert, leer lassen, um nichts zu ändern',
    'ksefSettings.certFileLabel': 'Zertifikatsdatei (.crt oder .cer)',
    'ksefSettings.keyFileLabel': 'Datei des privaten Schlüssels (.key)',
    'ksefSettings.keyPasswordLabel': 'Passwort des privaten Schlüssels',
    'ksefSettings.keyPasswordHint': 'Das Passwort, das beim Erzeugen des Zertifikats in der KSeF-Steuerpflichtigen-App festgelegt wurde. Es dient nur zum Lesen des Schlüssels beim Speichern: Wir speichern das Passwort nicht, der Schlüssel wird verschlüsselt gespeichert.',
    'ksefSettings.fileChosen': 'Ausgewählt: {name}',
    'ksefSettings.fileSavedHint': 'Gespeichert. Wählen Sie nur dann eine Datei, wenn Sie sie ersetzen möchten.',
    'ksefSettings.fileReadError': 'Die Datei {name} konnte nicht gelesen werden.',
    'ksefSettings.fileTooLarge': 'Die Datei {name} ist zu groß für ein Zertifikat oder einen Schlüssel. Prüfen Sie, ob es die richtige Datei ist.',
    'ksefSettings.pasteToggle': 'Manuell als Text einfügen (PEM)',
    'ksefSettings.testConnection': 'Verbindung zu KSeF prüfen',
    'ksefSettings.testing': 'Wird geprüft…',
    'ksefSettings.testHint': 'Prüft die gespeicherten Einstellungen: verbindet sich mit KSeF im Namen der Steuernummer aus den Firmendaten, ohne eine Rechnung zu senden.',
    'ksefSettings.testOk': 'Die Verbindung funktioniert. KSeF hat das {method} in der Umgebung {env} akzeptiert.',
    'ksefSettings.testMethodToken': 'Token',
    'ksefSettings.testMethodCert': 'Zertifikat',
    'ksefSettings.envTestShort': 'Test',
    'ksefSettings.envDemoShort': 'Vorproduktion',
    'ksefSettings.envProdShort': 'Produktion',
    'ksefSettings.testError': 'Die Verbindung zu KSeF konnte nicht geprüft werden.',
    'ksefSettings.enableSending': 'Versand an KSeF aktivieren',
    'ksefSettings.autoSendLabel': 'Nach Ausstellung einer USt-Rechnung/Korrektur automatisch senden',
    'ksefSettings.autoSendHint': 'Der automatische Versand ist optional (Opt-in) und läuft im Hintergrund. Ein KSeF-Ausfall blockiert nie die Rechnungsausstellung, sondern belässt sie für den manuellen Versand „An KSeF senden“.',
    'ksefSettings.saveSettings': 'Einstellungen speichern',
    'ksefSettings.saving': 'Wird gespeichert…',
    'ksefSettings.saveError': 'Speichern fehlgeschlagen',
    'ksefSettings.saved': 'KSeF-Einstellungen gespeichert.',
    'ksefSettings.howItWorksTitle': 'Wie funktioniert der Versand?',
    'ksefSettings.howItWorksBody': 'In der Rechnungsliste erscheint bei USt-Rechnungen und Korrekturen die Schaltfläche „An KSeF senden“. Nach Annahme erhält die Rechnung eine KSeF-Nummer und wird rechtsverbindlich. Proformarechnungen und Quittungen werden nicht gesendet. Die Testumgebung ermöglicht es, den gesamten Prozess sicher zu prüfen, bevor die Produktion aktiviert wird.',
    'paymentThankYou.backToShop': 'Zurück zur Website des Verleihs',
    'paymentThankYou.cancelledTitle': 'Zahlung abgebrochen',
    'paymentThankYou.cancelledDesc': 'Es ist nichts passiert. Sie können zur E-Mail zurückkehren und es erneut versuchen.',
    'paymentThankYou.depositAlreadyTitle': 'Kaution ist bereits blockiert',
    'paymentThankYou.depositTitle': 'Kaution blockiert',
    'paymentThankYou.depositDesc1': 'Es wurde kein Geld abgebucht. Dies ist eine Blockierung auf der Karte, die nach unbeschädigter Rückgabe der Ausrüstung freigegeben wird.',
    'paymentThankYou.contactHint': 'Bei Fragen antworten Sie bitte auf die erhaltene E-Mail.',
    'paymentThankYou.alreadyPaidTitle': 'Zahlung wurde bereits registriert',
    'paymentThankYou.thankYouTitle': 'Vielen Dank für Ihre Zahlung!',
    'paymentThankYou.alreadyPaidDesc': 'Für diese Reservierung ist bereits eine Zahlung registriert.',
    'paymentThankYou.paidDesc': 'Ihre Zahlung wurde angenommen. Die Bestätigung senden wir an Ihre E-Mail-Adresse.',
    'paymentThankYou.shopSeesPayment': 'Der Verleih sieht Ihre Zahlung. Bei Fragen antworten Sie bitte auf die erhaltene E-Mail.',
    'paymentReturn.title': 'Zahlung',
    'paymentReturn.subtitle': 'Status der Online-Zahlung.',
    'paymentReturn.status.pending.title': 'Zahlung wird geprüft…',
    'paymentReturn.status.pending.desc': 'Die Zahlungsbestätigung kann einen Moment dauern.',
    'paymentReturn.status.paid.title': 'Bezahlt ✓',
    'paymentReturn.status.paid.desc': 'Die Zahlung wurde verbucht.',
    'paymentReturn.status.paid.descAdvance': 'Die Anzahlung wurde verbucht.',
    'paymentReturn.status.failed.title': 'Zahlung fehlgeschlagen',
    'paymentReturn.status.failed.desc': 'Die Zahlung konnte nicht bestätigt werden. Bitte versuchen Sie es erneut.',
    'paymentReturn.status.cancelled.title': 'Zahlung abgebrochen',
    'paymentReturn.status.cancelled.desc': 'Die Zahlung wurde unterbrochen.',
    'paymentReturn.status.unknown.title': 'Keine Zahlungsinformationen',
    'paymentReturn.status.unknown.desc': 'Diese Zahlung wurde nicht gefunden.',
    'paymentReturn.stuckDesc': 'Zahlung noch nicht bestätigt. Die Bestätigung kann einen Moment dauern, prüfen Sie es gleich noch einmal.',
    'paymentReturn.retry': 'Erneut prüfen',
    'paymentReturn.backToCalendar': 'Zurück zum Kalender',
    'reservation.perDay': 'Tag',
    'reservation.discountLabel': 'Rabatt',
    'reservation.toPay': 'Zu zahlen',

    // PaymentSettings
    'paymentSettings.title': 'Online-Zahlungen',
    'paymentSettings.subtitle': 'Akzeptieren Sie BLIK- und Kartenzahlungen. Kundengeld geht direkt auf Ihr Konto (Stripe).',
    'paymentSettings.cardTitle': 'Zahlungskonto (Stripe)',
    'paymentSettings.loading': 'Wird geladen…',
    'paymentSettings.loadError': 'Zahlungseinstellungen konnten nicht geladen werden.',
    'paymentSettings.returnedFromStripe': 'Sie sind von Stripe zurück. Den aktuellen Kontostatus sehen Sie unten.',
    'paymentSettings.serverMissingTitle': 'Online-Zahlungen sind auf dem Server noch nicht aktiviert',
    'paymentSettings.serverMissingBody': 'Diese the.rENT-Installation hat keinen konfigurierten Stripe-Schlüssel, daher kann kein Konto verbunden und keine Online-Zahlung angenommen werden. Der Serveradministrator muss die Variable {envVar} setzen (Testmodus-Schlüssel {testKey} in der Entwicklung, Live-Schlüssel in der Produktion) und das Backend neu starten. Nehmen Sie bis dahin Anzahlungen bar oder per Überweisung entgegen - die Überweisungsdaten werden in der Reservierungsbestätigung versendet.',
    'paymentSettings.onboardIntro': 'Die Verbindung dauert wenige Minuten und erfolgt auf der sicheren Seite von Stripe:',
    'paymentSettings.step1': 'Klicken Sie auf „Mit Stripe verbinden“.',
    'paymentSettings.step2': 'Geben Sie Firmendaten und Bankkontonummer an (dorthin gehen die Auszahlungen).',
    'paymentSettings.step3': 'Sie kehren automatisch hierher zurück. Sobald der Status auf „Aktiv“ wechselt, können Sie Zahlungen annehmen.',
    'paymentSettings.connectButton': 'Mit Stripe verbinden',
    'paymentSettings.redirecting': 'Weiterleitung…',
    'paymentSettings.statusIncomplete': 'Einrichtung unvollständig',
    'paymentSettings.statusUnknown': 'Kontostatus konnte nicht geprüft werden',
    'paymentSettings.statusUnknownHint': 'Stripe war gerade nicht erreichbar, daher wissen wir nicht, ob das Konto Zahlungen annimmt. Das bedeutet nicht unbedingt, dass die Einrichtung unvollständig ist. Aktualisieren Sie den Status in einem Moment.',
    'paymentSettings.statusStaleHint': 'Stripe war gerade nicht erreichbar. Angezeigt wird der zuletzt bekannte Kontostatus.',
    'paymentSettings.statusPaused': 'Pausiert: Online-Zahlungen werden nicht angenommen',
    'paymentSettings.statusActive': 'Aktiv: Sie können Zahlungen annehmen',
    'paymentSettings.needsMoreDataHint': 'Stripe benötigt noch Firmendaten (oder diese werden gerade geprüft). Schließen Sie die Einrichtung ab, dann wechselt der Status auf „Aktiv“.',
    'paymentSettings.finishSetup': 'Einrichtung bei Stripe abschließen',
    'paymentSettings.refreshStatus': 'Status aktualisieren',
    'paymentSettings.activeHint': 'Das Konto ist aktiv: Zahlungslinks, Kartenzahlungen am Schalter und Widget-Anzahlungen gehen auf Ihr Stripe-Konto. Auszahlungen und Transaktionsverlauf finden Sie im Stripe-Dashboard.',
    'paymentSettings.pausedHint': 'Online-Zahlungen sind pausiert. Neue Online-Zahlungen (Links, Widget, neue Kautionsblockierungen) sind gesperrt, aber Rückerstattungen, das Einziehen/Freigeben bereits gehaltener Kautionen sowie Bar-/Überweisungszahlungen funktionieren normal weiter. Setzen Sie unten fort, wenn Sie wieder Online-Zahlungen annehmen möchten.',
    'paymentSettings.advanceSectionTitle': 'Anzahlung im Widget',
    'paymentSettings.advanceSectionHint': 'Welchen Prozentsatz des Reservierungsbetrags der Kunde bei einer Buchung über das Widget online bezahlt. 100 bedeutet den vollen Betrag.',
    'paymentSettings.save': 'Speichern',
    'paymentSettings.saving': 'Wird gespeichert…',
    'paymentSettings.advanceSaved': 'Gespeichert: Bei einer Buchung im Widget zahlt der Kunde {percent}% des Betrags online.',
    'paymentSettings.saveError': 'Speichern fehlgeschlagen',
    'paymentSettings.autoCancelSectionTitle': 'Automatische Stornierung unbezahlter Reservierungen',
    'paymentSettings.autoCancelHint': 'Eine Widget-Reservierung ohne Zahlung wird nach dieser Anzahl Stunden automatisch storniert (der Kunde erhält vorher eine Zahlungserinnerung per E-Mail). Leer lassen, um die Funktion zu deaktivieren. Empfohlen: 24.',
    'paymentSettings.hoursUnit': 'Std.',
    'paymentSettings.autoCancelDisabled': 'Automatische Stornierung deaktiviert.',
    'paymentSettings.autoCancelSaved': 'Unbezahlte Widget-Reservierungen werden nach {hours} Std. storniert.',
    'paymentSettings.pauseSectionTitle': 'Online-Zahlungen pausieren',
    'paymentSettings.pausedNowHint': 'Online-Zahlungen sind jetzt pausiert. Das Stripe-Konto bleibt verbunden, daher kehrt eine Fortsetzung zum selben Konto zurück. Rückerstattungen, das Abrechnen bereits gehaltener Kautionen und Offline-Zahlungen funktionieren weiter; nur neue Online-Zahlungen sind pausiert.',
    'paymentSettings.pauseAvailableHint': 'Deaktivieren Sie vorübergehend die Annahme NEUER Online-Zahlungen (einschließlich neuer Kautionsblockierungen) bei weiterhin verbundenem Stripe-Konto. Im Gegensatz zur Trennung kehrt eine Fortsetzung zum selben Konto zurück. Rückerstattungen, das Abrechnen bereits gehaltener Kautionen und Offline-Zahlungen funktionieren weiter.',
    'paymentSettings.resumeOnline': 'Online-Zahlungen fortsetzen',
    'paymentSettings.pauseOnline': 'Online-Zahlungen pausieren',
    'paymentSettings.processing': 'Wird verarbeitet…',
    'paymentSettings.pauseConfirmTitle': 'Online-Zahlungen pausieren?',
    'paymentSettings.pauseConfirmMessage': 'Kunden können nicht mehr über Links oder das Widget bezahlen, bis Sie fortsetzen. Das Stripe-Konto bleibt verbunden (im Gegensatz zur Trennung). Nur NEUE Online-Zahlungen werden pausiert, einschließlich neuer Kautionsblockierungen. Rückerstattungen, das Einziehen und Freigeben bereits gehaltener Kautionen sowie Bar-/Überweisungszahlungen funktionieren weiter.',
    'paymentSettings.pauseFailed': 'Der Online-Zahlungsstatus konnte nicht geändert werden',
    'paymentSettings.pausedSuccess': 'Online-Zahlungen pausiert.',
    'paymentSettings.resumedSuccess': 'Online-Zahlungen fortgesetzt.',
    'paymentSettings.disconnectSectionTitle': 'Zahlungen trennen',
    'paymentSettings.disconnectHint': 'Deaktiviert die Annahme von Online-Zahlungen in the.rENT. Das Stripe-Konto Ihres Verleihs und die eingenommenen Gelder bleiben unberührt, und Sie können Zahlungen jederzeit wieder verbinden.',
    'paymentSettings.disconnectButton': 'Stripe-Konto trennen',
    'paymentSettings.disconnectConfirmTitle': 'Online-Zahlungen trennen?',
    'paymentSettings.disconnectConfirmMessage': 'Zahlungsschaltflächen und -links funktionieren nicht mehr, bis Sie das Konto erneut verbinden. Ihr Stripe-Konto und die eingenommenen Gelder bleiben unberührt.',
    'paymentSettings.disconnectFailed': 'Stripe konnte nicht getrennt werden',
    'paymentSettings.disconnectedSuccess': 'Online-Zahlungen wurden getrennt.',
    'paymentSettings.onboardFailed': 'Die Verbindung mit Stripe konnte nicht gestartet werden',
    'paymentSettings.adminOnly': 'Die Einstellungen für Online-Zahlungen stehen nur dem Administrator des Unternehmens zur Verfügung.',
    'paymentSettings.stripeLinkExpired': 'Der Stripe-Einrichtungslink ist abgelaufen oder wurde bereits verwendet. Klicken Sie auf die Schaltfläche unten, um einen neuen zu öffnen.',
    'paymentSettings.advanceRange': 'Geben Sie eine ganze Zahl von 1 bis 100 ein.',
    'paymentSettings.autoCancelOffNow': 'Aktuell: aus',
    'paymentSettings.widgetSettingsPremium': 'Die im Widget gezahlte Anzahlung und die automatische Stornierung unbezahlter Widget-Reservierungen sind im Premium-Tarif zusammen mit dem Buchungs-Widget verfügbar.',
    'paymentSettings.premiumTitle': 'Online-Zahlungen sind im Premium-Tarif enthalten.',
    'paymentSettings.premiumBody': 'Im Basic-Tarif erfassen Sie Bar- oder Überweisungszahlungen an der Reservierung. Früher gesendete Zahlungslinks funktionieren weiter.',
    'paymentSettings.premiumConnectedBody': 'Im Basic-Tarif können Sie keine neuen Zahlungslinks senden. Früher gesendete Links, Erstattungen und Kautionen funktionieren weiter, und Sie können das verbundene Stripe-Konto pausieren, trennen oder seine Einrichtung abschließen.',
    'premium.badge': 'Premium',
    'premium.badgeTitle': 'Funktion des Premium-Tarifs',
    'premium.want': 'Ich möchte Premium',
    'premium.defaultMessage': 'Diese Funktion ist im Premium-Tarif enthalten.',
    'premium.request.subject': 'Ich möchte zu Premium wechseln',
    'premium.request.body': 'Ich möchte zum Premium-Tarif wechseln. Mich interessiert: {feature}.',
    'premium.feature.widget': 'Buchungs-Widget',
    'premium.feature.own_smtp': 'E-Mails von der Adresse Ihres Verleihs',
    'premium.feature.reminders': 'automatische Erinnerungen',
    'premium.feature.sms': 'SMS an Kunden',
    'premium.feature.payment_links': 'Online-Zahlungen',
    'premium.feature.booking_link': 'Buchungslink und QR-Code',
    'premium.feature.unpaid_guard': 'Schutz vor unbezahlten Reservierungen',
    'premium.feature.other': 'Funktionen des Premium-Tarifs',
    'przerwa.tytul': 'Konto pausiert, nur Ansicht',
    'przerwa.tytulDo': 'Konto pausiert bis {do}, nur Ansicht',
    'przerwa.opis': 'Sie können die Firmendaten wie gewohnt ansehen, aber Änderungen werden nicht gespeichert. Rechnungen und KSeF funktionieren (Ausstellung, Korrektur, Zahlung auf der Rechnung, Versand, Einstellungen für Rechnungen und KSeF), ebenso Erstattungen, Kautionen, Ihr Passwort, das Entziehen des Zugangs von Mitarbeitern, das Löschen von Kundendaten und der Export der Firmendaten. Widget, Erinnerungen und Zahlungslinks sind aus.',
    'przerwa.zaplanowana': 'Ab {od} wird das Konto pausiert: Die Daten bleiben sichtbar und Rechnungen und KSeF funktionieren weiter, übriges Speichern, Widget und Zahlungslinks sind dann aus.',
    'przerwa.zapisZablokowany': 'Das Konto ist pausiert und nur lesbar. Änderungen speichern Sie nach der Wiederaufnahme.',
    'przerwa.wznowienie.przycisk': 'Wiederaufnahme anfragen',
    'przerwa.wznowienie.temat': 'Anfrage zur Wiederaufnahme des Kontos nach der Pause',
    'przerwa.wznowienie.tresc': 'Bitte nehmen Sie unser Konto nach der Pause wieder auf. Wir möchten wieder arbeiten ab: ',
    'przerwa.szablonTylkoOdczyt': 'Das Konto ist pausiert, daher ist die Vorlage nur lesbar.',
    'przerwa.wznowiona': 'Die Pause ist beendet. Sie können wieder Änderungen speichern.',
    'rezygnacja.tytul': 'Konto nach Kündigung, nur Ansicht',
    'rezygnacja.opis': 'Sie können die Firmendaten wie gewohnt ansehen. Rechnungen und KSeF funktionieren (Ausstellung, Korrektur, Zahlung auf der Rechnung, Versand, Einstellungen für Rechnungen und KSeF), ebenso Erstattungen, Kautionen, Ihr Passwort und der Export der Firmendaten. Übrige Änderungen werden nicht gespeichert, und Buchungen im Widget, Erinnerungen und Zahlungslinks sind aus.',
    'rezygnacja.usuniecie': 'Die Firmendaten können frühestens am {od} gelöscht werden. Laden Sie vorher den Datenexport herunter: eine Datei mit Ihren Daten und den Rechnungen als PDF. Die Rechnungen bewahren Sie selbst für die gesetzlich vorgeschriebene Frist auf.',
    'rezygnacja.usunieciePracownik': 'Die Firmendaten können frühestens am {od} gelöscht werden. Den Datenexport lädt der Administrator der Firma herunter.',
    'rezygnacja.eksport.przycisk': 'Datenexport herunterladen',
    'rezygnacja.eksport.opis': 'Das Konto ist gekündigt, und der Export funktioniert wie gewohnt. Laden Sie ihn herunter, bevor die Firmendaten gelöscht werden.',
    'rezygnacja.odwolanie.przycisk': 'Rücknahme der Kündigung anfragen',
    'rezygnacja.odwolanie.temat': 'Anfrage zur Rücknahme der Kündigung',
    'rezygnacja.odwolanie.tresc': 'Bitte nehmen Sie unsere Kündigung zurück. Wir möchten the.rENT weiter nutzen. ',
    'rezygnacja.zaplanowana': 'Ab {od} ist das Konto gekündigt und nur lesbar: Die Daten bleiben sichtbar, Export, Rechnungen und KSeF funktionieren weiter, Buchungen, Widget und Zahlungslinks sind dann aus.',
    'rezygnacja.zapisZablokowany': 'Das Konto ist gekündigt und nur lesbar. Sie können den Export der Firmendaten herunterladen und Rechnungen bearbeiten.',
    'rezygnacja.odwolana': 'Die Kündigung wurde zurückgenommen. Sie können wieder Änderungen speichern.',
    'rezygnacja.szablonTylkoOdczyt': 'Das Konto ist gekündigt, daher ist die Vorlage nur lesbar.',
    'rezygnacja.daneFirmy': 'Das Konto ist gekündigt: Die Firmendaten sind nur lesbar, die Rechnungseinstellungen speichern Sie wie gewohnt.',
    'reservation.choose': 'Wählen',
    'reservation.pickDate': 'Datum wählen',
    'reservation.success.saved': 'Reservierung gespeichert!',
    'reservation.error.fill': 'Füllen Sie alle erforderlichen Felder aus!',
    'reservation.error.equipment': 'Wählen Sie die Ausrüstung aus!',
    'reservation.error.save': 'Fehler beim Speichern der Reservierung.',
    'reservation.error.selectDates': 'Bitte wählen Sie zuerst die Reservierungsdaten aus!',
    'reservation.clearRangeTitle': 'Ausgewählten Zeitraum löschen',
    'reservation.notePlaceholder': 'Zusätzliche Hinweise...',
    'reservation.generateContract': 'Vertrag generieren',
    'reservation.generatingContract': 'Vertrag wird erstellt…',
    'reservation.contractGenerated': 'Der Vertrag wurde erstellt und heruntergeladen.',
    'contractError.session': 'Ihre Sitzung ist abgelaufen. Melden Sie sich erneut an und versuchen Sie es noch einmal.',
    'contractError.tooLarge': 'Die Vertragsdaten sind zu groß zum Senden. Kürzen Sie die Notiz oder verringern Sie die Anzahl der Positionen.',
    'contractError.busy': 'Der Server ist gerade ausgelastet. Bitte versuchen Sie es gleich noch einmal.',
    'contractError.noTemplate': 'Keine Vertragsvorlage gefunden. Veröffentlichen Sie eine Vorlage im Vertragseditor.',
    'contractError.server': 'Der Server hat das Dokument nicht erstellt. Prüfen Sie Ihre eigene .docx-Vorlage in den Vertragseinstellungen oder versuchen Sie es erneut.',
    'contractError.http': 'Der Server hat einen Fehler gemeldet (HTTP {status}).',
    'contractError.network': 'Keine Verbindung zum Server. Prüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.',
    'reservation.cleared': 'Formular wurde geleert',
    'reservation.contract.generated': 'Vertrag wurde erstellt und heruntergeladen',
    'reservation.subtitle': 'Erstellen Sie eine neue Ausrüstungsreservierung',
    'reservation.addressEdit': 'Adresse bearbeiten',
    'reservation.paymentAndDiscount': 'Rabatt und Zahlung',
    'reservation.paymentMethodPlaceholder': 'Zahlung wählen',

    // Validation
    'validation.required': 'Dieses Feld ist erforderlich',
    'validation.invalidEmail': 'Ungültiges E-Mail-Format',
    'validation.selectEquipment': 'Wählen Sie mindestens ein Ausrüstungsteil aus',
    'validation.fillAllFields': 'Bitte füllen Sie alle erforderlichen Felder aus, um fortzufahren.',

    // Home page
    'home.header': 'Verleih-Übersicht',
    'home.nav.calendar': 'Kalender',
    'home.nav.newReservation': 'Neue Reservierung',
    'home.nav.statistics': 'Statistiken',
    'home.nav.profile': 'Profil',
    'home.pagination.prev': 'Vorherige',
    'home.pagination.next': 'Nächste',
    'home.pagination.page': 'Seite',
    'home.pagination.of': 'von',
    'home.upcomingReservations': 'Bevorstehende Reservierungen',
    'home.loadingReservations': 'Lade Reservierungen...',
    'home.noRentals': 'Keine Vermietungen',
    'home.category.all': 'Alle Kategorien',
    'home.loading': 'Lade Daten...',
    'home.noData': 'Keine Daten',
    'home.rental.today': 'Vermietungen für heute',
    'home.rental.week': 'Vermietungen für diese Woche',
    'home.rental.month': 'Vermietungen für 30 Tage',
    'home.rental.all': 'Alle Reservierungen',
    'home.ongoingReservations': 'Laufende Reservierungen',
    'home.upcomingShort': 'Bevorstehend',
    'home.ongoingShort': 'Laufend',
    'home.kpisTitle': 'Kennzahlen',
    'home.kpisSubtitle': 'Übersicht der wichtigsten Daten Ihres Verleihs',
    'home.kpis.clients': 'Kunden',
    'home.favorites': 'Favoriten',
    'home.favorites.helper': 'Wähle bis zu 4 Seiten',
    'home.favorites.edit': 'Bearbeiten',
    'home.favorites.choose': 'Wählen Sie Seiten für Favoriten (max. 4)',
    'home.favorites.cancel': 'Abbrechen',
    'home.favorites.save': 'Speichern',
    'home.period.today': 'Heute',
    'home.period.week': 'Dieser Woche',
    'home.period.month': '30 Tage',
    'home.period.all': 'Alle',

    'home.kpis.title': 'KPIs',
    'home.kpis.totalRentals': 'Gesamtvermietungen',
    'home.kpis.availableEquipment': 'Verfügbare Ausrüstung',
    'home.kpis.activeCustomers': 'Aktive Kunden',
    'home.kpis.overdueReturns': 'Überfällige Rückgaben',

    'home.bestSellers.title': 'Am häufigsten vermietete Ausrüstung',
    'home.filter.all': 'Alle',
    'home.table.name': 'Name',
    'home.table.size': 'Größe',
    'home.table.brand': 'Marke',
    'home.table.category': 'Kategorie',
    'home.table.class': 'Klasse',
    'home.table.rentalsYear': 'Vermietungen (Jahr)',
    'home.refresh': 'Daten aktualisieren',
    'home.noCategories': 'Keine Kategorien',
    'home.favorites.desc.calendar': 'Kalenderansicht und Details der Reservierung',
    'home.favorites.desc.reservation': 'Schnell eine neue Reservierung anlegen',
    'home.favorites.desc.statistics': 'Schneller Zugriff auf Statistiken',
    'home.favorites.desc.profile': 'Kontoeinstellungen und Profil',

    // Calendar
    'calendar.title': 'Reservierungskalender',
    'calendar.titleHint': 'Reservierungen verwalten und Geräteauslastung planen',
    'calendar.addReservation': 'Reservierung hinzufügen',
    'calendar.todayButton.label': 'Heute',
    'calendar.todayButton.tooltip': 'Gehe zu heute',
    'calendar.legend.start': 'Start',
    'calendar.legend.end': 'Ende',
    'calendar.tabs.calendar': 'Kalender',
    'calendar.tabs.upcoming': 'Bevorstehend',
    'calendar.tabs.history': 'Historie',
    'calendar.tabs.returns': 'Rückgaben',
    'calendar.equipmentCountOne': '{count} Artikel',
    'calendar.equipmentCountFew': '{count} Artikel',
    'calendar.equipmentCountMany': '{count} Artikel',
    'calendar.equipmentCountOther': '{count} Artikel',
    'calendar.moreReservations': 'Noch {count} Reservierung(en) - klicken Sie auf den Tag, um alle zu sehen',
    'calendar.moreWord': 'mehr',

    'calendar.dayReservations.title': 'Reservierungen für',
    'calendar.dayReservations.empty': 'Keine Reservierungen für diesen Tag.',
    'calendar.dayReservations.noneToday': 'keine Reservierungen',

    'calendar.dayPlan.pickups': 'Ausgaben',
    'calendar.dayPlan.itemPickedUp': 'ausgegeben',
    'calendar.dayPlan.itemReturned': 'zurück',
    'calendar.dayPlan.itemReturnsToday': 'kommt heute zurück',
    'calendar.dayPlan.prepareReturningToday': 'kommt heute zurück: {count} Stk.',
    'calendar.dayPlan.returns': 'Rückgaben',
    'calendar.dayPlan.ongoing': 'Laufend',
    'calendar.dayPlan.pickupsEmpty': 'An diesem Tag wird nichts ausgegeben.',
    'calendar.dayPlan.returnsEmpty': 'An diesem Tag kommt nichts zurück.',
    'calendar.dayPlan.ongoingEmpty': 'Keine laufenden Vermietungen aus den Vortagen.',
    'calendar.dayPlan.prepare': 'Vorzubereiten',
    'calendar.dayPlan.pieces': '{count} Stk.',
    'calendar.dayPlan.noSize': 'ohne Größe',
    'calendar.dayPlan.noType': 'Ohne Kategorie',
    'calendar.dayPlan.otherEquipment': 'Sonstige Ausrüstung',
    'calendar.dayPlan.equipmentLoading': 'Inventar wird geladen...',
    'calendar.dayPlan.equipmentFailed': 'Das Inventar konnte nicht geladen werden, daher fehlt die Aufteilung nach Typ und Größe. Laden Sie die Seite neu.',
    'calendar.dayPlan.print': 'Tagesplan drucken',
    'calendar.dayPlan.printTitle': 'Tagesplan',
    'calendar.dayPlan.until': 'bis {date}',
    'calendar.dayPlan.since': 'seit {date}',
    'calendar.dayPlan.sameDayReturn': 'Rückgabe am selben Tag',
    'calendar.dayPlan.sameDayPickup': 'Ausgabe am selben Tag',
    'calendar.dayPlan.inventoryNo': 'Nr. {number}',
    'calendar.dayPlan.unknownItem': 'Artikel #{id}',
    'calendar.dayPlan.noEquipment': 'ohne Ausrüstung',
    'calendar.dayPlan.reservationNo': 'Reservierung #{id}',
    'calendar.dayPlan.printedAt': 'Gedruckt: {date}',

    'calendar.delete.refundFailed': 'Rückerstattung fehlgeschlagen: {error}. Die Reservierung wurde NICHT gelöscht. Klicken Sie erneut, um die Rückerstattung abzuschließen, oder erstatten Sie manuell über die Zahlungsliste.',
    'calendar.delete.genericError': 'Beim Stornieren der Reservierung ist ein Fehler aufgetreten.',

    // ReservationFormView
    'reservationForm.date.startBeforeToday': 'Das Startdatum kann nicht vor heute liegen.',
    'reservationForm.date.endBeforeToday': 'Das Enddatum kann nicht vor heute liegen.',
    'reservationForm.classQuote.failed': 'Der Preis dieser Klassenanfrage konnte nicht neu berechnet werden, daher lassen sich der neue Zeitraum und die Ausrüstung jetzt nicht speichern. Bitte gleich erneut versuchen.',
    'reservationForm.deposit.overrideConfirm': 'Die Kaution {amount} ist {times}x höher als die Kaution der gewählten Ausrüstung ({equipmentDeposit}). Dieser Betrag wird auf der Karte des Kunden blockiert. Trotzdem speichern?',
    'reservationForm.payment.sendLinkError': 'Der Link konnte nicht gesendet werden',
    'reservationForm.payment.linksPremium': 'Online-Zahlungslinks und Kartenzahlungen über Stripe sind im Premium-Tarif enthalten. Bar- oder Überweisungszahlungen erfassen Sie unten.',
    'reservationForm.payment.sendLinkPriceList': 'Link für den Restbetrag senden',
    'reservationForm.payment.priceListNote': 'Den Betrag im Link berechnet die Preisliste: Diese rabattierte Reservierung wurde vor der Umstellung der Betragsberechnung gespeichert, daher kann er von „Noch zu zahlen“ abweichen. Den genauen Betrag sehen Sie in der E-Mail an den Kunden und auf der Zahlungsseite.',
    'reservationForm.payment.prepareLinkError': 'Der Link konnte nicht vorbereitet werden',
    'reservationForm.payment.initError': 'Die Zahlung konnte nicht gestartet werden',
    'reservationForm.photos.addRequired': 'Fügen Sie ein Foto oder eine Notiz hinzu.',
    'reservation.save.paymentLinkFailed': 'Reservierung gespeichert, aber der Zahlungslink konnte nicht gesendet werden. Sie können ihn aus dem Kalender senden.',
    'reservation.payLinkPremium': 'Der Online-Zahlungslink ist im Premium-Tarif enthalten.',
    'reservation.save.paymentLinkFailedReason': 'Reservierung gespeichert, aber der Zahlungslink wurde nicht gesendet: {reason}',
    'reservation.save.docsPartialFailure': 'Reservierung gespeichert, aber {failed} von {total} Dokumentationseinträgen konnten nicht gespeichert werden (Grund: {reason}). Fügen Sie sie aus dem Kalender hinzu.',
    'reservation.save.docsUnconfirmed': 'Reservierung gespeichert, aber für {failed} von {total} Dokumentationseinträgen fehlt die Bestätigung der Speicherung, weil die Antwort des Servers nicht angekommen ist. Prüfen Sie die Dokumentation der Reservierung im Kalender und fügen Sie fehlende Einträge hinzu.',
    'reservation.save.docsMixed': 'Reservierung gespeichert, aber {failed} von {total} Dokumentationseinträgen konnten nicht gespeichert werden (Grund: {reason}), und für {unconfirmed} fehlt die Bestätigung der Speicherung, weil die Antwort des Servers nicht angekommen ist. Prüfen Sie die Dokumentation der Reservierung im Kalender und fügen Sie fehlende Einträge hinzu.',
    'reservationForm.photos.partialFailure': '{failed} von {total} Einträgen konnten nicht gespeichert werden. Grund: {reason}.',
    'reservationForm.photos.reasonConnection': 'vorübergehender Serverfehler',
    'reservationForm.photos.unconfirmed': 'Für {count} von {total} Einträgen fehlt die Bestätigung der Speicherung: Die Antwort des Servers ist nicht angekommen, die Speicherung kann trotzdem gelungen sein.',
    'reservationForm.photos.reasonSession': 'Ihre Sitzung ist abgelaufen, bitte melden Sie sich erneut an',
    'reservationForm.photos.reasonRejected': 'der Server hat den Eintrag nicht angenommen',
    'reservationForm.photos.removedFiles': 'Fotos, die der Server nicht annimmt, wurden aus dem Formular entfernt: {files}.',
    'reservationForm.photos.checkListBeforeRetry': 'Prüfen Sie vor dem erneuten Senden die Dokumentationsliste dieser Reservierung.',
    'reservationForm.photos.deleteConfirmTitle': 'Diesen Dokumentationseintrag löschen?',
    'reservationForm.deposit.operationError': 'Kautionsvorgang fehlgeschlagen',
    'reservationForm.offline.invalidAmount': 'Geben Sie einen gültigen Betrag ein.',
    'reservationForm.offline.confirmSaveTitle': '{what} {how} speichern?',
    'reservationForm.offline.confirmSaveMessage': 'Dadurch wird ein Zahlungseintrag erstellt. Nur verwenden, wenn der Kunde tatsächlich bezahlt hat.',
    'reservationForm.offline.saveError': 'Zahlung konnte nicht gespeichert werden',
    'reservationForm.offline.advanceWord': 'die Anzahlung',
    'reservationForm.offline.paymentWord': 'eine Zahlung von {amount}',
    'reservationForm.offline.cashWord': 'bar',
    'reservationForm.offline.transferWord': 'per Überweisung',
    'reservationForm.offline.cardWord': 'per Karte (Terminal)',
    'reservationForm.offline.amountPrompt': 'Gezahlter Betrag {how} in PLN:',
    'reservationForm.customLink.sentToClient': 'Der Link für den angegebenen Betrag wurde an den Kunden gesendet.',
    'reservationForm.customLink.copied': 'Link kopiert.',
    'reservationForm.contract.generateError': 'Vertrag konnte nicht erstellt werden: {message}',
    'reservationForm.deposit.linkSent': 'Der Link zur Kautionsblockierung wurde an den Kunden gesendet.',
    'reservationForm.deposit.linkCopied': 'Link zur Kautionsblockierung kopiert.',
    'reservationForm.deposit.invalidAmountRange': 'Ungültiger Betrag. Geben Sie einen Wert zwischen 0,01 und {max} ein.',
    'reservationForm.deposit.captureConfirm': '{amount} von der Kaution einziehen? Die verbleibende Blockierung wird freigegeben.',
    'reservationForm.deposit.releaseConfirm': 'Die gesamte Kautionsblockierung freigeben? Das Geld geht an den Kunden zurück.',
    'reservationForm.deposit.refundConfirm': '{amount} der eingezogenen Kaution an {email} erstatten?',
    'reservationForm.deposit.title': 'Kaution',
    'reservationForm.deposit.takenCash': '{amount} bar angenommen',
    'reservationForm.deposit.takenTransfer': '{amount} per Überweisung angenommen',
    'reservationForm.deposit.takenCard': '{amount} per Karte (Terminal) angenommen',
    'reservationForm.deposit.cancelledNote': 'Die Reservierung ist storniert und nimmt keine neue Kaution an.',
    'reservationForm.deposit.refundAdminOnly': 'Eine Kartenkaution erstattet ein Administrator.',
    'reservationForm.deposit.offlineHint': 'Oder die Kaution vor Ort annehmen:',
    'reservationForm.deposit.linksPremium': 'Der Link für die Kartenkaution ist im Premium-Tarif enthalten. Die Kaution in bar oder per Überweisung nehmen Sie unten an.',
    'reservationForm.deposit.offlineCash': 'Kaution bar',
    'reservationForm.deposit.offlineTransfer': 'Kaution per Überweisung',
    'reservationForm.deposit.offlineCard': 'Kaution per Karte (Terminal)',
    'reservationForm.deposit.offlineConfirm': 'Kaution von {amount} {how} angenommen erfassen?',
    'reservationForm.deposit.offlineSaved': 'Vor Ort angenommene Kaution erfasst.',
    'reservationForm.deposit.giveBack': 'Kaution zurückgeben',
    'reservationForm.deposit.giveBackConfirm': 'Rückgabe von {amount} der Kaution an den Kunden erfassen? Ein kleinerer Betrag ist ein Abzug für Schäden.',

    'calendar.delete.title': 'Reservierung stornieren',
    'calendar.delete.confirmMessage': 'Reservierung #{id} wirklich stornieren?',
    'calendar.delete.irreversible': 'Die Reservierung bleibt als storniert im Verlauf, und die Ausrüstung ist sofort wieder verfügbar. Die Stornierung kann nicht rückgängig gemacht werden.',
    'calendar.delete.paidOnline': 'Online bezahlt',
    'calendar.delete.cancelFeeLabel': 'Stornogebühr (einbehalten)',
    'calendar.delete.cancelFeeAria': 'Stornogebühr',
    'calendar.delete.cancelFeeUnitAria': 'Einheit der Stornogebühr',
    'calendar.delete.toRefund': 'Rückerstattung an Kunden',
    'calendar.delete.feeLockedHint': 'Ein Teil der Rückerstattung wurde bereits durchgeführt, daher sind die Beträge gesperrt. Klicken Sie erneut, um die Rückerstattung abzuschließen und zu löschen.',
    'calendar.delete.feeHint': 'Die Rückerstattung geht auf die Karte zurück, mit der der Kunde bezahlt hat. Der einbehaltene Teil bleibt als Stornogebühr. Lassen Sie das Feld leer, um den vollen Betrag zurückzuerstatten.',
    'calendar.delete.refundCheckFailed': 'Die bezahlten Online-Zahlungen dieser Reservierung konnten nicht geprüft werden. Falls Sie trotzdem stornieren, erstatten Sie eine eventuelle Rückerstattung manuell über die Zahlungsliste.',
    'calendar.delete.checkingPayments': 'Zahlungen werden geprüft…',
    'calendar.delete.deleting': 'Wird storniert…',
    'calendar.delete.deleteAnyway': 'Trotzdem stornieren',
    'calendar.delete.refundAndDelete': '{amount} erstatten und stornieren',
    'calendar.delete.confirmCancel': 'Reservierung stornieren',
    'calendar.delete.keep': 'Nicht stornieren',
    'calendar.delete.done': 'Reservierung #{id} storniert. Sie finden sie im Reiter „Historie“.',
    'calendar.delete.feeOverPaid': 'Die Gebühr ist höher als die Zahlung ({amount}). Korrigieren Sie den Betrag oder geben Sie 100% ein, um alles einzubehalten.',
    'calendar.delete.fixFee': 'Gebühr korrigieren',
    'calendar.delete.adminRequired': 'Für diese Reservierung wurde Geld angenommen. Stornieren kann sie nur ein Administrator, der die Erstattung von Zahlung und Kaution abwickelt.',
    'calendar.delete.paidOnSite': 'Vor Ort erhalten',
    'calendar.delete.paidOnSiteWithMethods': 'Vor Ort erhalten ({methods})',
    'calendar.delete.paidOnSiteHint': 'Dieses Geld erstattet das Panel nicht: Geben Sie es dem Kunden selbst zurück, bar oder per Überweisung.',
    'calendar.delete.paidOnInvoice': 'Auf Rechnung {number} eingetragen',
    'calendar.delete.paidOnInvoiceHint': 'Diese Zahlungen erstattet das Panel nicht: Geben Sie sie dem Kunden selbst zurück, bar oder per Überweisung.',
    'calendar.delete.depositAuthorized': 'Kaution auf der Karte blockiert',
    'calendar.delete.releaseDeposit': 'Kautionssperre beim Stornieren freigeben',
    'calendar.delete.depositKeptHint': 'Die Kaution bleibt blockiert. Sie können sie später in den Details der stornierten Reservierung freigeben.',
    'calendar.delete.depositCaptured': 'Kaution eingezogen',
    'calendar.delete.depositCapturedHint': 'Die eingezogene Kaution bleibt bei der Reservierung. Die Erstattung erfolgt über die Kautionskarte in den Reservierungsdetails.',
    'calendar.delete.depositReleaseFailed': 'Reservierung storniert, aber die Kaution konnte nicht freigegeben werden. Geben Sie sie in den Details der stornierten Reservierung frei.',

    'calendar.upcoming.title': 'Bevorstehende Reservierungen',
    'calendar.upcoming.empty': 'Keine bevorstehenden Reservierungen.',
    'calendar.returns.hint': 'Reservierungen mit Rückgabe heute, die noch nicht vollständig zurück sind, und überfällige: ausgegebene Ausrüstung, die nicht rechtzeitig zurückkam.',
    'calendar.returns.overdue': 'Überfällig',
    'calendar.returns.today': 'Rückgabe heute',
    'calendar.returns.empty': 'Es wartet nichts auf Rückgabe.',
    'calendar.returns.loadFailed': 'Die Rückgabeliste konnte nicht geladen werden. Seite neu laden.',
    'calendar.returns.lateOne': '{count} Tag überfällig',
    'calendar.returns.lateFew': '{count} Tage überfällig',
    'calendar.returns.lateMany': '{count} Tage überfällig',
    'calendar.returns.lateOther': '{count} Tage überfällig',
    'calendar.handover.out': 'Beim Kunden: {n} von {total}',
    'calendar.handover.allReturned': 'Ausrüstung zurück',

    'calendar.history.title': 'Gesamte Reservierungshistorie',
    'calendar.history.empty': 'Keine Reservierungen in der Datenbank.',
    'calendar.history.noResults': 'Keine Ergebnisse für die gewählten Kriterien.',
    'calendar.history.loadMore': 'Mehr anzeigen',
    'calendar.history.loadFailed': 'Die Reservierungshistorie konnte nicht geladen werden. Bitte erneut versuchen.',
    'calendar.history.statusFilterHint': 'Der Statusfilter gilt für geladene Reservierungen. Ältere laden Sie mit der Schaltfläche daneben.',

    'calendar.filters.from': 'Von:',
    'calendar.filters.to': 'Bis:',
    'calendar.filters.name': 'Vor- oder Nachname:',
    'calendar.filters.namePlaceholder': 'Vor- oder Nachnamen eingeben',
    'calendar.filters.status': 'Status:',
    'calendar.filters.statusAll': 'Alle',
    'calendar.filters.clear': 'Filter löschen',
    'calendar.status.upcoming': 'Bevorstehend',
    'calendar.status.ongoing': 'Laufend',
    'calendar.status.finished': 'Beendet',
    'calendar.status.cancelled': 'Storniert',
    'calendar.status.overdue': 'Überfällig',
    'calendar.status.unknown': 'Unbekannt',
    'calendar.status.nadchodząca': 'Bevorstehend',
    'calendar.status.trwająca': 'Laufend',
    'calendar.status.zakończona': 'Beendet',
    'calendar.pagination.previous': 'Vorherige',
    'calendar.pagination.next': 'Nächste',
    'calendar.pagination.pageInfo': 'Seite {page} von {total}',
    'calendar.details': 'Details',
    'calendar.startLabel': 'Start',
    'calendar.endLabel': 'Ende',
    'calendar.modal.title': 'Reservierungsdetails',
    'calendar.modal.clientData': 'Kundendaten',
    'calendar.modal.rentalPeriod': 'Mietzeitraum',
    'calendar.modal.equipment': 'Gemietete Ausrüstung',
    'calendar.modal.financial': 'Finanzinformationen',
    'calendar.modal.additional': 'Zusätzliche Informationen',
    'calendar.modal.edit': 'Bearbeiten',
    'calendar.modal.delete': 'Löschen',
    'calendar.modal.deleteConfirmTitle': 'Löschung der Reservierung bestätigen',
    'calendar.modal.deleteConfirmText': 'Sind Sie sicher, dass Sie die Reservierung löschen möchten',
    'calendar.modal.deleteWarning': 'Vorgang kann nicht rückgängig gemacht werden!',
    'calendar.modal.cancel': 'Abbrechen',
    'calendar.modal.close': 'Schließen',

    // Calendar - EDYCJA
    'calendar.edit.title': 'Reservierung bearbeiten',
    'calendar.edit.firstname': 'Vorname:',
    'calendar.edit.lastname': 'Nachname:',
    'calendar.edit.cancel': 'Abbrechen',
    'calendar.edit.save': 'Änderungen speichern',
    'calendar.edit.success': 'Reservierung wurde aktualisiert!',
    'calendar.edit.error': 'Fehler beim Aktualisieren der Reservierung',

    'calendar.paymentStatus.Opłacone': 'Bezahlt',
    'calendar.paymentStatus.Nieopłacone': 'Unbezahlt',
    'calendar.paymentStatus.Częściowo opłacone': 'Teilweise bezahlt', 
    'calendar.paymentStatus.Zwrot': 'Rückerstattung',
    
    'calendar.paymentMethod.Karta płatnicza': 'Kreditkarte',
    'calendar.paymentMethod.Gotówka': 'Bargeld',
    'calendar.paymentMethod.Przelew': 'Banküberweisung',
    'calendar.paymentMethod.BLIK': 'BLIK',
    'calendar.paymentMethod.PayPal': 'PayPal',
    'calendar.paymentMethod.Inne': 'Andere',

    'calendar.label.nameSurname': 'Name und Nachname:',
    'calendar.label.phone': 'Telefon:',
    'calendar.label.email': 'E-Mail:',
    'calendar.label.address': 'Adresse:',
    'calendar.label.idNumber': 'Personalausweisnummer:',
    'calendar.label.registrationDate': 'Kundenregistrierungsdatum:',
    'calendar.label.reservationDate': 'Reservierungsdatum:',
    'calendar.label.from': 'Von:',
    'calendar.label.to': 'Bis:',
    'calendar.label.duration': 'Dauer:',
    'calendar.label.days': 'Tage',
    'calendar.label.discount': 'Rabatt:',
    'calendar.label.status': 'Status:',
    'calendar.label.totalPrice': 'Gesamtpreis:',
    'calendar.label.deposit': 'Kaution:',
    'calendar.label.paymentStatus': 'Zahlungsstatus:',
    'calendar.label.paymentMethod': 'Zahlungsmethode:',
    'calendar.label.paymentDate': 'Zahlungsdatum:',
    'calendar.label.note': 'Notiz:',
    'calendar.label.reservationId': 'Reservierungs-ID:',
    'calendar.label.createdAt': 'Erstellt am:',
    'calendar.label.updatedAt': 'Zuletzt geändert:',

    'calendar.currency': 'zł',
    
    'calendar.weekdays': [
      "Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"
    ],
    'calendar.months': [
      "Januar", "Februar", "März", "April", "Mai", "Juni",
      "Juli", "August", "September", "Oktober", "November", "Dezember"
    ],
    'calendar.monthsShort': [
      "Jan", "Feb", "Mär", "Apr", "Mai", "Jun",
      "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"
    ],

    // Statistics
    'statistics.header': 'Statistiken zur Vermietung',
    'statistics.subtitle': 'Übersicht über wichtige Kennzahlen und Diagramme',
    'statistics.clearFilters': 'KPI-Filter löschen',
    'statistics.year': 'Jahr',
    'statistics.month': 'Monat',
    'statistics.periodFor': 'Zeitraum',
    'statistics.metric.count': 'Anzahl der Reservierungen',
    'statistics.metric.value': 'Vermietungswert',
    'statistics.bar.count': 'Anzahl der Reservierungen',
    'statistics.bar.value': 'Vermietungswert',
    'statistics.loading': 'Lade Daten...',
    'statistics.kpi.title': 'KPI',


    'statistics.section.finances': 'Finanzen',
    'statistics.summary.rentalValue': 'Mietwert im Zeitraum',
    'statistics.summary.rentalValueHint': 'Summe der Reservierungen nach Rabatten, unabhängig von ausgestellten Rechnungen. Den Rechnungsumsatz zeigt der Bereich Rechnungen.',
    'statistics.finances.valuePerActiveCustomer': 'Wert pro aktivem Kunden',



    'statistics.section.customers': 'Kunden',


    'statistics.advanced.title': 'Erweiterte Metriken',
    'statistics.advanced.periodDays': 'Tage im Zeitraum',
    'statistics.advanced.equipmentCount': 'Geräteanzahl',
    'statistics.advanced.byCategory': 'Nach Kategorie',
    'statistics.advanced.revenuePerItem': 'Umsatz / Gerät (Top)',
    'statistics.advanced.itemName': 'Gerät',
    'statistics.advanced.itemRevenue': 'Umsatz',
    'statistics.advanced.itemRentals': 'Vermietungen',
    'statistics.advanced.itemAvg': 'Ø / Vermietung',
    'statistics.advanced.inventoryNumber': 'Nr. {number}',
    'statistics.advanced.revenue': 'Umsatz',
    'statistics.advanced.rentals': 'Reservierungen',
    'statistics.prevYear': 'Vorheriges Jahr',
    'statistics.nextYear': 'Nächstes Jahr',
    'statistics.wholeYear': 'Ganzes Jahr',
    'statistics.noSeason': 'Ohne Saison',
    'statistics.seasonLabel': 'Saison',
    'statistics.season.winter': 'Winter',
    'statistics.season.spring': 'Frühling',
    'statistics.season.summer': 'Sommer',
    'statistics.season.autumn': 'Herbst',
    'statistics.loadError': 'Die Kennzahlen konnten nicht geladen werden. Bitte die Seite neu laden.',
    'statistics.chart.revenuePln': 'Mietwert (PLN)',
    'statistics.chart.reservationsCount': 'Anzahl der Reservierungen',
    'statistics.chart.hint': 'Balken, Saison oder Trend anklicken, um die KPIs einzugrenzen',
    'statistics.chart.monthlyActivity': 'Monatliche Aktivität',
    'statistics.chart.equipmentStatus': 'Ausrüstung heute',
    'statistics.chart.equipmentTotal': 'Gesamt: {count} Stück',
    'statistics.chart.itemsUnit': 'Stück',
    'statistics.chart.noData': 'Keine Daten',
    'statistics.chart.inUseToday': 'In Benutzung',
    'statistics.chart.availableToday': 'Verfügbar',
    'statistics.chart.outOfServiceToday': 'In Wartung oder inaktiv',
    'statistics.chart.seasonality': 'Saisonalität',
    'statistics.chart.bySeason': 'Saisons {year}',
    'statistics.chart.reservationsUnit': 'Res.',
    'statistics.chart.noDataFor': 'Keine Daten für {year}',
    'statistics.chart.trend': 'Monatlicher Trend',
    'statistics.badge.period': 'Zeitraum: {label}',
    'statistics.badge.activeCustomers': 'Aktive Kunden im Zeitraum: {count}',
    'statistics.badge.availableToday': 'Heute verfügbare Ausrüstung: {count}',
    'statistics.change.noComparison': 'Keine Vergleichsdaten',
    'statistics.change.vsPeriod': '{value} ggü. {period}',
    'statistics.change.comparedWith': 'ggü. {period}',
    'statistics.change.vsPeriodOngoing': '{value} ggü. {period} (Zeitraum läuft)',
    'statistics.change.comparedWithOngoing': 'ggü. {period} (Zeitraum läuft)',
    'statistics.change.notStarted': 'Der Zeitraum hat noch nicht begonnen',
    'statistics.change.year': '{year}',
    'statistics.change.season.winter': 'Winter {label}',
    'statistics.change.season.spring': 'Frühling {label}',
    'statistics.change.season.summer': 'Sommer {label}',
    'statistics.change.season.autumn': 'Herbst {label}',
    'statistics.section.demand': 'Nachfrage und Reservierungen',
    'statistics.section.operations': 'Betrieb und Ausrüstung',
    'statistics.card.reservationsPeriod': 'Reservierungen im Zeitraum',
    'statistics.card.reservationsYear': 'Reservierungen {year}',
    'statistics.card.avgDays': 'Durchschnittliche Mietdauer',
    'statistics.card.daysValue': '{value} Tage',
    'statistics.card.change': 'Reservierungen ggü. Vorjahr',
    'statistics.card.revenueYear': 'Mietwert {year}',
    'statistics.card.avgReservationValuePeriod': 'Durchschnittlicher Reservierungswert im Zeitraum',
    'statistics.card.utilization': 'Ausrüstungsauslastung',
    'statistics.card.utilizationMeta': '{rented} von {available} Miettagen',
    'statistics.card.rentedOnce': 'Mindestens einmal vermietete Ausrüstung im Zeitraum',
    'statistics.card.rentedOnceValue': '{count} Stück ({percent}%)',
    'statistics.card.inUseToday': 'Heute genutzte Ausrüstung',
    'statistics.card.availableToday': 'Heute verfügbare Ausrüstung',
    'statistics.card.activeCustomers': 'Aktive Kunden im Zeitraum',
    'statistics.card.activeOfAll': 'Aktiv im Zeitraum: {active}, Kunden insgesamt: {total}',
    'statistics.card.activeShare': 'Anteil aktiver Kunden',
    'statistics.card.newCustomers': 'Neue Kunden im Zeitraum',
    'statistics.card.reservationsPerCustomer': 'Ø Reservierungen pro aktivem Kunden',
    'statistics.advanced.category': 'Kategorie',
    'statistics.advanced.seasonalityYear': 'Saisonalität {year}',

    // Security
    'security.title': 'Sicherheit',
    'security.changePassword': 'Passwort ändern',
    'security.oldPassword': 'Altes Passwort',
    'security.newPassword': 'Neues Passwort',
    'security.password': 'Passwort',
    'security.confirmPassword': 'Passwort bestätigen',
    'security.repeatPassword': 'Neues Passwort wiederholen',
    'security.subtitle': 'Verwalten Sie Passwort, Sitzungen und überwachen Sie die Kontoaktivität',
    'security.changePasswordButton': 'Passwort ändern',
    'security.changing': 'Ändern...',
    'security.change': 'Ändern',
    'security.passwordsDifferent': 'Passwörter stimmen nicht überein.',
    'security.passwordTooShort': 'Passwort zu kurz (min. 6 Zeichen).',
    'security.passwordChanged': 'Passwort geändert.',
    'security.changePasswordError': 'Fehler beim Ändern des Passworts.',
    'security.twoFA': 'Zwei-Faktor-Authentifizierung (2FA)',
    'security.enabled': 'Aktiviert',
    'security.disabled': 'Deaktiviert',
    'security.disable2FA': '2FA deaktivieren',
    'security.enable2FA': '2FA aktivieren',
    'twoFactorSetup.intro': 'Aktivieren Sie die zweistufige Verifizierung. Sie benötigen eine Authenticator-App: Google Authenticator, Authy oder Microsoft Authenticator.',
    'twoFactorSetup.startError': 'Die Einrichtung konnte nicht gestartet werden.',
    'twoFactorSetup.connectionError': 'Verbindung zum Server fehlgeschlagen.',
    'twoFactorSetup.wrongCodeError': 'Falscher Code. Bitte versuchen Sie es erneut.',
    'twoFactorSetup.loading': 'Wird geladen...',
    'twoFactorSetup.startButton': 'Einrichtung starten',
    'twoFactorSetup.step1Title': 'Schritt 1: QR-Code scannen',
    'twoFactorSetup.step1Intro': 'Öffnen Sie Ihre Authenticator-App und scannen Sie den QR-Code unten:',
    'twoFactorSetup.qrAlt': 'QR-Code zur 2FA-Einrichtung',
    'twoFactorSetup.cantScan': 'Können Sie nicht scannen? Geben Sie den Schlüssel manuell ein:',
    'twoFactorSetup.next': 'Weiter →',
    'twoFactorSetup.step2Title': 'Schritt 2: Code bestätigen',
    'twoFactorSetup.step2Intro': 'Geben Sie den 6-stelligen Code aus der App ein, um die korrekte Einrichtung zu bestätigen:',
    'twoFactorSetup.verifying': 'Wird überprüft...',
    'twoFactorSetup.confirm': 'Bestätigen',
    'twoFactorSetup.passwordLabel': 'Aktuelles Passwort (zum Aktivieren erforderlich)',
    'twoFactorSetup.back': 'Zurück',
    'twoFactorSetup.step3Title': 'Schritt 3: Backup-Codes',
    'twoFactorSetup.importantLabel': 'Wichtig:',
    'twoFactorSetup.backupCodesWarning': 'Bewahren Sie diese Codes an einem sicheren Ort auf. Jeder kann nur einmal verwendet werden und wird nicht erneut angezeigt.',
    'twoFactorSetup.copied': '✓ Kopiert!',
    'twoFactorSetup.copyAll': 'Alle kopieren',
    'twoFactorSetup.done': 'Fertig - 2FA aktiv',
    'security.activeSessions': 'Aktive Sitzungen',
    'security.device': 'Gerät',
    'security.ip': 'IP',
    'security.lastActivity': 'Letzte Aktivität',
    'security.status': 'Status',
    'security.current': 'Aktuell',
     'security.other': 'Andere',
    'security.logout': 'Sitzung abmelden',
     'security.noSessions': 'Keine aktiven Sitzungen.',
     'security.empty.sessions': 'Keine aktiven Sitzungen',
    'security.logoutOthers': 'Andere Sitzungen abmelden',
    'security.sessionRevoked': 'Sitzung widerrufen.',
    'security.operationError': 'Betriebsfehler.',
    'security.loginHistory': 'Anmeldehistorie',
    'security.time': 'Zeit',
    'security.noHistory': 'Keine Historie.',
    'security.ok': 'OK',
    'security.error': 'Fehler',
    'security.auditLog': 'Sicherheitsprüfung',
    'security.devices.title': 'Angemeldete Geräte',
    'security.devices.subtitle': 'Browser und Geräte mit aktivem Zugriff auf Ihr Konto. Wenn Sie eines nicht erkennen, melden Sie es ab.',
    'security.devices.lastActive': 'Zuletzt aktiv:',
    'security.devices.revoke': 'Abmelden',
    'security.devices.revoking': 'Wird abgemeldet...',
    'security.devices.revokeAll': 'Alle anderen Geräte abmelden',
    'security.devices.confirmAll': 'Sind Sie sicher? Dort ist eine erneute Anmeldung nötig.',
    'security.devices.confirmYes': 'Ja, abmelden',
    'security.devices.thisDevice': 'Dieses Gerät',
    'security.devices.unknown': 'Unbekannt',
    'security.devices.empty': 'Keine aktiven Geräte',
    'security.devices.revokedOne': 'Das Gerät wurde abgemeldet.',
    'security.devices.revokedAll': 'Abgemeldete Geräte: {count}.',
    'security.devices.revokeFailed': 'Das Gerät konnte nicht abgemeldet werden. Bitte erneut versuchen.',
    'security.action': 'Aktion',
    'security.details': 'Details',
    'security.noAudit': 'Keine Prüfereignisse',
    'security.currentPassword': 'Aktuelles Passwort',
    'security.table.time': 'Zeit',
    'security.table.ip': 'IP',
    'security.table.status': 'Status',
    'security.table.device': 'Gerät',
    'security.table.last': 'Letzte',
    'security.table.actions': 'Aktionen',
    'security.empty.loginHistory': 'Keine Anmeldehistorie',
    'security.empty.auditLog': 'Keine Audit-Ereignisse',
    'security.tips.title': 'Sicherheitshinweise',
    'security.tips.passwordTitle': 'Starke Passwörter verwenden',
    'security.tips.passwordDesc': 'Mindestens 12 Zeichen aus Buchstaben, Ziffern und Symbolen',
    'security.tips.changeTitle': 'Passwörter regelmäßig ändern',
    'security.tips.changeDesc': 'Alle 3 bis 6 Monate',
    'security.tips.monitorTitle': 'Sitzungen überwachen',
    'security.tips.monitorDesc': 'Achten Sie auf unbekannte Geräte',

    // Users
    'users.noPermissions': 'Keine Berechtigungen',
    'users.adminOnly': 'Dieser Abschnitt ist nur für Administratoren verfügbar.',
    'users.title': 'Benutzerverwaltung',
    'users.addUser': 'Benutzer hinzufügen',
    'users.firstName': 'Vorname',
    'users.lastName': 'Nachname',
    'users.email': 'Email',
    'users.admin': 'Admin',
    'users.actions': 'Aktionen',
    'users.undoDelete': 'Löschen rückgängig machen',
    'users.delete': 'Löschen',
    'users.noUsers': 'Keine Benutzer.',
    'users.revokeSessions': 'Von allen Geräten abmelden',
    'users.revokeSelfHint': 'Eigene Geräte melden Sie unter Kontosicherheit ab',
    'users.revokeConfirm': 'Dieser Mitarbeiter wird auf allen Geräten abgemeldet und muss sich erneut anmelden.',
    'users.revokeAction': 'Abmelden',
    'users.revokeDone': 'Abgemeldete Geräte: {count}.',
    'users.revokeFailed': 'Der Mitarbeiter konnte nicht abgemeldet werden. Bitte erneut versuchen.',
    'users.user': 'Mitarbeiter',
    'users.saving': 'Speichern…',
    'users.saveError': 'Fehler beim Speichern der Benutzer.',
    'users.changesSaved': 'Änderungen gespeichert.',
    'users.confirmPassword': 'Bestätigen Sie mit Passwort',
    'users.enterAdminPassword': 'Geben Sie das Administratorkennwort ein, um die Änderungen zu bestätigen.',
    'users.password': 'Passwort',
    'users.confirmAndSave': 'Bestätigen und speichern',
    'users.confirmDelete': 'Sind Sie sicher, dass Sie diesen Benutzer löschen möchten?',
    'users.deleteError': 'Fehler beim Löschen des Benutzers',
    'users.deleteModalTitle': 'Löschen des Benutzers bestätigen',
    'users.passwordConfirmLabel': 'Administratorpasswort (Bestätigung)',
    'users.passwordPlaceholder': 'Passwort eingeben',
    'users.enterPasswordError': 'Geben Sie Ihr Passwort ein, um den Vorgang zu bestätigen.',
    'users.wrongPasswordError': 'Falsches Passwort.',
    'users.cannotDeleteSelfError': 'Sie können sich nicht selbst löschen.',
    'users.lastAdminError': 'Der Benutzer kann nicht gelöscht werden - er ist der letzte Administrator im System.',
    'users.serverError': 'Serverfehler ({status})',
    'userDetails.adminModalTitle': 'Berechtigungsänderung bestätigen',
    'users.noFirstName': 'Kein Vorname',
    'users.noLastName': 'Kein Nachname',
    'users.noEmail': 'Keine E-Mail',
    'users.loadError': 'Fehler beim Laden der Benutzer',
    'users.invalidPhone': 'Die Telefonnummer darf nicht mehr als 9 Ziffern enthalten.',

    // YourData
   
    'yourData.noUser': 'Kein angemeldeter Benutzer.',
    'yourData.loadError': 'Fehler beim Laden der Benutzerdaten.',
    'yourData.saved': 'Daten gespeichert.',
    'yourData.saveError': 'Fehler beim Speichern der Daten.',
    'yourData.loginAgain': 'Bitte erneut anmelden.',
    'yourData.title': 'Ihre Daten',
    'yourData.noPhoto': 'Kein Foto',
    'yourData.choose': 'Foto auswählen',
    'yourData.remove': 'Entfernen',
    'yourData.firstName': 'Vorname',
    'yourData.lastName': 'Nachname',
    'yourData.email': 'Email',
    'yourData.phone': 'Telefon',
    'yourData.saving': 'Speichern…',
    'yourData.fileTooLarge': 'Datei zu groß (max 1MB).',
    'yourData.firstNamePlaceholder': 'Vorname',
    'yourData.lastNamePlaceholder': 'Nachname',
    'yourData.emailPlaceholder': 'adresse@email.com',
    'yourData.phonePlaceholder': '+48 123 456 789',
    'yourData.success': 'Die Daten wurden aktualisiert',
    'yourData.error': 'Fehler beim Aktualisieren der Daten',
    'yourData.invalidPhone': 'Ungültige Telefonnummer. Geben Sie 9 Ziffern an (z. B. 501234567) oder entfernen Sie die Vorwahl +48 und Leerzeichen.',
    'yourData.change': 'Daten ändern',
    'yourData.loading': 'Daten werden geladen...',
    'yourData.backToProfile': 'Zurück zum Profil',
    'yourData.fillRequired': 'Füllen Sie die Pflichtfelder aus',
    'security.passwordMinStrength': 'Das Passwort muss mindestens sein: {strength}',
    'security.policy.minLength': 'Min. {min} Zeichen',
    'security.policy.upperCase': 'Großbuchstabe',
    'security.policy.lowerCase': 'Kleinbuchstabe',
    'security.policy.digit': 'Ziffer',
    'security.policy.minStrength': 'Passwortstärke: mindestens "{strength}"',
    'security.twoFA.title': 'Zwei-Faktor-Authentifizierung (2FA)',
    'security.twoFA.active': 'Aktiv',
    'security.twoFA.enabledOn': 'Aktiviert: {date}',
    'security.twoFA.backupCodesRemaining': 'Verbleibende Backup-Codes: {count} / 10',
    'security.twoFA.lowCodesWarning': '(Wenige Codes übrig - erwägen Sie, 2FA zu deaktivieren und wieder zu aktivieren, um neue zu generieren)',
    'security.twoFA.confirmDisableIntro': 'Um 2FA zu deaktivieren, bestätigen Sie Ihre Identität mit einem TOTP-Code oder einem Backup-Code:',
    'security.twoFA.codePlaceholder': 'TOTP-Code (6 Ziffern) oder Backup-Code (XXXX-XXXX)',
    'security.twoFA.disabling': 'Wird deaktiviert...',
    'security.twoFA.confirmDisable': 'Deaktivierung bestätigen',
    'security.twoFA.intro': 'Die Zwei-Faktor-Authentifizierung bietet zusätzlichen Schutz für Ihr Konto. Nach der Aktivierung werden Sie bei jeder Anmeldung nach einem 6-stelligen Code aus Ihrer Authenticator-App gefragt.',
    'passwordStrength.0': 'Sehr schwach',
    'passwordStrength.1': 'Schwach',
    'passwordStrength.2': 'Mittel',
    'passwordStrength.3': 'Gut',
    'passwordStrength.4': 'Stark',

    'addUser.invalidPhone': 'Ungültige Telefonnummer - geben Sie 9 Ziffern an (z. B. 501234567) oder entfernen Sie +48/Leerzeichen.',
    'equipmentDetails.title': 'Gerätedetails',
    'equipmentDetails.edit': 'Bearbeiten',
    'equipmentDetails.save': 'Speichern',
    'equipmentDetails.cancel': 'Abbrechen',
    'equipmentDetails.loadError': 'Daten des Geräts konnten nicht geladen werden.',
    'equipmentDetails.saveSuccess': 'Änderungen gespeichert!',
    'equipmentDetails.saveError': 'Fehler beim Speichern der Änderungen.',
    'sidebar.home': 'Startseite',
    'sidebar.newReservation': 'Neue Reservierung',
    'sidebar.generateOffer': 'Angebote',
    'sidebar.calendar': 'Kalender',
    'sidebar.inventory': 'Lager',
    'sidebar.statistics': 'Statistiken',
    'sidebar.profile': 'Profil',
    'sidebar.logout': 'Abmelden',
    'sidebar.logoutSaving': 'Änderungen werden gespeichert, Abmeldung läuft…',
    'sidebar.clients': 'Kunden',
    'sidebar.group.main': 'Allgemein',
    'sidebar.group.manage': 'Verwaltung',
    'sidebar.group.account': 'Konto',
    'sidebar.organization': 'Organisation',
    'sidebar.payments': 'Zahlungen',
    'sidebar.group.tools': 'Werkzeuge',
    'sidebar.contractTemplate': 'Vertragsbaukasten',
    'sidebar.offerTemplate': 'Angebotsbaukasten',
    'sidebar.paymentSettings': 'Online-Zahlungen',
    'sidebar.invoices': 'Rechnungen',
    'sidebar.notifications': 'Benachrichtigungen',
    'sidebar.widget': 'Widget',
    'sidebar.superAdmin': 'Super-Admin-Bereich',
    'sidebar.openMenu': 'Menü öffnen',
    'sidebar.collapseMenu': 'Menü einklappen',
    'sidebar.expandMenu': 'Menü ausklappen',
    'superAdmin.nameEmailRequired': 'Name und E-Mail sind erforderlich',
    'superAdmin.serverError': 'Der Server ist nicht erreichbar',
    'superAdmin.ownerRequired': 'E-Mail sowie Vor- und Nachname des Inhabers sind erforderlich',
    'superAdmin.pendingStatusLocked': 'Der Status einer Organisation, die auf die Aktivierung wartet, kann nicht geändert werden. Der Kunde muss zuerst das Aktivierungsformular ausfüllen.',
    'superAdmin.orgUpdated': 'Die Daten der Organisation wurden aktualisiert',
    'superAdmin.copied': 'In die Zwischenablage kopiert',
    'superAdmin.title': 'Super-Admin-Bereich',
    'superAdmin.subtitle': 'Verwaltung der Organisationen in the.rENT',
    'superAdmin.statAll': 'Alle Organisationen',
    'superAdmin.statActive': 'Aktiv',
    'superAdmin.statPending': 'Warten auf Aktivierung',
    'superAdmin.searchPlaceholder': 'Organisationen suchen...',
    'superAdmin.search': 'Suchen',
    'superAdmin.loading': 'Organisationen werden geladen...',
    'superAdmin.empty': 'Keine Organisationen vorhanden',
    'superAdmin.colId': 'ID',
    'superAdmin.colName': 'Name',
    'superAdmin.colNip': 'Steuernummer (NIP)',
    'superAdmin.colEmail': 'E-Mail',
    'superAdmin.colPlan': 'Paket',
    'superAdmin.colStatus': 'Status',
    'superAdmin.colDemo': 'Demo',
    'superAdmin.colCreated': 'Erstellt am',
    'superAdmin.colActions': 'Aktionen',
    'superAdmin.editTooltip': 'Daten der Organisation bearbeiten',
    'superAdmin.resendTooltip': 'Aktivierungslink erneut senden',
    'superAdmin.deletePendingTooltip': 'Diese auf Aktivierung wartende Organisation löschen',
    'superAdmin.addTitle': 'Neue Organisation anlegen',
    'superAdmin.noteBefore': 'Die Organisation wird angelegt, aber ',
    'superAdmin.demoNoteBefore': 'Die Demo-Organisation wird angelegt, aber ',
    'superAdmin.noteBold': 'die Aktivierungs-E-Mail wird nicht automatisch versendet',
    'superAdmin.fieldName': 'Name des Verleihs *',
    'superAdmin.fieldEmail': 'Kontakt-E-Mail *',
    'superAdmin.emailHint': 'An diese Adresse geht der Aktivierungslink',
    'superAdmin.fieldNip': 'Steuernummer (NIP)',
    'superAdmin.fieldPhone': 'Telefon',
    'superAdmin.fieldAddress': 'Adresse',
    'superAdmin.fieldPlan': 'Abonnement',
    'superAdmin.demoTitle': 'Demo-Organisation anlegen',
    'superAdmin.fieldOwnerName': 'Vor- und Nachname des Inhabers *',
    'superAdmin.fieldOwnerEmail': 'E-Mail des Inhabers *',
    'superAdmin.demoEmailHint': 'An diese Adresse geht der Aktivierungslink, gültig 24 Stunden.',
    'superAdmin.demoPresetLabel': 'Branche des Verleihs',
    'superAdmin.demoPresetHint': 'Bestimmt die Beispielgeräte, Kunden und Lagerkonfiguration, die der Interessent nach der Aktivierung sieht.',
    'superAdmin.demoDaysLabel': 'Demo-Dauer (Tage)',
    'superAdmin.demoDaysHint': 'Ab der Kontoaktivierung gezählt, 1 bis 365 Tage.',
    'superAdmin.demoPurgeOn': 'Löschung am {date}',
    'superAdmin.demoManage': 'Demo',
    'superAdmin.demoManageTooltip': 'Demo verlängern oder in ein Kundenkonto umwandeln',
    'demoManage.title': 'Demo: {name}',
    'demoManage.extendTitle': 'Demo verlängern',
    'demoManage.extendHint': 'Eine abgelaufene Demo wird ab heute verlängert, eine laufende ab ihrem aktuellen Ende. Die Verlängerung verschiebt auch die automatische Löschung.',
    'demoManage.extendPending': 'Das Konto ist noch nicht aktiviert: Sie legen die Demo-Dauer ab der Aktivierung fest.',
    'demoManage.extendButton': 'Um {days} Tage verlängern',
    'demoManage.setDaysButton': '{days} Tage ab Aktivierung festlegen',
    'demoManage.extended': 'Demo verlängert.',
    'demoManage.convertTitle': 'In ein Kundenkonto umwandeln',
    'demoManage.convertHint': 'Das Konto ist keine Demo mehr: kein Zeitlimit, keine gesperrten Nachrichten oder Zahlungen, keine automatische Löschung. Benutzer, Einstellungen, Lagerkonfiguration, Vorlagen sowie die von der Firma hinzugefügten Preislisten und Pakete bleiben erhalten.',
    'demoManage.planLabel': 'Tarif nach der Umwandlung',
    'demoManage.planPlaceholder': 'Tarif wählen',
    'demoManage.planHint': 'Die Demo läuft im Premium-Tarif. Wählen Sie den Tarif, den der Kunde gekauft hat: Basic schaltet Widget, E-Mails von der Adresse des Verleihs und automatische Erinnerungen (E-Mail und SMS) ab.',
    'demoManage.planRequired': 'Zuerst einen Tarif wählen',
    'demoManage.wipeLabel': 'Beispieldaten löschen (empfohlen)',
    'demoManage.wipeHint': 'Die fiktiven Demo-Daten und alles, was auf fiktiven Kunden aufbaut, werden gelöscht, auch das Beispielpaket und die Preisregel aus der Demo. Der in der Demo eingeschaltete Tausch am selben Tag wird ausgeschaltet, sofern die Firma diese Einstellung nicht geändert hat.',
    'demoManage.previewItems': 'Kunden: {clients} · Geräte: {equipment} · Reservierungen: {reservations} · Angebote: {offers} · Rechnungen: {invoices}.',
    'demoManage.previewCompany': 'Auch die fiktiven Firmendaten (Steuernummer, Konto, Adresse), aber nur unveränderte Felder.',
    'demoManage.previewLoading': 'Beispieldaten werden gezählt…',
    'demoManage.previewFailed': 'Die Beispieldaten konnten nicht gezählt werden.',
    'demoManage.keepHint': 'Die Beispieldaten bleiben im Kundenkonto.',
    'demoManage.convertButton': 'In Kunden umwandeln',
    'demoManage.confirmConvertWipe': '„{name}“ in ein Kundenkonto umwandeln und die Beispieldaten endgültig löschen?',
    'demoManage.confirmConvert': '„{name}“ in ein Kundenkonto umwandeln, ohne die Beispieldaten zu löschen?',
    'demoManage.converted': 'Demo in ein Kundenkonto umgewandelt.',
    'demoManage.error': 'Der Vorgang ist fehlgeschlagen.',
    'superAdmin.createdTitle': 'Organisation angelegt',
    'superAdmin.createdBefore': 'Die Organisation ',
    'superAdmin.createdAfter': ' wurde erfolgreich angelegt.',
    'superAdmin.activationLink': 'Aktivierungslink (24 Stunden gültig):',
    'superAdmin.editTitle': 'Organisation bearbeiten',
    'superAdmin.smtpCheckFailed': 'Der SMTP-Status konnte nicht geprüft werden',
    'superAdmin.loadError': 'Die Organisationen konnten nicht geladen werden',
    'superAdmin.twoFactorRequiredTitle': 'Zwei-Faktor-Authentifizierung aktivieren',
    'superAdmin.twoFactorRequiredBody': 'Das Admin-Panel verwaltet alle Unternehmen, daher reicht ein Passwort allein nicht aus. Aktivieren Sie die Zwei-Faktor-Authentifizierung (ein Code aus einer App auf Ihrem Telefon), melden Sie sich dann ab und mit dem Code erneut an. Bis dahin funktioniert dieses Konto wie ein normales Administratorkonto Ihres Unternehmens.',
    'superAdmin.twoFactorRequiredCta': 'Zu den Sicherheitseinstellungen',
    'superAdmin.twoFactorSessionTitle': 'Mit dem Code erneut anmelden',
    'superAdmin.twoFactorSessionBody': 'Die Zwei-Faktor-Authentifizierung ist bereits aktiviert, aber diese Sitzung wurde ohne Code angemeldet. Melden Sie sich ab und mit dem Code aus der App auf Ihrem Telefon erneut an.',
    'superAdmin.twoFactorSessionCta': 'Abmelden',
    'superAdmin.createError': 'Die Organisation konnte nicht angelegt werden',
    'superAdmin.createDemoError': 'Die Demo-Organisation konnte nicht angelegt werden',
    'superAdmin.updateError': 'Die Organisation konnte nicht aktualisiert werden',
    'superAdmin.resendError': 'Die E-Mail konnte nicht gesendet werden',
    'superAdmin.deleteError': 'Die Organisation konnte nicht gelöscht werden',
    'superAdmin.confirmActivate': 'Diese Organisation aktivieren?',
    'superAdmin.confirmDeactivate': 'Diese Organisation deaktivieren?',
    'superAdmin.confirmResend': 'Den Aktivierungslink erneut an "{name}" ({email}) senden?',
    'superAdmin.confirmDeletePending': 'Die wartende Organisation "{name}" löschen?\n\nDas lässt sich nicht rückgängig machen.',
    'superAdmin.demoAwaiting': 'wartet auf Aktivierung',
    'superAdmin.demoExpired': 'abgelaufen',
    'superAdmin.dayOne': 'Tag',
    'superAdmin.dayMany': 'Tage',
    'superAdmin.statusSent': 'Gesendet',
    'superAdmin.statusActive': 'Aktiv',
    'superAdmin.statusInactive': 'Inaktiv',
    'superAdmin.resending': 'Wird gesendet...',
    'superAdmin.resend': 'Erneut senden',
    'superAdmin.delete': 'Löschen',
    'superAdmin.activate': 'Aktivieren',
    'superAdmin.deactivate': 'Deaktivieren',
    'superAdmin.submitCreate': 'Organisation anlegen',
    'superAdmin.submitCreateDemo': 'Demo anlegen',
    'superAdmin.noteCopyClient': 'Kopieren Sie den Link nach dem Anlegen und senden Sie ihn dem Kunden selbst.',
    'superAdmin.noteCopyLead': 'Kopieren Sie den Link nach dem Anlegen und senden Sie ihn dem Interessenten selbst.',
    'superAdmin.reason': 'Grund',
    'superAdmin.sentTo': 'Der Aktivierungslink wurde gesendet an',
    'superAdmin.emailNotSent': 'Die E-Mail wurde nicht gesendet.',
    'superAdmin.copyLinkManually': 'Kopieren Sie den Link unten und senden Sie ihn dem Kunden selbst, zum Beispiel über Messenger oder SMS.',
    'superAdmin.filterAll': 'Alle',
    'superAdmin.filterActive': 'Aktiv',
    'superAdmin.filterInactive': 'Inaktiv',
    'superAdmin.filterPaused': 'Pausiert',
    'superAdmin.statusPaused': 'Pausiert',
    'superAdmin.statusPauseScheduled': 'Pause ab {od}',
    'superAdmin.pause': 'Pause',
    'superAdmin.pauseTooltip': 'Saisonpause: Konto nur lesbar',
    'pauseManage.title': 'Pause: {name}',
    'pauseManage.explain': 'Während der Pause kann sich die Firma anmelden und Daten ansehen und speichert nur Rechnungen, KSeF, Erstattungen und Kautionen. Widget, Erinnerungen und Zahlungslinks sind aus, Rechnungen gehen weiter an KSeF. Die Pause beenden Sie hier: Nichts nimmt das Konto von selbst wieder auf.',
    'pauseManage.startInfo': 'Die Pause beginnt am 1. des nächsten Monats. Bis dahin funktioniert das Konto normal, nimmt aber keine Reservierung an, die am ersten Tag der Pause oder später endet.',
    'pauseManage.stateActive': 'Pausiert seit {od}.',
    'pauseManage.stateScheduled': 'Pause geplant ab {od}. Bis dahin funktioniert das Konto normal, nimmt aber keine Reservierung an, die an diesem Tag oder später endet.',
    'pauseManage.untilLabel': 'Geplantes Ende (optional)',
    'pauseManage.untilHint': 'Die Firma sieht dieses Datum im Banner. Die Pause endet an diesem Tag nicht von selbst.',
    'pauseManage.enable': 'Pause starten',
    'pauseManage.saveUntil': 'Ende speichern',
    'pauseManage.resume': 'Pause beenden',
    'pauseManage.cancelScheduled': 'Pause absagen',
    'pauseManage.confirmNextMonth': 'Pause für „{name}“ ab dem 1. des nächsten Monats planen?',
    'pauseManage.confirmResume': 'Pause von „{name}“ beenden? Das Konto arbeitet sofort wieder normal.',
    'pauseManage.confirmCancel': 'Geplante Pause von „{name}“ absagen?',
    'pauseManage.enabled': 'Pause gespeichert.',
    'pauseManage.untilSaved': 'Geplantes Ende gespeichert.',
    'pauseManage.resumed': 'Pause beendet.',
    'pauseManage.error': 'Die Pause konnte nicht geändert werden.',
    'pauseManage.unsentKsef': 'Rechnungen, die nicht an KSeF übermittelt wurden: {liczba}. Die Übermittlungsfrist läuft auch in der Pause weiter, und die Firma kann sie aus der Rechnungsliste senden.',
    'pauseManage.confirmAnyway': 'Pause trotzdem starten?',
    'pauseManage.confirmOpenReservations': 'Die Firma hat Reservierungen, die sie in der Pause nicht bearbeiten kann: am ersten Tag der Pause laufend: {trwajace}, später: {nadchodzace}. In der Pause kann sie dafür weder Ausgabe, Rückgabe noch Zahlung vor Ort erfassen. Rechnungen, Korrekturen und KSeF funktionieren auch in der Pause. Pause trotzdem starten?',
    'superAdmin.filterResigned': 'Gekündigt',
    'superAdmin.statusResigned': 'Gekündigt, Löschung ab {od}',
    'superAdmin.statusResignScheduled': 'Kündigung ab {od}',
    'superAdmin.resign': 'Kündigung',
    'superAdmin.resignTooltip': 'Kündigung: Konto nur lesbar, Löschung der Daten nach 30 Tagen',
    'superAdmin.confirmDeactivateResigned': 'Gekündigte Firma deaktivieren? Die Kündigung wird zurückgenommen: Die Firma verliert Anmeldung und Datenexport, und ihre Daten werden nach 30 Tagen nicht gelöscht.',
    'superAdmin.deleteData': 'Firmendaten löschen',
    'superAdmin.deleteDataTooltip': 'Löscht endgültig alle Daten der gekündigten Firma. Verfügbar ab dem Löschtag, 30 Tage nach der Kündigung.',
    'superAdmin.deleteDataFrom': 'verfügbar ab {od}',
    'deleteResigned.title': 'Firmendaten löschen: {name}',
    'deleteResigned.intro': 'Die Kündigung gilt seit {od}, die Firmendaten können ab {usuniecie} gelöscht werden. Die Löschung lässt sich nicht rückgängig machen.',
    'deleteResigned.whatTitle': 'Endgültig gelöscht werden:',
    'deleteResigned.whatData': 'alle Firmendaten: Kunden, Reservierungen, Ausrüstung, Zahlungen, Rechnungen und ihr Status in KSeF, Angebote, Preislisten und Einstellungen',
    'deleteResigned.whatUsers': 'Mitarbeiterkonten samt Sitzungen und Anmeldeverlauf',
    'deleteResigned.whatFiles': 'Dateien: Fotos des Ausrüstungszustands, Bilder des Widgets und die hochgeladene Vertragsvorlage',
    'deleteResigned.log': 'Es bleibt nur ein Protokolleintrag: Firmennummer, Kündigungstag, Löschtag und das Konto, das die Daten gelöscht hat.',
    'deleteResigned.backups': 'Sicherungskopien enthalten diese Daten noch bis zu etwa 6 Monate, die Kopie außerhalb des Servers bis zu etwa 17 Tage länger. Aus den Kopien stellen wir sie nicht wieder her.',
    'deleteResigned.exportReminder': 'Stellen Sie vor dem Löschen sicher, dass die Firma davon weiß und ihren Datenexport heruntergeladen hat (Administrator der Firma: Profil, Export der Firmendaten). Rechnungen bewahrt die Firma selbst auf. Diese Schaltfläche sendet der Firma keine E-Mail.',
    'deleteResigned.confirmLabel': 'Zur Bestätigung den Firmennamen eingeben:',
    'deleteResigned.confirmHint': 'Groß- und Kleinschreibung zählt.',
    'deleteResigned.submit': 'Daten endgültig löschen',
    'deleteResigned.submitting': 'Wird gelöscht…',
    'deleteResigned.done': 'Die Daten von „{name}“ wurden gelöscht.',
    'deleteResigned.error.notResigned': 'Diese Firma ist nicht gekündigt, daher können ihre Daten nicht gelöscht werden. Die Kündigung wurde vielleicht zurückgenommen. Die Liste wurde aktualisiert.',
    'deleteResigned.error.notYet': 'Die Daten dieser Firma können erst ab {od} gelöscht werden.',
    'deleteResigned.error.notYetNoDate': 'Die Daten dieser Firma können noch nicht gelöscht werden. Die Liste wurde aktualisiert.',
    'deleteResigned.error.ksefPending': 'Die Firma hat Rechnungen, die noch an KSeF gesendet werden müssen oder unterwegs sind: {liczba}. Die Daten können erst gelöscht werden, wenn die Firma sie aus der Rechnungsliste sendet.',
    'deleteResigned.error.nameMismatch': 'Der eingegebene Name stimmt nicht mit dem Firmennamen überein. Bitte genau eingeben, mit Groß- und Kleinbuchstaben.',
    'deleteResigned.error.platformAccount': 'Diese Firma hat ein Konto eines Super Admins, daher können ihre Daten nicht gelöscht werden.',
    'deleteResigned.error.demo': 'Das ist ein Demokonto. Demokonten entfernt die Demobereinigung, nicht diese Schaltfläche.',
    'deleteResigned.error.conflict': 'Die Bedingungen für die Löschung haben sich inzwischen geändert. Die Liste wurde aktualisiert, bitte prüfen und erneut versuchen.',
    'deleteResigned.error.notFound': 'Diese Firma gibt es nicht mehr. Die Liste wurde aktualisiert.',
    'deleteResigned.error.session': 'Die Sitzung erlaubt diesen Vorgang nicht. Bitte abmelden und erneut mit dem Authentifizierungscode anmelden.',
    'deleteResigned.error.generic': 'Die Firmendaten konnten nicht gelöscht werden. Bitte gleich erneut versuchen.',
    'deleteResigned.error.unknownOutcome': 'Es ist nicht bekannt, ob die Daten gelöscht wurden, weil der Server nicht geantwortet hat. Die Liste wurde aktualisiert, bitte vor einem neuen Versuch prüfen.',
    'resignManage.title': 'Kündigung: {name}',
    'resignManage.explain': 'Ab dem Kündigungstag kann sich die Firma anmelden, Daten ansehen, den Datenexport herunterladen und Rechnungen sowie KSeF bearbeiten, übriges Speichern, Widget, Erinnerungen und Zahlungslinks sind aus. Nach 30 Tagen können die Firmendaten gelöscht werden: automatisch, nachdem die Administratoren per E-Mail informiert wurden (E-Mails und automatische Löschung funktionieren erst, wenn die Regel zur Datenaufbewahrung auf dem Server eingeschaltet ist), oder manuell mit der Schaltfläche „Firmendaten löschen“ in der Liste, ohne E-Mail. Das ist keine Deaktivierung: Eine inaktive Firma hat weder Anmeldung noch Löschtermin.',
    'resignManage.startLabel': 'Kündigungstag',
    'resignManage.startToday': 'Ab heute',
    'resignManage.startDay': 'Ab einem gewählten Tag',
    'resignManage.dayLabel': 'Kündigungstag',
    'resignManage.todayOnly': 'Die Firma ist inaktiv oder in einer laufenden Pause, daher kann die Kündigung nur ab heute beginnen.',
    'resignManage.newDayLabel': 'Neuer Kündigungstag',
    'resignManage.stateScheduled': 'Kündigung geplant ab {od}. Bis dahin funktioniert das Konto normal, nimmt aber keine Reservierung an, die an diesem Tag oder später endet.',
    'resignManage.stateActive': 'Gekündigt seit {od}. Die Firmendaten können frühestens am {usuniecie} gelöscht werden.',
    'resignManage.stateActiveNoDate': 'Gekündigt seit {od}.',
    'resignManage.enable': 'Kündigung festlegen',
    'resignManage.changeDay': 'Tag ändern',
    'resignManage.startNow': 'Heute beginnen',
    'resignManage.cancel': 'Kündigung zurücknehmen',
    'resignManage.confirmToday': 'Kündigung von „{name}“ ab heute festlegen? Das Konto ist sofort nur lesbar, und die Daten können nach 30 Tagen gelöscht werden.',
    'resignManage.confirmDay': 'Kündigung von „{name}“ ab {od} festlegen? Bis dahin funktioniert das Konto normal, nimmt aber keine Reservierung an, die an diesem Tag oder später endet. Danach ist es nur lesbar, und die Daten können nach 30 Tagen gelöscht werden.',
    'resignManage.confirmCancel': 'Kündigung von „{name}“ zurücknehmen? Das Konto arbeitet sofort wieder normal als aktiv.',
    'resignManage.saved': 'Kündigung gespeichert.',
    'resignManage.cancelled': 'Kündigung zurückgenommen.',
    'resignManage.error': 'Die Kündigung konnte nicht geändert werden.',
    'resignManage.unsentKsef': 'Rechnungen, die nicht an KSeF übermittelt wurden: {liczba}. Die Übermittlungsfrist läuft weiter, und die Firma kann sie aus der Rechnungsliste senden.',
    'resignManage.confirmAnyway': 'Kündigung trotzdem festlegen?',
    'resignManage.pausePlanned': 'Die Firma hat eine geplante Pause ab {od}. Die Kündigung hebt sie auf: Bis zum Kündigungstag funktioniert das Konto normal, daher kann die Kündigung spätestens am {od} beginnen.',
    'resignManage.pauseOngoing': 'Die Firma pausiert seit {od}. Die Kündigung beendet die Pause und ersetzt sie.',
    'resignManage.confirmOpenReservations': 'Die Firma hat Reservierungen, die sie nach der Kündigung nicht bearbeiten kann: am Kündigungstag laufend: {trwajace}, später: {nadchodzace}. Sie kann dafür weder Ausgabe, Rückgabe noch Zahlung vor Ort erfassen. Rechnungen, Korrekturen und KSeF funktionieren. Kündigung trotzdem festlegen?',
    'superAdmin.copy': 'Kopieren',
    'superAdmin.saveChanges': 'Änderungen speichern',

    // Rechnungen (Liste, Editor, Vorschau, KSeF) — U.16
    'invoices.title': 'Rechnungen',
    'invoices.new': 'Neue Rechnung',
    'invoices.loading': 'Rechnungen werden geladen…',
    'invoices.loadError': 'Rechnungen konnten nicht geladen werden.',
    'invoices.nipLabel': 'USt-IdNr.: {nip}',
    'invoices.filters.search': 'Suchen',
    'invoices.filters.searchPlaceholder': 'Nummer, Käufer, USt-IdNr. …',
    'invoices.filters.docType': 'Dokumenttyp',
    'invoices.filters.allTypes': 'Alle Typen',
    'invoices.filters.paymentStatus': 'Zahlungsstatus',
    'invoices.filters.dateFrom': 'Von',
    'invoices.filters.dateTo': 'Bis',
    'invoices.table.number': 'Nummer',
    'invoices.subtitle': 'Rechnungen, Proformas und Korrekturen: Ausstellung, Abrechnung und KSeF-Versand',
    'invoices.stats.outstanding': 'Offen · Rechnungen: {count}',
    'invoices.stats.overdue': 'Überfällig · {amount}',
    'invoices.stats.overdueNone': 'Überfällig',
    'invoices.stats.thisMonth': 'Bruttoumsatz in diesem Monat',
    'invoices.paymentFilter.unpaid': 'Unbezahlt',
    'invoices.paymentFilter.partial': 'Teilweise bezahlt',
    'invoices.paymentFilter.paid': 'Bezahlt',
    'invoices.resultCount': 'Treffer: {count}',
    'invoices.emptyFiltered.title': 'Keine Rechnung entspricht den Filtern',
    'invoices.emptyFiltered.description': 'Ändern Sie die Kriterien oder setzen Sie die Filter zurück, um alle Dokumente zu sehen.',
    'invoices.table.issued': 'Ausgestellt',
    'invoices.table.due': 'Fällig',
    'invoices.table.overdue': 'überfällig',
    'invoices.table.paidPart': 'bezahlt {amount}',
    'invoices.preview.settlement': 'Abrechnung',
    'invoices.preview.invoiceTotal': 'Bruttobetrag des Dokuments',
    'invoices.preview.paymentProgress': 'Zahlungsfortschritt',
    'invoices.preview.paidAmount': 'Bezahlt {amount}',
    'invoices.preview.remainingAmount': 'Offen {amount}',
    'invoices.preview.paidInFull': 'Vollständig bezahlt',
    'invoices.preview.overdueSince': 'Zahlung war fällig am {date}',
    'invoices.preview.details': 'Details',
    'invoices.preview.correctionSection': 'Änderungen am Dokument',
    'invoices.editor.fromReservation': 'Basierend auf Reservierung #{id}',
    'invoices.editor.summaryTitle': 'Zusammenfassung',
    'invoices.editor.editCompanyData': 'Firmendaten bearbeiten',
    'invoices.table.grossAmount': 'Bruttobetrag',
    'invoices.table.payment': 'Zahlung',
    'invoices.table.ksef': 'KSeF',
    'invoices.fields.issueDate': 'Ausstellungsdatum',
    'invoices.fields.saleDate': 'Verkaufsdatum',
    'invoices.fields.dueDate': 'Zahlungsziel',
    'invoices.fields.buyer': 'Käufer',
    'invoices.fields.seller': 'Verkäufer',
    'invoices.fields.paymentMethod': 'Zahlungsart',
    'invoices.fields.notes': 'Anmerkungen',
    'invoices.fields.paid': 'Bezahlt',
    'invoices.fields.totalDue': 'Zu zahlen',
    'invoices.fields.address': 'Adresse',
    'invoices.fields.email': 'E-Mail',
    'invoices.fields.phone': 'Telefon',
    'invoices.fields.nip': 'USt-IdNr.',
    'invoices.fields.regon': 'REGON',
    'invoices.fields.buyerNameCompany': 'Firmenname',
    'invoices.fields.buyerNamePrivate': 'Vor- und Nachname',
    'invoices.status.corrected': 'korrigiert',
    'invoices.status.draft': 'Entwurf',
    'invoices.docType.vat': 'USt-Rechnung',
    'invoices.docType.proforma': 'Proforma',
    'invoices.docType.simplified': 'Vereinfachte Rechnung',
    'invoices.docType.correction': 'Korrektur',
    'invoices.docType.vatExempt': 'Rechnung',
    'invoices.paymentStatus.unpaid': 'Unbezahlt',
    'invoices.paymentStatus.partial': 'Teilweise bezahlt',
    'invoices.paymentStatus.paid': 'Bezahlt',
    'invoices.paymentMethod.transfer': 'Überweisung',
    'invoices.paymentMethod.cash': 'Bargeld',
    'invoices.paymentMethod.card': 'Karte',
    'invoices.paymentMethod.blik': 'BLIK',
    'invoices.paymentMethod.other': 'Andere',
    'invoices.ksefStatus.pending': 'Ausstehend',
    'invoices.ksefStatus.sent': 'Gesendet',
    'invoices.ksefStatus.accepted': 'Angenommen',
    'invoices.ksefStatus.rejected': 'Abgelehnt',
    'invoices.ksefStatus.error': 'Fehler',
    'invoices.ksefStatus.upoReceived': 'UPO erhalten',
    'invoices.ksef.send': 'An KSeF senden',
    'invoices.ksef.sending': 'Wird gesendet…',
    'invoices.ksef.retry': 'Erneut senden',
    'invoices.ksef.downloadUpo': 'UPO herunterladen',
    'invoices.ksef.numberTooltip': 'KSeF-Nummer: {number}',
    'invoices.ksef.sendConfirmTitle': 'An KSeF senden?',
    'invoices.ksef.sendConfirmMessage': 'Möchten Sie die Rechnung {number} wirklich an das nationale E-Rechnungssystem senden?',
    'invoices.ksef.sendError': 'Die Rechnung konnte nicht an KSeF gesendet werden.',
    'invoices.ksef.upoError': 'Das UPO konnte nicht heruntergeladen werden.',
    'invoices.ksef.sendPending': 'Die Rechnung ist möglicherweise schon in KSeF. Wir prüfen den Status beim nächsten Öffnen der Liste, bitte nicht erneut senden.',
    'invoices.ksef.duplicateNote': 'Diese Rechnung ist bereits in KSeF. Prüfen Sie sie in der Steuerzahler-Anwendung, bitte nicht erneut senden.',
    'invoices.ksef.deliveryUnknownNote': 'Unklar, ob die Rechnung KSeF erreicht hat. Wir prüfen das selbst, bitte nicht erneut senden. Falls sie nicht angekommen ist, wird das Senden spätestens nach 13 Stunden wieder freigegeben.',
    'invoices.ksef.otherEnvironmentNote': 'Status aus einer anderen KSeF-Umgebung. In der aktuellen wurde die Rechnung noch nicht gesendet.',
    'invoices.ksef.prodEnvironmentNote': 'Die Rechnung ist im produktiven KSeF eingereicht, daher senden wir sie nicht an die Testumgebung.',
    'invoices.filters.ksefAttention': 'Nicht in KSeF',
    'ksefUwaga.titleOne': '{count} Rechnung ist nicht in KSeF angekommen',
    'ksefUwaga.titleFew': '{count} Rechnungen sind nicht in KSeF angekommen',
    'ksefUwaga.titleMany': '{count} Rechnungen sind nicht in KSeF angekommen',
    'ksefUwaga.titleOther': '{count} Rechnungen sind nicht in KSeF angekommen',
    'ksefUwaga.lead': 'Eine Rechnung an ein Unternehmen muss spätestens am nächsten Werktag nach der Ausstellung an KSeF gesendet werden. Senden Sie sie aus der Rechnungsliste oder prüfen Sie den Grund in den Details.',
    'ksefUwaga.overdue': 'Sendefrist überschritten: {count}.',
    'ksefUwaga.dueToday': 'Sendefrist endet heute: {count}.',
    'ksefUwaga.show': 'Diese Rechnungen anzeigen',
    'ksefUwaga.details': 'Details',
    'ksefUwaga.more': 'Angezeigt werden die {shown} ältesten von {count}. Alle sehen Sie nach Klick auf „Diese Rechnungen anzeigen“.',
    'ksefUwaga.state.notSent': 'nicht gesendet',
    'ksefUwaga.state.error': 'Sendefehler',
    'ksefUwaga.state.rejected': 'von KSeF abgelehnt',
    'ksefUwaga.state.waiting': 'wartet auf KSeF',
    'ksefUwaga.state.duplicate': 'KSeF meldet ein Duplikat',
    'ksefUwaga.issued': 'ausgestellt am {date}',
    'ksefUwaga.deadline': 'Frist {date}',
    'ksefUwaga.deadlinePassed': 'Frist abgelaufen am {date}',
    'ksefUwaga.deadlineToday': 'Frist endet heute',
    'ksefUwaga.duplicateHint': 'Diese Rechnung ist bereits in KSeF. Prüfen Sie sie in der Steuerzahler-Anwendung, bitte nicht erneut senden.',
    'ksefUwaga.simplifiedHint': 'Vereinfachte Rechnungen sendet die App nicht an KSeF. Reichen Sie sie in der KSeF-Steuerzahler-Anwendung ein.',
    'ksefUwaga.waitingHint': 'Den Status prüfen wir selbst, bitte nicht erneut senden.',
    'ksefUwaga.certExpired': 'Das KSeF-Zertifikat ist am {date} abgelaufen. Der Versand an KSeF funktioniert erst wieder, wenn Sie in den KSeF-Einstellungen ein neues Zertifikat hochladen.',
    'ksefUwaga.certToday': 'Das KSeF-Zertifikat läuft heute ab. Erzeugen Sie in der Steuerzahler-Anwendung ein neues und laden Sie es in den KSeF-Einstellungen hoch.',
    'ksefUwaga.certTomorrow': 'Das KSeF-Zertifikat läuft morgen ({date}) ab. Erzeugen Sie in der Steuerzahler-Anwendung ein neues und laden Sie es in den KSeF-Einstellungen hoch.',
    'ksefUwaga.certSoon': 'Das KSeF-Zertifikat läuft am {date} ab, in {count} Tagen. Ein neues können Sie schon jetzt in der Steuerzahler-Anwendung erzeugen und in den KSeF-Einstellungen hochladen.',
    'ksefUwaga.tokenPassed': 'KSeF-Token funktionieren seit {date} nicht mehr. Wechseln Sie in den KSeF-Einstellungen zur Methode KSeF-Zertifikat.',
    'ksefUwaga.tokenSoon': 'Nach geltenden Vorschriften funktionieren KSeF-Token bis {date}. Wechseln Sie vorher in den KSeF-Einstellungen zur Methode KSeF-Zertifikat.',
    'ksefUwaga.openSettings': 'KSeF-Einstellungen',
    'ksefSettings.prodSince': 'Wir überwachen Rechnungen ab dem {date}, seit das Unternehmen an das produktive KSeF sendet. Rechnungen, die nicht in KSeF ankommen, zeigen wir in der Rechnungsliste und auf der Startseite.',
    'ksefSettings.alertEmailLabel': 'Administratoren per E-Mail über Rechnungen, die nicht in KSeF angekommen sind, und über ein ablaufendes Zertifikat informieren',
    'ksefSettings.alertEmailHint': 'Höchstens eine E-Mail pro Tag, mit Rechnungsnummern und einem Link zur Liste, ohne Käuferdaten, dazu Erinnerungen 30, 7 und 1 Tag vor Ablauf des Zertifikats. Gilt nur für das produktive KSeF.',
    'invoices.pdf.download': 'PDF herunterladen',
    'invoices.pdf.downloadError': 'Die PDF-Datei konnte nicht heruntergeladen werden.',
    'invoices.pdf.busy': 'Zu viele PDF-Dokumente gleichzeitig. Bitte versuchen Sie es gleich noch einmal.',
    'invoices.pdf.retry': 'Erneut versuchen',
    'invoices.empty.title': 'Keine Rechnungen',
    'invoices.empty.description': 'Es wurde noch keine Rechnung ausgestellt. Erstellen Sie die erste, um zu beginnen.',
    'invoices.newModal.title': 'Neue Rechnung',
    'invoices.newModal.subtitle': 'Wählen Sie, wie Sie die Rechnung erstellen möchten',
    'invoices.newModal.fromReservationTitle': 'Aus einer Reservierung',
    'invoices.newModal.fromReservationDescription': 'Käuferdaten und Positionen anhand einer bestehenden Reservierung ausfüllen',
    'invoices.newModal.blankTitle': 'Von Grund auf',
    'invoices.newModal.blankDescription': 'Alle Daten manuell ausfüllen',
    'invoices.reservationModal.title': 'Reservierung auswählen',
    'invoices.reservationModal.empty': 'Keine Reservierungen zur Auswahl.',
    'invoices.reservationModal.searchPlaceholder': 'Suche: Kunde, E-Mail, Telefon, Reservierungsnr. oder Ausrüstung',
    'invoices.reservationModal.searchAria': 'Reservierungen suchen',
    'invoices.reservationModal.scopeAria': 'Welche Reservierungen anzeigen',
    'invoices.reservationModal.scopeOpen': 'Zu fakturieren',
    'invoices.reservationModal.scopeAll': 'Alle',
    'invoices.reservationModal.periodAria': 'Mietzeitraum',
    'invoices.reservationModal.periodAll': 'Gesamter Zeitraum',
    'invoices.reservationModal.periodThisMonth': 'Dieser Monat',
    'invoices.reservationModal.periodLastMonth': 'Letzter Monat',
    'invoices.reservationModal.periodLast3Months': 'Letzte 3 Monate',
    'invoices.reservationModal.countOne': '{count} Reservierung',
    'invoices.reservationModal.countFew': '{count} Reservierungen',
    'invoices.reservationModal.countMany': '{count} Reservierungen',
    'invoices.reservationModal.loading': 'Reservierungen werden geladen…',
    'invoices.reservationModal.loadError': 'Reservierungen konnten nicht geladen werden.',
    'invoices.reservationModal.loadMore': 'Ältere anzeigen ({count})',
    'invoices.reservationModal.noClient': 'Kein Kunde zugeordnet',
    'invoices.reservationModal.invoicedBadge': 'Rechnung {number}',
    'invoices.reservationModal.proformaBadge': 'Proforma {number}',
    'invoices.reservationModal.canceledBadge': 'Storniert',
    'invoices.reservationModal.allInvoicedTitle': 'Alles fakturiert',
    'invoices.reservationModal.allInvoicedDescription': 'Jede Reservierung hat bereits eine Rechnung oder wurde storniert. Zeigen Sie alle an, um ein weiteres Dokument auszustellen.',
    'invoices.reservationModal.noMatchTitle': 'Keine Reservierung passt',
    'invoices.reservationModal.noMatchDescription': 'Prüfen Sie die Schreibweise oder wählen Sie einen längeren Zeitraum.',
    'invoices.reservationModal.showAll': 'Alle anzeigen',
    'invoices.reservationModal.clearFilters': 'Filter zurücksetzen',
    'invoices.editor.titleNew': 'Neue Rechnung',
    'invoices.editor.titleEdit': 'Rechnung bearbeiten',
    'invoices.editor.backToList': 'Zurück zur Liste',
    'invoices.editor.loadError': 'Daten konnten nicht geladen werden.',
    'invoices.editor.saveError': 'Rechnung konnte nicht gespeichert werden.',
    'invoices.editor.saveDraft': 'Als Entwurf speichern',
    'invoices.editor.reservationNotFound': 'Reservierung nicht gefunden.',
    'invoices.editor.sellerMissing': 'Vervollständigen Sie die Firmendaten in den Einstellungen, um Rechnungen auszustellen.',
    'invoices.editor.bankAccountMissing': 'Die Bankkontonummer der Firma fehlt.',
    'invoices.editor.bankAccountLabel': 'Konto: {account}',
    'invoices.editor.completeCompanyData': 'Firmendaten vervollständigen',
    'invoices.editor.orChooseOtherMethod': 'oder wählen Sie eine andere Zahlungsart.',
    'invoices.editor.clientSearchPlaceholder': 'Kunde nach Name oder E-Mail suchen…',
    'invoices.editor.selectedClient': 'Ausgewählter Kunde #{id}',
    'invoices.editor.changeClient': 'Ändern',
    'invoices.editor.issueGeneric': 'Ausstellen',
    'invoices.editor.issueProforma': 'Proforma ausstellen',
    'invoices.editor.issueByType.VAT': 'USt-Rechnung ausstellen',
    'invoices.editor.issueByType.SIMPLIFIED': 'Vereinfachte Rechnung ausstellen',
    'invoices.editor.issueByType.PROFORMA': 'Proforma ausstellen',
    'invoices.editor.addItem': '+ Position hinzufügen',
    'invoices.editor.grossItemsHint': 'Positionen aus der Reservierung behalten einen Bruttobetrag gleich dem Reservierungsbetrag; Netto und MwSt. werden daraus berechnet. Eine Änderung des Nettopreises berechnet die Position vom Netto.',
    'invoices.editor.removeItem': 'Position entfernen',
    'invoices.editor.itemNamePlaceholder': 'Name des Produkts/der Dienstleistung',
    'invoices.editor.notesPlaceholder': 'Zusätzliche Anmerkungen zur Rechnung…',
    'invoices.editor.buyerType.private': 'Privatperson',
    'invoices.editor.buyerType.company': 'Firma',
    'invoices.editor.sections.header': 'Dokumentkopf',
    'invoices.editor.sections.parties': 'Verkäufer und Käufer',
    'invoices.editor.sections.items': 'Positionen',
    'invoices.editor.table.lp': 'Nr.',
    'invoices.editor.table.name': 'Name',
    'invoices.editor.table.unit': 'Einh.',
    'invoices.editor.table.quantity': 'Menge',
    'invoices.editor.table.unitPriceNet': 'Nettopreis',
    'invoices.editor.table.vat': 'USt',
    'invoices.editor.table.net': 'Netto',
    'invoices.editor.table.gross': 'Brutto',
    'invoices.editor.summary.vatRateNet': 'Netto ({rate})',
    'invoices.editor.summary.totalNet': 'Summe netto',
    'invoices.editor.summary.totalVat': 'Summe USt',
    'invoices.editor.summary.totalGross': 'Summe brutto',
    'invoices.editor.summary.total': 'Gesamt',
    'invoices.editor.summary.exemptSale': 'Umsatzsteuerfreier Verkauf',
    'invoices.editor.summary.exemptNet': 'Befreit (zw)',
    'invoices.editor.table.unitPrice': 'Preis',
    'invoices.editor.table.value': 'Wert',
    'invoices.editor.vatExemptCode': 'zw',
    'invoices.editor.notApplicable': 'entfällt',
    'invoices.editor.zeroRateHint': '0 % ist ein inländischer Satz, keine Umsatzsteuerbefreiung. Befreite Umsätze mit dem Satz „zw“ kennzeichnen.',
    'invoices.editor.exemptionBasis': 'Rechtsgrundlage der USt-Befreiung',
    'invoices.editor.exemptionBasisPh': 'z. B. art. 113 ust. 1 ustawy o VAT',
    'invoices.editor.exemptionBasisHint': 'Steht auf der Rechnung und geht an KSeF. Standardmäßig die aus den Firmendaten.',
    'invoices.editor.issueExempt': 'Rechnung ausstellen',
    'invoices.editor.validation.exemptTaxedItem': 'Eine von der USt befreite Firma stellt nur Positionen „zw“ aus. Ändern Sie die Sätze oder den USt-Status in den Firmendaten.',
    'invoices.editor.validation.exemptionBasisRequired': 'Eine befreite Position („zw“) braucht die Rechtsgrundlage der Befreiung.',
    'invoices.editor.validation.exemptionBasisIncomplete': 'Ergänzen Sie die Rechtsgrundlage: Ersetzen Sie „…“ durch die Nummer.',
    'invoices.editor.validation.buyerNameRequired': 'Geben Sie den Namen des Käufers ein.',
    'invoices.editor.validation.nipRequired': 'Geben Sie die USt-IdNr. des Käufers ein.',
    'invoices.editor.validation.sellerRequired': 'Ergänzen Sie Steuernummer und Adresse Ihrer Firma unter Einstellungen → Firmendaten, um eine Rechnung auszustellen.',
    'invoices.editor.validation.itemsRequired': 'Fügen Sie mindestens eine Position hinzu.',
    'invoices.editor.validation.itemNameRequired': 'Geben Sie für jede Position einen Namen ein.',
    'invoices.preview.notFound': 'Rechnung nicht gefunden.',
    'invoices.preview.backToList': 'Zurück zur Liste',
    'invoices.preview.downloadPdf': 'PDF herunterladen',
    'invoices.preview.sendEmail': 'Per E-Mail senden',
    'invoices.preview.registerPayment': 'Zahlung erfassen',
    'invoices.preview.issueCorrection': 'Korrektur ausstellen',
    'invoices.preview.correctedBadge': 'korrigiert',
    'invoices.preview.draftBadge': 'Entwurf',
    'invoices.preview.noBuyerEmail': 'Für den Käufer ist keine E-Mail-Adresse hinterlegt.',
    'invoices.preview.sendEmailConfirmTitle': 'Rechnung per E-Mail senden?',
    'invoices.preview.sendEmailConfirmMessage': 'Die Rechnung wird an {email} gesendet.',
    'invoices.preview.actionError': 'Etwas ist schiefgelaufen: {message}',
    'invoices.preview.deleteConfirmTitle': 'Rechnung löschen?',
    'invoices.preview.deleteConfirmMessage': 'Dieser Vorgang kann nicht rückgängig gemacht werden.',
    'invoices.preview.vatLockedBanner': 'Eine ausgestellte USt-Rechnung kann nicht bearbeitet oder gelöscht werden. Änderungen erfolgen per Korrektur.',
    'invoices.preview.pdfPreviewTitle': 'PDF-Vorschau der Rechnung',
    'invoices.preview.generatingPdf': 'PDF-Vorschau wird erstellt…',
    'invoices.preview.paymentModalTitle': 'Zahlung erfassen',
    'invoices.preview.paymentModalInvoiceAmount': 'Rechnungsbetrag: {amount} · bisher bezahlt: {paid} · offen: {remaining}',
    'invoices.preview.paymentModalAmountLabel': 'Zahlungsbetrag',
    'invoices.preview.savePayment': 'Zahlung speichern',
    'invoices.preview.paymentAmountInvalid': 'Geben Sie einen Zahlungsbetrag größer als null ein.',
    'invoices.preview.correctionNoPayment': 'Eine Korrektur wird nicht durch eine Zahlung beglichen, da sie den Betrag der korrigierten Rechnung ändert.',
    'invoices.preview.correctModalTitle': 'Korrektur ausstellen',
    'invoices.preview.correctModalDescription': 'Die Korrektur setzt alle Positionen der ursprünglichen Rechnung auf null (Storno) und wird sofort ausgestellt, daher kann sie danach nicht mehr bearbeitet werden. Um nur einzelne Positionen zu ändern, stellen Sie nach der Korrektur eine neue Rechnung mit den richtigen Daten aus. Bei aktiviertem automatischem Versand geht die Korrektur auch per E-Mail an den Käufer und an KSeF.',
    'invoices.preview.correctReasonLabel': 'Korrekturgrund',
    'invoices.preview.correctReasonPlaceholder': 'Z. B. Geräterückgabe, Preisfehler…',
    'invoices.preview.correctReasonRequired': 'Geben Sie den Korrekturgrund ein.',
    'invoices.preview.creating': 'Wird erstellt…',
    'invoices.preview.issueCorrectionSubmit': 'Korrektur ausstellen',

    // Zahlungen — U.16
    'payments.title': 'Zahlungen',
    'payments.subtitle': 'Kundenzahlungen: wer, wie viel, wann und wie',
    'payments.statPaidLabel': 'Eingenommen ({period})',
    'payments.statPendingLabel': 'Ausstehend',
    'payments.statRowsLabel': 'Angezeigte Zeilen',
    'payments.periodSelected': 'ausgewählter Zeitraum',
    'payments.periodTotal': 'insgesamt',
    'payments.paidCountOne': '1 Zahlung',
    'payments.paidCountMany': '{count} Zahlungen',
    'payments.paidCountFew': '{count} Zahlungen',
    'payments.adminOnly': 'Das Zahlungsregister steht dem Administrator des Unternehmens zur Verfügung. Die Zahlungen einer Reservierung sehen Sie in deren Details im Kalender.',
    'payments.status.reversed': 'Rückgängig gemachter Eintrag',
    'payments.reversedAt': 'Rückgängig gemacht am {date}: kein Geld erhalten',
    'payments.reversedNote': 'Eintrag rückgängig gemacht: kein Geld erhalten',
    'payments.reservationCancelled': 'Reservierung storniert',
    'payments.paidAfterCancel': 'Nach der Stornierung bezahlt: zu erstatten',
    'payments.depositAfterCancel': 'Kaution nach der Stornierung blockiert: Sperre aufheben',
    'payments.secondDeposit': 'Zweite Kaution für diese Reservierung: Sperre aufheben',
    'payments.pendingHint': 'warten auf den Kunden',
    'payments.afterFilters': 'nach Filtern',
    'payments.recentPayments': 'zuletzt',
    'payments.filterDateFrom': 'Von',
    'payments.filterDateTo': 'Bis',
    'payments.filterClientLabel': 'Kunde',
    'payments.filterClientPlaceholder': 'Nach Name oder E-Mail suchen…',
    'payments.statusFilter.paid': 'Bezahlt',
    'payments.statusFilter.pending': 'Ausstehend',
    'payments.statusFilter.failed': 'Fehlgeschlagen',
    'payments.statusFilter.refunded': 'Erstattet',
    'payments.status.paid': 'Bezahlt',
    'payments.status.pending': 'Ausstehend',
    'payments.status.failed': 'Fehlgeschlagen',
    'payments.status.refunded': 'Erstattet',
    'payments.status.cancelled': 'Storniert',
    'payments.status.partiallyRefunded': 'Teilweise erstattet',
    'payments.status.authorized': 'Autorisiert',
    'payments.status.captured': 'Gesichert',
    'payments.status.released': 'Freigegeben',
    'payments.type.deposit': 'Kaution',
    'payments.type.advance': 'Anzahlung',
    'payments.type.balance': 'Restzahlung',
    'payments.methodCash': 'Bargeld',
    'payments.methodTransfer': 'Überweisung',
    'payments.methodCard': 'Karte (Terminal)',
    'payments.methodOnline': 'Online',
    'payments.filterMethod': 'Zahlungsart',
    'paymentDeadline.toggle': 'Stornieren, wenn der Kunde nicht zahlt bis',
    'paymentDeadline.hint': 'Der Kunde sieht die Frist in der Nachricht mit dem Link und erhält vorher eine Erinnerung.',
    'paymentDeadline.hintNoEmail': 'Der Kunde hat keine E-Mail-Adresse und erhält daher keine Erinnerung. Die Frist steht im Text zum Kopieren zusammen mit dem Link.',
    'paymentDeadline.invalid': 'Wählen Sie eine Frist mindestens eine Stunde ab jetzt und spätestens um 22:00 Uhr am Tag vor Beginn der Reservierung (höchstens 30 Tage).',
    'paymentDeadline.noRoom': 'Die Reservierung beginnt zu bald, um eine Zahlungsfrist festzulegen.',
    'paymentDeadline.premium': 'Die automatische Stornierung unbezahlter Reservierungen ist im Premium-Tarif enthalten.',
    'paymentDeadline.infoTitle': 'Frist für die Anzahlung: {date}',
    'paymentDeadline.info': 'Ohne Zahlung bis zu dieser Frist wird die Reservierung automatisch storniert und die Ausrüstung freigegeben. Der Kunde erhält vorher eine Erinnerung.',
    'paymentDeadline.infoNoEmail': 'Ohne Zahlung bis zu dieser Frist wird die Reservierung automatisch storniert und die Ausrüstung freigegeben. Der Kunde hat keine E-Mail-Adresse und erhält daher keine Erinnerung.',
    'paymentDeadline.removedByLink': 'Die Zahlungsfrist ist abgelaufen oder läuft gleich ab, daher hat der neue Link sie entfernt. Die Reservierung wird nicht automatisch storniert.',
    'paymentDeadline.removedByLinkWidget': 'Die Zahlungsfrist ist abgelaufen oder läuft gleich ab, daher hat der neue Link sie entfernt. Eine Widget-Reservierung fällt auf die Widget-Regeln zurück: Ohne Zahlung erhält der Kunde eine Erinnerung, und etwa {hours} Std. danach wird die Reservierung automatisch storniert.',
    'paymentDeadline.droppedNoTimeWidget': 'Zahlungsfrist der Reservierung Nr. {id} entfernt: Die Erinnerung kam vor dem Starttag nicht rechtzeitig, der Kunde hätte keine Zeit zum Zahlen. Eine Widget-Reservierung fällt auf die Widget-Regeln zurück: Ohne Zahlung erhält der Kunde eine Erinnerung, und etwa {hours} Std. danach wird die Reservierung automatisch storniert.',
    'paymentDeadline.droppedNoTime': 'Zahlungsfrist der Reservierung Nr. {id} entfernt: Die Erinnerung kam vor dem Starttag nicht rechtzeitig, der Kunde hätte keine Zeit zum Zahlen. Die Reservierung bleibt bestehen.',
    'paymentDeadline.editNote': 'Das Speichern geänderter Daten oder einer geänderten Anzahlung entfernt die Zahlungsfrist.',
    'paymentDeadline.remove': 'Frist entfernen',
    'paymentDeadline.removing': 'Wird entfernt…',
    'paymentDeadline.removeConfirmTitle': 'Zahlungsfrist entfernen?',
    'paymentDeadline.removeConfirmMessage': 'Die Reservierung wird nicht automatisch storniert und der Kunde erhält keine Erinnerung an die Frist.',
    'paymentDeadline.removeConfirmMessageWidget': 'Eine Widget-Reservierung fällt auf die Widget-Regeln zurück: Ohne Zahlung erhält der Kunde eine Erinnerung, und etwa {hours} Std. danach wird die Reservierung automatisch storniert.',
    'paymentDeadline.removed': 'Zahlungsfrist entfernt.',
    'paymentDeadline.removeError': 'Zahlungsfrist konnte nicht entfernt werden.',
    'paymentSettings.deadlineSectionTitle': 'Frist für die Anzahlung',
    'paymentSettings.deadlineSectionHint': 'Standardzeit für die Zahlung, wenn Sie beim Anzahlungslink „Stornieren, wenn der Kunde nicht zahlt bis“ ankreuzen. Die Frist kann bei jeder Reservierung geändert werden.',
    'paymentSettings.deadlinePremium': 'Eine Zahlungsfrist mit automatischer Stornierung unbezahlter Reservierungen ist im Premium-Tarif enthalten.',
    'paymentSettings.deadlineRange': 'Geben Sie eine Stundenzahl von {min} bis {max} ein.',
    'paymentSettings.deadlineSaved': 'Gespeichert: standardmäßig {hours} Std. für die Zahlung.',
    'payments.tableClient': 'Kunde',
    'payments.tableSource': 'Quelle',
    'payments.tablePaidAt': 'Bezahlt am',
    'payments.noClientData': 'Keine Kundendaten',
    'payments.noSource': '—',
    'payments.reservationRef': 'Reservierung #{id}',
    'payments.offerRef': 'Angebot #{seq}',
    'payments.refundedAmount': 'Erstattet: {amount}',
    'payments.overpayment': 'Überzahlung: {amount}',
    'payments.refundAction': 'Erstatten',
    'payments.reverseAction': 'Eintrag rückgängig machen',
    'payments.cancelRequestAction': 'Anfrage stornieren',
    'payments.blockLinkAction': 'Link sperren',
    'payments.payLinkLabel': 'Zahlungslink:',
    'payments.payLinkHint': 'Klicken, um die gesamte Adresse auszuwählen',
    'payments.refundPrompt': 'Erstattungsbetrag (max. {max})',
    'payments.refundInvalidAmount': 'Ungültiger Erstattungsbetrag (max. {max}).',
    'payments.refundError': 'Die Erstattung konnte nicht durchgeführt werden.',
    'payments.reverseError': 'Der Eintrag konnte nicht rückgängig gemacht werden.',
    'payments.cancelRequestError': 'Die Anfrage konnte nicht storniert werden.',
    'payments.confirmRefundTitle': 'Zahlung erstatten?',
    'payments.confirmRefundMessage': 'Sie erstatten {amount} an {client}.',
    'payments.confirmReverseTitle': 'Eintrag rückgängig machen?',
    'payments.confirmReverseMessage': 'Sie machen den Eintrag {amount} ({method}) rückgängig.',
    'payments.confirmCancelTitle': 'Anfrage stornieren?',
    'payments.confirmCancelMessage': 'Die Zahlungsanfrage über {amount} wird storniert.',
    'payments.emptyNoneTitle': 'Keine Zahlungen',
    'payments.emptyNone': 'Es wurde noch keine Zahlung erfasst.',
    'payments.emptyFilteredTitle': 'Keine Ergebnisse',
    'payments.emptyFiltered': 'Keine Zahlung entspricht den ausgewählten Filtern.',

    // Profil — Überschriften der Kartengruppen (U.16)
    'profile.group.account': 'Konto',
    'profile.group.company': 'Firma',
    'profile.group.sales': 'Verkauf',
    'profile.group.integrations': 'Integrationen',

    // Anmeldung (U.16)
    'login.tagline': 'Verwaltung Ihrer Verleihfirma',
    'login.heading': 'Anmelden',
    'login.subtitle': 'Geben Sie Ihre Daten ein, um auf das Panel zuzugreifen',
    'login.usernamePlaceholder': 'Benutzername',
    'login.passwordPlaceholder': 'Passwort',
    'login.submitting': 'Anmeldung läuft…',
    'login.submit': 'Anmelden',
    'login.forgotPassword': 'Passwort vergessen?',
    'login.allFieldsRequired': 'Füllen Sie alle Felder aus.',
    'login.tooManyAttempts': 'Zu viele Anmeldeversuche. Bitte versuchen Sie es später erneut.',
    'login.genericError': 'Ungültiger Benutzername oder falsches Passwort.',
    'login.connectionError': 'Verbindungsfehler zum Server.',
    'login.success': 'Erfolgreich angemeldet.',
    'login.resetTitle': 'Passwort zurücksetzen',
    'login.resetDescription': 'Geben Sie die mit Ihrem Konto verknüpfte E-Mail-Adresse ein, und wir senden Ihnen einen Link zum Festlegen eines neuen Passworts.',
    'login.resetEmailPlaceholder': 'E-Mail-Adresse',
    'login.resetSentDefault': 'Falls die angegebene E-Mail-Adresse im System vorhanden ist, haben wir einen Link zum Zurücksetzen des Passworts gesendet.',
    'login.resetError': 'Der Link zum Zurücksetzen des Passworts konnte nicht gesendet werden.',
    'login.resetSubmitting': 'Wird gesendet…',
    'login.resetSubmit': 'Link zum Zurücksetzen senden',

    // Benutzer hinzufügen — Passwortrichtlinie und Formularzustände (U.16)
    'addUser.demoDisabled': 'Im Demo-Modus nicht verfügbar',
    'addUser.formIncompleteHint': 'Füllen Sie die erforderlichen Formularfelder aus',
    'addUser.passwordMinLength': 'Mindestens {min} Zeichen',
    'addUser.passwordUppercase': 'Ein Großbuchstabe',
    'addUser.passwordLowercase': 'Ein Kleinbuchstabe',
    'addUser.passwordDigit': 'Eine Ziffer',
    'addUser.passwordStrengthGood': 'Ausreichende Passwortstärke',

    // Vertragseditor — RTE-Werkzeugleiste (U.16)
    'contracts.editor.fontDefault': 'Standard',
    'contracts.editor.fontFamily': 'Schriftart',
    'contracts.editor.fontSize': 'Schriftgröße',
    'contracts.editor.equipmentPlaceholder': 'Ausrüstungstabelle',
    'contracts.editor.logoPlaceholder': 'Firmenlogo',
    'contracts.editor.linkPrompt': 'Geben Sie die URL ein',
    'contracts.editor.bold': 'Fett',
    'contracts.editor.italic': 'Kursiv',
    'contracts.editor.underline': 'Unterstrichen',
    'contracts.editor.strike': 'Durchgestrichen',
    'contracts.editor.heading': 'Überschrift',
    'contracts.editor.bulletList': 'Aufzählungsliste',
    'contracts.editor.orderedList': 'Nummerierte Liste',
    'contracts.editor.alignLeft': 'Linksbündig',
    'contracts.editor.alignCenter': 'Zentrieren',
    'contracts.editor.alignRight': 'Rechtsbündig',
    'contracts.editor.link': 'Link einfügen',

    // Kalender — Terminkonflikte ohne Datum (U.16)
    'calendar.noDate': 'kein Datum',

    // ── P8.1e (6/6): i18n konstruktora umowy (tresc umowy CELOWO zostaje po polsku) ──
    'contractBuilder.addSection': 'Abschnitt hinzufügen',
    'contractBuilder.advancedToggle': 'Erweiterte Optionen ein-/ausblenden (Verschieben, Ausrichtung, Löschen von Abschnitten)',
    'contractBuilder.allFields': 'Alle verfügbaren Felder',
    'contractBuilder.autoSaveError': 'Automatisches Speichern fehlgeschlagen. Speichern Sie den Entwurf von Hand.',
    'contractBuilder.bannerFillCompany': 'Firmendaten vervollständigen',
    'contractBuilder.bannerIncomplete': 'Unvollständige Firmendaten',
    'contractBuilder.bannerLoadFailed': 'Die Firmendaten konnten nicht geladen werden',
    'contractBuilder.bannerLoadFailedBody': 'Die Vorschau zeigt leere Felder dort, wo die Firmendaten stehen. Laden Sie die Seite neu oder prüfen Sie die Firmendaten.',
    'contractBuilder.bannerSettingsAction': 'Firmendaten',
    'contractBuilder.blockContent': 'Blockinhalt',
    'contractBuilder.blockHeading': 'Blocküberschrift',
    'contractBuilder.catClient': 'Kundendaten',
    'contractBuilder.catContract': 'Vertrag',
    'contractBuilder.catEquipment': 'Ausrüstung',
    'contractBuilder.catFinance': 'Finanzen',
    'contractBuilder.catOrganization': 'Organisation',
    'contractBuilder.contentPanel': 'Vertragsinhalt',
    'contractBuilder.contractSettings': 'Firmendaten',
    'contractBuilder.deleteError': 'Fehler beim Löschen: {msg}',
    'contractBuilder.deleteSection': 'Abschnitt löschen',
    'contractBuilder.deleteSectionTitle': 'Abschnitt "{name}" wirklich löschen?',
    'contractBuilder.deleteVersionTitle': 'Diese Fassung aus dem Verlauf entfernen',
    'contractBuilder.deleting': 'Wird gelöscht...',
    'contractBuilder.documentLook': 'Aussehen des Dokuments',
    'contractBuilder.downloadPdf': 'PDF herunterladen',
    'contractBuilder.downloading': 'Wird heruntergeladen...',
    'contractBuilder.errorPrefix': 'Fehler: {msg}',
    'contractBuilder.fontSize': 'Schriftgröße',
    'contractBuilder.generating': 'Wird erzeugt...',
    'contractBuilder.headingAlignGroup': 'Ausrichtung der Abschnittsüberschrift',
    'contractBuilder.headingCenter': 'Überschrift zentriert',
    'contractBuilder.checkBeforePublish': 'Vor dem Veröffentlichen prüfen',
    'contractBuilder.dragToReorder': 'Zum Umsortieren ziehen',
    'contractBuilder.pdfFrameTitle': 'PDF-Vorschau des Vertrags',
    'contractBuilder.headingLeft': 'Überschrift linksbündig',
    'contractBuilder.headingRight': 'Überschrift rechtsbündig',
    'contractBuilder.history': 'Verlauf ({count})',
    'contractBuilder.historyHead': 'Frühere Versionen: {count}',
    'contractBuilder.importDisclosure': 'Sie haben schon einen eigenen Vertrag? Importieren Sie seinen Text',
    'contractBuilder.importEmpty': 'Fügen Sie den Vertragstext zum Import ein.',
    'contractBuilder.importError': 'Fehler beim Import des Vertragstexts.',
    'contractBuilder.importLabel': 'Vertragstext einfügen (TXT)',
    'contractBuilder.importNoSections': 'Aus dem angegebenen Text konnten keine Abschnitte erstellt werden.',
    'contractBuilder.importPartial': 'Der Text wurde importiert, einige Felder wurden aber nicht erkannt',
    'contractBuilder.importPlaceholder': 'Fügen Sie den vollständigen Vertragstext ein. Das System teilt ihn automatisch in Abschnitte und versucht, die Felder zu erkennen.',
    'contractBuilder.importSubmit': 'Text in den Editor importieren',
    'contractBuilder.imported': 'Vertragstext importiert. Prüfen Sie die Abschnitte und speichern Sie einen Entwurf.',
    'contractBuilder.importing': 'Wird importiert...',
    'contractBuilder.intro': 'Sie stellen den Vertragstext zusammen, und die Vorschau zeigt sofort, wie er auf Papier aussieht. Felder wie "Vorname des Kunden" setzt das System beim Erzeugen des Vertrags für eine Reservierung selbst ein.',
    'contractBuilder.irreversible': 'Das lässt sich nicht rückgängig machen.',
    'contractBuilder.logoMissing': 'Keines. Fügen Sie ein Logo unter "Firmendaten" hinzu.',
    'contractBuilder.logoSet': 'Eingestellt unter "Firmendaten".',
    'contractBuilder.modeAdvanced': 'Erweitert',
    'contractBuilder.modeSimple': 'Einfache Ansicht',
    'contractBuilder.moveDown': 'Abschnitt nach unten verschieben',
    'contractBuilder.moveUp': 'Abschnitt nach oben verschieben',
    'contractBuilder.noWarnings': 'Keine Warnungen. Die Vorlage ist bereit zur Veröffentlichung.',
    'contractBuilder.pdfDownloadError': 'Fehler beim Herunterladen des PDF: {msg}',
    'contractBuilder.pdfModalHint': 'PDF-Vorschau: hier sehen Sie den echten Seitenumbruch (1:1 wie im Ausdruck)',
    'contractBuilder.pdfPreview': 'PDF-Vorschau',
    'contractBuilder.pdfPreviewError': 'Fehler beim Erzeugen der PDF-Vorschau: {msg}',
    'contractBuilder.pickFieldBelow': '(wählen Sie ein Feld aus der Liste unten)',
    'contractBuilder.presetNoDeposit': 'Ohne Kaution',
    'contractBuilder.presetStandardNotes': 'Standard + Notizen',
    'contractBuilder.previewPanel': 'Vertragsvorschau',
    'contractBuilder.redo': 'Wiederholen',
    'contractBuilder.redoTitle': 'Wiederholen (Strg+Y)',
    'contractBuilder.restore': 'Wiederherstellen',
    'contractBuilder.restoreTitle': 'Diese Fassung in den Editor laden',
    'contractBuilder.saveDraft': 'Entwurf speichern',
    'contractBuilder.saved': 'Die Vertragsvorlage wurde erfolgreich gespeichert!',
    'contractBuilder.sectionAdded': 'Ein neuer Abschnitt wurde im aktuellen Schritt hinzugefügt.',
    'contractBuilder.startHint': 'Die Wahl einer Vorlage ersetzt alle Abschnitte. Danach passen Sie den Text nach Belieben an.',
    'contractBuilder.startTitle': 'Mit einer fertigen Vorlage beginnen',
    'contractBuilder.statusDescDraft': 'Die Vorlage ist noch nicht aktiv. Veröffentlichen Sie sie, um sie produktiv zu nutzen.',
    'contractBuilder.statusDescEmpty': 'Beginnen Sie mit einer fertigen Vorlage oder importieren Sie Ihren eigenen Vertragstext.',
    'contractBuilder.statusDescPublished': 'Neue Verträge verwenden diese Vorlage.',
    'contractBuilder.statusDraft': 'Entwurf',
    'contractBuilder.statusEmpty': 'Keine Vorlage',
    'contractBuilder.readOnlyNotice': 'Die Vertragsvorlage ändert der Administrator der Firma. Sie können sie ansehen und eine PDF-Vorschau herunterladen.',
    'contractBuilder.statusDraftOverPublished': 'Entwurf (v{n} gültig)',
    'contractBuilder.statusDescDraftOverPublished': 'Kunden erhalten weiterhin die veröffentlichte Version v{n}. Veröffentlichen Sie, damit die Änderungen in neue Verträge übernommen werden.',
    'contractBuilder.templateLoadFailed': 'Die Vertragsvorlage konnte nicht geladen werden. Laden Sie die Seite vor dem Bearbeiten neu: Änderungen werden nicht gespeichert, damit der gespeicherte Entwurf nicht überschrieben wird.',
    'contractBuilder.step1': 'Schritt 1: Start und Kunde',
    'contractBuilder.step1Helper': 'Füllen Sie den Vertragskopf und die Kundendaten aus. Das ist der am häufigsten bearbeitete Teil.',
    'contractBuilder.step2': 'Schritt 2: Ausrüstung und Beträge',
    'contractBuilder.step2Helper': 'Präzisieren Sie die Beschreibung der Ausrüstung, die Termine und die Finanzangaben.',
    'contractBuilder.step3Helper': 'Fügen Sie Unterschriften und zusätzliche Klauseln hinzu. Hier landen auch eigene Abschnitte.',
    'contractBuilder.tableFontSize': 'Schrift in der Ausrüstungstabelle',
    'contractBuilder.undoTitle': 'Rückgängig (Strg+Z)',
    'contractBuilder.untitled': '(ohne Titel)',
    'contractBuilder.varAddress': 'Adresse des Kunden',
    'contractBuilder.varAdvance': 'Anzahlung',
    'contractBuilder.varAmountDue': 'Zu zahlen',
    'contractBuilder.varBankAccount': 'Bankkonto',
    'contractBuilder.varBankName': 'Name der Bank',
    'contractBuilder.varDays': 'Anzahl der Miettage',
    'contractBuilder.varDeposit': 'Kaution',
    'contractBuilder.varEmail': 'E-Mail des Kunden',
    'contractBuilder.varEndDate': 'Enddatum',
    'contractBuilder.varEquipmentTable': 'Ausrüstungstabelle (automatisch erzeugt)',
    'contractBuilder.varFirstName': 'Vorname des Kunden',
    'contractBuilder.varIdNumber': 'Ausweisnummer des Kunden',
    'contractBuilder.varClientCompanyName': 'Firmenname des Kunden',
    'contractBuilder.varClientNip': 'Steuernummer des Kunden (NIP)',
    'contractBuilder.varClientCompanyLine': 'Firmendaten des Kunden (ganze Zeile, entfällt bei Privatkunden)',
    'contractBuilder.varLastName': 'Nachname des Kunden',
    'contractBuilder.varOrgAddress': 'Adresse der Organisation',
    'contractBuilder.varOrgName': 'Name der Organisation',
    'contractBuilder.varOrgPhone': 'Telefon der Organisation',
    'contractBuilder.varPhone': 'Telefon des Kunden',
    'contractBuilder.varStartDate': 'Beginndatum',
    'contractBuilder.varTotalPrice': 'Gesamtpreis',
    'contractBuilder.varsLabel': 'Felder zum Einfügen in den Text',
    'contractBuilder.versionDeleteTitle': 'Fassung v{n} aus dem Verlauf entfernen?',
    'contractBuilder.versionDeleted': 'Fassung v{n} aus dem Verlauf entfernt.',
    'contractBuilder.versionLoadBody': 'Sie ersetzt den aktuell bearbeiteten Inhalt. Es wird nichts veröffentlicht. Wenn es passt, klicken Sie auf "Vorlage veröffentlichen", um sie zu aktivieren.',
    'contractBuilder.versionLoadFailed': 'Fassung v{n} konnte nicht geladen werden.',
    'contractBuilder.versionLoadTitle': 'Fassung v{n} laden?',
    'contractBuilder.versionLoaded': 'Fassung v{n} in den Editor geladen. Prüfen Sie sie und klicken Sie auf "Vorlage veröffentlichen", um sie zu aktivieren.',
    'contractBuilder.warnEmptySection': 'Abschnitt "{name}" hat keinen Inhalt.',
    'contractBuilder.warnNoSignatures': 'Es fehlt ein Unterschriftenabschnitt: Fügen Sie einen Abschnitt hinzu, dessen Titel mit „Podpis” beginnt oder der eine ________ Unterschriftslinie enthält.',
    'contractBuilder.yesPublish': 'Ja, veröffentlichen',
    'contractBuilder.pageTitle': 'Vertragsbaukasten',
    'contractBuilder.autoSavedAt': 'Automatisch gespeichert {time}',
    'contractBuilder.missingLabel': 'Es fehlt:',
    'contractBuilder.missingCompanyEffect': 'Die Vorschau und die erzeugten Verträge haben an diesen Stellen leere Felder.',
    'contractBuilder.untitledInContract': '(ohne Titel im Vertrag)',
    'contractBuilder.unknownVarsTitle': 'Unbekannte Felder: {list}',
    'contractBuilder.unknownVarsBadge': 'Unbekannte Felder: {n}',
    'contractBuilder.showLess': 'Weniger anzeigen',
    'contractBuilder.showAllFields': 'Alle Felder anzeigen',
    'contractBuilder.sheetSplitNote': 'ungefähre Seitenaufteilung, die genaue zeigt die "PDF-Vorschau"',
    'contractBuilder.statusLoadFailed': 'Vorlage nicht geladen',
    'contractBuilder.statusDescLoadFailed': 'Es ist nicht bekannt, welche Vorlagenversion gilt. Laden Sie die Seite neu.',
    'contractBuilder.statusPublished': 'Veröffentlicht',
    'contractBuilder.statusPublishedVersion': 'Veröffentlicht (v{n})',
    'contractBuilder.importSection': 'Abschnitt „{name}”:',
    'contractBuilder.importDidYouMean': 'meinten Sie',
    'contractBuilder.templateConflict': 'Die Vorlage wurde in einem anderen Tab oder auf einem anderen Computer geändert. Laden Sie die Seite neu.',
    'contractBuilder.accountChanged': 'In einem anderen Tab hat sich ein anderes Konto angemeldet, daher wurden die Änderungen nicht gespeichert. Laden Sie die Seite neu.',
    'contractBuilder.exitSaveFailed': 'Der Vertragsentwurf wurde nicht gespeichert: {msg}',
    'contractBuilder.blockNameHeading': 'Blockname im Editor (wird nicht gedruckt)',
    'contractBuilder.blockNameHeadingHint': 'Den Vertragstitel tragen Sie unten in „Blockinhalt” ein.',
    'contractBuilder.testOn': 'Testen mit',
    'contractBuilder.scenarioStandard': 'Szenario: Standard',
    'contractBuilder.scenarioNoDeposit': 'Szenario: ohne Kaution',
    'contractBuilder.scenarioLongTerm': 'Szenario: längere Miete',
    'contractBuilder.presetApplied': 'Vertragsmuster übernommen.',
    'contractBuilder.publishTemplate': 'Vorlage veröffentlichen',
    'contractBuilder.publishing': 'Wird veröffentlicht...',
    'contractBuilder.publishTitle': 'Vorlage veröffentlichen?',
    'contractBuilder.publishBodyReplace': 'Die Veröffentlichung ersetzt die aktive Vorlage Ihrer Firma, die aktuelle Version (v{n}) wandert in den Verlauf. Neue Verträge werden aus der neuen Vorlage erzeugt.',
    'contractBuilder.publishBodyFirst': 'Nach der Veröffentlichung werden neue Verträge aus dieser Vorlage erzeugt.',
    'contractBuilder.publishBlocked': 'Vor der Veröffentlichung korrigieren',
    'contractBuilder.warnNoHeading': 'Es fehlt ein Überschriftenblock mit dem Vertragstitel (z. B. „UMOWA NAJMU”).',
    'contractBuilder.warnNoContent': 'Die Vorlage hat keinen Inhalt.',
    'contractBuilder.warnUnknownVars': 'Unbekannte Felder: {list}. Entfernen Sie sie oder wählen Sie ein Feld aus der Liste.',
    'contractBuilder.warnCompanyIncomplete': 'Unvollständige Firmendaten: {list}',
    'contractBuilder.sessionExpired': 'Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.',

    // ── P8.1e (5/6): i18n konstruktora oferty (dokument CELOWO zostaje po polsku) ──
    'offerTemplate.alignCenter': 'Zentriert',
    'offerTemplate.alignLeft': 'Linksbündig',
    'offerTemplate.alignRight': 'Rechtsbündig',
    'offerTemplate.checkBeforePublish': 'Vor dem Veröffentlichen prüfen',
    'offerTemplate.clickFieldFirst': 'Klicken Sie zuerst in ein Textfeld (Einleitung oder Fußzeile), dann auf eine Variable.',
    'offerTemplate.companyIncomplete': 'Unvollständige Firmendaten',
    'offerTemplate.companyIncompleteBody': 'Es fehlt: {fields}. Das Angebot zeigt an diesen Stellen "-", auch in den Zahlungsdaten.',
    'offerTemplate.contentPanel': 'Angebotsinhalt',
    'offerTemplate.contractSettings': 'Firmendaten',
    'offerTemplate.deleteVersionFailed': 'Die Fassung konnte nicht gelöscht werden',
    'offerTemplate.deleteVersionTitle': 'Diese Fassung aus dem Verlauf entfernen',
    'offerTemplate.downloadPdf': 'PDF herunterladen',
    'offerTemplate.downloading': 'Wird heruntergeladen...',
    'offerTemplate.draftSaved': 'Entwurf gespeichert. Kunden erhalten weiterhin die veröffentlichte Fassung.',
    'offerTemplate.exitBack': 'Zurück zum Editor',
    'offerTemplate.exitNotLoaded': 'Die Änderungen im Angebots-Editor wurden nicht gespeichert, weil seine Einstellungen nicht geladen wurden. Laden Sie die Seite neu und nehmen Sie die Änderungen erneut vor.',
    'offerTemplate.exitSaveFailed': 'Die Änderungen im Angebots-Editor wurden nicht gespeichert ({msg}). Sie bleiben in diesem Tab erhalten und kommen zurück, wenn Sie den Editor wieder öffnen.',
    'offerTemplate.exitTooLong': 'Die Änderungen im Angebots-Editor wurden nicht gespeichert: Einleitung oder Fußzeile hat mehr als 2000 Zeichen. Sie bleiben in diesem Tab erhalten und kommen zurück, wenn Sie den Editor wieder öffnen.',
    'offerTemplate.fillCompany': 'Firmendaten vervollständigen',
    'offerTemplate.fontSize': 'Schriftgröße',
    'offerTemplate.footerLabel': 'Fußzeile / Zahlungshinweis',
    'offerTemplate.generateError': 'Fehler beim Erzeugen',
    'offerTemplate.generating': 'Wird erzeugt...',
    'offerTemplate.groupHeader': 'Kopfbereich',
    'offerTemplate.groupTexts': 'Texte',
    'offerTemplate.groupValidity': 'Gültigkeit',
    'offerTemplate.history': 'Verlauf ({count})',
    'offerTemplate.historyHead': 'Frühere Versionen: {count}',
    'offerTemplate.intro': 'Sie stellen ein, was im Angebot fest bleibt: Logo, Titel, Texte und Gültigkeit. Die Tabellen mit Kundendaten, Ausrüstung und Zusammenfassung füllen sich selbst aus der Reservierung, und die Vorschau zeigt sie mit Beispieldaten.',
    'offerTemplate.introLabel': 'Einleitungstext (über den Tabellen, optional)',
    'offerTemplate.loadFailed': 'Die Angebotsvorlage konnte nicht geladen werden',
    'offerTemplate.loadFailedBody': 'Der Editor zeigt Standardwerte statt Ihrer Vorlage, daher ist das Speichern deaktiviert. Laden Sie die Seite neu.',
    'offerTemplate.loading': 'Einstellungen werden geladen…',
    'offerTemplate.logoAlign': 'Logo-Ausrichtung',
    'offerTemplate.missingAccount': 'Kontonummer',
    'offerTemplate.missingBankName': 'Name der Bank',
    'offerTemplate.missingName': 'Firmenname',
    'offerTemplate.noLogoHint': 'Kein Logo. Fügen Sie eines unter "Firmendaten" hinzu.',
    'offerTemplate.noWarnings': 'Keine Warnungen. Die Vorlage ist bereit zur Veröffentlichung.',
    'offerTemplate.offerTitle': 'Titel des Angebots',
    'offerTemplate.pagesApprox': 'Seitenumbruch ungefähr, das erzeugte PDF zeigt ihn genau',
    'offerTemplate.pdfFailed': 'Das Angebots-PDF konnte nicht erzeugt werden',
    'offerTemplate.pdfFrameTitle': 'PDF-Vorschau des Angebots',
    'offerTemplate.pdfModalHint': 'PDF-Vorschau: hier sehen Sie den echten Seitenumbruch (1:1 wie im Ausdruck)',
    'offerTemplate.pdfPreview': 'PDF-Vorschau',
    'offerTemplate.previewError': 'Fehler beim Erzeugen der Vorschau',
    'offerTemplate.previewPanel': 'Angebotsvorschau',
    'offerTemplate.publish': 'Vorlage veröffentlichen',
    'offerTemplate.publishBlocked': 'Diese Vorlage kann gerade nicht veröffentlicht werden',
    'offerTemplate.publishConfirmBody': 'Das Veröffentlichen ersetzt die Vorlage, aus der die Angebote für Ihre Kunden erzeugt werden.',
    'offerTemplate.publishConfirmTitle': 'Vorlage veröffentlichen?',
    'offerTemplate.publishError': 'Fehler beim Veröffentlichen',
    'offerTemplate.publishMovesToHistory': 'Die aktuelle Version wird in den Verlauf verschoben.',
    'offerTemplate.published': 'Vorlage veröffentlicht. Neue Angebote nutzen diese Fassung.',
    'offerTemplate.publishing': 'Wird veröffentlicht...',
    'offerTemplate.reload': 'Seite neu laden',
    'offerTemplate.restore': 'Wiederherstellen',
    'offerTemplate.restoreTitle': 'Diese Fassung in den Editor laden',
    'offerTemplate.restoredBody': 'Beim letzten Verlassen des Editors konnten sie nicht gespeichert werden. Speichern Sie den Entwurf, um sie zu behalten, oder verwerfen Sie sie.',
    'offerTemplate.restoredDiscard': 'Änderungen verwerfen',
    'offerTemplate.restoredTitle': 'Nicht gespeicherte Änderungen wiederhergestellt',
    'offerTemplate.sampleData': 'Beispieldaten',
    'offerTemplate.saveDraft': 'Entwurf speichern',
    'offerTemplate.saveError': 'Speicherfehler',
    'offerTemplate.settingsNotLoaded': 'Die Einstellungen wurden nicht geladen. Laden Sie die Seite neu, sonst lassen sich Änderungen nicht speichern.',
    'offerTemplate.showLogo': 'Firmenlogo auf dem Angebot anzeigen',
    'offerTemplate.statusDefault': 'Keine Vorlage',
    'offerTemplate.statusDescDefault': 'Angebote werden mit den Standardeinstellungen versendet. Veröffentlichen Sie, um Ihre eigene Vorlage zu nutzen.',
    'offerTemplate.statusDescDraft': 'Sie haben Änderungen, die Kunden noch nicht sehen. Veröffentlichen Sie sie, damit sie gelten.',
    'offerTemplate.statusDescLoadFailed': 'Welche Vorlage gilt, ist erst nach dem Laden der Seite bekannt.',
    'offerTemplate.statusDescPublished': 'Neue Angebote verwenden diese Vorlage.',
    'offerTemplate.statusDraft': 'Entwurf',
    'offerTemplate.statusLoadFailed': 'Nicht geladen',
    'offerTemplate.statusPublished': 'Veröffentlicht',
    'offerTemplate.textTooLong': 'Einleitung oder Fußzeile hat mehr als 2000 Zeichen. Kürzen Sie den Text, sonst lässt sich die Vorlage weder speichern noch veröffentlichen.',
    'offerTemplate.title': 'Angebotseditor',
    'offerTemplate.unsaved': 'Nicht gespeicherte Änderungen',
    'offerTemplate.validityHint': 'Von 1 bis 365 Tagen. Die Gültigkeit zählt ab dem Ausstellungstag des Angebots und erscheint in seiner letzten Zeile.',
    'offerTemplate.validityInvalid': 'Geben Sie eine Anzahl Tage von 1 bis 365 ein. Wenn Sie das Feld so verlassen, gilt wieder der vorige Wert: {n}.',
    'offerTemplate.validityLabel': 'Angebot gültig für (Tage)',
    'offerTemplate.validityTooLong': 'Höchstens 365 Tage. Das Angebot gilt 365 Tage.',
    'offerTemplate.varBank': 'Bank',
    'offerTemplate.varDataOferty': 'Angebotsdatum',
    'offerTemplate.varDepozyt': 'Kaution',
    'offerTemplate.varEmail': 'E-Mail',
    'offerTemplate.varFirma': 'Firmenname',
    'offerTemplate.varKlient': 'Kunde',
    'offerTemplate.varNrKonta': 'Kontonr.',
    'offerTemplate.varNrOferty': 'Angebotsnr.',
    'offerTemplate.varRazem': 'Gesamtbetrag',
    'offerTemplate.varTerminDo': 'Bis',
    'offerTemplate.varTerminOd': 'Von',
    'offerTemplate.varWaznosc': 'Gültigkeit (Tage)',
    'offerTemplate.varZaliczka': 'Anzahlung',
    'offerTemplate.varsHint': 'Klicken Sie zuerst unten in ein Textfeld, dann auf ein Feld aus der Liste - es wird an der Cursorposition eingefügt.',
    'offerTemplate.varsLabel': 'Felder zum Einfügen in den Text',
    'offerTemplate.versionRestored': 'Fassung v{n} in den Editor geladen. Veröffentlichen Sie sie, damit sie gilt.',
    'offerTemplate.warnCompanyData': 'Firmendaten fehlen ({fields}), daher zeigt das Angebot an diesen Stellen "-".',
    'offerTemplate.warnNoLogo': 'Das Logo ist aktiviert, es ist aber keines unter "Firmendaten" hinterlegt - das Angebot erscheint ohne Logo.',
    'offerTemplate.warnNoTitle': 'Das Angebot hat keinen Titel.',
    'offerTemplate.yesPublish': 'Ja, veröffentlichen',

    // ── P8.1e (4/6): i18n panelu widgetu (podglad widgetu CELOWO zostaje po polsku) ──
    'widgetMedia.adminOnlySub': 'Dieser Bereich ist nur für Administratoren zugänglich.',
    'widgetMedia.adminOnlyTitle': 'Widget-Einstellungen',
    'widgetMedia.allowedDomains': 'Für das Widget zugelassene Domains',
    'widgetMedia.allowedDomainsHint': 'Adressen der Seiten Ihres Verleihs, auf die Kunden nach einer Online-Zahlung zurückkehren können, z. B. https://ihredomain.de. Wir speichern nur die Adresse der Website, ohne Pfad; wenn Ihre Website auch unter www erreichbar ist, fügen Sie beide Adressen hinzu. Das mit dem Code von dieser Seite eingefügte Widget und der Link mit QR-Code funktionieren immer, und das Feld verhindert nicht, dass das Widget auf einer anderen Website eingefügt wird. Leer lassen, um nichts einzuschränken. Eine Adresse pro Zeile oder durch Kommas getrennt.',
    'widgetMedia.privacyPolicyUrl': 'Datenschutzerklärung (Seitenadresse)',
    'widgetMedia.privacyPolicyUrlPlaceholder': 'https://ihrefirma.de/datenschutz',
    'widgetMedia.privacyPolicyUrlHint': 'Unter dem Buchungsformular zeigt das Widget, dass Ihre Firma (Name aus den Firmendaten) Verantwortlicher für die Kundendaten ist, und verlinkt auf diese Seite. Das verlangt die DSGVO (Art. 13). Ohne Adresse erscheint nur der Satz zum Verantwortlichen.',
    'widgetMedia.termsUrl': 'AGB des Verleihs (Seitenadresse)',
    'widgetMedia.termsUrlPlaceholder': 'https://ihrefirma.de/agb',
    'widgetMedia.termsUrlHint': 'Wenn Sie eine Adresse angeben, zeigt das Widget unter der Buchungsschaltfläche, dass der Kunde mit der Buchung die AGB akzeptiert; das Wort „AGB“ verlinkt auf diese Seite. Leeres Feld = kein Hinweis.',
    'widgetMedia.blockBasic': 'Grundlagen',
    'widgetMedia.blockPresentation': 'Datendarstellung',
    'widgetMedia.blockTheme': 'Farbschema',
    'widgetMedia.checkingServer': 'Widget-Server wird geprüft…',
    'widgetMedia.deviceDesktop': 'Computer',
    'widgetMedia.deviceMobile': 'Telefon',
    'widgetMedia.devicePicker': 'Vorschaugerät wählen',
    'widgetMedia.embedCopied': 'Einbettungscode in die Zwischenablage kopiert!',
    'widgetMedia.embedCopyFailed': 'Der Code konnte nicht automatisch kopiert werden. Markieren Sie ihn von Hand und kopieren Sie ihn (Strg+C).',
    'widgetMedia.embedDemoNote': 'Im Demo-Konto zeigt das Widget Ausrüstung, Termine und Preise, nimmt aber keine Reservierungen an, weil im Demo-Konto keine Daten echter Kunden erfasst werden dürfen (Nutzungsbedingungen, § 6 Abs. 3).',
    'widgetMedia.superAdminNotPremium': 'Ihre Firma ist nicht im Premium-Tarif. Als Super-Admin können Sie hier die Widget-Einstellungen ändern, aber das Widget auf Ihrer Website, der Buchungslink und der QR-Code funktionieren für Kunden erst, wenn die Firma zu Premium wechselt.',
    'widgetMedia.bookingLink.title': 'Buchungslink und QR-Code',
    'widgetMedia.bookingLink.subtitle': 'Kunden buchen die Ausrüstung auf der Widget-Seite, auch ohne eigene Website. Senden Sie ihnen den Link oder drucken Sie den QR-Code, zum Beispiel für die Theke oder einen Flyer.',
    'widgetMedia.bookingLink.fieldLabel': 'Buchungslink',
    'widgetMedia.bookingLink.copy': 'Buchungslink kopieren',
    'widgetMedia.bookingLink.copied': 'Kopiert',
    'widgetMedia.bookingLink.copyFailed': 'Kopieren fehlgeschlagen. Markieren Sie den Link im Feld und kopieren Sie ihn manuell.',
    'widgetMedia.bookingLink.downloadPng': 'PNG herunterladen',
    'widgetMedia.bookingLink.downloadSvg': 'SVG herunterladen',
    'widgetMedia.bookingLink.print': 'QR-Code drucken',
    'widgetMedia.bookingLink.open': 'Buchungsseite in neuem Tab öffnen',
    'widgetMedia.bookingLink.qrAlt': 'QR-Code mit dem Buchungslink',
    'widgetMedia.bookingLink.printTitle': 'QR-Code zur Buchung',
    'widgetMedia.bookingLink.fileName': 'buchungslink-qr',
    'widgetMedia.bookingLink.printHeading': 'Ausrüstung online buchen. Scannen Sie den Code mit der Handykamera.',
    'widgetMedia.bookingLink.missing': 'Der Link erscheint, sobald das Panel die Widget-Adresse und den Code Ihrer Firma kennt.',
    'widgetMedia.bookingLink.demoNote': 'Bei einem Demo-Konto zeigt die Buchungsseite Ausrüstung, Termine und Preise, nimmt aber keine Buchungen an (AGB, § 6 Abs. 3). Der Kunde sieht dazu einen Hinweis.',
    'widgetMedia.embedSubtitle': 'Wenn das Widget so aussieht, wie Sie es möchten - kopieren Sie den Code unten und fügen Sie ihn auf Ihrer Seite ein. Das Widget wird über seinen eindeutigen Code Ihrer Organisation zugeordnet.',
    'widgetMedia.embedTitle': 'Code zur Installation auf Ihrer Seite',
    'widgetMedia.fileTooBig': 'Datei zu groß (max. 5MB)',
    'widgetMedia.invalidFormat': 'Ungültiges Format (erlaubt: JPG, PNG, WEBP)',
    'widgetMedia.hideCode': 'Code ausblenden',
    'widgetMedia.imagesCategoriesHint': 'Bilder für die Kategorie-Kacheln. Empfohlene Auflösung:',
    'widgetMedia.imagesClassesHint': 'Bilder für die Klassen-Kacheln. Empfohlene Auflösung:',
    'widgetMedia.imagesFormatHint': ', max. 5MB (JPG, PNG, WEBP).',
    'widgetMedia.invalidScope': 'Ungültiger Bereich.',
    'widgetMedia.livePreview': 'Live-Vorschau',
    'widgetMedia.loadFailed': 'Die Daten konnten nicht geladen werden.',
    'widgetMedia.loading': 'Daten werden geladen...',
    'widgetMedia.premiumOnly': 'Das Widget ist nur im Premium-Tarif verfügbar.',
    'widgetMedia.previewNote': 'Orientierende Vorschau - Ihre Änderungen werden gespeichert und erscheinen im echten Widget.',
    'widgetMedia.priceDaily': 'Tagespreis',
    'widgetMedia.priceMode': 'Anzeigemodus des Preises',
    'widgetMedia.priceTotal': 'Gesamtpreis',
    'widgetMedia.refresh': 'Aktualisieren',
    'widgetMedia.refreshPreview': 'Vorschau aktualisieren',
    'widgetMedia.rotateError': 'Fehler beim Erneuern des Codes.',
    'widgetMedia.rotateFailed': 'Es konnte kein neuer Code erzeugt werden.',
    'widgetMedia.rotateOk': 'Ein neuer Widget-Code wurde erzeugt.',
    'widgetMedia.saveError': 'Speicherfehler.',
    'widgetMedia.saveFailed': 'Speichern nicht möglich.',
    'widgetMedia.saveSettings': 'Einstellungen speichern',
    'widgetMedia.saveSettingsError': 'Fehler beim Speichern der Einstellungen.',
    'widgetMedia.saveSettingsFailed': 'Die Einstellungen konnten nicht gespeichert werden.',
    'widgetMedia.savedChanges': 'Änderungen gespeichert.',
    'widgetMedia.sectionCategories': 'Kategorien',
    'widgetMedia.sectionClasses': 'Ausrüstungsklassen',
    'widgetMedia.classesDefaultGroup': 'Standardbild der Klasse',
    'widgetMedia.classesDefaultHint': 'Das Widget zeigt es in jeder Kategorie, in der die Klasse kein eigenes Bild hat (unten).',
    'widgetMedia.classDefaultBadge': 'Standardbild',
    'widgetMedia.groupImages': 'Bilder: {own} von {all}',
    'widgetMedia.categoriesGroup': 'Alle Kategorien',
    'widgetMedia.settingsSaved': 'Widget-Einstellungen erfolgreich gespeichert!',
    'widgetMedia.settingsSub': 'Passen Sie Aussehen und Verhalten des Widgets an Ihren Verleih an.',
    'widgetMedia.showCode': 'Code anzeigen',
    'widgetMedia.copied': 'Kopiert!',
    'widgetMedia.copyCode': 'Code kopieren',
    'widgetMedia.showImages': 'Bilder auf den Kacheln anzeigen',
    'widgetMedia.showProgress': 'Fortschrittsbalken anzeigen',
    'widgetMedia.showSizeChart': 'Größentabelle anzeigen',
    'widgetMedia.subtitle': 'Aussehen, Inhalte und Bilder, die im Kunden-Widget erscheinen.',
    'widgetMedia.themeBlue': 'Blau',
    'widgetMedia.themeDarkBlue': 'Dunkelblau (Marke)',
    'widgetMedia.themeGreen': 'Grün',
    'widgetMedia.themeNature': 'Verlauf Natur',
    'widgetMedia.customThemeTitle': 'Eigenes Farbschema',
    'widgetMedia.customThemeModeAria': 'Art des eigenen Farbschemas',
    'widgetMedia.modeSolid': 'Einfarbig',
    'widgetMedia.modeGradient': 'Verlauf',
    'widgetMedia.customThemeHintSolid': 'Eine Farbe für das gesamte Design.',
    'widgetMedia.customThemeHintGradient': 'Zwei Farben ergeben einen weichen Verlauf im Hintergrund.',
    'widgetMedia.customColorSolid': 'Designfarbe',
    'widgetMedia.customColor1': 'Farbe 1',
    'widgetMedia.customColor2': 'Farbe 2',
    'widgetMedia.customAccent': 'Akzentfarbe',
    'widgetMedia.shuffleColors': 'Farbpaar auswürfeln',
    'widgetMedia.previewFallbackTitle': 'Ihr Verleih',
    'widgetMedia.previewCta': 'Jetzt buchen',
    'widgetMedia.themeNight': 'Verlauf Nacht',
    'widgetMedia.themeOcean': 'Verlauf Ozean',
    'widgetMedia.themeOrange': 'Orange',
    'widgetMedia.themePurple': 'Violett',
    'widgetMedia.themeRed': 'Rot',
    'widgetMedia.themeSunset': 'Verlauf Sonnenuntergang',
    'widgetMedia.themeTurquoise': 'Türkis',
    'widgetMedia.title': 'Widget',
    'widgetMedia.uploadFailed': 'Die Datei konnte nicht hochgeladen werden.',
    'widgetMedia.uploadOk': 'Bild erfolgreich hochgeladen.',
    'widgetMedia.uploadTitle': 'Bild hochladen (JPG, PNG, WEBP, max. 5MB)',
    'widgetMedia.uploading': 'Wird hochgeladen...',
    'widgetMedia.widgetName': 'Name des Widgets',

    // ── P8.1e (3/6): przewodniki stron i kalendarz sprzetu ──
    'equipmentCalendar.aggregateHint': 'Die Zahlen an den Tagen sind Reservierungen und Angebote aller Stücke zusammen.',
    'equipmentCalendar.aggregateView': 'Gesamtansicht des Kalenders',
    'equipmentCalendar.allEquipment': 'Alle Ausrüstung',
    'equipmentCalendar.apartmentNo': 'Wohnungsnummer',
    'equipmentCalendar.backToInventory': 'Zurück zum Lager',
    'equipmentCalendar.basicData': 'Grunddaten',
    'equipmentCalendar.bookEquipment': 'Ausrüstung reservieren',
    'equipmentCalendar.buildingNo': 'Hausnummer',
    'equipmentCalendar.checkAvailabilityFailed': 'Die Verfügbarkeit der Ausrüstung konnte nicht geprüft werden.',
    'equipmentCalendar.city': 'Stadt',
    'equipmentCalendar.clearRange': 'Zeitraum zurücksetzen',
    'equipmentCalendar.clientLabel': 'Kunde:',
    'equipmentCalendar.dateRange': 'Zeitraum*',
    'equipmentCalendar.dayCount': 'Anzahl der Tage',
    'equipmentCalendar.dayEmpty': 'An diesem Tag ist das Stück frei.',
    'equipmentCalendar.dayEmptyAll': 'An diesem Tag gibt es keine Reservierungen oder Angebote.',
    'equipmentCalendar.daysFew': '{count} Tage',
    'equipmentCalendar.daysMany': '{count} Tage',
    'equipmentCalendar.daysOne': '{count} Tag',
    'equipmentCalendar.daysOther': '{count} Tage',
    'equipmentCalendar.editAddress': 'Adresse bearbeiten',
    'equipmentCalendar.emptyPickEquipment': 'Klicken Sie auf "Ausrüstung wählen", um Ausrüstung zur Reservierung hinzuzufügen',
    'equipmentCalendar.emptyPickRange': 'Wählen Sie zuerst einen Zeitraum, um verfügbare Ausrüstung zu sehen',
    'equipmentCalendar.equipmentRequired': 'Ausrüstung wählen',
    'equipmentCalendar.errorPanel': 'Fehler',
    'equipmentCalendar.fillRequired': 'Füllen Sie alle Pflichtfelder aus',
    'equipmentCalendar.firstname': 'Vorname*',
    'equipmentCalendar.firstnameRequired': 'Vorname ist erforderlich',
    'equipmentCalendar.goToday': 'Zurück zu heute',
    'equipmentCalendar.kindReservation': 'Reservierung',
    'equipmentCalendar.lastname': 'Nachname*',
    'equipmentCalendar.lastnameRequired': 'Nachname ist erforderlich',
    'equipmentCalendar.legend': 'Legende',
    'equipmentCalendar.legendAvailable': 'Verfügbar',
    'equipmentCalendar.legendBooked': 'Reserviert',
    'equipmentCalendar.legendOffer': 'Angebot',
    'equipmentCalendar.legendOfferHold': 'Angebot (vorläufige Sperre)',
    'equipmentCalendar.legendToday': 'Heute',
    'equipmentCalendar.loadAvailableFailed': 'Die verfügbare Ausrüstung konnte nicht geladen werden.',
    'equipmentCalendar.loadFailed': 'Der Ausrüstungskalender konnte nicht geladen werden. Prüfen Sie die Verbindung und versuchen Sie es erneut.',
    'equipmentCalendar.loading': 'Wird geladen...',
    'equipmentCalendar.moreOnDay': '{count} weitere an diesem Tag',
    'equipmentCalendar.newReservation': 'Neue Reservierung',
    'equipmentCalendar.newReservationHint': 'Geben Sie die Reservierungsdaten ein und wählen Sie die Ausrüstung',
    'equipmentCalendar.next30': 'Nächste 30 Tage',
    'equipmentCalendar.next30Empty': 'In den nächsten 30 Tagen ist nichts geplant.',
    'equipmentCalendar.noReservations': 'Keine Reservierungen',
    'equipmentCalendar.noUpcomingOffers': 'Keine anstehenden Angebote',
    'equipmentCalendar.notFound': 'Keine Ausrüstung mit dieser Kennung gefunden.',
    'equipmentCalendar.notePlaceholder': 'Notiz eingeben',
    'equipmentCalendar.notes': 'Notizen',
    'equipmentCalendar.occupancy': '{month}: {busy} von {total} Tagen belegt',
    'equipmentCalendar.offerFor': 'Angebot: {name}',
    'equipmentCalendar.open': 'Öffnen',
    'equipmentCalendar.openTitle': 'Reservierungsdetails öffnen',
    'equipmentCalendar.phApartmentOptional': 'Wohnungsnummer (optional)',
    'equipmentCalendar.phFirstname': 'Vorname',
    'equipmentCalendar.phLastname': 'Nachname',
    'equipmentCalendar.phPhone': 'Telefon',
    'equipmentCalendar.phone': 'Telefon*',
    'equipmentCalendar.phoneRequired': 'Telefon ist erforderlich',
    'equipmentCalendar.pickRangeFirst': 'Wählen Sie zuerst einen Zeitraum.',
    'equipmentCalendar.pickRangeFirstShort': 'Wählen Sie zuerst einen Zeitraum',
    'equipmentCalendar.postalCode': 'Postleitzahl',
    'equipmentCalendar.rangeFrom': 'Von',
    'equipmentCalendar.rangeRequired': 'Wählen Sie einen Zeitraum',
    'equipmentCalendar.rangeTo': 'Bis',
    'equipmentCalendar.removeFromReservation': 'Ausrüstung aus der Reservierung entfernen',
    'equipmentCalendar.reservationRange': 'Reservierungszeitraum',
    'equipmentCalendar.reservations': 'Reservierungen',
    'equipmentCalendar.saveAddress': 'Adresse speichern',
    'equipmentCalendar.saveError': 'Speicherfehler',
    'equipmentCalendar.saveReservation': 'Reservierung speichern',
    'equipmentCalendar.saveReservationFailed': 'Die Reservierung konnte nicht gespeichert werden',
    'equipmentCalendar.searchEquipment': 'Ausrüstung suchen...',
    'equipmentCalendar.selectedDay': 'Gewählter Tag',
    'equipmentCalendar.selectedEquipment': 'Gewählte Ausrüstung',
    'equipmentCalendar.selectedEquipmentRequired': 'Gewählte Ausrüstung*',
    'equipmentCalendar.showInCalendar': 'Im Kalender zeigen',
    'equipmentCalendar.statusFree': 'Heute frei',
    'equipmentCalendar.statusHeld': 'Durch ein Angebot gesperrt bis {date}',
    'equipmentCalendar.statusLabel': 'Status:',
    'equipmentCalendar.statusNext': 'Nächste Reservierung: {range}, {name}',
    'equipmentCalendar.statusNoNext': 'Keine Reservierungen geplant',
    'equipmentCalendar.statusRented': 'Vermietet bis {date}',
    'equipmentCalendar.street': 'Straße',
    'equipmentCalendar.summary': 'Zusammenfassung',
    'equipmentCalendar.title': 'Mietkalender',
    'equipmentCalendar.upcomingOffers': 'Anstehende Angebote ({count})',
    'reservationDetails.cancelledNote': 'Diese Reservierung ist storniert: Die Ausrüstung ist frei, neue Zahlungen werden nicht angenommen. Eine Kautionssperre auf der Karte rechnen Sie unten ab.',
    'reservationDetails.depositAfterReturn': 'Die gesamte Ausrüstung ist zurück, die Kaution ist aber noch auf der Karte gesperrt. Geben Sie sie frei oder ziehen Sie einen Betrag für Schäden im Abschnitt „Online-Kaution“ ein.',
    'reservationDetails.daysFew': '{count} Tage',
    'reservationDetails.daysMany': '{count} Tage',
    'reservationDetails.daysOne': '{count} Tag',
    'reservationDetails.daysOther': '{count} Tage',
    'reservationDetails.equipment': 'Ausrüstung',
    'reservationDetails.eyebrow': 'Reservierungsdetails #{id}',
    'reservationDetails.itemsCount': 'Stück: {count}',
    'reservationDetails.note': 'Notiz',
    'reservationDetails.paidExtra': 'Davon nachgezahlt: {amount}',
    'reservationDetails.paidInFull': 'Vollständig bezahlt',
    'reservationDetails.payments': 'Zahlungen und Kaution',
    'reservationDetails.remaining': 'Noch zu zahlen',
    'pageTours.calendar.day.lead': 'Die farbigen Balken im Raster sind Reservierungen; dieses Feld zeigt den gewählten Tag.',
    'pageTours.calendar.day.p1': 'Ein Klick auf einen Tag im Kalender zeigt hier den Tagesplan: Ausgaben, Rückgaben und die vorzubereitende Ausrüstung.',
    'pageTours.calendar.day.p2': 'Ein Klick auf eine Reservierung öffnet die Details: Bearbeiten sowie Ausgabe und Rücknahme der Ausrüstung.',
    'pageTours.calendar.day.p3': 'Die Pfeile über dem Raster wechseln den Monat, "Heute" springt zum aktuellen Tag zurück.',
    'pageTours.calendar.day.title': 'Reservierungskalender',
    'pageTours.calendar.tabs.lead': 'Die Reiter zeigen dieselben Reservierungen als Liste.',
    'pageTours.calendar.tabs.p1': '"Bevorstehend" ist alles ab heute - die Zahl im Abzeichen sagt, wie viele es sind.',
    'pageTours.calendar.tabs.p2': '"Historie" beginnt mit den neuesten und lässt Sie nach Namen suchen.',
    'pageTours.calendar.tabs.p3': '"Reservierung hinzufügen" oben rechts öffnet das Formular für eine neue Reservierung.',
    'pageTours.calendar.tabs.title': 'Liste statt Raster',
    'pageTours.calendar.title': 'Kalender',
    'pageTours.clients.card.lead': 'Ein Klick auf eine Karte öffnet die Kundendetails.',
    'pageTours.clients.card.p1': '"Daten bearbeiten" ändert Kontakt und Adresse - sie landen später im Vertrag und auf der Rechnung.',
    'pageTours.clients.card.p2': '"Reservierungen" zeigt die Miethistorie dieser Person, "Neue Reservierung" beginnt eine weitere mit ihren Daten.',
    'pageTours.clients.card.p3': '"Kunde hinzufügen" oben hilft, wenn jemand spontan hereinkommt.',
    'pageTours.clients.card.title': 'Kundenkarte',
    'pageTours.clients.search.lead': 'Eine Liste aller Personen, die je bei Ihnen gemietet haben.',
    'pageTours.clients.search.p1': 'Suche nach Nachname, Vorname, Telefon oder E-Mail - Sie tippen einen Teil ein, die Liste filtert sofort.',
    'pageTours.clients.search.p2': 'Daneben: Sortierung (A-Z, nach Anzahl der Reservierungen, neueste) und ein Filter für alle, neue der letzten 30 Tage oder Stammkunden.',
    'pageTours.clients.search.p3': 'Kunden tragen sich bei einer Buchung über das Widget selbst ein - Sie müssen sie nicht von Hand anlegen.',
    'pageTours.clients.search.title': 'Kundenstamm',
    'pageTours.clients.title': 'Kunden',
    'pageTours.contract-template.preview.lead': 'Die Vorschau zeigt den Vertrag so, wie er auf Papier herauskommt.',
    'pageTours.contract-template.preview.p1': '"Testen mit" setzt Beispielreservierungen ein: Standard, ohne Kaution und längere Miete.',
    'pageTours.contract-template.preview.p2': '"PDF-Vorschau" zeigt die genaue Aufteilung auf Seiten.',
    'pageTours.contract-template.preview.p3': 'Änderungen werden als Entwurf gespeichert - Kunden erhalten die neue Fassung erst nach "Vorlage veröffentlichen".',
    'pageTours.contract-template.preview.title': 'Vorschau und Veröffentlichung',
    'pageTours.contract-template.start.lead': 'Den Vertrag setzen Sie aus Blöcken zusammen - am einfachsten beginnen Sie mit einer fertigen Vorlage.',
    'pageTours.contract-template.start.p1': 'Eine Vorlage ersetzt alle Abschnitte, danach passen Sie den Text nach Ihren Wünschen an.',
    'pageTours.contract-template.start.p2': 'Sie haben schon einen eigenen Vertrag? Klappen Sie den Import auf und fügen Sie den Text ein.',
    'pageTours.contract-template.start.p3': 'Felder wie Kundenname oder Ausrüstungsliste fügen Sie aus einer Liste ein - im Vertrag zu einer Reservierung stehen dann die echten Daten.',
    'pageTours.contract-template.start.title': 'Vertragseditor',
    'pageTours.contract-template.title': 'Vertragseditor',
    'pageTours.counter': 'Schritt {current} von {total}',
    'pageTours.equipment-bundles.effect.lead': 'Sie müssen nicht an das Paket denken - das System erkennt es selbst.',
    'pageTours.equipment-bundles.effect.p1': 'Nimmt ein Kunde eine zum Set passende Kombination, sinkt der Preis auf den Paketsatz.',
    'pageTours.equipment-bundles.effect.p2': 'Die Preisaufschlüsselung in der Zusammenfassung zeigt, wie viel der Kunde beim Set gespart hat.',
    'pageTours.equipment-bundles.effect.p3': 'Der Schalter in der Listenzeile aktiviert und deaktiviert ein Set, ohne es zu löschen.',
    'pageTours.equipment-bundles.effect.title': 'So wirkt es bei der Buchung',
    'pageTours.equipment-bundles.presets.lead': 'Ein Paket sind mehrere Ausrüstungstypen, die zusammen günstiger vermietet werden - "Neues Set" legt eines von Grund auf an.',
    'pageTours.equipment-bundles.presets.p1': '"Schnellsets" darunter schlagen Geräte vor, die Kunden zusammen mieten, samt Preisvorschlag.',
    'pageTours.equipment-bundles.presets.p2': 'Ein Klick auf den Vorschlag füllt nur das Formular - Preis und Name können Sie vor dem Speichern ändern.',
    'pageTours.equipment-bundles.presets.p3': 'Ein Set muss mindestens zwei Ausrüstungstypen enthalten.',
    'pageTours.equipment-bundles.presets.title': 'Sets zu einem Preis',
    'pageTours.equipment-bundles.title': 'Ausrüstungspakete',
    'help.button.aria': 'Hilfe und Rückmeldung',
    'help.menu.label': 'Hilfe',
    'help.menu.bug': 'Fehler melden',
    'help.menu.question': 'Frage stellen',
    'help.menu.idea': 'Änderung oder neue Funktion vorschlagen',
    'help.menu.tour': 'Anleitung zu dieser Seite',
    'help.form.title': 'Schreiben Sie uns',
    'help.form.subtitle': 'Ihre Nachricht geht an das the.rENT-Team, wir antworten per E-Mail.',
    'help.form.category': 'Thema',
    'help.category.bug': 'Fehler',
    'help.category.question': 'Frage',
    'help.category.idea': 'Vorschlag',
    'help.category.other': 'Sonstiges',
    'help.form.subject': 'Betreff',
    'help.form.message': 'Beschreibung',
    'help.form.hint.bug': 'Was haben Sie getan, was ist passiert und was haben Sie erwartet?',
    'help.form.hint.question': 'Was suchen Sie oder was möchten Sie tun?',
    'help.form.hint.idea': 'Was möchten Sie ändern oder ergänzen, und wobei würde es Ihnen helfen?',
    'help.form.hint.other': 'Schreiben Sie uns, wobei wir helfen können.',
    'help.form.counter': '{n} von {max} Zeichen',
    'help.form.noCustomerData': 'Geben Sie keine Kundendaten an, wenn sie nicht nötig sind.',
    'help.form.replyTo': 'Wir antworten an',
    'help.form.replyToMissing': 'Ihr Konto hat keine E-Mail-Adresse, daher können wir nicht per E-Mail antworten. Geben Sie in der Beschreibung eine Telefonnummer oder einen anderen Kontaktweg an.',
    'help.form.send': 'Senden',
    'help.form.sending': 'Wird gesendet…',
    'help.form.cancel': 'Abbrechen',
    'help.form.close': 'Schließen',
    'help.shots.toggle': 'Screenshot anhängen (optional)',
    'help.shots.drop': 'Screenshot einfügen (Strg+V), hierher ziehen oder',
    'help.shots.choose': 'Datei auswählen',
    'help.shots.count': 'Angehängt: {n} von {max}',
    'help.shots.warning': 'Ein Screenshot kann Daten Ihrer Kunden enthalten. Schneiden Sie ihn zu oder verdecken Sie die Daten vor dem Senden.',
    'help.shots.howTo': 'So erstellen Sie einen Screenshot: unter Windows Win+Umschalt+S, auf dem Mac Cmd+Umschalt+4, auf dem Handy Ein-/Aus- und Leiser-Taste gleichzeitig.',
    'help.shots.remove': 'Screenshot {n} entfernen',
    'help.shots.alt': 'Screenshot {n}',
    'help.shots.limit': 'Sie können höchstens {max} Screenshots anhängen.',
    'help.shots.notImage': 'Eine Datei, die kein Bild ist, wurde übersprungen.',
    'help.context.summary': 'Was wir zusätzlich senden',
    'help.context.intro': 'Das fügen wir automatisch hinzu, damit wir die Ursache schneller finden:',
    'help.context.page': 'Seite',
    'help.context.browser': 'Browser',
    'help.context.language': 'Sprache des Panels',
    'help.context.window': 'Fenstergröße',
    'help.context.org': 'Firma',
    'help.context.account': 'Konto',
    'help.context.role': 'Rolle und Tarif',
    'help.context.roleValue': 'aus Ihrem Konto',
    'help.context.attachments': 'Screenshots',
    'help.context.none': 'keine',
    'help.done.title': 'Danke, Ihre Nachricht wurde gesendet',
    'help.done.ticket': 'Vorgangsnummer',
    'help.done.reply': 'Wir antworten an {email}.',
    'help.done.replyNoEmail': 'Ihr Konto hat keine E-Mail-Adresse. Nennen Sie die Vorgangsnummer, wenn Sie uns schreiben.',
    'help.error.invalid_category': 'Wählen Sie das Thema Ihrer Nachricht.',
    'help.error.subject_required': 'Geben Sie einen Betreff ein.',
    'help.error.subject_too_long': 'Der Betreff darf höchstens {max} Zeichen haben.',
    'help.error.message_too_short': 'Beschreiben Sie das Anliegen in mindestens {min} Zeichen.',
    'help.error.message_too_long': 'Die Beschreibung darf höchstens {max} Zeichen haben.',
    'help.error.too_many_attachments': 'Sie können höchstens {max} Screenshots anhängen.',
    'help.error.attachment_too_large': 'Einer der Screenshots ist zu groß. Schneiden Sie ihn zu oder verkleinern Sie ihn.',
    'help.error.attachment_not_image': 'Eine der Dateien ist kein PNG-, JPEG- oder WebP-Bild.',
    'help.error.attachment_unreadable': 'Einer der Screenshots kann nicht gelesen werden. Speichern Sie ihn erneut und hängen Sie ihn noch einmal an.',
    'help.error.request_too_large': 'Die Screenshots sind zusammen zu groß. Entfernen Sie einen oder schneiden Sie sie zu.',
    'help.error.too_many_requests': 'Es wurden bereits viele Nachrichten gesendet. Versuchen Sie es in {minutes} Min. erneut oder schreiben Sie uns per E-Mail.',
    'help.error.server_busy': 'Der Server ist gerade ausgelastet. Versuchen Sie es in {seconds} s erneut oder schreiben Sie uns per E-Mail.',
    'help.error.session': 'Ihre Sitzung ist abgelaufen. Melden Sie sich erneut an, Ihr Text bleibt erhalten. Sie können uns auch per E-Mail schreiben.',
    'help.error.generic': 'Die Nachricht konnte nicht gesendet werden.',
    'help.fallback.retry': 'Erneut versuchen',
    'help.fallback.title': 'Die Nachricht konnte nicht über das Panel gesendet werden',
    'help.fallback.body': 'Senden Sie sie stattdessen per E-Mail, der Text ist vorbereitet.',
    'help.fallback.link': 'Nachricht im E-Mail-Programm öffnen',
    'help.fallback.address': 'Oder schreiben Sie an {email}.',
    'help.fallback.attachNote': 'Screenshots lassen sich nicht automatisch anhängen, fügen Sie sie der E-Mail selbst hinzu.',
    'help.mailto.attachNote': 'Zu dieser Nachricht gehören Screenshots ({n}); ich hänge sie an diese E-Mail an.',
    'pageTours.finish': 'Verstanden',
    'pageTours.home.favorites.lead': 'Verknüpfungen zu den Seiten, die Sie am häufigsten nutzen.',
    'pageTours.home.favorites.p1': 'Ein Klick auf eine Kachel führt direkt zur gewählten Seite.',
    'pageTours.home.favorites.p2': 'Über "Bearbeiten" wählen Sie bis zu vier Verknüpfungen aus.',
    'pageTours.home.favorites.p3': 'Die Kacheln ziehen Sie am Griff in der Ecke, um sie nach Ihren Wünschen anzuordnen.',
    'pageTours.home.favorites.title': 'Ihr Dashboard',
    'pageTours.home.title': 'Startseite',
    'pageTours.home.upcoming.lead': 'Eine Liste dessen, was Sie in den nächsten Tagen ausgeben.',
    'pageTours.home.upcoming.p1': 'Der Schalter "Bevorstehend / Laufend" zeigt auch Reservierungen, die schon begonnen haben.',
    'pageTours.home.upcoming.p2': 'Den Zeitraum ändern Sie daneben: heute, diese Woche oder 30 Tage.',
    'pageTours.home.upcoming.p3': 'Ein Klick auf eine Reservierung öffnet sie mit allen Details im Kalender.',
    'pageTours.home.upcoming.title': 'Nächste Reservierungen',
    'pageTours.inventory.actions.lead': 'Die gesamte Ausrüstung in einer Tabelle, darüber die häufigsten Aktionen.',
    'pageTours.inventory.actions.p1': '"Ausrüstung hinzufügen" legt ein Stück an; eine längere Liste laden Sie aus einer Tabelle hoch (Profil → Datenimport).',
    'pageTours.inventory.actions.p2': '"Inventar-Einstellungen" legen fest, welche Felder und Spalten Ihre Ausrüstung hat.',
    'pageTours.inventory.actions.p3': '"Etiketten" druckt QR- und Strichcodes, der "Gerätekalender" zeigt die Belegung der Stücke.',
    'pageTours.inventory.actions.title': 'Inventar',
    'pageTours.inventory.filters.lead': 'Ein Feld sucht nach Name, Marke, Nummer und Strichcode.',
    'pageTours.inventory.filters.p1': 'Die Chips darunter grenzen die Liste ein - ein gesetzter Chip zeigt seinen Wert und ein Kreuz zum Löschen.',
    'pageTours.inventory.filters.p2': '"Kamera" und "Handy" scannen den Code vom Aufkleber und finden das Stück sofort.',
    'pageTours.inventory.filters.p3': 'Ein Klick auf ein Stück öffnet seine Details mit Bearbeiten und Etikettendruck.',
    'pageTours.inventory.filters.title': 'Suche und Filter',
    'pageTours.inventory.title': 'Inventar',
    'pageTours.invoices.filters.lead': 'Suche und Filter grenzen die Liste ein.',
    'pageTours.invoices.filters.p1': 'Sie suchen nach Nummer, Käufer oder Steuernummer; daneben wählen Sie Dokumenttyp und Zeitraum.',
    'pageTours.invoices.filters.p2': 'Die Chips unter den Feldern filtern nach Zahlung: unbezahlt, teilweise bezahlt, bezahlt.',
    'pageTours.invoices.filters.p3': 'In jeder Zeile laden Sie das PDF herunter und senden eine Mehrwertsteuerrechnung an KSeF (im Demo-Modus ist das Senden an KSeF gesperrt).',
    'pageTours.invoices.filters.title': 'Dokumentenliste',
    'pageTours.invoices.new.lead': 'Hier stellen Sie Proformarechnungen, Mehrwertsteuerrechnungen und Korrekturen aus.',
    'pageTours.invoices.new.p1': '"Neue Rechnung" erstellt ein Dokument aus einer Reservierung (Positionen und Käufer füllen sich selbst) oder von Grund auf.',
    'pageTours.invoices.new.p2': 'Die Kacheln darunter zeigen, wie viel auf Zahlung wartet und was überfällig ist.',
    'pageTours.invoices.new.p3': 'Eine ausgestellte Mehrwertsteuerrechnung bearbeiten Sie nicht - Sie berichtigen sie per Korrektur.',
    'pageTours.invoices.new.title': 'Rechnungen',
    'pageTours.invoices.title': 'Rechnungen',
    'pageTours.next': 'Weiter',
    'pageTours.notifications.email.lead': 'E-Mails an Kunden gehen automatisch raus - Sie schalten nur die ein, die Sie brauchen.',
    'pageTours.notifications.email.p1': 'Vier Arten: Reservierungsbestätigung, Erinnerung an die Abholung, an die Rückgabe und fertiger Vertrag.',
    'pageTours.notifications.email.p2': 'Nach dem Einschalten klappt der Text auf: Kunden- und Reservierungsdaten fügen Sie per Chip ein, der Test-Button schickt ein Muster an Ihre Adresse.',
    'pageTours.notifications.email.p3': 'Erinnerungen gehen so viele Tage vorher raus, wie Sie einstellen, und nur zwischen 9 und 20 Uhr.',
    'pageTours.notifications.email.title': 'E-Mail-Benachrichtigungen',
    'pageTours.notifications.sms.lead': 'SMS werden über Ihr eigenes Konto bei SMSAPI.pl verschickt.',
    'pageTours.notifications.sms.p1': 'Sie schalten sie mit dem Hauptschalter ein und dann jede Art einzeln - wie bei E-Mails.',
    'pageTours.notifications.sms.p2': 'Den API-Token fügen Sie einmal ein; nach dem Speichern wird er nirgends mehr angezeigt.',
    'pageTours.notifications.sms.p3': 'Im Demo-Modus werden keine Nachrichten an Kunden gesendet - ein Test geht nur an Ihre eigene E-Mail-Adresse.',
    'pageTours.notifications.sms.title': 'SMS-Benachrichtigungen',
    'pageTours.notifications.title': 'Benachrichtigungen',
    'pageTours.offer-template.fields.lead': 'Die festen Teile des Angebots legen Sie einmal fest, die Kundendaten füllen sich selbst.',
    'pageTours.offer-template.fields.p1': 'Die Chips fügen Felder (Kunde, Zeitraum, Betrag, Kontonummer) an der Cursorposition im Textfeld ein.',
    'pageTours.offer-template.fields.p2': 'Die Tabellen mit Kundendaten, Ausrüstung und Zusammenfassung entstehen automatisch.',
    'pageTours.offer-template.fields.p3': 'In der Kopfzeile darüber legen Sie Titel, Firmenlogo und Schriftgröße fest.',
    'pageTours.offer-template.fields.title': 'Angebotseditor',
    'pageTours.offer-template.preview.lead': 'Die Vorschau zeigt das Angebot mit Beispieldaten.',
    'pageTours.offer-template.preview.p1': '"PDF-Vorschau" und "PDF herunterladen" liefern genau die Datei, die der Kunde bekommt.',
    'pageTours.offer-template.preview.p2': '"Entwurf speichern" ändert nichts für Kunden - die neue Fassung gilt erst nach "Vorlage veröffentlichen".',
    'pageTours.offer-template.preview.p3': 'Frühere veröffentlichte Fassungen bleiben im Verlauf.',
    'pageTours.offer-template.preview.title': 'Vorschau und Veröffentlichung',
    'pageTours.offer-template.title': 'Angebotseditor',
    'pageTours.offers.form.lead': 'Hier kalkulieren Sie eine Anfrage, bevor daraus eine Reservierung wird.',
    'pageTours.offers.form.p1': 'Sie tragen Kundendaten ein (das E-Mail-Feld schlägt vorhandene vor), Zeitraum und Ausrüstung - der Preis kommt aus Ihrer Preisliste.',
    'pageTours.offers.form.p2': 'Den Rabatt geben Sie als Betrag oder in Prozent an; den Endbetrag können Sie auch von Hand überschreiben.',
    'pageTours.offers.form.p3': '"Angebot erzeugen" macht ein PDF, "Angebot per E-Mail senden" schickt es dem Kunden.',
    'pageTours.offers.form.title': 'Angebot für einen Kunden',
    'pageTours.offers.history.lead': 'Gesendete Angebote gehen nicht verloren - sie liegen im Reiter mit dem Angebotsverlauf.',
    'pageTours.offers.history.p1': 'Sie sehen, was an wen ging, und können das Dokument erneut erzeugen.',
    'pageTours.offers.history.p2': 'Aus einem angenommenen Angebot wird eine Reservierung, ohne etwas abzutippen.',
    'pageTours.offers.history.p3': 'Ausrüstung aus einem Angebot kann vorübergehend gesperrt werden, damit sie niemand zwischenzeitlich bucht.',
    'pageTours.offers.history.title': 'Angebotsverlauf',
    'pageTours.offers.title': 'Angebote',
    'pageTours.payment-settings.account.lead': 'Nach dem Verbinden des Kontos erscheinen in dieser Karte die Zahlungseinstellungen.',
    'pageTours.payment-settings.account.p1': '"Anzahlung im Widget": welchen Prozentsatz des Betrags der Kunde bei der Buchung online zahlt.',
    'pageTours.payment-settings.account.p2': 'Automatische Stornierung: Eine Widget-Reservierung ohne Zahlung wird nach der eingestellten Stundenzahl storniert, der Kunde wird vorher erinnert.',
    'pageTours.payment-settings.account.p3': 'Das Pausieren der Online-Zahlungen stoppt neue Zahlungen, ohne das Konto zu trennen.',
    'pageTours.payment-settings.account.title': 'Konto und Zahlungsregeln',
    'pageTours.payment-settings.intro.lead': 'Kunden zahlen per BLIK oder Karte, und das Geld geht direkt auf Ihr Konto.',
    'pageTours.payment-settings.intro.p1': 'Die Zahlungen wickelt Stripe ab - Ihr Konto verbinden Sie einmal auf dessen sicherer Seite.',
    'pageTours.payment-settings.intro.p2': 'Auch ohne Verbindung funktionieren Reservierungen: Die Anzahlung nehmen Sie bar oder per Überweisung an.',
    'pageTours.payment-settings.intro.p3': 'Im Demo-Modus sind Online-Zahlungen abgeschaltet - keine Karte wird belastet.',
    'pageTours.payment-settings.intro.title': 'Online-Zahlungen',
    'pageTours.payment-settings.title': 'Online-Zahlungen',
    'pageTours.payments.deposits.lead': 'Die Kacheln oben zeigen, wie viel schon eingenommen wurde und wie viele Zahlungen auf den Kunden warten.',
    'pageTours.payments.deposits.p1': 'Eine Anzahlung bestätigt die Reservierung; ihren Prozentsatz stellen Sie in den Zahlungseinstellungen ein.',
    'pageTours.payments.deposits.p2': 'Eine Kaution läuft über eine Kartensperre und wird danach eingezogen oder freigegeben.',
    'pageTours.payments.deposits.p3': 'Im Demo-Modus sind Online-Zahlungen abgeschaltet - keine Karte wird belastet.',
    'pageTours.payments.deposits.title': 'Anzahlungen und Kautionen',
    'pageTours.payments.list.lead': 'Zusammen: Online-Zahlungen und die vor Ort angenommenen.',
    'pageTours.payments.list.p1': 'Die Status-Chips filtern die Liste - dieselben Farben wie die Abzeichen in der Tabelle.',
    'pageTours.payments.list.p2': 'Zeitraum und Suchfeld grenzen die Liste auf einen konkreten Vorgang ein.',
    'pageTours.payments.list.p3': 'Online-Zahlungen gleichen Sie mit den Stripe-Auszahlungen ab; Bargeld und Überweisung werden bei der Reservierung von Hand erfasst.',
    'pageTours.payments.list.title': 'Kundenzahlungen',
    'pageTours.payments.title': 'Zahlungen',
    'pageTours.prev': 'Zurück',
    'pageTours.price-rules.form.lead': 'Wenn Sie etwas jenseits der Vorlagen brauchen.',
    'pageTours.price-rules.form.p1': '"Neue Regel" öffnet das Formular: Zeitraum, Wochentage, Klasse oder Ausrüstungstyp und die Änderung - Prozent oder Betrag.',
    'pageTours.price-rules.form.p2': 'Die Priorität entscheidet, welche Regel gewinnt, wenn mehrere zugleich passen.',
    'pageTours.price-rules.form.p3': 'Regeln gelten überall dort, wo ein Preis berechnet wird: Reservierungen, Angebote und Widget.',
    'pageTours.price-rules.form.title': 'Eigene Regel',
    'pageTours.price-rules.presets.lead': 'Der einfachste Einstieg: eine fertige Regel per Schalter aktivieren.',
    'pageTours.price-rules.presets.p1': 'Wochenendzuschlag, Hochsaison und Nebensaison-Aktion - mit bereits gesetzten Zeiträumen.',
    'pageTours.price-rules.presets.p2': 'Die Chips daneben wählen die Höhe der Änderung (z. B. +10%, +15%, +20%).',
    'pageTours.price-rules.presets.p3': 'Das Ausschalten legt die Regel nur schlafen, es löscht sie nicht.',
    'pageTours.price-rules.presets.title': 'Schnellregeln',
    'pageTours.price-rules.title': 'Saisonpreise',
    'pageTours.profile.account.lead': 'Die Einstellungen sind in Gruppen aufgeteilt - die erste betrifft Sie selbst.',
    'pageTours.profile.account.p1': '"Ihre Daten" und "Sicherheit": Kontakt, Passwort und Anmeldung in zwei Schritten.',
    'pageTours.profile.account.p2': '"Ihre Einstellungen": helles oder dunkles Design und die Sprache des Panels.',
    'pageTours.profile.account.p3': '"Benutzer": Konten für Mitarbeiter - jeder meldet sich mit eigenem Login an.',
    'pageTours.profile.account.title': 'Ihr Konto',
    'pageTours.profile.company.lead': 'Weiter unten liegen die Einstellungen für den ganzen Verleih.',
    'pageTours.profile.company.p1': '"Firmendaten" landen auf Verträgen, Angeboten und Rechnungen - ergänzen Sie sie vor dem ersten Dokument.',
    'pageTours.profile.company.p2': 'Unter "Verkauf" finden Sie dynamische Preise (Saisons, Wochenenden) und Ausrüstungspakete.',
    'pageTours.profile.company.p3': 'Unter "Integrationen": E-Mail-Versand, Datenimport aus einer Tabelle und das Widget für die Website.',
    'pageTours.profile.company.title': 'Firma und Verkauf',
    'pageTours.profile.title': 'Profil',
    'pageTours.reservation.client.lead': 'Das Formular läuft von oben nach unten: Kunde, Zeitraum, Ausrüstung, Zahlung.',
    'pageTours.reservation.client.p1': 'Beginnen Sie mit dem Nachnamen - wir schlagen Kunden vor, die schon bei Ihnen waren, und füllen ihre Daten aus.',
    'pageTours.reservation.client.p2': 'Eine neue Person landet beim Speichern der Reservierung automatisch im Kundenstamm.',
    'pageTours.reservation.client.p3': 'Felder mit Sternchen sind Pflicht; die Adresse geben Sie nach einem Klick ins Feld als Straße, PLZ und Ort ein.',
    'pageTours.reservation.client.title': 'Neue Reservierung',
    'pageTours.reservation.equipment.lead': 'Die Ausrüstung wählen Sie nach dem Zeitraum - dann ist klar, was frei ist.',
    'pageTours.reservation.equipment.p1': '"Ausrüstung wählen" zeigt nur die Stücke, die in diesem Zeitraum verfügbar sind.',
    'pageTours.reservation.equipment.p2': 'Ein Stück fügen Sie auch per Code-Scan hinzu: mit Scanner, Kamera oder Handy.',
    'pageTours.reservation.equipment.p3': 'Der Preis ergibt sich aus Preisliste und Paketen; die Zusammenfassung unten zeigt Rabatt und Anzahlung.',
    'pageTours.reservation.equipment.title': 'Ausrüstung für die Reservierung',
    'pageTours.reservation.title': 'Neue Reservierung',
    'pageTours.skip': 'Rundgang überspringen',
    'pageTours.statistics.charts.lead': 'Die Diagramme werden aus Ihren Reservierungen berechnet - Sie müssen nichts eintragen.',
    'pageTours.statistics.charts.p1': 'Dieser Schalter wechselt die Kennzahl der Diagramme: Anzahl der Reservierungen oder Wert in Währung.',
    'pageTours.statistics.charts.p2': '"Saisonalität" zeigt die Verteilung übers Jahr - Hochphase und tote Monate sind sofort sichtbar.',
    'pageTours.statistics.charts.p3': 'Ganz unten, unter "Erweiterte Metriken", die Tabelle "Umsatz / Gerät": die Ausrüstung mit dem höchsten Umsatz im gewählten Zeitraum, mit der Zahl der Vermietungen. Die Grundlage dafür, was Sie nachkaufen.',
    'pageTours.statistics.charts.title': 'Wie das Geschäft läuft',
    'pageTours.statistics.kpi.lead': 'Der KPI-Bereich hat eigene Filter für Jahr, Monat und Saison.',
    'pageTours.statistics.kpi.p1': 'Wählen Sie Jahr, Monat oder Saison - die Kennzahlen werden für diesen Zeitraum neu berechnet. Der Prozentwert unter den Kacheln vergleicht ihn mit demselben Zeitraum im Vorjahr, ein laufender Zeitraum zählt bis heute.',
    'pageTours.statistics.kpi.p2': '"Löschen" kehrt zum aktuellen Monat zurück, die Diagramme zum aktuellen Jahr. Die Jahrespfeile über dem Diagramm stellen die Kennzahlen auf das ganze Jahr.',
    'pageTours.statistics.kpi.p3': 'Auslastung und durchschnittlicher Mietwert sagen Ihnen, ob Sie die Preise anheben sollten.',
    'pageTours.statistics.kpi.title': 'Kennzahlen für einen Zeitraum',
    'pageTours.statistics.title': 'Statistiken',
    'pageTours.widget.embed.lead': 'Oberhalb dieser Stelle ändern Sie Name, Farben und Kategoriebilder - die Vorschau ändert sich sofort.',
    'pageTours.widget.embed.p1': '"Code anzeigen" liefert einen Ausschnitt zum Einfügen in Ihre Website.',
    'pageTours.widget.embed.p2': 'Die zugelassenen Domains sind die Seiten, auf die Kunden nach einer Online-Zahlung zurückkehren; das Widget aus dem Code und der Link mit QR-Code funktionieren immer.',
    'pageTours.widget.embed.p3': 'Kategoriebilder laden Sie von Ihrer Festplatte hoch - das Widget lädt keine Bilder von anderen Websites.',
    'pageTours.widget.embed.title': 'Einstellungen und Einbau',
    'pageTours.widget.preview.lead': 'Das Widget ist ein Buchungsformular, das Sie auf Ihrer eigenen Website einbinden.',
    'pageTours.widget.preview.p1': 'Die Live-Vorschau zeigt es so, wie der Kunde es sieht - am Computer und am Handy.',
    'pageTours.widget.preview.p2': 'Der Kunde wählt Zeitraum und Ausrüstung, und die Reservierung landet direkt in Ihrem Kalender. Im Demo-Konto nimmt das Widget keine Reservierungen an.',
    'pageTours.widget.preview.p3': 'Die Verfügbarkeit ergibt sich aus Inventar und Reservierungen, ein Kunde kann also keine belegte Ausrüstung buchen.',
    'pageTours.widget.preview.title': 'Buchungs-Widget',
    'pageTours.widget.title': 'Widget',

    // ── P8.1e (2/5): ustawienia firmy i powiadomien ──
    'contractSettings.alignCenter': 'Zentriert',
    'contractSettings.alignLeft': 'Linksbündig',
    'contractSettings.alignRight': 'Rechtsbündig',
    'contractSettings.autoEmail': 'Rechnung automatisch per E-Mail an den Käufer senden',
    'contractSettings.autoEmailHint': 'Nach dem Ausstellen einer Mehrwertsteuerrechnung, eines Belegs oder einer Korrektur sendet das System das PDF automatisch an die E-Mail-Adresse des Kunden.',
    'contractSettings.bankCard': 'Bankdaten',
    'contractSettings.bankName': 'Name der Bank',
    'contractSettings.bankNamePh': 'PKO Bank Polski S.A.',
    'contractSettings.changeLogo': 'Logo ändern',
    'contractSettings.city': 'Stadt',
    'contractSettings.cityPh': 'Warszawa',
    'contractSettings.companyCard': 'Firmendaten (Verleih)',
    'contractSettings.companyName': 'Vollständiger Firmenname',
    'contractSettings.companyNamePh': 'z. B. Twoja Firma Sp. z o.o.',
    'contractSettings.email': 'Firmen-E-Mail',
    'contractSettings.emailBody': 'E-Mail-Text',
    'contractSettings.emailPh': 'kontakt@ihrefirma.de',
    'contractSettings.emailSubject': 'E-Mail-Betreff',
    'contractSettings.goToBuilder': 'Zum Vertragseditor →',
    'contractSettings.iban': 'Kontonummer (IBAN)',
    'contractSettings.ibanPh': 'PL 12 3456 7890 1234 5678 9012 3456',
    'contractSettings.insertVarHint': 'Klicken Sie, um eine Variable an der Cursorposition in Betreff oder Text einzufügen:',
    'contractSettings.insertVarTitle': 'Zum Einfügen klicken',
    'contractSettings.invoiceCard': 'Rechnungseinstellungen',
    'contractSettings.krs': 'KRS (optional)',
    'contractSettings.loadError': 'Die Vertragseinstellungen konnten nicht geladen werden.',
    'contractSettings.loading': 'Wird geladen…',
    'contractSettings.logoAlign': 'Logo-Ausrichtung',
    'contractSettings.logoCard': 'Firmenlogo',
    'contractSettings.logoHeight': 'Logohöhe (px)',
    'contractSettings.logoHeightError': 'Geben Sie eine ganze Zahl von {min} bis {max} ein.',
    'contractSettings.logoHeightHint': 'Von {min} bis {max} px, ein leeres Feld bedeutet {def} px. Ein breites Logo ist zusätzlich auf 260 px Breite begrenzt und kann daher niedriger ausfallen als die eingegebene Höhe.',
    'contractSettings.saveBlockedAfterLoadError': 'Laden Sie die Seite neu, bevor Sie speichern: Das Speichern ist deaktiviert, damit leere Felder die gespeicherten Firmendaten nicht überschreiben.',
    'contractSettings.logoHint': 'Erscheint oben auf erzeugten Verträgen. PNG, JPG, WEBP oder SVG, maximal 1 MB.',
    'contractSettings.logoTooBig': 'Das Logo ist zu groß. Die maximale Größe beträgt 1 MB.',
    'contractSettings.logoType': 'Das Logo muss eine PNG-, JPG-, WEBP- oder SVG-Datei sein.',
    'contractSettings.missingDataBody': 'Fehlende Firmendaten: {list}. Diese werden automatisch in Verträge eingesetzt. Ohne sie bleiben Felder im Vertrag leer. Trotzdem zum Editor wechseln?',
    'contractSettings.missingDataTitle': 'Firmendaten fehlen',
    'contractSettings.noLogo': 'Kein Logo',
    'contractSettings.numberFormat': 'Die Rechnungsnummer hat das Format:',
    'contractSettings.payBlik': 'BLIK',
    'contractSettings.payCard': 'Karte',
    'contractSettings.payCash': 'Bargeld',
    'contractSettings.payMethod': 'Standard-Zahlungsart',
    'contractSettings.payOther': 'Sonstige',
    'contractSettings.payTerm': 'Standard-Zahlungsziel (Tage)',
    'contractSettings.payTransfer': 'Banküberweisung',
    'contractSettings.phone': 'Firmentelefon',
    'contractSettings.pickLogo': 'Logodatei auswählen',
    'contractSettings.postalCode': 'Postleitzahl',
    'contractSettings.prefixCorrection': 'Korrektur',
    'contractSettings.prefixProforma': 'Proforma',
    'contractSettings.prefixSimplified': 'Beleg / vereinfacht',
    'contractSettings.prefixVat': 'Mehrwertsteuerrechnung',
    'contractSettings.prefixes': 'Präfixe der Rechnungsnummerierung',
    'contractSettings.regon': 'REGON (optional)',
    'contractSettings.removeLogo': 'Logo entfernen',
    'contractSettings.save': 'Einstellungen speichern',
    'contractSettings.saveError': 'Speicherfehler',
    'contractSettings.saveGenericError': 'Fehler beim Speichern der Einstellungen.',
    'contractSettings.saveInvoiceError': 'Fehler beim Speichern der Rechnungseinstellungen',
    'contractSettings.saved': 'Firmendaten und Rechnungseinstellungen wurden gespeichert.',
    'contractSettings.saving': 'Wird gespeichert…',
    'contractSettings.signerCard': 'Unterzeichnende Person',
    'contractSettings.signerName': 'Vor- und Nachname',
    'contractSettings.signerNamePh': 'Jan Kowalski',
    'contractSettings.signerTitle': 'Position / Funktion',
    'contractSettings.signerTitlePh': 'Inhaber / Geschäftsführer',
    'contractSettings.street': 'Straße und Hausnummer',
    'contractSettings.streetPh': 'ul. Przykładowa 1',
    'contractSettings.subtitle': 'Die Daten Ihres Verleihs werden automatisch in erzeugte Verträge eingesetzt.',
    'contractSettings.title': 'Firmendaten',
    'contractSettings.unsavedBanner': 'Sie haben nicht gespeicherte Änderungen. Speichern Sie sie, bevor Sie die Seite wechseln.',
    'contractSettings.pauseNote': 'Das Konto ist pausiert: Die Firmendaten sind nur lesbar, die Rechnungseinstellungen speichern Sie wie gewohnt.',
    'contractSettings.unsavedBody': 'Sie haben nicht gespeicherte Änderungen. Möchten Sie wirklich zum Vertragseditor wechseln?',
    'contractSettings.unsavedTitle': 'Nicht gespeicherte Änderungen',
    'contractSettings.varBuyerName': 'Name des Käufers',
    'contractSettings.varDocLabel': 'Belegart',
    'contractSettings.varInvoiceNumber': 'Rechnungsnummer',
    'contractSettings.varOrganizationName': 'Firmenname',
    'contractSettings.varTotalGross': 'Bruttobetrag',
    'contractSettings.varAmountPaid': 'Bezahlt',
    'contractSettings.varAmountDue': 'Offener Betrag',
    'contractSettings.vatRate': 'Standard-Mehrwertsteuersatz',
    'contractSettings.vatStatus': 'USt-Status',
    'contractSettings.vatStatusActive': 'Umsatzsteuerpflichtig',
    'contractSettings.vatStatusExempt': 'Von der USt befreit',
    'contractSettings.vatRateZero': '0 % (inländisch, keine Befreiung)',
    'contractSettings.vatRateLegacy': '{rate} % (nicht in der Liste, anderen Satz wählen)',
    'contractSettings.vatZeroHint': 'Ein Satz von 0 % ist keine Umsatzsteuerbefreiung. Ist die Firma befreit, wählen Sie den Status „Von der USt befreit“ und geben Sie die Rechtsgrundlage an. Bereits ausgestellte Rechnungen ändern sich nicht.',
    'contractSettings.vatBasis': 'Rechtsgrundlage der USt-Befreiung',
    'contractSettings.vatBasisPh': 'z. B. art. 113 ust. 1 ustawy o VAT',
    'contractSettings.vatBasis113': 'Art. 113 Abs. 1: Umsatz bis 240 000 PLN im Vorjahr',
    'contractSettings.vatBasis1139': 'Art. 113 Abs. 9: Tätigkeit in diesem Jahr begonnen',
    'contractSettings.vatBasis43': 'Art. 43 Abs. 1: gesetzlich befreite Leistung (Nummer eintragen)',
    'contractSettings.vatExemptHint': 'Rechnungen einer befreiten Firma tragen den Titel „Faktura“, Positionen mit dem Satz „zw“ und einen Satz zur Befreiung mit dieser Rechtsgrundlage. Seit 2026 gilt die Kleinunternehmerbefreiung bis 240 000 PLN Umsatz im Jahr. Bestätigen Sie die Grundlage mit Ihrer Buchhaltung.',
    'contractSettings.vatBasisRequired': 'Eine von der USt befreite Firma muss die Rechtsgrundlage angeben.',
    'contractSettings.vatBasisIncomplete': 'Ergänzen Sie die Rechtsgrundlage: Ersetzen Sie „…“ durch die Nummer.',
    'notifications.active': 'Aktiv',
    'notifications.body': 'Text der Nachricht',
    'notifications.chars': 'Zeichen',
    'notifications.confirmDesc': 'Wird direkt nach dem Anlegen einer Reservierung automatisch an den Kunden gesendet.',
    'notifications.confirmLabel': 'Reservierungsbestätigung',
    'notifications.contractDesc': 'Wird an den Kunden gesendet, wenn ein Mitarbeiter im System einen Mietvertrag erzeugt.',
    'notifications.contractLabel': 'Vertrag fertig',
    'notifications.daysBefore': 'Tage vorher',
    'notifications.demoNotice': 'Demo-Modus - an Kunden werden keine Nachrichten gesendet. Eine Testnachricht geht nur an Ihre eigene E-Mail-Adresse.',
    'notifications.premiumTitle': 'Automatische Erinnerungen und SMS sind im Premium-Tarif enthalten.',
    'notifications.premiumBody': 'Im Basic-Tarif erhalten Kunden die Buchungsbestätigung und den Vertrag per E-Mail.',
    'notifications.remindersPremium': 'Erinnerungen an Abholung und Rückgabe sind im Premium-Tarif enthalten. Gespeicherte Einstellungen wirken nach dem Wechsel zu Premium.',
    'notifications.smsPremium': 'SMS an Kunden (Buchungsbestätigung und Rückgabe-Erinnerung) sind im Premium-Tarif enthalten. Gespeicherte Einstellungen wirken nach dem Wechsel zu Premium, und einen gespeicherten SMSAPI-Token können Sie entfernen.',
    'notifications.superAdminNotPremium': 'Ihre Firma ist nicht im Premium-Tarif. Als Super-Admin können Sie Erinnerungen und SMS speichern, aber sie werden erst gesendet, wenn die Firma zu Premium wechselt.',
    'notifications.emailCard': 'E-Mail-Benachrichtigungen',
    'notifications.inactive': 'Deaktiviert',
    'notifications.insertData': 'Daten einfügen:',
    'notifications.insertHint': 'Klicken Sie auf eine Schaltfläche, um Kunden- oder Firmendaten an der passenden Stelle im Text einzufügen.',
    'notifications.loadError': 'Die Benachrichtigungseinstellungen konnten nicht geladen werden.',
    'notifications.loading': 'Wird geladen…',
    'notifications.pickupDesc': 'Wird automatisch N Tage vor der geplanten Abholung gesendet.',
    'notifications.pickupLabel': 'Erinnerung an die Abholung',
    'notifications.returnDesc': 'Wird automatisch N Tage vor Ablauf der Rückgabefrist gesendet.',
    'notifications.returnLabel': 'Erinnerung an die Rückgabe',
    'notifications.save': 'Einstellungen speichern',
    'notifications.saveError': 'Speicherfehler',
    'notifications.saveGenericError': 'Speicherfehler.',
    'notifications.saved': 'Die Benachrichtigungseinstellungen wurden gespeichert.',
    'notifications.saving': 'Wird gespeichert…',
    'notifications.sendError': 'Sendefehler',
    'notifications.sendTest': 'Test-E-Mail an meine Adresse senden',
    'notifications.sending': 'Wird gesendet…',
    'notifications.smsBody': 'SMS-Text (max. 160 Zeichen)',
    'notifications.smsCard': 'SMS-Benachrichtigungen',
    'notifications.smsConfirmDesc': 'Eine kurze SMS direkt nach dem Anlegen einer Reservierung.',
    'notifications.smsConfirmLabel': 'Reservierungsbestätigung (SMS)',
    'notifications.smsEnableDesc': 'Nach dem Aktivieren können Sie die einzelnen SMS-Benachrichtigungen unten einschalten.',
    'notifications.smsEnableLabel': 'SMS aktivieren (SMSAPI.pl)',
    'notifications.smsInfoAfter': ' (Kosten ca. 0,09 PLN pro SMS). Ein eigenes Konto und ein API-Token sind erforderlich.',
    'notifications.smsInfoBefore': 'SMS werden versendet über',
    'notifications.smsReturnDesc': 'Eine kurze SMS N Tage vor Ablauf der Rückgabefrist.',
    'notifications.smsReturnLabel': 'Erinnerung an die Rückgabe (SMS)',
    'notifications.smsSender': 'SMS-Absender (max. 11 Zeichen, ohne Leerzeichen)',
    'notifications.smsSenderPh': 'z. B. therENT',
    'notifications.smsStep1a': 'Konto anlegen bei',
    'notifications.smsStep1b': 'und Guthaben aufladen',
    'notifications.smsStep2a': 'Gehen Sie zu',
    'notifications.smsStep2b': 'API → Zugriffstoken',
    'notifications.smsStep2c': 'und kopieren Sie das OAuth-Token',
    'notifications.smsStep3': 'Token unten einfügen und Einstellungen speichern',
    'notifications.smsToken': 'API-Token (SMSAPI OAuth)',
    'notifications.smsTokenPh': 'Token aus dem SMSAPI-Panel einfügen',
    'notifications.smsTokenSavedPh': 'Token gespeichert. Geben Sie einen neuen ein, um ihn zu ersetzen',
    'notifications.smsTokenRemove': 'Gespeicherten Token entfernen',
    'notifications.smsTokenWillRemove': 'Der Token wird beim Speichern der Einstellungen entfernt.',
    'notifications.tomorrowMismatch': 'Der Text sagt „morgen“, die Erinnerung geht aber mehr als einen Tag vorher raus, daher erhält der Kunde eine falsche Angabe. Fügen Sie statt „morgen“ das Datum ein oder stellen Sie 1 Tag ein.',
    'notifications.smtpInfoAfter': ' ein.',
    'notifications.smtpInfoBefore': 'Ohne eigenen Mailserver werden E-Mails an Kunden von der Adresse von the.rENT gesendet, mit dem Namen Ihres Verleihs unterzeichnet, und Antworten gehen an die E-Mail-Adresse in den Firmendaten. Einen eigenen Mailserver (Premium-Tarif) richten Sie auf der Seite',
    'notifications.subject': 'Betreff der Nachricht',
    'notifications.subtitle': 'Automatische Nachrichten an Kunden rund um ihre Reservierungen. Aktivieren Sie nur, was Sie brauchen.',
    'notifications.title': 'Kundenbenachrichtigungen',
    'notifications.usedInBody': 'Im Text verwendet:',
    'notifications.varEndDate': 'Rückgabedatum',
    'notifications.varFirstName': 'Vorname',
    'notifications.varLastName': 'Nachname',
    'notifications.varOrgName': 'Firmenname',
    'notifications.varOrgPhone': 'Firmentelefon',
    'notifications.varPickupDate': 'Abholdatum',
    'notifications.varReturnDate': 'Rückgabedatum',
    'notifications.varReservationId': 'Reservierungsnummer',
    'notifications.varOrgEmail': 'E-Mail des Verleihs',
    'notifications.varOrgContact': 'Kontakt (E-Mail und Telefon)',
    'notifications.widgetEmailsCard': 'Widget-E-Mails an Kunden',
    'notifications.widgetEmailsInfo': 'Diese E-Mails werden immer verschickt, wenn ein Kunde über das Widget bucht. Sie können Betreff, Einleitung und Schluss ändern. Nummer, Zeitraum, Beträge, Zahlungslink und Bankdaten fügen wir selbst ein, sie können also nicht versehentlich entfernt werden.',
    'notifications.widgetEmailCustom': 'Eigener Text',
    'notifications.widgetEmailDefault': 'Standardtext',
    'notifications.widgetEmailEdit': 'Text bearbeiten',
    'notifications.widgetEmailCollapse': 'Einklappen',
    'notifications.widgetEmailIntro': 'Einleitung',
    'notifications.widgetEmailOutro': 'Schluss',
    'notifications.widgetEmailSystemPart': 'Zwischen Einleitung und Schluss fügen wir ein:',
    'notifications.widgetEmailReset': 'Standardtext wiederherstellen',
    'notifications.widgetEmail.confirm.label': 'Buchungsbestätigung',
    'notifications.widgetEmail.confirm.desc': 'Nach einer Buchung im Widget. Bei Buchung nach Klassen nach Bestätigung der Verfügbarkeit.',
    'notifications.widgetEmail.confirm.system': 'Buchungsnummer, Zeitraum, fälligen Betrag sowie Online-Zahlungslink oder Bankdaten mit Zahlungsfrist.',
    'notifications.widgetEmail.request.label': 'Anfrage nach Klassen erhalten',
    'notifications.widgetEmail.request.desc': 'Wenn der Kunde eine Ausrüstungsklasse wählt, bevor Sie die Verfügbarkeit bestätigen.',
    'notifications.widgetEmail.request.system': 'Nummer und Zeitraum, bestellte Ausrüstung mit Maßen, geschätzten Wert und den Hinweis, dass erst nach Bestätigung gezahlt wird.',
    'notifications.widgetEmail.decline.label': 'Anfrage abgelehnt',
    'notifications.widgetEmail.decline.desc': 'Wenn Sie eine Anfrage nach Klassen ablehnen.',
    'notifications.widgetEmail.decline.system': 'Nummer und Zeitraum der Anfrage, Hinweis auf die Stornierung und Ihre Nachricht bei der Ablehnung.',
    'notifications.widgetEmail.unpaid_reminder.label': 'Zahlungserinnerung',
    'notifications.widgetEmail.unpaid_reminder.desc': 'Wenn eine Buchung unbezahlt ist, vor der automatischen Stornierung. Auch Buchungen aus dem Panel mit Zahlungsfrist.',
    'notifications.widgetEmail.unpaid_reminder.system': 'Nummer und Zeitraum, Betrag, die Schaltfläche „Online bezahlen“ und wann die Buchung storniert wird.',
    'notifications.widgetEmail.unpaid_cancel.label': 'Storniert wegen fehlender Zahlung',
    'notifications.widgetEmail.unpaid_cancel.desc': 'Wenn eine Buchung storniert wird, weil die Zahlung nicht eingegangen ist.',
    'notifications.widgetEmail.unpaid_cancel.system': 'Nummer und Zeitraum sowie den Hinweis, dass die Buchung wegen fehlender Zahlung storniert wurde.',
    'notifications.varStartDate': 'Abholdatum',
    'notifications.willInsert': 'Fügt ein: {var}',

    // ── P8.1e (1/4): wejscie do aplikacji + poczta ──
    'activation.activationError': 'Fehler bei der Kontoaktivierung.',
    'activation.adminSection': 'Administratordaten',
    'activation.adminSectionHint': 'Erstellen Sie ein Administratorkonto für Ihren Verleih. Nach der Aktivierung können Sie Mitarbeiter und Ausrüstung verwalten.',
    'activation.checkingToken': 'Aktivierungs-Token wird geprüft...',
    'activation.connectionErrorLater': 'Verbindungsfehler. Bitte versuchen Sie es später erneut.',
    'activation.connectionErrorRetry': 'Verbindungsfehler. Bitte versuchen Sie es erneut.',
    'activation.email': 'E-Mail (Login) *',
    'activation.emailHint': 'Diese E-Mail ist Ihr Login zum System',
    'activation.emailInvalid': 'Ungültiges E-Mail-Format',
    'activation.emailRequired': 'E-Mail ist erforderlich',
    'activation.firstname': 'Vorname *',
    'activation.firstnameRequired': 'Vorname ist erforderlich',
    'activation.footer': 'Nach der Aktivierung können Sie sich anmelden und Ihren Verleih verwalten.',
    'activation.termsBefore': 'Ich akzeptiere die',
    'activation.termsLink': 'Nutzungsbedingungen',
    'activation.termsAfter': ' (Dokument in polnischer Sprache).',
    'activation.termsRequired': 'Akzeptieren Sie die Nutzungsbedingungen, um das Konto zu aktivieren.',
    'activation.demoDataNote': 'Das Demokonto dient zum Testen des Systems mit Beispieldaten. Geben Sie keine Daten echter Kunden ein.',
    'activation.goToLogin': 'Zur Anmeldung',
    'activation.invalidLinkBody': 'Der Aktivierungslink ist möglicherweise abgelaufen oder wurde bereits verwendet.',
    'activation.invalidLinkTitle': 'Ungültiger Link',
    'activation.invalidToken': 'Das Aktivierungs-Token ist ungültig oder abgelaufen.',
    'activation.lastname': 'Nachname *',
    'activation.lastnameRequired': 'Nachname ist erforderlich',
    'activation.password': 'Passwort *',
    'activation.passwordConfirm': 'Passwort bestätigen *',
    'activation.passwordMin8': 'Das Passwort muss mindestens 8 Zeichen lang sein',
    'activation.passwordMax128': 'Das Passwort darf höchstens 128 Zeichen lang sein',
    'activation.passwordTooWeak': 'Das Passwort ist zu schwach. Verlängern Sie es oder fügen Sie ein paar Wörter hinzu.',
    'activation.passwordStrength': 'Passwortstärke',
    'activation.passwordRequirements': 'Anforderungen',
    'activation.reqLength': 'Mindestens {min} Zeichen',
    'activation.reqStrength': 'Stärke mindestens „{strength}“',
    'activation.reqMatch': 'Beide Passwörter stimmen überein',
    'activation.passwordTip': 'Am einfachsten zu einem starken Passwort: ein paar zusammenhanglose Wörter oder ein kurzer Satz. Buchstaben durch Ziffern zu ersetzen (z. B. „a“ durch „4“) bringt wenig.',
    'activation.passwordMismatch': 'Die Passwörter stimmen nicht überein',
    'activation.passwordRequired': 'Passwort ist erforderlich',
    'activation.phEmail': 'max@verleih.de',
    'activation.phFirstname': 'Max',
    'activation.phLastname': 'Mustermann',
    'activation.phone': 'Telefon *',
    'activation.phoneDigits': 'Die Telefonnummer muss 9 Ziffern haben',
    'activation.phoneRequired': 'Telefonnummer ist erforderlich',
    'activation.redirecting': 'Sie werden gleich zur Anmeldeseite weitergeleitet...',
    'activation.rentalLabel': 'Verleih:',
    'activation.submit': 'Konto aktivieren',
    'activation.submitting': 'Aktivierung läuft...',
    'activation.successAfter': ' wurde erfolgreich aktiviert.',
    'activation.successBefore': 'Ihr Verleih',
    'activation.successTitle': 'Konto aktiviert!',
    'activation.title': 'Kontoaktivierung',
    'emailSettings.bccHelp': 'Jedes gesendete Angebot wird an diese Adresse kopiert.',
    'emailSettings.bccLabel': 'BCC - Blindkopie (optional)',
    'emailSettings.bccPlaceholder': 'z. B. archiv@ihrefirma.de',
    'emailSettings.connectionError': 'Verbindungsfehler',
    'emailSettings.deleteConfig': 'Konfiguration löschen',
    'emailSettings.deleteConfirmBody': 'Angebote werden von der Standard-Systemadresse gesendet.',
    'emailSettings.deleteConfirmTitle': 'E-Mail-Konfiguration wirklich löschen?',
    'emailSettings.deleting': 'Wird gelöscht...',
    'emailSettings.demoNotice': 'Demo-Modus - eigenes SMTP kann nicht konfiguriert werden.',
    'emailSettings.premiumTitle': 'Ein eigener Mailserver ist im Premium-Tarif enthalten.',
    'emailSettings.premiumBody': 'Im Basic-Tarif werden E-Mails an Ihre Kunden von der Adresse von the.rENT gesendet, mit dem Namen Ihres Verleihs, und Antworten gehen an die E-Mail aus den Firmendaten.',
    'emailSettings.premiumSavedNote': 'Die gespeicherte Konfiguration bleibt erhalten und funktioniert nach dem Wechsel zu Premium wieder. Sie können sie auch löschen.',
    'emailSettings.superAdminNotPremium': 'Ihre Firma ist nicht im Premium-Tarif. Als Super-Admin können Sie die Konfiguration speichern und testen, aber E-Mails an Kunden gehen von der Adresse von the.rENT, bis die Firma zu Premium wechselt.',
    'emailSettings.emailExamplePlaceholder': 'z. B. angebote@ihrefirma.de',
    'emailSettings.enableHelp': 'Wenn deaktiviert, werden Angebote von der Standard-Systemadresse gesendet.',
    'emailSettings.enableLabel': 'Eigene E-Mail aktivieren',
    'emailSettings.fromEmailLabel': 'Absender-E-Mail *',
    'emailSettings.fromNameLabel': 'Absendername *',
    'emailSettings.fromNamePlaceholder': 'z. B. Skiverleih XYZ',
    'emailSettings.gmailStep1': 'Melden Sie sich bei dem Google-Konto an, von dem Sie Mails senden möchten',
    'emailSettings.gmailStep2': 'Gehen Sie zu',
    'emailSettings.gmailStep3a': 'Aktivieren Sie die',
    'emailSettings.gmailStep3b': 'Bestätigung in zwei Schritten',
    'emailSettings.gmailStep3c': '(falls noch nicht geschehen)',
    'emailSettings.gmailStep4': 'Gehen Sie nach der 2FA-Aktivierung zu',
    'emailSettings.gmailStep5a': 'Tragen Sie im Feld "App-Name" z. B.',
    'emailSettings.gmailStep5b': 'ein und klicken Sie auf',
    'emailSettings.gmailStep5c': 'Erstellen',
    'emailSettings.gmailStep6a': 'Google erzeugt ein',
    'emailSettings.gmailStep6b': '16-stelliges Passwort',
    'emailSettings.gmailStep6c': '- kopieren Sie es',
    'emailSettings.gmailStep7': 'Kommen Sie hierher zurück und füllen Sie das Formular aus:',
    'emailSettings.gmailTitle': 'Gmail einrichten - Schritt für Schritt',
    'emailSettings.gmailWarning': 'Gmail verlangt, dass das Feld "Absender-E-Mail" mit dem SMTP-Login übereinstimmt. Wenn Sie von einer anderen Adresse senden möchten, fügen Sie sie in Gmail als Alias hinzu: Einstellungen → Alle Einstellungen aufrufen → Konten und Import → Senden als → "Weitere E-Mail-Adresse hinzufügen".',
    'emailSettings.helpBody': 'Sobald Sie einen eigenen SMTP-Server einrichten, gehen alle Angebote und Benachrichtigungen aus the.rENT von Ihrer E-Mail-Adresse aus. Der Kunde erhält eine Nachricht mit Ihrem Namen und Ihrer Adresse - das wirkt professionell und schafft Vertrauen.',
    'emailSettings.helpTitle': 'Wie funktioniert das?',
    'emailSettings.hostLabel': 'SMTP-Host *',
    'emailSettings.hostPlaceholder': 'z. B. smtp.gmail.com',
    'emailSettings.importantLabel': 'Wichtig:',
    'emailSettings.loginLabel': 'SMTP-Login *',
    'emailSettings.otherServersBody': 'Wenn Sie einen Hoster (z. B. nazwa.pl, OVH) oder einen Dienst wie Mailgun, SendGrid oder Amazon SES nutzen - tragen Sie die vom Anbieter gelieferten SMTP-Daten ein. Auf diesen Servern funktioniert das Feld "Absender-E-Mail" ohne Einschränkungen.',
    'emailSettings.otherServersTitle': 'Andere SMTP-Server',
    'emailSettings.passwordEnter': 'Passwort eingeben',
    'emailSettings.passwordHelp': 'Leer lassen, wenn Sie das Passwort nicht ändern möchten.',
    'emailSettings.passwordKeep': '(unverändert - leer lassen)',
    'emailSettings.passwordLabel': 'SMTP-Passwort *',
    'emailSettings.port25': '25 (ohne Verschlüsselung)',
    'emailSettings.port2525': '2525 (alternativ)',
    'emailSettings.port587': '587 (STARTTLS - empfohlen)',
    'emailSettings.replyToHelp': 'Wenn ein Kunde auf ein Angebot antwortet, geht die Nachricht an diese Adresse.',
    'emailSettings.replyToLabel': 'Reply-To (optional)',
    'emailSettings.replyToPlaceholder': 'Antwortadresse',
    'emailSettings.save': 'Einstellungen speichern',
    'emailSettings.saveError': 'Speicherfehler',
    'emailSettings.saved': 'Einstellungen erfolgreich gespeichert!',
    'emailSettings.sendErrorCause.auth': 'falscher Benutzername oder falsches Passwort',
    'emailSettings.sendErrorCause.connect': 'keine Verbindung zum Server möglich',
    'emailSettings.sendErrorCause.connectionLost': 'der Server hat die Verbindung abgebrochen',
    'emailSettings.sendErrorCause.dns': 'kein Server unter diesem Namen gefunden',
    'emailSettings.sendErrorCause.other': 'Fehler des Mailservers',
    'emailSettings.sendErrorCause.rejected': 'der Server hat die Nachricht abgelehnt',
    'emailSettings.sendErrorCause.sender': 'der Server hat die Absenderadresse nicht akzeptiert',
    'emailSettings.sendErrorCause.timeout': 'der Server antwortet nicht mehr',
    'emailSettings.sendErrorCause.tls': 'keine verschlüsselte Verbindung möglich (prüfen Sie die SSL-Einstellung, den Port und das Serverzertifikat)',
    'emailSettings.sendErrorFallback': 'Wir haben die E-Mail von der Adresse von the.rENT mit dem Namen Ihres Verleihs gesendet, Antworten gehen an Ihre Adresse.',
    'emailSettings.sendErrorFix': 'Prüfen Sie die Einstellungen des Mailservers, speichern Sie sie und senden Sie einen Test. Diese Meldung verschwindet nach dem Speichern oder nach dem ersten erfolgreichen Versand.',
    'emailSettings.sendErrorOpen': 'E-Mail-Einstellungen öffnen',
    'emailSettings.sendErrorNoFallback': 'Die E-Mail hat den Kunden möglicherweise nicht erreicht. Wir haben sie nicht ein zweites Mal gesendet, weil der Server sie bereits angenommen haben könnte.',
    'emailSettings.sendErrorTitle': 'Die letzte E-Mail wurde nicht über Ihren Mailserver gesendet.',
    'emailSettings.sendErrorWhen': '{czas}: {przyczyna}.',
    'emailSettings.senderLabel': 'Absender:',
    'emailSettings.senderSubtitle': 'Diese Daten erscheinen als Absender in den gesendeten Angeboten.',
    'emailSettings.senderTitle': 'Absenderdaten',
    'emailSettings.smtpSubtitle': 'Geben Sie die Daten Ihres Postausgangsservers ein. Wählen Sie eine Vorlage oder tragen Sie sie manuell ein.',
    'emailSettings.smtpTitle': 'SMTP-Server',
    'emailSettings.sslHelp': 'Für Port 465 aktivieren. Port 587 nutzt meist STARTTLS (deaktiviert).',
    'emailSettings.sslLabel': 'SSL-Verbindung',
    'emailSettings.statusTitle': 'Konfigurationsstatus',
    'emailSettings.subtitle': 'Richten Sie eine eigene E-Mail-Adresse für den Versand von Angeboten und Benachrichtigungen ein',
    'emailSettings.tblFrom': 'Absender-E-Mail',
    'emailSettings.tblFromValue': 'Dieselbe Adresse wie der SMTP-Login',
    'emailSettings.tblHost': 'SMTP-Host',
    'emailSettings.tblLogin': 'SMTP-Login',
    'emailSettings.tblLoginValue': 'Ihre Gmail-Adresse (z. B. max@gmail.com)',
    'emailSettings.tblPassword': 'SMTP-Passwort',
    'emailSettings.tblPasswordValue': 'Das 16-stellige Passwort aus Schritt 6 (ohne Leerzeichen)',
    'emailSettings.tblPort': 'Port',
    'emailSettings.tblPortValue': '587 (STARTTLS)',
    'emailSettings.tblSsl': 'SSL-Verbindung',
    'emailSettings.tblSslValue': 'Deaktiviert',
    'emailSettings.testFailed': 'Test fehlgeschlagen',
    'emailSettings.testRecipientLabel': 'E-Mail-Adresse des Empfängers',
    'emailSettings.testRecipientPlaceholder': 'z. B. max@example.com',
    'emailSettings.testSend': 'Test senden',
    'emailSettings.testSubtitle': 'Prüfen Sie, ob die SMTP-Konfiguration funktioniert, indem Sie eine Nachricht an eine Adresse Ihrer Wahl senden.',
    'emailSettings.testTitle': 'Test-E-Mail senden',
    'emailSettings.testing': 'Wird gesendet...',
    'emailSettings.title': 'E-Mail-Einstellungen',
    'emailSettings.unverified': 'Nicht verifiziert',
    'emailSettings.verified': 'Verifiziert',
    'resetPassword.backToLogin': 'Zurück zur Anmeldung',
    'resetPassword.checkingLink': 'Link wird geprüft...',
    'resetPassword.confirmPlaceholder': 'Passwort bestätigen',
    'resetPassword.connectionErrorLater': 'Verbindungsfehler. Bitte versuchen Sie es später erneut.',
    'resetPassword.connectionErrorRetry': 'Verbindungsfehler. Bitte versuchen Sie es erneut.',
    'resetPassword.defaultUserName': 'Nutzer',
    'resetPassword.greetingAfter': ', legen Sie ein neues Passwort für Ihr Konto fest.',
    'resetPassword.greetingBefore': 'Hallo',
    'resetPassword.invalidLink': 'Der Link zum Zurücksetzen des Passworts ist ungültig oder abgelaufen.',
    'resetPassword.invalidLinkTitle': 'Ungültiger Link',
    'resetPassword.mismatch': 'Die Passwörter stimmen nicht überein.',
    'resetPassword.mismatchInline': 'Die Passwörter stimmen nicht überein',
    'resetPassword.newPasswordPlaceholder': 'Neues Passwort (mind. 8 Zeichen)',
    'resetPassword.pleaseWait': 'Bitte warten...',
    'resetPassword.redirecting': 'Sie werden gleich zur Anmeldung weitergeleitet...',
    'resetPassword.resetError': 'Fehler beim Zurücksetzen des Passworts.',
    'resetPassword.strengthAdd': 'Ergänzen: {list}',
    'resetPassword.strengthCase': 'Groß- und Kleinbuchstaben',
    'resetPassword.strengthDigits': 'Ziffern',
    'resetPassword.strengthGood': 'Gut',
    'resetPassword.strengthMedium': 'Mittel',
    'resetPassword.strengthMin8': 'Mindestens 8 Zeichen',
    'resetPassword.strengthSpecial': 'Sonderzeichen',
    'resetPassword.strengthStrong': 'Starkes Passwort!',
    'resetPassword.strengthVeryGood': 'Sehr gut',
    'resetPassword.strengthWeak': 'Schwach',
    'resetPassword.submit': 'Passwort ändern',
    'resetPassword.submitting': 'Wird zurückgesetzt...',
    'resetPassword.successBody': 'Sie können sich jetzt mit dem neuen Passwort anmelden.',
    'resetPassword.successTitle': 'Ihr Passwort wurde geändert!',
    'resetPassword.title': 'Passwort zurücksetzen',
    'resetPassword.tooShort': 'Das Passwort muss mindestens 8 Zeichen lang sein.',
    'twoFactor.attemptsLeft': 'Verbleibende Versuche: {count}.',
    'twoFactor.backToTotp': 'Zurück zum TOTP-Code',
    'twoFactor.backupHint': 'Geben Sie einen Ihrer Backup-Codes ein (Format: XXXX-XXXX).',
    'twoFactor.cancelLogin': 'Anmeldung abbrechen',
    'twoFactor.loggingIn': 'Anmeldung läuft...',
    'twoFactor.loginWithBackup': 'Mit Backup-Code anmelden',
    'twoFactor.title': 'Zwei-Faktor-Verifizierung',
    'twoFactor.totpHint': 'Geben Sie den 6-stelligen Code aus Ihrer Authenticator-App ein (Google Authenticator, Authy usw.)',
    'twoFactor.useBackupCode': 'Backup-Code verwenden',
    'twoFactor.verify': 'Bestätigen',
    'twoFactor.verifying': 'Wird geprüft...',
    'twoFactor.wrongBackupCode': 'Ungültiger Backup-Code.',
    'twoFactor.wrongCode': 'Falscher Bestätigungscode.',

    // ── P8.1d: i18n Magazynu (konfigurator, tabela, presety, opisy pol) ──
    'inventory.deleteError': 'Beim Löschen von {name} ist ein Fehler aufgetreten: {msg}',
    'inventory.deleteFailed': 'Ausrüstung {name} kann nicht gelöscht werden.',
    'inventory.deleteGenericError': 'Fehler beim Löschen der Ausrüstung.',
    'inventory.deleteHasRefs': 'Ausrüstung {name} kann nicht gelöscht werden, da sie bestehenden Reservierungen oder anderen Verknüpfungen in der Datenbank zugeordnet ist. Entfernen Sie diese Ausrüstung zuerst aus den Reservierungen.',
    'inventory.deleteNotFound': 'Ausrüstung {name} wurde nicht gefunden (möglicherweise bereits gelöscht).',
    'inventoryFields.bail.desc': 'Für die Ausrüstung erhobene Kaution',
    'inventoryFields.bail.descAlt': 'Kaution',
    'inventoryFields.barcode.desc': 'Barcode oder QR-Code',
    'inventoryFields.brand.desc': 'Marke des Herstellers',
    'inventoryFields.brand.descAlt': 'Hersteller',
    'inventoryFields.category.desc': 'Ausrüstungstyp (z. B. Ski, Schuhe)',
    'inventoryFields.class.desc': 'Qualitätsklasse (z. B. Standard, Premium)',
    'inventoryFields.compatibility.desc': 'Kompatibilität',
    'inventoryFields.condition.desc': 'Technischer Zustand der Ausrüstung',
    'inventoryFields.condition.descAlt': 'Technischer Zustand',
    'inventoryFields.currency.desc': 'Währung',
    'inventoryFields.images.desc': 'Links zu Fotos',
    'inventoryFields.images.descAlt': 'Fotoadressen (URL)',
    'inventoryFields.inventory_number.desc': 'Eindeutige Inventarnummer',
    'inventoryFields.inventory_number.descAlt': 'Nummer im System',
    'inventoryFields.location.desc': 'Lagerort',
    'inventoryFields.maintenanceDate.desc': 'Datum der letzten Wartung',
    'inventoryFields.name.desc': 'Modellname',
    'inventoryFields.name.descAlt': 'Name des Ausrüstungsmodells',
    'inventoryFields.price.desc': 'Mietpreis pro Tag',
    'inventoryFields.price.descAlt': 'Mietpreis',
    'inventoryFields.price_over_7.desc': 'Preis pro Tag bei mehr als 7 Tagen',
    'inventoryFields.price_over_7.descAlt': 'Preis bei Miete über 7 Tage',
    'inventoryFields.purchaseDate.desc': 'Kaufdatum',
    'inventoryFields.size.desc': 'Größe der Ausrüstung',
    'inventoryFields.size.descAlt': 'Größe (z. B. Skilänge, Schuhgröße)',
    'inventoryFields.sizeRange.desc': 'Größenbereich',
    'inventoryFields.sku.desc': 'Interner Code oder SKU',
    'inventoryFields.sku.descAlt': 'Lagercode oder SKU',
    'inventoryFields.status.desc': 'Verfügbarkeitsstatus',
    'inventoryFields.supplier.desc': 'Lieferant der Ausrüstung',
    'inventoryFields.tags.desc': 'Tags, die das Filtern erleichtern',
    'inventoryFields.tags.descAlt': 'Durch Komma getrennte Tags',
    'inventoryFields.typeId.desc': 'Art der Ausrüstung',
    'inventoryFields.wearLevel.desc': 'Abnutzungsgrad',
    'inventoryPresets.bikes.desc': 'Verleih von Fahrrädern und Fahrradausrüstung',
    'inventoryPresets.bikes.name': 'Fahrräder',
    'inventoryPresets.events.desc': 'Verleih von Ausstattung für Feiern und Events',
    'inventoryPresets.events.name': 'Eventausrüstung',
    'inventoryPresets.ski.desc': 'Verleih von Ski- und Snowboardausrüstung',
    'inventoryPresets.ski.name': 'Ski und Snowboard',
    'inventoryPresets.tools.desc': 'Verleih von Werkzeugen und Baugeräten',
    'inventoryPresets.tools.name': 'Bauwerkzeuge',
    'inventoryPresets.vehicles.desc': 'Verleih von Anhängern und Fahrzeugen',
    'inventoryPresets.vehicles.name': 'Anhänger und Fahrzeuge',
    'inventoryPresets.water.desc': 'Verleih von Wassersportausrüstung',
    'inventoryPresets.water.name': 'Kajaks und SUP',
    'inventorySettings.activeCount': '{visible} / {total} aktiv',
    'inventorySettings.addCategory': 'Kategorie hinzufügen',
    'inventorySettings.addColumn': 'Spalte hinzufügen',
    'inventorySettings.addCustomColumn': 'Eigene Spalte hinzufügen',
    'inventorySettings.alwaysRequired': 'immer erforderlich',
    'inventorySettings.alwaysRequiredHint': 'Name, Preis und Kategorie sind immer erforderlich, denn ohne sie lässt sich Ausrüstung nicht in der Datenbank speichern. Die übrigen Felder können Sie deaktivieren, wenn Ihre Branche sie nicht nutzt (z. B. eine Vermietung ohne Kaution).',
    'inventorySettings.atLeastOneColumn': 'Mindestens eine Spalte muss ausgewählt sein.',
    'inventorySettings.autoSaveHint': 'Änderungen werden automatisch gespeichert. Sie können eine eigene Spalte hinzufügen, wenn sie unten nicht aufgeführt ist.',
    'inventorySettings.autodetect': 'Automatische Erkennung',
    'inventorySettings.baseFields': 'Basisfelder',
    'inventorySettings.catAdded': 'Kategorie "{name}" hinzugefügt.',
    'inventorySettings.catNameRequired': 'Geben Sie einen Kategorienamen ein.',
    'inventorySettings.catSaveFailed': 'Kategorie konnte nicht gespeichert werden.',
    'inventorySettings.catUpdated': '"{name}" aktualisiert.',
    'inventorySettings.categoriesSub': 'Kategorien verwalten und für jede die Pflichtfelder festlegen',
    'inventorySettings.categoriesTitle': 'Ausrüstungskategorien',
    'inventorySettings.categoryNameLabel': 'Kategoriename',
    'inventorySettings.categoryNamePlaceholder': 'z. B. Alpinski, Snowboardschuhe…',
    'inventorySettings.categoryNamePlaceholderShort': 'z. B. Alpinski…',
    'inventorySettings.colAdded': 'Spalte "{name}" hinzugefügt.',
    'inventorySettings.colDeleted': 'Spalte gelöscht.',
    'inventorySettings.colDescLabel': 'Beschreibung (optional)',
    'inventorySettings.colDescPlaceholder': 'Kurze Beschreibung dieser Spalte…',
    'inventorySettings.colExampleLabel': 'Beispielwert (optional)',
    'inventorySettings.colExamplePlaceholder': 'z. B. 12345, 2026-01-15…',
    'inventorySettings.colExists': 'Spalte "{name}" existiert bereits.',
    'inventorySettings.colNameLabel': 'Spaltenname *',
    'inventorySettings.colNamePlaceholder': 'z. B. Zertifikat, Gewicht, Hersteller…',
    'inventorySettings.colNameRequired': 'Geben Sie einen Spaltennamen ein.',
    'inventorySettings.columnsHint': 'Wählen Sie, welche Informationen in der Lagertabelle sichtbar sein sollen',
    'inventorySettings.createCategory': 'Kategorie erstellen',
    'inventorySettings.createFirstCategory': 'Erste Kategorie erstellen',
    'inventorySettings.deleteThisColumn': 'Diese Spalte löschen',
    'inventorySettings.deselectAll': 'Alle abwählen',
    'inventorySettings.editCategory': 'Bearbeiten: {name}',
    'inventorySettings.errorPrefix': 'Fehler: {msg}',
    'inventorySettings.extraFields': 'Zusätzliche Felder',
    'inventorySettings.extraFieldsScope': 'Nur für Geräte dieser Kategorie erforderlich, zusätzlich zu den im ganzen Lager erforderlichen Feldern (oben). Der Import prüft sie nicht.',
    'inventorySettings.extraRequiredFields': 'Zusätzliche Pflichtfelder',
    'inventorySettings.fetchFailed': 'Daten konnten nicht vom Server geladen werden.',
    'inventorySettings.fieldType': 'Feldtyp',
    'inventorySettings.groupBasic': 'Grundinformationen',
    'inventorySettings.groupCustom': 'Eigene Spalten',
    'inventorySettings.groupMeta': 'Zusätzliche Metadaten',
    'inventorySettings.groupPricing': 'Preise und Kaution',
    'inventorySettings.listValuesLabel': 'Listenwerte (durch Komma getrennt)',
    'inventorySettings.listValuesPlaceholder': 'z. B. Neu, Gebraucht, Reparaturbedürftig',
    'inventorySettings.loadingFromDb': 'Wird aus der Datenbank geladen...',
    'inventorySettings.nameMin2': 'Der Name muss mindestens 2 Zeichen lang sein.',
    'inventorySettings.nameOnlyInvalidChars': 'Der Name enthält nur unzulässige Zeichen.',
    'inventorySettings.newCategory': 'Neue Kategorie',
    'inventorySettings.newCategoryTitle': 'Neue Ausrüstungskategorie',
    'inventorySettings.newColumn': 'Neue Spalte',
    'inventorySettings.noAuthLogin': 'Keine Berechtigung - bitte anmelden.',
    'inventorySettings.noCategories': 'Keine Kategorien',
    'inventorySettings.noCategoriesDesc': 'Erstellen Sie Ihre erste Ausrüstungskategorie oder nutzen Sie die automatische Erkennung, um sie aus vorhandenen Daten in der Datenbank zu ermitteln.',
    'inventorySettings.noCategory': 'Ohne Kategorie',
    'inventorySettings.fieldTypeText': 'Text',
    'inventorySettings.fieldTypeNumber': 'Zahl',
    'inventorySettings.fieldTypeList': 'Liste',
    'inventorySettings.additional': 'Weitere',
    'inventorySettings.noDataReset': 'Keine Daten - Einstellungen zurückgesetzt.',
    'inventorySettings.noEquipmentKeptCats': 'Keine Ausrüstung; Kategorien beibehalten.',
    'inventorySettings.none': 'Keine',
    'inventorySettings.processing': 'Wird verarbeitet...',
    'inventorySettings.requiredCount': '{count} Pflichtfelder',
    'inventorySettings.requiredHint': 'Gilt für das Formular zum Hinzufügen von Ausrüstung und für die Importvorlage: Ein Pflichtfeld erhält in der .xlsx-Datei ein Sternchen',
    'inventorySettings.requiredTitle': 'Pflichtfelder',
    'inventorySettings.restoreDefaults': 'Standard wiederherstellen',
    'inventorySettings.saveChanges': 'Änderungen speichern',
    'inventorySettings.saveServerFailed': 'Speichern auf dem Server fehlgeschlagen (Änderungen nur lokal).',
    'inventorySettings.saving': 'Wird gespeichert…',
    'inventorySettings.selectAll': 'Alle auswählen',
    'inventorySettings.subtitle': 'Sichtbare Spalten, Pflichtfelder und Ausrüstungskategorien',
    'inventorySettings.syncedWithDb': 'Mit der Datenbank synchronisiert.',
    'inventorySettings.visibleColumns': 'Sichtbare Spalten',
    'paperSheet.fitPage': 'Ganze Seite',
    'paperSheet.zoomGroup': 'Vorschau-Zoom',
    'builderChrome.closeWithEsc': 'Schließen (Esc)',
  }
};

// Uzupełnij brakujące tłumaczenia EN/DE na podstawie PL (fallback)
const fillMissing = (srcLangObj, destLangObj) => {
  Object.keys(srcLangObj).forEach(key => {
    const srcSection = srcLangObj[key];
    if (typeof srcSection !== 'object' || srcSection === null) {
      if (!(key in destLangObj)) destLangObj[key] = srcSection;
      return;
    }
    if (!destLangObj[key] || typeof destLangObj[key] !== 'object') destLangObj[key] = {};
    Object.keys(srcSection).forEach(k => {
      if (!(k in destLangObj[key])) destLangObj[key][k] = srcSection[k];
    });
  });
};

// Wykonaj uzupełnienie
fillMissing(translations.pl, translations.en);
fillMissing(translations.pl, translations.de);

// ZAMIENIAMY implementację hooka na Context API
import React, { useState, useCallback, createContext, useContext } from 'react';

// Context i Provider
const TranslationContext = createContext({
  t: (k) => k,
  currentLanguage: 'pl',
  setLanguage: () => {}
});

/**
 * Języki, które użytkownik może wybrać w Preferencjach (P8.1, 2026-10-05: na razie tylko polski).
 *
 * Słownik EN/DE jest kompletny co do kluczy, ale około 700 napisów panelu nie przechodzi
 * przez `t()` (P8.1f), więc po wybraniu angielskiego klient dostawał aplikację w połowie po
 * polsku, co wygląda na usterkę. Przełącznik jest schowany, a zapisany wcześniej wybór
 * innego języka jest ignorowany. Słownik zostaje: żeby przywrócić wybór, dopisz język tutaj.
 */
export const WYBIERALNE_JEZYKI = ['pl'];

/** Język startowy z zapisanego wyboru: tylko spośród dostępnych, inaczej polski. */
export function jezykStartowy(zapisany, dostepne = WYBIERALNE_JEZYKI) {
  return dostepne.includes(zapisany) ? zapisany : 'pl';
}

/**
 * `dostepneJezyki` nadpisuje listę wyłącznie w testach: tłumaczenia EN/DE dalej utrzymujemy,
 * więc testy ekranów mogą renderować je mimo schowanego wyboru w panelu.
 */
export function TranslationProvider({ children, dostepneJezyki = WYBIERALNE_JEZYKI }) {
  const [currentLanguage, setCurrentLanguage] = useState(() => jezykStartowy(localStorage.getItem('language'), dostepneJezyki));

  const setLanguage = useCallback((newLanguage) => {
    const jezyk = jezykStartowy(newLanguage, dostepneJezyki);
    localStorage.setItem('language', jezyk);
    setCurrentLanguage(jezyk);
  }, [dostepneJezyki]);

  /**
   * `t(klucz)` albo `t(klucz, { parametry })`.
   *
   * Wstawianie parametrow dolozone 2026-08-19. Do tej pory `t` przyjmowalo WYLACZNIE klucz,
   * wiec kazdy napis z liczba albo nazwa ("Pokazano 1-9 z 42", "Ladowanie klientow...")
   * musial byc sklejany w kodzie strony — i wlasnie dlatego wiekszosc z nich zostala po
   * polsku na stale. Skladnia `{nazwa}` byla juz uzywana w slowniku (np. `common.pageInfo`),
   * tylko nikt jej nie rozwijal. Brakujacy parametr zostaje w tekscie jako `{nazwa}`, zeby
   * bylo widac, ze czegos nie podano, zamiast cicho wstawiac "undefined".
   */
  const t = useCallback((key, params) => {
    const raw = translations[currentLanguage]?.[key] ?? translations.pl?.[key] ?? key;
    if (!params) return raw;
    return String(raw).replace(/\{(\w+)\}/g, (whole, name) =>
      params[name] === undefined || params[name] === null ? whole : String(params[name])
    );
  }, [currentLanguage]);

  const value = { t, currentLanguage, setLanguage };

  return (
    <TranslationContext.Provider value={value}>
      {children}
    </TranslationContext.Provider>
  );
}

// Hook korzystający z Contextu (używaj go we wszystkich komponentach)
export function useTranslation() {
  return useContext(TranslationContext);
}
